import br, { useState as Ot, useEffect as Ce, useMemo as Fn, memo as lr, useCallback as Ie, useContext as Ar, useReducer as yv, createContext as RR } from "react";
import { useNavigate as vv, useParams as op, Routes as xv, Route as ui } from "react-router-dom";
import { FormElement as Tn, DataSourceLogo as no, DataSourceLabel as Is, MessageIcon as DR, ItemsCart as MR, TabsNavigationNew as sp, ShortListWrapper as OR, SpinnerWidgetContainer as ro, FavoritesHeader as LR, HomePageWidgetList as PR, HomePageWidgetListItem as gh, ModuleDescriptionCard as NR, NAME_COLUMN as IR, PageList as jR, TabWithCounter as La, FormActionsContainer as up, Dropzone as kR, SecondaryContentWrapper as _v, BaseEntityContent as BR, Content as FR, Chart as Vt, ErrorBoundary as bv, AuthorCell as UR, PrimaryButton as $R, ConfirmationDialog as zR, LineChartCell as wv, NameCell as VR, DateCell as Ev, DescriptionCard as YR, StatisticsBoard as WR, ExportMetadata as GR, ImportMetadata as qR, BaseContentWrapper as HR, BaseInfoWrapper as XR, DataCatalogBaseInfo as QR } from "@prometheus/features";
import { Grid as G, Button as _e, Icon as Qe, Autocomplete as xl, Checkbox as di, ContentBlock as Ec, useTheme as Sc, Tooltip as is, Box as He, Spinner as Ke, IconButton as ud, useNotifications as bi, Divider as fs, Input as ja, Paper as ka, Block as Et, Skeleton as mh, EmptyTableStub as cd, StatusTag as Ac, LogoBox as KR, Typography as an, BlockTitle as Lt, Select as Ui, Radio as ty, NewTable as Sv, IconActionButton as ZR, EditableInput as ey, Table as cp, Avatar as Av } from "@prometheus/components";
import { api as Pt, getSortDirection as js, wait as JR, capitalize as tD, orderBy as eD, groupBy as nD, createSortingMethodListConfig as rD, createHeadersFromMetadataAttributes as ny, getAccessTypeBadgeColor as Tv, getExecutionPolicyBadgeColor as Cv, createFiltersPanelListConfig as iD, createCrudMethodsListConfig as aD, createFormattersEntityConfig as oD, createBreadcrumbsEntityConfig as sD, createCrudEntityConfig as uD, getReducerWithProduce as Rv, isEqual as $u, isFinite as cD, formatNumber as Dv, parsePermissions as lD, parseMetadataValues as yh } from "@prometheus/utils";
import Qt from "@emotion/styled";
import { TypesOfContainer as on, InvitationStatus as ar, DataSourceFormTabs as hc, DataSourceAccessType as ry, MetaAttributeTypes as hn } from "@prometheus/enums";
import { useList as _l, ModalContext as io, useRequest as qi, DialogContext as fD, useMetadata as hD, useMetadataValues as dD, UseMetadataValuesStatus as iy, useEntityNew as pD } from "@prometheus/hooks";
import { InvitationsActions as vh, Status as ne, ListActions as gD } from "@prometheus/types";
import { getSummary as ay, getImage as mD, setBreadcrumbs as yD } from "@prometheus/redux";
import { useSelector as Mv, useDispatch as Ov } from "react-redux";
import wr from "numeral";
var Ao = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function vD(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function xD(t) {
  if (t.__esModule) return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(r) {
    var a = Object.getOwnPropertyDescriptor(t, r);
    Object.defineProperty(n, r, a.get ? a : {
      enumerable: !0,
      get: function() {
        return t[r];
      }
    });
  }), n;
}
var ld = { exports: {} }, To = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var oy;
function _D() {
  if (oy) return To;
  oy = 1;
  var t = Symbol.for("react.transitional.element"), e = Symbol.for("react.fragment");
  function n(r, a, o) {
    var u = null;
    if (o !== void 0 && (u = "" + o), a.key !== void 0 && (u = "" + a.key), "key" in a) {
      o = {};
      for (var c in a)
        c !== "key" && (o[c] = a[c]);
    } else o = a;
    return a = o.ref, {
      $$typeof: t,
      type: r,
      key: u,
      ref: a !== void 0 ? a : null,
      props: o
    };
  }
  return To.Fragment = e, To.jsx = n, To.jsxs = n, To;
}
var Co = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var sy;
function bD() {
  return sy || (sy = 1, process.env.NODE_ENV !== "production" && function() {
    function t(j) {
      if (j == null) return null;
      if (typeof j == "function")
        return j.$$typeof === Y ? null : j.displayName || j.name || null;
      if (typeof j == "string") return j;
      switch (j) {
        case E:
          return "Fragment";
        case M:
          return "Profiler";
        case S:
          return "StrictMode";
        case x:
          return "Suspense";
        case v:
          return "SuspenseList";
        case P:
          return "Activity";
      }
      if (typeof j == "object")
        switch (typeof j.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), j.$$typeof) {
          case b:
            return "Portal";
          case O:
            return (j.displayName || "Context") + ".Provider";
          case N:
            return (j._context.displayName || "Context") + ".Consumer";
          case A:
            var X = j.render;
            return j = j.displayName, j || (j = X.displayName || X.name || "", j = j !== "" ? "ForwardRef(" + j + ")" : "ForwardRef"), j;
          case w:
            return X = j.displayName || null, X !== null ? X : t(j.type) || "Memo";
          case C:
            X = j._payload, j = j._init;
            try {
              return t(j(X));
            } catch {
            }
        }
      return null;
    }
    function e(j) {
      return "" + j;
    }
    function n(j) {
      try {
        e(j);
        var X = !1;
      } catch {
        X = !0;
      }
      if (X) {
        X = console;
        var tt = X.error, et = typeof Symbol == "function" && Symbol.toStringTag && j[Symbol.toStringTag] || j.constructor.name || "Object";
        return tt.call(
          X,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          et
        ), e(j);
      }
    }
    function r(j) {
      if (j === E) return "<>";
      if (typeof j == "object" && j !== null && j.$$typeof === C)
        return "<...>";
      try {
        var X = t(j);
        return X ? "<" + X + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function a() {
      var j = V.A;
      return j === null ? null : j.getOwner();
    }
    function o() {
      return Error("react-stack-top-frame");
    }
    function u(j) {
      if (k.call(j, "key")) {
        var X = Object.getOwnPropertyDescriptor(j, "key").get;
        if (X && X.isReactWarning) return !1;
      }
      return j.key !== void 0;
    }
    function c(j, X) {
      function tt() {
        F || (F = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          X
        ));
      }
      tt.isReactWarning = !0, Object.defineProperty(j, "key", {
        get: tt,
        configurable: !0
      });
    }
    function l() {
      var j = t(this.type);
      return U[j] || (U[j] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), j = this.props.ref, j !== void 0 ? j : null;
    }
    function d(j, X, tt, et, ot, Z, lt, z) {
      return tt = Z.ref, j = {
        $$typeof: m,
        type: j,
        key: X,
        props: Z,
        _owner: ot
      }, (tt !== void 0 ? tt : null) !== null ? Object.defineProperty(j, "ref", {
        enumerable: !1,
        get: l
      }) : Object.defineProperty(j, "ref", { enumerable: !1, value: null }), j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(j, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(j, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: lt
      }), Object.defineProperty(j, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: z
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    }
    function g(j, X, tt, et, ot, Z, lt, z) {
      var nt = X.children;
      if (nt !== void 0)
        if (et)
          if (T(nt)) {
            for (et = 0; et < nt.length; et++)
              y(nt[et]);
            Object.freeze && Object.freeze(nt);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else y(nt);
      if (k.call(X, "key")) {
        nt = t(j);
        var it = Object.keys(X).filter(function(ht) {
          return ht !== "key";
        });
        et = 0 < it.length ? "{key: someKey, " + it.join(": ..., ") + ": ...}" : "{key: someKey}", B[nt + et] || (it = 0 < it.length ? "{" + it.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          et,
          nt,
          it,
          nt
        ), B[nt + et] = !0);
      }
      if (nt = null, tt !== void 0 && (n(tt), nt = "" + tt), u(X) && (n(X.key), nt = "" + X.key), "key" in X) {
        tt = {};
        for (var Q in X)
          Q !== "key" && (tt[Q] = X[Q]);
      } else tt = X;
      return nt && c(
        tt,
        typeof j == "function" ? j.displayName || j.name || "Unknown" : j
      ), d(
        j,
        nt,
        Z,
        ot,
        a(),
        tt,
        lt,
        z
      );
    }
    function y(j) {
      typeof j == "object" && j !== null && j.$$typeof === m && j._store && (j._store.validated = 1);
    }
    var f = br, m = Symbol.for("react.transitional.element"), b = Symbol.for("react.portal"), E = Symbol.for("react.fragment"), S = Symbol.for("react.strict_mode"), M = Symbol.for("react.profiler"), N = Symbol.for("react.consumer"), O = Symbol.for("react.context"), A = Symbol.for("react.forward_ref"), x = Symbol.for("react.suspense"), v = Symbol.for("react.suspense_list"), w = Symbol.for("react.memo"), C = Symbol.for("react.lazy"), P = Symbol.for("react.activity"), Y = Symbol.for("react.client.reference"), V = f.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, k = Object.prototype.hasOwnProperty, T = Array.isArray, R = console.createTask ? console.createTask : function() {
      return null;
    };
    f = {
      react_stack_bottom_frame: function(j) {
        return j();
      }
    };
    var F, U = {}, H = f.react_stack_bottom_frame.bind(
      f,
      o
    )(), W = R(r(o)), B = {};
    Co.Fragment = E, Co.jsx = function(j, X, tt, et, ot) {
      var Z = 1e4 > V.recentlyCreatedOwnerStacks++;
      return g(
        j,
        X,
        tt,
        !1,
        et,
        ot,
        Z ? Error("react-stack-top-frame") : H,
        Z ? R(r(j)) : W
      );
    }, Co.jsxs = function(j, X, tt, et, ot) {
      var Z = 1e4 > V.recentlyCreatedOwnerStacks++;
      return g(
        j,
        X,
        tt,
        !0,
        et,
        ot,
        Z ? Error("react-stack-top-frame") : H,
        Z ? R(r(j)) : W
      );
    };
  }()), Co;
}
process.env.NODE_ENV === "production" ? ld.exports = _D() : ld.exports = bD();
var p = ld.exports;
const wD = {
  content: [
    {
      id: 91,
      name: "My New Data Source ",
      modelType: "CDM",
      cdmVersion: "V5_3_1",
      published: !0,
      dbmsType: "MS_SQL_SERVER",
      metadata: {
        21: 1
      },
      accessType: "RESTRICTED",
      executionPolicy: "MANUAL",
      dataNode: {
        id: 3,
        name: "QA-EENODE1",
        description: "Odysseus Arachne Enterprise QA Server",
        virtual: !1,
        atlasVersion: "2.10.0",
        healthStatus: "GREEN",
        healthStatusTitle: "GREEN",
        dataOwners: null,
        currentUserDataOwner: !0,
        published: !0,
        organization: {
          id: 2,
          name: "Odysseus"
        },
        permissions: {}
      },
      healthStatus: "GREEN",
      healthStatusTitle: "GREEN",
      permissions: {}
    },
    {
      id: 1,
      name: "SynPUF 110k",
      modelType: "CDM",
      cdmVersion: "V5_3_1",
      published: !0,
      dbmsType: "POSTGRESQL",
      metadata: {},
      accessType: "PUBLIC",
      executionPolicy: "UNSUPERVISED",
      dataNode: {
        id: 3,
        name: "QA-EENODE1",
        description: "Odysseus Arachne Enterprise QA Server",
        virtual: !1,
        atlasVersion: "2.10.0",
        healthStatus: "GREEN",
        healthStatusTitle: "GREEN",
        dataOwners: null,
        currentUserDataOwner: !0,
        published: !0,
        organization: {
          id: 2,
          name: "Odysseus"
        },
        permissions: {}
      },
      healthStatus: "GREEN",
      healthStatusTitle: "GREEN",
      permissions: {}
    },
    {
      id: 48,
      name: "SynPUF 110k (BigQuery)",
      modelType: "OTHER",
      published: !0,
      dbmsType: "BIGQUERY",
      metadata: {},
      accessType: "PUBLIC",
      executionPolicy: "SUPERVISED",
      dataNode: {
        id: 3,
        name: "QA-EENODE1",
        description: "Odysseus Arachne Enterprise QA Server",
        virtual: !1,
        atlasVersion: "2.10.0",
        healthStatus: "GREEN",
        healthStatusTitle: "GREEN",
        dataOwners: null,
        currentUserDataOwner: !0,
        published: !0,
        organization: {
          id: 2,
          name: "Odysseus"
        },
        permissions: {}
      },
      healthStatus: "GREEN",
      healthStatusTitle: "GREEN",
      permissions: {}
    },
    {
      id: 47,
      name: "SynPUF 110k (Impala)",
      modelType: "OTHER",
      published: !0,
      dbmsType: "IMPALA",
      metadata: {},
      accessType: "PUBLIC",
      executionPolicy: "SUPERVISED",
      dataNode: {
        id: 3,
        name: "QA-EENODE1",
        description: "Odysseus Arachne Enterprise QA Server",
        virtual: !1,
        atlasVersion: "2.10.0",
        healthStatus: "GREEN",
        healthStatusTitle: "GREEN",
        dataOwners: null,
        currentUserDataOwner: !0,
        published: !0,
        organization: {
          id: 2,
          name: "Odysseus"
        },
        permissions: {}
      },
      healthStatus: "GREEN",
      healthStatusTitle: "GREEN",
      permissions: {}
    },
    {
      id: 23,
      name: "SynPUF 2m",
      modelType: "CDM",
      cdmVersion: "V5_3_1",
      published: !0,
      dbmsType: "POSTGRESQL",
      metadata: {},
      accessType: "PUBLIC",
      executionPolicy: "UNSUPERVISED",
      dataNode: {
        id: 3,
        name: "QA-EENODE1",
        description: "Odysseus Arachne Enterprise QA Server",
        virtual: !1,
        atlasVersion: "2.10.0",
        healthStatus: "GREEN",
        healthStatusTitle: "GREEN",
        dataOwners: null,
        currentUserDataOwner: !0,
        published: !0,
        organization: {
          id: 2,
          name: "Odysseus"
        },
        permissions: {}
      },
      healthStatus: "GREEN",
      healthStatusTitle: "GREEN",
      permissions: {}
    },
    {
      id: 66,
      name: "SynPUF 2m sp",
      modelType: "CDM",
      cdmVersion: "V5_3_1",
      published: !0,
      dbmsType: "POSTGRESQL",
      metadata: {},
      accessType: "RESTRICTED",
      executionPolicy: "UNSUPERVISED",
      dataNode: {
        id: 3,
        name: "QA-EENODE1",
        description: "Odysseus Arachne Enterprise QA Server",
        virtual: !1,
        atlasVersion: "2.10.0",
        healthStatus: "GREEN",
        healthStatusTitle: "GREEN",
        dataOwners: null,
        currentUserDataOwner: !0,
        published: !0,
        organization: {
          id: 2,
          name: "Odysseus"
        },
        permissions: {}
      },
      healthStatus: "GREEN",
      healthStatusTitle: "GREEN",
      permissions: {}
    },
    {
      id: 24,
      name: "Synthea Covid19",
      modelType: "OTHER",
      published: !0,
      dbmsType: "POSTGRESQL",
      metadata: {},
      accessType: "PUBLIC",
      executionPolicy: "UNSUPERVISED",
      dataNode: {
        id: 3,
        name: "QA-EENODE1",
        description: "Odysseus Arachne Enterprise QA Server",
        virtual: !1,
        atlasVersion: "2.10.0",
        healthStatus: "GREEN",
        healthStatusTitle: "GREEN",
        dataOwners: null,
        currentUserDataOwner: !0,
        published: !0,
        organization: {
          id: 2,
          name: "Odysseus"
        },
        permissions: {}
      },
      healthStatus: "GREEN",
      healthStatusTitle: "GREEN",
      permissions: {}
    },
    {
      id: 2,
      name: "ds_for_autotests",
      modelType: "CDM",
      cdmVersion: "V5_3_1",
      published: !0,
      dbmsType: "POSTGRESQL",
      metadata: {
        20: "Hello World",
        22: 3,
        23: [5, 6]
      },
      accessType: "RESTRICTED",
      executionPolicy: "UNSUPERVISED",
      dataNode: {
        id: 3,
        name: "QA-EENODE1",
        description: "Odysseus Arachne Enterprise QA Server",
        virtual: !1,
        atlasVersion: "2.10.0",
        healthStatus: "GREEN",
        healthStatusTitle: "GREEN",
        dataOwners: null,
        currentUserDataOwner: !0,
        published: !0,
        organization: {
          id: 2,
          name: "Odysseus"
        },
        permissions: {}
      },
      healthStatus: "GREEN",
      healthStatusTitle: "GREEN",
      permissions: {}
    },
    {
      id: 90,
      name: "manual",
      modelType: "CDM",
      cdmVersion: "V5_3_1",
      published: !0,
      dbmsType: "POSTGRESQL",
      metadata: {},
      accessType: "PUBLIC",
      executionPolicy: "MANUAL",
      dataNode: {
        id: 3,
        name: "QA-EENODE1",
        description: "Odysseus Arachne Enterprise QA Server",
        virtual: !1,
        atlasVersion: "2.10.0",
        healthStatus: "GREEN",
        healthStatusTitle: "GREEN",
        dataOwners: null,
        currentUserDataOwner: !0,
        published: !0,
        organization: {
          id: 2,
          name: "Odysseus"
        },
        permissions: {}
      },
      healthStatus: "GREEN",
      healthStatusTitle: "GREEN",
      permissions: {}
    }
  ]
}, zu = {
  1: {
    id: 1,
    name: "SynPUF 110k",
    modelType: "CDM",
    cdmVersion: "V5_3_1",
    published: !0,
    dbmsType: "POSTGRESQL",
    metadata: {},
    accessType: "PUBLIC",
    executionPolicy: "UNSUPERVISED",
    dataNode: {
      id: 3,
      name: "QA-EENODE1",
      description: "Odysseus Arachne Enterprise QA Server",
      virtual: !1,
      atlasVersion: "2.10.0",
      healthStatus: "GREEN",
      healthStatusTitle: "GREEN",
      dataOwners: null,
      currentUserDataOwner: !0,
      published: !0,
      organization: {
        id: 2,
        name: "Odysseus"
      },
      permissions: {}
    },
    healthStatus: "GREEN",
    healthStatusTitle: "GREEN",
    permissions: {
      DELETE_DATASOURCE: !0,
      EDIT_ACHILLES_REPORT_PERMISSION: !0,
      ACCESS_DATASOURCE: !0,
      ACCESS_ACHILLES_REPORT_PERMISSION: !0,
      EDIT_DATASOURCE: !0,
      UPLOAD_ACHILLES_REPORTS: !0
    }
  }
};
({
  ...wD.content.reduce((t, e) => {
    const { id: n } = e;
    return {
      ...t,
      [`entity_${n}`]: zu[n] ? zu[n] : zu[Object.keys(zu)[0]]
    };
  }, {})
});
const Lv = (t) => {
  const { pageNumber: e, pageSize: n, sortBy: r, query: a } = t, o = js(r), u = `/data-sources/list?size=${n || ""}&page=${e || 0}&sort=${o}&${a || ""}`;
  return Pt.get(u);
}, ED = (t) => {
  const { pageSize: e, sortBy: n, query: r } = t, a = js(n), o = `/data-sources/list-most-used?size=${e || ""}&page=0&sort=${a}&${r || ""}`;
  return Pt.get(o);
}, Pv = (t) => Pt.get(`/data-sources/${t}`), Nv = (t) => Pt.delete(`/data-sources/${t}`), Iv = (t, e) => Pt.put(`/data-sources/${t}`, e), SD = (t) => Pt.post("/data-sources", t), AD = (t, e) => e !== "new" ? Iv(e, t) : SD(t), TD = (t) => {
  const e = `/data-sources/filter?${t}`;
  return Pt.get(e);
}, CD = () => Pt.get("/data-sources/sorts"), RD = () => Pt.get("/workspace/datasource/sorts"), DD = () => Pt.get("/model-type"), MD = (t) => Pt.get(`/users/tenant/${t}`), lp = (t, e, n) => {
  const r = n ? `/studies/${t}/analyses/${n}/datasources` : `/studies/${t}/datasource/invites-legacy`, a = e ? "?status=ACTIVE" : "";
  return Pt.get(`${r}${a}`);
}, fp = (t, e) => {
  const n = e ? `/workspace/analyses/${e}/datasources` : "/workspace/datasource/invites/legacy", r = t ? "?status=ACTIVE" : "";
  return Pt.get(`${n}${r}`);
}, OD = (t) => (e) => Pt.get(`/studies/${t}/datasource/${e}`), LD = (t) => Pt.get(`/workspace/datasource/${t}`), PD = (t) => Pt.post(`/studies/datasource/${t}/enable`), ND = (t) => Pt.post(`/workspace/datasource/${t}/enable`), ID = (t) => Pt.post(`/studies/datasource/${t}/disable`), jD = (t) => Pt.post(`/workspace/datasource/${t}/disable`), kD = (t) => Pt.post(`/studies/datasource/invites/${t}/dismiss`, {
  note: ""
}), BD = (t) => Pt.post(`/workspace/datasource/invites/${t}/dismiss`, {
  note: ""
}), FD = (t, e, n = 1e4) => {
  const r = `/data-sources/list?size=${n || ""}&page=0&name==*${t || ""}*`;
  return Pt.get(r);
}, jv = (t, e, n) => Pt.post(`/studies/${t}/datasource/invites`, {
  datasourceId: e,
  message: n
}), UD = (t, e) => Pt.post("/workspace/datasource/invites", {
  datasourceId: t,
  message: e
}), $D = (t, e) => {
  const n = (/* @__PURE__ */ new Date()).valueOf(), r = {
    // ...study_data_sources[0],
    virtual: !0,
    name: e.name,
    id: n
  };
  return JR(r);
}, zD = (t, e) => Pt.post(`/datasource/${t}/reports/import`, e), VD = (t) => Pt.get(`/datasource/${t}/reports/list`), uy = (t, e) => Pt.get(`/datasource/${t}/reports/${e}`), YD = (t, e, n) => Pt.get(`/datasource/${t}/reports/${e}/${n}`), xh = (t, e) => {
  let n = "";
  t && e && (n += `?size=1000000&page=0&${t}=${e}`);
  const r = `/data-sources/metadata-value/list${n}`;
  return Pt.get(r);
}, _h = (t) => Pt.post("/data-sources/metadata-value", t), bh = (t, e) => {
  const n = `/data-sources/metadata-value/${e}`;
  return Pt.put(n, t);
}, wh = (t) => {
  const e = `/data-sources/metadata-value/${t}`;
  return Pt.delete(e);
}, WD = (t, e) => {
  const { pageNumber: n, pageSize: r, sortBy: a, query: o } = e, u = js(a), c = `/datasource/${t}/reports-type/list?size=${r || 1e4}&page=${n || 1}&sort=${u}&${o || ""}`;
  return Pt.get(c);
}, GD = (t, e) => Pt.put(`/datasource/${t}/permissions/list`, e), qD = (t) => Pt.get(`/datasource/${t}/permissions/list`), HD = (t) => Pt.get(`/datasource/tenant/${t}`), hp = (t) => Pt.get(`/datanodes/${t}/owners`), XD = (t, e) => Pt.post(`/datanodes/${t}/owners`, e), cy = (t, e) => Pt.delete(`/datanodes/${t}/owners/${e}`), QD = (t) => Pt.get(`/data-sources/${t}/summary`), KD = (t) => Pt.post(`/datasource/${t}/achilles`), ZD = (t) => Pt.get(`/datasource/${t}/achilles/submissions`), JD = (t, e, n, r) => {
  const a = {
    cdmVersion: e,
    checkLevels: n,
    excludedTables: r
  };
  return Pt.post(`/datasource/${t}/dqd`, a);
}, tM = (t) => Pt.get(`/datasource/${t}/dqd/submissions`), kv = (t) => Pt.get(`/datasource/${t}/dqd/reports`), Bv = (t) => Pt.get(`/datasource/${t}/dqd/overview`), Eh = (t, e) => {
  const n = `/data-sources/metadata-value/${t}/copy`;
  return Pt.post(n, e);
}, eM = (t, e) => {
  const n = { headers: { "Content-Type": "application/json" } };
  return Pt.post(`/datasource/${t}/logo`, e.image, n);
}, nM = (t) => Pt.get(`/datasource/${t}/logo`), rM = (t) => Pt.get(`/data-sources/${t}/statistics`), iM = (t, e) => {
  const { pageNumber: n, pageSize: r, sortBy: a, query: o } = e, u = js(a), c = `/data-sources/${t}/users?${o || ""}&size=${r || ""}&page=${n || ""}&sort=${u}`;
  return Pt.get(c);
}, aM = (t, e) => {
  const { pageNumber: n, pageSize: r, sortBy: a, query: o } = e, u = js(a), c = `/data-sources/${t}/studies?${o || ""}&size=${r || ""}&page=${n || ""}&sort=${u}`;
  return Pt.get(c);
}, oM = Qt(G)`
  padding: 4px 4px 4px 8px;
  border-bottom: 1px solid
    ${({ theme: t }) => t.palette.borderColor.light};
  display: flex;
  align-items: center;
  &:hover {
    background-color: ${({ theme: t }) => t.palette.backgroundColor.main};
  }
  svg {
    font-size: 16px;
  }
`, sM = (t) => {
  const { tenantId: e, onChange: n, dataSources: r } = t, [a, o] = Ot([]), [u, c] = Ot([]), l = br.useMemo(() => {
    const y = u.map((m) => m.object.id);
    return r == null ? void 0 : r.filter((m) => !y.includes(m.id)).map((m) => ({
      object: { ...m, title: m.name }
    }));
  }, [r, u]), d = (y) => {
    c(y), n(g(y));
  }, g = br.useCallback(
    (y) => {
      const f = y.filter(
        (b) => !a.map((E) => E.object.id).includes(b.object.id)
      ), m = a.filter(
        (b) => !y.map((E) => E.object.id).includes(b.object.id)
      );
      return { added: f, deleted: m };
    },
    [a]
  );
  return Ce(() => {
    HD(e).then((y) => {
      o(y), c(y);
    });
  }, []), /* @__PURE__ */ p.jsxs(G, { container: !0, p: 2, spacing: 2, children: [
    /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(Tn, { name: "existingDataSources", textLabel: "Added data sources", children: /* @__PURE__ */ p.jsx(G, { container: !0, mt: 2, children: u.length > 0 ? u.map((y) => /* @__PURE__ */ p.jsxs(
      oM,
      {
        item: !0,
        xs: 12,
        container: !0,
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ p.jsx(G, { item: !0, children: y.object.title }),
          /* @__PURE__ */ p.jsx(G, { item: !0, children: /* @__PURE__ */ p.jsx(
            _e,
            {
              size: "small",
              sx: { minWidth: 20, height: 20 },
              color: "error",
              onClick: () => {
                d(
                  u.filter(
                    (f) => f.object.id !== y.object.id
                  )
                );
              },
              children: /* @__PURE__ */ p.jsx(Qe, { iconName: "deactivate", fontSize: "small" })
            }
          ) })
        ]
      },
      y.object.id
    )) : /* @__PURE__ */ p.jsx("div", { children: "-" }) }) }) }),
    /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(Tn, { name: "dataSourceList", textLabel: "Add new data source", children: /* @__PURE__ */ p.jsx(
      xl,
      {
        className: "",
        name: "dataSourceList",
        id: "dataSourceList",
        options: l,
        value: u,
        placeholder: "Select participants",
        multiple: !0,
        onChange: (y, f) => {
          d(f);
        },
        fullWidth: !0,
        getOptionLabel: (y) => y.object.title,
        isOptionEqualToValue: (y, f) => y.object.id === (f == null ? void 0 : f.object.id),
        renderTags: () => "",
        disableClearable: !0
      }
    ) }) }) })
  ] });
}, uM = {
  createListMethods: (t, e, n) => () => {
    switch (t) {
      case on.WORKSPACE:
        return fp(!0, n);
      case on.STUDY:
        return lp(e, !0, n);
    }
  }
}, cM = Qt.div`
  cursor: pointer;
  padding: 12px;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  align-items: center;
  &:hover {
    background-color: ${({ theme: t }) => {
  var e;
  return (e = t.palette) == null ? void 0 : e.backgroundColor.dark;
}};
  }
  & > *:not(:last-child) {
    margin-right: 8px;
  }
`, lM = (t) => {
  const e = {};
  return t.forEach((n) => {
    const r = n.subject;
    e[r.id] = { ...r, logo: n.logo };
  }), e;
}, fM = (t) => {
  var y;
  const { onAdd: e, typeContainer: n, parentId: r, analysisId: a } = t, [o, u] = Ot({}), [c, l] = Ot({}), d = Fn(() => uM.createListMethods(n, r, a), [r]);
  Ce(() => {
    d().then((f) => {
      const b = (f.content || f).filter((E) => E.status === "ACTIVE");
      u(lM(b));
    });
  }, [d]);
  const g = (f, m) => {
    if (c[f]) {
      const b = { ...c };
      delete b[f], l(b);
    } else
      l({
        ...c,
        [f]: m
      });
  };
  return Ce(() => {
    e(Object.keys(c));
  }, [c]), /* @__PURE__ */ p.jsx(G, { container: !0, children: /* @__PURE__ */ p.jsxs(G, { item: !0, xs: 12, children: [
    ((y = Object.keys(o)) == null ? void 0 : y.length) === 0 && /* @__PURE__ */ p.jsx(
      G,
      {
        item: !0,
        xs: 12,
        color: "textColor.label",
        fontSize: 12,
        textAlign: "center",
        p: 2,
        children: "You have no active data sources"
      }
    ),
    Object.keys(o).map((f) => {
      const m = o[f], b = Object.keys(c).find(
        (E) => E === f
      );
      return /* @__PURE__ */ p.jsxs(
        cM,
        {
          onClick: (E) => g(f, m),
          name: "new-data-source-list-item",
          children: [
            /* @__PURE__ */ p.jsx(di, { checked: !!b }),
            /* @__PURE__ */ p.jsx(no, { value: m.id, size: 26 }),
            /* @__PURE__ */ p.jsx(Is, { dataSource: m })
          ]
        },
        f
      );
    })
  ] }) });
}, hM = {
  title: "Data sources",
  url: "/data-catalog",
  description: "Data Catalog is a collection of data sets available to the research team to be used in studies.",
  titleButton: "Go to data catalog"
};
var Wa = /* @__PURE__ */ ((t) => (t.BY_NAME = "BY_NAME", t.BY_STATUS = "BY_STATUS", t))(Wa || {});
function dM(t) {
  return t.map((e) => ({
    ...e,
    id: e.subject.id,
    invitationId: e.id
  }));
}
function ly(t) {
  return dM;
}
const pM = {
  addButtonText: "Add data source",
  groupingVariants: [
    {
      value: Wa.BY_STATUS,
      name: "Status"
    },
    {
      value: Wa.BY_NAME,
      name: "Name"
    }
  ],
  modal: {
    header: {
      new: "Add data source"
    }
  },
  listConfigGetter: (t, e, n) => ({
    primaryKey: "id",
    methods: {
      read: {
        method: () => {
          switch (e) {
            case on.WORKSPACE:
              return fp();
            case on.STUDY:
              return lp(t);
            default:
              return Lv({});
          }
        },
        formatter: ly()
      },
      get: {
        method: (r) => {
          switch (e) {
            case on.WORKSPACE:
              return LD(r);
            case on.STUDY:
              return OD(t)(r);
            default:
              return Pv(r);
          }
        },
        formatter: ly()
      },
      enable: (r) => {
        switch (e) {
          case on.WORKSPACE:
            return ND(r);
          case on.STUDY:
            return PD(r);
        }
      },
      disable: (r) => {
        switch (e) {
          case on.WORKSPACE:
            return jD(r);
          case on.STUDY:
            return ID(r);
        }
      },
      dismiss: (r) => {
        switch (e) {
          case on.WORKSPACE:
            return BD(r);
          case on.STUDY:
            return kD(r);
        }
      }
    }
  })
};
Qt.div``;
Qt(Ec)`
  margin: 0;
  box-shadow: none;
  .collapsible-block__content {
    padding: 10px;
  }
`;
function gM(t, e) {
  switch (t) {
    case ar.ACTIVE:
      return e.palette.success.main;
    case ar.PENDING:
      return e.palette.warning.main;
    case ar.REJECTED:
      return e.palette.error.main;
    case ar.DISABLED:
    default:
      return e.palette.grey[400];
  }
}
function mM(t) {
  return tD(t);
}
const yM = lr(
  (t) => {
    const { status: e } = t, n = Sc(), { color: r, title: a } = Fn(() => ({
      color: gM(e, n),
      title: mM(e).toUpperCase()
    }), [e, n]);
    return /* @__PURE__ */ p.jsx(
      is,
      {
        text: /* @__PURE__ */ p.jsx(He, { sx: { textTransform: "capitalize" }, children: a.toLowerCase() }),
        placement: "left",
        children: /* @__PURE__ */ p.jsx(
          He,
          {
            "data-status": e,
            sx: {
              backgroundColor: r,
              width: 14,
              height: 14,
              borderRadius: "50%",
              boxShadow: "inset -4px -4px 10px rgba(255,255,255,.4)",
              cursor: "pointer",
              transition: "300ms",
              ":hover": {
                filter: "brightness(90%)"
              }
            }
          }
        )
      }
    );
  }
), vM = Qt(G)`
  font-weight: bold;
  font-size: 14px;
  overflow-x: hidden;
  text-overflow: ellipsis;
  min-width: calc(100% - 54px);
  white-space: nowrap;
`, xM = (t) => {
  const { dataSource: e, showStatus: n = !1, changeStatus: r } = t, [a, o] = Ot(!1);
  Ce(() => {
    o(!1);
  }, [e.status]);
  const u = br.useMemo(
    () => {
      var l, d;
      return ((l = e.actions) == null ? void 0 : l[vh.DISMISS]) || ((d = e.actions) == null ? void 0 : d[vh.DISABLE]);
    },
    [e.actions]
  ), c = br.useMemo(
    () => {
      var l;
      return (l = e.actions) == null ? void 0 : l[vh.ENABLE];
    },
    [e.actions]
  );
  return /* @__PURE__ */ p.jsxs(
    G,
    {
      container: !0,
      borderBottom: "1px solid #EEEEEE",
      py: 2,
      color: "textColor.secondary",
      spacing: 0.5,
      justifyContent: "space-between",
      flexWrap: "nowrap",
      className: "data-sources-list-item",
      width: "100%",
      alignItems: "center",
      children: [
        /* @__PURE__ */ p.jsx(G, { item: !0, alignItems: "center", width: "calc(100% - 20px)", children: /* @__PURE__ */ p.jsxs(G, { container: !0, alignItems: "center", flexWrap: "nowrap", spacing: 1, children: [
          /* @__PURE__ */ p.jsx(G, { item: !0, className: "data-source-logo", display: "inline-flex", children: /* @__PURE__ */ p.jsx(no, { value: e.id, size: 20 }) }),
          /* @__PURE__ */ p.jsx(G, { item: !0, className: "data-source-list-item-status", width: 24, children: n && /* @__PURE__ */ p.jsx(yM, { status: e.status }) }),
          /* @__PURE__ */ p.jsx(
            vM,
            {
              item: !0,
              className: "data-source-list-item-name",
              color: "textColor.secondary",
              children: /* @__PURE__ */ p.jsx(
                is,
                {
                  text: e.subject.name + " : " + e.subject.dataNode.name,
                  color: "primary",
                  width: "auto",
                  children: /* @__PURE__ */ p.jsxs("span", { children: [
                    e.subject.name,
                    ": ",
                    e.subject.dataNode.name
                  ] })
                }
              )
            }
          ),
          e.dismissNote && /* @__PURE__ */ p.jsx(G, { item: !0, width: 30, textAlign: "right", children: /* @__PURE__ */ p.jsx(DR, { tooltipText: e.dismissNote }) })
        ] }) }),
        /* @__PURE__ */ p.jsx(G, { item: !0, width: 20, children: /* @__PURE__ */ p.jsx(p.Fragment, { children: a ? /* @__PURE__ */ p.jsx(Ke, { size: 16 }) : /* @__PURE__ */ p.jsx(p.Fragment, { children: (e.status === ar.ACTIVE || e.status === ar.PENDING) && u ? /* @__PURE__ */ p.jsx(
          ud,
          {
            name: "study-data-source-remove-btn",
            onClick: () => {
              o(!0), r(e, "disable");
            },
            sx: { p: 0.5 },
            children: /* @__PURE__ */ p.jsx(
              is,
              {
                text: "Disable data source",
                color: "primary",
                width: "auto",
                children: /* @__PURE__ */ p.jsx(
                  Qe,
                  {
                    iconName: "deactivate",
                    name: "disable",
                    sx: { fontSize: 14, color: "text.secondary" }
                  }
                )
              }
            )
          }
        ) : c && /* @__PURE__ */ p.jsx(
          ud,
          {
            name: "study-data-source-remove-btn",
            onClick: () => {
              o(!0), r(e, "enable");
            },
            sx: { p: 0.5 },
            children: /* @__PURE__ */ p.jsx(
              is,
              {
                text: "Enable data source",
                color: "primary",
                width: "auto",
                children: /* @__PURE__ */ p.jsx(
                  Qe,
                  {
                    iconName: "reload",
                    name: "reload",
                    sx: { fontSize: 14, color: "text.secondary" }
                  }
                )
              }
            )
          }
        ) }) }) })
      ]
    }
  );
}, _M = lr((t) => {
  const { dataSource: e, groupingVariant: n, onRemove: r } = t, a = Ie((o, u) => {
    r == null || r(o, u);
  }, []);
  return /* @__PURE__ */ p.jsx(G, { container: !0, spacing: 2, children: /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: n === Wa.BY_NAME && /* @__PURE__ */ p.jsx(
    xM,
    {
      dataSource: e,
      changeStatus: a,
      showStatus: !0
    }
  ) }) });
}), bM = lr((t) => {
  const { data: e, processingIds: n, groupingVariant: r, onRemove: a } = t;
  return /* @__PURE__ */ p.jsx(G, { container: !0, mt: -1, className: "data-sources-list", children: e.map((o) => /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(
    _M,
    {
      dataSource: o,
      isProcessing: n.includes(o.id),
      groupingVariant: r,
      onRemove: a
    }
  ) }, o.id)) });
}), wM = {
  entityNavigationPanel: (t) => [
    {
      value: hc.DATA_CATALOG,
      title: "Data catalog",
      onTabClick: t
    }
    // {
    //   id: DataSourceFormTabs.VIRTUAL_SOURCE,
    //   title: 'Virtual Source',
    //   onTab: setActive
    // },
  ]
}, EM = {
  getApiMethods: (t) => ({
    create: (e, n, r) => {
      switch (t) {
        case on.WORKSPACE:
          return UD(n, r);
        case on.STUDY:
          return jv(e, n, r);
        default:
          return;
      }
    }
  }),
  listConfigGetter: (t) => ({
    primaryKey: "id",
    methods: {
      read: {
        method: (e) => FD(e.query),
        formatter: (e) => e
      }
    }
  })
}, SM = Qt.div`
  margin: 0;
  .content-block {
    box-shadow: none;
    border: 1px solid ${({ theme: t }) => {
  var e;
  return (e = t.palette) == null ? void 0 : e.borderColor.light;
}};
  }
`;
Qt.div`
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 200px;
`;
Qt.div`
  padding: 12px;
`;
Qt.div`
  margin-right: 8px;
`;
Qt.div`
  cursor: pointer;
  padding: 12px;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  align-items: center;
  &:hover {
    background-color: ${({ theme: t }) => {
  var e;
  return (e = t.palette) == null ? void 0 : e.backgroundColor.dark;
}};
  }
`;
const AM = Qt.div`
  margin-top: 16px;
  text-align: right;
  & > button:not(:last-of-type) {
    margin-right: 10px;
  }
`, TM = Qt.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.4);
  z-index: 1;
  pointer-events: none;
`;
Qt.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  color: ${({ theme: t }) => {
  var e;
  return (e = t == null ? void 0 : t.palette) == null ? void 0 : e.grey[600];
}};
  text-transform: uppercase;
  flex-grow: 1;
`;
const CM = Qt(G)`
  .cart-item__container {
    display: flex;
    align-items: center;
    :hover {
      background-color: ${({ theme: t }) => {
  var e;
  return (e = t == null ? void 0 : t.palette) == null ? void 0 : e.backgroundColor.main;
}};
    }
  }
  .cart-item__remove-btn {
    margin-right: 8px;
  }
  .content-block__title {
    display: none;
  }
`, RM = (t) => {
  const { studyId: e, onCancel: n, afterCreate: r, currentList: a, typeContainer: o } = t, { getApiMethods: u, listConfigGetter: c } = EM, [l, d] = Ot(!1), [g, y] = Ot(""), f = Fn(() => u(o), [e, o]), { enqueueSnackbar: m } = bi(), { primaryKey: b, methods: E } = c(Number(e)), S = _l({
    primaryKey: b,
    methods: E
  }), [M, N] = Ot([]);
  Ce(() => {
    S.getEntityList();
  }, []);
  const O = (v, w) => {
    v.preventDefault(), N(w);
  }, A = (v, w) => {
    v.preventDefault(), N(
      (C) => C.filter((P) => P.id !== w.id)
    );
  }, x = Ie(async () => {
    d(!0);
    const v = M.map(
      (w) => f.create(
        e || null,
        w.id,
        g || ""
      )
    );
    try {
      await Promise.all(v), d(!1), r == null || r();
    } catch {
      d(!1), m({
        message: `Failed to add data ${M.length > 1 ? "sources" : "source"}!`,
        variant: "error"
      });
    }
  }, [M, g]);
  return /* @__PURE__ */ p.jsxs(SM, { name: "new-data-source-form-data-catalog", children: [
    /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ p.jsx(Tn, { name: "dataSources", textLabel: "Data Sources", children: /* @__PURE__ */ p.jsx(
      xl,
      {
        value: M,
        options: eD(
          Object.values(S.data.byId),
          (v) => v.name.toLowerCase()
        ).filter((v) => !a.includes(v.id)),
        onChange: function(v, w) {
          O(v, w);
        },
        getOptionLabel: function(v) {
          return v.name;
        },
        isOptionEqualToValue: (v, w) => v.id === w.id,
        placeholder: "Select data sources from list",
        OptionComponent: (v, w, { selected: C }) => /* @__PURE__ */ p.jsxs(
          He,
          {
            ...v,
            sx: {
              fontSize: "13px",
              height: "30px",
              display: "flex",
              alignItems: "center"
            },
            children: [
              /* @__PURE__ */ p.jsx(
                di,
                {
                  sx: { marginRight: 8 },
                  checked: C,
                  size: "small"
                }
              ),
              /* @__PURE__ */ p.jsx(He, { sx: { display: "inline-flex", mr: 1 }, children: /* @__PURE__ */ p.jsx(no, { value: w.id, size: 20 }) }),
              w.name
            ]
          }
        ),
        renderTags: (v, w) => {
          var C;
          return /* @__PURE__ */ p.jsxs(
            He,
            {
              sx: {
                px: 1,
                fontSize: 14,
                color: "textColor.label"
              },
              children: [
                v != null && v.length ? (v == null ? void 0 : v.length) === ((C = S.data.ids) == null ? void 0 : C.length) ? "All tables" : v == null ? void 0 : v.length : "None",
                " ",
                "selected..."
              ]
            },
            "tag-props"
          );
        },
        loading: !S.isLoaded,
        multiple: !0,
        disableCloseOnSelect: !0
      }
    ) }) }),
    /* @__PURE__ */ p.jsx(fs, {}),
    (S.isLoading || l) && /* @__PURE__ */ p.jsx(TM, { children: /* @__PURE__ */ p.jsx(Ke, {}) }),
    S.isLoaded && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
      /* @__PURE__ */ p.jsx(CM, { children: /* @__PURE__ */ p.jsx(
        MR,
        {
          items: M,
          title: "Selected Data Sources",
          emptyText: /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
            "No data sources selected. ",
            /* @__PURE__ */ p.jsx("br", {}),
            " Select data sources from the drop down list above."
          ] }),
          buttonText: "Delete all data sources",
          itemComponent: (v) => /* @__PURE__ */ p.jsx(Is, { dataSource: v }),
          onRemove: (v, w) => {
            A(v, w);
          }
        }
      ) }),
      /* @__PURE__ */ p.jsxs(G, { item: !0, xs: 12, p: 2, children: [
        /* @__PURE__ */ p.jsx(
          ja,
          {
            multiline: !0,
            fullWidth: !0,
            value: g,
            onChange: (v) => y(v.target.value),
            maxRows: 3,
            minRows: 2,
            placeholder: "Enter invitation message"
          }
        ),
        /* @__PURE__ */ p.jsxs(AM, { children: [
          /* @__PURE__ */ p.jsx(
            _e,
            {
              variant: "outlined",
              onClick: n,
              startIcon: /* @__PURE__ */ p.jsx(Qe, { iconName: "deactivate" }),
              name: "delete",
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ p.jsx(
            _e,
            {
              onClick: x,
              variant: "contained",
              color: "success",
              startIcon: /* @__PURE__ */ p.jsx(Qe, { iconName: "submit" }),
              name: "save",
              disabled: !S.data.ids.length || S.isLoading || l || !M.length,
              children: "Save"
            }
          )
        ] })
      ] })
    ] })
  ] });
}, DM = Qt.div`
  /* margin: 15px; */
`, fy = Qt.div`
  align-items: center;
  display: flex;
  min-height: 30px;
  label {
    margin-right: 10px;
    min-width: 140px;
  }

  .autocomplete {
    width: 100%;
  }
`;
Qt.div`
  & > button {
    margin-right: 10px;
  }
`;
const MM = Qt.div`
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
`, OM = {
  addDataSource: $D,
  participantsListGetter: (t) => ({
    primaryKey: "id",
    methods: {
      read: {
        // TODO
        method: () => {
        },
        formatter: (e) => {
          const n = nD(
            e,
            (r) => r.id
          );
          return Object.keys(n).map((r) => {
            const a = n[r][0];
            return {
              id: a.id,
              fullName: a.fullName
            };
          });
        }
      }
    }
  })
}, LM = (t) => {
  const { studyId: e, onCancel: n, afterCreate: r } = t, [a, o] = Ot(!1), [u, c] = Ot({
    name: "",
    dataOwnersIds: []
  }), { participantsListGetter: l, addDataSource: d } = OM, { methods: g, primaryKey: y } = l(e), f = _l({ methods: g, primaryKey: y, autoLoad: !0 }), { enqueueSnackbar: m } = bi(), b = Ie(
    (M) => {
      const { name: N, value: O } = M.target;
      c({
        ...u,
        [N]: O
      });
    },
    [u]
  ), E = Ie(
    (M) => (N, O) => {
      c({
        ...u,
        [M]: O
      });
    },
    [u]
  ), S = Ie(async () => {
    o(!0);
    try {
      const M = await d(Number(e), u);
      r == null || r([M]), o(!1);
    } catch {
      o(!1), m({
        message: "Failed to add Virtual Data Source!",
        variant: "error"
      });
    }
  }, [u]);
  return f.isLoading ? /* @__PURE__ */ p.jsx(MM, { children: /* @__PURE__ */ p.jsx(Ke, {}) }) : /* @__PURE__ */ p.jsx(DM, { children: /* @__PURE__ */ p.jsxs(G, { container: !0, spacing: 2, children: [
    /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsxs(fy, { children: [
      /* @__PURE__ */ p.jsx("label", { htmlFor: "virtual-source-name", children: "Data Source Name: " }),
      /* @__PURE__ */ p.jsx(
        ja,
        {
          id: "virtual-source-name",
          name: "name",
          onChange: b,
          type: "text",
          value: u.name,
          fullWidth: !0
        }
      )
    ] }) }),
    /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsxs(fy, { children: [
      /* @__PURE__ */ p.jsx("label", { htmlFor: "virtual-source-data-owner", children: "Data Owners: " }),
      /* @__PURE__ */ p.jsx(
        xl,
        {
          multiple: !0,
          name: "dataOwnersIds",
          id: "virtual-source-data-owner",
          value: u.dataOwnersIds,
          placeholder: "Select data owners...",
          options: Object.values(f.data.byId),
          fullWidth: !0,
          getOptionLabel: (M) => M.fullName,
          onChange: E("dataOwnersIds")
        }
      )
    ] }) }),
    /* @__PURE__ */ p.jsxs(G, { item: !0, xs: 12, children: [
      /* @__PURE__ */ p.jsx(
        _e,
        {
          variant: "contained",
          onClick: S,
          disabled: a || !u.name || !u.dataOwnersIds.length,
          children: "Add"
        }
      ),
      /* @__PURE__ */ p.jsx(_e, { variant: "outlined", onClick: n, children: "Cancel" })
    ] })
  ] }) });
}, PM = (t) => {
  const { studyId: e, onCancel: n, afterCreate: r, currentList: a, typeContainer: o } = t, [u, c] = Ot(
    hc.DATA_CATALOG
  ), l = Fn(() => wM.entityNavigationPanel(c), []);
  return /* @__PURE__ */ p.jsxs(G, { container: !0, children: [
    /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(ka, { elevation: 3, children: /* @__PURE__ */ p.jsx(sp, { tabs: l, active: u }) }) }),
    /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
      u == hc.DATA_CATALOG && /* @__PURE__ */ p.jsx(
        RM,
        {
          studyId: e,
          onCancel: n,
          afterCreate: r,
          currentList: a,
          typeContainer: o
        }
      ),
      u == hc.VIRTUAL_SOURCE && /* @__PURE__ */ p.jsx(
        LM,
        {
          studyId: e,
          onCancel: n,
          afterCreate: r
        }
      )
    ] }) })
  ] });
}, NM = (t) => {
  var M;
  const { parentId: e, typeContainer: n, viewMode: r } = t, a = Mv((N) => N.invitations.count), o = Ov(), { addButtonText: u, modal: c, listConfigGetter: l } = pM, d = l(
    e,
    n,
    Wa.BY_NAME
  ), { openModal: g, closeModal: y } = Ar(io), f = _l({
    methods: d.methods,
    primaryKey: d.primaryKey
  });
  Ce(() => {
    f.getEntityList();
  }, [a]);
  const m = Ie(() => {
    y();
  }, []), b = Ie(() => {
    f.getEntityList(), m(), o(ay(n, e));
  }, []), E = Ie(() => {
    const N = f.data.ids.map((O) => {
      const A = f.data.byId[O];
      if (A.status === ar.ACTIVE || A.status === ar.PENDING)
        return A.subject.id;
    });
    g(
      () => /* @__PURE__ */ p.jsx(
        PM,
        {
          studyId: e,
          onCancel: m,
          afterCreate: b,
          currentList: N,
          typeContainer: n
        }
      ),
      c.header.new,
      {
        onClose: m,
        width: "700px",
        closeOnClickOutside: !0
      }
    );
  }, [f.data.ids]), S = Ie(
    async (N, O) => {
      try {
        O === "disable" && (N.status === ar.PENDING ? await d.methods.dismiss(N.invitationId) : N.status === ar.ACTIVE && await d.methods.disable(N.invitationId)), O === "enable" && N.status === ar.DISABLED && await d.methods.enable(N.invitationId);
      } catch {
      }
      o(ay(n, e)), await f.getEntityList();
    },
    []
  );
  return /* @__PURE__ */ p.jsx(
    OR,
    {
      addButtonText: u,
      onAddClick: E,
      status: f.status,
      isEmpty: ((M = f.data.ids) == null ? void 0 : M.length) === 0,
      actions: f.actions,
      listName: "data-sources",
      emptyTableText: "No data sources",
      viewMode: r,
      loadingSkeleton: /* @__PURE__ */ p.jsx(G, { container: !0, mt: -1, className: "data-sources-list", children: Array.from({ length: 9 }).map((N, O) => /* @__PURE__ */ p.jsx(
        G,
        {
          item: !0,
          xs: 12,
          borderBottom: "1px solid #EEEEEE",
          py: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          flexWrap: "nowrap",
          children: /* @__PURE__ */ p.jsxs(
            G,
            {
              container: !0,
              alignItems: "center",
              flexWrap: "nowrap",
              spacing: 1,
              width: "100%",
              children: [
                /* @__PURE__ */ p.jsx(G, { item: !0, display: "inline-flex", children: /* @__PURE__ */ p.jsx(mh, { variant: "rounded", sx: { width: 20, height: 20 } }) }),
                /* @__PURE__ */ p.jsx(G, { item: !0, width: 24, children: /* @__PURE__ */ p.jsx(mh, { variant: "circular", sx: { width: 16, height: 16 } }) }),
                /* @__PURE__ */ p.jsx(G, { item: !0, flexGrow: 1, minWidth: 0, children: /* @__PURE__ */ p.jsx(
                  mh,
                  {
                    variant: "rounded",
                    sx: { height: 20, width: O % 2 === 0 ? "92%" : "78%" }
                  }
                ) })
              ]
            }
          )
        },
        `data-sources-loading-${O}`
      )) }),
      children: /* @__PURE__ */ p.jsx(
        bM,
        {
          processingIds: f.processingIds,
          data: Object.values(f.data.byId),
          groupingVariant: Wa.BY_NAME,
          onRemove: S
        }
      )
    }
  );
}, IM = (t) => {
  const { config: e, viewMode: n } = t, { typeContainer: r, parentId: a } = e;
  return /* @__PURE__ */ p.jsx(
    NM,
    {
      parentId: a,
      typeContainer: r,
      viewMode: n
    }
  );
}, jM = {
  createListMethods: (t, e) => () => {
    switch (t) {
      case on.WORKSPACE:
        return fp(!0);
      case on.STUDY:
        return lp(e, !0);
    }
  }
}, kM = (t, e) => {
  const n = jM.createListMethods(t, e), [r, a] = Ot(), [o, u] = Ot(ne.INITIAL), c = async () => {
    u(ne.IN_PROGRESS);
    try {
      const l = await n();
      a(BM((l == null ? void 0 : l.content) || l)), u(ne.SUCCESS);
    } catch (l) {
      console.error(l), u(ne.ERROR);
    }
  };
  return Ce(() => {
    c();
  }, []), {
    dataSources: r,
    status: o,
    getDataSources: c
  };
}, BM = (t) => {
  let e = (t == null ? void 0 : t.filter((n) => n.status === "ACTIVE").map((n) => n.subject)) || [];
  return e.sort(
    (n, r) => {
      var a, o;
      return (((a = r.vaults) == null ? void 0 : a.length) || 0) - (((o = n.vaults) == null ? void 0 : o.length) || 0);
    }
  ), e;
};
Qt.div`
  cursor: pointer;
  padding: 12px;
  display: flex;
  align-items: center;
  &:hover {
    background-color: ${({ theme: t }) => {
  var e;
  return (e = t.palette) == null ? void 0 : e.backgroundColor.main;
}};
  }
`;
const FM = Qt.div`
  display: flex;
  align-items: center;
  & > *:not(:last-child) {
    margin-right: 8px;
  }
`, UM = (t) => {
  const { onAdd: e, typeContainer: n, parentId: r } = t, [a, o] = Ot({}), { dataSources: u, status: c } = kM(n, r), l = (d, g) => {
    o((y) => {
      var b;
      let f = { ...y };
      f[d.id] ? f[d.id][g.id] ? (delete f[d.id][g.id], (b = Object.keys(f[d.id])) != null && b.length || delete f[d.id]) : f[d.id][g.id] = g : f[d.id] = {
        [g.id]: g
      };
      const m = Object.keys(f).reduce((E, S) => {
        const M = Object.values(f[S]).map((N) => ({
          vaultId: N.id,
          dataSourceId: S
        }));
        return E.push(...M), E;
      }, []);
      return e(Object.keys(f), m), f;
    });
  };
  return /* @__PURE__ */ p.jsxs(G, { container: !0, spacing: 1, mb: 2, children: [
    c === ne.IN_PROGRESS && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, textAlign: "center", children: /* @__PURE__ */ p.jsx(Ke, { size: 50, color: "secondary" }) }),
    (u == null ? void 0 : u.length) === 0 && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, fontSize: 12, textAlign: "center", children: /* @__PURE__ */ p.jsx(ka, { elevation: 3, sx: { p: 2, color: "textColor.label" }, children: "You have no active data sources" }) }),
    u == null ? void 0 : u.map((d) => {
      var g, y, f;
      return /* @__PURE__ */ p.jsx(
        G,
        {
          item: !0,
          xs: 12,
          className: "new-data-source-list-item",
          children: /* @__PURE__ */ p.jsx(
            Ec,
            {
              title: /* @__PURE__ */ p.jsxs(FM, { children: [
                /* @__PURE__ */ p.jsx(no, { value: d.id }),
                /* @__PURE__ */ p.jsx(Is, { dataSource: d })
              ] }),
              collapsible: !0,
              size: "dense",
              defaultState: !!((g = d == null ? void 0 : d.vaults) != null && g.length),
              children: /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, pl: 4, children: (y = d == null ? void 0 : d.vaults) != null && y.length ? (f = d == null ? void 0 : d.vaults) == null ? void 0 : f.map((m) => {
                var E;
                const b = !!((E = a[d.id]) != null && E[m.id]);
                return /* @__PURE__ */ p.jsxs(
                  He,
                  {
                    fontSize: 14,
                    color: "textColor.main",
                    onClick: () => {
                      l(d, m);
                    },
                    sx: { cursor: "pointer" },
                    children: [
                      /* @__PURE__ */ p.jsx(
                        di,
                        {
                          checked: b,
                          size: "small",
                          sx: {
                            mr: 1,
                            svg: { width: "0.9em", height: "0.9em" }
                          }
                        }
                      ),
                      m.name,
                      m.vaultSchema ? ` - ${m.vaultSchema}` : ""
                    ]
                  }
                );
              }) : /* @__PURE__ */ p.jsx(He, { color: "textColor.label", fontSize: 12, children: "You have no vaults configured for this data source" }) })
            }
          )
        },
        d.id
      );
    })
  ] });
}, $M = (t) => {
  const e = Ie((l) => ED({ pageSize: 1e3 }), []), n = vv(), { status: r, state: a } = qi(e), [o, u] = Ot(!1), c = () => {
    u(!o);
  };
  return r === ne.INITIAL || r === ne.IN_PROGRESS ? /* @__PURE__ */ p.jsx(ro, { children: /* @__PURE__ */ p.jsx(Ke, { size: 32 }) }) : /* @__PURE__ */ p.jsxs(G, { container: !0, children: [
    /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(LR, { children: "Most used data sources" }) }),
    /* @__PURE__ */ p.jsxs(PR, { children: [
      r === ne.SUCCESS && (a != null && a.length ? a.slice(0, Math.min(a.length, o ? 10 : 5)).map((l) => (l.type, /* @__PURE__ */ p.jsx(
        gh,
        {
          onClick: () => n(`/data-catalog/${l.id}`),
          children: /* @__PURE__ */ p.jsxs("div", { className: "list-item-section nowrap", children: [
            /* @__PURE__ */ p.jsx(He, { minWidth: 24, children: /* @__PURE__ */ p.jsx(no, { value: l.id }) }),
            /* @__PURE__ */ p.jsx("div", { className: "list-item-title", title: l.name, children: /* @__PURE__ */ p.jsx(
              Is,
              {
                dataSource: l,
                withTooltip: !1
              }
            ) })
          ] })
        },
        l.id + "-data-source"
      ))) : /* @__PURE__ */ p.jsx(gh, { light: !0, children: /* @__PURE__ */ p.jsx(cd, { noDataText: "No data sources found", dark: !0 }) })),
      r === ne.ERROR && /* @__PURE__ */ p.jsx(gh, { light: !0, children: /* @__PURE__ */ p.jsx(
        cd,
        {
          noDataText: "Failed to load most used data sources",
          addButtonText: ""
        }
      ) })
    ] }),
    (a == null ? void 0 : a.length) > 5 && /* @__PURE__ */ p.jsx(G, { container: !0, justifyContent: "flex-end", mt: 2, children: /* @__PURE__ */ p.jsx(_e, { onClick: c, size: "small", variant: "text", color: "info", children: o ? "Show less" : "Show more..." }) })
  ] });
}, zM = lr((t) => {
  const { name: e, path: n, config: r, children: a, viewMode: o } = t, u = vv(), {
    onAdd: c,
    onCancel: l,
    typeContainer: d,
    parentId: g,
    onChange: y,
    dataSources: f,
    analysisId: m
  } = r, { title: b, url: E, description: S, titleButton: M } = hM;
  return /* @__PURE__ */ p.jsxs(br.Fragment, { children: [
    e === "widget-info" && /* @__PURE__ */ p.jsx(IM, { path: n, config: r, viewMode: o }),
    e === "data-source-list-in-study" && /* @__PURE__ */ p.jsx(
      fM,
      {
        onAdd: c,
        onCancel: l,
        analysisId: m,
        typeContainer: d,
        parentId: g
      }
    ),
    e === "data-source-list-with-vaults" && /* @__PURE__ */ p.jsx(
      UM,
      {
        onAdd: c,
        typeContainer: d,
        parentId: g
      }
    ),
    e === "data-source-list-current-tenant" && /* @__PURE__ */ p.jsx(
      sM,
      {
        tenantId: g,
        onChange: y,
        onClose: l,
        dataSources: f,
        children: a
      }
    ),
    e === "home-widget" && /* @__PURE__ */ p.jsx(
      NR,
      {
        title: b,
        onClick: () => u(E),
        description: S,
        iconName: "dataCatalog",
        actions: /* @__PURE__ */ p.jsx(p.Fragment, { children: /* @__PURE__ */ p.jsx(
          _e,
          {
            onClick: () => u(E),
            variant: "outlined",
            name: "save",
            children: M
          }
        ) }),
        children: /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, container: !0, pt: 2, children: /* @__PURE__ */ p.jsx($M, {}) })
      }
    )
  ] });
}), VM = {
  rowId: "id",
  iconName: "dataCatalog",
  loadingMessage: "Loading data sources...",
  addButtonTitle: "Add data source",
  tableTitle: "Data sources",
  createCrudMethod: (t, e) => aD(
    t,
    e,
    (n) => Lv(n),
    Nv
  ),
  listInitialSort: { id: "name", desc: !1 },
  createFiltersPanel: (t, e) => iD(t, e, TD),
  createSortingMethod: (t) => rD(t, {
    getSorting: CD,
    getSortingWorkspace: RD
  }),
  // it should be redone in future probably
  metadataFilter: "&filter.metadata.subject=DATA_SOURCE",
  // getListMetadata: searchParams => {
  //   return getList(searchParams, `&metadataSubjects=DATA_SOURCE`);
  // },
  getCols: ({ metaAttributes: t }) => [
    {
      id: "logo",
      header: "",
      accessorKey: "id",
      enableHiding: !1,
      cell: no,
      size: 36,
      meta: {
        columnType: "action"
      }
    },
    IR({
      cell: ({ row: e }) => {
        const { original: n } = e;
        return n ? /* @__PURE__ */ p.jsx(Is, { dataSource: n }) : "";
      }
    }),
    ...ny(t, !1),
    {
      id: "modelTypeLabel",
      header: "Model type",
      accessorKey: "modelTypeLabel",
      size: 110,
      minSize: 80
    },
    // {
    //   id: 'cdmVersionLabel',
    //   header: 'Version',
    //   accessorKey: 'cdmVersionLabel',
    //   Cell: ({ value: cdmVersion }) => <span>{cdmVersion}</span>,
    // },
    {
      id: "accessTypeLabel",
      header: "Access type",
      accessorKey: "accessTypeLabel",
      enableResizing: !1,
      minSize: 140,
      meta: {
        align: "center",
        headerAlign: "center"
      },
      cell: ({ getValue: e, row: n }) => {
        const r = Sc();
        return e() ? /* @__PURE__ */ p.jsx(
          Ac,
          {
            light: !0,
            color: Tv(n.original.accessType, r),
            text: e(),
            align: "center",
            minWidth: 90
          }
        ) : "";
      }
    },
    {
      id: "executionPolicy",
      header: "Execution policy",
      accessorKey: "executionPolicy",
      enableResizing: !1,
      meta: {
        align: "center",
        headerAlign: "center"
      },
      cell: ({ getValue: e }) => {
        const n = Sc();
        return e() ? /* @__PURE__ */ p.jsx(
          Ac,
          {
            light: !0,
            text: e(),
            color: Cv(e(), n),
            align: "center",
            minWidth: 90
          }
        ) : "";
      }
    },
    ...ny(t, !0)
  ]
}, YM = () => {
  const t = Ar(
    tf
  );
  return /* @__PURE__ */ p.jsx(
    jR,
    {
      isImport: !1,
      isEnableMetadata: !0,
      moduleConfig: t,
      listConfig: {
        ...VM
        // cols,
      },
      variant: "primary"
    }
  );
}, hy = "New Data source", WM = {
  createCrudEntity: (t, e) => uD(
    t,
    e,
    Pv,
    Nv,
    AD
  ),
  formatters: oD(
    hy,
    () => {
    },
    (t) => ({
      base: {
        title: t.name
      },
      original: t,
      actions: t.actions
    }),
    (t) => t
  ),
  entityBreadcrumbs: (t, e, n) => sD(hy, t, e, n),
  entityNavigationPanel: (t, e, n) => [
    {
      title: /* @__PURE__ */ p.jsx(
        La,
        {
          title: "Details",
          count: String((t == null ? void 0 : t.metadata) || 0),
          status: e,
          dense: !0
        }
      ),
      value: "",
      end: !0
    },
    ...Number((t == null ? void 0 : t.reports) || 0) > 0 ? [
      {
        title: /* @__PURE__ */ p.jsx(
          La,
          {
            title: "Reports",
            count: String((t == null ? void 0 : t.reports) || 0),
            status: e,
            dense: !0
          }
        ),
        value: "reports"
      }
    ] : [],
    {
      title: /* @__PURE__ */ p.jsx(
        La,
        {
          title: "Data Owners",
          count: String((t == null ? void 0 : t.ownersCount) || 0),
          status: e,
          dense: !0
        }
      ),
      value: "data-owners"
    },
    {
      title: "Utilization Statistics",
      value: "utilization-statistics"
    },
    {
      title: /* @__PURE__ */ p.jsx(
        La,
        {
          title: "Documents",
          count: String((t == null ? void 0 : t.documents) || 0),
          status: e,
          dense: !0
        }
      ),
      value: "documents"
    },
    ...t != null && t.hasDqd ? [
      {
        title: "Data Quality",
        value: "dqd-reports"
      }
    ] : []
  ]
}, GM = Qt.div`
  padding: 20px;
`, qM = lr((t) => {
  const { parentId: e, afterCreate: n, onCancel: r, subModules: a, dataSourceId: o } = t, { enqueueSnackbar: u } = bi(), [c, l] = Ot(!1), [d, g] = Ot(""), y = Ie(async () => {
    l(!0), await jv(d, o, ""), u({
      message: "Create new request for Study",
      variant: "success"
    }), r();
  }, [d]);
  return c ? /* @__PURE__ */ p.jsx(ro, { children: /* @__PURE__ */ p.jsx(Ke, { size: 32 }) }) : /* @__PURE__ */ p.jsx(G, { container: !0, p: 2, children: /* @__PURE__ */ p.jsx(Et, { children: /* @__PURE__ */ p.jsxs(G, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(
      a.study,
      {
        type: "component",
        name: "studies-list-select",
        subModules: a,
        config: {
          onChange: (f) => {
            g(f);
          }
        }
      }
    ) }),
    /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsxs(up, { children: [
      /* @__PURE__ */ p.jsx(
        _e,
        {
          variant: "outlined",
          disabled: c,
          onClick: r,
          startIcon: /* @__PURE__ */ p.jsx(Qe, { iconName: "deactivate" }),
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ p.jsx(
        _e,
        {
          onClick: y,
          variant: "contained",
          color: "success",
          disabled: !d,
          startIcon: /* @__PURE__ */ p.jsx(Qe, { iconName: "submit" }),
          children: "Request access"
        }
      )
    ] }) })
  ] }) }) });
});
var Fv = /* @__PURE__ */ ((t) => (t.INITIAL = "INITIAL", t.LOADING_METADATA = "LOADING_METADATA", t.LOADED_METADATA = "LOADED_METADATA", t.ERROR_LOADED_METADATA = "ERROR_LOADED_METADATA", t.LOADING_CREATE_METADATA = "LOADING_CREATE_METADATA", t.LOADED_CREATE_METADATA = "LOADED_CREATE_METADATA", t.ERROR_LOADED_CREATE_METADATA = "ERROR_LOADED_CREATE_METADATA", t))(Fv || {});
Fv.INITIAL;
var Bt = /* @__PURE__ */ ((t) => (t.DASHBOARD = "dashboard", t.DATADENSITY = "data_density", t.PERSON = "person", t.VISIT = "visit", t.CONDITION = "condition", t.CONDITION_ERA = "conditionera", t.PROCEDURE = "procedure", t.DRUG = "drug", t.DRUG_ERA = "drugera", t.MEASUREMENT = "measurement", t.OBSERVATION = "observation", t.OBSERVATION_PERIOD = "observation_period", t.DEATH = "death", t.AHILLES_SHEEL = "achillesheel", t.COST = "cost", t.PAYER_PLAN = "payer_plan", t))(Bt || {}), zr = /* @__PURE__ */ ((t) => (t.SUPERVISED = "SUPERVISED", t.UNSUPERVISED = "UNSUPERVISED", t.MANUAL = "MANUAL", t))(zr || {}), Ba = /* @__PURE__ */ ((t) => (t.VISIBLE_TO_ALL = "VISIBLE_TO_ALL", t.HIDE_TO_ALL = "HIDE_TO_ALL", t.VISIBLE_TO_APPROVED_CONTRIBUTORS = "VISIBLE_TO_APPROVED_CONTRIBUTORS", t))(Ba || {}), fd = /* @__PURE__ */ ((t) => (t.INITIAL = "INITIAL", t.LOADING = "LOADING", t.LOADED = "LOADED", t.FAILED = "FAILED", t))(fd || {});
const HM = {
  permissionReports: [],
  status: "INITIAL",
  error: null
}, XM = (t, e) => Rv(t, (n) => {
  switch (e.type) {
    case "GET_PERMISSIONS_REQUEST":
      n.status = "LOADING", n.permissionReports = [], n.error = null;
      break;
    case "GET_PERMISSIONS_REQUEST_DONE":
      n.status = "LOADED", n.permissionReports = e.payload;
      break;
    case "GET_PERMISSIONS_REQUEST_FAILED":
      n.status = "FAILED", n.permissionReports = [], n.error = e.payload;
      break;
    case "UPDATE_PERMISSIONS_REQUEST":
      break;
    case "UPDATE_PERMISSIONS_REQUEST_DONE":
      n.permissionReports = e.payload, n.error = null;
      break;
    case "UPDATE_PERMISSIONS_REQUEST_FAILED":
      n.permissionReports = [], n.error = e.payload;
      break;
  }
}), QM = (t) => {
  const [e, n] = yv(XM, HM), r = Ie(async () => {
    n({
      type: "GET_PERMISSIONS_REQUEST"
      /* GET_PERMISSIONS_REQUEST */
    });
    try {
      const o = await WD(t, {}), u = await qD(t), c = o.map((l) => {
        const d = u.content.find(
          (g) => g.type === l.type
        );
        return {
          ...l,
          ...d,
          grant: (d == null ? void 0 : d.grant) || Ba.HIDE_TO_ALL
        };
      });
      n({
        type: "GET_PERMISSIONS_REQUEST_DONE",
        payload: c
      });
    } catch (o) {
      n({
        type: "GET_PERMISSIONS_REQUEST_FAILED",
        payload: o
      });
    }
  }, []), a = Ie(
    async (o, u) => {
      const c = Object.keys(u).map((l) => u[l]);
      n({
        type: "UPDATE_PERMISSIONS_REQUEST"
        /* UPDATE_PERMISSIONS_REQUEST */
      });
      try {
        const l = await GD(o, c), d = e.permissionReports.map((g) => {
          const y = l.content.find(
            (f) => f.type === g.type
          );
          return {
            ...g,
            ...y,
            grant: (y == null ? void 0 : y.grant) || Ba.HIDE_TO_ALL
          };
        });
        n({
          type: "UPDATE_PERMISSIONS_REQUEST_DONE",
          payload: d
        });
      } catch (l) {
        n({
          type: "UPDATE_PERMISSIONS_REQUEST_FAILED",
          payload: l
        });
      }
    },
    [e.permissionReports]
  );
  return Ce(() => {
    r();
  }, []), {
    ...e,
    updatePermissions: a
  };
};
Bt.DASHBOARD, Bt.DATADENSITY, Bt.PERSON, Bt.VISIT, Bt.CONDITION, Bt.CONDITION_ERA, Bt.PROCEDURE, Bt.DRUG, Bt.DRUG_ERA, Bt.MEASUREMENT, Bt.OBSERVATION, Bt.OBSERVATION_PERIOD, Bt.DEATH, Bt.AHILLES_SHEEL, Bt.COST, Bt.PAYER_PLAN;
const KM = {
  name: "recordsPerPerson",
  description: "Records per person"
}, ZM = {
  name: "lengthOfEra",
  description: "Length of era"
}, Uv = [
  "0-9",
  "10-19",
  "20-29",
  "30-39",
  "40-49",
  "50-59",
  "60-69",
  "70-79",
  "80-89",
  "90-99"
], JM = [
  {
    name: "Unrestricted",
    value: ry.PUBLIC
  },
  {
    name: "Restricted",
    value: ry.RESTRICTED
  }
], Sh = [
  {
    name: "Supervised",
    value: zr.SUPERVISED
  },
  {
    name: "Unsupervised",
    value: zr.UNSUPERVISED
  },
  {
    name: "Manual",
    value: zr.MANUAL
  }
], tO = [
  {
    name: "Visible to all",
    value: Ba.VISIBLE_TO_ALL
  },
  {
    name: "Always hidden",
    value: Ba.HIDE_TO_ALL
  },
  {
    name: "Visible to approved contributors",
    value: Ba.VISIBLE_TO_APPROVED_CONTRIBUTORS
  }
];
Qt(Et)`
  padding: 10px;
`;
Qt.div`
  /* margin: 10px; */
  label {
    color: ${({ theme: t }) => {
  var e;
  return (e = t.palette) == null ? void 0 : e.primary.main;
}};
    font-weight: 700;
    width: 230px;
    display: block;
    font-size: 14px;
  }
  p {
    margin: 0;
    margin-top: 5px;
    font-size: 16px;
    color: #323232;
  }
`;
const eO = Qt.div`
  border-bottom: 1px solid #e7e7e7;
`;
Qt.div`
  text-align: right;
`;
const nO = Qt.div`
  background: #ffffff;
  border-top: 1px solid #ffffff;
  box-shadow: ${({ theme: t }) => t.customShadows[2]};
  width: 100%;
  z-index: 2;
`, rO = Qt.div`
  /* width: 100%; */
  .dropzone {
    max-width: 100%;
  }
`;
function iO(t) {
  const [e, n] = Ot(null), [r, a] = Ot(null), [o, u] = Ot(ne.INITIAL), { enqueueSnackbar: c } = bi(), l = async () => {
    u(ne.IN_PROGRESS);
    try {
      const g = await nM(t);
      n(g), a(g), u(ne.SUCCESS);
    } catch (g) {
      console.error("LOGO ERR:", g), u(ne.ERROR);
    }
  }, d = async () => {
    u(ne.IN_PROGRESS);
    try {
      const g = await eM(t, {
        image: r.image,
        id: e == null ? void 0 : e.id
      });
      n(g), a(g), c({ message: "Logo updated successfully" }), u(ne.SUCCESS);
    } catch (g) {
      console.error("LOGO ERR:", g), c({ message: "Something went wrong" }), u(ne.ERROR);
    }
  };
  return Ce(() => {
    t && l();
  }, [t]), {
    loadImage: l,
    uploadFile: d,
    state: r,
    defaultState: e,
    setState: a,
    status: o
  };
}
const aO = ({
  id: t,
  onChange: e
}) => {
  const { enqueueSnackbar: n } = bi(), { state: r, status: a, defaultState: o, setState: u, uploadFile: c } = iO(t), l = (f) => {
    const m = f[0], b = new FileReader();
    b.onloadend = function() {
      u({ image: b.result, name: m.name });
    }, b.readAsDataURL(m);
  }, d = () => {
    u(null);
  }, g = (f) => {
    n({ message: "Please, check file size" });
  }, y = async () => {
    await c(), e == null || e();
  };
  return a === ne.IN_PROGRESS ? /* @__PURE__ */ p.jsx(He, { py: 6, textAlign: "center", children: /* @__PURE__ */ p.jsx(Ke, { size: 40, color: "info" }) }) : /* @__PURE__ */ p.jsx(rO, { children: r != null && r.image ? /* @__PURE__ */ p.jsxs(He, { py: 4, textAlign: "center", children: [
    /* @__PURE__ */ p.jsx(He, { display: "inline-block", children: /* @__PURE__ */ p.jsx(KR, { image: r.image }) }),
    (r == null ? void 0 : r.name) && /* @__PURE__ */ p.jsx(an, { fontSize: 12, mt: 1, children: r.name }),
    /* @__PURE__ */ p.jsxs(He, { mt: 1, children: [
      /* @__PURE__ */ p.jsx(
        _e,
        {
          variant: "outlined",
          startIcon: /* @__PURE__ */ p.jsx(Qe, { iconName: "edit", color: "info" }),
          sx: { mr: 1, minWidth: 96 },
          onClick: d,
          children: "Edit"
        }
      ),
      /* @__PURE__ */ p.jsx(
        _e,
        {
          variant: "contained",
          color: "success",
          startIcon: /* @__PURE__ */ p.jsx(Qe, { iconName: "save" }),
          onClick: y,
          disabled: o && (o == null ? void 0 : o.id) === (r == null ? void 0 : r.id) || !r,
          children: "Upload"
        }
      )
    ] })
  ] }) : /* @__PURE__ */ p.jsx(
    kR,
    {
      onDrop: l,
      placeholder: "imageAdd",
      acceptExt: ["image/png", "image/jpeg", "image/svg+xml"],
      textAvailableExt: "PNG, JPEG, SVG",
      maxSize: 3 * 1024 * 1024,
      onDropReject: g,
      uploadText: /* @__PURE__ */ p.jsxs(He, { px: 1, children: [
        /* @__PURE__ */ p.jsx(
          an,
          {
            color: "info.main",
            component: "span",
            fontSize: 14,
            fontWeight: 500,
            children: "Drop"
          }
        ),
        " ",
        "your logo here or",
        " ",
        /* @__PURE__ */ p.jsx(
          an,
          {
            color: "info.main",
            component: "span",
            fontSize: 14,
            fontWeight: 500,
            children: "browse"
          }
        ),
        " ",
        "with size 100x100px and less than 3Mb"
      ] })
    }
  ) });
}, Ah = (t, e) => {
  const n = {};
  return Object.keys(t).forEach((r) => {
    const a = t[r], o = a.type === hn.INTEGER || a.type === hn.STRING ? t[r].values[0] : t[r].values;
    n[r] = {
      attributeId: a.id,
      dataSourceId: e,
      type: a.type,
      required: a.required,
      values: a.type === hn.INTEGER || a.type === hn.STRING ? {
        valueId: o == null ? void 0 : o.id,
        value: o == null ? void 0 : o.value
      } : o.map((u) => ({
        valueId: u.id,
        value: u.attributeOption.value,
        optionId: u.attributeOption.id
      }))
    };
  }), n;
}, oO = (t) => {
  const {
    dataSource: e,
    onChange: n,
    onClose: r,
    reloadLogo: a,
    canManageAccessSettings: o = !0
  } = t, [u, c] = Ot(!1), { name: l, description: d, modelType: g, accessType: y, executionPolicy: f } = e, [m, b] = Ot({
    name: l,
    description: d,
    accessType: y,
    executionPolicy: f,
    modelType: g,
    reports: e.achillesPermissions,
    meta: Ah(e.metaAttributes, e.id)
  }), E = Fn(() => {
    if (!f)
      return Sh;
    if (zr.MANUAL !== f)
      return Sh.filter(
        (O) => O.value !== zr.MANUAL
      );
    if (zr.MANUAL == f)
      return Sh.filter(
        (O) => O.value == zr.MANUAL
      );
  }, []), S = async () => {
    c(!0);
    const O = Ah(e.metaAttributes, e.id);
    (!$u(O, m.meta) || !$u(e.achillesPermissions, m.reports) || y !== m.accessType || g !== m.modelType || f !== m.executionPolicy || l !== m.name || d !== m.description) && await n({
      currentState: m,
      dataSource: e
    }), c(!1);
  }, M = (O) => O && O.trim().length > 0, N = () => {
    const O = Ah(e.metaAttributes, e.id);
    let A = !0;
    return Object.values(m.meta).forEach((x) => {
      if (x.required)
        switch (x.type) {
          case hn.INTEGER:
          case hn.STRING:
            x.values && x.values.value || (A = !1);
            break;
          case hn.ENUM:
          case hn.ENUM_MULTI:
            x.values && x.values.length > 0 || (A = !1);
            break;
        }
    }), !A || !M(m.name) || $u(O, m.meta) && $u(e.achillesPermissions, m.reports) && y == m.accessType && f == m.executionPolicy && l === m.name && d === m.description;
  };
  return /* @__PURE__ */ p.jsxs(G, { container: !0, children: [
    /* @__PURE__ */ p.jsx(nO, { children: /* @__PURE__ */ p.jsxs(G, { container: !0, spacing: 2, px: 2, py: 1, justifyContent: "flex-end", children: [
      /* @__PURE__ */ p.jsx(G, { item: !0, children: /* @__PURE__ */ p.jsx(
        _e,
        {
          variant: "outlined",
          onClick: r,
          startIcon: /* @__PURE__ */ p.jsx(Qe, { iconName: "deactivate" }),
          name: "delete",
          children: "Cancel"
        }
      ) }),
      /* @__PURE__ */ p.jsx(G, { item: !0, children: /* @__PURE__ */ p.jsx(
        _e,
        {
          disabled: u || N(),
          onClick: S,
          variant: "contained",
          color: "success",
          startIcon: u ? /* @__PURE__ */ p.jsx(Ke, { size: 16 }) : /* @__PURE__ */ p.jsx(Qe, { iconName: "submit" }),
          name: "save",
          children: "Save"
        }
      ) })
    ] }) }),
    /* @__PURE__ */ p.jsx(_v, { children: /* @__PURE__ */ p.jsxs(G, { container: !0, spacing: 2, children: [
      /* @__PURE__ */ p.jsxs(G, { item: !0, xs: 12, md: 6, children: [
        /* @__PURE__ */ p.jsxs(ka, { elevation: 3, sx: { mb: 2 }, children: [
          /* @__PURE__ */ p.jsx(Lt, { title: "Logo" }),
          /* @__PURE__ */ p.jsx(G, { container: !0, children: /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(
            aO,
            {
              id: e.id,
              onChange: a
            }
          ) }) })
        ] }),
        /* @__PURE__ */ p.jsxs(ka, { elevation: 3, children: [
          /* @__PURE__ */ p.jsx(Lt, { title: "Details" }),
          /* @__PURE__ */ p.jsxs(G, { container: !0, p: 2, spacing: 1, children: [
            /* @__PURE__ */ p.jsx(G, { item: !0, xs: 6, children: /* @__PURE__ */ p.jsx(Tn, { name: "name", textLabel: "Name", required: !0, children: /* @__PURE__ */ p.jsx(
              ja,
              {
                id: "name",
                name: "name",
                type: "text",
                size: "medium",
                value: m.name,
                onChange: (O) => {
                  b({ ...m, name: O.target.value });
                },
                fullWidth: !0
              }
            ) }) }),
            /* @__PURE__ */ p.jsx(G, { item: !0, xs: 6, children: /* @__PURE__ */ p.jsx(Tn, { name: "description", textLabel: "Description", children: /* @__PURE__ */ p.jsx(
              ja,
              {
                id: "description",
                name: "description",
                type: "text",
                size: "medium",
                value: m.description,
                onChange: (O) => {
                  b({
                    ...m,
                    description: O.target.value
                  });
                },
                fullWidth: !0
              }
            ) }) })
          ] }),
          /* @__PURE__ */ p.jsxs(G, { container: !0, p: 2, spacing: 1, children: [
            /* @__PURE__ */ p.jsx(G, { item: !0, xs: 6, children: /* @__PURE__ */ p.jsx(
              Tn,
              {
                name: "access-type",
                textLabel: "Access type",
                required: !0,
                children: /* @__PURE__ */ p.jsx(
                  Ui,
                  {
                    className: "",
                    name: "access-type",
                    disablePortal: !0,
                    id: "access-type",
                    options: JM,
                    value: m.accessType,
                    disabled: !o,
                    placeholder: "Select type...",
                    onChange: (O) => {
                      b({ ...m, accessType: O });
                    },
                    fullWidth: !0
                  }
                )
              }
            ) }),
            /* @__PURE__ */ p.jsx(G, { item: !0, xs: 6, children: /* @__PURE__ */ p.jsx(Tn, { name: "ex", textLabel: "Execution policy", required: !0, children: /* @__PURE__ */ p.jsx(
              Ui,
              {
                className: "",
                name: "ex",
                disablePortal: !0,
                id: "ex",
                options: E,
                value: m.executionPolicy,
                disabled: !o || f === zr.MANUAL,
                placeholder: "Select type...",
                onChange: (O) => {
                  b({ ...m, executionPolicy: O });
                },
                fullWidth: !0
              }
            ) }) }),
            /* @__PURE__ */ p.jsx(G, { item: !0, xs: 6, children: /* @__PURE__ */ p.jsx(
              Tn,
              {
                name: "model-type",
                textLabel: "Model type",
                required: !0,
                children: /* @__PURE__ */ p.jsx(
                  Ui,
                  {
                    className: "",
                    name: "model-type",
                    disablePortal: !0,
                    id: "model-type",
                    options: e.modelTypes,
                    value: m.modelType,
                    placeholder: "Select type...",
                    onChange: (O) => {
                      b({ ...m, modelType: O });
                    },
                    fullWidth: !0
                  }
                )
              }
            ) })
          ] }),
          /* @__PURE__ */ p.jsx(G, { container: !0, p: 2, spacing: 1, children: /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(eO, {}) }) }),
          /* @__PURE__ */ p.jsx(G, { container: !0, p: 2, spacing: 1, children: e.metaAttributes && Object.keys(e.metaAttributes).map((O) => {
            const A = e.metaAttributes[O], x = m.meta[O], v = x.values, w = A.type === hn.INTEGER ? "number" : "text";
            return /* @__PURE__ */ p.jsx(G, { item: !0, xs: 6, children: /* @__PURE__ */ p.jsxs(
              Tn,
              {
                name: A.name,
                textLabel: A.name,
                required: A.required,
                children: [
                  (A.type === hn.STRING || A.type === hn.INTEGER) && /* @__PURE__ */ p.jsx(
                    ja,
                    {
                      id: A.name,
                      name: A.name,
                      type: w,
                      size: "medium",
                      value: v.value,
                      onChange: (C) => b({
                        ...m,
                        meta: {
                          ...m.meta,
                          [O]: {
                            ...x,
                            values: {
                              ...v,
                              value: C.target.value
                            }
                          }
                        }
                      }),
                      fullWidth: !0
                    }
                  ),
                  A.type === hn.ENUM_MULTI && /* @__PURE__ */ p.jsx(
                    Ui,
                    {
                      className: "",
                      name: "role",
                      disablePortal: !0,
                      multiple: !0,
                      id: "new-analysis-type",
                      options: A.options.map((C) => ({
                        ...C,
                        name: C.value
                      })),
                      value: v.map((C) => C.value),
                      placeholder: "Select values...",
                      onChange: (C, P) => {
                        const Y = { ...x };
                        Y.values = [], C.length > 0 && C.forEach((V) => {
                          x.values.findIndex(
                            (T) => V.includes(T.value)
                          );
                          const k = A.options.find(
                            (T) => V.includes(T.value)
                          );
                          Y.values.push({
                            value: k.value,
                            optionId: k.id
                          });
                        }), b({
                          ...m,
                          meta: {
                            ...m.meta,
                            [O]: {
                              ...Y
                            }
                          }
                        });
                      },
                      fullWidth: !0
                    }
                  ),
                  A.type === hn.ENUM && /* @__PURE__ */ p.jsx(
                    Ui,
                    {
                      className: "",
                      name: "role",
                      disablePortal: !0,
                      id: "new-analysis-type",
                      options: A.options.map((C) => ({
                        ...C,
                        name: C.value
                      })),
                      value: v.length > 0 ? v[0].value : [],
                      placeholder: "Select type...",
                      onChange: (C, P) => {
                        const Y = A.options.find(
                          (V) => V.value === C
                        );
                        b({
                          ...m,
                          meta: {
                            ...m.meta,
                            [O]: {
                              ...x,
                              values: [
                                {
                                  value: Y.value,
                                  optionId: Y.id
                                }
                              ]
                            }
                          }
                        });
                      },
                      fullWidth: !0
                    }
                  )
                ]
              }
            ) }, O);
          }) })
        ] })
      ] }),
      /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, md: 6, children: /* @__PURE__ */ p.jsxs(ka, { elevation: 3, children: [
        /* @__PURE__ */ p.jsx(Lt, { title: "Reports" }),
        /* @__PURE__ */ p.jsx(G, { container: !0, p: 2, spacing: 1, children: Object.keys(m.reports).map((O) => {
          const A = m.reports[O];
          return /* @__PURE__ */ p.jsx(G, { item: !0, xs: 6, children: /* @__PURE__ */ p.jsx(Tn, { name: A.title, textLabel: A.title, children: /* @__PURE__ */ p.jsx(
            Ui,
            {
              className: "",
              name: "role",
              disablePortal: !0,
              id: "new-analysis-type",
              options: tO,
              value: A.grant,
              placeholder: "Select report...",
              onChange: (x) => {
                b({
                  ...m,
                  reports: {
                    ...m.reports,
                    [O]: {
                      ...A,
                      grant: x
                    }
                  }
                });
              },
              fullWidth: !0
            }
          ) }) }, O);
        }) })
      ] }) })
    ] }) })
  ] });
}, sO = [
  {
    header: "Status",
    size: 90,
    maxSize: 90,
    sortingFn: "alphanumeric",
    filterFn: "arrIncludesSomeEqual",
    accessorFn: (t) => {
      const e = t.passed, n = t.failed;
      return t.isError ? "Error" : e !== void 0 && e === 1 || e === void 0 && n !== void 0 && n === 0 ? "Pass" : n !== void 0 && n === 1 || n === void 0 && e !== void 0 && e === 0 ? "Fail" : "Not Applicable";
    }
  },
  {
    header: "Context",
    accessorKey: "context",
    sortingFn: "alphanumeric",
    filterFn: "arrIncludesSomeEqual"
  },
  {
    header: "Category",
    accessorKey: "category",
    sortingFn: "alphanumeric",
    filterFn: "arrIncludesSomeEqual"
  },
  {
    header: "Subcategory",
    accessorFn: (t) => t.subcategory || "None",
    cell: (t) => t.getValue() === "None" ? "" : t.getValue(),
    size: 100,
    maxSize: 100,
    sortingFn: "alphanumeric",
    filterFn: "arrIncludesSomeEqual"
  },
  {
    header: "Level",
    accessorKey: "checkLevel",
    size: 100,
    maxSize: 100,
    sortingFn: "alphanumeric",
    filterFn: "arrIncludesSomeEqual"
  },
  {
    header: "Description",
    accessorKey: "checkDescription",
    disbleSorting: !0,
    size: 280,
    sortingFn: "alphanumeric",
    meta: {
      filterVariant: "value"
    }
  },
  {
    header: "% Records",
    accessorFn: (t) => (t.pctViolatedRows * 100).toFixed(2) + "%",
    enableColumnFilter: !1
  }
], uO = Qt.table`
  border-collapse: collapse;
  width: 100%;
`;
Qt.span`
  text-align: right;
  float: right;
  margin: 10px;
  font-size: 0.8rem;
  color: ${({ theme: t }) => {
  var e;
  return (e = t.palette) == null ? void 0 : e.textColor.secondary;
}};
`;
const cO = Qt.div`
  border-top: 1px solid ${({ theme: t }) => {
  var e;
  return (e = t.palette) == null ? void 0 : e.borderColor.main;
}};
  padding: 16px 16px 0px;
  background: ${({ theme: t }) => {
  var e;
  return (e = t.palette) == null ? void 0 : e.backgroundColor.white;
}};
  padding-top: 16px;

  .details-item {
    font-size: 12px;
    padding: 10px;
    border-bottom: 1px solid lightgray;
    color: ${({ theme: t }) => {
  var e;
  return (e = t.palette) == null ? void 0 : e.textColor.primary;
}};
    display: flex;

    label {
      font-weight: bold;
      color: ${({ theme: t }) => {
  var e;
  return (e = t.palette) == null ? void 0 : e.textColor.label;
}};
      font-weight: bold;
      width: 60px;
      display: block;
      padding-right: 20px;
    }

    .no-wrap {
      white-space: nowrap;
    }

    span {
      flex-grow: 1;
      text-align: left;
    }

    span pre {
      white-space: pre-wrap;
      margin: 0;
    }
  }
`, gr = Qt("th", {
  shouldForwardProp: (t) => t !== "align" && t !== "headerLevel"
})(({ align: t, headerLevel: e, theme: n }) => {
  var r;
  return {
    border: "1px solid" + n.palette.borderColor.main + 80,
    textAlign: t || "center",
    color: (r = n.palette) == null ? void 0 : r.textColor.secondary,
    backgroundColor: lO(e, n),
    padding: "8px 16px",
    fontSize: 13
  };
}), lO = (t, e) => {
  switch (t) {
    case -1:
      return e.palette.backgroundColor.white;
    case 0:
      return e.palette.backgroundColor.dark;
    case 1:
      return "#f0f6fc";
    default:
      return e.palette.backgroundColor.dark;
  }
}, Ue = Qt("td", {
  shouldForwardProp: (t) => t !== "align" && t !== "fontSize" && t !== "bold" && t !== "textColor"
})(({ align: t, theme: e, fontSize: n, bold: r, textColor: a }) => ({
  border: "1px solid" + e.palette.borderColor.main + 80,
  textAlign: t || "center",
  fontSize: n || 12,
  color: a || e.palette.textColor.secondary,
  padding: "6px 10px",
  fontWeight: r ? "bold" : 400,
  position: "relative",
  span: {
    display: "none"
  }
})), Ro = Qt.label`
  display: flex;
  padding: 0px 6px;
  font-size: 14px;
  white-space: nowrap;
  align-items: center;
  > span {
    margin-right: 10px;
  }
`, fO = Qt.div`
  font-size: 12px;
  padding: 16px;
  color: ${({ theme: t }) => {
  var e;
  return (e = t.palette) == null ? void 0 : e.textColor.primary;
}};
  label {
    padding: 2px 0px 0px 5px;
  }

  span.no-data {
    padding-left: 5px;
  }
`, hO = Qt.div`
  max-height: 200px;
  overflow-y: auto;
`, dO = (t) => {
  const { checkResult: e } = t;
  return /* @__PURE__ */ p.jsx(cO, { children: /* @__PURE__ */ p.jsxs(G, { item: !0, xs: 4, children: [
    /* @__PURE__ */ p.jsxs("div", { className: "details-item", children: [
      /* @__PURE__ */ p.jsx("label", { children: "Name" }),
      /* @__PURE__ */ p.jsx("span", { children: e.checkName })
    ] }),
    /* @__PURE__ */ p.jsxs("div", { className: "details-item", children: [
      /* @__PURE__ */ p.jsx("label", { children: "Description" }),
      /* @__PURE__ */ p.jsx("span", { children: e.checkDescription })
    ] }),
    /* @__PURE__ */ p.jsxs("div", { className: "details-item", children: [
      /* @__PURE__ */ p.jsx("label", { children: "Level" }),
      /* @__PURE__ */ p.jsx("span", { children: e.checkLevel })
    ] }),
    /* @__PURE__ */ p.jsxs("div", { className: "details-item", children: [
      /* @__PURE__ */ p.jsx("label", { children: "# Rows Violated" }),
      /* @__PURE__ */ p.jsx("span", { children: e.numViolatedRows })
    ] }),
    /* @__PURE__ */ p.jsxs("div", { className: "details-item", children: [
      /* @__PURE__ */ p.jsx("label", { children: "% Rows Violated" }),
      /* @__PURE__ */ p.jsx("span", { children: e.pctViolatedRows })
    ] }),
    /* @__PURE__ */ p.jsxs("div", { className: "details-item", children: [
      /* @__PURE__ */ p.jsx("label", { children: "Execution time" }),
      /* @__PURE__ */ p.jsx("span", { children: e.executionTime })
    ] }),
    /* @__PURE__ */ p.jsxs("div", { className: "details-item", children: [
      /* @__PURE__ */ p.jsx("label", { className: "no-wrap", children: "SQL Query" }),
      /* @__PURE__ */ p.jsx("span", { children: /* @__PURE__ */ p.jsx("pre", { children: e.queryText }) })
    ] }),
    /* @__PURE__ */ p.jsxs("div", { className: "details-item", children: [
      /* @__PURE__ */ p.jsx("label", { children: "Error Log" }),
      /* @__PURE__ */ p.jsx("span", { children: e.error })
    ] })
  ] }) });
}, pO = [
  { name: "PERSON" },
  { name: "OBSERVATION_PERIOD" },
  { name: "VISIT_OCCURRENCE" },
  { name: "VISIT_DETAIL" },
  { name: "CONDITION_OCCURRENCE" },
  { name: "DRUG_EXPOSURE" },
  { name: "PROCEDURE_OCCURRENCE" },
  { name: "DEVICE_EXPOSURE" },
  { name: "MEASUREMENT" },
  { name: "OBSERVATION" },
  { name: "DEATH" },
  { name: "NOTE" },
  { name: "NOTE_NLP" },
  { name: "SPECIMEN" },
  { name: "FACT_RELATIONSHIP" },
  { name: "DRUG_ERA" },
  { name: "DOSE_ERA" },
  { name: "CONDITION_ERA" },
  { name: "EPISODE", cdmVersions: ["5.4"] },
  { name: "EPISODE_EVENT", cdmVersions: ["5.4"] },
  { name: "COHORT", cdmVersions: ["5.4"] }
  // TODO should this go to VOCABULARIES?
], gO = [
  { name: "METADATA" },
  { name: "CDM_SOURCE" }
], mO = [
  { name: "LOCATION" },
  { name: "CARE_SITE" },
  { name: "PROVIDER" }
], yO = [
  { name: "PAYER_PLAN_PERIOD" },
  { name: "COST" }
], vO = [
  { name: "CONCEPT" },
  { name: "VOCABULARY" },
  { name: "DOMAIN" },
  { name: "CONCEPT_CLASS" },
  { name: "CONCEPT_RELATIONSHIP" },
  { name: "RELATIONSHIP" },
  { name: "CONCEPT_SYNONYM" },
  { name: "CONCEPT_ANCESTOR" },
  { name: "SOURCE_TO_CONCEPT_MAP" },
  { name: "DRUG_STRENGTH" },
  { name: "COHORT_DEFINITION" },
  { name: "ATTRIBUTE_DEFINITION", cdmVersions: ["5.3"] }
], xO = (t) => {
  const e = [];
  return pO.forEach((n) => {
    (!n.cdmVersions || n.cdmVersions.some((r) => r === t)) && e.push({ name: n.name, group: "Clinical Data Tables" });
  }), gO.forEach((n) => {
    (!n.cdmVersions || n.cdmVersions.some((r) => r === t)) && e.push({ name: n.name, group: "Metadata Tables" });
  }), mO.forEach((n) => {
    (!n.cdmVersions || n.cdmVersions.some((r) => r === t)) && e.push({ name: n.name, group: "Health System" });
  }), yO.forEach((n) => {
    (!n.cdmVersions || n.cdmVersions.some((r) => r === t)) && e.push({ name: n.name, group: "Health Economics" });
  }), vO.forEach((n) => {
    (!n.cdmVersions || n.cdmVersions.some((r) => r === t)) && e.push({ name: n.name, group: "Vocabularies" });
  }), e;
}, dy = {
  "Metadata Tables": { header: "#d2f7f3", options: "#ebf7f7" },
  "Clinical Data Tables": { header: "#d9ecff", options: "#f4f9ff" },
  "Health Economics": { header: "#d4f7d2", options: "#ecfceb" },
  "Health System": { header: "#fceeca", options: "#fcf5e3" },
  Vocabularies: { header: "#f6ebfc", options: "#fcf7ff" },
  selectAll: { header: "#ffffff", options: "#ffffff" }
}, py = (t) => {
  const e = [], n = [];
  return Object.keys(t).forEach((r) => {
    t[r] ? e.push(r) : n.push(r);
  }), { includedTables: e, excludedTables: n };
}, _O = Qt.div`
  padding: 8px 10px;
  position: sticky;
  background-color: ${({ color: t }) => (t == null ? void 0 : t.header) || "#ffffff"};
  z-index: 2;
  top: 0;
`, bO = Qt.div`
  background-color: ${({ color: t }) => (t == null ? void 0 : t.options) || "#ffffff"};
  min-height: 34px;
  cursor: pointer;
`, wO = Qt.div`
  padding: 8px 10px;
  cursor: pointer;

  /* pointer-events: ${({ disabled: t }) => t ? "none" : "all"}; */
  position: sticky;
  top: 0;
`, EO = (t) => {
  const { onTableSelect: e, cdmVersion: n, disabled: r } = t;
  let a = xO(n);
  const o = (m) => {
    const b = {};
    return a.forEach((E) => {
      b[E.name] = m;
    }), b;
  };
  Ce(() => {
    c(o(!0)), d(!0);
  }, [n]);
  const [u, c] = Ot(
    () => o(!0)
  ), [l, d] = Ot(!0), g = (m, b) => {
    let E = o(!1);
    b.map((S) => typeof S == "object" ? S.name : S).forEach((S) => {
      E[S] = !0;
    }), c(E), d(b.length === a.length), e(py(E));
  }, y = (m) => {
    m.preventDefault();
    const b = !l;
    d(b);
    let E = o(b);
    c(E), e(py(E));
  }, f = Ie(({ children: m, ...b }) => /* @__PURE__ */ p.jsx(
    ka,
    {
      ...b,
      sx: {
        ".MuiAutocomplete-listbox": {
          p: 0,
          pb: 1,
          li: {
            pointerEvents: "all"
          }
        },
        position: "relative"
      },
      children: m
    }
  ), []);
  return /* @__PURE__ */ p.jsx(
    xl,
    {
      disableCloseOnSelect: !0,
      id: "includedTables",
      name: "includedTables",
      disabled: r,
      onChange: g,
      options: [{ name: "Select all", group: "selectAll" }, ...a],
      value: a.map((m) => m.name).filter(
        (m) => u[m] === !0
      ),
      multiple: !0,
      getOptionLabel: function(m) {
        return m.name || m;
      },
      PaperComponent: f,
      groupBy: (m) => m.group,
      OptionComponent: (m, b, { selected: E }) => /* @__PURE__ */ p.jsxs(He, { ...m, sx: { fontSize: "13px", height: "28px" }, children: [
        /* @__PURE__ */ p.jsx(
          di,
          {
            sx: { marginRight: 8 },
            checked: b.group === "selectAll" ? l : E,
            size: "small"
          }
        ),
        b.name
      ] }),
      isOptionEqualToValue: (m, b) => m.name === b,
      renderTags: (m, b) => /* @__PURE__ */ p.jsxs(
        He,
        {
          sx: {
            px: 1,
            fontSize: 14,
            color: "textColor.label"
          },
          children: [
            m != null && m.length ? (m == null ? void 0 : m.length) === a.length ? "All tables" : m == null ? void 0 : m.length : "None",
            " ",
            "selected..."
          ]
        },
        "tag-props"
      ),
      renderGroup: (m) => /* @__PURE__ */ p.jsx("li", { children: m.group === "selectAll" ? /* @__PURE__ */ p.jsxs(
        wO,
        {
          onMouseDown: (b) => b.preventDefault(),
          onClick: y,
          children: [
            /* @__PURE__ */ p.jsx(
              di,
              {
                sx: { marginRight: 8 },
                checked: l,
                size: "small"
              }
            ),
            "Select All"
          ]
        }
      ) : /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
        /* @__PURE__ */ p.jsx(_O, { color: dy[m.group], children: m.group }),
        /* @__PURE__ */ p.jsx(bO, { color: dy[m.group], children: m.children })
      ] }) }, m.key)
    }
  );
}, $v = (t) => {
  const {
    dataSourceId: e,
    afterSubmit: n,
    disabled: r = !1,
    cdmVersionParam: a = null,
    checkLevelsParam: o = /* @__PURE__ */ new Set(["CONCEPT", "FIELD", "TABLE"]),
    excludedTablesParam: u = []
  } = t, [c, l] = Ot(a), [d, g] = Ot(o), [y, f] = Ot(["dummy"]), [m, b] = Ot(u), [E, S] = Ot(ne.INITIAL), { enqueueSnackbar: M } = bi(), N = (w) => {
    b(w.excludedTables), f(w.includedTables);
  }, O = (w) => d.has(w), A = (w, C) => {
    const P = structuredClone(d);
    C === !0 ? P.add(w) : P.delete(w), g(P);
  }, x = async () => {
    S(ne.IN_PROGRESS);
    try {
      let w = [];
      O("CONCEPT") && w.push("CONCEPT"), O("FIELD") && w.push("FIELD"), O("TABLE") && w.push("TABLE"), await JD(
        e,
        c,
        w,
        m
      ), localStorage.setItem(`statusFinishDqdReports${e}`, "AWAIT"), S(ne.SUCCESS), M({
        message: "Running Data Quality Dashboard Reports",
        variant: "success"
      }), n();
    } catch {
      S(ne.ERROR), localStorage.setItem(
        `statusFinishDqdReports${e}`,
        "DECLINE"
      ), M({
        message: "Analysis was not submitted",
        variant: "error"
      });
    }
  }, v = Fn(() => E === ne.IN_PROGRESS ? /* @__PURE__ */ p.jsx(Ke, { size: 18 }) : /* @__PURE__ */ p.jsx(Qe, { iconName: "submit" }), [E]);
  return /* @__PURE__ */ p.jsx(fO, { children: /* @__PURE__ */ p.jsx(Et, { elevated: !0, outlined: !0, children: /* @__PURE__ */ p.jsxs(G, { container: !0, p: 2, spacing: 2, direction: "column", children: [
    /* @__PURE__ */ p.jsx(G, { item: !0, children: /* @__PURE__ */ p.jsxs(Tn, { textLabel: "CDM version", required: !0, children: [
      /* @__PURE__ */ p.jsxs(Ro, { children: [
        /* @__PURE__ */ p.jsx(
          ty,
          {
            checked: c === "5.3",
            disabled: r,
            value: "5.3",
            onChange: function(w) {
              l("5.3");
            },
            size: "small"
          }
        ),
        "CDM 5.3"
      ] }),
      /* @__PURE__ */ p.jsxs(Ro, { children: [
        /* @__PURE__ */ p.jsx(
          ty,
          {
            checked: c === "5.4",
            disabled: r,
            value: "5.4",
            onChange: function(w) {
              l("5.4");
            },
            size: "small"
          }
        ),
        "CDM 5.4"
      ] })
    ] }) }),
    /* @__PURE__ */ p.jsx(G, { item: !0, children: /* @__PURE__ */ p.jsxs(Tn, { textLabel: "Check level", required: !0, children: [
      /* @__PURE__ */ p.jsxs(Ro, { children: [
        /* @__PURE__ */ p.jsx(
          di,
          {
            disabled: r,
            onChange: (w) => {
              A("CONCEPT", w.target.checked);
            },
            checked: O("CONCEPT")
          }
        ),
        "Concept"
      ] }),
      /* @__PURE__ */ p.jsxs(Ro, { children: [
        /* @__PURE__ */ p.jsx(
          di,
          {
            disabled: r,
            onChange: (w) => {
              A("FIELD", w.target.checked);
            },
            checked: O("FIELD")
          }
        ),
        "Field"
      ] }),
      /* @__PURE__ */ p.jsxs(Ro, { children: [
        /* @__PURE__ */ p.jsx(
          di,
          {
            disabled: r,
            onChange: (w) => {
              A("TABLE", w.target.checked);
            },
            checked: O("TABLE")
          }
        ),
        "Table"
      ] })
    ] }) }),
    /* @__PURE__ */ p.jsx(G, { item: !0, children: r ? /* @__PURE__ */ p.jsx(Tn, { textLabel: "Excluded tables", labelSize: 0, children: m.filter((w) => w).length === 0 ? /* @__PURE__ */ p.jsx("span", { className: "no-data", children: "No excluded tables." }) : /* @__PURE__ */ p.jsx(hO, { children: /* @__PURE__ */ p.jsx("ul", { children: Array.from(m).sort().map((w) => /* @__PURE__ */ p.jsx("li", { children: w }, w)) }) }) }) : /* @__PURE__ */ p.jsx(
      Tn,
      {
        textLabel: "OMOP CDM tables",
        description: "All tables are selected by default",
        labelSize: 4,
        htmlFor: "includedTables",
        required: !0,
        children: /* @__PURE__ */ p.jsx(
          EO,
          {
            disabled: r || !c,
            onTableSelect: N,
            cdmVersion: c
          }
        )
      }
    ) }),
    /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: !r && /* @__PURE__ */ p.jsx(up, { children: /* @__PURE__ */ p.jsx(
      _e,
      {
        onClick: x,
        variant: "contained",
        color: "success",
        startIcon: v,
        name: "save",
        disabled: c === null || !O("CONCEPT") && !O("FIELD") && !O("TABLE") || y.length === 0 || E === ne.IN_PROGRESS,
        children: "Run"
      }
    ) }) })
  ] }) }) });
}, SO = (t) => {
  var y;
  const { dataSource: e } = t, { state: n, status: r } = qi(
    kv,
    e.id
  ), { state: a, status: o } = qi(
    Bv,
    e.id
  ), { openModal: u, closeModal: c } = Ar(io), l = (f) => {
    const m = f.original;
    u(
      () => /* @__PURE__ */ p.jsx(
        dO,
        {
          checkResult: m,
          onClose: c
        }
      ),
      "Check result details",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: c
      }
    );
  }, d = () => {
    u(
      () => /* @__PURE__ */ p.jsx(
        $v,
        {
          disabled: !0,
          dataSourceId: e.id,
          afterSubmit: c,
          cdmVersionParam: n.Design.cdmVersion,
          checkLevelsParam: new Set(n.Design.checkLevels),
          excludedTablesParam: n.Design.excludedTables
        }
      ),
      "DQD Run configuration",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: c
      }
    );
  }, g = r === ne.IN_PROGRESS || r === ne.IN_PROGRESS_RELOAD || o === ne.IN_PROGRESS || o === ne.IN_PROGRESS_RELOAD;
  return /* @__PURE__ */ p.jsx(p.Fragment, { children: /* @__PURE__ */ p.jsx(
    G,
    {
      container: !0,
      bgcolor: "backgroundColor.dark",
      flexGrow: 1,
      px: 6,
      py: 2,
      rowSpacing: 2,
      alignContent: "flex-start",
      children: g ? /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(Et, { elevated: !0, outlined: !0, minHeight: 162, children: /* @__PURE__ */ p.jsx(G, { container: !0, justifyContent: "space-around", my: "auto", children: /* @__PURE__ */ p.jsx(Ke, { size: 70, color: "secondary" }) }) }) }) : !n && (a == null ? void 0 : a.length) === 0 ? /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(Et, { elevated: !0, outlined: !0, minHeight: 162, children: /* @__PURE__ */ p.jsx(G, { container: !0, children: /* @__PURE__ */ p.jsx(
        cd,
        {
          noDataText: "There is no Data Quality Dashboard report yet for this data source."
        }
      ) }) }) }) : /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
        (a == null ? void 0 : a.length) > 0 && /* @__PURE__ */ p.jsx(p.Fragment, { children: /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
          /* @__PURE__ */ p.jsx(Lt, { title: "Data Quality Dashboard", children: /* @__PURE__ */ p.jsx(
            _e,
            {
              onClick: () => d(),
              variant: "text",
              color: "info",
              name: "save",
              startIcon: /* @__PURE__ */ p.jsx(Qe, { iconName: "info" }),
              children: "See config"
            }
          ) }),
          /* @__PURE__ */ p.jsxs(G, { item: !0, xs: "auto", p: 2, pb: 1, overflow: "auto", children: [
            /* @__PURE__ */ p.jsxs(uO, { children: [
              /* @__PURE__ */ p.jsx("colgroup", { children: /* @__PURE__ */ p.jsx("col", { width: "10%" }) }),
              /* @__PURE__ */ p.jsxs("thead", { children: [
                /* @__PURE__ */ p.jsxs("tr", { children: [
                  /* @__PURE__ */ p.jsx(
                    gr,
                    {
                      headerLevel: -1,
                      rowSpan: 2
                    }
                  ),
                  /* @__PURE__ */ p.jsx(gr, { colSpan: 6, align: "center", children: "Verification" }),
                  /* @__PURE__ */ p.jsx(gr, { colSpan: 6, children: "Validation" }),
                  /* @__PURE__ */ p.jsx(gr, { colSpan: 6, children: "Total" })
                ] }, 1),
                /* @__PURE__ */ p.jsx("tr", { children: Array.from({ length: 3 }, () => /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
                  /* @__PURE__ */ p.jsx(gr, { headerLevel: 1, children: "Pass" }),
                  /* @__PURE__ */ p.jsx(gr, { headerLevel: 1, children: "Fail" }),
                  /* @__PURE__ */ p.jsx(gr, { headerLevel: 1, children: "N/A" }),
                  /* @__PURE__ */ p.jsx(gr, { headerLevel: 1, children: "Error" }),
                  /* @__PURE__ */ p.jsx(gr, { headerLevel: 1, children: "Total" }),
                  /* @__PURE__ */ p.jsx(gr, { headerLevel: 1, children: "%Pass" })
                ] })) }, 2)
              ] }),
              /* @__PURE__ */ p.jsx("tbody", { children: a.map((f, m) => /* @__PURE__ */ p.jsxs("tr", { children: [
                /* @__PURE__ */ p.jsx(
                  Ue,
                  {
                    bold: !0,
                    fontSize: 13,
                    align: "left",
                    children: f == null ? void 0 : f.category
                  }
                ),
                /* @__PURE__ */ p.jsx(
                  Ue,
                  {
                    bold: m == 3,
                    textColor: (f == null ? void 0 : f.ver_p) !== 0 ? "green" : "",
                    children: f == null ? void 0 : f.ver_p
                  }
                ),
                /* @__PURE__ */ p.jsx(
                  Ue,
                  {
                    bold: m == 3,
                    textColor: (f == null ? void 0 : f.ver_f) !== 0 ? "red" : "",
                    children: f == null ? void 0 : f.ver_f
                  }
                ),
                /* @__PURE__ */ p.jsx(Ue, { bold: m == 3, children: f == null ? void 0 : f.ver_na }),
                /* @__PURE__ */ p.jsx(Ue, { bold: m == 3, children: f == null ? void 0 : f.ver_e }),
                /* @__PURE__ */ p.jsx(Ue, { bold: !0, children: f == null ? void 0 : f.ver_t }),
                /* @__PURE__ */ p.jsxs(Ue, { bold: m == 3, children: [
                  f == null ? void 0 : f.ver_pp,
                  "%"
                ] }),
                /* @__PURE__ */ p.jsx(
                  Ue,
                  {
                    bold: m == 3,
                    textColor: (f == null ? void 0 : f.val_p) !== 0 ? "green" : "",
                    children: f == null ? void 0 : f.val_p
                  }
                ),
                /* @__PURE__ */ p.jsx(
                  Ue,
                  {
                    bold: m == 3,
                    textColor: (f == null ? void 0 : f.val_f) !== 0 ? "red" : "",
                    children: f == null ? void 0 : f.val_f
                  }
                ),
                /* @__PURE__ */ p.jsx(Ue, { bold: m == 3, children: f == null ? void 0 : f.val_na }),
                /* @__PURE__ */ p.jsx(Ue, { bold: m == 3, children: f == null ? void 0 : f.val_e }),
                /* @__PURE__ */ p.jsx(Ue, { bold: !0, children: f == null ? void 0 : f.val_t }),
                /* @__PURE__ */ p.jsxs(Ue, { bold: m == 3, children: [
                  f == null ? void 0 : f.val_pp,
                  "%"
                ] }),
                /* @__PURE__ */ p.jsx(
                  Ue,
                  {
                    bold: m == 3,
                    textColor: (f == null ? void 0 : f.tot_p) !== 0 ? "green" : "",
                    children: f == null ? void 0 : f.tot_p
                  }
                ),
                /* @__PURE__ */ p.jsx(
                  Ue,
                  {
                    bold: m == 3,
                    textColor: (f == null ? void 0 : f.tot_f) !== 0 ? "red" : "",
                    children: f == null ? void 0 : f.tot_f
                  }
                ),
                /* @__PURE__ */ p.jsx(Ue, { bold: m == 3, children: f == null ? void 0 : f.tot_na }),
                /* @__PURE__ */ p.jsx(Ue, { bold: m == 3, children: f == null ? void 0 : f.tot_e }),
                /* @__PURE__ */ p.jsx(Ue, { bold: !0, children: f == null ? void 0 : f.tot_t }),
                /* @__PURE__ */ p.jsxs(Ue, { bold: m == 3, children: [
                  f == null ? void 0 : f.tot_pp,
                  "%"
                ] })
              ] })) })
            ] }),
            n && /* @__PURE__ */ p.jsxs(
              an,
              {
                textAlign: "right",
                variant: "subtitle2",
                mt: 1,
                children: [
                  "Results generated at ",
                  n.startTimestamp,
                  " in",
                  " ",
                  n.executionTime
                ]
              }
            )
          ] })
        ] }) }) }),
        n && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(Et, { elevated: !0, outlined: !0, children: /* @__PURE__ */ p.jsx(He, { p: 2, children: /* @__PURE__ */ p.jsx(
          Sv,
          {
            onRowClick: l,
            columns: sO,
            data: n.CheckResults ?? [],
            totalElements: ((y = n.CheckResults) == null ? void 0 : y.length) ?? 0,
            enableFiltering: !0
          }
        ) }) }) })
      ] })
    }
  ) });
}, AO = (t) => {
  const {
    dataSource: e,
    isLoading: n,
    onUpload: r,
    onChange: a,
    subModules: o,
    canUpdate: u,
    canManageReports: c = u,
    canManageAccessSettings: l = u,
    onImport: d,
    onExport: g,
    onFinishRunningReport: y,
    reloadLogo: f
  } = t, m = Sc(), b = Ar(io), { openModal: E, closeModal: S } = b, { status: M, state: N } = qi(
    ZD,
    e.id
  ), [O, A] = Ot(!0), [x, v] = Ot(
    localStorage.getItem(`statusFinishDqdReports${e.id}`) === "AWAIT"
  );
  Ce(() => {
    A((N == null ? void 0 : N.length) > 0);
  }, [N]);
  const { enqueueSnackbar: w } = bi(), {
    name: C,
    description: P,
    dataNode: Y,
    modelTypeLabel: V,
    cdmVersionLabel: k,
    accessType: T,
    accessTypeLabel: R,
    executionPolicy: F
  } = e, U = (X) => typeof X == "string" ? X.trim().length > 0 : X != null && X !== "";
  Ce(() => {
    if (!x) {
      localStorage.removeItem(`statusFinishDqdReports${e.id}`);
      return;
    }
    let X = setInterval(async () => {
      localStorage.getItem(
        `statusFinishDqdReports${e.id}`
      ) !== "AWAIT" && clearInterval(X);
      try {
        await tM(
          e.id
        ) === 0 && (v(!1), y());
      } catch (et) {
        console.log(et);
      }
    }, 3e4);
    return () => {
      clearInterval(X);
    };
  }, [x]);
  const H = () => {
    E(
      () => /* @__PURE__ */ p.jsx(
        oO,
        {
          dataSource: e,
          onChange: async (X) => {
            await a(X), S();
          },
          onClose: S,
          reloadLogo: f,
          canManageAccessSettings: l
        }
      ),
      `Update data source: ${e.name}`,
      {
        closeOnClickOutside: !0,
        onClose: S
      }
    );
  }, W = async () => {
    try {
      A(!0), await KD(e.id), w({
        message: "Running Achilles Reports",
        variant: "success"
      });
    } catch (X) {
      console.error(X);
    }
  }, B = async () => {
    E(
      () => /* @__PURE__ */ p.jsx(
        $v,
        {
          dataSourceId: e.id,
          afterSubmit: S
        }
      ),
      "Run Data Quality Dashboard reports",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: S
      }
    );
  }, j = ZR;
  return n ? /* @__PURE__ */ p.jsx(ro, { children: /* @__PURE__ */ p.jsx(Ke, { size: 32 }) }) : /* @__PURE__ */ p.jsx(BR, { children: /* @__PURE__ */ p.jsxs(G, { container: !0, px: 6, py: 3, alignContent: "flex-start", children: [
    /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsxs(
      G,
      {
        item: !0,
        xs: 12,
        display: "flex",
        justifyContent: "space-between",
        mb: U(C) || U(P) ? 2 : 0,
        children: [
          /* @__PURE__ */ p.jsx("div", {}),
          /* @__PURE__ */ p.jsx("div", { children: u && /* @__PURE__ */ p.jsxs(G, { item: !0, display: "flex", justifyContent: "flex-end", children: [
            /* @__PURE__ */ p.jsx(G, { item: !0, children: /* @__PURE__ */ p.jsx(
              j,
              {
                onClick: H,
                iconName: "edit",
                title: "Update",
                name: "edit-data-source",
                color: "info"
              }
            ) }),
            c && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
              /* @__PURE__ */ p.jsx(G, { item: !0, ml: 1, children: /* @__PURE__ */ p.jsx(
                j,
                {
                  onClick: () => r(e.id),
                  iconName: "import",
                  title: "Upload reports",
                  name: "upload-data-source-reports",
                  color: "primary",
                  noCollapse: !0
                }
              ) }),
              /* @__PURE__ */ p.jsx(G, { item: !0, ml: 1, children: /* @__PURE__ */ p.jsx(
                j,
                {
                  onClick: W,
                  iconName: "play",
                  title: "Run Achilles Reports",
                  name: "run-achilles-reports",
                  color: "primary",
                  disabled: O,
                  loading: O,
                  noCollapse: !0
                }
              ) }),
              /* @__PURE__ */ p.jsx(G, { item: !0, ml: 1, children: /* @__PURE__ */ p.jsx(
                j,
                {
                  onClick: B,
                  iconName: "play",
                  title: "Run Data Quality Dashboard Reports",
                  name: "run-data-quality-dashboard-reports",
                  color: "primary",
                  disabled: x,
                  loading: x,
                  noCollapse: !0
                }
              ) })
            ] })
          ] }) })
        ]
      }
    ) }),
    U(C) && /* @__PURE__ */ p.jsx(G, { container: !0, spacing: 3, py: 2, children: /* @__PURE__ */ p.jsxs(G, { item: !0, xs: 3, mt: 2, children: [
      /* @__PURE__ */ p.jsx(an, { variant: "subtitle1", component: "label", children: "Name" }),
      /* @__PURE__ */ p.jsx(
        ey,
        {
          name: "name",
          value: C,
          onSubmit: (X) => {
          },
          color: m.palette.textColor.secondary,
          multiline: !0,
          fullWidth: !0,
          disabled: !0,
          sx: {
            ml: -1.1,
            width: "calc(100% + 16px)"
          }
        }
      )
    ] }) }),
    U(P) && /* @__PURE__ */ p.jsxs(G, { container: !0, spacing: 3, py: 2, children: [
      /* @__PURE__ */ p.jsxs(G, { item: !0, xs: 3, mt: 2, children: [
        /* @__PURE__ */ p.jsx(an, { variant: "subtitle1", component: "label", children: "Description" }),
        /* @__PURE__ */ p.jsx(
          ey,
          {
            name: "description",
            value: P,
            onSubmit: (X) => {
            },
            color: m.palette.textColor.secondary,
            multiline: !0,
            fullWidth: !0,
            disabled: !0,
            sx: {
              ml: -1.1,
              width: "calc(100% + 16px)"
            }
          }
        )
      ] }),
      /* @__PURE__ */ p.jsx(fs, { sx: { mt: 2 } })
    ] }),
    /* @__PURE__ */ p.jsx(G, { item: !0, xs: 8, children: /* @__PURE__ */ p.jsxs(G, { container: !0, spacing: 3, py: 2, children: [
      U(V) && /* @__PURE__ */ p.jsxs(G, { item: !0, md: 6, xl: 4, children: [
        /* @__PURE__ */ p.jsx(an, { variant: "subtitle1", component: "label", children: "Model type:" }),
        /* @__PURE__ */ p.jsx(an, { variant: "body2", py: 0.5, children: V })
      ] }),
      U(T) && U(R) && /* @__PURE__ */ p.jsxs(G, { item: !0, md: 6, xl: 4, children: [
        /* @__PURE__ */ p.jsx(an, { variant: "subtitle1", component: "label", children: "Access type:" }),
        /* @__PURE__ */ p.jsx(an, { variant: "body2", component: "div", py: 0.5, children: /* @__PURE__ */ p.jsx(
          Ac,
          {
            light: !0,
            color: Tv(T, m),
            text: R,
            align: "center"
          }
        ) })
      ] }),
      U(F) && /* @__PURE__ */ p.jsxs(G, { item: !0, md: 6, xl: 4, children: [
        /* @__PURE__ */ p.jsx(an, { variant: "subtitle1", component: "label", children: "Execution policy:" }),
        /* @__PURE__ */ p.jsx(an, { variant: "body2", component: "div", py: 0.5, children: /* @__PURE__ */ p.jsx(
          Ac,
          {
            light: !0,
            color: Cv(F, m),
            text: F,
            align: "center",
            minWidth: 90
          }
        ) })
      ] })
    ] }) }),
    e.metaAttributes && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
      /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(fs, {}) }),
      /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12 }),
      /* @__PURE__ */ p.jsx(G, { item: !0, xs: 8, children: /* @__PURE__ */ p.jsx(G, { container: !0, spacing: 3, py: 2, children: Object.keys(e.metaAttributes).map((X) => {
        const tt = e.metaAttributes[X], et = tt.values.map((ot) => tt.type == hn.INTEGER || tt.type == hn.STRING ? ot.value : ot.attributeOption.value).join(", ");
        return U(et) && /* @__PURE__ */ p.jsxs(G, { item: !0, md: 6, xl: 4, children: [
          /* @__PURE__ */ p.jsx(an, { variant: "subtitle1", component: "label", children: tt.name }),
          /* @__PURE__ */ p.jsx(an, { variant: "body2", component: "div", py: 0.5, children: et })
        ] }, X);
      }) }) })
    ] })
  ] }) });
}, Qr = (t, e) => {
  const n = {};
  let r = "";
  return t && t.length > 0 && t instanceof Array ? (r = Object.keys(t[0]), r.forEach(function(a) {
    n[a] = [];
  }), t.forEach(function(a) {
    var o = a;
    r.forEach(function(u) {
      var c = o[u];
      e && cD(+c) && (c = +c), n[u].push(c);
    });
  })) : n.empty = !0, n;
};
var TO = "4.13.0";
function ea(t, e) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function dp(t) {
  return t.length === 1 && (t = CO(t)), {
    left: function(e, n, r, a) {
      for (r == null && (r = 0), a == null && (a = e.length); r < a; ) {
        var o = r + a >>> 1;
        t(e[o], n) < 0 ? r = o + 1 : a = o;
      }
      return r;
    },
    right: function(e, n, r, a) {
      for (r == null && (r = 0), a == null && (a = e.length); r < a; ) {
        var o = r + a >>> 1;
        t(e[o], n) > 0 ? a = o : r = o + 1;
      }
      return r;
    }
  };
}
function CO(t) {
  return function(e, n) {
    return ea(t(e), n);
  };
}
var zv = dp(ea), Hi = zv.right, RO = zv.left;
function DO(t, e) {
  e == null && (e = Vv);
  for (var n = 0, r = t.length - 1, a = t[0], o = new Array(r < 0 ? 0 : r); n < r; ) o[n] = e(a, a = t[++n]);
  return o;
}
function Vv(t, e) {
  return [t, e];
}
function MO(t, e, n) {
  var r = t.length, a = e.length, o = new Array(r * a), u, c, l, d;
  for (n == null && (n = Vv), u = l = 0; u < r; ++u)
    for (d = t[u], c = 0; c < a; ++c, ++l)
      o[l] = n(d, e[c]);
  return o;
}
function OO(t, e) {
  return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function mi(t) {
  return t === null ? NaN : +t;
}
function Yv(t, e) {
  var n = t.length, r = 0, a = -1, o = 0, u, c, l = 0;
  if (e == null)
    for (; ++a < n; )
      isNaN(u = mi(t[a])) || (c = u - o, o += c / ++r, l += c * (u - o));
  else
    for (; ++a < n; )
      isNaN(u = mi(e(t[a], a, t))) || (c = u - o, o += c / ++r, l += c * (u - o));
  if (r > 1) return l / (r - 1);
}
function Wv(t, e) {
  var n = Yv(t, e);
  return n && Math.sqrt(n);
}
function ks(t, e) {
  var n = t.length, r = -1, a, o, u;
  if (e == null) {
    for (; ++r < n; )
      if ((a = t[r]) != null && a >= a)
        for (o = u = a; ++r < n; )
          (a = t[r]) != null && (o > a && (o = a), u < a && (u = a));
  } else
    for (; ++r < n; )
      if ((a = e(t[r], r, t)) != null && a >= a)
        for (o = u = a; ++r < n; )
          (a = e(t[r], r, t)) != null && (o > a && (o = a), u < a && (u = a));
  return [o, u];
}
var Gv = Array.prototype, LO = Gv.slice, PO = Gv.map;
function Vu(t) {
  return function() {
    return t;
  };
}
function NO(t) {
  return t;
}
function tr(t, e, n) {
  t = +t, e = +e, n = (a = arguments.length) < 2 ? (e = t, t = 0, 1) : a < 3 ? 1 : +n;
  for (var r = -1, a = Math.max(0, Math.ceil((e - t) / n)) | 0, o = new Array(a); ++r < a; )
    o[r] = t + r * n;
  return o;
}
var hd = Math.sqrt(50), dd = Math.sqrt(10), pd = Math.sqrt(2);
function pp(t, e, n) {
  var r, a = -1, o, u, c;
  if (e = +e, t = +t, n = +n, t === e && n > 0) return [t];
  if ((r = e < t) && (o = t, t = e, e = o), (c = as(t, e, n)) === 0 || !isFinite(c)) return [];
  if (c > 0)
    for (t = Math.ceil(t / c), e = Math.floor(e / c), u = new Array(o = Math.ceil(e - t + 1)); ++a < o; ) u[a] = (t + a) * c;
  else
    for (t = Math.floor(t * c), e = Math.ceil(e * c), u = new Array(o = Math.ceil(t - e + 1)); ++a < o; ) u[a] = (t - a) / c;
  return r && u.reverse(), u;
}
function as(t, e, n) {
  var r = (e - t) / Math.max(0, n), a = Math.floor(Math.log(r) / Math.LN10), o = r / Math.pow(10, a);
  return a >= 0 ? (o >= hd ? 10 : o >= dd ? 5 : o >= pd ? 2 : 1) * Math.pow(10, a) : -Math.pow(10, -a) / (o >= hd ? 10 : o >= dd ? 5 : o >= pd ? 2 : 1);
}
function hs(t, e, n) {
  var r = Math.abs(e - t) / Math.max(0, n), a = Math.pow(10, Math.floor(Math.log(r) / Math.LN10)), o = r / a;
  return o >= hd ? a *= 10 : o >= dd ? a *= 5 : o >= pd && (a *= 2), e < t ? -a : a;
}
function qv(t) {
  return Math.ceil(Math.log(t.length) / Math.LN2) + 1;
}
function IO() {
  var t = NO, e = ks, n = qv;
  function r(a) {
    var o, u = a.length, c, l = new Array(u);
    for (o = 0; o < u; ++o)
      l[o] = t(a[o], o, a);
    var d = e(l), g = d[0], y = d[1], f = n(l, g, y);
    Array.isArray(f) || (f = hs(g, y, f), f = tr(Math.ceil(g / f) * f, Math.floor(y / f) * f, f));
    for (var m = f.length; f[0] <= g; ) f.shift(), --m;
    for (; f[m - 1] > y; ) f.pop(), --m;
    var b = new Array(m + 1), E;
    for (o = 0; o <= m; ++o)
      E = b[o] = [], E.x0 = o > 0 ? f[o - 1] : g, E.x1 = o < m ? f[o] : y;
    for (o = 0; o < u; ++o)
      c = l[o], g <= c && c <= y && b[Hi(f, c, 0, m)].push(a[o]);
    return b;
  }
  return r.value = function(a) {
    return arguments.length ? (t = typeof a == "function" ? a : Vu(a), r) : t;
  }, r.domain = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : Vu([a[0], a[1]]), r) : e;
  }, r.thresholds = function(a) {
    return arguments.length ? (n = typeof a == "function" ? a : Array.isArray(a) ? Vu(LO.call(a)) : Vu(a), r) : n;
  }, r;
}
function ds(t, e, n) {
  if (n == null && (n = mi), !!(r = t.length)) {
    if ((e = +e) <= 0 || r < 2) return +n(t[0], 0, t);
    if (e >= 1) return +n(t[r - 1], r - 1, t);
    var r, a = (r - 1) * e, o = Math.floor(a), u = +n(t[o], o, t), c = +n(t[o + 1], o + 1, t);
    return u + (c - u) * (a - o);
  }
}
function jO(t, e, n) {
  return t = PO.call(t, mi).sort(ea), Math.ceil((n - e) / (2 * (ds(t, 0.75) - ds(t, 0.25)) * Math.pow(t.length, -1 / 3)));
}
function kO(t, e, n) {
  return Math.ceil((n - e) / (3.5 * Wv(t) * Math.pow(t.length, -1 / 3)));
}
function bl(t, e) {
  var n = t.length, r = -1, a, o;
  if (e == null) {
    for (; ++r < n; )
      if ((a = t[r]) != null && a >= a)
        for (o = a; ++r < n; )
          (a = t[r]) != null && a > o && (o = a);
  } else
    for (; ++r < n; )
      if ((a = e(t[r], r, t)) != null && a >= a)
        for (o = a; ++r < n; )
          (a = e(t[r], r, t)) != null && a > o && (o = a);
  return o;
}
function BO(t, e) {
  var n = t.length, r = n, a = -1, o, u = 0;
  if (e == null)
    for (; ++a < n; )
      isNaN(o = mi(t[a])) ? --r : u += o;
  else
    for (; ++a < n; )
      isNaN(o = mi(e(t[a], a, t))) ? --r : u += o;
  if (r) return u / r;
}
function FO(t, e) {
  var n = t.length, r = -1, a, o = [];
  if (e == null)
    for (; ++r < n; )
      isNaN(a = mi(t[r])) || o.push(a);
  else
    for (; ++r < n; )
      isNaN(a = mi(e(t[r], r, t))) || o.push(a);
  return ds(o.sort(ea), 0.5);
}
function gp(t) {
  for (var e = t.length, n, r = -1, a = 0, o, u; ++r < e; ) a += t[r].length;
  for (o = new Array(a); --e >= 0; )
    for (u = t[e], n = u.length; --n >= 0; )
      o[--a] = u[n];
  return o;
}
function wl(t, e) {
  var n = t.length, r = -1, a, o;
  if (e == null) {
    for (; ++r < n; )
      if ((a = t[r]) != null && a >= a)
        for (o = a; ++r < n; )
          (a = t[r]) != null && o > a && (o = a);
  } else
    for (; ++r < n; )
      if ((a = e(t[r], r, t)) != null && a >= a)
        for (o = a; ++r < n; )
          (a = e(t[r], r, t)) != null && o > a && (o = a);
  return o;
}
function UO(t, e) {
  for (var n = e.length, r = new Array(n); n--; ) r[n] = t[e[n]];
  return r;
}
function $O(t, e) {
  if (n = t.length) {
    var n, r = 0, a = 0, o, u = t[a];
    for (e == null && (e = ea); ++r < n; )
      (e(o = t[r], u) < 0 || e(u, u) !== 0) && (u = o, a = r);
    if (e(u, u) === 0) return a;
  }
}
function zO(t, e, n) {
  for (var r = (n ?? t.length) - (e = e == null ? 0 : +e), a, o; r; )
    o = Math.random() * r-- | 0, a = t[r + e], t[r + e] = t[o + e], t[o + e] = a;
  return t;
}
function VO(t, e) {
  var n = t.length, r = -1, a, o = 0;
  if (e == null)
    for (; ++r < n; )
      (a = +t[r]) && (o += a);
  else
    for (; ++r < n; )
      (a = +e(t[r], r, t)) && (o += a);
  return o;
}
function Hv(t) {
  if (!(o = t.length)) return [];
  for (var e = -1, n = wl(t, YO), r = new Array(n); ++e < n; )
    for (var a = -1, o, u = r[e] = new Array(o); ++a < o; )
      u[a] = t[a][e];
  return r;
}
function YO(t) {
  return t.length;
}
function WO() {
  return Hv(arguments);
}
var Th = Array.prototype.slice;
function GO(t) {
  return t;
}
var dc = 1, pc = 2, gd = 3, $o = 4, gy = 1e-6;
function qO(t) {
  return "translate(" + (t + 0.5) + ",0)";
}
function HO(t) {
  return "translate(0," + (t + 0.5) + ")";
}
function XO(t) {
  return function(e) {
    return +t(e);
  };
}
function QO(t) {
  var e = Math.max(0, t.bandwidth() - 1) / 2;
  return t.round() && (e = Math.round(e)), function(n) {
    return +t(n) + e;
  };
}
function KO() {
  return !this.__axis;
}
function El(t, e) {
  var n = [], r = null, a = null, o = 6, u = 6, c = 3, l = t === dc || t === $o ? -1 : 1, d = t === $o || t === pc ? "x" : "y", g = t === dc || t === gd ? qO : HO;
  function y(f) {
    var m = r ?? (e.ticks ? e.ticks.apply(e, n) : e.domain()), b = a ?? (e.tickFormat ? e.tickFormat.apply(e, n) : GO), E = Math.max(o, 0) + c, S = e.range(), M = +S[0] + 0.5, N = +S[S.length - 1] + 0.5, O = (e.bandwidth ? QO : XO)(e.copy()), A = f.selection ? f.selection() : f, x = A.selectAll(".domain").data([null]), v = A.selectAll(".tick").data(m, e).order(), w = v.exit(), C = v.enter().append("g").attr("class", "tick"), P = v.select("line"), Y = v.select("text");
    x = x.merge(x.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "#000")), v = v.merge(C), P = P.merge(C.append("line").attr("stroke", "#000").attr(d + "2", l * o)), Y = Y.merge(C.append("text").attr("fill", "#000").attr(d, l * E).attr("dy", t === dc ? "0em" : t === gd ? "0.71em" : "0.32em")), f !== A && (x = x.transition(f), v = v.transition(f), P = P.transition(f), Y = Y.transition(f), w = w.transition(f).attr("opacity", gy).attr("transform", function(V) {
      return isFinite(V = O(V)) ? g(V) : this.getAttribute("transform");
    }), C.attr("opacity", gy).attr("transform", function(V) {
      var k = this.parentNode.__axis;
      return g(k && isFinite(k = k(V)) ? k : O(V));
    })), w.remove(), x.attr("d", t === $o || t == pc ? "M" + l * u + "," + M + "H0.5V" + N + "H" + l * u : "M" + M + "," + l * u + "V0.5H" + N + "V" + l * u), v.attr("opacity", 1).attr("transform", function(V) {
      return g(O(V));
    }), P.attr(d + "2", l * o), Y.attr(d, l * E).text(b), A.filter(KO).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", t === pc ? "start" : t === $o ? "end" : "middle"), A.each(function() {
      this.__axis = O;
    });
  }
  return y.scale = function(f) {
    return arguments.length ? (e = f, y) : e;
  }, y.ticks = function() {
    return n = Th.call(arguments), y;
  }, y.tickArguments = function(f) {
    return arguments.length ? (n = f == null ? [] : Th.call(f), y) : n.slice();
  }, y.tickValues = function(f) {
    return arguments.length ? (r = f == null ? null : Th.call(f), y) : r && r.slice();
  }, y.tickFormat = function(f) {
    return arguments.length ? (a = f, y) : a;
  }, y.tickSize = function(f) {
    return arguments.length ? (o = u = +f, y) : o;
  }, y.tickSizeInner = function(f) {
    return arguments.length ? (o = +f, y) : o;
  }, y.tickSizeOuter = function(f) {
    return arguments.length ? (u = +f, y) : u;
  }, y.tickPadding = function(f) {
    return arguments.length ? (c = +f, y) : c;
  }, y;
}
function ZO(t) {
  return El(dc, t);
}
function JO(t) {
  return El(pc, t);
}
function tL(t) {
  return El(gd, t);
}
function eL(t) {
  return El($o, t);
}
var nL = { value: function() {
} };
function wi() {
  for (var t = 0, e = arguments.length, n = {}, r; t < e; ++t) {
    if (!(r = arguments[t] + "") || r in n) throw new Error("illegal type: " + r);
    n[r] = [];
  }
  return new gc(n);
}
function gc(t) {
  this._ = t;
}
function rL(t, e) {
  return t.trim().split(/^|\s+/).map(function(n) {
    var r = "", a = n.indexOf(".");
    if (a >= 0 && (r = n.slice(a + 1), n = n.slice(0, a)), n && !e.hasOwnProperty(n)) throw new Error("unknown type: " + n);
    return { type: n, name: r };
  });
}
gc.prototype = wi.prototype = {
  constructor: gc,
  on: function(t, e) {
    var n = this._, r = rL(t + "", n), a, o = -1, u = r.length;
    if (arguments.length < 2) {
      for (; ++o < u; ) if ((a = (t = r[o]).type) && (a = iL(n[a], t.name))) return a;
      return;
    }
    if (e != null && typeof e != "function") throw new Error("invalid callback: " + e);
    for (; ++o < u; )
      if (a = (t = r[o]).type) n[a] = my(n[a], t.name, e);
      else if (e == null) for (a in n) n[a] = my(n[a], t.name, null);
    return this;
  },
  copy: function() {
    var t = {}, e = this._;
    for (var n in e) t[n] = e[n].slice();
    return new gc(t);
  },
  call: function(t, e) {
    if ((a = arguments.length - 2) > 0) for (var n = new Array(a), r = 0, a, o; r < a; ++r) n[r] = arguments[r + 2];
    if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    for (o = this._[t], r = 0, a = o.length; r < a; ++r) o[r].value.apply(e, n);
  },
  apply: function(t, e, n) {
    if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    for (var r = this._[t], a = 0, o = r.length; a < o; ++a) r[a].value.apply(e, n);
  }
};
function iL(t, e) {
  for (var n = 0, r = t.length, a; n < r; ++n)
    if ((a = t[n]).name === e)
      return a.value;
}
function my(t, e, n) {
  for (var r = 0, a = t.length; r < a; ++r)
    if (t[r].name === e) {
      t[r] = nL, t = t.slice(0, r).concat(t.slice(r + 1));
      break;
    }
  return n != null && t.push({ name: e, value: n }), t;
}
var md = "http://www.w3.org/1999/xhtml";
const yd = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: md,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function Bs(t) {
  var e = t += "", n = e.indexOf(":");
  return n >= 0 && (e = t.slice(0, n)) !== "xmlns" && (t = t.slice(n + 1)), yd.hasOwnProperty(e) ? { space: yd[e], local: t } : t;
}
function aL(t) {
  return function() {
    var e = this.ownerDocument, n = this.namespaceURI;
    return n === md && e.documentElement.namespaceURI === md ? e.createElement(t) : e.createElementNS(n, t);
  };
}
function oL(t) {
  return function() {
    return this.ownerDocument.createElementNS(t.space, t.local);
  };
}
function Sl(t) {
  var e = Bs(t);
  return (e.local ? oL : aL)(e);
}
function sL() {
}
function Al(t) {
  return t == null ? sL : function() {
    return this.querySelector(t);
  };
}
function uL(t) {
  typeof t != "function" && (t = Al(t));
  for (var e = this._groups, n = e.length, r = new Array(n), a = 0; a < n; ++a)
    for (var o = e[a], u = o.length, c = r[a] = new Array(u), l, d, g = 0; g < u; ++g)
      (l = o[g]) && (d = t.call(l, l.__data__, g, o)) && ("__data__" in l && (d.__data__ = l.__data__), c[g] = d);
  return new yn(r, this._parents);
}
function cL() {
  return [];
}
function mp(t) {
  return t == null ? cL : function() {
    return this.querySelectorAll(t);
  };
}
function lL(t) {
  typeof t != "function" && (t = mp(t));
  for (var e = this._groups, n = e.length, r = [], a = [], o = 0; o < n; ++o)
    for (var u = e[o], c = u.length, l, d = 0; d < c; ++d)
      (l = u[d]) && (r.push(t.call(l, l.__data__, d, u)), a.push(l));
  return new yn(r, a);
}
var Xv = function(t) {
  return function() {
    return this.matches(t);
  };
};
if (typeof document < "u") {
  var Do = document.documentElement;
  if (!Do.matches) {
    var fL = Do.webkitMatchesSelector || Do.msMatchesSelector || Do.mozMatchesSelector || Do.oMatchesSelector;
    Xv = function(t) {
      return function() {
        return fL.call(this, t);
      };
    };
  }
}
const yp = Xv;
function hL(t) {
  typeof t != "function" && (t = yp(t));
  for (var e = this._groups, n = e.length, r = new Array(n), a = 0; a < n; ++a)
    for (var o = e[a], u = o.length, c = r[a] = [], l, d = 0; d < u; ++d)
      (l = o[d]) && t.call(l, l.__data__, d, o) && c.push(l);
  return new yn(r, this._parents);
}
function Qv(t) {
  return new Array(t.length);
}
function dL() {
  return new yn(this._enter || this._groups.map(Qv), this._parents);
}
function Tc(t, e) {
  this.ownerDocument = t.ownerDocument, this.namespaceURI = t.namespaceURI, this._next = null, this._parent = t, this.__data__ = e;
}
Tc.prototype = {
  constructor: Tc,
  appendChild: function(t) {
    return this._parent.insertBefore(t, this._next);
  },
  insertBefore: function(t, e) {
    return this._parent.insertBefore(t, e);
  },
  querySelector: function(t) {
    return this._parent.querySelector(t);
  },
  querySelectorAll: function(t) {
    return this._parent.querySelectorAll(t);
  }
};
function pL(t) {
  return function() {
    return t;
  };
}
var yy = "$";
function gL(t, e, n, r, a, o) {
  for (var u = 0, c, l = e.length, d = o.length; u < d; ++u)
    (c = e[u]) ? (c.__data__ = o[u], r[u] = c) : n[u] = new Tc(t, o[u]);
  for (; u < l; ++u)
    (c = e[u]) && (a[u] = c);
}
function mL(t, e, n, r, a, o, u) {
  var c, l, d = {}, g = e.length, y = o.length, f = new Array(g), m;
  for (c = 0; c < g; ++c)
    (l = e[c]) && (f[c] = m = yy + u.call(l, l.__data__, c, e), m in d ? a[c] = l : d[m] = l);
  for (c = 0; c < y; ++c)
    m = yy + u.call(t, o[c], c, o), (l = d[m]) ? (r[c] = l, l.__data__ = o[c], d[m] = null) : n[c] = new Tc(t, o[c]);
  for (c = 0; c < g; ++c)
    (l = e[c]) && d[f[c]] === l && (a[c] = l);
}
function yL(t, e) {
  if (!t)
    return m = new Array(this.size()), d = -1, this.each(function(v) {
      m[++d] = v;
    }), m;
  var n = e ? mL : gL, r = this._parents, a = this._groups;
  typeof t != "function" && (t = pL(t));
  for (var o = a.length, u = new Array(o), c = new Array(o), l = new Array(o), d = 0; d < o; ++d) {
    var g = r[d], y = a[d], f = y.length, m = t.call(g, g && g.__data__, d, r), b = m.length, E = c[d] = new Array(b), S = u[d] = new Array(b), M = l[d] = new Array(f);
    n(g, y, E, S, M, m, e);
    for (var N = 0, O = 0, A, x; N < b; ++N)
      if (A = E[N]) {
        for (N >= O && (O = N + 1); !(x = S[O]) && ++O < b; ) ;
        A._next = x || null;
      }
  }
  return u = new yn(u, r), u._enter = c, u._exit = l, u;
}
function vL() {
  return new yn(this._exit || this._groups.map(Qv), this._parents);
}
function xL(t) {
  for (var e = this._groups, n = t._groups, r = e.length, a = n.length, o = Math.min(r, a), u = new Array(r), c = 0; c < o; ++c)
    for (var l = e[c], d = n[c], g = l.length, y = u[c] = new Array(g), f, m = 0; m < g; ++m)
      (f = l[m] || d[m]) && (y[m] = f);
  for (; c < r; ++c)
    u[c] = e[c];
  return new yn(u, this._parents);
}
function _L() {
  for (var t = this._groups, e = -1, n = t.length; ++e < n; )
    for (var r = t[e], a = r.length - 1, o = r[a], u; --a >= 0; )
      (u = r[a]) && (o && o !== u.nextSibling && o.parentNode.insertBefore(u, o), o = u);
  return this;
}
function bL(t) {
  t || (t = wL);
  function e(y, f) {
    return y && f ? t(y.__data__, f.__data__) : !y - !f;
  }
  for (var n = this._groups, r = n.length, a = new Array(r), o = 0; o < r; ++o) {
    for (var u = n[o], c = u.length, l = a[o] = new Array(c), d, g = 0; g < c; ++g)
      (d = u[g]) && (l[g] = d);
    l.sort(e);
  }
  return new yn(a, this._parents).order();
}
function wL(t, e) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function EL() {
  var t = arguments[0];
  return arguments[0] = this, t.apply(null, arguments), this;
}
function SL() {
  var t = new Array(this.size()), e = -1;
  return this.each(function() {
    t[++e] = this;
  }), t;
}
function AL() {
  for (var t = this._groups, e = 0, n = t.length; e < n; ++e)
    for (var r = t[e], a = 0, o = r.length; a < o; ++a) {
      var u = r[a];
      if (u) return u;
    }
  return null;
}
function TL() {
  var t = 0;
  return this.each(function() {
    ++t;
  }), t;
}
function CL() {
  return !this.node();
}
function RL(t) {
  for (var e = this._groups, n = 0, r = e.length; n < r; ++n)
    for (var a = e[n], o = 0, u = a.length, c; o < u; ++o)
      (c = a[o]) && t.call(c, c.__data__, o, a);
  return this;
}
function DL(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function ML(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function OL(t, e) {
  return function() {
    this.setAttribute(t, e);
  };
}
function LL(t, e) {
  return function() {
    this.setAttributeNS(t.space, t.local, e);
  };
}
function PL(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? this.removeAttribute(t) : this.setAttribute(t, n);
  };
}
function NL(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, n);
  };
}
function IL(t, e) {
  var n = Bs(t);
  if (arguments.length < 2) {
    var r = this.node();
    return n.local ? r.getAttributeNS(n.space, n.local) : r.getAttribute(n);
  }
  return this.each((e == null ? n.local ? ML : DL : typeof e == "function" ? n.local ? NL : PL : n.local ? LL : OL)(n, e));
}
function vp(t) {
  return t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView;
}
function jL(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function kL(t, e, n) {
  return function() {
    this.style.setProperty(t, e, n);
  };
}
function BL(t, e, n) {
  return function() {
    var r = e.apply(this, arguments);
    r == null ? this.style.removeProperty(t) : this.style.setProperty(t, r, n);
  };
}
function FL(t, e, n) {
  return arguments.length > 1 ? this.each((e == null ? jL : typeof e == "function" ? BL : kL)(t, e, n ?? "")) : Xi(this.node(), t);
}
function Xi(t, e) {
  return t.style.getPropertyValue(e) || vp(t).getComputedStyle(t, null).getPropertyValue(e);
}
function UL(t) {
  return function() {
    delete this[t];
  };
}
function $L(t, e) {
  return function() {
    this[t] = e;
  };
}
function zL(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? delete this[t] : this[t] = n;
  };
}
function VL(t, e) {
  return arguments.length > 1 ? this.each((e == null ? UL : typeof e == "function" ? zL : $L)(t, e)) : this.node()[t];
}
function Kv(t) {
  return t.trim().split(/^|\s+/);
}
function xp(t) {
  return t.classList || new Zv(t);
}
function Zv(t) {
  this._node = t, this._names = Kv(t.getAttribute("class") || "");
}
Zv.prototype = {
  add: function(t) {
    var e = this._names.indexOf(t);
    e < 0 && (this._names.push(t), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function(t) {
    var e = this._names.indexOf(t);
    e >= 0 && (this._names.splice(e, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function(t) {
    return this._names.indexOf(t) >= 0;
  }
};
function Jv(t, e) {
  for (var n = xp(t), r = -1, a = e.length; ++r < a; ) n.add(e[r]);
}
function tx(t, e) {
  for (var n = xp(t), r = -1, a = e.length; ++r < a; ) n.remove(e[r]);
}
function YL(t) {
  return function() {
    Jv(this, t);
  };
}
function WL(t) {
  return function() {
    tx(this, t);
  };
}
function GL(t, e) {
  return function() {
    (e.apply(this, arguments) ? Jv : tx)(this, t);
  };
}
function qL(t, e) {
  var n = Kv(t + "");
  if (arguments.length < 2) {
    for (var r = xp(this.node()), a = -1, o = n.length; ++a < o; ) if (!r.contains(n[a])) return !1;
    return !0;
  }
  return this.each((typeof e == "function" ? GL : e ? YL : WL)(n, e));
}
function HL() {
  this.textContent = "";
}
function XL(t) {
  return function() {
    this.textContent = t;
  };
}
function QL(t) {
  return function() {
    var e = t.apply(this, arguments);
    this.textContent = e ?? "";
  };
}
function KL(t) {
  return arguments.length ? this.each(t == null ? HL : (typeof t == "function" ? QL : XL)(t)) : this.node().textContent;
}
function ZL() {
  this.innerHTML = "";
}
function JL(t) {
  return function() {
    this.innerHTML = t;
  };
}
function tP(t) {
  return function() {
    var e = t.apply(this, arguments);
    this.innerHTML = e ?? "";
  };
}
function eP(t) {
  return arguments.length ? this.each(t == null ? ZL : (typeof t == "function" ? tP : JL)(t)) : this.node().innerHTML;
}
function nP() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function rP() {
  return this.each(nP);
}
function iP() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function aP() {
  return this.each(iP);
}
function oP(t) {
  var e = typeof t == "function" ? t : Sl(t);
  return this.select(function() {
    return this.appendChild(e.apply(this, arguments));
  });
}
function sP() {
  return null;
}
function uP(t, e) {
  var n = typeof t == "function" ? t : Sl(t), r = e == null ? sP : typeof e == "function" ? e : Al(e);
  return this.select(function() {
    return this.insertBefore(n.apply(this, arguments), r.apply(this, arguments) || null);
  });
}
function cP() {
  var t = this.parentNode;
  t && t.removeChild(this);
}
function lP() {
  return this.each(cP);
}
function fP() {
  return this.parentNode.insertBefore(this.cloneNode(!1), this.nextSibling);
}
function hP() {
  return this.parentNode.insertBefore(this.cloneNode(!0), this.nextSibling);
}
function dP(t) {
  return this.select(t ? hP : fP);
}
function pP(t) {
  return arguments.length ? this.property("__data__", t) : this.node().__data__;
}
var ex = {}, St = null;
if (typeof document < "u") {
  var gP = document.documentElement;
  "onmouseenter" in gP || (ex = { mouseenter: "mouseover", mouseleave: "mouseout" });
}
function mP(t, e, n) {
  return t = nx(t, e, n), function(r) {
    var a = r.relatedTarget;
    (!a || a !== this && !(a.compareDocumentPosition(this) & 8)) && t.call(this, r);
  };
}
function nx(t, e, n) {
  return function(r) {
    var a = St;
    St = r;
    try {
      t.call(this, this.__data__, e, n);
    } finally {
      St = a;
    }
  };
}
function yP(t) {
  return t.trim().split(/^|\s+/).map(function(e) {
    var n = "", r = e.indexOf(".");
    return r >= 0 && (n = e.slice(r + 1), e = e.slice(0, r)), { type: e, name: n };
  });
}
function vP(t) {
  return function() {
    var e = this.__on;
    if (e) {
      for (var n = 0, r = -1, a = e.length, o; n < a; ++n)
        o = e[n], (!t.type || o.type === t.type) && o.name === t.name ? this.removeEventListener(o.type, o.listener, o.capture) : e[++r] = o;
      ++r ? e.length = r : delete this.__on;
    }
  };
}
function xP(t, e, n) {
  var r = ex.hasOwnProperty(t.type) ? mP : nx;
  return function(a, o, u) {
    var c = this.__on, l, d = r(e, o, u);
    if (c) {
      for (var g = 0, y = c.length; g < y; ++g)
        if ((l = c[g]).type === t.type && l.name === t.name) {
          this.removeEventListener(l.type, l.listener, l.capture), this.addEventListener(l.type, l.listener = d, l.capture = n), l.value = e;
          return;
        }
    }
    this.addEventListener(t.type, d, n), l = { type: t.type, name: t.name, value: e, listener: d, capture: n }, c ? c.push(l) : this.__on = [l];
  };
}
function _P(t, e, n) {
  var r = yP(t + ""), a, o = r.length, u;
  if (arguments.length < 2) {
    var c = this.node().__on;
    if (c) {
      for (var l = 0, d = c.length, g; l < d; ++l)
        for (a = 0, g = c[l]; a < o; ++a)
          if ((u = r[a]).type === g.type && u.name === g.name)
            return g.value;
    }
    return;
  }
  for (c = e ? xP : vP, n == null && (n = !1), a = 0; a < o; ++a) this.each(c(r[a], e, n));
  return this;
}
function ps(t, e, n, r) {
  var a = St;
  t.sourceEvent = St, St = t;
  try {
    return e.apply(n, r);
  } finally {
    St = a;
  }
}
function rx(t, e, n) {
  var r = vp(t), a = r.CustomEvent;
  typeof a == "function" ? a = new a(e, n) : (a = r.document.createEvent("Event"), n ? (a.initEvent(e, n.bubbles, n.cancelable), a.detail = n.detail) : a.initEvent(e, !1, !1)), t.dispatchEvent(a);
}
function bP(t, e) {
  return function() {
    return rx(this, t, e);
  };
}
function wP(t, e) {
  return function() {
    return rx(this, t, e.apply(this, arguments));
  };
}
function EP(t, e) {
  return this.each((typeof e == "function" ? wP : bP)(t, e));
}
var _p = [null];
function yn(t, e) {
  this._groups = t, this._parents = e;
}
function na() {
  return new yn([[document.documentElement]], _p);
}
yn.prototype = na.prototype = {
  constructor: yn,
  select: uL,
  selectAll: lL,
  filter: hL,
  data: yL,
  enter: dL,
  exit: vL,
  merge: xL,
  order: _L,
  sort: bL,
  call: EL,
  nodes: SL,
  node: AL,
  size: TL,
  empty: CL,
  each: RL,
  attr: IL,
  style: FL,
  property: VL,
  classed: qL,
  text: KL,
  html: eP,
  raise: rP,
  lower: aP,
  append: oP,
  insert: uP,
  remove: lP,
  clone: dP,
  datum: pP,
  on: _P,
  dispatch: EP
};
function Cn(t) {
  return typeof t == "string" ? new yn([[document.querySelector(t)]], [document.documentElement]) : new yn([[t]], _p);
}
function SP(t) {
  return Cn(Sl(t).call(document.documentElement));
}
var AP = 0;
function ix() {
  return new vd();
}
function vd() {
  this._ = "@" + (++AP).toString(36);
}
vd.prototype = ix.prototype = {
  constructor: vd,
  get: function(t) {
    for (var e = this._; !(e in t); ) if (!(t = t.parentNode)) return;
    return t[e];
  },
  set: function(t, e) {
    return t[this._] = e;
  },
  remove: function(t) {
    return this._ in t && delete t[this._];
  },
  toString: function() {
    return this._;
  }
};
function bp() {
  for (var t = St, e; e = t.sourceEvent; ) t = e;
  return t;
}
function Tl(t, e) {
  var n = t.ownerSVGElement || t;
  if (n.createSVGPoint) {
    var r = n.createSVGPoint();
    return r.x = e.clientX, r.y = e.clientY, r = r.matrixTransform(t.getScreenCTM().inverse()), [r.x, r.y];
  }
  var a = t.getBoundingClientRect();
  return [e.clientX - a.left - t.clientLeft, e.clientY - a.top - t.clientTop];
}
function fi(t) {
  var e = bp();
  return e.changedTouches && (e = e.changedTouches[0]), Tl(t, e);
}
function TP(t) {
  return typeof t == "string" ? new yn([document.querySelectorAll(t)], [document.documentElement]) : new yn([t ?? []], _p);
}
function Cc(t, e, n) {
  arguments.length < 3 && (n = e, e = bp().changedTouches);
  for (var r = 0, a = e ? e.length : 0, o; r < a; ++r)
    if ((o = e[r]).identifier === n)
      return Tl(t, o);
  return null;
}
function CP(t, e) {
  e == null && (e = bp().touches);
  for (var n = 0, r = e ? e.length : 0, a = new Array(r); n < r; ++n)
    a[n] = Tl(t, e[n]);
  return a;
}
function Ch() {
  St.stopImmediatePropagation();
}
function Fa() {
  St.preventDefault(), St.stopImmediatePropagation();
}
function Cl(t) {
  var e = t.document.documentElement, n = Cn(t).on("dragstart.drag", Fa, !0);
  "onselectstart" in e ? n.on("selectstart.drag", Fa, !0) : (e.__noselect = e.style.MozUserSelect, e.style.MozUserSelect = "none");
}
function Rl(t, e) {
  var n = t.document.documentElement, r = Cn(t).on("dragstart.drag", null);
  e && (r.on("click.drag", Fa, !0), setTimeout(function() {
    r.on("click.drag", null);
  }, 0)), "onselectstart" in n ? r.on("selectstart.drag", null) : (n.style.MozUserSelect = n.__noselect, delete n.__noselect);
}
function Yu(t) {
  return function() {
    return t;
  };
}
function xd(t, e, n, r, a, o, u, c, l, d) {
  this.target = t, this.type = e, this.subject = n, this.identifier = r, this.active = a, this.x = o, this.y = u, this.dx = c, this.dy = l, this._ = d;
}
xd.prototype.on = function() {
  var t = this._.on.apply(this._, arguments);
  return t === this._ ? this : t;
};
function RP() {
  return !St.button;
}
function DP() {
  return this.parentNode;
}
function MP(t) {
  return t ?? { x: St.x, y: St.y };
}
function OP() {
  return "ontouchstart" in this;
}
function LP() {
  var t = RP, e = DP, n = MP, r = OP, a = {}, o = wi("start", "drag", "end"), u = 0, c, l, d, g, y = 0;
  function f(A) {
    A.on("mousedown.drag", m).filter(r).on("touchstart.drag", S).on("touchmove.drag", M).on("touchend.drag touchcancel.drag", N).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  function m() {
    if (!(g || !t.apply(this, arguments))) {
      var A = O("mouse", e.apply(this, arguments), fi, this, arguments);
      A && (Cn(St.view).on("mousemove.drag", b, !0).on("mouseup.drag", E, !0), Cl(St.view), Ch(), d = !1, c = St.clientX, l = St.clientY, A("start"));
    }
  }
  function b() {
    if (Fa(), !d) {
      var A = St.clientX - c, x = St.clientY - l;
      d = A * A + x * x > y;
    }
    a.mouse("drag");
  }
  function E() {
    Cn(St.view).on("mousemove.drag mouseup.drag", null), Rl(St.view, d), Fa(), a.mouse("end");
  }
  function S() {
    if (t.apply(this, arguments)) {
      var A = St.changedTouches, x = e.apply(this, arguments), v = A.length, w, C;
      for (w = 0; w < v; ++w)
        (C = O(A[w].identifier, x, Cc, this, arguments)) && (Ch(), C("start"));
    }
  }
  function M() {
    var A = St.changedTouches, x = A.length, v, w;
    for (v = 0; v < x; ++v)
      (w = a[A[v].identifier]) && (Fa(), w("drag"));
  }
  function N() {
    var A = St.changedTouches, x = A.length, v, w;
    for (g && clearTimeout(g), g = setTimeout(function() {
      g = null;
    }, 500), v = 0; v < x; ++v)
      (w = a[A[v].identifier]) && (Ch(), w("end"));
  }
  function O(A, x, v, w, C) {
    var P = v(x, A), Y, V, k, T = o.copy();
    if (ps(new xd(f, "beforestart", Y, A, u, P[0], P[1], 0, 0, T), function() {
      return (St.subject = Y = n.apply(w, C)) == null ? !1 : (V = Y.x - P[0] || 0, k = Y.y - P[1] || 0, !0);
    }))
      return function R(F) {
        var U = P, H;
        switch (F) {
          case "start":
            a[A] = R, H = u++;
            break;
          case "end":
            delete a[A], --u;
          case "drag":
            P = v(x, A), H = u;
            break;
        }
        ps(new xd(f, F, Y, A, H, P[0] + V, P[1] + k, P[0] - U[0], P[1] - U[1], T), T.apply, T, [F, w, C]);
      };
  }
  return f.filter = function(A) {
    return arguments.length ? (t = typeof A == "function" ? A : Yu(!!A), f) : t;
  }, f.container = function(A) {
    return arguments.length ? (e = typeof A == "function" ? A : Yu(A), f) : e;
  }, f.subject = function(A) {
    return arguments.length ? (n = typeof A == "function" ? A : Yu(A), f) : n;
  }, f.touchable = function(A) {
    return arguments.length ? (r = typeof A == "function" ? A : Yu(!!A), f) : r;
  }, f.on = function() {
    var A = o.on.apply(o, arguments);
    return A === o ? f : A;
  }, f.clickDistance = function(A) {
    return arguments.length ? (y = (A = +A) * A, f) : Math.sqrt(y);
  }, f;
}
function ao(t, e, n) {
  t.prototype = e.prototype = n, n.constructor = t;
}
function Fs(t, e) {
  var n = Object.create(t.prototype);
  for (var r in e) n[r] = e[r];
  return n;
}
function Ei() {
}
var Qi = 0.7, Ga = 1 / Qi, Ua = "\\s*([+-]?\\d+)\\s*", gs = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", Er = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", PP = /^#([0-9a-f]{3})$/, NP = /^#([0-9a-f]{6})$/, IP = new RegExp("^rgb\\(" + [Ua, Ua, Ua] + "\\)$"), jP = new RegExp("^rgb\\(" + [Er, Er, Er] + "\\)$"), kP = new RegExp("^rgba\\(" + [Ua, Ua, Ua, gs] + "\\)$"), BP = new RegExp("^rgba\\(" + [Er, Er, Er, gs] + "\\)$"), FP = new RegExp("^hsl\\(" + [gs, Er, Er] + "\\)$"), UP = new RegExp("^hsla\\(" + [gs, Er, Er, gs] + "\\)$"), vy = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
ao(Ei, yi, {
  displayable: function() {
    return this.rgb().displayable();
  },
  toString: function() {
    return this.rgb() + "";
  }
});
function yi(t) {
  var e;
  return t = (t + "").trim().toLowerCase(), (e = PP.exec(t)) ? (e = parseInt(e[1], 16), new Xe(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, (e & 15) << 4 | e & 15, 1)) : (e = NP.exec(t)) ? xy(parseInt(e[1], 16)) : (e = IP.exec(t)) ? new Xe(e[1], e[2], e[3], 1) : (e = jP.exec(t)) ? new Xe(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, 1) : (e = kP.exec(t)) ? _y(e[1], e[2], e[3], e[4]) : (e = BP.exec(t)) ? _y(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, e[4]) : (e = FP.exec(t)) ? by(e[1], e[2] / 100, e[3] / 100, 1) : (e = UP.exec(t)) ? by(e[1], e[2] / 100, e[3] / 100, e[4]) : vy.hasOwnProperty(t) ? xy(vy[t]) : t === "transparent" ? new Xe(NaN, NaN, NaN, 0) : null;
}
function xy(t) {
  return new Xe(t >> 16 & 255, t >> 8 & 255, t & 255, 1);
}
function _y(t, e, n, r) {
  return r <= 0 && (t = e = n = NaN), new Xe(t, e, n, r);
}
function wp(t) {
  return t instanceof Ei || (t = yi(t)), t ? (t = t.rgb(), new Xe(t.r, t.g, t.b, t.opacity)) : new Xe();
}
function ms(t, e, n, r) {
  return arguments.length === 1 ? wp(t) : new Xe(t, e, n, r ?? 1);
}
function Xe(t, e, n, r) {
  this.r = +t, this.g = +e, this.b = +n, this.opacity = +r;
}
ao(Xe, ms, Fs(Ei, {
  brighter: function(t) {
    return t = t == null ? Ga : Math.pow(Ga, t), new Xe(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  darker: function(t) {
    return t = t == null ? Qi : Math.pow(Qi, t), new Xe(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return 0 <= this.r && this.r <= 255 && 0 <= this.g && this.g <= 255 && 0 <= this.b && this.b <= 255 && 0 <= this.opacity && this.opacity <= 1;
  },
  toString: function() {
    var t = this.opacity;
    return t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t)), (t === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (t === 1 ? ")" : ", " + t + ")");
  }
}));
function by(t, e, n, r) {
  return r <= 0 ? t = e = n = NaN : n <= 0 || n >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new yr(t, e, n, r);
}
function $P(t) {
  if (t instanceof yr) return new yr(t.h, t.s, t.l, t.opacity);
  if (t instanceof Ei || (t = yi(t)), !t) return new yr();
  if (t instanceof yr) return t;
  t = t.rgb();
  var e = t.r / 255, n = t.g / 255, r = t.b / 255, a = Math.min(e, n, r), o = Math.max(e, n, r), u = NaN, c = o - a, l = (o + a) / 2;
  return c ? (e === o ? u = (n - r) / c + (n < r) * 6 : n === o ? u = (r - e) / c + 2 : u = (e - n) / c + 4, c /= l < 0.5 ? o + a : 2 - o - a, u *= 60) : c = l > 0 && l < 1 ? 0 : u, new yr(u, c, l, t.opacity);
}
function Rc(t, e, n, r) {
  return arguments.length === 1 ? $P(t) : new yr(t, e, n, r ?? 1);
}
function yr(t, e, n, r) {
  this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
}
ao(yr, Rc, Fs(Ei, {
  brighter: function(t) {
    return t = t == null ? Ga : Math.pow(Ga, t), new yr(this.h, this.s, this.l * t, this.opacity);
  },
  darker: function(t) {
    return t = t == null ? Qi : Math.pow(Qi, t), new yr(this.h, this.s, this.l * t, this.opacity);
  },
  rgb: function() {
    var t = this.h % 360 + (this.h < 0) * 360, e = isNaN(t) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * e, a = 2 * n - r;
    return new Xe(
      Rh(t >= 240 ? t - 240 : t + 120, a, r),
      Rh(t, a, r),
      Rh(t < 120 ? t + 240 : t - 120, a, r),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  }
}));
function Rh(t, e, n) {
  return (t < 60 ? e + (n - e) * t / 60 : t < 180 ? n : t < 240 ? e + (n - e) * (240 - t) / 60 : e) * 255;
}
var ax = Math.PI / 180, ox = 180 / Math.PI, Dc = 18, sx = 0.95047, ux = 1, cx = 1.08883, lx = 4 / 29, $a = 6 / 29, fx = 3 * $a * $a, zP = $a * $a * $a;
function Ep(t) {
  if (t instanceof Yr) return new Yr(t.l, t.a, t.b, t.opacity);
  if (t instanceof pi) {
    var e = t.h * ax;
    return new Yr(t.l, Math.cos(e) * t.c, Math.sin(e) * t.c, t.opacity);
  }
  t instanceof Xe || (t = wp(t));
  var n = Lh(t.r), r = Lh(t.g), a = Lh(t.b), o = Dh((0.4124564 * n + 0.3575761 * r + 0.1804375 * a) / sx), u = Dh((0.2126729 * n + 0.7151522 * r + 0.072175 * a) / ux), c = Dh((0.0193339 * n + 0.119192 * r + 0.9503041 * a) / cx);
  return new Yr(116 * u - 16, 500 * (o - u), 200 * (u - c), t.opacity);
}
function Mc(t, e, n, r) {
  return arguments.length === 1 ? Ep(t) : new Yr(t, e, n, r ?? 1);
}
function Yr(t, e, n, r) {
  this.l = +t, this.a = +e, this.b = +n, this.opacity = +r;
}
ao(Yr, Mc, Fs(Ei, {
  brighter: function(t) {
    return new Yr(this.l + Dc * (t ?? 1), this.a, this.b, this.opacity);
  },
  darker: function(t) {
    return new Yr(this.l - Dc * (t ?? 1), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var t = (this.l + 16) / 116, e = isNaN(this.a) ? t : t + this.a / 500, n = isNaN(this.b) ? t : t - this.b / 200;
    return t = ux * Mh(t), e = sx * Mh(e), n = cx * Mh(n), new Xe(
      Oh(3.2404542 * e - 1.5371385 * t - 0.4985314 * n),
      // D65 -> sRGB
      Oh(-0.969266 * e + 1.8760108 * t + 0.041556 * n),
      Oh(0.0556434 * e - 0.2040259 * t + 1.0572252 * n),
      this.opacity
    );
  }
}));
function Dh(t) {
  return t > zP ? Math.pow(t, 1 / 3) : t / fx + lx;
}
function Mh(t) {
  return t > $a ? t * t * t : fx * (t - lx);
}
function Oh(t) {
  return 255 * (t <= 31308e-7 ? 12.92 * t : 1.055 * Math.pow(t, 1 / 2.4) - 0.055);
}
function Lh(t) {
  return (t /= 255) <= 0.04045 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
}
function VP(t) {
  if (t instanceof pi) return new pi(t.h, t.c, t.l, t.opacity);
  t instanceof Yr || (t = Ep(t));
  var e = Math.atan2(t.b, t.a) * ox;
  return new pi(e < 0 ? e + 360 : e, Math.sqrt(t.a * t.a + t.b * t.b), t.l, t.opacity);
}
function Oc(t, e, n, r) {
  return arguments.length === 1 ? VP(t) : new pi(t, e, n, r ?? 1);
}
function pi(t, e, n, r) {
  this.h = +t, this.c = +e, this.l = +n, this.opacity = +r;
}
ao(pi, Oc, Fs(Ei, {
  brighter: function(t) {
    return new pi(this.h, this.c, this.l + Dc * (t ?? 1), this.opacity);
  },
  darker: function(t) {
    return new pi(this.h, this.c, this.l - Dc * (t ?? 1), this.opacity);
  },
  rgb: function() {
    return Ep(this).rgb();
  }
}));
var hx = -0.14861, Sp = 1.78277, Ap = -0.29227, Dl = -0.90649, ys = 1.97294, wy = ys * Dl, Ey = ys * Sp, Sy = Sp * Ap - Dl * hx;
function YP(t) {
  if (t instanceof Yi) return new Yi(t.h, t.s, t.l, t.opacity);
  t instanceof Xe || (t = wp(t));
  var e = t.r / 255, n = t.g / 255, r = t.b / 255, a = (Sy * r + wy * e - Ey * n) / (Sy + wy - Ey), o = r - a, u = (ys * (n - a) - Ap * o) / Dl, c = Math.sqrt(u * u + o * o) / (ys * a * (1 - a)), l = c ? Math.atan2(u, o) * ox - 120 : NaN;
  return new Yi(l < 0 ? l + 360 : l, c, a, t.opacity);
}
function cr(t, e, n, r) {
  return arguments.length === 1 ? YP(t) : new Yi(t, e, n, r ?? 1);
}
function Yi(t, e, n, r) {
  this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
}
ao(Yi, cr, Fs(Ei, {
  brighter: function(t) {
    return t = t == null ? Ga : Math.pow(Ga, t), new Yi(this.h, this.s, this.l * t, this.opacity);
  },
  darker: function(t) {
    return t = t == null ? Qi : Math.pow(Qi, t), new Yi(this.h, this.s, this.l * t, this.opacity);
  },
  rgb: function() {
    var t = isNaN(this.h) ? 0 : (this.h + 120) * ax, e = +this.l, n = isNaN(this.s) ? 0 : this.s * e * (1 - e), r = Math.cos(t), a = Math.sin(t);
    return new Xe(
      255 * (e + n * (hx * r + Sp * a)),
      255 * (e + n * (Ap * r + Dl * a)),
      255 * (e + n * (ys * r)),
      this.opacity
    );
  }
}));
function dx(t, e, n, r, a) {
  var o = t * t, u = o * t;
  return ((1 - 3 * t + 3 * o - u) * e + (4 - 6 * o + 3 * u) * n + (1 + 3 * t + 3 * o - 3 * u) * r + u * a) / 6;
}
function px(t) {
  var e = t.length - 1;
  return function(n) {
    var r = n <= 0 ? n = 0 : n >= 1 ? (n = 1, e - 1) : Math.floor(n * e), a = t[r], o = t[r + 1], u = r > 0 ? t[r - 1] : 2 * a - o, c = r < e - 1 ? t[r + 2] : 2 * o - a;
    return dx((n - r / e) * e, u, a, o, c);
  };
}
function gx(t) {
  var e = t.length;
  return function(n) {
    var r = Math.floor(((n %= 1) < 0 ? ++n : n) * e), a = t[(r + e - 1) % e], o = t[r % e], u = t[(r + 1) % e], c = t[(r + 2) % e];
    return dx((n - r / e) * e, a, o, u, c);
  };
}
function Ml(t) {
  return function() {
    return t;
  };
}
function mx(t, e) {
  return function(n) {
    return t + n * e;
  };
}
function WP(t, e, n) {
  return t = Math.pow(t, n), e = Math.pow(e, n) - t, n = 1 / n, function(r) {
    return Math.pow(t + r * e, n);
  };
}
function Tp(t, e) {
  var n = e - t;
  return n ? mx(t, n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n) : Ml(isNaN(t) ? e : t);
}
function GP(t) {
  return (t = +t) == 1 ? We : function(e, n) {
    return n - e ? WP(e, n, t) : Ml(isNaN(e) ? n : e);
  };
}
function We(t, e) {
  var n = e - t;
  return n ? mx(t, n) : Ml(isNaN(t) ? e : t);
}
const vs = function t(e) {
  var n = GP(e);
  function r(a, o) {
    var u = n((a = ms(a)).r, (o = ms(o)).r), c = n(a.g, o.g), l = n(a.b, o.b), d = We(a.opacity, o.opacity);
    return function(g) {
      return a.r = u(g), a.g = c(g), a.b = l(g), a.opacity = d(g), a + "";
    };
  }
  return r.gamma = t, r;
}(1);
function yx(t) {
  return function(e) {
    var n = e.length, r = new Array(n), a = new Array(n), o = new Array(n), u, c;
    for (u = 0; u < n; ++u)
      c = ms(e[u]), r[u] = c.r || 0, a[u] = c.g || 0, o[u] = c.b || 0;
    return r = t(r), a = t(a), o = t(o), c.opacity = 1, function(l) {
      return c.r = r(l), c.g = a(l), c.b = o(l), c + "";
    };
  };
}
var qP = yx(px), HP = yx(gx);
function vx(t, e) {
  var n = e ? e.length : 0, r = t ? Math.min(n, t.length) : 0, a = new Array(r), o = new Array(n), u;
  for (u = 0; u < r; ++u) a[u] = Us(t[u], e[u]);
  for (; u < n; ++u) o[u] = e[u];
  return function(c) {
    for (u = 0; u < r; ++u) o[u] = a[u](c);
    return o;
  };
}
function xx(t, e) {
  var n = /* @__PURE__ */ new Date();
  return t = +t, e -= t, function(r) {
    return n.setTime(t + e * r), n;
  };
}
function jn(t, e) {
  return t = +t, e -= t, function(n) {
    return t + e * n;
  };
}
function _x(t, e) {
  var n = {}, r = {}, a;
  (t === null || typeof t != "object") && (t = {}), (e === null || typeof e != "object") && (e = {});
  for (a in e)
    a in t ? n[a] = Us(t[a], e[a]) : r[a] = e[a];
  return function(o) {
    for (a in n) r[a] = n[a](o);
    return r;
  };
}
var _d = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Ph = new RegExp(_d.source, "g");
function XP(t) {
  return function() {
    return t;
  };
}
function QP(t) {
  return function(e) {
    return t(e) + "";
  };
}
function Cp(t, e) {
  var n = _d.lastIndex = Ph.lastIndex = 0, r, a, o, u = -1, c = [], l = [];
  for (t = t + "", e = e + ""; (r = _d.exec(t)) && (a = Ph.exec(e)); )
    (o = a.index) > n && (o = e.slice(n, o), c[u] ? c[u] += o : c[++u] = o), (r = r[0]) === (a = a[0]) ? c[u] ? c[u] += a : c[++u] = a : (c[++u] = null, l.push({ i: u, x: jn(r, a) })), n = Ph.lastIndex;
  return n < e.length && (o = e.slice(n), c[u] ? c[u] += o : c[++u] = o), c.length < 2 ? l[0] ? QP(l[0].x) : XP(e) : (e = l.length, function(d) {
    for (var g = 0, y; g < e; ++g) c[(y = l[g]).i] = y.x(d);
    return c.join("");
  });
}
function Us(t, e) {
  var n = typeof e, r;
  return e == null || n === "boolean" ? Ml(e) : (n === "number" ? jn : n === "string" ? (r = yi(e)) ? (e = r, vs) : Cp : e instanceof yi ? vs : e instanceof Date ? xx : Array.isArray(e) ? vx : typeof e.valueOf != "function" && typeof e.toString != "function" || isNaN(e) ? _x : jn)(t, e);
}
function bx(t, e) {
  return t = +t, e -= t, function(n) {
    return Math.round(t + e * n);
  };
}
var Ay = 180 / Math.PI, bd = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function wx(t, e, n, r, a, o) {
  var u, c, l;
  return (u = Math.sqrt(t * t + e * e)) && (t /= u, e /= u), (l = t * n + e * r) && (n -= t * l, r -= e * l), (c = Math.sqrt(n * n + r * r)) && (n /= c, r /= c, l /= c), t * r < e * n && (t = -t, e = -e, l = -l, u = -u), {
    translateX: a,
    translateY: o,
    rotate: Math.atan2(e, t) * Ay,
    skewX: Math.atan(l) * Ay,
    scaleX: u,
    scaleY: c
  };
}
var Mo, Nh, Ty, Wu;
function KP(t) {
  return t === "none" ? bd : (Mo || (Mo = document.createElement("DIV"), Nh = document.documentElement, Ty = document.defaultView), Mo.style.transform = t, t = Ty.getComputedStyle(Nh.appendChild(Mo), null).getPropertyValue("transform"), Nh.removeChild(Mo), t = t.slice(7, -1).split(","), wx(+t[0], +t[1], +t[2], +t[3], +t[4], +t[5]));
}
function ZP(t) {
  return t == null || (Wu || (Wu = document.createElementNS("http://www.w3.org/2000/svg", "g")), Wu.setAttribute("transform", t), !(t = Wu.transform.baseVal.consolidate())) ? bd : (t = t.matrix, wx(t.a, t.b, t.c, t.d, t.e, t.f));
}
function Ex(t, e, n, r) {
  function a(d) {
    return d.length ? d.pop() + " " : "";
  }
  function o(d, g, y, f, m, b) {
    if (d !== y || g !== f) {
      var E = m.push("translate(", null, e, null, n);
      b.push({ i: E - 4, x: jn(d, y) }, { i: E - 2, x: jn(g, f) });
    } else (y || f) && m.push("translate(" + y + e + f + n);
  }
  function u(d, g, y, f) {
    d !== g ? (d - g > 180 ? g += 360 : g - d > 180 && (d += 360), f.push({ i: y.push(a(y) + "rotate(", null, r) - 2, x: jn(d, g) })) : g && y.push(a(y) + "rotate(" + g + r);
  }
  function c(d, g, y, f) {
    d !== g ? f.push({ i: y.push(a(y) + "skewX(", null, r) - 2, x: jn(d, g) }) : g && y.push(a(y) + "skewX(" + g + r);
  }
  function l(d, g, y, f, m, b) {
    if (d !== y || g !== f) {
      var E = m.push(a(m) + "scale(", null, ",", null, ")");
      b.push({ i: E - 4, x: jn(d, y) }, { i: E - 2, x: jn(g, f) });
    } else (y !== 1 || f !== 1) && m.push(a(m) + "scale(" + y + "," + f + ")");
  }
  return function(d, g) {
    var y = [], f = [];
    return d = t(d), g = t(g), o(d.translateX, d.translateY, g.translateX, g.translateY, y, f), u(d.rotate, g.rotate, y, f), c(d.skewX, g.skewX, y, f), l(d.scaleX, d.scaleY, g.scaleX, g.scaleY, y, f), d = g = null, function(m) {
      for (var b = -1, E = f.length, S; ++b < E; ) y[(S = f[b]).i] = S.x(m);
      return y.join("");
    };
  };
}
var Sx = Ex(KP, "px, ", "px)", "deg)"), Ax = Ex(ZP, ", ", ")", ")"), Oo = Math.SQRT2, Ih = 2, Cy = 4, JP = 1e-12;
function Ry(t) {
  return ((t = Math.exp(t)) + 1 / t) / 2;
}
function tN(t) {
  return ((t = Math.exp(t)) - 1 / t) / 2;
}
function eN(t) {
  return ((t = Math.exp(2 * t)) - 1) / (t + 1);
}
function Tx(t, e) {
  var n = t[0], r = t[1], a = t[2], o = e[0], u = e[1], c = e[2], l = o - n, d = u - r, g = l * l + d * d, y, f;
  if (g < JP)
    f = Math.log(c / a) / Oo, y = function(N) {
      return [
        n + N * l,
        r + N * d,
        a * Math.exp(Oo * N * f)
      ];
    };
  else {
    var m = Math.sqrt(g), b = (c * c - a * a + Cy * g) / (2 * a * Ih * m), E = (c * c - a * a - Cy * g) / (2 * c * Ih * m), S = Math.log(Math.sqrt(b * b + 1) - b), M = Math.log(Math.sqrt(E * E + 1) - E);
    f = (M - S) / Oo, y = function(N) {
      var O = N * f, A = Ry(S), x = a / (Ih * m) * (A * eN(Oo * O + S) - tN(S));
      return [
        n + x * l,
        r + x * d,
        a * A / Ry(Oo * O + S)
      ];
    };
  }
  return y.duration = f * 1e3, y;
}
function Cx(t) {
  return function(e, n) {
    var r = t((e = Rc(e)).h, (n = Rc(n)).h), a = We(e.s, n.s), o = We(e.l, n.l), u = We(e.opacity, n.opacity);
    return function(c) {
      return e.h = r(c), e.s = a(c), e.l = o(c), e.opacity = u(c), e + "";
    };
  };
}
const nN = Cx(Tp);
var rN = Cx(We);
function iN(t, e) {
  var n = We((t = Mc(t)).l, (e = Mc(e)).l), r = We(t.a, e.a), a = We(t.b, e.b), o = We(t.opacity, e.opacity);
  return function(u) {
    return t.l = n(u), t.a = r(u), t.b = a(u), t.opacity = o(u), t + "";
  };
}
function Rx(t) {
  return function(e, n) {
    var r = t((e = Oc(e)).h, (n = Oc(n)).h), a = We(e.c, n.c), o = We(e.l, n.l), u = We(e.opacity, n.opacity);
    return function(c) {
      return e.h = r(c), e.c = a(c), e.l = o(c), e.opacity = u(c), e + "";
    };
  };
}
const aN = Rx(Tp);
var oN = Rx(We);
function Dx(t) {
  return function e(n) {
    n = +n;
    function r(a, o) {
      var u = t((a = cr(a)).h, (o = cr(o)).h), c = We(a.s, o.s), l = We(a.l, o.l), d = We(a.opacity, o.opacity);
      return function(g) {
        return a.h = u(g), a.s = c(g), a.l = l(Math.pow(g, n)), a.opacity = d(g), a + "";
      };
    }
    return r.gamma = e, r;
  }(1);
}
const sN = Dx(Tp);
var Ol = Dx(We);
function uN(t, e) {
  for (var n = new Array(e), r = 0; r < e; ++r) n[r] = t(r / (e - 1));
  return n;
}
var qa = 0, zo = 0, Lo = 0, Mx = 1e3, Lc, Vo, Pc = 0, Ki = 0, Ll = 0, xs = typeof performance == "object" && performance.now ? performance : Date, Ox = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(t) {
  setTimeout(t, 17);
};
function oo() {
  return Ki || (Ox(cN), Ki = xs.now() + Ll);
}
function cN() {
  Ki = 0;
}
function _s() {
  this._call = this._time = this._next = null;
}
_s.prototype = Pl.prototype = {
  constructor: _s,
  restart: function(t, e, n) {
    if (typeof t != "function") throw new TypeError("callback is not a function");
    n = (n == null ? oo() : +n) + (e == null ? 0 : +e), !this._next && Vo !== this && (Vo ? Vo._next = this : Lc = this, Vo = this), this._call = t, this._time = n, wd();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, wd());
  }
};
function Pl(t, e, n) {
  var r = new _s();
  return r.restart(t, e, n), r;
}
function Lx() {
  oo(), ++qa;
  for (var t = Lc, e; t; )
    (e = Ki - t._time) >= 0 && t._call.call(null, e), t = t._next;
  --qa;
}
function Dy() {
  Ki = (Pc = xs.now()) + Ll, qa = zo = 0;
  try {
    Lx();
  } finally {
    qa = 0, fN(), Ki = 0;
  }
}
function lN() {
  var t = xs.now(), e = t - Pc;
  e > Mx && (Ll -= e, Pc = t);
}
function fN() {
  for (var t, e = Lc, n, r = 1 / 0; e; )
    e._call ? (r > e._time && (r = e._time), t = e, e = e._next) : (n = e._next, e._next = null, e = t ? t._next = n : Lc = n);
  Vo = t, wd(r);
}
function wd(t) {
  if (!qa) {
    zo && (zo = clearTimeout(zo));
    var e = t - Ki;
    e > 24 ? (t < 1 / 0 && (zo = setTimeout(Dy, t - xs.now() - Ll)), Lo && (Lo = clearInterval(Lo))) : (Lo || (Pc = xs.now(), Lo = setInterval(lN, Mx)), qa = 1, Ox(Dy));
  }
}
function Ed(t, e, n) {
  var r = new _s();
  return e = e == null ? 0 : +e, r.restart(function(a) {
    r.stop(), t(a + e);
  }, e, n), r;
}
function hN(t, e, n) {
  var r = new _s(), a = e;
  return e == null ? (r.restart(t, e, n), r) : (e = +e, n = n == null ? oo() : +n, r.restart(function o(u) {
    u += a, r.restart(o, a += e, n), t(u);
  }, e, n), r);
}
var dN = wi("start", "end", "interrupt"), pN = [], Px = 0, Sd = 1, Nc = 2, jh = 3, My = 4, Ad = 5, mc = 6;
function Nl(t, e, n, r, a, o) {
  var u = t.__transition;
  if (!u) t.__transition = {};
  else if (n in u) return;
  gN(t, n, {
    name: e,
    index: r,
    // For context during callback.
    group: a,
    // For context during callback.
    on: dN,
    tween: pN,
    time: o.time,
    delay: o.delay,
    duration: o.duration,
    ease: o.ease,
    timer: null,
    state: Px
  });
}
function Rp(t, e) {
  var n = fr(t, e);
  if (n.state > Px) throw new Error("too late; already scheduled");
  return n;
}
function ra(t, e) {
  var n = fr(t, e);
  if (n.state > Nc) throw new Error("too late; already started");
  return n;
}
function fr(t, e) {
  var n = t.__transition;
  if (!n || !(n = n[e])) throw new Error("transition not found");
  return n;
}
function gN(t, e, n) {
  var r = t.__transition, a;
  r[e] = n, n.timer = Pl(o, 0, n.time);
  function o(d) {
    n.state = Sd, n.timer.restart(u, n.delay, n.time), n.delay <= d && u(d - n.delay);
  }
  function u(d) {
    var g, y, f, m;
    if (n.state !== Sd) return l();
    for (g in r)
      if (m = r[g], m.name === n.name) {
        if (m.state === jh) return Ed(u);
        m.state === My ? (m.state = mc, m.timer.stop(), m.on.call("interrupt", t, t.__data__, m.index, m.group), delete r[g]) : +g < e && (m.state = mc, m.timer.stop(), delete r[g]);
      }
    if (Ed(function() {
      n.state === jh && (n.state = My, n.timer.restart(c, n.delay, n.time), c(d));
    }), n.state = Nc, n.on.call("start", t, t.__data__, n.index, n.group), n.state === Nc) {
      for (n.state = jh, a = new Array(f = n.tween.length), g = 0, y = -1; g < f; ++g)
        (m = n.tween[g].value.call(t, t.__data__, n.index, n.group)) && (a[++y] = m);
      a.length = y + 1;
    }
  }
  function c(d) {
    for (var g = d < n.duration ? n.ease.call(null, d / n.duration) : (n.timer.restart(l), n.state = Ad, 1), y = -1, f = a.length; ++y < f; )
      a[y].call(null, g);
    n.state === Ad && (n.on.call("end", t, t.__data__, n.index, n.group), l());
  }
  function l() {
    n.state = mc, n.timer.stop(), delete r[e];
    for (var d in r) return;
    delete t.__transition;
  }
}
function Wi(t, e) {
  var n = t.__transition, r, a, o = !0, u;
  if (n) {
    e = e == null ? null : e + "";
    for (u in n) {
      if ((r = n[u]).name !== e) {
        o = !1;
        continue;
      }
      a = r.state > Nc && r.state < Ad, r.state = mc, r.timer.stop(), a && r.on.call("interrupt", t, t.__data__, r.index, r.group), delete n[u];
    }
    o && delete t.__transition;
  }
}
function mN(t) {
  return this.each(function() {
    Wi(this, t);
  });
}
function yN(t, e) {
  var n, r;
  return function() {
    var a = ra(this, t), o = a.tween;
    if (o !== n) {
      r = n = o;
      for (var u = 0, c = r.length; u < c; ++u)
        if (r[u].name === e) {
          r = r.slice(), r.splice(u, 1);
          break;
        }
    }
    a.tween = r;
  };
}
function vN(t, e, n) {
  var r, a;
  if (typeof n != "function") throw new Error();
  return function() {
    var o = ra(this, t), u = o.tween;
    if (u !== r) {
      a = (r = u).slice();
      for (var c = { name: e, value: n }, l = 0, d = a.length; l < d; ++l)
        if (a[l].name === e) {
          a[l] = c;
          break;
        }
      l === d && a.push(c);
    }
    o.tween = a;
  };
}
function xN(t, e) {
  var n = this._id;
  if (t += "", arguments.length < 2) {
    for (var r = fr(this.node(), n).tween, a = 0, o = r.length, u; a < o; ++a)
      if ((u = r[a]).name === t)
        return u.value;
    return null;
  }
  return this.each((e == null ? yN : vN)(n, t, e));
}
function Dp(t, e, n) {
  var r = t._id;
  return t.each(function() {
    var a = ra(this, r);
    (a.value || (a.value = {}))[e] = n.apply(this, arguments);
  }), function(a) {
    return fr(a, r).value[e];
  };
}
function Nx(t, e) {
  var n;
  return (typeof e == "number" ? jn : e instanceof yi ? vs : (n = yi(e)) ? (e = n, vs) : Cp)(t, e);
}
function _N(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function bN(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function wN(t, e, n) {
  var r, a;
  return function() {
    var o = this.getAttribute(t);
    return o === n ? null : o === r ? a : a = e(r = o, n);
  };
}
function EN(t, e, n) {
  var r, a;
  return function() {
    var o = this.getAttributeNS(t.space, t.local);
    return o === n ? null : o === r ? a : a = e(r = o, n);
  };
}
function SN(t, e, n) {
  var r, a, o;
  return function() {
    var u, c = n(this);
    return c == null ? void this.removeAttribute(t) : (u = this.getAttribute(t), u === c ? null : u === r && c === a ? o : o = e(r = u, a = c));
  };
}
function AN(t, e, n) {
  var r, a, o;
  return function() {
    var u, c = n(this);
    return c == null ? void this.removeAttributeNS(t.space, t.local) : (u = this.getAttributeNS(t.space, t.local), u === c ? null : u === r && c === a ? o : o = e(r = u, a = c));
  };
}
function TN(t, e) {
  var n = Bs(t), r = n === "transform" ? Ax : Nx;
  return this.attrTween(t, typeof e == "function" ? (n.local ? AN : SN)(n, r, Dp(this, "attr." + t, e)) : e == null ? (n.local ? bN : _N)(n) : (n.local ? EN : wN)(n, r, e + ""));
}
function CN(t, e) {
  function n() {
    var r = this, a = e.apply(r, arguments);
    return a && function(o) {
      r.setAttributeNS(t.space, t.local, a(o));
    };
  }
  return n._value = e, n;
}
function RN(t, e) {
  function n() {
    var r = this, a = e.apply(r, arguments);
    return a && function(o) {
      r.setAttribute(t, a(o));
    };
  }
  return n._value = e, n;
}
function DN(t, e) {
  var n = "attr." + t;
  if (arguments.length < 2) return (n = this.tween(n)) && n._value;
  if (e == null) return this.tween(n, null);
  if (typeof e != "function") throw new Error();
  var r = Bs(t);
  return this.tween(n, (r.local ? CN : RN)(r, e));
}
function MN(t, e) {
  return function() {
    Rp(this, t).delay = +e.apply(this, arguments);
  };
}
function ON(t, e) {
  return e = +e, function() {
    Rp(this, t).delay = e;
  };
}
function LN(t) {
  var e = this._id;
  return arguments.length ? this.each((typeof t == "function" ? MN : ON)(e, t)) : fr(this.node(), e).delay;
}
function PN(t, e) {
  return function() {
    ra(this, t).duration = +e.apply(this, arguments);
  };
}
function NN(t, e) {
  return e = +e, function() {
    ra(this, t).duration = e;
  };
}
function IN(t) {
  var e = this._id;
  return arguments.length ? this.each((typeof t == "function" ? PN : NN)(e, t)) : fr(this.node(), e).duration;
}
function jN(t, e) {
  if (typeof e != "function") throw new Error();
  return function() {
    ra(this, t).ease = e;
  };
}
function kN(t) {
  var e = this._id;
  return arguments.length ? this.each(jN(e, t)) : fr(this.node(), e).ease;
}
function BN(t) {
  typeof t != "function" && (t = yp(t));
  for (var e = this._groups, n = e.length, r = new Array(n), a = 0; a < n; ++a)
    for (var o = e[a], u = o.length, c = r[a] = [], l, d = 0; d < u; ++d)
      (l = o[d]) && t.call(l, l.__data__, d, o) && c.push(l);
  return new Tr(r, this._parents, this._name, this._id);
}
function FN(t) {
  if (t._id !== this._id) throw new Error();
  for (var e = this._groups, n = t._groups, r = e.length, a = n.length, o = Math.min(r, a), u = new Array(r), c = 0; c < o; ++c)
    for (var l = e[c], d = n[c], g = l.length, y = u[c] = new Array(g), f, m = 0; m < g; ++m)
      (f = l[m] || d[m]) && (y[m] = f);
  for (; c < r; ++c)
    u[c] = e[c];
  return new Tr(u, this._parents, this._name, this._id);
}
function UN(t) {
  return (t + "").trim().split(/^|\s+/).every(function(e) {
    var n = e.indexOf(".");
    return n >= 0 && (e = e.slice(0, n)), !e || e === "start";
  });
}
function $N(t, e, n) {
  var r, a, o = UN(e) ? Rp : ra;
  return function() {
    var u = o(this, t), c = u.on;
    c !== r && (a = (r = c).copy()).on(e, n), u.on = a;
  };
}
function zN(t, e) {
  var n = this._id;
  return arguments.length < 2 ? fr(this.node(), n).on.on(t) : this.each($N(n, t, e));
}
function VN(t) {
  return function() {
    var e = this.parentNode;
    for (var n in this.__transition) if (+n !== t) return;
    e && e.removeChild(this);
  };
}
function YN() {
  return this.on("end.remove", VN(this._id));
}
function WN(t) {
  var e = this._name, n = this._id;
  typeof t != "function" && (t = Al(t));
  for (var r = this._groups, a = r.length, o = new Array(a), u = 0; u < a; ++u)
    for (var c = r[u], l = c.length, d = o[u] = new Array(l), g, y, f = 0; f < l; ++f)
      (g = c[f]) && (y = t.call(g, g.__data__, f, c)) && ("__data__" in g && (y.__data__ = g.__data__), d[f] = y, Nl(d[f], e, n, f, d, fr(g, n)));
  return new Tr(o, this._parents, e, n);
}
function GN(t) {
  var e = this._name, n = this._id;
  typeof t != "function" && (t = mp(t));
  for (var r = this._groups, a = r.length, o = [], u = [], c = 0; c < a; ++c)
    for (var l = r[c], d = l.length, g, y = 0; y < d; ++y)
      if (g = l[y]) {
        for (var f = t.call(g, g.__data__, y, l), m, b = fr(g, n), E = 0, S = f.length; E < S; ++E)
          (m = f[E]) && Nl(m, e, n, E, f, b);
        o.push(f), u.push(g);
      }
  return new Tr(o, u, e, n);
}
var qN = na.prototype.constructor;
function HN() {
  return new qN(this._groups, this._parents);
}
function XN(t, e) {
  var n, r, a;
  return function() {
    var o = Xi(this, t), u = (this.style.removeProperty(t), Xi(this, t));
    return o === u ? null : o === n && u === r ? a : a = e(n = o, r = u);
  };
}
function QN(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function KN(t, e, n) {
  var r, a;
  return function() {
    var o = Xi(this, t);
    return o === n ? null : o === r ? a : a = e(r = o, n);
  };
}
function ZN(t, e, n) {
  var r, a, o;
  return function() {
    var u = Xi(this, t), c = n(this);
    return c == null && (c = (this.style.removeProperty(t), Xi(this, t))), u === c ? null : u === r && c === a ? o : o = e(r = u, a = c);
  };
}
function JN(t, e, n) {
  var r = (t += "") == "transform" ? Sx : Nx;
  return e == null ? this.styleTween(t, XN(t, r)).on("end.style." + t, QN(t)) : this.styleTween(t, typeof e == "function" ? ZN(t, r, Dp(this, "style." + t, e)) : KN(t, r, e + ""), n);
}
function tI(t, e, n) {
  function r() {
    var a = this, o = e.apply(a, arguments);
    return o && function(u) {
      a.style.setProperty(t, o(u), n);
    };
  }
  return r._value = e, r;
}
function eI(t, e, n) {
  var r = "style." + (t += "");
  if (arguments.length < 2) return (r = this.tween(r)) && r._value;
  if (e == null) return this.tween(r, null);
  if (typeof e != "function") throw new Error();
  return this.tween(r, tI(t, e, n ?? ""));
}
function nI(t) {
  return function() {
    this.textContent = t;
  };
}
function rI(t) {
  return function() {
    var e = t(this);
    this.textContent = e ?? "";
  };
}
function iI(t) {
  return this.tween("text", typeof t == "function" ? rI(Dp(this, "text", t)) : nI(t == null ? "" : t + ""));
}
function aI() {
  for (var t = this._name, e = this._id, n = jx(), r = this._groups, a = r.length, o = 0; o < a; ++o)
    for (var u = r[o], c = u.length, l, d = 0; d < c; ++d)
      if (l = u[d]) {
        var g = fr(l, e);
        Nl(l, t, n, d, u, {
          time: g.time + g.delay + g.duration,
          delay: 0,
          duration: g.duration,
          ease: g.ease
        });
      }
  return new Tr(r, this._parents, t, n);
}
var oI = 0;
function Tr(t, e, n, r) {
  this._groups = t, this._parents = e, this._name = n, this._id = r;
}
function Ix(t) {
  return na().transition(t);
}
function jx() {
  return ++oI;
}
var Ea = na.prototype;
Tr.prototype = Ix.prototype = {
  constructor: Tr,
  select: WN,
  selectAll: GN,
  filter: BN,
  merge: FN,
  selection: HN,
  transition: aI,
  call: Ea.call,
  nodes: Ea.nodes,
  node: Ea.node,
  size: Ea.size,
  empty: Ea.empty,
  each: Ea.each,
  on: zN,
  attr: TN,
  attrTween: DN,
  style: JN,
  styleTween: eI,
  text: iI,
  remove: YN,
  tween: xN,
  delay: LN,
  duration: IN,
  ease: kN
};
function sI(t) {
  return +t;
}
function uI(t) {
  return t * t;
}
function cI(t) {
  return t * (2 - t);
}
function Oy(t) {
  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}
function lI(t) {
  return t * t * t;
}
function fI(t) {
  return --t * t * t + 1;
}
function Td(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}
var Mp = 3, hI = function t(e) {
  e = +e;
  function n(r) {
    return Math.pow(r, e);
  }
  return n.exponent = t, n;
}(Mp), dI = function t(e) {
  e = +e;
  function n(r) {
    return 1 - Math.pow(1 - r, e);
  }
  return n.exponent = t, n;
}(Mp), Ly = function t(e) {
  e = +e;
  function n(r) {
    return ((r *= 2) <= 1 ? Math.pow(r, e) : 2 - Math.pow(2 - r, e)) / 2;
  }
  return n.exponent = t, n;
}(Mp), kx = Math.PI, Bx = kx / 2;
function pI(t) {
  return 1 - Math.cos(t * Bx);
}
function gI(t) {
  return Math.sin(t * Bx);
}
function Py(t) {
  return (1 - Math.cos(kx * t)) / 2;
}
function mI(t) {
  return Math.pow(2, 10 * t - 10);
}
function yI(t) {
  return 1 - Math.pow(2, -10 * t);
}
function Ny(t) {
  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
}
function vI(t) {
  return 1 - Math.sqrt(1 - t * t);
}
function xI(t) {
  return Math.sqrt(1 - --t * t);
}
function Iy(t) {
  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}
var Cd = 4 / 11, _I = 6 / 11, bI = 8 / 11, wI = 3 / 4, EI = 9 / 11, SI = 10 / 11, AI = 15 / 16, TI = 21 / 22, CI = 63 / 64, Gu = 1 / Cd / Cd;
function RI(t) {
  return 1 - bs(1 - t);
}
function bs(t) {
  return (t = +t) < Cd ? Gu * t * t : t < bI ? Gu * (t -= _I) * t + wI : t < SI ? Gu * (t -= EI) * t + AI : Gu * (t -= TI) * t + CI;
}
function DI(t) {
  return ((t *= 2) <= 1 ? 1 - bs(1 - t) : bs(t - 1) + 1) / 2;
}
var Op = 1.70158, MI = function t(e) {
  e = +e;
  function n(r) {
    return r * r * ((e + 1) * r - e);
  }
  return n.overshoot = t, n;
}(Op), OI = function t(e) {
  e = +e;
  function n(r) {
    return --r * r * ((e + 1) * r + e) + 1;
  }
  return n.overshoot = t, n;
}(Op), jy = function t(e) {
  e = +e;
  function n(r) {
    return ((r *= 2) < 1 ? r * r * ((e + 1) * r - e) : (r -= 2) * r * ((e + 1) * r + e) + 2) / 2;
  }
  return n.overshoot = t, n;
}(Op), Ha = 2 * Math.PI, Lp = 1, Pp = 0.3, LI = function t(e, n) {
  var r = Math.asin(1 / (e = Math.max(1, e))) * (n /= Ha);
  function a(o) {
    return e * Math.pow(2, 10 * --o) * Math.sin((r - o) / n);
  }
  return a.amplitude = function(o) {
    return t(o, n * Ha);
  }, a.period = function(o) {
    return t(e, o);
  }, a;
}(Lp, Pp), ky = function t(e, n) {
  var r = Math.asin(1 / (e = Math.max(1, e))) * (n /= Ha);
  function a(o) {
    return 1 - e * Math.pow(2, -10 * (o = +o)) * Math.sin((o + r) / n);
  }
  return a.amplitude = function(o) {
    return t(o, n * Ha);
  }, a.period = function(o) {
    return t(e, o);
  }, a;
}(Lp, Pp), PI = function t(e, n) {
  var r = Math.asin(1 / (e = Math.max(1, e))) * (n /= Ha);
  function a(o) {
    return ((o = o * 2 - 1) < 0 ? e * Math.pow(2, 10 * o) * Math.sin((r - o) / n) : 2 - e * Math.pow(2, -10 * o) * Math.sin((r + o) / n)) / 2;
  }
  return a.amplitude = function(o) {
    return t(o, n * Ha);
  }, a.period = function(o) {
    return t(e, o);
  }, a;
}(Lp, Pp), Rd = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: Td
};
function NI(t, e) {
  for (var n; !(n = t.__transition) || !(n = n[e]); )
    if (!(t = t.parentNode))
      return Rd.time = oo(), Rd;
  return n;
}
function II(t) {
  var e, n;
  t instanceof Tr ? (e = t._id, t = t._name) : (e = jx(), (n = Rd).time = oo(), t = t == null ? null : t + "");
  for (var r = this._groups, a = r.length, o = 0; o < a; ++o)
    for (var u = r[o], c = u.length, l, d = 0; d < c; ++d)
      (l = u[d]) && Nl(l, t, e, d, u, n || NI(l, e));
  return new Tr(r, this._parents, t, e);
}
na.prototype.interrupt = mN;
na.prototype.transition = II;
var jI = [null];
function kI(t, e) {
  var n = t.__transition, r, a;
  if (n) {
    e = e == null ? null : e + "";
    for (a in n)
      if ((r = n[a]).state > Sd && r.name === e)
        return new Tr([[t]], jI, e, +a);
  }
  return null;
}
function By(t) {
  return function() {
    return t;
  };
}
function BI(t, e, n) {
  this.target = t, this.type = e, this.selection = n;
}
function Fy() {
  St.stopImmediatePropagation();
}
function qu() {
  St.preventDefault(), St.stopImmediatePropagation();
}
var Uy = {}, kh = { name: "space" }, Sa = { name: "handle" }, Aa = { name: "center" }, yc = {
  name: "x",
  handles: ["e", "w"].map(ws),
  input: function(t, e) {
    return t && [[t[0], e[0][1]], [t[1], e[1][1]]];
  },
  output: function(t) {
    return t && [t[0][0], t[1][0]];
  }
}, vc = {
  name: "y",
  handles: ["n", "s"].map(ws),
  input: function(t, e) {
    return t && [[e[0][0], t[0]], [e[1][0], t[1]]];
  },
  output: function(t) {
    return t && [t[0][1], t[1][1]];
  }
}, FI = {
  name: "xy",
  handles: ["n", "e", "s", "w", "nw", "ne", "se", "sw"].map(ws),
  input: function(t) {
    return t;
  },
  output: function(t) {
    return t;
  }
}, Ur = {
  overlay: "crosshair",
  selection: "move",
  n: "ns-resize",
  e: "ew-resize",
  s: "ns-resize",
  w: "ew-resize",
  nw: "nwse-resize",
  ne: "nesw-resize",
  se: "nwse-resize",
  sw: "nesw-resize"
}, $y = {
  e: "w",
  w: "e",
  nw: "ne",
  ne: "nw",
  se: "sw",
  sw: "se"
}, zy = {
  n: "s",
  s: "n",
  nw: "sw",
  ne: "se",
  se: "ne",
  sw: "nw"
}, UI = {
  overlay: 1,
  selection: 1,
  n: null,
  e: 1,
  s: null,
  w: -1,
  nw: -1,
  ne: 1,
  se: 1,
  sw: -1
}, $I = {
  overlay: 1,
  selection: 1,
  n: -1,
  e: null,
  s: 1,
  w: null,
  nw: -1,
  ne: -1,
  se: 1,
  sw: 1
};
function ws(t) {
  return { type: t };
}
function zI() {
  return !St.button;
}
function VI() {
  var t = this.ownerSVGElement || this;
  return [[0, 0], [t.width.baseVal.value, t.height.baseVal.value]];
}
function Bh(t) {
  for (; !t.__brush; ) if (!(t = t.parentNode)) return;
  return t.__brush;
}
function Fh(t) {
  return t[0][0] === t[1][0] || t[0][1] === t[1][1];
}
function YI(t) {
  var e = t.__brush;
  return e ? e.dim.output(e.selection) : null;
}
function WI() {
  return Np(yc);
}
function GI() {
  return Np(vc);
}
function qI() {
  return Np(FI);
}
function Np(t) {
  var e = VI, n = zI, r = wi(u, "start", "brush", "end"), a = 6, o;
  function u(f) {
    var m = f.property("__brush", y).selectAll(".overlay").data([ws("overlay")]);
    m.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", Ur.overlay).merge(m).each(function() {
      var E = Bh(this).extent;
      Cn(this).attr("x", E[0][0]).attr("y", E[0][1]).attr("width", E[1][0] - E[0][0]).attr("height", E[1][1] - E[0][1]);
    }), f.selectAll(".selection").data([ws("selection")]).enter().append("rect").attr("class", "selection").attr("cursor", Ur.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
    var b = f.selectAll(".handle").data(t.handles, function(E) {
      return E.type;
    });
    b.exit().remove(), b.enter().append("rect").attr("class", function(E) {
      return "handle handle--" + E.type;
    }).attr("cursor", function(E) {
      return Ur[E.type];
    }), f.each(c).attr("fill", "none").attr("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush touchstart.brush", g);
  }
  u.move = function(f, m) {
    f.selection ? f.on("start.brush", function() {
      l(this, arguments).beforestart().start();
    }).on("interrupt.brush end.brush", function() {
      l(this, arguments).end();
    }).tween("brush", function() {
      var b = this, E = b.__brush, S = l(b, arguments), M = E.selection, N = t.input(typeof m == "function" ? m.apply(this, arguments) : m, E.extent), O = Us(M, N);
      function A(x) {
        E.selection = x === 1 && Fh(N) ? null : O(x), c.call(b), S.brush();
      }
      return M && N ? A : A(1);
    }) : f.each(function() {
      var b = this, E = arguments, S = b.__brush, M = t.input(typeof m == "function" ? m.apply(b, E) : m, S.extent), N = l(b, E).beforestart();
      Wi(b), S.selection = M == null || Fh(M) ? null : M, c.call(b), N.start().brush().end();
    });
  };
  function c() {
    var f = Cn(this), m = Bh(this).selection;
    m ? (f.selectAll(".selection").style("display", null).attr("x", m[0][0]).attr("y", m[0][1]).attr("width", m[1][0] - m[0][0]).attr("height", m[1][1] - m[0][1]), f.selectAll(".handle").style("display", null).attr("x", function(b) {
      return b.type[b.type.length - 1] === "e" ? m[1][0] - a / 2 : m[0][0] - a / 2;
    }).attr("y", function(b) {
      return b.type[0] === "s" ? m[1][1] - a / 2 : m[0][1] - a / 2;
    }).attr("width", function(b) {
      return b.type === "n" || b.type === "s" ? m[1][0] - m[0][0] + a : a;
    }).attr("height", function(b) {
      return b.type === "e" || b.type === "w" ? m[1][1] - m[0][1] + a : a;
    })) : f.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
  }
  function l(f, m) {
    return f.__brush.emitter || new d(f, m);
  }
  function d(f, m) {
    this.that = f, this.args = m, this.state = f.__brush, this.active = 0;
  }
  d.prototype = {
    beforestart: function() {
      return ++this.active === 1 && (this.state.emitter = this, this.starting = !0), this;
    },
    start: function() {
      return this.starting && (this.starting = !1, this.emit("start")), this;
    },
    brush: function() {
      return this.emit("brush"), this;
    },
    end: function() {
      return --this.active === 0 && (delete this.state.emitter, this.emit("end")), this;
    },
    emit: function(f) {
      ps(new BI(u, f, t.output(this.state.selection)), r.apply, r, [f, this.that, this.args]);
    }
  };
  function g() {
    if (St.touches) {
      if (St.changedTouches.length < St.touches.length) return qu();
    } else if (o) return;
    if (!n.apply(this, arguments)) return;
    var f = this, m = St.target.__data__.type, b = (St.metaKey ? m = "overlay" : m) === "selection" ? Uy : St.altKey ? Aa : Sa, E = t === vc ? null : UI[m], S = t === yc ? null : $I[m], M = Bh(f), N = M.extent, O = M.selection, A = N[0][0], x, v, w = N[0][1], C, P, Y = N[1][0], V, k, T = N[1][1], R, F, U, H, W, B = E && S && St.shiftKey, j, X, tt = fi(f), et = tt, ot = l(f, arguments).beforestart();
    m === "overlay" ? M.selection = O = [
      [x = t === vc ? A : tt[0], C = t === yc ? w : tt[1]],
      [V = t === vc ? Y : x, R = t === yc ? T : C]
    ] : (x = O[0][0], C = O[0][1], V = O[1][0], R = O[1][1]), v = x, P = C, k = V, F = R;
    var Z = Cn(f).attr("pointer-events", "none"), lt = Z.selectAll(".overlay").attr("cursor", Ur[m]);
    if (St.touches)
      Z.on("touchmove.brush", nt, !0).on("touchend.brush touchcancel.brush", Q, !0);
    else {
      var z = Cn(St.view).on("keydown.brush", ht, !0).on("keyup.brush", pt, !0).on("mousemove.brush", nt, !0).on("mouseup.brush", Q, !0);
      Cl(St.view);
    }
    Fy(), Wi(f), c.call(f), ot.start();
    function nt() {
      var st = fi(f);
      B && !j && !X && (Math.abs(st[0] - et[0]) > Math.abs(st[1] - et[1]) ? X = !0 : j = !0), et = st, W = !0, qu(), it();
    }
    function it() {
      var st;
      switch (U = et[0] - tt[0], H = et[1] - tt[1], b) {
        case kh:
        case Uy: {
          E && (U = Math.max(A - x, Math.min(Y - V, U)), v = x + U, k = V + U), S && (H = Math.max(w - C, Math.min(T - R, H)), P = C + H, F = R + H);
          break;
        }
        case Sa: {
          E < 0 ? (U = Math.max(A - x, Math.min(Y - x, U)), v = x + U, k = V) : E > 0 && (U = Math.max(A - V, Math.min(Y - V, U)), v = x, k = V + U), S < 0 ? (H = Math.max(w - C, Math.min(T - C, H)), P = C + H, F = R) : S > 0 && (H = Math.max(w - R, Math.min(T - R, H)), P = C, F = R + H);
          break;
        }
        case Aa: {
          E && (v = Math.max(A, Math.min(Y, x - U * E)), k = Math.max(A, Math.min(Y, V + U * E))), S && (P = Math.max(w, Math.min(T, C - H * S)), F = Math.max(w, Math.min(T, R + H * S)));
          break;
        }
      }
      k < v && (E *= -1, st = x, x = V, V = st, st = v, v = k, k = st, m in $y && lt.attr("cursor", Ur[m = $y[m]])), F < P && (S *= -1, st = C, C = R, R = st, st = P, P = F, F = st, m in zy && lt.attr("cursor", Ur[m = zy[m]])), M.selection && (O = M.selection), j && (v = O[0][0], k = O[1][0]), X && (P = O[0][1], F = O[1][1]), (O[0][0] !== v || O[0][1] !== P || O[1][0] !== k || O[1][1] !== F) && (M.selection = [[v, P], [k, F]], c.call(f), ot.brush());
    }
    function Q() {
      if (Fy(), St.touches) {
        if (St.touches.length) return;
        o && clearTimeout(o), o = setTimeout(function() {
          o = null;
        }, 500), Z.on("touchmove.brush touchend.brush touchcancel.brush", null);
      } else
        Rl(St.view, W), z.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
      Z.attr("pointer-events", "all"), lt.attr("cursor", Ur.overlay), M.selection && (O = M.selection), Fh(O) && (M.selection = null, c.call(f)), ot.end();
    }
    function ht() {
      switch (St.keyCode) {
        case 16: {
          B = E && S;
          break;
        }
        case 18: {
          b === Sa && (E && (V = k - U * E, x = v + U * E), S && (R = F - H * S, C = P + H * S), b = Aa, it());
          break;
        }
        case 32: {
          (b === Sa || b === Aa) && (E < 0 ? V = k - U : E > 0 && (x = v - U), S < 0 ? R = F - H : S > 0 && (C = P - H), b = kh, lt.attr("cursor", Ur.selection), it());
          break;
        }
        default:
          return;
      }
      qu();
    }
    function pt() {
      switch (St.keyCode) {
        case 16: {
          B && (j = X = B = !1, it());
          break;
        }
        case 18: {
          b === Aa && (E < 0 ? V = k : E > 0 && (x = v), S < 0 ? R = F : S > 0 && (C = P), b = Sa, it());
          break;
        }
        case 32: {
          b === kh && (St.altKey ? (E && (V = k - U * E, x = v + U * E), S && (R = F - H * S, C = P + H * S), b = Aa) : (E < 0 ? V = k : E > 0 && (x = v), S < 0 ? R = F : S > 0 && (C = P), b = Sa), lt.attr("cursor", Ur[m]), it());
          break;
        }
        default:
          return;
      }
      qu();
    }
  }
  function y() {
    var f = this.__brush || { selection: null };
    return f.extent = e.apply(this, arguments), f.dim = t, f;
  }
  return u.extent = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : By([[+f[0][0], +f[0][1]], [+f[1][0], +f[1][1]]]), u) : e;
  }, u.filter = function(f) {
    return arguments.length ? (n = typeof f == "function" ? f : By(!!f), u) : n;
  }, u.handleSize = function(f) {
    return arguments.length ? (a = +f, u) : a;
  }, u.on = function() {
    var f = r.on.apply(r, arguments);
    return f === r ? u : f;
  }, u;
}
var Vy = Math.cos, Yy = Math.sin, Fx = Math.PI, Hu = Fx / 2, Wy = Fx * 2, Gy = Math.max;
function HI(t) {
  return function(e, n) {
    return t(
      e.source.value + e.target.value,
      n.source.value + n.target.value
    );
  };
}
function XI() {
  var t = 0, e = null, n = null, r = null;
  function a(o) {
    var u = o.length, c = [], l = tr(u), d = [], g = [], y = g.groups = new Array(u), f = new Array(u * u), m, b, E, S, M, N;
    for (m = 0, M = -1; ++M < u; ) {
      for (b = 0, N = -1; ++N < u; )
        b += o[M][N];
      c.push(b), d.push(tr(u)), m += b;
    }
    for (e && l.sort(function(Y, V) {
      return e(c[Y], c[V]);
    }), n && d.forEach(function(Y, V) {
      Y.sort(function(k, T) {
        return n(o[V][k], o[V][T]);
      });
    }), m = Gy(0, Wy - t * u) / m, S = m ? t : Wy / u, b = 0, M = -1; ++M < u; ) {
      for (E = b, N = -1; ++N < u; ) {
        var O = l[M], A = d[O][N], x = o[O][A], v = b, w = b += x * m;
        f[A * u + O] = {
          index: O,
          subindex: A,
          startAngle: v,
          endAngle: w,
          value: x
        };
      }
      y[O] = {
        index: O,
        startAngle: E,
        endAngle: b,
        value: c[O]
      }, b += S;
    }
    for (M = -1; ++M < u; )
      for (N = M - 1; ++N < u; ) {
        var C = f[N * u + M], P = f[M * u + N];
        (C.value || P.value) && g.push(C.value < P.value ? { source: P, target: C } : { source: C, target: P });
      }
    return r ? g.sort(r) : g;
  }
  return a.padAngle = function(o) {
    return arguments.length ? (t = Gy(0, o), a) : t;
  }, a.sortGroups = function(o) {
    return arguments.length ? (e = o, a) : e;
  }, a.sortSubgroups = function(o) {
    return arguments.length ? (n = o, a) : n;
  }, a.sortChords = function(o) {
    return arguments.length ? (o == null ? r = null : (r = HI(o))._ = o, a) : r && r._;
  }, a;
}
var QI = Array.prototype.slice;
function Uh(t) {
  return function() {
    return t;
  };
}
var Dd = Math.PI, Md = 2 * Dd, $i = 1e-6, KI = Md - $i;
function Od() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null, this._ = "";
}
function Si() {
  return new Od();
}
Od.prototype = Si.prototype = {
  constructor: Od,
  moveTo: function(t, e) {
    this._ += "M" + (this._x0 = this._x1 = +t) + "," + (this._y0 = this._y1 = +e);
  },
  closePath: function() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
  },
  lineTo: function(t, e) {
    this._ += "L" + (this._x1 = +t) + "," + (this._y1 = +e);
  },
  quadraticCurveTo: function(t, e, n, r) {
    this._ += "Q" + +t + "," + +e + "," + (this._x1 = +n) + "," + (this._y1 = +r);
  },
  bezierCurveTo: function(t, e, n, r, a, o) {
    this._ += "C" + +t + "," + +e + "," + +n + "," + +r + "," + (this._x1 = +a) + "," + (this._y1 = +o);
  },
  arcTo: function(t, e, n, r, a) {
    t = +t, e = +e, n = +n, r = +r, a = +a;
    var o = this._x1, u = this._y1, c = n - t, l = r - e, d = o - t, g = u - e, y = d * d + g * g;
    if (a < 0) throw new Error("negative radius: " + a);
    if (this._x1 === null)
      this._ += "M" + (this._x1 = t) + "," + (this._y1 = e);
    else if (y > $i) if (!(Math.abs(g * c - l * d) > $i) || !a)
      this._ += "L" + (this._x1 = t) + "," + (this._y1 = e);
    else {
      var f = n - o, m = r - u, b = c * c + l * l, E = f * f + m * m, S = Math.sqrt(b), M = Math.sqrt(y), N = a * Math.tan((Dd - Math.acos((b + y - E) / (2 * S * M))) / 2), O = N / M, A = N / S;
      Math.abs(O - 1) > $i && (this._ += "L" + (t + O * d) + "," + (e + O * g)), this._ += "A" + a + "," + a + ",0,0," + +(g * f > d * m) + "," + (this._x1 = t + A * c) + "," + (this._y1 = e + A * l);
    }
  },
  arc: function(t, e, n, r, a, o) {
    t = +t, e = +e, n = +n;
    var u = n * Math.cos(r), c = n * Math.sin(r), l = t + u, d = e + c, g = 1 ^ o, y = o ? r - a : a - r;
    if (n < 0) throw new Error("negative radius: " + n);
    this._x1 === null ? this._ += "M" + l + "," + d : (Math.abs(this._x1 - l) > $i || Math.abs(this._y1 - d) > $i) && (this._ += "L" + l + "," + d), n && (y < 0 && (y = y % Md + Md), y > KI ? this._ += "A" + n + "," + n + ",0,1," + g + "," + (t - u) + "," + (e - c) + "A" + n + "," + n + ",0,1," + g + "," + (this._x1 = l) + "," + (this._y1 = d) : y > $i && (this._ += "A" + n + "," + n + ",0," + +(y >= Dd) + "," + g + "," + (this._x1 = t + n * Math.cos(a)) + "," + (this._y1 = e + n * Math.sin(a))));
  },
  rect: function(t, e, n, r) {
    this._ += "M" + (this._x0 = this._x1 = +t) + "," + (this._y0 = this._y1 = +e) + "h" + +n + "v" + +r + "h" + -n + "Z";
  },
  toString: function() {
    return this._;
  }
};
function ZI(t) {
  return t.source;
}
function JI(t) {
  return t.target;
}
function t3(t) {
  return t.radius;
}
function e3(t) {
  return t.startAngle;
}
function n3(t) {
  return t.endAngle;
}
function r3() {
  var t = ZI, e = JI, n = t3, r = e3, a = n3, o = null;
  function u() {
    var c, l = QI.call(arguments), d = t.apply(this, l), g = e.apply(this, l), y = +n.apply(this, (l[0] = d, l)), f = r.apply(this, l) - Hu, m = a.apply(this, l) - Hu, b = y * Vy(f), E = y * Yy(f), S = +n.apply(this, (l[0] = g, l)), M = r.apply(this, l) - Hu, N = a.apply(this, l) - Hu;
    if (o || (o = c = Si()), o.moveTo(b, E), o.arc(0, 0, y, f, m), (f !== M || m !== N) && (o.quadraticCurveTo(0, 0, S * Vy(M), S * Yy(M)), o.arc(0, 0, S, M, N)), o.quadraticCurveTo(0, 0, b, E), o.closePath(), c) return o = null, c + "" || null;
  }
  return u.radius = function(c) {
    return arguments.length ? (n = typeof c == "function" ? c : Uh(+c), u) : n;
  }, u.startAngle = function(c) {
    return arguments.length ? (r = typeof c == "function" ? c : Uh(+c), u) : r;
  }, u.endAngle = function(c) {
    return arguments.length ? (a = typeof c == "function" ? c : Uh(+c), u) : a;
  }, u.source = function(c) {
    return arguments.length ? (t = c, u) : t;
  }, u.target = function(c) {
    return arguments.length ? (e = c, u) : e;
  }, u.context = function(c) {
    return arguments.length ? (o = c ?? null, u) : o;
  }, u;
}
var Kn = "$";
function Ic() {
}
Ic.prototype = Cr.prototype = {
  constructor: Ic,
  has: function(t) {
    return Kn + t in this;
  },
  get: function(t) {
    return this[Kn + t];
  },
  set: function(t, e) {
    return this[Kn + t] = e, this;
  },
  remove: function(t) {
    var e = Kn + t;
    return e in this && delete this[e];
  },
  clear: function() {
    for (var t in this) t[0] === Kn && delete this[t];
  },
  keys: function() {
    var t = [];
    for (var e in this) e[0] === Kn && t.push(e.slice(1));
    return t;
  },
  values: function() {
    var t = [];
    for (var e in this) e[0] === Kn && t.push(this[e]);
    return t;
  },
  entries: function() {
    var t = [];
    for (var e in this) e[0] === Kn && t.push({ key: e.slice(1), value: this[e] });
    return t;
  },
  size: function() {
    var t = 0;
    for (var e in this) e[0] === Kn && ++t;
    return t;
  },
  empty: function() {
    for (var t in this) if (t[0] === Kn) return !1;
    return !0;
  },
  each: function(t) {
    for (var e in this) e[0] === Kn && t(this[e], e.slice(1), this);
  }
};
function Cr(t, e) {
  var n = new Ic();
  if (t instanceof Ic) t.each(function(c, l) {
    n.set(l, c);
  });
  else if (Array.isArray(t)) {
    var r = -1, a = t.length, o;
    if (e == null) for (; ++r < a; ) n.set(r, t[r]);
    else for (; ++r < a; ) n.set(e(o = t[r], r, t), o);
  } else if (t) for (var u in t) n.set(u, t[u]);
  return n;
}
function Ip() {
  var t = [], e = [], n, r, a;
  function o(c, l, d, g) {
    if (l >= t.length)
      return n != null && c.sort(n), r != null ? r(c) : c;
    for (var y = -1, f = c.length, m = t[l++], b, E, S = Cr(), M, N = d(); ++y < f; )
      (M = S.get(b = m(E = c[y]) + "")) ? M.push(E) : S.set(b, [E]);
    return S.each(function(O, A) {
      g(N, A, o(O, l, d, g));
    }), N;
  }
  function u(c, l) {
    if (++l > t.length) return c;
    var d, g = e[l - 1];
    return r != null && l >= t.length ? d = c.entries() : (d = [], c.each(function(y, f) {
      d.push({ key: f, values: u(y, l) });
    })), g != null ? d.sort(function(y, f) {
      return g(y.key, f.key);
    }) : d;
  }
  return a = {
    object: function(c) {
      return o(c, 0, i3, a3);
    },
    map: function(c) {
      return o(c, 0, qy, Hy);
    },
    entries: function(c) {
      return u(o(c, 0, qy, Hy), 0);
    },
    key: function(c) {
      return t.push(c), a;
    },
    sortKeys: function(c) {
      return e[t.length - 1] = c, a;
    },
    sortValues: function(c) {
      return n = c, a;
    },
    rollup: function(c) {
      return r = c, a;
    }
  };
}
function i3() {
  return {};
}
function a3(t, e, n) {
  t[e] = n;
}
function qy() {
  return Cr();
}
function Hy(t, e, n) {
  t.set(e, n);
}
function jc() {
}
var Bi = Cr.prototype;
jc.prototype = Ux.prototype = {
  constructor: jc,
  has: Bi.has,
  add: function(t) {
    return t += "", this[Kn + t] = t, this;
  },
  remove: Bi.remove,
  clear: Bi.clear,
  values: Bi.keys,
  size: Bi.size,
  empty: Bi.empty,
  each: Bi.each
};
function Ux(t, e) {
  var n = new jc();
  if (t instanceof jc) t.each(function(o) {
    n.add(o);
  });
  else if (t) {
    var r = -1, a = t.length;
    if (e == null) for (; ++r < a; ) n.add(t[r]);
    else for (; ++r < a; ) n.add(e(t[r], r, t));
  }
  return n;
}
function $x(t) {
  var e = [];
  for (var n in t) e.push(n);
  return e;
}
function o3(t) {
  var e = [];
  for (var n in t) e.push(t[n]);
  return e;
}
function s3(t) {
  var e = [];
  for (var n in t) e.push({ key: n, value: t[n] });
  return e;
}
var Xy = {}, $h = {}, zh = 34, Po = 10, Vh = 13;
function zx(t) {
  return new Function("d", "return {" + t.map(function(e, n) {
    return JSON.stringify(e) + ": d[" + n + "]";
  }).join(",") + "}");
}
function u3(t, e) {
  var n = zx(t);
  return function(r, a) {
    return e(n(r), a, t);
  };
}
function c3(t) {
  var e = /* @__PURE__ */ Object.create(null), n = [];
  return t.forEach(function(r) {
    for (var a in r)
      a in e || n.push(e[a] = a);
  }), n;
}
function jp(t) {
  var e = new RegExp('["' + t + `
\r]`), n = t.charCodeAt(0);
  function r(d, g) {
    var y, f, m = a(d, function(b, E) {
      if (y) return y(b, E - 1);
      f = b, y = g ? u3(b, g) : zx(b);
    });
    return m.columns = f || [], m;
  }
  function a(d, g) {
    var y = [], f = d.length, m = 0, b = 0, E, S = f <= 0, M = !1;
    d.charCodeAt(f - 1) === Po && --f, d.charCodeAt(f - 1) === Vh && --f;
    function N() {
      if (S) return $h;
      if (M) return M = !1, Xy;
      var A, x = m, v;
      if (d.charCodeAt(x) === zh) {
        for (; m++ < f && d.charCodeAt(m) !== zh || d.charCodeAt(++m) === zh; ) ;
        return (A = m) >= f ? S = !0 : (v = d.charCodeAt(m++)) === Po ? M = !0 : v === Vh && (M = !0, d.charCodeAt(m) === Po && ++m), d.slice(x + 1, A - 1).replace(/""/g, '"');
      }
      for (; m < f; ) {
        if ((v = d.charCodeAt(A = m++)) === Po) M = !0;
        else if (v === Vh)
          M = !0, d.charCodeAt(m) === Po && ++m;
        else if (v !== n) continue;
        return d.slice(x, A);
      }
      return S = !0, d.slice(x, f);
    }
    for (; (E = N()) !== $h; ) {
      for (var O = []; E !== Xy && E !== $h; ) O.push(E), E = N();
      g && (O = g(O, b++)) == null || y.push(O);
    }
    return y;
  }
  function o(d, g) {
    return g == null && (g = c3(d)), [g.map(l).join(t)].concat(d.map(function(y) {
      return g.map(function(f) {
        return l(y[f]);
      }).join(t);
    })).join(`
`);
  }
  function u(d) {
    return d.map(c).join(`
`);
  }
  function c(d) {
    return d.map(l).join(t);
  }
  function l(d) {
    return d == null ? "" : e.test(d += "") ? '"' + d.replace(/"/g, '""') + '"' : d;
  }
  return {
    parse: r,
    parseRows: a,
    format: o,
    formatRows: u
  };
}
var Il = jp(","), Vx = Il.parse, l3 = Il.parseRows, f3 = Il.format, h3 = Il.formatRows, jl = jp("	"), Yx = jl.parse, d3 = jl.parseRows, p3 = jl.format, g3 = jl.formatRows;
function m3(t, e) {
  var n;
  t == null && (t = 0), e == null && (e = 0);
  function r() {
    var a, o = n.length, u, c = 0, l = 0;
    for (a = 0; a < o; ++a)
      u = n[a], c += u.x, l += u.y;
    for (c = c / o - t, l = l / o - e, a = 0; a < o; ++a)
      u = n[a], u.x -= c, u.y -= l;
  }
  return r.initialize = function(a) {
    n = a;
  }, r.x = function(a) {
    return arguments.length ? (t = +a, r) : t;
  }, r.y = function(a) {
    return arguments.length ? (e = +a, r) : e;
  }, r;
}
function $e(t) {
  return function() {
    return t;
  };
}
function hi() {
  return (Math.random() - 0.5) * 1e-6;
}
function y3(t) {
  var e = +this._x.call(null, t), n = +this._y.call(null, t);
  return Wx(this.cover(e, n), e, n, t);
}
function Wx(t, e, n, r) {
  if (isNaN(e) || isNaN(n)) return t;
  var a, o = t._root, u = { data: r }, c = t._x0, l = t._y0, d = t._x1, g = t._y1, y, f, m, b, E, S, M, N;
  if (!o) return t._root = u, t;
  for (; o.length; )
    if ((E = e >= (y = (c + d) / 2)) ? c = y : d = y, (S = n >= (f = (l + g) / 2)) ? l = f : g = f, a = o, !(o = o[M = S << 1 | E])) return a[M] = u, t;
  if (m = +t._x.call(null, o.data), b = +t._y.call(null, o.data), e === m && n === b) return u.next = o, a ? a[M] = u : t._root = u, t;
  do
    a = a ? a[M] = new Array(4) : t._root = new Array(4), (E = e >= (y = (c + d) / 2)) ? c = y : d = y, (S = n >= (f = (l + g) / 2)) ? l = f : g = f;
  while ((M = S << 1 | E) === (N = (b >= f) << 1 | m >= y));
  return a[N] = o, a[M] = u, t;
}
function v3(t) {
  var e, n, r = t.length, a, o, u = new Array(r), c = new Array(r), l = 1 / 0, d = 1 / 0, g = -1 / 0, y = -1 / 0;
  for (n = 0; n < r; ++n)
    isNaN(a = +this._x.call(null, e = t[n])) || isNaN(o = +this._y.call(null, e)) || (u[n] = a, c[n] = o, a < l && (l = a), a > g && (g = a), o < d && (d = o), o > y && (y = o));
  for (g < l && (l = this._x0, g = this._x1), y < d && (d = this._y0, y = this._y1), this.cover(l, d).cover(g, y), n = 0; n < r; ++n)
    Wx(this, u[n], c[n], t[n]);
  return this;
}
function x3(t, e) {
  if (isNaN(t = +t) || isNaN(e = +e)) return this;
  var n = this._x0, r = this._y0, a = this._x1, o = this._y1;
  if (isNaN(n))
    a = (n = Math.floor(t)) + 1, o = (r = Math.floor(e)) + 1;
  else if (n > t || t > a || r > e || e > o) {
    var u = a - n, c = this._root, l, d;
    switch (d = (e < (r + o) / 2) << 1 | t < (n + a) / 2) {
      case 0: {
        do
          l = new Array(4), l[d] = c, c = l;
        while (u *= 2, a = n + u, o = r + u, t > a || e > o);
        break;
      }
      case 1: {
        do
          l = new Array(4), l[d] = c, c = l;
        while (u *= 2, n = a - u, o = r + u, n > t || e > o);
        break;
      }
      case 2: {
        do
          l = new Array(4), l[d] = c, c = l;
        while (u *= 2, a = n + u, r = o - u, t > a || r > e);
        break;
      }
      case 3: {
        do
          l = new Array(4), l[d] = c, c = l;
        while (u *= 2, n = a - u, r = o - u, n > t || r > e);
        break;
      }
    }
    this._root && this._root.length && (this._root = c);
  } else return this;
  return this._x0 = n, this._y0 = r, this._x1 = a, this._y1 = o, this;
}
function _3() {
  var t = [];
  return this.visit(function(e) {
    if (!e.length) do
      t.push(e.data);
    while (e = e.next);
  }), t;
}
function b3(t) {
  return arguments.length ? this.cover(+t[0][0], +t[0][1]).cover(+t[1][0], +t[1][1]) : isNaN(this._x0) ? void 0 : [[this._x0, this._y0], [this._x1, this._y1]];
}
function mn(t, e, n, r, a) {
  this.node = t, this.x0 = e, this.y0 = n, this.x1 = r, this.y1 = a;
}
function w3(t, e, n) {
  var r, a = this._x0, o = this._y0, u, c, l, d, g = this._x1, y = this._y1, f = [], m = this._root, b, E;
  for (m && f.push(new mn(m, a, o, g, y)), n == null ? n = 1 / 0 : (a = t - n, o = e - n, g = t + n, y = e + n, n *= n); b = f.pop(); )
    if (!(!(m = b.node) || (u = b.x0) > g || (c = b.y0) > y || (l = b.x1) < a || (d = b.y1) < o))
      if (m.length) {
        var S = (u + l) / 2, M = (c + d) / 2;
        f.push(
          new mn(m[3], S, M, l, d),
          new mn(m[2], u, M, S, d),
          new mn(m[1], S, c, l, M),
          new mn(m[0], u, c, S, M)
        ), (E = (e >= M) << 1 | t >= S) && (b = f[f.length - 1], f[f.length - 1] = f[f.length - 1 - E], f[f.length - 1 - E] = b);
      } else {
        var N = t - +this._x.call(null, m.data), O = e - +this._y.call(null, m.data), A = N * N + O * O;
        if (A < n) {
          var x = Math.sqrt(n = A);
          a = t - x, o = e - x, g = t + x, y = e + x, r = m.data;
        }
      }
  return r;
}
function E3(t) {
  if (isNaN(g = +this._x.call(null, t)) || isNaN(y = +this._y.call(null, t))) return this;
  var e, n = this._root, r, a, o, u = this._x0, c = this._y0, l = this._x1, d = this._y1, g, y, f, m, b, E, S, M;
  if (!n) return this;
  if (n.length) for (; ; ) {
    if ((b = g >= (f = (u + l) / 2)) ? u = f : l = f, (E = y >= (m = (c + d) / 2)) ? c = m : d = m, e = n, !(n = n[S = E << 1 | b])) return this;
    if (!n.length) break;
    (e[S + 1 & 3] || e[S + 2 & 3] || e[S + 3 & 3]) && (r = e, M = S);
  }
  for (; n.data !== t; ) if (a = n, !(n = n.next)) return this;
  return (o = n.next) && delete n.next, a ? (o ? a.next = o : delete a.next, this) : e ? (o ? e[S] = o : delete e[S], (n = e[0] || e[1] || e[2] || e[3]) && n === (e[3] || e[2] || e[1] || e[0]) && !n.length && (r ? r[M] = n : this._root = n), this) : (this._root = o, this);
}
function S3(t) {
  for (var e = 0, n = t.length; e < n; ++e) this.remove(t[e]);
  return this;
}
function A3() {
  return this._root;
}
function T3() {
  var t = 0;
  return this.visit(function(e) {
    if (!e.length) do
      ++t;
    while (e = e.next);
  }), t;
}
function C3(t) {
  var e = [], n, r = this._root, a, o, u, c, l;
  for (r && e.push(new mn(r, this._x0, this._y0, this._x1, this._y1)); n = e.pop(); )
    if (!t(r = n.node, o = n.x0, u = n.y0, c = n.x1, l = n.y1) && r.length) {
      var d = (o + c) / 2, g = (u + l) / 2;
      (a = r[3]) && e.push(new mn(a, d, g, c, l)), (a = r[2]) && e.push(new mn(a, o, g, d, l)), (a = r[1]) && e.push(new mn(a, d, u, c, g)), (a = r[0]) && e.push(new mn(a, o, u, d, g));
    }
  return this;
}
function R3(t) {
  var e = [], n = [], r;
  for (this._root && e.push(new mn(this._root, this._x0, this._y0, this._x1, this._y1)); r = e.pop(); ) {
    var a = r.node;
    if (a.length) {
      var o, u = r.x0, c = r.y0, l = r.x1, d = r.y1, g = (u + l) / 2, y = (c + d) / 2;
      (o = a[0]) && e.push(new mn(o, u, c, g, y)), (o = a[1]) && e.push(new mn(o, g, c, l, y)), (o = a[2]) && e.push(new mn(o, u, y, g, d)), (o = a[3]) && e.push(new mn(o, g, y, l, d));
    }
    n.push(r);
  }
  for (; r = n.pop(); )
    t(r.node, r.x0, r.y0, r.x1, r.y1);
  return this;
}
function D3(t) {
  return t[0];
}
function M3(t) {
  return arguments.length ? (this._x = t, this) : this._x;
}
function O3(t) {
  return t[1];
}
function L3(t) {
  return arguments.length ? (this._y = t, this) : this._y;
}
function kl(t, e, n) {
  var r = new kp(e ?? D3, n ?? O3, NaN, NaN, NaN, NaN);
  return t == null ? r : r.addAll(t);
}
function kp(t, e, n, r, a, o) {
  this._x = t, this._y = e, this._x0 = n, this._y0 = r, this._x1 = a, this._y1 = o, this._root = void 0;
}
function Qy(t) {
  for (var e = { data: t.data }, n = e; t = t.next; ) n = n.next = { data: t.data };
  return e;
}
var xn = kl.prototype = kp.prototype;
xn.copy = function() {
  var t = new kp(this._x, this._y, this._x0, this._y0, this._x1, this._y1), e = this._root, n, r;
  if (!e) return t;
  if (!e.length) return t._root = Qy(e), t;
  for (n = [{ source: e, target: t._root = new Array(4) }]; e = n.pop(); )
    for (var a = 0; a < 4; ++a)
      (r = e.source[a]) && (r.length ? n.push({ source: r, target: e.target[a] = new Array(4) }) : e.target[a] = Qy(r));
  return t;
};
xn.add = y3;
xn.addAll = v3;
xn.cover = x3;
xn.data = _3;
xn.extent = b3;
xn.find = w3;
xn.remove = E3;
xn.removeAll = S3;
xn.root = A3;
xn.size = T3;
xn.visit = C3;
xn.visitAfter = R3;
xn.x = M3;
xn.y = L3;
function P3(t) {
  return t.x + t.vx;
}
function N3(t) {
  return t.y + t.vy;
}
function I3(t) {
  var e, n, r = 1, a = 1;
  typeof t != "function" && (t = $e(t == null ? 1 : +t));
  function o() {
    for (var l, d = e.length, g, y, f, m, b, E, S = 0; S < a; ++S)
      for (g = kl(e, P3, N3).visitAfter(u), l = 0; l < d; ++l)
        y = e[l], b = n[y.index], E = b * b, f = y.x + y.vx, m = y.y + y.vy, g.visit(M);
    function M(N, O, A, x, v) {
      var w = N.data, C = N.r, P = b + C;
      if (w) {
        if (w.index > y.index) {
          var Y = f - w.x - w.vx, V = m - w.y - w.vy, k = Y * Y + V * V;
          k < P * P && (Y === 0 && (Y = hi(), k += Y * Y), V === 0 && (V = hi(), k += V * V), k = (P - (k = Math.sqrt(k))) / k * r, y.vx += (Y *= k) * (P = (C *= C) / (E + C)), y.vy += (V *= k) * P, w.vx -= Y * (P = 1 - P), w.vy -= V * P);
        }
        return;
      }
      return O > f + P || x < f - P || A > m + P || v < m - P;
    }
  }
  function u(l) {
    if (l.data) return l.r = n[l.data.index];
    for (var d = l.r = 0; d < 4; ++d)
      l[d] && l[d].r > l.r && (l.r = l[d].r);
  }
  function c() {
    if (e) {
      var l, d = e.length, g;
      for (n = new Array(d), l = 0; l < d; ++l) g = e[l], n[g.index] = +t(g, l, e);
    }
  }
  return o.initialize = function(l) {
    e = l, c();
  }, o.iterations = function(l) {
    return arguments.length ? (a = +l, o) : a;
  }, o.strength = function(l) {
    return arguments.length ? (r = +l, o) : r;
  }, o.radius = function(l) {
    return arguments.length ? (t = typeof l == "function" ? l : $e(+l), c(), o) : t;
  }, o;
}
function j3(t) {
  return t.index;
}
function Ky(t, e) {
  var n = t.get(e);
  if (!n) throw new Error("missing: " + e);
  return n;
}
function k3(t) {
  var e = j3, n = g, r, a = $e(30), o, u, c, l, d = 1;
  t == null && (t = []);
  function g(E) {
    return 1 / Math.min(c[E.source.index], c[E.target.index]);
  }
  function y(E) {
    for (var S = 0, M = t.length; S < d; ++S)
      for (var N = 0, O, A, x, v, w, C, P; N < M; ++N)
        O = t[N], A = O.source, x = O.target, v = x.x + x.vx - A.x - A.vx || hi(), w = x.y + x.vy - A.y - A.vy || hi(), C = Math.sqrt(v * v + w * w), C = (C - o[N]) / C * E * r[N], v *= C, w *= C, x.vx -= v * (P = l[N]), x.vy -= w * P, A.vx += v * (P = 1 - P), A.vy += w * P;
  }
  function f() {
    if (u) {
      var E, S = u.length, M = t.length, N = Cr(u, e), O;
      for (E = 0, c = new Array(S); E < M; ++E)
        O = t[E], O.index = E, typeof O.source != "object" && (O.source = Ky(N, O.source)), typeof O.target != "object" && (O.target = Ky(N, O.target)), c[O.source.index] = (c[O.source.index] || 0) + 1, c[O.target.index] = (c[O.target.index] || 0) + 1;
      for (E = 0, l = new Array(M); E < M; ++E)
        O = t[E], l[E] = c[O.source.index] / (c[O.source.index] + c[O.target.index]);
      r = new Array(M), m(), o = new Array(M), b();
    }
  }
  function m() {
    if (u)
      for (var E = 0, S = t.length; E < S; ++E)
        r[E] = +n(t[E], E, t);
  }
  function b() {
    if (u)
      for (var E = 0, S = t.length; E < S; ++E)
        o[E] = +a(t[E], E, t);
  }
  return y.initialize = function(E) {
    u = E, f();
  }, y.links = function(E) {
    return arguments.length ? (t = E, f(), y) : t;
  }, y.id = function(E) {
    return arguments.length ? (e = E, y) : e;
  }, y.iterations = function(E) {
    return arguments.length ? (d = +E, y) : d;
  }, y.strength = function(E) {
    return arguments.length ? (n = typeof E == "function" ? E : $e(+E), m(), y) : n;
  }, y.distance = function(E) {
    return arguments.length ? (a = typeof E == "function" ? E : $e(+E), b(), y) : a;
  }, y;
}
function B3(t) {
  return t.x;
}
function F3(t) {
  return t.y;
}
var U3 = 10, $3 = Math.PI * (3 - Math.sqrt(5));
function z3(t) {
  var e, n = 1, r = 1e-3, a = 1 - Math.pow(r, 1 / 300), o = 0, u = 0.6, c = Cr(), l = Pl(g), d = wi("tick", "end");
  t == null && (t = []);
  function g() {
    y(), d.call("tick", e), n < r && (l.stop(), d.call("end", e));
  }
  function y() {
    var b, E = t.length, S;
    for (n += (o - n) * a, c.each(function(M) {
      M(n);
    }), b = 0; b < E; ++b)
      S = t[b], S.fx == null ? S.x += S.vx *= u : (S.x = S.fx, S.vx = 0), S.fy == null ? S.y += S.vy *= u : (S.y = S.fy, S.vy = 0);
  }
  function f() {
    for (var b = 0, E = t.length, S; b < E; ++b) {
      if (S = t[b], S.index = b, isNaN(S.x) || isNaN(S.y)) {
        var M = U3 * Math.sqrt(b), N = b * $3;
        S.x = M * Math.cos(N), S.y = M * Math.sin(N);
      }
      (isNaN(S.vx) || isNaN(S.vy)) && (S.vx = S.vy = 0);
    }
  }
  function m(b) {
    return b.initialize && b.initialize(t), b;
  }
  return f(), e = {
    tick: y,
    restart: function() {
      return l.restart(g), e;
    },
    stop: function() {
      return l.stop(), e;
    },
    nodes: function(b) {
      return arguments.length ? (t = b, f(), c.each(m), e) : t;
    },
    alpha: function(b) {
      return arguments.length ? (n = +b, e) : n;
    },
    alphaMin: function(b) {
      return arguments.length ? (r = +b, e) : r;
    },
    alphaDecay: function(b) {
      return arguments.length ? (a = +b, e) : +a;
    },
    alphaTarget: function(b) {
      return arguments.length ? (o = +b, e) : o;
    },
    velocityDecay: function(b) {
      return arguments.length ? (u = 1 - b, e) : 1 - u;
    },
    force: function(b, E) {
      return arguments.length > 1 ? (E == null ? c.remove(b) : c.set(b, m(E)), e) : c.get(b);
    },
    find: function(b, E, S) {
      var M = 0, N = t.length, O, A, x, v, w;
      for (S == null ? S = 1 / 0 : S *= S, M = 0; M < N; ++M)
        v = t[M], O = b - v.x, A = E - v.y, x = O * O + A * A, x < S && (w = v, S = x);
      return w;
    },
    on: function(b, E) {
      return arguments.length > 1 ? (d.on(b, E), e) : d.on(b);
    }
  };
}
function V3() {
  var t, e, n, r = $e(-30), a, o = 1, u = 1 / 0, c = 0.81;
  function l(f) {
    var m, b = t.length, E = kl(t, B3, F3).visitAfter(g);
    for (n = f, m = 0; m < b; ++m) e = t[m], E.visit(y);
  }
  function d() {
    if (t) {
      var f, m = t.length, b;
      for (a = new Array(m), f = 0; f < m; ++f) b = t[f], a[b.index] = +r(b, f, t);
    }
  }
  function g(f) {
    var m = 0, b, E, S = 0, M, N, O;
    if (f.length) {
      for (M = N = O = 0; O < 4; ++O)
        (b = f[O]) && (E = Math.abs(b.value)) && (m += b.value, S += E, M += E * b.x, N += E * b.y);
      f.x = M / S, f.y = N / S;
    } else {
      b = f, b.x = b.data.x, b.y = b.data.y;
      do
        m += a[b.data.index];
      while (b = b.next);
    }
    f.value = m;
  }
  function y(f, m, b, E) {
    if (!f.value) return !0;
    var S = f.x - e.x, M = f.y - e.y, N = E - m, O = S * S + M * M;
    if (N * N / c < O)
      return O < u && (S === 0 && (S = hi(), O += S * S), M === 0 && (M = hi(), O += M * M), O < o && (O = Math.sqrt(o * O)), e.vx += S * f.value * n / O, e.vy += M * f.value * n / O), !0;
    if (f.length || O >= u) return;
    (f.data !== e || f.next) && (S === 0 && (S = hi(), O += S * S), M === 0 && (M = hi(), O += M * M), O < o && (O = Math.sqrt(o * O)));
    do
      f.data !== e && (N = a[f.data.index] * n / O, e.vx += S * N, e.vy += M * N);
    while (f = f.next);
  }
  return l.initialize = function(f) {
    t = f, d();
  }, l.strength = function(f) {
    return arguments.length ? (r = typeof f == "function" ? f : $e(+f), d(), l) : r;
  }, l.distanceMin = function(f) {
    return arguments.length ? (o = f * f, l) : Math.sqrt(o);
  }, l.distanceMax = function(f) {
    return arguments.length ? (u = f * f, l) : Math.sqrt(u);
  }, l.theta = function(f) {
    return arguments.length ? (c = f * f, l) : Math.sqrt(c);
  }, l;
}
function Y3(t, e, n) {
  var r, a = $e(0.1), o, u;
  typeof t != "function" && (t = $e(+t)), e == null && (e = 0), n == null && (n = 0);
  function c(d) {
    for (var g = 0, y = r.length; g < y; ++g) {
      var f = r[g], m = f.x - e || 1e-6, b = f.y - n || 1e-6, E = Math.sqrt(m * m + b * b), S = (u[g] - E) * o[g] * d / E;
      f.vx += m * S, f.vy += b * S;
    }
  }
  function l() {
    if (r) {
      var d, g = r.length;
      for (o = new Array(g), u = new Array(g), d = 0; d < g; ++d)
        u[d] = +t(r[d], d, r), o[d] = isNaN(u[d]) ? 0 : +a(r[d], d, r);
    }
  }
  return c.initialize = function(d) {
    r = d, l();
  }, c.strength = function(d) {
    return arguments.length ? (a = typeof d == "function" ? d : $e(+d), l(), c) : a;
  }, c.radius = function(d) {
    return arguments.length ? (t = typeof d == "function" ? d : $e(+d), l(), c) : t;
  }, c.x = function(d) {
    return arguments.length ? (e = +d, c) : e;
  }, c.y = function(d) {
    return arguments.length ? (n = +d, c) : n;
  }, c;
}
function W3(t) {
  var e = $e(0.1), n, r, a;
  typeof t != "function" && (t = $e(t == null ? 0 : +t));
  function o(c) {
    for (var l = 0, d = n.length, g; l < d; ++l)
      g = n[l], g.vx += (a[l] - g.x) * r[l] * c;
  }
  function u() {
    if (n) {
      var c, l = n.length;
      for (r = new Array(l), a = new Array(l), c = 0; c < l; ++c)
        r[c] = isNaN(a[c] = +t(n[c], c, n)) ? 0 : +e(n[c], c, n);
    }
  }
  return o.initialize = function(c) {
    n = c, u();
  }, o.strength = function(c) {
    return arguments.length ? (e = typeof c == "function" ? c : $e(+c), u(), o) : e;
  }, o.x = function(c) {
    return arguments.length ? (t = typeof c == "function" ? c : $e(+c), u(), o) : t;
  }, o;
}
function G3(t) {
  var e = $e(0.1), n, r, a;
  typeof t != "function" && (t = $e(t == null ? 0 : +t));
  function o(c) {
    for (var l = 0, d = n.length, g; l < d; ++l)
      g = n[l], g.vy += (a[l] - g.y) * r[l] * c;
  }
  function u() {
    if (n) {
      var c, l = n.length;
      for (r = new Array(l), a = new Array(l), c = 0; c < l; ++c)
        r[c] = isNaN(a[c] = +t(n[c], c, n)) ? 0 : +e(n[c], c, n);
    }
  }
  return o.initialize = function(c) {
    n = c, u();
  }, o.strength = function(c) {
    return arguments.length ? (e = typeof c == "function" ? c : $e(+c), u(), o) : e;
  }, o.y = function(c) {
    return arguments.length ? (t = typeof c == "function" ? c : $e(+c), u(), o) : t;
  }, o;
}
function kc(t, e) {
  if ((n = (t = e ? t.toExponential(e - 1) : t.toExponential()).indexOf("e")) < 0) return null;
  var n, r = t.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +t.slice(n + 1)
  ];
}
function Xa(t) {
  return t = kc(Math.abs(t)), t ? t[1] : NaN;
}
function q3(t, e) {
  return function(n, r) {
    for (var a = n.length, o = [], u = 0, c = t[0], l = 0; a > 0 && c > 0 && (l + c + 1 > r && (c = Math.max(1, r - l)), o.push(n.substring(a -= c, a + c)), !((l += c + 1) > r)); )
      c = t[u = (u + 1) % t.length];
    return o.reverse().join(e);
  };
}
function H3(t) {
  return function(e) {
    return e.replace(/[0-9]/g, function(n) {
      return t[+n];
    });
  };
}
function X3(t, e) {
  t = t.toPrecision(e);
  t: for (var n = t.length, r = 1, a = -1, o; r < n; ++r)
    switch (t[r]) {
      case ".":
        a = o = r;
        break;
      case "0":
        a === 0 && (a = r), o = r;
        break;
      case "e":
        break t;
      default:
        a > 0 && (a = 0);
        break;
    }
  return a > 0 ? t.slice(0, a) + t.slice(o + 1) : t;
}
var Gx;
function Q3(t, e) {
  var n = kc(t, e);
  if (!n) return t + "";
  var r = n[0], a = n[1], o = a - (Gx = Math.max(-8, Math.min(8, Math.floor(a / 3))) * 3) + 1, u = r.length;
  return o === u ? r : o > u ? r + new Array(o - u + 1).join("0") : o > 0 ? r.slice(0, o) + "." + r.slice(o) : "0." + new Array(1 - o).join("0") + kc(t, Math.max(0, e + o - 1))[0];
}
function Zy(t, e) {
  var n = kc(t, e);
  if (!n) return t + "";
  var r = n[0], a = n[1];
  return a < 0 ? "0." + new Array(-a).join("0") + r : r.length > a + 1 ? r.slice(0, a + 1) + "." + r.slice(a + 1) : r + new Array(a - r.length + 2).join("0");
}
const qx = {
  "": X3,
  "%": function(t, e) {
    return (t * 100).toFixed(e);
  },
  b: function(t) {
    return Math.round(t).toString(2);
  },
  c: function(t) {
    return t + "";
  },
  d: function(t) {
    return Math.round(t).toString(10);
  },
  e: function(t, e) {
    return t.toExponential(e);
  },
  f: function(t, e) {
    return t.toFixed(e);
  },
  g: function(t, e) {
    return t.toPrecision(e);
  },
  o: function(t) {
    return Math.round(t).toString(8);
  },
  p: function(t, e) {
    return Zy(t * 100, e);
  },
  r: Zy,
  s: Q3,
  X: function(t) {
    return Math.round(t).toString(16).toUpperCase();
  },
  x: function(t) {
    return Math.round(t).toString(16);
  }
};
var K3 = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;
function Es(t) {
  return new Bp(t);
}
Es.prototype = Bp.prototype;
function Bp(t) {
  if (!(e = K3.exec(t))) throw new Error("invalid format: " + t);
  var e, n = e[1] || " ", r = e[2] || ">", a = e[3] || "-", o = e[4] || "", u = !!e[5], c = e[6] && +e[6], l = !!e[7], d = e[8] && +e[8].slice(1), g = e[9] || "";
  g === "n" ? (l = !0, g = "g") : qx[g] || (g = ""), (u || n === "0" && r === "=") && (u = !0, n = "0", r = "="), this.fill = n, this.align = r, this.sign = a, this.symbol = o, this.zero = u, this.width = c, this.comma = l, this.precision = d, this.type = g;
}
Bp.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width == null ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0)) + this.type;
};
function Jy(t) {
  return t;
}
var t1 = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function Hx(t) {
  var e = t.grouping && t.thousands ? q3(t.grouping, t.thousands) : Jy, n = t.currency, r = t.decimal, a = t.numerals ? H3(t.numerals) : Jy, o = t.percent || "%";
  function u(l) {
    l = Es(l);
    var d = l.fill, g = l.align, y = l.sign, f = l.symbol, m = l.zero, b = l.width, E = l.comma, S = l.precision, M = l.type, N = f === "$" ? n[0] : f === "#" && /[boxX]/.test(M) ? "0" + M.toLowerCase() : "", O = f === "$" ? n[1] : /[%p]/.test(M) ? o : "", A = qx[M], x = !M || /[defgprs%]/.test(M);
    S = S == null ? M ? 6 : 12 : /[gprs]/.test(M) ? Math.max(1, Math.min(21, S)) : Math.max(0, Math.min(20, S));
    function v(w) {
      var C = N, P = O, Y, V, k;
      if (M === "c")
        P = A(w) + P, w = "";
      else {
        w = +w;
        var T = w < 0;
        if (w = A(Math.abs(w), S), T && +w == 0 && (T = !1), C = (T ? y === "(" ? y : "-" : y === "-" || y === "(" ? "" : y) + C, P = (M === "s" ? t1[8 + Gx / 3] : "") + P + (T && y === "(" ? ")" : ""), x) {
          for (Y = -1, V = w.length; ++Y < V; )
            if (k = w.charCodeAt(Y), 48 > k || k > 57) {
              P = (k === 46 ? r + w.slice(Y + 1) : w.slice(Y)) + P, w = w.slice(0, Y);
              break;
            }
        }
      }
      E && !m && (w = e(w, 1 / 0));
      var R = C.length + w.length + P.length, F = R < b ? new Array(b - R + 1).join(d) : "";
      switch (E && m && (w = e(F + w, F.length ? b - P.length : 1 / 0), F = ""), g) {
        case "<":
          w = C + w + P + F;
          break;
        case "=":
          w = C + F + w + P;
          break;
        case "^":
          w = F.slice(0, R = F.length >> 1) + C + w + P + F.slice(R);
          break;
        default:
          w = F + C + w + P;
          break;
      }
      return a(w);
    }
    return v.toString = function() {
      return l + "";
    }, v;
  }
  function c(l, d) {
    var g = u((l = Es(l), l.type = "f", l)), y = Math.max(-8, Math.min(8, Math.floor(Xa(d) / 3))) * 3, f = Math.pow(10, -y), m = t1[8 + y / 3];
    return function(b) {
      return g(f * b) + m;
    };
  }
  return {
    format: u,
    formatPrefix: c
  };
}
var Xu, Yt, $s;
Xx({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function Xx(t) {
  return Xu = Hx(t), Yt = Xu.format, $s = Xu.formatPrefix, Xu;
}
function Qx(t) {
  return Math.max(0, -Xa(Math.abs(t)));
}
function Kx(t, e) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Xa(e) / 3))) * 3 - Xa(Math.abs(t)));
}
function Zx(t, e) {
  return t = Math.abs(t), e = Math.abs(e) - t, Math.max(0, Xa(e) - Xa(t)) + 1;
}
function Ai() {
  return new Bc();
}
function Bc() {
  this.reset();
}
Bc.prototype = {
  constructor: Bc,
  reset: function() {
    this.s = // rounded value
    this.t = 0;
  },
  add: function(t) {
    e1(Qu, t, this.t), e1(this, Qu.s, this.s), this.s ? this.t += Qu.t : this.s = Qu.t;
  },
  valueOf: function() {
    return this.s;
  }
};
var Qu = new Bc();
function e1(t, e, n) {
  var r = t.s = e + n, a = r - e, o = r - a;
  t.t = e - o + (n - a);
}
var Mt = 1e-6, n1 = 1e-12, ae = Math.PI, Ne = ae / 2, Fc = ae / 4, Rn = ae * 2, xe = 180 / ae, It = ae / 180, ce = Math.abs, so = Math.atan, vn = Math.atan2, Dt = Math.cos, Ku = Math.ceil, Jx = Math.exp, Uc = Math.log, Yh = Math.pow, At = Math.sin, Ss = Math.sign || function(t) {
  return t > 0 ? 1 : t < 0 ? -1 : 0;
}, ze = Math.sqrt, Fp = Math.tan;
function t_(t) {
  return t > 1 ? 0 : t < -1 ? ae : Math.acos(t);
}
function Un(t) {
  return t > 1 ? Ne : t < -1 ? -Ne : Math.asin(t);
}
function r1(t) {
  return (t = At(t / 2)) * t;
}
function Ee() {
}
function $c(t, e) {
  t && a1.hasOwnProperty(t.type) && a1[t.type](t, e);
}
var i1 = {
  Feature: function(t, e) {
    $c(t.geometry, e);
  },
  FeatureCollection: function(t, e) {
    for (var n = t.features, r = -1, a = n.length; ++r < a; ) $c(n[r].geometry, e);
  }
}, a1 = {
  Sphere: function(t, e) {
    e.sphere();
  },
  Point: function(t, e) {
    t = t.coordinates, e.point(t[0], t[1], t[2]);
  },
  MultiPoint: function(t, e) {
    for (var n = t.coordinates, r = -1, a = n.length; ++r < a; ) t = n[r], e.point(t[0], t[1], t[2]);
  },
  LineString: function(t, e) {
    Ld(t.coordinates, e, 0);
  },
  MultiLineString: function(t, e) {
    for (var n = t.coordinates, r = -1, a = n.length; ++r < a; ) Ld(n[r], e, 0);
  },
  Polygon: function(t, e) {
    o1(t.coordinates, e);
  },
  MultiPolygon: function(t, e) {
    for (var n = t.coordinates, r = -1, a = n.length; ++r < a; ) o1(n[r], e);
  },
  GeometryCollection: function(t, e) {
    for (var n = t.geometries, r = -1, a = n.length; ++r < a; ) $c(n[r], e);
  }
};
function Ld(t, e, n) {
  var r = -1, a = t.length - n, o;
  for (e.lineStart(); ++r < a; ) o = t[r], e.point(o[0], o[1], o[2]);
  e.lineEnd();
}
function o1(t, e) {
  var n = -1, r = t.length;
  for (e.polygonStart(); ++n < r; ) Ld(t[n], e, 1);
  e.polygonEnd();
}
function or(t, e) {
  t && i1.hasOwnProperty(t.type) ? i1[t.type](t, e) : $c(t, e);
}
var zc = Ai(), Vc = Ai(), e_, n_, Pd, Nd, Id, Rr = {
  point: Ee,
  lineStart: Ee,
  lineEnd: Ee,
  polygonStart: function() {
    zc.reset(), Rr.lineStart = Z3, Rr.lineEnd = J3;
  },
  polygonEnd: function() {
    var t = +zc;
    Vc.add(t < 0 ? Rn + t : t), this.lineStart = this.lineEnd = this.point = Ee;
  },
  sphere: function() {
    Vc.add(Rn);
  }
};
function Z3() {
  Rr.point = tj;
}
function J3() {
  r_(e_, n_);
}
function tj(t, e) {
  Rr.point = r_, e_ = t, n_ = e, t *= It, e *= It, Pd = t, Nd = Dt(e = e / 2 + Fc), Id = At(e);
}
function r_(t, e) {
  t *= It, e *= It, e = e / 2 + Fc;
  var n = t - Pd, r = n >= 0 ? 1 : -1, a = r * n, o = Dt(e), u = At(e), c = Id * u, l = Nd * o + c * Dt(a), d = c * r * At(a);
  zc.add(vn(d, l)), Pd = t, Nd = o, Id = u;
}
function ej(t) {
  return Vc.reset(), or(t, Rr), Vc * 2;
}
function Yc(t) {
  return [vn(t[1], t[0]), Un(t[2])];
}
function Zi(t) {
  var e = t[0], n = t[1], r = Dt(n);
  return [r * Dt(e), r * At(e), At(n)];
}
function Zu(t, e) {
  return t[0] * e[0] + t[1] * e[1] + t[2] * e[2];
}
function Qa(t, e) {
  return [t[1] * e[2] - t[2] * e[1], t[2] * e[0] - t[0] * e[2], t[0] * e[1] - t[1] * e[0]];
}
function Wh(t, e) {
  t[0] += e[0], t[1] += e[1], t[2] += e[2];
}
function Ju(t, e) {
  return [t[0] * e, t[1] * e, t[2] * e];
}
function Wc(t) {
  var e = ze(t[0] * t[0] + t[1] * t[1] + t[2] * t[2]);
  t[0] /= e, t[1] /= e, t[2] /= e;
}
var Te, kn, Le, Zn, zi, i_, a_, za, os = Ai(), ci, qr, $r = {
  point: jd,
  lineStart: s1,
  lineEnd: u1,
  polygonStart: function() {
    $r.point = s_, $r.lineStart = nj, $r.lineEnd = rj, os.reset(), Rr.polygonStart();
  },
  polygonEnd: function() {
    Rr.polygonEnd(), $r.point = jd, $r.lineStart = s1, $r.lineEnd = u1, zc < 0 ? (Te = -(Le = 180), kn = -(Zn = 90)) : os > Mt ? Zn = 90 : os < -Mt && (kn = -90), qr[0] = Te, qr[1] = Le;
  }
};
function jd(t, e) {
  ci.push(qr = [Te = t, Le = t]), e < kn && (kn = e), e > Zn && (Zn = e);
}
function o_(t, e) {
  var n = Zi([t * It, e * It]);
  if (za) {
    var r = Qa(za, n), a = [r[1], -r[0], 0], o = Qa(a, r);
    Wc(o), o = Yc(o);
    var u = t - zi, c = u > 0 ? 1 : -1, l = o[0] * xe * c, d, g = ce(u) > 180;
    g ^ (c * zi < l && l < c * t) ? (d = o[1] * xe, d > Zn && (Zn = d)) : (l = (l + 360) % 360 - 180, g ^ (c * zi < l && l < c * t) ? (d = -o[1] * xe, d < kn && (kn = d)) : (e < kn && (kn = e), e > Zn && (Zn = e))), g ? t < zi ? In(Te, t) > In(Te, Le) && (Le = t) : In(t, Le) > In(Te, Le) && (Te = t) : Le >= Te ? (t < Te && (Te = t), t > Le && (Le = t)) : t > zi ? In(Te, t) > In(Te, Le) && (Le = t) : In(t, Le) > In(Te, Le) && (Te = t);
  } else
    ci.push(qr = [Te = t, Le = t]);
  e < kn && (kn = e), e > Zn && (Zn = e), za = n, zi = t;
}
function s1() {
  $r.point = o_;
}
function u1() {
  qr[0] = Te, qr[1] = Le, $r.point = jd, za = null;
}
function s_(t, e) {
  if (za) {
    var n = t - zi;
    os.add(ce(n) > 180 ? n + (n > 0 ? 360 : -360) : n);
  } else
    i_ = t, a_ = e;
  Rr.point(t, e), o_(t, e);
}
function nj() {
  Rr.lineStart();
}
function rj() {
  s_(i_, a_), Rr.lineEnd(), ce(os) > Mt && (Te = -(Le = 180)), qr[0] = Te, qr[1] = Le, za = null;
}
function In(t, e) {
  return (e -= t) < 0 ? e + 360 : e;
}
function ij(t, e) {
  return t[0] - e[0];
}
function c1(t, e) {
  return t[0] <= t[1] ? t[0] <= e && e <= t[1] : e < t[0] || t[1] < e;
}
function aj(t) {
  var e, n, r, a, o, u, c;
  if (Zn = Le = -(Te = kn = 1 / 0), ci = [], or(t, $r), n = ci.length) {
    for (ci.sort(ij), e = 1, r = ci[0], o = [r]; e < n; ++e)
      a = ci[e], c1(r, a[0]) || c1(r, a[1]) ? (In(r[0], a[1]) > In(r[0], r[1]) && (r[1] = a[1]), In(a[0], r[1]) > In(r[0], r[1]) && (r[0] = a[0])) : o.push(r = a);
    for (u = -1 / 0, n = o.length - 1, e = 0, r = o[n]; e <= n; r = a, ++e)
      a = o[e], (c = In(r[1], a[0])) > u && (u = c, Te = a[0], Le = r[1]);
  }
  return ci = qr = null, Te === 1 / 0 || kn === 1 / 0 ? [[NaN, NaN], [NaN, NaN]] : [[Te, kn], [Le, Zn]];
}
var Yo, Gc, qc, Hc, Xc, Qc, Kc, Zc, kd, Bd, Fd, u_, c_, dn, pn, gn, ur = {
  sphere: Ee,
  point: Up,
  lineStart: l1,
  lineEnd: f1,
  polygonStart: function() {
    ur.lineStart = uj, ur.lineEnd = cj;
  },
  polygonEnd: function() {
    ur.lineStart = l1, ur.lineEnd = f1;
  }
};
function Up(t, e) {
  t *= It, e *= It;
  var n = Dt(e);
  zs(n * Dt(t), n * At(t), At(e));
}
function zs(t, e, n) {
  ++Yo, qc += (t - qc) / Yo, Hc += (e - Hc) / Yo, Xc += (n - Xc) / Yo;
}
function l1() {
  ur.point = oj;
}
function oj(t, e) {
  t *= It, e *= It;
  var n = Dt(e);
  dn = n * Dt(t), pn = n * At(t), gn = At(e), ur.point = sj, zs(dn, pn, gn);
}
function sj(t, e) {
  t *= It, e *= It;
  var n = Dt(e), r = n * Dt(t), a = n * At(t), o = At(e), u = vn(ze((u = pn * o - gn * a) * u + (u = gn * r - dn * o) * u + (u = dn * a - pn * r) * u), dn * r + pn * a + gn * o);
  Gc += u, Qc += u * (dn + (dn = r)), Kc += u * (pn + (pn = a)), Zc += u * (gn + (gn = o)), zs(dn, pn, gn);
}
function f1() {
  ur.point = Up;
}
function uj() {
  ur.point = lj;
}
function cj() {
  l_(u_, c_), ur.point = Up;
}
function lj(t, e) {
  u_ = t, c_ = e, t *= It, e *= It, ur.point = l_;
  var n = Dt(e);
  dn = n * Dt(t), pn = n * At(t), gn = At(e), zs(dn, pn, gn);
}
function l_(t, e) {
  t *= It, e *= It;
  var n = Dt(e), r = n * Dt(t), a = n * At(t), o = At(e), u = pn * o - gn * a, c = gn * r - dn * o, l = dn * a - pn * r, d = ze(u * u + c * c + l * l), g = Un(d), y = d && -g / d;
  kd += y * u, Bd += y * c, Fd += y * l, Gc += g, Qc += g * (dn + (dn = r)), Kc += g * (pn + (pn = a)), Zc += g * (gn + (gn = o)), zs(dn, pn, gn);
}
function fj(t) {
  Yo = Gc = qc = Hc = Xc = Qc = Kc = Zc = kd = Bd = Fd = 0, or(t, ur);
  var e = kd, n = Bd, r = Fd, a = e * e + n * n + r * r;
  return a < n1 && (e = Qc, n = Kc, r = Zc, Gc < Mt && (e = qc, n = Hc, r = Xc), a = e * e + n * n + r * r, a < n1) ? [NaN, NaN] : [vn(n, e) * xe, Un(r / ze(a)) * xe];
}
function Ta(t) {
  return function() {
    return t;
  };
}
function f_(t, e) {
  function n(r, a) {
    return r = t(r, a), e(r[0], r[1]);
  }
  return t.invert && e.invert && (n.invert = function(r, a) {
    return r = e.invert(r, a), r && t.invert(r[0], r[1]);
  }), n;
}
function Ud(t, e) {
  return [t > ae ? t - Rn : t < -ae ? t + Rn : t, e];
}
Ud.invert = Ud;
function $p(t, e, n) {
  return (t %= Rn) ? e || n ? f_(d1(t), p1(e, n)) : d1(t) : e || n ? p1(e, n) : Ud;
}
function h1(t) {
  return function(e, n) {
    return e += t, [e > ae ? e - Rn : e < -ae ? e + Rn : e, n];
  };
}
function d1(t) {
  var e = h1(t);
  return e.invert = h1(-t), e;
}
function p1(t, e) {
  var n = Dt(t), r = At(t), a = Dt(e), o = At(e);
  function u(c, l) {
    var d = Dt(l), g = Dt(c) * d, y = At(c) * d, f = At(l), m = f * n + g * r;
    return [
      vn(y * a - m * o, g * n - f * r),
      Un(m * a + y * o)
    ];
  }
  return u.invert = function(c, l) {
    var d = Dt(l), g = Dt(c) * d, y = At(c) * d, f = At(l), m = f * a - y * o;
    return [
      vn(y * a + f * o, g * n + m * r),
      Un(m * n - g * r)
    ];
  }, u;
}
function h_(t) {
  t = $p(t[0] * It, t[1] * It, t.length > 2 ? t[2] * It : 0);
  function e(n) {
    return n = t(n[0] * It, n[1] * It), n[0] *= xe, n[1] *= xe, n;
  }
  return e.invert = function(n) {
    return n = t.invert(n[0] * It, n[1] * It), n[0] *= xe, n[1] *= xe, n;
  }, e;
}
function d_(t, e, n, r, a, o) {
  if (n) {
    var u = Dt(e), c = At(e), l = r * n;
    a == null ? (a = e + r * Rn, o = e - l / 2) : (a = g1(u, a), o = g1(u, o), (r > 0 ? a < o : a > o) && (a += r * Rn));
    for (var d, g = a; r > 0 ? g > o : g < o; g -= l)
      d = Yc([u, -c * Dt(g), -c * At(g)]), t.point(d[0], d[1]);
  }
}
function g1(t, e) {
  e = Zi(e), e[0] -= t, Wc(e);
  var n = t_(-e[1]);
  return ((-e[2] < 0 ? -n : n) + Rn - Mt) % Rn;
}
function hj() {
  var t = Ta([0, 0]), e = Ta(90), n = Ta(6), r, a, o = { point: u };
  function u(l, d) {
    r.push(l = a(l, d)), l[0] *= xe, l[1] *= xe;
  }
  function c() {
    var l = t.apply(this, arguments), d = e.apply(this, arguments) * It, g = n.apply(this, arguments) * It;
    return r = [], a = $p(-l[0] * It, -l[1] * It, 0).invert, d_(o, d, g, 1), l = { type: "Polygon", coordinates: [r] }, r = a = null, l;
  }
  return c.center = function(l) {
    return arguments.length ? (t = typeof l == "function" ? l : Ta([+l[0], +l[1]]), c) : t;
  }, c.radius = function(l) {
    return arguments.length ? (e = typeof l == "function" ? l : Ta(+l), c) : e;
  }, c.precision = function(l) {
    return arguments.length ? (n = typeof l == "function" ? l : Ta(+l), c) : n;
  }, c;
}
function p_() {
  var t = [], e;
  return {
    point: function(n, r) {
      e.push([n, r]);
    },
    lineStart: function() {
      t.push(e = []);
    },
    lineEnd: Ee,
    rejoin: function() {
      t.length > 1 && t.push(t.pop().concat(t.shift()));
    },
    result: function() {
      var n = t;
      return t = [], e = null, n;
    }
  };
}
function xc(t, e) {
  return ce(t[0] - e[0]) < Mt && ce(t[1] - e[1]) < Mt;
}
function tc(t, e, n, r) {
  this.x = t, this.z = e, this.o = n, this.e = r, this.v = !1, this.n = this.p = null;
}
function g_(t, e, n, r, a) {
  var o = [], u = [], c, l;
  if (t.forEach(function(b) {
    if (!((E = b.length - 1) <= 0)) {
      var E, S = b[0], M = b[E], N;
      if (xc(S, M)) {
        for (a.lineStart(), c = 0; c < E; ++c) a.point((S = b[c])[0], S[1]);
        a.lineEnd();
        return;
      }
      o.push(N = new tc(S, b, null, !0)), u.push(N.o = new tc(S, null, N, !1)), o.push(N = new tc(M, b, null, !1)), u.push(N.o = new tc(M, null, N, !0));
    }
  }), !!o.length) {
    for (u.sort(e), m1(o), m1(u), c = 0, l = u.length; c < l; ++c)
      u[c].e = n = !n;
    for (var d = o[0], g, y; ; ) {
      for (var f = d, m = !0; f.v; ) if ((f = f.n) === d) return;
      g = f.z, a.lineStart();
      do {
        if (f.v = f.o.v = !0, f.e) {
          if (m)
            for (c = 0, l = g.length; c < l; ++c) a.point((y = g[c])[0], y[1]);
          else
            r(f.x, f.n.x, 1, a);
          f = f.n;
        } else {
          if (m)
            for (g = f.p.z, c = g.length - 1; c >= 0; --c) a.point((y = g[c])[0], y[1]);
          else
            r(f.x, f.p.x, -1, a);
          f = f.p;
        }
        f = f.o, g = f.z, m = !m;
      } while (!f.v);
      a.lineEnd();
    }
  }
}
function m1(t) {
  if (e = t.length) {
    for (var e, n = 0, r = t[0], a; ++n < e; )
      r.n = a = t[n], a.p = r, r = a;
    r.n = a = t[0], a.p = r;
  }
}
var Gh = Ai();
function m_(t, e) {
  var n = e[0], r = e[1], a = [At(n), -Dt(n), 0], o = 0, u = 0;
  Gh.reset();
  for (var c = 0, l = t.length; c < l; ++c)
    if (g = (d = t[c]).length)
      for (var d, g, y = d[g - 1], f = y[0], m = y[1] / 2 + Fc, b = At(m), E = Dt(m), S = 0; S < g; ++S, f = N, b = A, E = x, y = M) {
        var M = d[S], N = M[0], O = M[1] / 2 + Fc, A = At(O), x = Dt(O), v = N - f, w = v >= 0 ? 1 : -1, C = w * v, P = C > ae, Y = b * A;
        if (Gh.add(vn(Y * w * At(C), E * x + Y * Dt(C))), o += P ? v + w * Rn : v, P ^ f >= n ^ N >= n) {
          var V = Qa(Zi(y), Zi(M));
          Wc(V);
          var k = Qa(a, V);
          Wc(k);
          var T = (P ^ v >= 0 ? -1 : 1) * Un(k[2]);
          (r > T || r === T && (V[0] || V[1])) && (u += P ^ v >= 0 ? 1 : -1);
        }
      }
  return (o < -Mt || o < Mt && Gh < -Mt) ^ u & 1;
}
function y_(t, e, n, r) {
  return function(a) {
    var o = e(a), u = p_(), c = e(u), l = !1, d, g, y, f = {
      point: m,
      lineStart: E,
      lineEnd: S,
      polygonStart: function() {
        f.point = M, f.lineStart = N, f.lineEnd = O, g = [], d = [];
      },
      polygonEnd: function() {
        f.point = m, f.lineStart = E, f.lineEnd = S, g = gp(g);
        var A = m_(d, r);
        g.length ? (l || (a.polygonStart(), l = !0), g_(g, pj, A, n, a)) : A && (l || (a.polygonStart(), l = !0), a.lineStart(), n(null, null, 1, a), a.lineEnd()), l && (a.polygonEnd(), l = !1), g = d = null;
      },
      sphere: function() {
        a.polygonStart(), a.lineStart(), n(null, null, 1, a), a.lineEnd(), a.polygonEnd();
      }
    };
    function m(A, x) {
      t(A, x) && a.point(A, x);
    }
    function b(A, x) {
      o.point(A, x);
    }
    function E() {
      f.point = b, o.lineStart();
    }
    function S() {
      f.point = m, o.lineEnd();
    }
    function M(A, x) {
      y.push([A, x]), c.point(A, x);
    }
    function N() {
      c.lineStart(), y = [];
    }
    function O() {
      M(y[0][0], y[0][1]), c.lineEnd();
      var A = c.clean(), x = u.result(), v, w = x.length, C, P, Y;
      if (y.pop(), d.push(y), y = null, !!w) {
        if (A & 1) {
          if (P = x[0], (C = P.length - 1) > 0) {
            for (l || (a.polygonStart(), l = !0), a.lineStart(), v = 0; v < C; ++v) a.point((Y = P[v])[0], Y[1]);
            a.lineEnd();
          }
          return;
        }
        w > 1 && A & 2 && x.push(x.pop().concat(x.shift())), g.push(x.filter(dj));
      }
    }
    return f;
  };
}
function dj(t) {
  return t.length > 1;
}
function pj(t, e) {
  return ((t = t.x)[0] < 0 ? t[1] - Ne - Mt : Ne - t[1]) - ((e = e.x)[0] < 0 ? e[1] - Ne - Mt : Ne - e[1]);
}
const $d = y_(
  function() {
    return !0;
  },
  gj,
  yj,
  [-ae, -Ne]
);
function gj(t) {
  var e = NaN, n = NaN, r = NaN, a;
  return {
    lineStart: function() {
      t.lineStart(), a = 1;
    },
    point: function(o, u) {
      var c = o > 0 ? ae : -ae, l = ce(o - e);
      ce(l - ae) < Mt ? (t.point(e, n = (n + u) / 2 > 0 ? Ne : -Ne), t.point(r, n), t.lineEnd(), t.lineStart(), t.point(c, n), t.point(o, n), a = 0) : r !== c && l >= ae && (ce(e - r) < Mt && (e -= r * Mt), ce(o - c) < Mt && (o -= c * Mt), n = mj(e, n, o, u), t.point(r, n), t.lineEnd(), t.lineStart(), t.point(c, n), a = 0), t.point(e = o, n = u), r = c;
    },
    lineEnd: function() {
      t.lineEnd(), e = n = NaN;
    },
    clean: function() {
      return 2 - a;
    }
  };
}
function mj(t, e, n, r) {
  var a, o, u = At(t - n);
  return ce(u) > Mt ? so((At(e) * (o = Dt(r)) * At(n) - At(r) * (a = Dt(e)) * At(t)) / (a * o * u)) : (e + r) / 2;
}
function yj(t, e, n, r) {
  var a;
  if (t == null)
    a = n * Ne, r.point(-ae, a), r.point(0, a), r.point(ae, a), r.point(ae, 0), r.point(ae, -a), r.point(0, -a), r.point(-ae, -a), r.point(-ae, 0), r.point(-ae, a);
  else if (ce(t[0] - e[0]) > Mt) {
    var o = t[0] < e[0] ? ae : -ae;
    a = n * o / 2, r.point(-o, a), r.point(0, a), r.point(o, a);
  } else
    r.point(e[0], e[1]);
}
function v_(t) {
  var e = Dt(t), n = 6 * It, r = e > 0, a = ce(e) > Mt;
  function o(g, y, f, m) {
    d_(m, t, n, f, g, y);
  }
  function u(g, y) {
    return Dt(g) * Dt(y) > e;
  }
  function c(g) {
    var y, f, m, b, E;
    return {
      lineStart: function() {
        b = m = !1, E = 1;
      },
      point: function(S, M) {
        var N = [S, M], O, A = u(S, M), x = r ? A ? 0 : d(S, M) : A ? d(S + (S < 0 ? ae : -ae), M) : 0;
        if (!y && (b = m = A) && g.lineStart(), A !== m && (O = l(y, N), (!O || xc(y, O) || xc(N, O)) && (N[0] += Mt, N[1] += Mt, A = u(N[0], N[1]))), A !== m)
          E = 0, A ? (g.lineStart(), O = l(N, y), g.point(O[0], O[1])) : (O = l(y, N), g.point(O[0], O[1]), g.lineEnd()), y = O;
        else if (a && y && r ^ A) {
          var v;
          !(x & f) && (v = l(N, y, !0)) && (E = 0, r ? (g.lineStart(), g.point(v[0][0], v[0][1]), g.point(v[1][0], v[1][1]), g.lineEnd()) : (g.point(v[1][0], v[1][1]), g.lineEnd(), g.lineStart(), g.point(v[0][0], v[0][1])));
        }
        A && (!y || !xc(y, N)) && g.point(N[0], N[1]), y = N, m = A, f = x;
      },
      lineEnd: function() {
        m && g.lineEnd(), y = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return E | (b && m) << 1;
      }
    };
  }
  function l(g, y, f) {
    var m = Zi(g), b = Zi(y), E = [1, 0, 0], S = Qa(m, b), M = Zu(S, S), N = S[0], O = M - N * N;
    if (!O) return !f && g;
    var A = e * M / O, x = -e * N / O, v = Qa(E, S), w = Ju(E, A), C = Ju(S, x);
    Wh(w, C);
    var P = v, Y = Zu(w, P), V = Zu(P, P), k = Y * Y - V * (Zu(w, w) - 1);
    if (!(k < 0)) {
      var T = ze(k), R = Ju(P, (-Y - T) / V);
      if (Wh(R, w), R = Yc(R), !f) return R;
      var F = g[0], U = y[0], H = g[1], W = y[1], B;
      U < F && (B = F, F = U, U = B);
      var j = U - F, X = ce(j - ae) < Mt, tt = X || j < Mt;
      if (!X && W < H && (B = H, H = W, W = B), tt ? X ? H + W > 0 ^ R[1] < (ce(R[0] - F) < Mt ? H : W) : H <= R[1] && R[1] <= W : j > ae ^ (F <= R[0] && R[0] <= U)) {
        var et = Ju(P, (-Y + T) / V);
        return Wh(et, w), [R, Yc(et)];
      }
    }
  }
  function d(g, y) {
    var f = r ? t : ae - t, m = 0;
    return g < -f ? m |= 1 : g > f && (m |= 2), y < -f ? m |= 4 : y > f && (m |= 8), m;
  }
  return y_(u, c, o, r ? [0, -t] : [-ae, t - ae]);
}
function vj(t, e, n, r, a, o) {
  var u = t[0], c = t[1], l = e[0], d = e[1], g = 0, y = 1, f = l - u, m = d - c, b;
  if (b = n - u, !(!f && b > 0)) {
    if (b /= f, f < 0) {
      if (b < g) return;
      b < y && (y = b);
    } else if (f > 0) {
      if (b > y) return;
      b > g && (g = b);
    }
    if (b = a - u, !(!f && b < 0)) {
      if (b /= f, f < 0) {
        if (b > y) return;
        b > g && (g = b);
      } else if (f > 0) {
        if (b < g) return;
        b < y && (y = b);
      }
      if (b = r - c, !(!m && b > 0)) {
        if (b /= m, m < 0) {
          if (b < g) return;
          b < y && (y = b);
        } else if (m > 0) {
          if (b > y) return;
          b > g && (g = b);
        }
        if (b = o - c, !(!m && b < 0)) {
          if (b /= m, m < 0) {
            if (b > y) return;
            b > g && (g = b);
          } else if (m > 0) {
            if (b < g) return;
            b < y && (y = b);
          }
          return g > 0 && (t[0] = u + g * f, t[1] = c + g * m), y < 1 && (e[0] = u + y * f, e[1] = c + y * m), !0;
        }
      }
    }
  }
}
var Wo = 1e9, ec = -Wo;
function Bl(t, e, n, r) {
  function a(d, g) {
    return t <= d && d <= n && e <= g && g <= r;
  }
  function o(d, g, y, f) {
    var m = 0, b = 0;
    if (d == null || (m = u(d, y)) !== (b = u(g, y)) || l(d, g) < 0 ^ y > 0)
      do
        f.point(m === 0 || m === 3 ? t : n, m > 1 ? r : e);
      while ((m = (m + y + 4) % 4) !== b);
    else
      f.point(g[0], g[1]);
  }
  function u(d, g) {
    return ce(d[0] - t) < Mt ? g > 0 ? 0 : 3 : ce(d[0] - n) < Mt ? g > 0 ? 2 : 1 : ce(d[1] - e) < Mt ? g > 0 ? 1 : 0 : g > 0 ? 3 : 2;
  }
  function c(d, g) {
    return l(d.x, g.x);
  }
  function l(d, g) {
    var y = u(d, 1), f = u(g, 1);
    return y !== f ? y - f : y === 0 ? g[1] - d[1] : y === 1 ? d[0] - g[0] : y === 2 ? d[1] - g[1] : g[0] - d[0];
  }
  return function(d) {
    var g = d, y = p_(), f, m, b, E, S, M, N, O, A, x, v, w = {
      point: C,
      lineStart: k,
      lineEnd: T,
      polygonStart: Y,
      polygonEnd: V
    };
    function C(F, U) {
      a(F, U) && g.point(F, U);
    }
    function P() {
      for (var F = 0, U = 0, H = m.length; U < H; ++U)
        for (var W = m[U], B = 1, j = W.length, X = W[0], tt, et, ot = X[0], Z = X[1]; B < j; ++B)
          tt = ot, et = Z, X = W[B], ot = X[0], Z = X[1], et <= r ? Z > r && (ot - tt) * (r - et) > (Z - et) * (t - tt) && ++F : Z <= r && (ot - tt) * (r - et) < (Z - et) * (t - tt) && --F;
      return F;
    }
    function Y() {
      g = y, f = [], m = [], v = !0;
    }
    function V() {
      var F = P(), U = v && F, H = (f = gp(f)).length;
      (U || H) && (d.polygonStart(), U && (d.lineStart(), o(null, null, 1, d), d.lineEnd()), H && g_(f, c, F, o, d), d.polygonEnd()), g = d, f = m = b = null;
    }
    function k() {
      w.point = R, m && m.push(b = []), x = !0, A = !1, N = O = NaN;
    }
    function T() {
      f && (R(E, S), M && A && y.rejoin(), f.push(y.result())), w.point = C, A && g.lineEnd();
    }
    function R(F, U) {
      var H = a(F, U);
      if (m && b.push([F, U]), x)
        E = F, S = U, M = H, x = !1, H && (g.lineStart(), g.point(F, U));
      else if (H && A) g.point(F, U);
      else {
        var W = [N = Math.max(ec, Math.min(Wo, N)), O = Math.max(ec, Math.min(Wo, O))], B = [F = Math.max(ec, Math.min(Wo, F)), U = Math.max(ec, Math.min(Wo, U))];
        vj(W, B, t, e, n, r) ? (A || (g.lineStart(), g.point(W[0], W[1])), g.point(B[0], B[1]), H || g.lineEnd(), v = !1) : H && (g.lineStart(), g.point(F, U), v = !1);
      }
      N = F, O = U, A = H;
    }
    return w;
  };
}
function xj() {
  var t = 0, e = 0, n = 960, r = 500, a, o, u;
  return u = {
    stream: function(c) {
      return a && o === c ? a : a = Bl(t, e, n, r)(o = c);
    },
    extent: function(c) {
      return arguments.length ? (t = +c[0][0], e = +c[0][1], n = +c[1][0], r = +c[1][1], a = o = null, u) : [[t, e], [n, r]];
    }
  };
}
var zd = Ai(), Vd, _c, bc, Ka = {
  sphere: Ee,
  point: Ee,
  lineStart: _j,
  lineEnd: Ee,
  polygonStart: Ee,
  polygonEnd: Ee
};
function _j() {
  Ka.point = wj, Ka.lineEnd = bj;
}
function bj() {
  Ka.point = Ka.lineEnd = Ee;
}
function wj(t, e) {
  t *= It, e *= It, Vd = t, _c = At(e), bc = Dt(e), Ka.point = Ej;
}
function Ej(t, e) {
  t *= It, e *= It;
  var n = At(e), r = Dt(e), a = ce(t - Vd), o = Dt(a), u = At(a), c = r * u, l = bc * n - _c * r * o, d = _c * n + bc * r * o;
  zd.add(vn(ze(c * c + l * l), d)), Vd = t, _c = n, bc = r;
}
function x_(t) {
  return zd.reset(), or(t, Ka), +zd;
}
var Yd = [null, null], Sj = { type: "LineString", coordinates: Yd };
function ss(t, e) {
  return Yd[0] = t, Yd[1] = e, x_(Sj);
}
var y1 = {
  Feature: function(t, e) {
    return Jc(t.geometry, e);
  },
  FeatureCollection: function(t, e) {
    for (var n = t.features, r = -1, a = n.length; ++r < a; ) if (Jc(n[r].geometry, e)) return !0;
    return !1;
  }
}, v1 = {
  Sphere: function() {
    return !0;
  },
  Point: function(t, e) {
    return x1(t.coordinates, e);
  },
  MultiPoint: function(t, e) {
    for (var n = t.coordinates, r = -1, a = n.length; ++r < a; ) if (x1(n[r], e)) return !0;
    return !1;
  },
  LineString: function(t, e) {
    return _1(t.coordinates, e);
  },
  MultiLineString: function(t, e) {
    for (var n = t.coordinates, r = -1, a = n.length; ++r < a; ) if (_1(n[r], e)) return !0;
    return !1;
  },
  Polygon: function(t, e) {
    return b1(t.coordinates, e);
  },
  MultiPolygon: function(t, e) {
    for (var n = t.coordinates, r = -1, a = n.length; ++r < a; ) if (b1(n[r], e)) return !0;
    return !1;
  },
  GeometryCollection: function(t, e) {
    for (var n = t.geometries, r = -1, a = n.length; ++r < a; ) if (Jc(n[r], e)) return !0;
    return !1;
  }
};
function Jc(t, e) {
  return t && v1.hasOwnProperty(t.type) ? v1[t.type](t, e) : !1;
}
function x1(t, e) {
  return ss(t, e) === 0;
}
function _1(t, e) {
  var n = ss(t[0], t[1]), r = ss(t[0], e), a = ss(e, t[1]);
  return r + a <= n + Mt;
}
function b1(t, e) {
  return !!m_(t.map(Aj), __(e));
}
function Aj(t) {
  return t = t.map(__), t.pop(), t;
}
function __(t) {
  return [t[0] * It, t[1] * It];
}
function Tj(t, e) {
  return (t && y1.hasOwnProperty(t.type) ? y1[t.type] : Jc)(t, e);
}
function w1(t, e, n) {
  var r = tr(t, e - Mt, n).concat(e);
  return function(a) {
    return r.map(function(o) {
      return [a, o];
    });
  };
}
function E1(t, e, n) {
  var r = tr(t, e - Mt, n).concat(e);
  return function(a) {
    return r.map(function(o) {
      return [o, a];
    });
  };
}
function b_() {
  var t, e, n, r, a, o, u, c, l = 10, d = l, g = 90, y = 360, f, m, b, E, S = 2.5;
  function M() {
    return { type: "MultiLineString", coordinates: N() };
  }
  function N() {
    return tr(Ku(r / g) * g, n, g).map(b).concat(tr(Ku(c / y) * y, u, y).map(E)).concat(tr(Ku(e / l) * l, t, l).filter(function(O) {
      return ce(O % g) > Mt;
    }).map(f)).concat(tr(Ku(o / d) * d, a, d).filter(function(O) {
      return ce(O % y) > Mt;
    }).map(m));
  }
  return M.lines = function() {
    return N().map(function(O) {
      return { type: "LineString", coordinates: O };
    });
  }, M.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        b(r).concat(
          E(u).slice(1),
          b(n).reverse().slice(1),
          E(c).reverse().slice(1)
        )
      ]
    };
  }, M.extent = function(O) {
    return arguments.length ? M.extentMajor(O).extentMinor(O) : M.extentMinor();
  }, M.extentMajor = function(O) {
    return arguments.length ? (r = +O[0][0], n = +O[1][0], c = +O[0][1], u = +O[1][1], r > n && (O = r, r = n, n = O), c > u && (O = c, c = u, u = O), M.precision(S)) : [[r, c], [n, u]];
  }, M.extentMinor = function(O) {
    return arguments.length ? (e = +O[0][0], t = +O[1][0], o = +O[0][1], a = +O[1][1], e > t && (O = e, e = t, t = O), o > a && (O = o, o = a, a = O), M.precision(S)) : [[e, o], [t, a]];
  }, M.step = function(O) {
    return arguments.length ? M.stepMajor(O).stepMinor(O) : M.stepMinor();
  }, M.stepMajor = function(O) {
    return arguments.length ? (g = +O[0], y = +O[1], M) : [g, y];
  }, M.stepMinor = function(O) {
    return arguments.length ? (l = +O[0], d = +O[1], M) : [l, d];
  }, M.precision = function(O) {
    return arguments.length ? (S = +O, f = w1(o, a, 90), m = E1(e, t, S), b = w1(c, u, 90), E = E1(r, n, S), M) : S;
  }, M.extentMajor([[-180, -90 + Mt], [180, 90 - Mt]]).extentMinor([[-180, -80 - Mt], [180, 80 + Mt]]);
}
function Cj() {
  return b_()();
}
function Rj(t, e) {
  var n = t[0] * It, r = t[1] * It, a = e[0] * It, o = e[1] * It, u = Dt(r), c = At(r), l = Dt(o), d = At(o), g = u * Dt(n), y = u * At(n), f = l * Dt(a), m = l * At(a), b = 2 * Un(ze(r1(o - r) + u * l * r1(a - n))), E = At(b), S = b ? function(M) {
    var N = At(M *= b) / E, O = At(b - M) / E, A = O * g + N * f, x = O * y + N * m, v = O * c + N * d;
    return [
      vn(x, A) * xe,
      vn(v, ze(A * A + x * x)) * xe
    ];
  } : function() {
    return [n * xe, r * xe];
  };
  return S.distance = b, S;
}
function Gi(t) {
  return t;
}
var qh = Ai(), Wd = Ai(), w_, E_, Gd, qd, Vr = {
  point: Ee,
  lineStart: Ee,
  lineEnd: Ee,
  polygonStart: function() {
    Vr.lineStart = Dj, Vr.lineEnd = Oj;
  },
  polygonEnd: function() {
    Vr.lineStart = Vr.lineEnd = Vr.point = Ee, qh.add(ce(Wd)), Wd.reset();
  },
  result: function() {
    var t = qh / 2;
    return qh.reset(), t;
  }
};
function Dj() {
  Vr.point = Mj;
}
function Mj(t, e) {
  Vr.point = S_, w_ = Gd = t, E_ = qd = e;
}
function S_(t, e) {
  Wd.add(qd * t - Gd * e), Gd = t, qd = e;
}
function Oj() {
  S_(w_, E_);
}
var Za = 1 / 0, tl = Za, As = -Za, el = As, nl = {
  point: Lj,
  lineStart: Ee,
  lineEnd: Ee,
  polygonStart: Ee,
  polygonEnd: Ee,
  result: function() {
    var t = [[Za, tl], [As, el]];
    return As = el = -(tl = Za = 1 / 0), t;
  }
};
function Lj(t, e) {
  t < Za && (Za = t), t > As && (As = t), e < tl && (tl = e), e > el && (el = e);
}
var Hd = 0, Xd = 0, Go = 0, rl = 0, il = 0, Pa = 0, Qd = 0, Kd = 0, qo = 0, A_, T_, vr, xr, Jn = {
  point: Ji,
  lineStart: S1,
  lineEnd: A1,
  polygonStart: function() {
    Jn.lineStart = Ij, Jn.lineEnd = jj;
  },
  polygonEnd: function() {
    Jn.point = Ji, Jn.lineStart = S1, Jn.lineEnd = A1;
  },
  result: function() {
    var t = qo ? [Qd / qo, Kd / qo] : Pa ? [rl / Pa, il / Pa] : Go ? [Hd / Go, Xd / Go] : [NaN, NaN];
    return Hd = Xd = Go = rl = il = Pa = Qd = Kd = qo = 0, t;
  }
};
function Ji(t, e) {
  Hd += t, Xd += e, ++Go;
}
function S1() {
  Jn.point = Pj;
}
function Pj(t, e) {
  Jn.point = Nj, Ji(vr = t, xr = e);
}
function Nj(t, e) {
  var n = t - vr, r = e - xr, a = ze(n * n + r * r);
  rl += a * (vr + t) / 2, il += a * (xr + e) / 2, Pa += a, Ji(vr = t, xr = e);
}
function A1() {
  Jn.point = Ji;
}
function Ij() {
  Jn.point = kj;
}
function jj() {
  C_(A_, T_);
}
function kj(t, e) {
  Jn.point = C_, Ji(A_ = vr = t, T_ = xr = e);
}
function C_(t, e) {
  var n = t - vr, r = e - xr, a = ze(n * n + r * r);
  rl += a * (vr + t) / 2, il += a * (xr + e) / 2, Pa += a, a = xr * t - vr * e, Qd += a * (vr + t), Kd += a * (xr + e), qo += a * 3, Ji(vr = t, xr = e);
}
function R_(t) {
  this._context = t;
}
R_.prototype = {
  _radius: 4.5,
  pointRadius: function(t) {
    return this._radius = t, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._line === 0 && this._context.closePath(), this._point = NaN;
  },
  point: function(t, e) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(t, e), this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(t, e);
        break;
      }
      default: {
        this._context.moveTo(t + this._radius, e), this._context.arc(t, e, this._radius, 0, Rn);
        break;
      }
    }
  },
  result: Ee
};
var Zd = Ai(), Hh, D_, M_, Ho, Xo, Ts = {
  point: Ee,
  lineStart: function() {
    Ts.point = Bj;
  },
  lineEnd: function() {
    Hh && O_(D_, M_), Ts.point = Ee;
  },
  polygonStart: function() {
    Hh = !0;
  },
  polygonEnd: function() {
    Hh = null;
  },
  result: function() {
    var t = +Zd;
    return Zd.reset(), t;
  }
};
function Bj(t, e) {
  Ts.point = O_, D_ = Ho = t, M_ = Xo = e;
}
function O_(t, e) {
  Ho -= t, Xo -= e, Zd.add(ze(Ho * Ho + Xo * Xo)), Ho = t, Xo = e;
}
function L_() {
  this._string = [];
}
L_.prototype = {
  _radius: 4.5,
  _circle: T1(4.5),
  pointRadius: function(t) {
    return (t = +t) !== this._radius && (this._radius = t, this._circle = null), this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._line === 0 && this._string.push("Z"), this._point = NaN;
  },
  point: function(t, e) {
    switch (this._point) {
      case 0: {
        this._string.push("M", t, ",", e), this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", t, ",", e);
        break;
      }
      default: {
        this._circle == null && (this._circle = T1(this._radius)), this._string.push("M", t, ",", e, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var t = this._string.join("");
      return this._string = [], t;
    } else
      return null;
  }
};
function T1(t) {
  return "m0," + t + "a" + t + "," + t + " 0 1,1 0," + -2 * t + "a" + t + "," + t + " 0 1,1 0," + 2 * t + "z";
}
function Fj(t, e) {
  var n = 4.5, r, a;
  function o(u) {
    return u && (typeof n == "function" && a.pointRadius(+n.apply(this, arguments)), or(u, r(a))), a.result();
  }
  return o.area = function(u) {
    return or(u, r(Vr)), Vr.result();
  }, o.measure = function(u) {
    return or(u, r(Ts)), Ts.result();
  }, o.bounds = function(u) {
    return or(u, r(nl)), nl.result();
  }, o.centroid = function(u) {
    return or(u, r(Jn)), Jn.result();
  }, o.projection = function(u) {
    return arguments.length ? (r = u == null ? (t = null, Gi) : (t = u).stream, o) : t;
  }, o.context = function(u) {
    return arguments.length ? (a = u == null ? (e = null, new L_()) : new R_(e = u), typeof n != "function" && a.pointRadius(n), o) : e;
  }, o.pointRadius = function(u) {
    return arguments.length ? (n = typeof u == "function" ? u : (a.pointRadius(+u), +u), o) : n;
  }, o.projection(t).context(e);
}
function Uj(t) {
  return {
    stream: Vs(t)
  };
}
function Vs(t) {
  return function(e) {
    var n = new Jd();
    for (var r in t) n[r] = t[r];
    return n.stream = e, n;
  };
}
function Jd() {
}
Jd.prototype = {
  constructor: Jd,
  point: function(t, e) {
    this.stream.point(t, e);
  },
  sphere: function() {
    this.stream.sphere();
  },
  lineStart: function() {
    this.stream.lineStart();
  },
  lineEnd: function() {
    this.stream.lineEnd();
  },
  polygonStart: function() {
    this.stream.polygonStart();
  },
  polygonEnd: function() {
    this.stream.polygonEnd();
  }
};
function zp(t, e, n) {
  var r = t.clipExtent && t.clipExtent();
  return t.scale(150).translate([0, 0]), r != null && t.clipExtent(null), or(n, t.stream(nl)), e(nl.result()), r != null && t.clipExtent(r), t;
}
function Fl(t, e, n) {
  return zp(t, function(r) {
    var a = e[1][0] - e[0][0], o = e[1][1] - e[0][1], u = Math.min(a / (r[1][0] - r[0][0]), o / (r[1][1] - r[0][1])), c = +e[0][0] + (a - u * (r[1][0] + r[0][0])) / 2, l = +e[0][1] + (o - u * (r[1][1] + r[0][1])) / 2;
    t.scale(150 * u).translate([c, l]);
  }, n);
}
function Vp(t, e, n) {
  return Fl(t, [[0, 0], e], n);
}
function Yp(t, e, n) {
  return zp(t, function(r) {
    var a = +e, o = a / (r[1][0] - r[0][0]), u = (a - o * (r[1][0] + r[0][0])) / 2, c = -o * r[0][1];
    t.scale(150 * o).translate([u, c]);
  }, n);
}
function Wp(t, e, n) {
  return zp(t, function(r) {
    var a = +e, o = a / (r[1][1] - r[0][1]), u = -o * r[0][0], c = (a - o * (r[1][1] + r[0][1])) / 2;
    t.scale(150 * o).translate([u, c]);
  }, n);
}
var C1 = 16, $j = Dt(30 * It);
function R1(t, e) {
  return +e ? Vj(t, e) : zj(t);
}
function zj(t) {
  return Vs({
    point: function(e, n) {
      e = t(e, n), this.stream.point(e[0], e[1]);
    }
  });
}
function Vj(t, e) {
  function n(r, a, o, u, c, l, d, g, y, f, m, b, E, S) {
    var M = d - r, N = g - a, O = M * M + N * N;
    if (O > 4 * e && E--) {
      var A = u + f, x = c + m, v = l + b, w = ze(A * A + x * x + v * v), C = Un(v /= w), P = ce(ce(v) - 1) < Mt || ce(o - y) < Mt ? (o + y) / 2 : vn(x, A), Y = t(P, C), V = Y[0], k = Y[1], T = V - r, R = k - a, F = N * T - M * R;
      (F * F / O > e || ce((M * T + N * R) / O - 0.5) > 0.3 || u * f + c * m + l * b < $j) && (n(r, a, o, u, c, l, V, k, P, A /= w, x /= w, v, E, S), S.point(V, k), n(V, k, P, A, x, v, d, g, y, f, m, b, E, S));
    }
  }
  return function(r) {
    var a, o, u, c, l, d, g, y, f, m, b, E, S = {
      point: M,
      lineStart: N,
      lineEnd: A,
      polygonStart: function() {
        r.polygonStart(), S.lineStart = x;
      },
      polygonEnd: function() {
        r.polygonEnd(), S.lineStart = N;
      }
    };
    function M(C, P) {
      C = t(C, P), r.point(C[0], C[1]);
    }
    function N() {
      y = NaN, S.point = O, r.lineStart();
    }
    function O(C, P) {
      var Y = Zi([C, P]), V = t(C, P);
      n(y, f, g, m, b, E, y = V[0], f = V[1], g = C, m = Y[0], b = Y[1], E = Y[2], C1, r), r.point(y, f);
    }
    function A() {
      S.point = M, r.lineEnd();
    }
    function x() {
      N(), S.point = v, S.lineEnd = w;
    }
    function v(C, P) {
      O(a = C, P), o = y, u = f, c = m, l = b, d = E, S.point = O;
    }
    function w() {
      n(y, f, g, m, b, E, o, u, a, c, l, d, C1, r), S.lineEnd = A, A();
    }
    return S;
  };
}
var Yj = Vs({
  point: function(t, e) {
    this.stream.point(t * It, e * It);
  }
});
function Wj(t) {
  return Vs({
    point: function(e, n) {
      var r = t(e, n);
      return this.stream.point(r[0], r[1]);
    }
  });
}
function Kr(t) {
  return Gp(function() {
    return t;
  })();
}
function Gp(t) {
  var e, n = 150, r = 480, a = 250, o, u, c = 0, l = 0, d = 0, g = 0, y = 0, f, m, b = null, E = $d, S = null, M, N, O, A = Gi, x = 0.5, v = R1(V, x), w, C;
  function P(R) {
    return R = m(R[0] * It, R[1] * It), [R[0] * n + o, u - R[1] * n];
  }
  function Y(R) {
    return R = m.invert((R[0] - o) / n, (u - R[1]) / n), R && [R[0] * xe, R[1] * xe];
  }
  function V(R, F) {
    return R = e(R, F), [R[0] * n + o, u - R[1] * n];
  }
  P.stream = function(R) {
    return w && C === R ? w : w = Yj(Wj(f)(E(v(A(C = R)))));
  }, P.preclip = function(R) {
    return arguments.length ? (E = R, b = void 0, T()) : E;
  }, P.postclip = function(R) {
    return arguments.length ? (A = R, S = M = N = O = null, T()) : A;
  }, P.clipAngle = function(R) {
    return arguments.length ? (E = +R ? v_(b = R * It) : (b = null, $d), T()) : b * xe;
  }, P.clipExtent = function(R) {
    return arguments.length ? (A = R == null ? (S = M = N = O = null, Gi) : Bl(S = +R[0][0], M = +R[0][1], N = +R[1][0], O = +R[1][1]), T()) : S == null ? null : [[S, M], [N, O]];
  }, P.scale = function(R) {
    return arguments.length ? (n = +R, k()) : n;
  }, P.translate = function(R) {
    return arguments.length ? (r = +R[0], a = +R[1], k()) : [r, a];
  }, P.center = function(R) {
    return arguments.length ? (c = R[0] % 360 * It, l = R[1] % 360 * It, k()) : [c * xe, l * xe];
  }, P.rotate = function(R) {
    return arguments.length ? (d = R[0] % 360 * It, g = R[1] % 360 * It, y = R.length > 2 ? R[2] % 360 * It : 0, k()) : [d * xe, g * xe, y * xe];
  }, P.precision = function(R) {
    return arguments.length ? (v = R1(V, x = R * R), T()) : ze(x);
  }, P.fitExtent = function(R, F) {
    return Fl(P, R, F);
  }, P.fitSize = function(R, F) {
    return Vp(P, R, F);
  }, P.fitWidth = function(R, F) {
    return Yp(P, R, F);
  }, P.fitHeight = function(R, F) {
    return Wp(P, R, F);
  };
  function k() {
    m = f_(f = $p(d, g, y), e);
    var R = e(c, l);
    return o = r - R[0] * n, u = a + R[1] * n, T();
  }
  function T() {
    return w = C = null, P;
  }
  return function() {
    return e = t.apply(this, arguments), P.invert = e.invert && Y, k();
  };
}
function qp(t) {
  var e = 0, n = ae / 3, r = Gp(t), a = r(e, n);
  return a.parallels = function(o) {
    return arguments.length ? r(e = o[0] * It, n = o[1] * It) : [e * xe, n * xe];
  }, a;
}
function Gj(t) {
  var e = Dt(t);
  function n(r, a) {
    return [r * e, At(a) / e];
  }
  return n.invert = function(r, a) {
    return [r / e, Un(a * e)];
  }, n;
}
function P_(t, e) {
  var n = At(t), r = (n + At(e)) / 2;
  if (ce(r) < Mt) return Gj(t);
  var a = 1 + n * (2 * r - n), o = ze(a) / r;
  function u(c, l) {
    var d = ze(a - 2 * r * At(l)) / r;
    return [d * At(c *= r), o - d * Dt(c)];
  }
  return u.invert = function(c, l) {
    var d = o - l;
    return [vn(c, ce(d)) / r * Ss(d), Un((a - (c * c + d * d) * r * r) / (2 * r))];
  }, u;
}
function al() {
  return qp(P_).scale(155.424).center([0, 33.6442]);
}
function N_() {
  return al().parallels([29.5, 45.5]).scale(1070).translate([480, 250]).rotate([96, 0]).center([-0.6, 38.7]);
}
function qj(t) {
  var e = t.length;
  return {
    point: function(n, r) {
      for (var a = -1; ++a < e; ) t[a].point(n, r);
    },
    sphere: function() {
      for (var n = -1; ++n < e; ) t[n].sphere();
    },
    lineStart: function() {
      for (var n = -1; ++n < e; ) t[n].lineStart();
    },
    lineEnd: function() {
      for (var n = -1; ++n < e; ) t[n].lineEnd();
    },
    polygonStart: function() {
      for (var n = -1; ++n < e; ) t[n].polygonStart();
    },
    polygonEnd: function() {
      for (var n = -1; ++n < e; ) t[n].polygonEnd();
    }
  };
}
function Hj() {
  var t, e, n = N_(), r, a = al().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), o, u = al().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), c, l, d = { point: function(f, m) {
    l = [f, m];
  } };
  function g(f) {
    var m = f[0], b = f[1];
    return l = null, r.point(m, b), l || (o.point(m, b), l) || (c.point(m, b), l);
  }
  g.invert = function(f) {
    var m = n.scale(), b = n.translate(), E = (f[0] - b[0]) / m, S = (f[1] - b[1]) / m;
    return (S >= 0.12 && S < 0.234 && E >= -0.425 && E < -0.214 ? a : S >= 0.166 && S < 0.234 && E >= -0.214 && E < -0.115 ? u : n).invert(f);
  }, g.stream = function(f) {
    return t && e === f ? t : t = qj([n.stream(e = f), a.stream(f), u.stream(f)]);
  }, g.precision = function(f) {
    return arguments.length ? (n.precision(f), a.precision(f), u.precision(f), y()) : n.precision();
  }, g.scale = function(f) {
    return arguments.length ? (n.scale(f), a.scale(f * 0.35), u.scale(f), g.translate(n.translate())) : n.scale();
  }, g.translate = function(f) {
    if (!arguments.length) return n.translate();
    var m = n.scale(), b = +f[0], E = +f[1];
    return r = n.translate(f).clipExtent([[b - 0.455 * m, E - 0.238 * m], [b + 0.455 * m, E + 0.238 * m]]).stream(d), o = a.translate([b - 0.307 * m, E + 0.201 * m]).clipExtent([[b - 0.425 * m + Mt, E + 0.12 * m + Mt], [b - 0.214 * m - Mt, E + 0.234 * m - Mt]]).stream(d), c = u.translate([b - 0.205 * m, E + 0.212 * m]).clipExtent([[b - 0.214 * m + Mt, E + 0.166 * m + Mt], [b - 0.115 * m - Mt, E + 0.234 * m - Mt]]).stream(d), y();
  }, g.fitExtent = function(f, m) {
    return Fl(g, f, m);
  }, g.fitSize = function(f, m) {
    return Vp(g, f, m);
  }, g.fitWidth = function(f, m) {
    return Yp(g, f, m);
  }, g.fitHeight = function(f, m) {
    return Wp(g, f, m);
  };
  function y() {
    return t = e = null, g;
  }
  return g.scale(1070);
}
function I_(t) {
  return function(e, n) {
    var r = Dt(e), a = Dt(n), o = t(r * a);
    return [
      o * a * At(e),
      o * At(n)
    ];
  };
}
function Ys(t) {
  return function(e, n) {
    var r = ze(e * e + n * n), a = t(r), o = At(a), u = Dt(a);
    return [
      vn(e * o, r * u),
      Un(r && n * o / r)
    ];
  };
}
var Hp = I_(function(t) {
  return ze(2 / (1 + t));
});
Hp.invert = Ys(function(t) {
  return 2 * Un(t / 2);
});
function Xj() {
  return Kr(Hp).scale(124.75).clipAngle(180 - 1e-3);
}
var Xp = I_(function(t) {
  return (t = t_(t)) && t / At(t);
});
Xp.invert = Ys(function(t) {
  return t;
});
function Qj() {
  return Kr(Xp).scale(79.4188).clipAngle(180 - 1e-3);
}
function Ws(t, e) {
  return [t, Uc(Fp((Ne + e) / 2))];
}
Ws.invert = function(t, e) {
  return [t, 2 * so(Jx(e)) - Ne];
};
function Kj() {
  return j_(Ws).scale(961 / Rn);
}
function j_(t) {
  var e = Kr(t), n = e.center, r = e.scale, a = e.translate, o = e.clipExtent, u = null, c, l, d;
  e.scale = function(y) {
    return arguments.length ? (r(y), g()) : r();
  }, e.translate = function(y) {
    return arguments.length ? (a(y), g()) : a();
  }, e.center = function(y) {
    return arguments.length ? (n(y), g()) : n();
  }, e.clipExtent = function(y) {
    return arguments.length ? (y == null ? u = c = l = d = null : (u = +y[0][0], c = +y[0][1], l = +y[1][0], d = +y[1][1]), g()) : u == null ? null : [[u, c], [l, d]];
  };
  function g() {
    var y = ae * r(), f = e(h_(e.rotate()).invert([0, 0]));
    return o(u == null ? [[f[0] - y, f[1] - y], [f[0] + y, f[1] + y]] : t === Ws ? [[Math.max(f[0] - y, u), c], [Math.min(f[0] + y, l), d]] : [[u, Math.max(f[1] - y, c)], [l, Math.min(f[1] + y, d)]]);
  }
  return g();
}
function nc(t) {
  return Fp((Ne + t) / 2);
}
function k_(t, e) {
  var n = Dt(t), r = t === e ? At(t) : Uc(n / Dt(e)) / Uc(nc(e) / nc(t)), a = n * Yh(nc(t), r) / r;
  if (!r) return Ws;
  function o(u, c) {
    a > 0 ? c < -Ne + Mt && (c = -Ne + Mt) : c > Ne - Mt && (c = Ne - Mt);
    var l = a / Yh(nc(c), r);
    return [l * At(r * u), a - l * Dt(r * u)];
  }
  return o.invert = function(u, c) {
    var l = a - c, d = Ss(r) * ze(u * u + l * l);
    return [vn(u, ce(l)) / r * Ss(l), 2 * so(Yh(a / d, 1 / r)) - Ne];
  }, o;
}
function Zj() {
  return qp(k_).scale(109.5).parallels([30, 30]);
}
function Cs(t, e) {
  return [t, e];
}
Cs.invert = Cs;
function Jj() {
  return Kr(Cs).scale(152.63);
}
function B_(t, e) {
  var n = Dt(t), r = t === e ? At(t) : (n - Dt(e)) / (e - t), a = n / r + t;
  if (ce(r) < Mt) return Cs;
  function o(u, c) {
    var l = a - c, d = r * u;
    return [l * At(d), a - l * Dt(d)];
  }
  return o.invert = function(u, c) {
    var l = a - c;
    return [vn(u, ce(l)) / r * Ss(l), a - Ss(r) * ze(u * u + l * l)];
  }, o;
}
function t5() {
  return qp(B_).scale(131.154).center([0, 13.9389]);
}
function Qp(t, e) {
  var n = Dt(e), r = Dt(t) * n;
  return [n * At(t) / r, At(e) / r];
}
Qp.invert = Ys(so);
function e5() {
  return Kr(Qp).scale(144.049).clipAngle(60);
}
function rc(t, e, n, r) {
  return t === 1 && e === 1 && n === 0 && r === 0 ? Gi : Vs({
    point: function(a, o) {
      this.stream.point(a * t + n, o * e + r);
    }
  });
}
function n5() {
  var t = 1, e = 0, n = 0, r = 1, a = 1, o = Gi, u = null, c, l, d, g = Gi, y, f, m;
  function b() {
    return y = f = null, m;
  }
  return m = {
    stream: function(E) {
      return y && f === E ? y : y = o(g(f = E));
    },
    postclip: function(E) {
      return arguments.length ? (g = E, u = c = l = d = null, b()) : g;
    },
    clipExtent: function(E) {
      return arguments.length ? (g = E == null ? (u = c = l = d = null, Gi) : Bl(u = +E[0][0], c = +E[0][1], l = +E[1][0], d = +E[1][1]), b()) : u == null ? null : [[u, c], [l, d]];
    },
    scale: function(E) {
      return arguments.length ? (o = rc((t = +E) * r, t * a, e, n), b()) : t;
    },
    translate: function(E) {
      return arguments.length ? (o = rc(t * r, t * a, e = +E[0], n = +E[1]), b()) : [e, n];
    },
    reflectX: function(E) {
      return arguments.length ? (o = rc(t * (r = E ? -1 : 1), t * a, e, n), b()) : r < 0;
    },
    reflectY: function(E) {
      return arguments.length ? (o = rc(t * r, t * (a = E ? -1 : 1), e, n), b()) : a < 0;
    },
    fitExtent: function(E, S) {
      return Fl(m, E, S);
    },
    fitSize: function(E, S) {
      return Vp(m, E, S);
    },
    fitWidth: function(E, S) {
      return Yp(m, E, S);
    },
    fitHeight: function(E, S) {
      return Wp(m, E, S);
    }
  };
}
function Kp(t, e) {
  var n = e * e, r = n * n;
  return [
    t * (0.8707 - 0.131979 * n + r * (-0.013791 + r * (3971e-6 * n - 1529e-6 * r))),
    e * (1.007226 + n * (0.015085 + r * (-0.044475 + 0.028874 * n - 5916e-6 * r)))
  ];
}
Kp.invert = function(t, e) {
  var n = e, r = 25, a;
  do {
    var o = n * n, u = o * o;
    n -= a = (n * (1.007226 + o * (0.015085 + u * (-0.044475 + 0.028874 * o - 5916e-6 * u))) - e) / (1.007226 + o * (0.015085 * 3 + u * (-0.044475 * 7 + 0.028874 * 9 * o - 5916e-6 * 11 * u)));
  } while (ce(a) > Mt && --r > 0);
  return [
    t / (0.8707 + (o = n * n) * (-0.131979 + o * (-0.013791 + o * o * o * (3971e-6 - 1529e-6 * o)))),
    n
  ];
};
function r5() {
  return Kr(Kp).scale(175.295);
}
function Zp(t, e) {
  return [Dt(e) * At(t), At(e)];
}
Zp.invert = Ys(Un);
function i5() {
  return Kr(Zp).scale(249.5).clipAngle(90 + Mt);
}
function Jp(t, e) {
  var n = Dt(e), r = 1 + Dt(t) * n;
  return [n * At(t) / r, At(e) / r];
}
Jp.invert = Ys(function(t) {
  return 2 * so(t);
});
function a5() {
  return Kr(Jp).scale(250).clipAngle(142);
}
function t0(t, e) {
  return [Uc(Fp((Ne + e) / 2)), -t];
}
t0.invert = function(t, e) {
  return [-e, 2 * so(Jx(t)) - Ne];
};
function o5() {
  var t = j_(t0), e = t.center, n = t.rotate;
  return t.center = function(r) {
    return arguments.length ? e([-r[1], r[0]]) : (r = e(), [r[1], -r[0]]);
  }, t.rotate = function(r) {
    return arguments.length ? n([r[0], r[1], r.length > 2 ? r[2] + 90 : 90]) : (r = n(), [r[0], r[1], r[2] - 90]);
  }, n([0, 0, 90]).scale(159.155);
}
function s5(t, e) {
  return t.parent === e.parent ? 1 : 2;
}
function u5(t) {
  return t.reduce(c5, 0) / t.length;
}
function c5(t, e) {
  return t + e.x;
}
function l5(t) {
  return 1 + t.reduce(f5, 0);
}
function f5(t, e) {
  return Math.max(t, e.y);
}
function h5(t) {
  for (var e; e = t.children; ) t = e[0];
  return t;
}
function d5(t) {
  for (var e; e = t.children; ) t = e[e.length - 1];
  return t;
}
function p5() {
  var t = s5, e = 1, n = 1, r = !1;
  function a(o) {
    var u, c = 0;
    o.eachAfter(function(f) {
      var m = f.children;
      m ? (f.x = u5(m), f.y = l5(m)) : (f.x = u ? c += t(f, u) : 0, f.y = 0, u = f);
    });
    var l = h5(o), d = d5(o), g = l.x - t(l, d) / 2, y = d.x + t(d, l) / 2;
    return o.eachAfter(r ? function(f) {
      f.x = (f.x - o.x) * e, f.y = (o.y - f.y) * n;
    } : function(f) {
      f.x = (f.x - g) / (y - g) * e, f.y = (1 - (o.y ? f.y / o.y : 1)) * n;
    });
  }
  return a.separation = function(o) {
    return arguments.length ? (t = o, a) : t;
  }, a.size = function(o) {
    return arguments.length ? (r = !1, e = +o[0], n = +o[1], a) : r ? null : [e, n];
  }, a.nodeSize = function(o) {
    return arguments.length ? (r = !0, e = +o[0], n = +o[1], a) : r ? [e, n] : null;
  }, a;
}
function g5(t) {
  var e = 0, n = t.children, r = n && n.length;
  if (!r) e = 1;
  else for (; --r >= 0; ) e += n[r].value;
  t.value = e;
}
function m5() {
  return this.eachAfter(g5);
}
function y5(t) {
  var e = this, n, r = [e], a, o, u;
  do
    for (n = r.reverse(), r = []; e = n.pop(); )
      if (t(e), a = e.children, a) for (o = 0, u = a.length; o < u; ++o)
        r.push(a[o]);
  while (r.length);
  return this;
}
function v5(t) {
  for (var e = this, n = [e], r, a; e = n.pop(); )
    if (t(e), r = e.children, r) for (a = r.length - 1; a >= 0; --a)
      n.push(r[a]);
  return this;
}
function x5(t) {
  for (var e = this, n = [e], r = [], a, o, u; e = n.pop(); )
    if (r.push(e), a = e.children, a) for (o = 0, u = a.length; o < u; ++o)
      n.push(a[o]);
  for (; e = r.pop(); )
    t(e);
  return this;
}
function _5(t) {
  return this.eachAfter(function(e) {
    for (var n = +t(e.data) || 0, r = e.children, a = r && r.length; --a >= 0; ) n += r[a].value;
    e.value = n;
  });
}
function b5(t) {
  return this.eachBefore(function(e) {
    e.children && e.children.sort(t);
  });
}
function w5(t) {
  for (var e = this, n = E5(e, t), r = [e]; e !== n; )
    e = e.parent, r.push(e);
  for (var a = r.length; t !== n; )
    r.splice(a, 0, t), t = t.parent;
  return r;
}
function E5(t, e) {
  if (t === e) return t;
  var n = t.ancestors(), r = e.ancestors(), a = null;
  for (t = n.pop(), e = r.pop(); t === e; )
    a = t, t = n.pop(), e = r.pop();
  return a;
}
function S5() {
  for (var t = this, e = [t]; t = t.parent; )
    e.push(t);
  return e;
}
function A5() {
  var t = [];
  return this.each(function(e) {
    t.push(e);
  }), t;
}
function T5() {
  var t = [];
  return this.eachBefore(function(e) {
    e.children || t.push(e);
  }), t;
}
function C5() {
  var t = this, e = [];
  return t.each(function(n) {
    n !== t && e.push({ source: n.parent, target: n });
  }), e;
}
function e0(t, e) {
  var n = new Ja(t), r = +t.value && (n.value = t.value), a, o = [n], u, c, l, d;
  for (e == null && (e = D5); a = o.pop(); )
    if (r && (a.value = +a.data.value), (c = e(a.data)) && (d = c.length))
      for (a.children = new Array(d), l = d - 1; l >= 0; --l)
        o.push(u = a.children[l] = new Ja(c[l])), u.parent = a, u.depth = a.depth + 1;
  return n.eachBefore(F_);
}
function R5() {
  return e0(this).eachBefore(M5);
}
function D5(t) {
  return t.children;
}
function M5(t) {
  t.data = t.data.data;
}
function F_(t) {
  var e = 0;
  do
    t.height = e;
  while ((t = t.parent) && t.height < ++e);
}
function Ja(t) {
  this.data = t, this.depth = this.height = 0, this.parent = null;
}
Ja.prototype = e0.prototype = {
  constructor: Ja,
  count: m5,
  each: y5,
  eachAfter: x5,
  eachBefore: v5,
  sum: _5,
  sort: b5,
  path: w5,
  ancestors: S5,
  descendants: A5,
  leaves: T5,
  links: C5,
  copy: R5
};
var O5 = Array.prototype.slice;
function L5(t) {
  for (var e = t.length, n, r; e; )
    r = Math.random() * e-- | 0, n = t[e], t[e] = t[r], t[r] = n;
  return t;
}
function U_(t) {
  for (var e = 0, n = (t = L5(O5.call(t))).length, r = [], a, o; e < n; )
    a = t[e], o && $_(o, a) ? ++e : (o = N5(r = P5(r, a)), e = 0);
  return o;
}
function P5(t, e) {
  var n, r;
  if (Xh(e, t)) return [e];
  for (n = 0; n < t.length; ++n)
    if (ic(e, t[n]) && Xh(Qo(t[n], e), t))
      return [t[n], e];
  for (n = 0; n < t.length - 1; ++n)
    for (r = n + 1; r < t.length; ++r)
      if (ic(Qo(t[n], t[r]), e) && ic(Qo(t[n], e), t[r]) && ic(Qo(t[r], e), t[n]) && Xh(z_(t[n], t[r], e), t))
        return [t[n], t[r], e];
  throw new Error();
}
function ic(t, e) {
  var n = t.r - e.r, r = e.x - t.x, a = e.y - t.y;
  return n < 0 || n * n < r * r + a * a;
}
function $_(t, e) {
  var n = t.r - e.r + 1e-6, r = e.x - t.x, a = e.y - t.y;
  return n > 0 && n * n > r * r + a * a;
}
function Xh(t, e) {
  for (var n = 0; n < e.length; ++n)
    if (!$_(t, e[n]))
      return !1;
  return !0;
}
function N5(t) {
  switch (t.length) {
    case 1:
      return I5(t[0]);
    case 2:
      return Qo(t[0], t[1]);
    case 3:
      return z_(t[0], t[1], t[2]);
  }
}
function I5(t) {
  return {
    x: t.x,
    y: t.y,
    r: t.r
  };
}
function Qo(t, e) {
  var n = t.x, r = t.y, a = t.r, o = e.x, u = e.y, c = e.r, l = o - n, d = u - r, g = c - a, y = Math.sqrt(l * l + d * d);
  return {
    x: (n + o + l / y * g) / 2,
    y: (r + u + d / y * g) / 2,
    r: (y + a + c) / 2
  };
}
function z_(t, e, n) {
  var r = t.x, a = t.y, o = t.r, u = e.x, c = e.y, l = e.r, d = n.x, g = n.y, y = n.r, f = r - u, m = r - d, b = a - c, E = a - g, S = l - o, M = y - o, N = r * r + a * a - o * o, O = N - u * u - c * c + l * l, A = N - d * d - g * g + y * y, x = m * b - f * E, v = (b * A - E * O) / (x * 2) - r, w = (E * S - b * M) / x, C = (m * O - f * A) / (x * 2) - a, P = (f * M - m * S) / x, Y = w * w + P * P - 1, V = 2 * (o + v * w + C * P), k = v * v + C * C - o * o, T = -(Y ? (V + Math.sqrt(V * V - 4 * Y * k)) / (2 * Y) : k / V);
  return {
    x: r + v + w * T,
    y: a + C + P * T,
    r: T
  };
}
function D1(t, e, n) {
  var r = t.x, a = t.y, o = e.r + n.r, u = t.r + n.r, c = e.x - r, l = e.y - a, d = c * c + l * l;
  if (d) {
    var g = 0.5 + ((u *= u) - (o *= o)) / (2 * d), y = Math.sqrt(Math.max(0, 2 * o * (u + d) - (u -= d) * u - o * o)) / (2 * d);
    n.x = r + g * c + y * l, n.y = a + g * l - y * c;
  } else
    n.x = r + u, n.y = a;
}
function M1(t, e) {
  var n = e.x - t.x, r = e.y - t.y, a = t.r + e.r;
  return a * a - 1e-6 > n * n + r * r;
}
function O1(t) {
  var e = t._, n = t.next._, r = e.r + n.r, a = (e.x * n.r + n.x * e.r) / r, o = (e.y * n.r + n.y * e.r) / r;
  return a * a + o * o;
}
function ac(t) {
  this._ = t, this.next = null, this.previous = null;
}
function V_(t) {
  if (!(a = t.length)) return 0;
  var e, n, r, a, o, u, c, l, d, g, y;
  if (e = t[0], e.x = 0, e.y = 0, !(a > 1)) return e.r;
  if (n = t[1], e.x = -n.r, n.x = e.r, n.y = 0, !(a > 2)) return e.r + n.r;
  D1(n, e, r = t[2]), e = new ac(e), n = new ac(n), r = new ac(r), e.next = r.previous = n, n.next = e.previous = r, r.next = n.previous = e;
  t: for (c = 3; c < a; ++c) {
    D1(e._, n._, r = t[c]), r = new ac(r), l = n.next, d = e.previous, g = n._.r, y = e._.r;
    do
      if (g <= y) {
        if (M1(l._, r._)) {
          n = l, e.next = n, n.previous = e, --c;
          continue t;
        }
        g += l._.r, l = l.next;
      } else {
        if (M1(d._, r._)) {
          e = d, e.next = n, n.previous = e, --c;
          continue t;
        }
        y += d._.r, d = d.previous;
      }
    while (l !== d.next);
    for (r.previous = e, r.next = n, e.next = n.previous = n = r, o = O1(e); (r = r.next) !== n; )
      (u = O1(r)) < o && (e = r, o = u);
    n = e.next;
  }
  for (e = [n._], r = n; (r = r.next) !== n; ) e.push(r._);
  for (r = U_(e), c = 0; c < a; ++c) e = t[c], e.x -= r.x, e.y -= r.y;
  return r.r;
}
function j5(t) {
  return V_(t), t;
}
function k5(t) {
  return t == null ? null : ol(t);
}
function ol(t) {
  if (typeof t != "function") throw new Error();
  return t;
}
function Vi() {
  return 0;
}
function Oa(t) {
  return function() {
    return t;
  };
}
function B5(t) {
  return Math.sqrt(t.value);
}
function F5() {
  var t = null, e = 1, n = 1, r = Vi;
  function a(o) {
    return o.x = e / 2, o.y = n / 2, t ? o.eachBefore(L1(t)).eachAfter(Qh(r, 0.5)).eachBefore(P1(1)) : o.eachBefore(L1(B5)).eachAfter(Qh(Vi, 1)).eachAfter(Qh(r, o.r / Math.min(e, n))).eachBefore(P1(Math.min(e, n) / (2 * o.r))), o;
  }
  return a.radius = function(o) {
    return arguments.length ? (t = k5(o), a) : t;
  }, a.size = function(o) {
    return arguments.length ? (e = +o[0], n = +o[1], a) : [e, n];
  }, a.padding = function(o) {
    return arguments.length ? (r = typeof o == "function" ? o : Oa(+o), a) : r;
  }, a;
}
function L1(t) {
  return function(e) {
    e.children || (e.r = Math.max(0, +t(e) || 0));
  };
}
function Qh(t, e) {
  return function(n) {
    if (r = n.children) {
      var r, a, o = r.length, u = t(n) * e || 0, c;
      if (u) for (a = 0; a < o; ++a) r[a].r += u;
      if (c = V_(r), u) for (a = 0; a < o; ++a) r[a].r -= u;
      n.r = c + u;
    }
  };
}
function P1(t) {
  return function(e) {
    var n = e.parent;
    e.r *= t, n && (e.x = n.x + t * e.x, e.y = n.y + t * e.y);
  };
}
function Y_(t) {
  t.x0 = Math.round(t.x0), t.y0 = Math.round(t.y0), t.x1 = Math.round(t.x1), t.y1 = Math.round(t.y1);
}
function Gs(t, e, n, r, a) {
  for (var o = t.children, u, c = -1, l = o.length, d = t.value && (r - e) / t.value; ++c < l; )
    u = o[c], u.y0 = n, u.y1 = a, u.x0 = e, u.x1 = e += u.value * d;
}
function U5() {
  var t = 1, e = 1, n = 0, r = !1;
  function a(u) {
    var c = u.height + 1;
    return u.x0 = u.y0 = n, u.x1 = t, u.y1 = e / c, u.eachBefore(o(e, c)), r && u.eachBefore(Y_), u;
  }
  function o(u, c) {
    return function(l) {
      l.children && Gs(l, l.x0, u * (l.depth + 1) / c, l.x1, u * (l.depth + 2) / c);
      var d = l.x0, g = l.y0, y = l.x1 - n, f = l.y1 - n;
      y < d && (d = y = (d + y) / 2), f < g && (g = f = (g + f) / 2), l.x0 = d, l.y0 = g, l.x1 = y, l.y1 = f;
    };
  }
  return a.round = function(u) {
    return arguments.length ? (r = !!u, a) : r;
  }, a.size = function(u) {
    return arguments.length ? (t = +u[0], e = +u[1], a) : [t, e];
  }, a.padding = function(u) {
    return arguments.length ? (n = +u, a) : n;
  }, a;
}
var N1 = "$", $5 = { depth: -1 }, I1 = {};
function z5(t) {
  return t.id;
}
function V5(t) {
  return t.parentId;
}
function Y5() {
  var t = z5, e = V5;
  function n(r) {
    var a, o, u = r.length, c, l, d, g = new Array(u), y, f, m = {};
    for (o = 0; o < u; ++o)
      a = r[o], d = g[o] = new Ja(a), (y = t(a, o, r)) != null && (y += "") && (f = N1 + (d.id = y), m[f] = f in m ? I1 : d);
    for (o = 0; o < u; ++o)
      if (d = g[o], y = e(r[o], o, r), y == null || !(y += "")) {
        if (c) throw new Error("multiple roots");
        c = d;
      } else {
        if (l = m[N1 + y], !l) throw new Error("missing: " + y);
        if (l === I1) throw new Error("ambiguous: " + y);
        l.children ? l.children.push(d) : l.children = [d], d.parent = l;
      }
    if (!c) throw new Error("no root");
    if (c.parent = $5, c.eachBefore(function(b) {
      b.depth = b.parent.depth + 1, --u;
    }).eachBefore(F_), c.parent = null, u > 0) throw new Error("cycle");
    return c;
  }
  return n.id = function(r) {
    return arguments.length ? (t = ol(r), n) : t;
  }, n.parentId = function(r) {
    return arguments.length ? (e = ol(r), n) : e;
  }, n;
}
function W5(t, e) {
  return t.parent === e.parent ? 1 : 2;
}
function Kh(t) {
  var e = t.children;
  return e ? e[0] : t.t;
}
function Zh(t) {
  var e = t.children;
  return e ? e[e.length - 1] : t.t;
}
function G5(t, e, n) {
  var r = n / (e.i - t.i);
  e.c -= r, e.s += n, t.c += r, e.z += n, e.m += n;
}
function q5(t) {
  for (var e = 0, n = 0, r = t.children, a = r.length, o; --a >= 0; )
    o = r[a], o.z += e, o.m += e, e += o.s + (n += o.c);
}
function H5(t, e, n) {
  return t.a.parent === e.parent ? t.a : n;
}
function wc(t, e) {
  this._ = t, this.parent = null, this.children = null, this.A = null, this.a = this, this.z = 0, this.m = 0, this.c = 0, this.s = 0, this.t = null, this.i = e;
}
wc.prototype = Object.create(Ja.prototype);
function X5(t) {
  for (var e = new wc(t, 0), n, r = [e], a, o, u, c; n = r.pop(); )
    if (o = n._.children)
      for (n.children = new Array(c = o.length), u = c - 1; u >= 0; --u)
        r.push(a = n.children[u] = new wc(o[u], u)), a.parent = n;
  return (e.parent = new wc(null, 0)).children = [e], e;
}
function Q5() {
  var t = W5, e = 1, n = 1, r = null;
  function a(d) {
    var g = X5(d);
    if (g.eachAfter(o), g.parent.m = -g.z, g.eachBefore(u), r) d.eachBefore(l);
    else {
      var y = d, f = d, m = d;
      d.eachBefore(function(N) {
        N.x < y.x && (y = N), N.x > f.x && (f = N), N.depth > m.depth && (m = N);
      });
      var b = y === f ? 1 : t(y, f) / 2, E = b - y.x, S = e / (f.x + b + E), M = n / (m.depth || 1);
      d.eachBefore(function(N) {
        N.x = (N.x + E) * S, N.y = N.depth * M;
      });
    }
    return d;
  }
  function o(d) {
    var g = d.children, y = d.parent.children, f = d.i ? y[d.i - 1] : null;
    if (g) {
      q5(d);
      var m = (g[0].z + g[g.length - 1].z) / 2;
      f ? (d.z = f.z + t(d._, f._), d.m = d.z - m) : d.z = m;
    } else f && (d.z = f.z + t(d._, f._));
    d.parent.A = c(d, f, d.parent.A || y[0]);
  }
  function u(d) {
    d._.x = d.z + d.parent.m, d.m += d.parent.m;
  }
  function c(d, g, y) {
    if (g) {
      for (var f = d, m = d, b = g, E = f.parent.children[0], S = f.m, M = m.m, N = b.m, O = E.m, A; b = Zh(b), f = Kh(f), b && f; )
        E = Kh(E), m = Zh(m), m.a = d, A = b.z + N - f.z - S + t(b._, f._), A > 0 && (G5(H5(b, d, y), d, A), S += A, M += A), N += b.m, S += f.m, O += E.m, M += m.m;
      b && !Zh(m) && (m.t = b, m.m += N - M), f && !Kh(E) && (E.t = f, E.m += S - O, y = d);
    }
    return y;
  }
  function l(d) {
    d.x *= e, d.y = d.depth * n;
  }
  return a.separation = function(d) {
    return arguments.length ? (t = d, a) : t;
  }, a.size = function(d) {
    return arguments.length ? (r = !1, e = +d[0], n = +d[1], a) : r ? null : [e, n];
  }, a.nodeSize = function(d) {
    return arguments.length ? (r = !0, e = +d[0], n = +d[1], a) : r ? [e, n] : null;
  }, a;
}
function Ul(t, e, n, r, a) {
  for (var o = t.children, u, c = -1, l = o.length, d = t.value && (a - n) / t.value; ++c < l; )
    u = o[c], u.x0 = e, u.x1 = r, u.y0 = n, u.y1 = n += u.value * d;
}
var W_ = (1 + Math.sqrt(5)) / 2;
function G_(t, e, n, r, a, o) {
  for (var u = [], c = e.children, l, d, g = 0, y = 0, f = c.length, m, b, E = e.value, S, M, N, O, A, x, v; g < f; ) {
    m = a - n, b = o - r;
    do
      S = c[y++].value;
    while (!S && y < f);
    for (M = N = S, x = Math.max(b / m, m / b) / (E * t), v = S * S * x, A = Math.max(N / v, v / M); y < f; ++y) {
      if (S += d = c[y].value, d < M && (M = d), d > N && (N = d), v = S * S * x, O = Math.max(N / v, v / M), O > A) {
        S -= d;
        break;
      }
      A = O;
    }
    u.push(l = { value: S, dice: m < b, children: c.slice(g, y) }), l.dice ? Gs(l, n, r, a, E ? r += b * S / E : o) : Ul(l, n, r, E ? n += m * S / E : a, o), E -= S, g = y;
  }
  return u;
}
const q_ = function t(e) {
  function n(r, a, o, u, c) {
    G_(e, r, a, o, u, c);
  }
  return n.ratio = function(r) {
    return t((r = +r) > 1 ? r : 1);
  }, n;
}(W_);
function K5() {
  var t = q_, e = !1, n = 1, r = 1, a = [0], o = Vi, u = Vi, c = Vi, l = Vi, d = Vi;
  function g(f) {
    return f.x0 = f.y0 = 0, f.x1 = n, f.y1 = r, f.eachBefore(y), a = [0], e && f.eachBefore(Y_), f;
  }
  function y(f) {
    var m = a[f.depth], b = f.x0 + m, E = f.y0 + m, S = f.x1 - m, M = f.y1 - m;
    S < b && (b = S = (b + S) / 2), M < E && (E = M = (E + M) / 2), f.x0 = b, f.y0 = E, f.x1 = S, f.y1 = M, f.children && (m = a[f.depth + 1] = o(f) / 2, b += d(f) - m, E += u(f) - m, S -= c(f) - m, M -= l(f) - m, S < b && (b = S = (b + S) / 2), M < E && (E = M = (E + M) / 2), t(f, b, E, S, M));
  }
  return g.round = function(f) {
    return arguments.length ? (e = !!f, g) : e;
  }, g.size = function(f) {
    return arguments.length ? (n = +f[0], r = +f[1], g) : [n, r];
  }, g.tile = function(f) {
    return arguments.length ? (t = ol(f), g) : t;
  }, g.padding = function(f) {
    return arguments.length ? g.paddingInner(f).paddingOuter(f) : g.paddingInner();
  }, g.paddingInner = function(f) {
    return arguments.length ? (o = typeof f == "function" ? f : Oa(+f), g) : o;
  }, g.paddingOuter = function(f) {
    return arguments.length ? g.paddingTop(f).paddingRight(f).paddingBottom(f).paddingLeft(f) : g.paddingTop();
  }, g.paddingTop = function(f) {
    return arguments.length ? (u = typeof f == "function" ? f : Oa(+f), g) : u;
  }, g.paddingRight = function(f) {
    return arguments.length ? (c = typeof f == "function" ? f : Oa(+f), g) : c;
  }, g.paddingBottom = function(f) {
    return arguments.length ? (l = typeof f == "function" ? f : Oa(+f), g) : l;
  }, g.paddingLeft = function(f) {
    return arguments.length ? (d = typeof f == "function" ? f : Oa(+f), g) : d;
  }, g;
}
function Z5(t, e, n, r, a) {
  var o = t.children, u, c = o.length, l, d = new Array(c + 1);
  for (d[0] = l = u = 0; u < c; ++u)
    d[u + 1] = l += o[u].value;
  g(0, c, t.value, e, n, r, a);
  function g(y, f, m, b, E, S, M) {
    if (y >= f - 1) {
      var N = o[y];
      N.x0 = b, N.y0 = E, N.x1 = S, N.y1 = M;
      return;
    }
    for (var O = d[y], A = m / 2 + O, x = y + 1, v = f - 1; x < v; ) {
      var w = x + v >>> 1;
      d[w] < A ? x = w + 1 : v = w;
    }
    A - d[x - 1] < d[x] - A && y + 1 < x && --x;
    var C = d[x] - O, P = m - C;
    if (S - b > M - E) {
      var Y = (b * P + S * C) / m;
      g(y, x, C, b, E, Y, M), g(x, f, P, Y, E, S, M);
    } else {
      var V = (E * P + M * C) / m;
      g(y, x, C, b, E, S, V), g(x, f, P, b, V, S, M);
    }
  }
}
function J5(t, e, n, r, a) {
  (t.depth & 1 ? Ul : Gs)(t, e, n, r, a);
}
const t6 = function t(e) {
  function n(r, a, o, u, c) {
    if ((l = r._squarify) && l.ratio === e)
      for (var l, d, g, y, f = -1, m, b = l.length, E = r.value; ++f < b; ) {
        for (d = l[f], g = d.children, y = d.value = 0, m = g.length; y < m; ++y) d.value += g[y].value;
        d.dice ? Gs(d, a, o, u, o += (c - o) * d.value / E) : Ul(d, a, o, a += (u - a) * d.value / E, c), E -= d.value;
      }
    else
      r._squarify = l = G_(e, r, a, o, u, c), l.ratio = e;
  }
  return n.ratio = function(r) {
    return t((r = +r) > 1 ? r : 1);
  }, n;
}(W_);
function e6(t) {
  for (var e = -1, n = t.length, r, a = t[n - 1], o = 0; ++e < n; )
    r = a, a = t[e], o += r[1] * a[0] - r[0] * a[1];
  return o / 2;
}
function n6(t) {
  for (var e = -1, n = t.length, r = 0, a = 0, o, u = t[n - 1], c, l = 0; ++e < n; )
    o = u, u = t[e], l += c = o[0] * u[1] - u[0] * o[1], r += (o[0] + u[0]) * c, a += (o[1] + u[1]) * c;
  return l *= 3, [r / l, a / l];
}
function r6(t, e, n) {
  return (e[0] - t[0]) * (n[1] - t[1]) - (e[1] - t[1]) * (n[0] - t[0]);
}
function i6(t, e) {
  return t[0] - e[0] || t[1] - e[1];
}
function j1(t) {
  for (var e = t.length, n = [0, 1], r = 2, a = 2; a < e; ++a) {
    for (; r > 1 && r6(t[n[r - 2]], t[n[r - 1]], t[a]) <= 0; ) --r;
    n[r++] = a;
  }
  return n.slice(0, r);
}
function a6(t) {
  if ((n = t.length) < 3) return null;
  var e, n, r = new Array(n), a = new Array(n);
  for (e = 0; e < n; ++e) r[e] = [+t[e][0], +t[e][1], e];
  for (r.sort(i6), e = 0; e < n; ++e) a[e] = [r[e][0], -r[e][1]];
  var o = j1(r), u = j1(a), c = u[0] === o[0], l = u[u.length - 1] === o[o.length - 1], d = [];
  for (e = o.length - 1; e >= 0; --e) d.push(t[r[o[e]][2]]);
  for (e = +c; e < u.length - l; ++e) d.push(t[r[u[e]][2]]);
  return d;
}
function o6(t, e) {
  for (var n = t.length, r = t[n - 1], a = e[0], o = e[1], u = r[0], c = r[1], l, d, g = !1, y = 0; y < n; ++y)
    r = t[y], l = r[0], d = r[1], d > o != c > o && a < (u - l) * (o - d) / (c - d) + l && (g = !g), u = l, c = d;
  return g;
}
function s6(t) {
  for (var e = -1, n = t.length, r = t[n - 1], a, o, u = r[0], c = r[1], l = 0; ++e < n; )
    a = u, o = c, r = t[e], u = r[0], c = r[1], a -= u, o -= c, l += Math.sqrt(a * a + o * o);
  return l;
}
var u6 = [].slice, c6 = {};
function tp(t) {
  this._size = t, this._call = this._error = null, this._tasks = [], this._data = [], this._waiting = this._active = this._ended = this._start = 0;
}
tp.prototype = X_.prototype = {
  constructor: tp,
  defer: function(t) {
    if (typeof t != "function") throw new Error("invalid callback");
    if (this._call) throw new Error("defer after await");
    if (this._error != null) return this;
    var e = u6.call(arguments, 1);
    return e.push(t), ++this._waiting, this._tasks.push(e), H_(this), this;
  },
  abort: function() {
    return this._error == null && n0(this, new Error("abort")), this;
  },
  await: function(t) {
    if (typeof t != "function") throw new Error("invalid callback");
    if (this._call) throw new Error("multiple await");
    return this._call = function(e, n) {
      t.apply(null, [e].concat(n));
    }, sl(this), this;
  },
  awaitAll: function(t) {
    if (typeof t != "function") throw new Error("invalid callback");
    if (this._call) throw new Error("multiple await");
    return this._call = t, sl(this), this;
  }
};
function H_(t) {
  if (!t._start)
    try {
      l6(t);
    } catch (e) {
      if (t._tasks[t._ended + t._active - 1]) n0(t, e);
      else if (!t._data) throw e;
    }
}
function l6(t) {
  for (; t._start = t._waiting && t._active < t._size; ) {
    var e = t._ended + t._active, n = t._tasks[e], r = n.length - 1, a = n[r];
    n[r] = f6(t, e), --t._waiting, ++t._active, n = a.apply(null, n), t._tasks[e] && (t._tasks[e] = n || c6);
  }
}
function f6(t, e) {
  return function(n, r) {
    t._tasks[e] && (--t._active, ++t._ended, t._tasks[e] = null, t._error == null && (n != null ? n0(t, n) : (t._data[e] = r, t._waiting ? H_(t) : sl(t))));
  };
}
function n0(t, e) {
  var n = t._tasks.length, r;
  for (t._error = e, t._data = void 0, t._waiting = NaN; --n >= 0; )
    if ((r = t._tasks[n]) && (t._tasks[n] = null, r.abort))
      try {
        r.abort();
      } catch {
      }
  t._active = NaN, sl(t);
}
function sl(t) {
  if (!t._active && t._call) {
    var e = t._data;
    t._data = void 0, t._call(t._error, e);
  }
}
function X_(t) {
  if (t == null) t = 1 / 0;
  else if (!((t = +t) >= 1)) throw new Error("invalid concurrency");
  return new tp(t);
}
function uo() {
  return Math.random();
}
const h6 = function t(e) {
  function n(r, a) {
    return r = r == null ? 0 : +r, a = a == null ? 1 : +a, arguments.length === 1 ? (a = r, r = 0) : a -= r, function() {
      return e() * a + r;
    };
  }
  return n.source = t, n;
}(uo), Q_ = function t(e) {
  function n(r, a) {
    var o, u;
    return r = r == null ? 0 : +r, a = a == null ? 1 : +a, function() {
      var c;
      if (o != null) c = o, o = null;
      else do
        o = e() * 2 - 1, c = e() * 2 - 1, u = o * o + c * c;
      while (!u || u > 1);
      return r + a * c * Math.sqrt(-2 * Math.log(u) / u);
    };
  }
  return n.source = t, n;
}(uo), d6 = function t(e) {
  function n() {
    var r = Q_.source(e).apply(this, arguments);
    return function() {
      return Math.exp(r());
    };
  }
  return n.source = t, n;
}(uo), K_ = function t(e) {
  function n(r) {
    return function() {
      for (var a = 0, o = 0; o < r; ++o) a += e();
      return a;
    };
  }
  return n.source = t, n;
}(uo), p6 = function t(e) {
  function n(r) {
    var a = K_.source(e)(r);
    return function() {
      return a() / r;
    };
  }
  return n.source = t, n;
}(uo), g6 = function t(e) {
  function n(r) {
    return function() {
      return -Math.log(1 - e()) / r;
    };
  }
  return n.source = t, n;
}(uo);
function r0(t, e) {
  var n, r = wi("beforesend", "progress", "load", "error"), a, o = Cr(), u = new XMLHttpRequest(), c = null, l = null, d, g, y = 0;
  typeof XDomainRequest < "u" && !("withCredentials" in u) && /^(http(s)?:)?\/\//.test(t) && (u = new XDomainRequest()), "onload" in u ? u.onload = u.onerror = u.ontimeout = f : u.onreadystatechange = function(m) {
    u.readyState > 3 && f(m);
  };
  function f(m) {
    var b = u.status, E;
    if (!b && y6(u) || b >= 200 && b < 300 || b === 304) {
      if (d)
        try {
          E = d.call(n, u);
        } catch (S) {
          r.call("error", n, S);
          return;
        }
      else
        E = u;
      r.call("load", n, E);
    } else
      r.call("error", n, m);
  }
  if (u.onprogress = function(m) {
    r.call("progress", n, m);
  }, n = {
    header: function(m, b) {
      return m = (m + "").toLowerCase(), arguments.length < 2 ? o.get(m) : (b == null ? o.remove(m) : o.set(m, b + ""), n);
    },
    // If mimeType is non-null and no Accept header is set, a default is used.
    mimeType: function(m) {
      return arguments.length ? (a = m == null ? null : m + "", n) : a;
    },
    // Specifies what type the response value should take;
    // for instance, arraybuffer, blob, document, or text.
    responseType: function(m) {
      return arguments.length ? (g = m, n) : g;
    },
    timeout: function(m) {
      return arguments.length ? (y = +m, n) : y;
    },
    user: function(m) {
      return arguments.length < 1 ? c : (c = m == null ? null : m + "", n);
    },
    password: function(m) {
      return arguments.length < 1 ? l : (l = m == null ? null : m + "", n);
    },
    // Specify how to convert the response content to a specific type;
    // changes the callback value on "load" events.
    response: function(m) {
      return d = m, n;
    },
    // Alias for send("GET", …).
    get: function(m, b) {
      return n.send("GET", m, b);
    },
    // Alias for send("POST", …).
    post: function(m, b) {
      return n.send("POST", m, b);
    },
    // If callback is non-null, it will be used for error and load events.
    send: function(m, b, E) {
      return u.open(m, t, !0, c, l), a != null && !o.has("accept") && o.set("accept", a + ",*/*"), u.setRequestHeader && o.each(function(S, M) {
        u.setRequestHeader(M, S);
      }), a != null && u.overrideMimeType && u.overrideMimeType(a), g != null && (u.responseType = g), y > 0 && (u.timeout = y), E == null && typeof b == "function" && (E = b, b = null), E != null && E.length === 1 && (E = m6(E)), E != null && n.on("error", E).on("load", function(S) {
        E(null, S);
      }), r.call("beforesend", n, u), u.send(b ?? null), n;
    },
    abort: function() {
      return u.abort(), n;
    },
    on: function() {
      var m = r.on.apply(r, arguments);
      return m === r ? n : m;
    }
  }, e != null) {
    if (typeof e != "function") throw new Error("invalid callback: " + e);
    return n.get(e);
  }
  return n;
}
function m6(t) {
  return function(e, n) {
    t(e == null ? n : null);
  };
}
function y6(t) {
  var e = t.responseType;
  return e && e !== "text" ? t.response : t.responseText;
}
function $l(t, e) {
  return function(n, r) {
    var a = r0(n).mimeType(t).response(e);
    if (r != null) {
      if (typeof r != "function") throw new Error("invalid callback: " + r);
      return a.get(r);
    }
    return a;
  };
}
const v6 = $l("text/html", function(t) {
  return document.createRange().createContextualFragment(t.responseText);
}), x6 = $l("application/json", function(t) {
  return JSON.parse(t.responseText);
}), _6 = $l("text/plain", function(t) {
  return t.responseText;
}), b6 = $l("application/xml", function(t) {
  var e = t.responseXML;
  if (!e) throw new Error("parse error");
  return e;
});
function Z_(t, e) {
  return function(n, r, a) {
    arguments.length < 3 && (a = r, r = null);
    var o = r0(n).mimeType(t);
    return o.row = function(u) {
      return arguments.length ? o.response(w6(e, r = u)) : r;
    }, o.row(r), a ? o.get(a) : o;
  };
}
function w6(t, e) {
  return function(n) {
    return t(n.responseText, e);
  };
}
const E6 = Z_("text/csv", Vx), S6 = Z_("text/tab-separated-values", Yx);
var J_ = Array.prototype, i0 = J_.map, vi = J_.slice, ep = { name: "implicit" };
function qs(t) {
  var e = Cr(), n = [], r = ep;
  t = t == null ? [] : vi.call(t);
  function a(o) {
    var u = o + "", c = e.get(u);
    if (!c) {
      if (r !== ep) return r;
      e.set(u, c = n.push(o));
    }
    return t[(c - 1) % t.length];
  }
  return a.domain = function(o) {
    if (!arguments.length) return n.slice();
    n = [], e = Cr();
    for (var u = -1, c = o.length, l, d; ++u < c; ) e.has(d = (l = o[u]) + "") || e.set(d, n.push(l));
    return a;
  }, a.range = function(o) {
    return arguments.length ? (t = vi.call(o), a) : t.slice();
  }, a.unknown = function(o) {
    return arguments.length ? (r = o, a) : r;
  }, a.copy = function() {
    return qs().domain(n).range(t).unknown(r);
  }, a;
}
function a0() {
  var t = qs().unknown(void 0), e = t.domain, n = t.range, r = [0, 1], a, o, u = !1, c = 0, l = 0, d = 0.5;
  delete t.unknown;
  function g() {
    var y = e().length, f = r[1] < r[0], m = r[f - 0], b = r[1 - f];
    a = (b - m) / Math.max(1, y - c + l * 2), u && (a = Math.floor(a)), m += (b - m - a * (y - c)) * d, o = a * (1 - c), u && (m = Math.round(m), o = Math.round(o));
    var E = tr(y).map(function(S) {
      return m + a * S;
    });
    return n(f ? E.reverse() : E);
  }
  return t.domain = function(y) {
    return arguments.length ? (e(y), g()) : e();
  }, t.range = function(y) {
    return arguments.length ? (r = [+y[0], +y[1]], g()) : r.slice();
  }, t.rangeRound = function(y) {
    return r = [+y[0], +y[1]], u = !0, g();
  }, t.bandwidth = function() {
    return o;
  }, t.step = function() {
    return a;
  }, t.round = function(y) {
    return arguments.length ? (u = !!y, g()) : u;
  }, t.padding = function(y) {
    return arguments.length ? (c = l = Math.max(0, Math.min(1, y)), g()) : c;
  }, t.paddingInner = function(y) {
    return arguments.length ? (c = Math.max(0, Math.min(1, y)), g()) : c;
  }, t.paddingOuter = function(y) {
    return arguments.length ? (l = Math.max(0, Math.min(1, y)), g()) : l;
  }, t.align = function(y) {
    return arguments.length ? (d = Math.max(0, Math.min(1, y)), g()) : d;
  }, t.copy = function() {
    return a0().domain(e()).range(r).round(u).paddingInner(c).paddingOuter(l).align(d);
  }, g();
}
function tb(t) {
  var e = t.copy;
  return t.padding = t.paddingOuter, delete t.paddingInner, delete t.paddingOuter, t.copy = function() {
    return tb(e());
  }, t;
}
function A6() {
  return tb(a0().paddingInner(1));
}
function o0(t) {
  return function() {
    return t;
  };
}
function eb(t) {
  return +t;
}
var k1 = [0, 1];
function s0(t, e) {
  return (e -= t = +t) ? function(n) {
    return (n - t) / e;
  } : o0(e);
}
function T6(t) {
  return function(e, n) {
    var r = t(e = +e, n = +n);
    return function(a) {
      return a <= e ? 0 : a >= n ? 1 : r(a);
    };
  };
}
function C6(t) {
  return function(e, n) {
    var r = t(e = +e, n = +n);
    return function(a) {
      return a <= 0 ? e : a >= 1 ? n : r(a);
    };
  };
}
function R6(t, e, n, r) {
  var a = t[0], o = t[1], u = e[0], c = e[1];
  return o < a ? (a = n(o, a), u = r(c, u)) : (a = n(a, o), u = r(u, c)), function(l) {
    return u(a(l));
  };
}
function D6(t, e, n, r) {
  var a = Math.min(t.length, e.length) - 1, o = new Array(a), u = new Array(a), c = -1;
  for (t[a] < t[0] && (t = t.slice().reverse(), e = e.slice().reverse()); ++c < a; )
    o[c] = n(t[c], t[c + 1]), u[c] = r(e[c], e[c + 1]);
  return function(l) {
    var d = Hi(t, l, 1, a) - 1;
    return u[d](o[d](l));
  };
}
function zl(t, e) {
  return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp());
}
function Vl(t, e) {
  var n = k1, r = k1, a = Us, o = !1, u, c, l;
  function d() {
    return u = Math.min(n.length, r.length) > 2 ? D6 : R6, c = l = null, g;
  }
  function g(y) {
    return (c || (c = u(n, r, o ? T6(t) : t, a)))(+y);
  }
  return g.invert = function(y) {
    return (l || (l = u(r, n, s0, o ? C6(e) : e)))(+y);
  }, g.domain = function(y) {
    return arguments.length ? (n = i0.call(y, eb), d()) : n.slice();
  }, g.range = function(y) {
    return arguments.length ? (r = vi.call(y), d()) : r.slice();
  }, g.rangeRound = function(y) {
    return r = vi.call(y), a = bx, d();
  }, g.clamp = function(y) {
    return arguments.length ? (o = !!y, d()) : o;
  }, g.interpolate = function(y) {
    return arguments.length ? (a = y, d()) : a;
  }, d();
}
function M6(t, e, n) {
  var r = t[0], a = t[t.length - 1], o = hs(r, a, e ?? 10), u;
  switch (n = Es(n ?? ",f"), n.type) {
    case "s": {
      var c = Math.max(Math.abs(r), Math.abs(a));
      return n.precision == null && !isNaN(u = Kx(o, c)) && (n.precision = u), $s(n, c);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      n.precision == null && !isNaN(u = Zx(o, Math.max(Math.abs(r), Math.abs(a)))) && (n.precision = u - (n.type === "e"));
      break;
    }
    case "f":
    case "%": {
      n.precision == null && !isNaN(u = Qx(o)) && (n.precision = u - (n.type === "%") * 2);
      break;
    }
  }
  return Yt(n);
}
function Hs(t) {
  var e = t.domain;
  return t.ticks = function(n) {
    var r = e();
    return pp(r[0], r[r.length - 1], n ?? 10);
  }, t.tickFormat = function(n, r) {
    return M6(e(), n, r);
  }, t.nice = function(n) {
    n == null && (n = 10);
    var r = e(), a = 0, o = r.length - 1, u = r[a], c = r[o], l;
    return c < u && (l = u, u = c, c = l, l = a, a = o, o = l), l = as(u, c, n), l > 0 ? (u = Math.floor(u / l) * l, c = Math.ceil(c / l) * l, l = as(u, c, n)) : l < 0 && (u = Math.ceil(u * l) / l, c = Math.floor(c * l) / l, l = as(u, c, n)), l > 0 ? (r[a] = Math.floor(u / l) * l, r[o] = Math.ceil(c / l) * l, e(r)) : l < 0 && (r[a] = Math.ceil(u * l) / l, r[o] = Math.floor(c * l) / l, e(r)), t;
  }, t;
}
function ul() {
  var t = Vl(s0, jn);
  return t.copy = function() {
    return zl(t, ul());
  }, Hs(t);
}
function nb() {
  var t = [0, 1];
  function e(n) {
    return +n;
  }
  return e.invert = e, e.domain = e.range = function(n) {
    return arguments.length ? (t = i0.call(n, eb), e) : t.slice();
  }, e.copy = function() {
    return nb().domain(t);
  }, Hs(e);
}
function rb(t, e) {
  t = t.slice();
  var n = 0, r = t.length - 1, a = t[n], o = t[r], u;
  return o < a && (u = n, n = r, r = u, u = a, a = o, o = u), t[n] = e.floor(a), t[r] = e.ceil(o), t;
}
function O6(t, e) {
  return (e = Math.log(e / t)) ? function(n) {
    return Math.log(n / t) / e;
  } : o0(e);
}
function L6(t, e) {
  return t < 0 ? function(n) {
    return -Math.pow(-e, n) * Math.pow(-t, 1 - n);
  } : function(n) {
    return Math.pow(e, n) * Math.pow(t, 1 - n);
  };
}
function P6(t) {
  return isFinite(t) ? +("1e" + t) : t < 0 ? 0 : t;
}
function B1(t) {
  return t === 10 ? P6 : t === Math.E ? Math.exp : function(e) {
    return Math.pow(t, e);
  };
}
function F1(t) {
  return t === Math.E ? Math.log : t === 10 && Math.log10 || t === 2 && Math.log2 || (t = Math.log(t), function(e) {
    return Math.log(e) / t;
  });
}
function U1(t) {
  return function(e) {
    return -t(-e);
  };
}
function ib() {
  var t = Vl(O6, L6).domain([1, 10]), e = t.domain, n = 10, r = F1(10), a = B1(10);
  function o() {
    return r = F1(n), a = B1(n), e()[0] < 0 && (r = U1(r), a = U1(a)), t;
  }
  return t.base = function(u) {
    return arguments.length ? (n = +u, o()) : n;
  }, t.domain = function(u) {
    return arguments.length ? (e(u), o()) : e();
  }, t.ticks = function(u) {
    var c = e(), l = c[0], d = c[c.length - 1], g;
    (g = d < l) && (y = l, l = d, d = y);
    var y = r(l), f = r(d), m, b, E, S = u == null ? 10 : +u, M = [];
    if (!(n % 1) && f - y < S) {
      if (y = Math.round(y) - 1, f = Math.round(f) + 1, l > 0) {
        for (; y < f; ++y)
          for (b = 1, m = a(y); b < n; ++b)
            if (E = m * b, !(E < l)) {
              if (E > d) break;
              M.push(E);
            }
      } else for (; y < f; ++y)
        for (b = n - 1, m = a(y); b >= 1; --b)
          if (E = m * b, !(E < l)) {
            if (E > d) break;
            M.push(E);
          }
    } else
      M = pp(y, f, Math.min(f - y, S)).map(a);
    return g ? M.reverse() : M;
  }, t.tickFormat = function(u, c) {
    if (c == null && (c = n === 10 ? ".0e" : ","), typeof c != "function" && (c = Yt(c)), u === 1 / 0) return c;
    u == null && (u = 10);
    var l = Math.max(1, n * u / t.ticks().length);
    return function(d) {
      var g = d / a(Math.round(r(d)));
      return g * n < n - 0.5 && (g *= n), g <= l ? c(d) : "";
    };
  }, t.nice = function() {
    return e(rb(e(), {
      floor: function(u) {
        return a(Math.floor(r(u)));
      },
      ceil: function(u) {
        return a(Math.ceil(r(u)));
      }
    }));
  }, t.copy = function() {
    return zl(t, ib().base(n));
  }, t;
}
function Ca(t, e) {
  return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
}
function u0() {
  var t = 1, e = Vl(r, a), n = e.domain;
  function r(o, u) {
    return (u = Ca(u, t) - (o = Ca(o, t))) ? function(c) {
      return (Ca(c, t) - o) / u;
    } : o0(u);
  }
  function a(o, u) {
    return u = Ca(u, t) - (o = Ca(o, t)), function(c) {
      return Ca(o + u * c, 1 / t);
    };
  }
  return e.exponent = function(o) {
    return arguments.length ? (t = +o, n(n())) : t;
  }, e.copy = function() {
    return zl(e, u0().exponent(t));
  }, Hs(e);
}
function N6() {
  return u0().exponent(0.5);
}
function ab() {
  var t = [], e = [], n = [];
  function r() {
    var o = 0, u = Math.max(1, e.length);
    for (n = new Array(u - 1); ++o < u; ) n[o - 1] = ds(t, o / u);
    return a;
  }
  function a(o) {
    if (!isNaN(o = +o)) return e[Hi(n, o)];
  }
  return a.invertExtent = function(o) {
    var u = e.indexOf(o);
    return u < 0 ? [NaN, NaN] : [
      u > 0 ? n[u - 1] : t[0],
      u < n.length ? n[u] : t[t.length - 1]
    ];
  }, a.domain = function(o) {
    if (!arguments.length) return t.slice();
    t = [];
    for (var u = 0, c = o.length, l; u < c; ++u) l = o[u], l != null && !isNaN(l = +l) && t.push(l);
    return t.sort(ea), r();
  }, a.range = function(o) {
    return arguments.length ? (e = vi.call(o), r()) : e.slice();
  }, a.quantiles = function() {
    return n.slice();
  }, a.copy = function() {
    return ab().domain(t).range(e);
  }, a;
}
function ob() {
  var t = 0, e = 1, n = 1, r = [0.5], a = [0, 1];
  function o(c) {
    if (c <= c) return a[Hi(r, c, 0, n)];
  }
  function u() {
    var c = -1;
    for (r = new Array(n); ++c < n; ) r[c] = ((c + 1) * e - (c - n) * t) / (n + 1);
    return o;
  }
  return o.domain = function(c) {
    return arguments.length ? (t = +c[0], e = +c[1], u()) : [t, e];
  }, o.range = function(c) {
    return arguments.length ? (n = (a = vi.call(c)).length - 1, u()) : a.slice();
  }, o.invertExtent = function(c) {
    var l = a.indexOf(c);
    return l < 0 ? [NaN, NaN] : l < 1 ? [t, r[0]] : l >= n ? [r[n - 1], e] : [r[l - 1], r[l]];
  }, o.copy = function() {
    return ob().domain([t, e]).range(a);
  }, Hs(o);
}
function sb() {
  var t = [0.5], e = [0, 1], n = 1;
  function r(a) {
    if (a <= a) return e[Hi(t, a, 0, n)];
  }
  return r.domain = function(a) {
    return arguments.length ? (t = vi.call(a), n = Math.min(t.length, e.length - 1), r) : t.slice();
  }, r.range = function(a) {
    return arguments.length ? (e = vi.call(a), n = Math.min(t.length, e.length - 1), r) : e.slice();
  }, r.invertExtent = function(a) {
    var o = e.indexOf(a);
    return [t[o - 1], t[o]];
  }, r.copy = function() {
    return sb().domain(t).range(e);
  }, r;
}
var Jh = /* @__PURE__ */ new Date(), td = /* @__PURE__ */ new Date();
function Ve(t, e, n, r) {
  function a(o) {
    return t(o = /* @__PURE__ */ new Date(+o)), o;
  }
  return a.floor = a, a.ceil = function(o) {
    return t(o = new Date(o - 1)), e(o, 1), t(o), o;
  }, a.round = function(o) {
    var u = a(o), c = a.ceil(o);
    return o - u < c - o ? u : c;
  }, a.offset = function(o, u) {
    return e(o = /* @__PURE__ */ new Date(+o), u == null ? 1 : Math.floor(u)), o;
  }, a.range = function(o, u, c) {
    var l = [], d;
    if (o = a.ceil(o), c = c == null ? 1 : Math.floor(c), !(o < u) || !(c > 0)) return l;
    do
      l.push(d = /* @__PURE__ */ new Date(+o)), e(o, c), t(o);
    while (d < o && o < u);
    return l;
  }, a.filter = function(o) {
    return Ve(function(u) {
      if (u >= u) for (; t(u), !o(u); ) u.setTime(u - 1);
    }, function(u, c) {
      if (u >= u)
        if (c < 0) for (; ++c <= 0; )
          for (; e(u, -1), !o(u); )
            ;
        else for (; --c >= 0; )
          for (; e(u, 1), !o(u); )
            ;
    });
  }, n && (a.count = function(o, u) {
    return Jh.setTime(+o), td.setTime(+u), t(Jh), t(td), Math.floor(n(Jh, td));
  }, a.every = function(o) {
    return o = Math.floor(o), !isFinite(o) || !(o > 0) ? null : o > 1 ? a.filter(r ? function(u) {
      return r(u) % o === 0;
    } : function(u) {
      return a.count(0, u) % o === 0;
    }) : a;
  }), a;
}
var ta = Ve(function() {
}, function(t, e) {
  t.setTime(+t + e);
}, function(t, e) {
  return e - t;
});
ta.every = function(t) {
  return t = Math.floor(t), !isFinite(t) || !(t > 0) ? null : t > 1 ? Ve(function(e) {
    e.setTime(Math.floor(e / t) * t);
  }, function(e, n) {
    e.setTime(+e + n * t);
  }, function(e, n) {
    return (n - e) / t;
  }) : ta;
};
var $1 = ta.range, oc = 1e3, Wr = 6e4, li = 36e5, ub = 864e5, cb = 6048e5, Rs = Ve(function(t) {
  t.setTime(Math.floor(t / oc) * oc);
}, function(t, e) {
  t.setTime(+t + e * oc);
}, function(t, e) {
  return (e - t) / oc;
}, function(t) {
  return t.getUTCSeconds();
}), z1 = Rs.range, c0 = Ve(function(t) {
  t.setTime(Math.floor(t / Wr) * Wr);
}, function(t, e) {
  t.setTime(+t + e * Wr);
}, function(t, e) {
  return (e - t) / Wr;
}, function(t) {
  return t.getMinutes();
}), I6 = c0.range, l0 = Ve(function(t) {
  var e = t.getTimezoneOffset() * Wr % li;
  e < 0 && (e += li), t.setTime(Math.floor((+t - e) / li) * li + e);
}, function(t, e) {
  t.setTime(+t + e * li);
}, function(t, e) {
  return (e - t) / li;
}, function(t) {
  return t.getHours();
}), j6 = l0.range, Xs = Ve(function(t) {
  t.setHours(0, 0, 0, 0);
}, function(t, e) {
  t.setDate(t.getDate() + e);
}, function(t, e) {
  return (e - t - (e.getTimezoneOffset() - t.getTimezoneOffset()) * Wr) / ub;
}, function(t) {
  return t.getDate() - 1;
}), k6 = Xs.range;
function ia(t) {
  return Ve(function(e) {
    e.setDate(e.getDate() - (e.getDay() + 7 - t) % 7), e.setHours(0, 0, 0, 0);
  }, function(e, n) {
    e.setDate(e.getDate() + n * 7);
  }, function(e, n) {
    return (n - e - (n.getTimezoneOffset() - e.getTimezoneOffset()) * Wr) / cb;
  });
}
var Ds = ia(0), Ms = ia(1), lb = ia(2), fb = ia(3), us = ia(4), hb = ia(5), db = ia(6), V1 = Ds.range, B6 = Ms.range, F6 = lb.range, U6 = fb.range, $6 = us.range, z6 = hb.range, V6 = db.range, f0 = Ve(function(t) {
  t.setDate(1), t.setHours(0, 0, 0, 0);
}, function(t, e) {
  t.setMonth(t.getMonth() + e);
}, function(t, e) {
  return e.getMonth() - t.getMonth() + (e.getFullYear() - t.getFullYear()) * 12;
}, function(t) {
  return t.getMonth();
}), Y6 = f0.range, Hr = Ve(function(t) {
  t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, function(t, e) {
  t.setFullYear(t.getFullYear() + e);
}, function(t, e) {
  return e.getFullYear() - t.getFullYear();
}, function(t) {
  return t.getFullYear();
});
Hr.every = function(t) {
  return !isFinite(t = Math.floor(t)) || !(t > 0) ? null : Ve(function(e) {
    e.setFullYear(Math.floor(e.getFullYear() / t) * t), e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
  }, function(e, n) {
    e.setFullYear(e.getFullYear() + n * t);
  });
};
var W6 = Hr.range, h0 = Ve(function(t) {
  t.setUTCSeconds(0, 0);
}, function(t, e) {
  t.setTime(+t + e * Wr);
}, function(t, e) {
  return (e - t) / Wr;
}, function(t) {
  return t.getUTCMinutes();
}), G6 = h0.range, d0 = Ve(function(t) {
  t.setUTCMinutes(0, 0, 0);
}, function(t, e) {
  t.setTime(+t + e * li);
}, function(t, e) {
  return (e - t) / li;
}, function(t) {
  return t.getUTCHours();
}), q6 = d0.range, Qs = Ve(function(t) {
  t.setUTCHours(0, 0, 0, 0);
}, function(t, e) {
  t.setUTCDate(t.getUTCDate() + e);
}, function(t, e) {
  return (e - t) / ub;
}, function(t) {
  return t.getUTCDate() - 1;
}), H6 = Qs.range;
function aa(t) {
  return Ve(function(e) {
    e.setUTCDate(e.getUTCDate() - (e.getUTCDay() + 7 - t) % 7), e.setUTCHours(0, 0, 0, 0);
  }, function(e, n) {
    e.setUTCDate(e.getUTCDate() + n * 7);
  }, function(e, n) {
    return (n - e) / cb;
  });
}
var Os = aa(0), Ls = aa(1), pb = aa(2), gb = aa(3), cs = aa(4), mb = aa(5), yb = aa(6), Y1 = Os.range, X6 = Ls.range, Q6 = pb.range, K6 = gb.range, Z6 = cs.range, J6 = mb.range, t8 = yb.range, p0 = Ve(function(t) {
  t.setUTCDate(1), t.setUTCHours(0, 0, 0, 0);
}, function(t, e) {
  t.setUTCMonth(t.getUTCMonth() + e);
}, function(t, e) {
  return e.getUTCMonth() - t.getUTCMonth() + (e.getUTCFullYear() - t.getUTCFullYear()) * 12;
}, function(t) {
  return t.getUTCMonth();
}), e8 = p0.range, Xr = Ve(function(t) {
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, function(t, e) {
  t.setUTCFullYear(t.getUTCFullYear() + e);
}, function(t, e) {
  return e.getUTCFullYear() - t.getUTCFullYear();
}, function(t) {
  return t.getUTCFullYear();
});
Xr.every = function(t) {
  return !isFinite(t = Math.floor(t)) || !(t > 0) ? null : Ve(function(e) {
    e.setUTCFullYear(Math.floor(e.getUTCFullYear() / t) * t), e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  }, function(e, n) {
    e.setUTCFullYear(e.getUTCFullYear() + n * t);
  });
};
var n8 = Xr.range;
function r8(t) {
  if (0 <= t.y && t.y < 100) {
    var e = new Date(-1, t.m, t.d, t.H, t.M, t.S, t.L);
    return e.setFullYear(t.y), e;
  }
  return new Date(t.y, t.m, t.d, t.H, t.M, t.S, t.L);
}
function sc(t) {
  if (0 <= t.y && t.y < 100) {
    var e = new Date(Date.UTC(-1, t.m, t.d, t.H, t.M, t.S, t.L));
    return e.setUTCFullYear(t.y), e;
  }
  return new Date(Date.UTC(t.y, t.m, t.d, t.H, t.M, t.S, t.L));
}
function No(t) {
  return { y: t, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0 };
}
function vb(t) {
  var e = t.dateTime, n = t.date, r = t.time, a = t.periods, o = t.days, u = t.shortDays, c = t.months, l = t.shortMonths, d = Io(a), g = jo(a), y = Io(o), f = jo(o), m = Io(u), b = jo(u), E = Io(c), S = jo(c), M = Io(l), N = jo(l), O = {
    a: H,
    A: W,
    b: B,
    B: j,
    c: null,
    d: H1,
    e: H1,
    f: C8,
    H: S8,
    I: A8,
    j: T8,
    L: xb,
    m: R8,
    M: D8,
    p: X,
    Q: K1,
    s: Z1,
    S: M8,
    u: O8,
    U: L8,
    V: P8,
    w: N8,
    W: I8,
    x: null,
    X: null,
    y: j8,
    Y: k8,
    Z: B8,
    "%": Q1
  }, A = {
    a: tt,
    A: et,
    b: ot,
    B: Z,
    c: null,
    d: X1,
    e: X1,
    f: z8,
    H: F8,
    I: U8,
    j: $8,
    L: _b,
    m: V8,
    M: Y8,
    p: lt,
    Q: K1,
    s: Z1,
    S: W8,
    u: G8,
    U: q8,
    V: H8,
    w: X8,
    W: Q8,
    x: null,
    X: null,
    y: K8,
    Y: Z8,
    Z: J8,
    "%": Q1
  }, x = {
    a: Y,
    A: V,
    b: k,
    B: T,
    c: R,
    d: G1,
    e: G1,
    f: _8,
    H: q1,
    I: q1,
    j: m8,
    L: x8,
    m: g8,
    M: y8,
    p: P,
    Q: w8,
    s: E8,
    S: v8,
    u: u8,
    U: c8,
    V: l8,
    w: s8,
    W: f8,
    x: F,
    X: U,
    y: d8,
    Y: h8,
    Z: p8,
    "%": b8
  };
  O.x = v(n, O), O.X = v(r, O), O.c = v(e, O), A.x = v(n, A), A.X = v(r, A), A.c = v(e, A);
  function v(z, nt) {
    return function(it) {
      var Q = [], ht = -1, pt = 0, st = z.length, xt, gt, dt;
      for (it instanceof Date || (it = /* @__PURE__ */ new Date(+it)); ++ht < st; )
        z.charCodeAt(ht) === 37 && (Q.push(z.slice(pt, ht)), (gt = W1[xt = z.charAt(++ht)]) != null ? xt = z.charAt(++ht) : gt = xt === "e" ? " " : "0", (dt = nt[xt]) && (xt = dt(it, gt)), Q.push(xt), pt = ht + 1);
      return Q.push(z.slice(pt, ht)), Q.join("");
    };
  }
  function w(z, nt) {
    return function(it) {
      var Q = No(1900), ht = C(Q, z, it += "", 0), pt, st;
      if (ht != it.length) return null;
      if ("Q" in Q) return new Date(Q.Q);
      if ("p" in Q && (Q.H = Q.H % 12 + Q.p * 12), "V" in Q) {
        if (Q.V < 1 || Q.V > 53) return null;
        "w" in Q || (Q.w = 1), "Z" in Q ? (pt = sc(No(Q.y)), st = pt.getUTCDay(), pt = st > 4 || st === 0 ? Ls.ceil(pt) : Ls(pt), pt = Qs.offset(pt, (Q.V - 1) * 7), Q.y = pt.getUTCFullYear(), Q.m = pt.getUTCMonth(), Q.d = pt.getUTCDate() + (Q.w + 6) % 7) : (pt = nt(No(Q.y)), st = pt.getDay(), pt = st > 4 || st === 0 ? Ms.ceil(pt) : Ms(pt), pt = Xs.offset(pt, (Q.V - 1) * 7), Q.y = pt.getFullYear(), Q.m = pt.getMonth(), Q.d = pt.getDate() + (Q.w + 6) % 7);
      } else ("W" in Q || "U" in Q) && ("w" in Q || (Q.w = "u" in Q ? Q.u % 7 : "W" in Q ? 1 : 0), st = "Z" in Q ? sc(No(Q.y)).getUTCDay() : nt(No(Q.y)).getDay(), Q.m = 0, Q.d = "W" in Q ? (Q.w + 6) % 7 + Q.W * 7 - (st + 5) % 7 : Q.w + Q.U * 7 - (st + 6) % 7);
      return "Z" in Q ? (Q.H += Q.Z / 100 | 0, Q.M += Q.Z % 100, sc(Q)) : nt(Q);
    };
  }
  function C(z, nt, it, Q) {
    for (var ht = 0, pt = nt.length, st = it.length, xt, gt; ht < pt; ) {
      if (Q >= st) return -1;
      if (xt = nt.charCodeAt(ht++), xt === 37) {
        if (xt = nt.charAt(ht++), gt = x[xt in W1 ? nt.charAt(ht++) : xt], !gt || (Q = gt(z, it, Q)) < 0) return -1;
      } else if (xt != it.charCodeAt(Q++))
        return -1;
    }
    return Q;
  }
  function P(z, nt, it) {
    var Q = d.exec(nt.slice(it));
    return Q ? (z.p = g[Q[0].toLowerCase()], it + Q[0].length) : -1;
  }
  function Y(z, nt, it) {
    var Q = m.exec(nt.slice(it));
    return Q ? (z.w = b[Q[0].toLowerCase()], it + Q[0].length) : -1;
  }
  function V(z, nt, it) {
    var Q = y.exec(nt.slice(it));
    return Q ? (z.w = f[Q[0].toLowerCase()], it + Q[0].length) : -1;
  }
  function k(z, nt, it) {
    var Q = M.exec(nt.slice(it));
    return Q ? (z.m = N[Q[0].toLowerCase()], it + Q[0].length) : -1;
  }
  function T(z, nt, it) {
    var Q = E.exec(nt.slice(it));
    return Q ? (z.m = S[Q[0].toLowerCase()], it + Q[0].length) : -1;
  }
  function R(z, nt, it) {
    return C(z, e, nt, it);
  }
  function F(z, nt, it) {
    return C(z, n, nt, it);
  }
  function U(z, nt, it) {
    return C(z, r, nt, it);
  }
  function H(z) {
    return u[z.getDay()];
  }
  function W(z) {
    return o[z.getDay()];
  }
  function B(z) {
    return l[z.getMonth()];
  }
  function j(z) {
    return c[z.getMonth()];
  }
  function X(z) {
    return a[+(z.getHours() >= 12)];
  }
  function tt(z) {
    return u[z.getUTCDay()];
  }
  function et(z) {
    return o[z.getUTCDay()];
  }
  function ot(z) {
    return l[z.getUTCMonth()];
  }
  function Z(z) {
    return c[z.getUTCMonth()];
  }
  function lt(z) {
    return a[+(z.getUTCHours() >= 12)];
  }
  return {
    format: function(z) {
      var nt = v(z += "", O);
      return nt.toString = function() {
        return z;
      }, nt;
    },
    parse: function(z) {
      var nt = w(z += "", r8);
      return nt.toString = function() {
        return z;
      }, nt;
    },
    utcFormat: function(z) {
      var nt = v(z += "", A);
      return nt.toString = function() {
        return z;
      }, nt;
    },
    utcParse: function(z) {
      var nt = w(z, sc);
      return nt.toString = function() {
        return z;
      }, nt;
    }
  };
}
var W1 = { "-": "", _: " ", 0: "0" }, Ze = /^\s*\d+/, i8 = /^%/, a8 = /[\\^$*+?|[\]().{}]/g;
function de(t, e, n) {
  var r = t < 0 ? "-" : "", a = (r ? -t : t) + "", o = a.length;
  return r + (o < n ? new Array(n - o + 1).join(e) + a : a);
}
function o8(t) {
  return t.replace(a8, "\\$&");
}
function Io(t) {
  return new RegExp("^(?:" + t.map(o8).join("|") + ")", "i");
}
function jo(t) {
  for (var e = {}, n = -1, r = t.length; ++n < r; ) e[t[n].toLowerCase()] = n;
  return e;
}
function s8(t, e, n) {
  var r = Ze.exec(e.slice(n, n + 1));
  return r ? (t.w = +r[0], n + r[0].length) : -1;
}
function u8(t, e, n) {
  var r = Ze.exec(e.slice(n, n + 1));
  return r ? (t.u = +r[0], n + r[0].length) : -1;
}
function c8(t, e, n) {
  var r = Ze.exec(e.slice(n, n + 2));
  return r ? (t.U = +r[0], n + r[0].length) : -1;
}
function l8(t, e, n) {
  var r = Ze.exec(e.slice(n, n + 2));
  return r ? (t.V = +r[0], n + r[0].length) : -1;
}
function f8(t, e, n) {
  var r = Ze.exec(e.slice(n, n + 2));
  return r ? (t.W = +r[0], n + r[0].length) : -1;
}
function h8(t, e, n) {
  var r = Ze.exec(e.slice(n, n + 4));
  return r ? (t.y = +r[0], n + r[0].length) : -1;
}
function d8(t, e, n) {
  var r = Ze.exec(e.slice(n, n + 2));
  return r ? (t.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}
function p8(t, e, n) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(e.slice(n, n + 6));
  return r ? (t.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}
function g8(t, e, n) {
  var r = Ze.exec(e.slice(n, n + 2));
  return r ? (t.m = r[0] - 1, n + r[0].length) : -1;
}
function G1(t, e, n) {
  var r = Ze.exec(e.slice(n, n + 2));
  return r ? (t.d = +r[0], n + r[0].length) : -1;
}
function m8(t, e, n) {
  var r = Ze.exec(e.slice(n, n + 3));
  return r ? (t.m = 0, t.d = +r[0], n + r[0].length) : -1;
}
function q1(t, e, n) {
  var r = Ze.exec(e.slice(n, n + 2));
  return r ? (t.H = +r[0], n + r[0].length) : -1;
}
function y8(t, e, n) {
  var r = Ze.exec(e.slice(n, n + 2));
  return r ? (t.M = +r[0], n + r[0].length) : -1;
}
function v8(t, e, n) {
  var r = Ze.exec(e.slice(n, n + 2));
  return r ? (t.S = +r[0], n + r[0].length) : -1;
}
function x8(t, e, n) {
  var r = Ze.exec(e.slice(n, n + 3));
  return r ? (t.L = +r[0], n + r[0].length) : -1;
}
function _8(t, e, n) {
  var r = Ze.exec(e.slice(n, n + 6));
  return r ? (t.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}
function b8(t, e, n) {
  var r = i8.exec(e.slice(n, n + 1));
  return r ? n + r[0].length : -1;
}
function w8(t, e, n) {
  var r = Ze.exec(e.slice(n));
  return r ? (t.Q = +r[0], n + r[0].length) : -1;
}
function E8(t, e, n) {
  var r = Ze.exec(e.slice(n));
  return r ? (t.Q = +r[0] * 1e3, n + r[0].length) : -1;
}
function H1(t, e) {
  return de(t.getDate(), e, 2);
}
function S8(t, e) {
  return de(t.getHours(), e, 2);
}
function A8(t, e) {
  return de(t.getHours() % 12 || 12, e, 2);
}
function T8(t, e) {
  return de(1 + Xs.count(Hr(t), t), e, 3);
}
function xb(t, e) {
  return de(t.getMilliseconds(), e, 3);
}
function C8(t, e) {
  return xb(t, e) + "000";
}
function R8(t, e) {
  return de(t.getMonth() + 1, e, 2);
}
function D8(t, e) {
  return de(t.getMinutes(), e, 2);
}
function M8(t, e) {
  return de(t.getSeconds(), e, 2);
}
function O8(t) {
  var e = t.getDay();
  return e === 0 ? 7 : e;
}
function L8(t, e) {
  return de(Ds.count(Hr(t), t), e, 2);
}
function P8(t, e) {
  var n = t.getDay();
  return t = n >= 4 || n === 0 ? us(t) : us.ceil(t), de(us.count(Hr(t), t) + (Hr(t).getDay() === 4), e, 2);
}
function N8(t) {
  return t.getDay();
}
function I8(t, e) {
  return de(Ms.count(Hr(t), t), e, 2);
}
function j8(t, e) {
  return de(t.getFullYear() % 100, e, 2);
}
function k8(t, e) {
  return de(t.getFullYear() % 1e4, e, 4);
}
function B8(t) {
  var e = t.getTimezoneOffset();
  return (e > 0 ? "-" : (e *= -1, "+")) + de(e / 60 | 0, "0", 2) + de(e % 60, "0", 2);
}
function X1(t, e) {
  return de(t.getUTCDate(), e, 2);
}
function F8(t, e) {
  return de(t.getUTCHours(), e, 2);
}
function U8(t, e) {
  return de(t.getUTCHours() % 12 || 12, e, 2);
}
function $8(t, e) {
  return de(1 + Qs.count(Xr(t), t), e, 3);
}
function _b(t, e) {
  return de(t.getUTCMilliseconds(), e, 3);
}
function z8(t, e) {
  return _b(t, e) + "000";
}
function V8(t, e) {
  return de(t.getUTCMonth() + 1, e, 2);
}
function Y8(t, e) {
  return de(t.getUTCMinutes(), e, 2);
}
function W8(t, e) {
  return de(t.getUTCSeconds(), e, 2);
}
function G8(t) {
  var e = t.getUTCDay();
  return e === 0 ? 7 : e;
}
function q8(t, e) {
  return de(Os.count(Xr(t), t), e, 2);
}
function H8(t, e) {
  var n = t.getUTCDay();
  return t = n >= 4 || n === 0 ? cs(t) : cs.ceil(t), de(cs.count(Xr(t), t) + (Xr(t).getUTCDay() === 4), e, 2);
}
function X8(t) {
  return t.getUTCDay();
}
function Q8(t, e) {
  return de(Ls.count(Xr(t), t), e, 2);
}
function K8(t, e) {
  return de(t.getUTCFullYear() % 100, e, 2);
}
function Z8(t, e) {
  return de(t.getUTCFullYear() % 1e4, e, 4);
}
function J8() {
  return "+0000";
}
function Q1() {
  return "%";
}
function K1(t) {
  return +t;
}
function Z1(t) {
  return Math.floor(+t / 1e3);
}
var Ra, je, bb, Yl, g0;
wb({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function wb(t) {
  return Ra = vb(t), je = Ra.format, bb = Ra.parse, Yl = Ra.utcFormat, g0 = Ra.utcParse, Ra;
}
var Eb = "%Y-%m-%dT%H:%M:%S.%LZ";
function t4(t) {
  return t.toISOString();
}
var e4 = Date.prototype.toISOString ? t4 : Yl(Eb);
function n4(t) {
  var e = new Date(t);
  return isNaN(e) ? null : e;
}
var r4 = +/* @__PURE__ */ new Date("2000-01-01T00:00:00.000Z") ? n4 : g0(Eb), Ko = 1e3, Zo = Ko * 60, Jo = Zo * 60, Ps = Jo * 24, i4 = Ps * 7, J1 = Ps * 30, ed = Ps * 365;
function a4(t) {
  return new Date(t);
}
function o4(t) {
  return t instanceof Date ? +t : +/* @__PURE__ */ new Date(+t);
}
function m0(t, e, n, r, a, o, u, c, l) {
  var d = Vl(s0, jn), g = d.invert, y = d.domain, f = l(".%L"), m = l(":%S"), b = l("%I:%M"), E = l("%I %p"), S = l("%a %d"), M = l("%b %d"), N = l("%B"), O = l("%Y"), A = [
    [u, 1, Ko],
    [u, 5, 5 * Ko],
    [u, 15, 15 * Ko],
    [u, 30, 30 * Ko],
    [o, 1, Zo],
    [o, 5, 5 * Zo],
    [o, 15, 15 * Zo],
    [o, 30, 30 * Zo],
    [a, 1, Jo],
    [a, 3, 3 * Jo],
    [a, 6, 6 * Jo],
    [a, 12, 12 * Jo],
    [r, 1, Ps],
    [r, 2, 2 * Ps],
    [n, 1, i4],
    [e, 1, J1],
    [e, 3, 3 * J1],
    [t, 1, ed]
  ];
  function x(w) {
    return (u(w) < w ? f : o(w) < w ? m : a(w) < w ? b : r(w) < w ? E : e(w) < w ? n(w) < w ? S : M : t(w) < w ? N : O)(w);
  }
  function v(w, C, P, Y) {
    if (w == null && (w = 10), typeof w == "number") {
      var V = Math.abs(P - C) / w, k = dp(function(T) {
        return T[2];
      }).right(A, V);
      k === A.length ? (Y = hs(C / ed, P / ed, w), w = t) : k ? (k = A[V / A[k - 1][2] < A[k][2] / V ? k - 1 : k], Y = k[1], w = k[0]) : (Y = Math.max(hs(C, P, w), 1), w = c);
    }
    return Y == null ? w : w.every(Y);
  }
  return d.invert = function(w) {
    return new Date(g(w));
  }, d.domain = function(w) {
    return arguments.length ? y(i0.call(w, o4)) : y().map(a4);
  }, d.ticks = function(w, C) {
    var P = y(), Y = P[0], V = P[P.length - 1], k = V < Y, T;
    return k && (T = Y, Y = V, V = T), T = v(w, Y, V, C), T = T ? T.range(Y, V + 1) : [], k ? T.reverse() : T;
  }, d.tickFormat = function(w, C) {
    return C == null ? x : l(C);
  }, d.nice = function(w, C) {
    var P = y();
    return (w = v(w, P[0], P[P.length - 1], C)) ? y(rb(P, w)) : d;
  }, d.copy = function() {
    return zl(d, m0(t, e, n, r, a, o, u, c, l));
  }, d;
}
function Wl() {
  return m0(Hr, f0, Ds, Xs, l0, c0, Rs, ta, je).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]);
}
function s4() {
  return m0(Xr, p0, Os, Qs, d0, h0, Rs, ta, Yl).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]);
}
function Ti(t) {
  return t.match(/.{6}/g).map(function(e) {
    return "#" + e;
  });
}
const u4 = Ti("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"), c4 = Ti("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6"), l4 = Ti("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9"), f4 = Ti("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5"), h4 = Ol(cr(300, 0.5, 0), cr(-240, 0.5, 1));
var d4 = Ol(cr(-100, 0.75, 0.35), cr(80, 1.5, 0.8)), p4 = Ol(cr(260, 0.75, 0.35), cr(80, 1.5, 0.8)), uc = cr();
function g4(t) {
  (t < 0 || t > 1) && (t -= Math.floor(t));
  var e = Math.abs(t - 0.5);
  return uc.h = 360 * t - 100, uc.s = 1.5 - 1.5 * e, uc.l = 0.8 - 0.9 * e, uc + "";
}
function Gl(t) {
  var e = t.length;
  return function(n) {
    return t[Math.max(0, Math.min(e - 1, Math.floor(n * e)))];
  };
}
const m4 = Gl(Ti("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var y4 = Gl(Ti("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf")), v4 = Gl(Ti("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4")), x4 = Gl(Ti("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
function Sb(t) {
  var e = 0, n = 1, r = !1;
  function a(o) {
    var u = (o - e) / (n - e);
    return t(r ? Math.max(0, Math.min(1, u)) : u);
  }
  return a.domain = function(o) {
    return arguments.length ? (e = +o[0], n = +o[1], a) : [e, n];
  }, a.clamp = function(o) {
    return arguments.length ? (r = !!o, a) : r;
  }, a.interpolator = function(o) {
    return arguments.length ? (t = o, a) : t;
  }, a.copy = function() {
    return Sb(t).domain([e, n]).clamp(r);
  }, Hs(a);
}
function Zt(t) {
  return function() {
    return t;
  };
}
var tv = Math.abs, nn = Math.atan2, Fi = Math.cos, _4 = Math.max, nd = Math.min, mr = Math.sin, Na = Math.sqrt, rn = 1e-12, xi = Math.PI, cl = xi / 2, gi = 2 * xi;
function b4(t) {
  return t > 1 ? 0 : t < -1 ? xi : Math.acos(t);
}
function ev(t) {
  return t >= 1 ? cl : t <= -1 ? -cl : Math.asin(t);
}
function w4(t) {
  return t.innerRadius;
}
function E4(t) {
  return t.outerRadius;
}
function S4(t) {
  return t.startAngle;
}
function A4(t) {
  return t.endAngle;
}
function T4(t) {
  return t && t.padAngle;
}
function C4(t, e, n, r, a, o, u, c) {
  var l = n - t, d = r - e, g = u - a, y = c - o, f = (g * (e - o) - y * (t - a)) / (y * l - g * d);
  return [t + f * l, e + f * d];
}
function cc(t, e, n, r, a, o, u) {
  var c = t - n, l = e - r, d = (u ? o : -o) / Na(c * c + l * l), g = d * l, y = -d * c, f = t + g, m = e + y, b = n + g, E = r + y, S = (f + b) / 2, M = (m + E) / 2, N = b - f, O = E - m, A = N * N + O * O, x = a - o, v = f * E - b * m, w = (O < 0 ? -1 : 1) * Na(_4(0, x * x * A - v * v)), C = (v * O - N * w) / A, P = (-v * N - O * w) / A, Y = (v * O + N * w) / A, V = (-v * N + O * w) / A, k = C - S, T = P - M, R = Y - S, F = V - M;
  return k * k + T * T > R * R + F * F && (C = Y, P = V), {
    cx: C,
    cy: P,
    x01: -g,
    y01: -y,
    x11: C * (a / x - 1),
    y11: P * (a / x - 1)
  };
}
function R4() {
  var t = w4, e = E4, n = Zt(0), r = null, a = S4, o = A4, u = T4, c = null;
  function l() {
    var d, g, y = +t.apply(this, arguments), f = +e.apply(this, arguments), m = a.apply(this, arguments) - cl, b = o.apply(this, arguments) - cl, E = tv(b - m), S = b > m;
    if (c || (c = d = Si()), f < y && (g = f, f = y, y = g), !(f > rn)) c.moveTo(0, 0);
    else if (E > gi - rn)
      c.moveTo(f * Fi(m), f * mr(m)), c.arc(0, 0, f, m, b, !S), y > rn && (c.moveTo(y * Fi(b), y * mr(b)), c.arc(0, 0, y, b, m, S));
    else {
      var M = m, N = b, O = m, A = b, x = E, v = E, w = u.apply(this, arguments) / 2, C = w > rn && (r ? +r.apply(this, arguments) : Na(y * y + f * f)), P = nd(tv(f - y) / 2, +n.apply(this, arguments)), Y = P, V = P, k, T;
      if (C > rn) {
        var R = ev(C / y * mr(w)), F = ev(C / f * mr(w));
        (x -= R * 2) > rn ? (R *= S ? 1 : -1, O += R, A -= R) : (x = 0, O = A = (m + b) / 2), (v -= F * 2) > rn ? (F *= S ? 1 : -1, M += F, N -= F) : (v = 0, M = N = (m + b) / 2);
      }
      var U = f * Fi(M), H = f * mr(M), W = y * Fi(A), B = y * mr(A);
      if (P > rn) {
        var j = f * Fi(N), X = f * mr(N), tt = y * Fi(O), et = y * mr(O);
        if (E < xi) {
          var ot = x > rn ? C4(U, H, tt, et, j, X, W, B) : [W, B], Z = U - ot[0], lt = H - ot[1], z = j - ot[0], nt = X - ot[1], it = 1 / mr(b4((Z * z + lt * nt) / (Na(Z * Z + lt * lt) * Na(z * z + nt * nt))) / 2), Q = Na(ot[0] * ot[0] + ot[1] * ot[1]);
          Y = nd(P, (y - Q) / (it - 1)), V = nd(P, (f - Q) / (it + 1));
        }
      }
      v > rn ? V > rn ? (k = cc(tt, et, U, H, f, V, S), T = cc(j, X, W, B, f, V, S), c.moveTo(k.cx + k.x01, k.cy + k.y01), V < P ? c.arc(k.cx, k.cy, V, nn(k.y01, k.x01), nn(T.y01, T.x01), !S) : (c.arc(k.cx, k.cy, V, nn(k.y01, k.x01), nn(k.y11, k.x11), !S), c.arc(0, 0, f, nn(k.cy + k.y11, k.cx + k.x11), nn(T.cy + T.y11, T.cx + T.x11), !S), c.arc(T.cx, T.cy, V, nn(T.y11, T.x11), nn(T.y01, T.x01), !S))) : (c.moveTo(U, H), c.arc(0, 0, f, M, N, !S)) : c.moveTo(U, H), !(y > rn) || !(x > rn) ? c.lineTo(W, B) : Y > rn ? (k = cc(W, B, j, X, y, -Y, S), T = cc(U, H, tt, et, y, -Y, S), c.lineTo(k.cx + k.x01, k.cy + k.y01), Y < P ? c.arc(k.cx, k.cy, Y, nn(k.y01, k.x01), nn(T.y01, T.x01), !S) : (c.arc(k.cx, k.cy, Y, nn(k.y01, k.x01), nn(k.y11, k.x11), !S), c.arc(0, 0, y, nn(k.cy + k.y11, k.cx + k.x11), nn(T.cy + T.y11, T.cx + T.x11), S), c.arc(T.cx, T.cy, Y, nn(T.y11, T.x11), nn(T.y01, T.x01), !S))) : c.arc(0, 0, y, A, O, S);
    }
    if (c.closePath(), d) return c = null, d + "" || null;
  }
  return l.centroid = function() {
    var d = (+t.apply(this, arguments) + +e.apply(this, arguments)) / 2, g = (+a.apply(this, arguments) + +o.apply(this, arguments)) / 2 - xi / 2;
    return [Fi(g) * d, mr(g) * d];
  }, l.innerRadius = function(d) {
    return arguments.length ? (t = typeof d == "function" ? d : Zt(+d), l) : t;
  }, l.outerRadius = function(d) {
    return arguments.length ? (e = typeof d == "function" ? d : Zt(+d), l) : e;
  }, l.cornerRadius = function(d) {
    return arguments.length ? (n = typeof d == "function" ? d : Zt(+d), l) : n;
  }, l.padRadius = function(d) {
    return arguments.length ? (r = d == null ? null : typeof d == "function" ? d : Zt(+d), l) : r;
  }, l.startAngle = function(d) {
    return arguments.length ? (a = typeof d == "function" ? d : Zt(+d), l) : a;
  }, l.endAngle = function(d) {
    return arguments.length ? (o = typeof d == "function" ? d : Zt(+d), l) : o;
  }, l.padAngle = function(d) {
    return arguments.length ? (u = typeof d == "function" ? d : Zt(+d), l) : u;
  }, l.context = function(d) {
    return arguments.length ? (c = d ?? null, l) : c;
  }, l;
}
function Ab(t) {
  this._context = t;
}
Ab.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(t, e);
        break;
    }
  }
};
function ql(t) {
  return new Ab(t);
}
function y0(t) {
  return t[0];
}
function v0(t) {
  return t[1];
}
function x0() {
  var t = y0, e = v0, n = Zt(!0), r = null, a = ql, o = null;
  function u(c) {
    var l, d = c.length, g, y = !1, f;
    for (r == null && (o = a(f = Si())), l = 0; l <= d; ++l)
      !(l < d && n(g = c[l], l, c)) === y && ((y = !y) ? o.lineStart() : o.lineEnd()), y && o.point(+t(g, l, c), +e(g, l, c));
    if (f) return o = null, f + "" || null;
  }
  return u.x = function(c) {
    return arguments.length ? (t = typeof c == "function" ? c : Zt(+c), u) : t;
  }, u.y = function(c) {
    return arguments.length ? (e = typeof c == "function" ? c : Zt(+c), u) : e;
  }, u.defined = function(c) {
    return arguments.length ? (n = typeof c == "function" ? c : Zt(!!c), u) : n;
  }, u.curve = function(c) {
    return arguments.length ? (a = c, r != null && (o = a(r)), u) : a;
  }, u.context = function(c) {
    return arguments.length ? (c == null ? r = o = null : o = a(r = c), u) : r;
  }, u;
}
function Tb() {
  var t = y0, e = null, n = Zt(0), r = v0, a = Zt(!0), o = null, u = ql, c = null;
  function l(g) {
    var y, f, m, b = g.length, E, S = !1, M, N = new Array(b), O = new Array(b);
    for (o == null && (c = u(M = Si())), y = 0; y <= b; ++y) {
      if (!(y < b && a(E = g[y], y, g)) === S)
        if (S = !S)
          f = y, c.areaStart(), c.lineStart();
        else {
          for (c.lineEnd(), c.lineStart(), m = y - 1; m >= f; --m)
            c.point(N[m], O[m]);
          c.lineEnd(), c.areaEnd();
        }
      S && (N[y] = +t(E, y, g), O[y] = +n(E, y, g), c.point(e ? +e(E, y, g) : N[y], r ? +r(E, y, g) : O[y]));
    }
    if (M) return c = null, M + "" || null;
  }
  function d() {
    return x0().defined(a).curve(u).context(o);
  }
  return l.x = function(g) {
    return arguments.length ? (t = typeof g == "function" ? g : Zt(+g), e = null, l) : t;
  }, l.x0 = function(g) {
    return arguments.length ? (t = typeof g == "function" ? g : Zt(+g), l) : t;
  }, l.x1 = function(g) {
    return arguments.length ? (e = g == null ? null : typeof g == "function" ? g : Zt(+g), l) : e;
  }, l.y = function(g) {
    return arguments.length ? (n = typeof g == "function" ? g : Zt(+g), r = null, l) : n;
  }, l.y0 = function(g) {
    return arguments.length ? (n = typeof g == "function" ? g : Zt(+g), l) : n;
  }, l.y1 = function(g) {
    return arguments.length ? (r = g == null ? null : typeof g == "function" ? g : Zt(+g), l) : r;
  }, l.lineX0 = l.lineY0 = function() {
    return d().x(t).y(n);
  }, l.lineY1 = function() {
    return d().x(t).y(r);
  }, l.lineX1 = function() {
    return d().x(e).y(n);
  }, l.defined = function(g) {
    return arguments.length ? (a = typeof g == "function" ? g : Zt(!!g), l) : a;
  }, l.curve = function(g) {
    return arguments.length ? (u = g, o != null && (c = u(o)), l) : u;
  }, l.context = function(g) {
    return arguments.length ? (g == null ? o = c = null : c = u(o = g), l) : o;
  }, l;
}
function D4(t, e) {
  return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function M4(t) {
  return t;
}
function O4() {
  var t = M4, e = D4, n = null, r = Zt(0), a = Zt(gi), o = Zt(0);
  function u(c) {
    var l, d = c.length, g, y, f = 0, m = new Array(d), b = new Array(d), E = +r.apply(this, arguments), S = Math.min(gi, Math.max(-gi, a.apply(this, arguments) - E)), M, N = Math.min(Math.abs(S) / d, o.apply(this, arguments)), O = N * (S < 0 ? -1 : 1), A;
    for (l = 0; l < d; ++l)
      (A = b[m[l] = l] = +t(c[l], l, c)) > 0 && (f += A);
    for (e != null ? m.sort(function(x, v) {
      return e(b[x], b[v]);
    }) : n != null && m.sort(function(x, v) {
      return n(c[x], c[v]);
    }), l = 0, y = f ? (S - d * O) / f : 0; l < d; ++l, E = M)
      g = m[l], A = b[g], M = E + (A > 0 ? A * y : 0) + O, b[g] = {
        data: c[g],
        index: l,
        value: A,
        startAngle: E,
        endAngle: M,
        padAngle: N
      };
    return b;
  }
  return u.value = function(c) {
    return arguments.length ? (t = typeof c == "function" ? c : Zt(+c), u) : t;
  }, u.sortValues = function(c) {
    return arguments.length ? (e = c, n = null, u) : e;
  }, u.sort = function(c) {
    return arguments.length ? (n = c, e = null, u) : n;
  }, u.startAngle = function(c) {
    return arguments.length ? (r = typeof c == "function" ? c : Zt(+c), u) : r;
  }, u.endAngle = function(c) {
    return arguments.length ? (a = typeof c == "function" ? c : Zt(+c), u) : a;
  }, u.padAngle = function(c) {
    return arguments.length ? (o = typeof c == "function" ? c : Zt(+c), u) : o;
  }, u;
}
var Cb = _0(ql);
function Rb(t) {
  this._curve = t;
}
Rb.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(t, e) {
    this._curve.point(e * Math.sin(t), e * -Math.cos(t));
  }
};
function _0(t) {
  function e(n) {
    return new Rb(t(n));
  }
  return e._curve = t, e;
}
function ts(t) {
  var e = t.curve;
  return t.angle = t.x, delete t.x, t.radius = t.y, delete t.y, t.curve = function(n) {
    return arguments.length ? e(_0(n)) : e()._curve;
  }, t;
}
function nv() {
  return ts(x0().curve(Cb));
}
function rv() {
  var t = Tb().curve(Cb), e = t.curve, n = t.lineX0, r = t.lineX1, a = t.lineY0, o = t.lineY1;
  return t.angle = t.x, delete t.x, t.startAngle = t.x0, delete t.x0, t.endAngle = t.x1, delete t.x1, t.radius = t.y, delete t.y, t.innerRadius = t.y0, delete t.y0, t.outerRadius = t.y1, delete t.y1, t.lineStartAngle = function() {
    return ts(n());
  }, delete t.lineX0, t.lineEndAngle = function() {
    return ts(r());
  }, delete t.lineX1, t.lineInnerRadius = function() {
    return ts(a());
  }, delete t.lineY0, t.lineOuterRadius = function() {
    return ts(o());
  }, delete t.lineY1, t.curve = function(u) {
    return arguments.length ? e(_0(u)) : e()._curve;
  }, t;
}
function es(t, e) {
  return [(e = +e) * Math.cos(t -= Math.PI / 2), e * Math.sin(t)];
}
var np = Array.prototype.slice;
function L4(t) {
  return t.source;
}
function P4(t) {
  return t.target;
}
function b0(t) {
  var e = L4, n = P4, r = y0, a = v0, o = null;
  function u() {
    var c, l = np.call(arguments), d = e.apply(this, l), g = n.apply(this, l);
    if (o || (o = c = Si()), t(o, +r.apply(this, (l[0] = d, l)), +a.apply(this, l), +r.apply(this, (l[0] = g, l)), +a.apply(this, l)), c) return o = null, c + "" || null;
  }
  return u.source = function(c) {
    return arguments.length ? (e = c, u) : e;
  }, u.target = function(c) {
    return arguments.length ? (n = c, u) : n;
  }, u.x = function(c) {
    return arguments.length ? (r = typeof c == "function" ? c : Zt(+c), u) : r;
  }, u.y = function(c) {
    return arguments.length ? (a = typeof c == "function" ? c : Zt(+c), u) : a;
  }, u.context = function(c) {
    return arguments.length ? (o = c ?? null, u) : o;
  }, u;
}
function N4(t, e, n, r, a) {
  t.moveTo(e, n), t.bezierCurveTo(e = (e + r) / 2, n, e, a, r, a);
}
function I4(t, e, n, r, a) {
  t.moveTo(e, n), t.bezierCurveTo(e, n = (n + a) / 2, r, n, r, a);
}
function j4(t, e, n, r, a) {
  var o = es(e, n), u = es(e, n = (n + a) / 2), c = es(r, n), l = es(r, a);
  t.moveTo(o[0], o[1]), t.bezierCurveTo(u[0], u[1], c[0], c[1], l[0], l[1]);
}
function k4() {
  return b0(N4);
}
function B4() {
  return b0(I4);
}
function F4() {
  var t = b0(j4);
  return t.angle = t.x, delete t.x, t.radius = t.y, delete t.y, t;
}
const w0 = {
  draw: function(t, e) {
    var n = Math.sqrt(e / xi);
    t.moveTo(n, 0), t.arc(0, 0, n, 0, gi);
  }
}, Db = {
  draw: function(t, e) {
    var n = Math.sqrt(e / 5) / 2;
    t.moveTo(-3 * n, -n), t.lineTo(-n, -n), t.lineTo(-n, -3 * n), t.lineTo(n, -3 * n), t.lineTo(n, -n), t.lineTo(3 * n, -n), t.lineTo(3 * n, n), t.lineTo(n, n), t.lineTo(n, 3 * n), t.lineTo(-n, 3 * n), t.lineTo(-n, n), t.lineTo(-3 * n, n), t.closePath();
  }
};
var Mb = Math.sqrt(1 / 3), U4 = Mb * 2;
const Ob = {
  draw: function(t, e) {
    var n = Math.sqrt(e / U4), r = n * Mb;
    t.moveTo(0, -n), t.lineTo(r, 0), t.lineTo(0, n), t.lineTo(-r, 0), t.closePath();
  }
};
var $4 = 0.8908130915292852, Lb = Math.sin(xi / 10) / Math.sin(7 * xi / 10), z4 = Math.sin(gi / 10) * Lb, V4 = -Math.cos(gi / 10) * Lb;
const Pb = {
  draw: function(t, e) {
    var n = Math.sqrt(e * $4), r = z4 * n, a = V4 * n;
    t.moveTo(0, -n), t.lineTo(r, a);
    for (var o = 1; o < 5; ++o) {
      var u = gi * o / 5, c = Math.cos(u), l = Math.sin(u);
      t.lineTo(l * n, -c * n), t.lineTo(c * r - l * a, l * r + c * a);
    }
    t.closePath();
  }
}, Nb = {
  draw: function(t, e) {
    var n = Math.sqrt(e), r = -n / 2;
    t.rect(r, r, n, n);
  }
};
var rd = Math.sqrt(3);
const Ib = {
  draw: function(t, e) {
    var n = -Math.sqrt(e / (rd * 3));
    t.moveTo(0, n * 2), t.lineTo(-rd * n, -n), t.lineTo(rd * n, -n), t.closePath();
  }
};
var Xn = -0.5, Qn = Math.sqrt(3) / 2, rp = 1 / Math.sqrt(12), Y4 = (rp / 2 + 1) * 3;
const jb = {
  draw: function(t, e) {
    var n = Math.sqrt(e / Y4), r = n / 2, a = n * rp, o = r, u = n * rp + n, c = -o, l = u;
    t.moveTo(r, a), t.lineTo(o, u), t.lineTo(c, l), t.lineTo(Xn * r - Qn * a, Qn * r + Xn * a), t.lineTo(Xn * o - Qn * u, Qn * o + Xn * u), t.lineTo(Xn * c - Qn * l, Qn * c + Xn * l), t.lineTo(Xn * r + Qn * a, Xn * a - Qn * r), t.lineTo(Xn * o + Qn * u, Xn * u - Qn * o), t.lineTo(Xn * c + Qn * l, Xn * l - Qn * c), t.closePath();
  }
};
var W4 = [
  w0,
  Db,
  Ob,
  Nb,
  Pb,
  Ib,
  jb
];
function G4() {
  var t = Zt(w0), e = Zt(64), n = null;
  function r() {
    var a;
    if (n || (n = a = Si()), t.apply(this, arguments).draw(n, +e.apply(this, arguments)), a) return n = null, a + "" || null;
  }
  return r.type = function(a) {
    return arguments.length ? (t = typeof a == "function" ? a : Zt(a), r) : t;
  }, r.size = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : Zt(+a), r) : e;
  }, r.context = function(a) {
    return arguments.length ? (n = a ?? null, r) : n;
  }, r;
}
function _i() {
}
function ll(t, e, n) {
  t._context.bezierCurveTo(
    (2 * t._x0 + t._x1) / 3,
    (2 * t._y0 + t._y1) / 3,
    (t._x0 + 2 * t._x1) / 3,
    (t._y0 + 2 * t._y1) / 3,
    (t._x0 + 4 * t._x1 + e) / 6,
    (t._y0 + 4 * t._y1 + n) / 6
  );
}
function Hl(t) {
  this._context = t;
}
Hl.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        ll(this, this._x1, this._y1);
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      default:
        ll(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
  }
};
function q4(t) {
  return new Hl(t);
}
function kb(t) {
  this._context = t;
}
kb.prototype = {
  areaStart: _i,
  areaEnd: _i,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._x2 = t, this._y2 = e;
        break;
      case 1:
        this._point = 2, this._x3 = t, this._y3 = e;
        break;
      case 2:
        this._point = 3, this._x4 = t, this._y4 = e, this._context.moveTo((this._x0 + 4 * this._x1 + t) / 6, (this._y0 + 4 * this._y1 + e) / 6);
        break;
      default:
        ll(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
  }
};
function H4(t) {
  return new kb(t);
}
function Bb(t) {
  this._context = t;
}
Bb.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var n = (this._x0 + 4 * this._x1 + t) / 6, r = (this._y0 + 4 * this._y1 + e) / 6;
        this._line ? this._context.lineTo(n, r) : this._context.moveTo(n, r);
        break;
      case 3:
        this._point = 4;
      default:
        ll(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
  }
};
function X4(t) {
  return new Bb(t);
}
function Fb(t, e) {
  this._basis = new Hl(t), this._beta = e;
}
Fb.prototype = {
  lineStart: function() {
    this._x = [], this._y = [], this._basis.lineStart();
  },
  lineEnd: function() {
    var t = this._x, e = this._y, n = t.length - 1;
    if (n > 0)
      for (var r = t[0], a = e[0], o = t[n] - r, u = e[n] - a, c = -1, l; ++c <= n; )
        l = c / n, this._basis.point(
          this._beta * t[c] + (1 - this._beta) * (r + l * o),
          this._beta * e[c] + (1 - this._beta) * (a + l * u)
        );
    this._x = this._y = null, this._basis.lineEnd();
  },
  point: function(t, e) {
    this._x.push(+t), this._y.push(+e);
  }
};
const Q4 = function t(e) {
  function n(r) {
    return e === 1 ? new Hl(r) : new Fb(r, e);
  }
  return n.beta = function(r) {
    return t(+r);
  }, n;
}(0.85);
function fl(t, e, n) {
  t._context.bezierCurveTo(
    t._x1 + t._k * (t._x2 - t._x0),
    t._y1 + t._k * (t._y2 - t._y0),
    t._x2 + t._k * (t._x1 - e),
    t._y2 + t._k * (t._y1 - n),
    t._x2,
    t._y2
  );
}
function E0(t, e) {
  this._context = t, this._k = (1 - e) / 6;
}
E0.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        fl(this, this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2, this._x1 = t, this._y1 = e;
        break;
      case 2:
        this._point = 3;
      default:
        fl(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const K4 = function t(e) {
  function n(r) {
    return new E0(r, e);
  }
  return n.tension = function(r) {
    return t(+r);
  }, n;
}(0);
function S0(t, e) {
  this._context = t, this._k = (1 - e) / 6;
}
S0.prototype = {
  areaStart: _i,
  areaEnd: _i,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._x3 = t, this._y3 = e;
        break;
      case 1:
        this._point = 2, this._context.moveTo(this._x4 = t, this._y4 = e);
        break;
      case 2:
        this._point = 3, this._x5 = t, this._y5 = e;
        break;
      default:
        fl(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const Z4 = function t(e) {
  function n(r) {
    return new S0(r, e);
  }
  return n.tension = function(r) {
    return t(+r);
  }, n;
}(0);
function A0(t, e) {
  this._context = t, this._k = (1 - e) / 6;
}
A0.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      default:
        fl(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const J4 = function t(e) {
  function n(r) {
    return new A0(r, e);
  }
  return n.tension = function(r) {
    return t(+r);
  }, n;
}(0);
function T0(t, e, n) {
  var r = t._x1, a = t._y1, o = t._x2, u = t._y2;
  if (t._l01_a > rn) {
    var c = 2 * t._l01_2a + 3 * t._l01_a * t._l12_a + t._l12_2a, l = 3 * t._l01_a * (t._l01_a + t._l12_a);
    r = (r * c - t._x0 * t._l12_2a + t._x2 * t._l01_2a) / l, a = (a * c - t._y0 * t._l12_2a + t._y2 * t._l01_2a) / l;
  }
  if (t._l23_a > rn) {
    var d = 2 * t._l23_2a + 3 * t._l23_a * t._l12_a + t._l12_2a, g = 3 * t._l23_a * (t._l23_a + t._l12_a);
    o = (o * d + t._x1 * t._l23_2a - e * t._l12_2a) / g, u = (u * d + t._y1 * t._l23_2a - n * t._l12_2a) / g;
  }
  t._context.bezierCurveTo(r, a, o, u, t._x2, t._y2);
}
function Ub(t, e) {
  this._context = t, this._alpha = e;
}
Ub.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        this.point(this._x2, this._y2);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    if (t = +t, e = +e, this._point) {
      var n = this._x2 - t, r = this._y2 - e;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
      default:
        T0(this, t, e);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const tk = function t(e) {
  function n(r) {
    return e ? new Ub(r, e) : new E0(r, 0);
  }
  return n.alpha = function(r) {
    return t(+r);
  }, n;
}(0.5);
function $b(t, e) {
  this._context = t, this._alpha = e;
}
$b.prototype = {
  areaStart: _i,
  areaEnd: _i,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(t, e) {
    if (t = +t, e = +e, this._point) {
      var n = this._x2 - t, r = this._y2 - e;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._x3 = t, this._y3 = e;
        break;
      case 1:
        this._point = 2, this._context.moveTo(this._x4 = t, this._y4 = e);
        break;
      case 2:
        this._point = 3, this._x5 = t, this._y5 = e;
        break;
      default:
        T0(this, t, e);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const ek = function t(e) {
  function n(r) {
    return e ? new $b(r, e) : new S0(r, 0);
  }
  return n.alpha = function(r) {
    return t(+r);
  }, n;
}(0.5);
function zb(t, e) {
  this._context = t, this._alpha = e;
}
zb.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    if (t = +t, e = +e, this._point) {
      var n = this._x2 - t, r = this._y2 - e;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      default:
        T0(this, t, e);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const nk = function t(e) {
  function n(r) {
    return e ? new zb(r, e) : new A0(r, 0);
  }
  return n.alpha = function(r) {
    return t(+r);
  }, n;
}(0.5);
function Vb(t) {
  this._context = t;
}
Vb.prototype = {
  areaStart: _i,
  areaEnd: _i,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(t, e) {
    t = +t, e = +e, this._point ? this._context.lineTo(t, e) : (this._point = 1, this._context.moveTo(t, e));
  }
};
function rk(t) {
  return new Vb(t);
}
function iv(t) {
  return t < 0 ? -1 : 1;
}
function av(t, e, n) {
  var r = t._x1 - t._x0, a = e - t._x1, o = (t._y1 - t._y0) / (r || a < 0 && -0), u = (n - t._y1) / (a || r < 0 && -0), c = (o * a + u * r) / (r + a);
  return (iv(o) + iv(u)) * Math.min(Math.abs(o), Math.abs(u), 0.5 * Math.abs(c)) || 0;
}
function ov(t, e) {
  var n = t._x1 - t._x0;
  return n ? (3 * (t._y1 - t._y0) / n - e) / 2 : e;
}
function id(t, e, n) {
  var r = t._x0, a = t._y0, o = t._x1, u = t._y1, c = (o - r) / 3;
  t._context.bezierCurveTo(r + c, a + c * e, o - c, u - c * n, o, u);
}
function hl(t) {
  this._context = t;
}
hl.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        id(this, this._t0, ov(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    var n = NaN;
    if (t = +t, e = +e, !(t === this._x1 && e === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, id(this, ov(this, n = av(this, t, e)), n);
          break;
        default:
          id(this, this._t0, n = av(this, t, e));
          break;
      }
      this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e, this._t0 = n;
    }
  }
};
function Yb(t) {
  this._context = new Wb(t);
}
(Yb.prototype = Object.create(hl.prototype)).point = function(t, e) {
  hl.prototype.point.call(this, e, t);
};
function Wb(t) {
  this._context = t;
}
Wb.prototype = {
  moveTo: function(t, e) {
    this._context.moveTo(e, t);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(t, e) {
    this._context.lineTo(e, t);
  },
  bezierCurveTo: function(t, e, n, r, a, o) {
    this._context.bezierCurveTo(e, t, r, n, o, a);
  }
};
function ik(t) {
  return new hl(t);
}
function ak(t) {
  return new Yb(t);
}
function Gb(t) {
  this._context = t;
}
Gb.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var t = this._x, e = this._y, n = t.length;
    if (n)
      if (this._line ? this._context.lineTo(t[0], e[0]) : this._context.moveTo(t[0], e[0]), n === 2)
        this._context.lineTo(t[1], e[1]);
      else
        for (var r = sv(t), a = sv(e), o = 0, u = 1; u < n; ++o, ++u)
          this._context.bezierCurveTo(r[0][o], a[0][o], r[1][o], a[1][o], t[u], e[u]);
    (this._line || this._line !== 0 && n === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(t, e) {
    this._x.push(+t), this._y.push(+e);
  }
};
function sv(t) {
  var e, n = t.length - 1, r, a = new Array(n), o = new Array(n), u = new Array(n);
  for (a[0] = 0, o[0] = 2, u[0] = t[0] + 2 * t[1], e = 1; e < n - 1; ++e) a[e] = 1, o[e] = 4, u[e] = 4 * t[e] + 2 * t[e + 1];
  for (a[n - 1] = 2, o[n - 1] = 7, u[n - 1] = 8 * t[n - 1] + t[n], e = 1; e < n; ++e) r = a[e] / o[e - 1], o[e] -= r, u[e] -= r * u[e - 1];
  for (a[n - 1] = u[n - 1] / o[n - 1], e = n - 2; e >= 0; --e) a[e] = (u[e] - a[e + 1]) / o[e];
  for (o[n - 1] = (t[n] + a[n - 1]) / 2, e = 0; e < n - 1; ++e) o[e] = 2 * t[e + 1] - a[e + 1];
  return [a, o];
}
function ok(t) {
  return new Gb(t);
}
function Xl(t, e) {
  this._context = t, this._t = e;
}
Xl.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, e), this._context.lineTo(t, e);
        else {
          var n = this._x * (1 - this._t) + t * this._t;
          this._context.lineTo(n, this._y), this._context.lineTo(n, e);
        }
        break;
      }
    }
    this._x = t, this._y = e;
  }
};
function sk(t) {
  return new Xl(t, 0.5);
}
function uk(t) {
  return new Xl(t, 0);
}
function ck(t) {
  return new Xl(t, 1);
}
function to(t, e) {
  if ((u = t.length) > 1)
    for (var n = 1, r, a, o = t[e[0]], u, c = o.length; n < u; ++n)
      for (a = o, o = t[e[n]], r = 0; r < c; ++r)
        o[r][1] += o[r][0] = isNaN(a[r][1]) ? a[r][0] : a[r][1];
}
function eo(t) {
  for (var e = t.length, n = new Array(e); --e >= 0; ) n[e] = e;
  return n;
}
function lk(t, e) {
  return t[e];
}
function fk() {
  var t = Zt([]), e = eo, n = to, r = lk;
  function a(o) {
    var u = t.apply(this, arguments), c, l = o.length, d = u.length, g = new Array(d), y;
    for (c = 0; c < d; ++c) {
      for (var f = u[c], m = g[c] = new Array(l), b = 0, E; b < l; ++b)
        m[b] = E = [0, +r(o[b], f, b, o)], E.data = o[b];
      m.key = f;
    }
    for (c = 0, y = e(g); c < d; ++c)
      g[y[c]].index = c;
    return n(g, y), g;
  }
  return a.keys = function(o) {
    return arguments.length ? (t = typeof o == "function" ? o : Zt(np.call(o)), a) : t;
  }, a.value = function(o) {
    return arguments.length ? (r = typeof o == "function" ? o : Zt(+o), a) : r;
  }, a.order = function(o) {
    return arguments.length ? (e = o == null ? eo : typeof o == "function" ? o : Zt(np.call(o)), a) : e;
  }, a.offset = function(o) {
    return arguments.length ? (n = o ?? to, a) : n;
  }, a;
}
function hk(t, e) {
  if ((r = t.length) > 0) {
    for (var n, r, a = 0, o = t[0].length, u; a < o; ++a) {
      for (u = n = 0; n < r; ++n) u += t[n][a][1] || 0;
      if (u) for (n = 0; n < r; ++n) t[n][a][1] /= u;
    }
    to(t, e);
  }
}
function dk(t, e) {
  if ((l = t.length) > 1)
    for (var n, r = 0, a, o, u, c, l, d = t[e[0]].length; r < d; ++r)
      for (u = c = 0, n = 0; n < l; ++n)
        (o = (a = t[e[n]][r])[1] - a[0]) >= 0 ? (a[0] = u, a[1] = u += o) : o < 0 ? (a[1] = c, a[0] = c += o) : a[0] = u;
}
function pk(t, e) {
  if ((a = t.length) > 0) {
    for (var n = 0, r = t[e[0]], a, o = r.length; n < o; ++n) {
      for (var u = 0, c = 0; u < a; ++u) c += t[u][n][1] || 0;
      r[n][1] += r[n][0] = -c / 2;
    }
    to(t, e);
  }
}
function gk(t, e) {
  if (!(!((u = t.length) > 0) || !((o = (a = t[e[0]]).length) > 0))) {
    for (var n = 0, r = 1, a, o, u; r < o; ++r) {
      for (var c = 0, l = 0, d = 0; c < u; ++c) {
        for (var g = t[e[c]], y = g[r][1] || 0, f = g[r - 1][1] || 0, m = (y - f) / 2, b = 0; b < c; ++b) {
          var E = t[e[b]], S = E[r][1] || 0, M = E[r - 1][1] || 0;
          m += S - M;
        }
        l += y, d += m * y;
      }
      a[r - 1][1] += a[r - 1][0] = n, l && (n -= d / l);
    }
    a[r - 1][1] += a[r - 1][0] = n, to(t, e);
  }
}
function qb(t) {
  var e = t.map(Hb);
  return eo(t).sort(function(n, r) {
    return e[n] - e[r];
  });
}
function Hb(t) {
  for (var e = 0, n = -1, r = t.length, a; ++n < r; ) (a = +t[n][1]) && (e += a);
  return e;
}
function mk(t) {
  return qb(t).reverse();
}
function yk(t) {
  var e = t.length, n, r, a = t.map(Hb), o = eo(t).sort(function(g, y) {
    return a[y] - a[g];
  }), u = 0, c = 0, l = [], d = [];
  for (n = 0; n < e; ++n)
    r = o[n], u < c ? (u += a[r], l.push(r)) : (c += a[r], d.push(r));
  return d.reverse().concat(l);
}
function vk(t) {
  return eo(t).reverse();
}
function uv(t) {
  return function() {
    return t;
  };
}
function xk(t) {
  return t[0];
}
function _k(t) {
  return t[1];
}
function dl() {
  this._ = null;
}
function Ql(t) {
  t.U = // parent node
  t.C = // color - true for red, false for black
  t.L = // left node
  t.R = // right node
  t.P = // previous node
  t.N = null;
}
dl.prototype = {
  constructor: dl,
  insert: function(t, e) {
    var n, r, a;
    if (t) {
      if (e.P = t, e.N = t.N, t.N && (t.N.P = e), t.N = e, t.R) {
        for (t = t.R; t.L; ) t = t.L;
        t.L = e;
      } else
        t.R = e;
      n = t;
    } else this._ ? (t = cv(this._), e.P = null, e.N = t, t.P = t.L = e, n = t) : (e.P = e.N = null, this._ = e, n = null);
    for (e.L = e.R = null, e.U = n, e.C = !0, t = e; n && n.C; )
      r = n.U, n === r.L ? (a = r.R, a && a.C ? (n.C = a.C = !1, r.C = !0, t = r) : (t === n.R && (ko(this, n), t = n, n = t.U), n.C = !1, r.C = !0, Bo(this, r))) : (a = r.L, a && a.C ? (n.C = a.C = !1, r.C = !0, t = r) : (t === n.L && (Bo(this, n), t = n, n = t.U), n.C = !1, r.C = !0, ko(this, r))), n = t.U;
    this._.C = !1;
  },
  remove: function(t) {
    t.N && (t.N.P = t.P), t.P && (t.P.N = t.N), t.N = t.P = null;
    var e = t.U, n, r = t.L, a = t.R, o, u;
    if (r ? a ? o = cv(a) : o = r : o = a, e ? e.L === t ? e.L = o : e.R = o : this._ = o, r && a ? (u = o.C, o.C = t.C, o.L = r, r.U = o, o !== a ? (e = o.U, o.U = t.U, t = o.R, e.L = t, o.R = a, a.U = o) : (o.U = e, e = o, t = o.R)) : (u = t.C, t = o), t && (t.U = e), !u) {
      if (t && t.C) {
        t.C = !1;
        return;
      }
      do {
        if (t === this._) break;
        if (t === e.L) {
          if (n = e.R, n.C && (n.C = !1, e.C = !0, ko(this, e), n = e.R), n.L && n.L.C || n.R && n.R.C) {
            (!n.R || !n.R.C) && (n.L.C = !1, n.C = !0, Bo(this, n), n = e.R), n.C = e.C, e.C = n.R.C = !1, ko(this, e), t = this._;
            break;
          }
        } else if (n = e.L, n.C && (n.C = !1, e.C = !0, Bo(this, e), n = e.L), n.L && n.L.C || n.R && n.R.C) {
          (!n.L || !n.L.C) && (n.R.C = !1, n.C = !0, ko(this, n), n = e.L), n.C = e.C, e.C = n.L.C = !1, Bo(this, e), t = this._;
          break;
        }
        n.C = !0, t = e, e = e.U;
      } while (!t.C);
      t && (t.C = !1);
    }
  }
};
function ko(t, e) {
  var n = e, r = e.R, a = n.U;
  a ? a.L === n ? a.L = r : a.R = r : t._ = r, r.U = a, n.U = r, n.R = r.L, n.R && (n.R.U = n), r.L = n;
}
function Bo(t, e) {
  var n = e, r = e.L, a = n.U;
  a ? a.L === n ? a.L = r : a.R = r : t._ = r, r.U = a, n.U = r, n.L = r.R, n.L && (n.L.U = n), r.R = n;
}
function cv(t) {
  for (; t.L; ) t = t.L;
  return t;
}
function ns(t, e, n, r) {
  var a = [null, null], o = sn.push(a) - 1;
  return a.left = t, a.right = e, n && pl(a, t, e, n), r && pl(a, e, t, r), Bn[t.index].halfedges.push(o), Bn[e.index].halfedges.push(o), a;
}
function Fo(t, e, n) {
  var r = [e, n];
  return r.left = t, r;
}
function pl(t, e, n, r) {
  !t[0] && !t[1] ? (t[0] = r, t.left = e, t.right = n) : t.left === n ? t[1] = r : t[0] = r;
}
function bk(t, e, n, r, a) {
  var o = t[0], u = t[1], c = o[0], l = o[1], d = u[0], g = u[1], y = 0, f = 1, m = d - c, b = g - l, E;
  if (E = e - c, !(!m && E > 0)) {
    if (E /= m, m < 0) {
      if (E < y) return;
      E < f && (f = E);
    } else if (m > 0) {
      if (E > f) return;
      E > y && (y = E);
    }
    if (E = r - c, !(!m && E < 0)) {
      if (E /= m, m < 0) {
        if (E > f) return;
        E > y && (y = E);
      } else if (m > 0) {
        if (E < y) return;
        E < f && (f = E);
      }
      if (E = n - l, !(!b && E > 0)) {
        if (E /= b, b < 0) {
          if (E < y) return;
          E < f && (f = E);
        } else if (b > 0) {
          if (E > f) return;
          E > y && (y = E);
        }
        if (E = a - l, !(!b && E < 0)) {
          if (E /= b, b < 0) {
            if (E > f) return;
            E > y && (y = E);
          } else if (b > 0) {
            if (E < y) return;
            E < f && (f = E);
          }
          return !(y > 0) && !(f < 1) || (y > 0 && (t[0] = [c + y * m, l + y * b]), f < 1 && (t[1] = [c + f * m, l + f * b])), !0;
        }
      }
    }
  }
}
function wk(t, e, n, r, a) {
  var o = t[1];
  if (o) return !0;
  var u = t[0], c = t.left, l = t.right, d = c[0], g = c[1], y = l[0], f = l[1], m = (d + y) / 2, b = (g + f) / 2, E, S;
  if (f === g) {
    if (m < e || m >= r) return;
    if (d > y) {
      if (!u) u = [m, n];
      else if (u[1] >= a) return;
      o = [m, a];
    } else {
      if (!u) u = [m, a];
      else if (u[1] < n) return;
      o = [m, n];
    }
  } else if (E = (d - y) / (f - g), S = b - E * m, E < -1 || E > 1)
    if (d > y) {
      if (!u) u = [(n - S) / E, n];
      else if (u[1] >= a) return;
      o = [(a - S) / E, a];
    } else {
      if (!u) u = [(a - S) / E, a];
      else if (u[1] < n) return;
      o = [(n - S) / E, n];
    }
  else if (g < f) {
    if (!u) u = [e, E * e + S];
    else if (u[0] >= r) return;
    o = [r, E * r + S];
  } else {
    if (!u) u = [r, E * r + S];
    else if (u[0] < e) return;
    o = [e, E * e + S];
  }
  return t[0] = u, t[1] = o, !0;
}
function Ek(t, e, n, r) {
  for (var a = sn.length, o; a--; )
    (!wk(o = sn[a], t, e, n, r) || !bk(o, t, e, n, r) || !(Math.abs(o[0][0] - o[1][0]) > he || Math.abs(o[0][1] - o[1][1]) > he)) && delete sn[a];
}
function Sk(t) {
  return Bn[t.index] = {
    site: t,
    halfedges: []
  };
}
function Ak(t, e) {
  var n = t.site, r = e.left, a = e.right;
  return n === a && (a = r, r = n), a ? Math.atan2(a[1] - r[1], a[0] - r[0]) : (n === r ? (r = e[1], a = e[0]) : (r = e[0], a = e[1]), Math.atan2(r[0] - a[0], a[1] - r[1]));
}
function Xb(t, e) {
  return e[+(e.left !== t.site)];
}
function Tk(t, e) {
  return e[+(e.left === t.site)];
}
function Ck() {
  for (var t = 0, e = Bn.length, n, r, a, o; t < e; ++t)
    if ((n = Bn[t]) && (o = (r = n.halfedges).length)) {
      var u = new Array(o), c = new Array(o);
      for (a = 0; a < o; ++a) u[a] = a, c[a] = Ak(n, sn[r[a]]);
      for (u.sort(function(l, d) {
        return c[d] - c[l];
      }), a = 0; a < o; ++a) c[a] = r[u[a]];
      for (a = 0; a < o; ++a) r[a] = c[a];
    }
}
function Rk(t, e, n, r) {
  var a = Bn.length, o, u, c, l, d, g, y, f, m, b, E, S, M = !0;
  for (o = 0; o < a; ++o)
    if (u = Bn[o]) {
      for (c = u.site, d = u.halfedges, l = d.length; l--; )
        sn[d[l]] || d.splice(l, 1);
      for (l = 0, g = d.length; l < g; )
        b = Tk(u, sn[d[l]]), E = b[0], S = b[1], y = Xb(u, sn[d[++l % g]]), f = y[0], m = y[1], (Math.abs(E - f) > he || Math.abs(S - m) > he) && (d.splice(l, 0, sn.push(Fo(
          c,
          b,
          Math.abs(E - t) < he && r - S > he ? [t, Math.abs(f - t) < he ? m : r] : Math.abs(S - r) < he && n - E > he ? [Math.abs(m - r) < he ? f : n, r] : Math.abs(E - n) < he && S - e > he ? [n, Math.abs(f - n) < he ? m : e] : Math.abs(S - e) < he && E - t > he ? [Math.abs(m - e) < he ? f : t, e] : null
        )) - 1), ++g);
      g && (M = !1);
    }
  if (M) {
    var N, O, A, x = 1 / 0;
    for (o = 0, M = null; o < a; ++o)
      (u = Bn[o]) && (c = u.site, N = c[0] - t, O = c[1] - e, A = N * N + O * O, A < x && (x = A, M = u));
    if (M) {
      var v = [t, e], w = [t, r], C = [n, r], P = [n, e];
      M.halfedges.push(
        sn.push(Fo(c = M.site, v, w)) - 1,
        sn.push(Fo(c, w, C)) - 1,
        sn.push(Fo(c, C, P)) - 1,
        sn.push(Fo(c, P, v)) - 1
      );
    }
  }
  for (o = 0; o < a; ++o)
    (u = Bn[o]) && (u.halfedges.length || delete Bn[o]);
}
var Qb = [], C0;
function Dk() {
  Ql(this), this.x = this.y = this.arc = this.site = this.cy = null;
}
function Ia(t) {
  var e = t.P, n = t.N;
  if (!(!e || !n)) {
    var r = e.site, a = t.site, o = n.site;
    if (r !== o) {
      var u = a[0], c = a[1], l = r[0] - u, d = r[1] - c, g = o[0] - u, y = o[1] - c, f = 2 * (l * y - d * g);
      if (!(f >= -1e-12)) {
        var m = l * l + d * d, b = g * g + y * y, E = (y * m - d * b) / f, S = (l * b - g * m) / f, M = Qb.pop() || new Dk();
        M.arc = t, M.site = a, M.x = E + u, M.y = (M.cy = S + c) + Math.sqrt(E * E + S * S), t.circle = M;
        for (var N = null, O = Ns._; O; )
          if (M.y < O.y || M.y === O.y && M.x <= O.x)
            if (O.L) O = O.L;
            else {
              N = O.P;
              break;
            }
          else if (O.R) O = O.R;
          else {
            N = O;
            break;
          }
        Ns.insert(N, M), N || (C0 = M);
      }
    }
  }
}
function Va(t) {
  var e = t.circle;
  e && (e.P || (C0 = e.N), Ns.remove(e), Qb.push(e), Ql(e), t.circle = null);
}
var Kb = [];
function Mk() {
  Ql(this), this.edge = this.site = this.circle = null;
}
function lv(t) {
  var e = Kb.pop() || new Mk();
  return e.site = t, e;
}
function ad(t) {
  Va(t), Ya.remove(t), Kb.push(t), Ql(t);
}
function Ok(t) {
  var e = t.circle, n = e.x, r = e.cy, a = [n, r], o = t.P, u = t.N, c = [t];
  ad(t);
  for (var l = o; l.circle && Math.abs(n - l.circle.x) < he && Math.abs(r - l.circle.cy) < he; )
    o = l.P, c.unshift(l), ad(l), l = o;
  c.unshift(l), Va(l);
  for (var d = u; d.circle && Math.abs(n - d.circle.x) < he && Math.abs(r - d.circle.cy) < he; )
    u = d.N, c.push(d), ad(d), d = u;
  c.push(d), Va(d);
  var g = c.length, y;
  for (y = 1; y < g; ++y)
    d = c[y], l = c[y - 1], pl(d.edge, l.site, d.site, a);
  l = c[0], d = c[g - 1], d.edge = ns(l.site, d.site, null, a), Ia(l), Ia(d);
}
function Lk(t) {
  for (var e = t[0], n = t[1], r, a, o, u, c = Ya._; c; )
    if (o = Zb(c, n) - e, o > he) c = c.L;
    else if (u = e - Pk(c, n), u > he) {
      if (!c.R) {
        r = c;
        break;
      }
      c = c.R;
    } else {
      o > -he ? (r = c.P, a = c) : u > -he ? (r = c, a = c.N) : r = a = c;
      break;
    }
  Sk(t);
  var l = lv(t);
  if (Ya.insert(r, l), !(!r && !a)) {
    if (r === a) {
      Va(r), a = lv(r.site), Ya.insert(l, a), l.edge = a.edge = ns(r.site, l.site), Ia(r), Ia(a);
      return;
    }
    if (!a) {
      l.edge = ns(r.site, l.site);
      return;
    }
    Va(r), Va(a);
    var d = r.site, g = d[0], y = d[1], f = t[0] - g, m = t[1] - y, b = a.site, E = b[0] - g, S = b[1] - y, M = 2 * (f * S - m * E), N = f * f + m * m, O = E * E + S * S, A = [(S * N - m * O) / M + g, (f * O - E * N) / M + y];
    pl(a.edge, d, b, A), l.edge = ns(d, t, null, A), a.edge = ns(t, b, null, A), Ia(r), Ia(a);
  }
}
function Zb(t, e) {
  var n = t.site, r = n[0], a = n[1], o = a - e;
  if (!o) return r;
  var u = t.P;
  if (!u) return -1 / 0;
  n = u.site;
  var c = n[0], l = n[1], d = l - e;
  if (!d) return c;
  var g = c - r, y = 1 / o - 1 / d, f = g / d;
  return y ? (-f + Math.sqrt(f * f - 2 * y * (g * g / (-2 * d) - l + d / 2 + a - o / 2))) / y + r : (r + c) / 2;
}
function Pk(t, e) {
  var n = t.N;
  if (n) return Zb(n, e);
  var r = t.site;
  return r[1] === e ? r[0] : 1 / 0;
}
var he = 1e-6, Ya, Bn, Ns, sn;
function Nk(t, e, n) {
  return (t[0] - n[0]) * (e[1] - t[1]) - (t[0] - e[0]) * (n[1] - t[1]);
}
function Ik(t, e) {
  return e[1] - t[1] || e[0] - t[0];
}
function ip(t, e) {
  var n = t.sort(Ik).pop(), r, a, o;
  for (sn = [], Bn = new Array(t.length), Ya = new dl(), Ns = new dl(); ; )
    if (o = C0, n && (!o || n[1] < o.y || n[1] === o.y && n[0] < o.x))
      (n[0] !== r || n[1] !== a) && (Lk(n), r = n[0], a = n[1]), n = t.pop();
    else if (o)
      Ok(o.arc);
    else
      break;
  if (Ck(), e) {
    var u = +e[0][0], c = +e[0][1], l = +e[1][0], d = +e[1][1];
    Ek(u, c, l, d), Rk(u, c, l, d);
  }
  this.edges = sn, this.cells = Bn, Ya = Ns = sn = Bn = null;
}
ip.prototype = {
  constructor: ip,
  polygons: function() {
    var t = this.edges;
    return this.cells.map(function(e) {
      var n = e.halfedges.map(function(r) {
        return Xb(e, t[r]);
      });
      return n.data = e.site.data, n;
    });
  },
  triangles: function() {
    var t = [], e = this.edges;
    return this.cells.forEach(function(n, r) {
      if (c = (o = n.halfedges).length)
        for (var a = n.site, o, u = -1, c, l, d = e[o[c - 1]], g = d.left === a ? d.right : d.left; ++u < c; )
          l = g, d = e[o[u]], g = d.left === a ? d.right : d.left, l && g && r < l.index && r < g.index && Nk(a, l, g) < 0 && t.push([a.data, l.data, g.data]);
    }), t;
  },
  links: function() {
    return this.edges.filter(function(t) {
      return t.right;
    }).map(function(t) {
      return {
        source: t.left.data,
        target: t.right.data
      };
    });
  },
  find: function(t, e, n) {
    for (var r = this, a, o = r._found || 0, u = r.cells.length, c; !(c = r.cells[o]); ) if (++o >= u) return null;
    var l = t - c.site[0], d = e - c.site[1], g = l * l + d * d;
    do
      c = r.cells[a = o], o = null, c.halfedges.forEach(function(y) {
        var f = r.edges[y], m = f.left;
        if (!((m === c.site || !m) && !(m = f.right))) {
          var b = t - m[0], E = e - m[1], S = b * b + E * E;
          S < g && (g = S, o = m.index);
        }
      });
    while (o !== null);
    return r._found = a, n == null || g <= n * n ? c.site : null;
  }
};
function jk() {
  var t = xk, e = _k, n = null;
  function r(a) {
    return new ip(a.map(function(o, u) {
      var c = [Math.round(t(o, u, a) / he) * he, Math.round(e(o, u, a) / he) * he];
      return c.index = u, c.data = o, c;
    }), n);
  }
  return r.polygons = function(a) {
    return r(a).polygons();
  }, r.links = function(a) {
    return r(a).links();
  }, r.triangles = function(a) {
    return r(a).triangles();
  }, r.x = function(a) {
    return arguments.length ? (t = typeof a == "function" ? a : uv(+a), r) : t;
  }, r.y = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : uv(+a), r) : e;
  }, r.extent = function(a) {
    return arguments.length ? (n = a == null ? null : [[+a[0][0], +a[0][1]], [+a[1][0], +a[1][1]]], r) : n && [[n[0][0], n[0][1]], [n[1][0], n[1][1]]];
  }, r.size = function(a) {
    return arguments.length ? (n = a == null ? null : [[0, 0], [+a[0], +a[1]]], r) : n && [n[1][0] - n[0][0], n[1][1] - n[0][1]];
  }, r;
}
function lc(t) {
  return function() {
    return t;
  };
}
function kk(t, e, n) {
  this.target = t, this.type = e, this.transform = n;
}
function Gr(t, e, n) {
  this.k = t, this.x = e, this.y = n;
}
Gr.prototype = {
  constructor: Gr,
  scale: function(t) {
    return t === 1 ? this : new Gr(this.k * t, this.x, this.y);
  },
  translate: function(t, e) {
    return t === 0 & e === 0 ? this : new Gr(this.k, this.x + this.k * t, this.y + this.k * e);
  },
  apply: function(t) {
    return [t[0] * this.k + this.x, t[1] * this.k + this.y];
  },
  applyX: function(t) {
    return t * this.k + this.x;
  },
  applyY: function(t) {
    return t * this.k + this.y;
  },
  invert: function(t) {
    return [(t[0] - this.x) / this.k, (t[1] - this.y) / this.k];
  },
  invertX: function(t) {
    return (t - this.x) / this.k;
  },
  invertY: function(t) {
    return (t - this.y) / this.k;
  },
  rescaleX: function(t) {
    return t.copy().domain(t.range().map(this.invertX, this).map(t.invert, t));
  },
  rescaleY: function(t) {
    return t.copy().domain(t.range().map(this.invertY, this).map(t.invert, t));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
var Kl = new Gr(1, 0, 0);
Jb.prototype = Gr.prototype;
function Jb(t) {
  return t.__zoom || Kl;
}
function od() {
  St.stopImmediatePropagation();
}
function Uo() {
  St.preventDefault(), St.stopImmediatePropagation();
}
function Bk() {
  return !St.button;
}
function Fk() {
  var t = this, e, n;
  return t instanceof SVGElement ? (t = t.ownerSVGElement || t, e = t.width.baseVal.value, n = t.height.baseVal.value) : (e = t.clientWidth, n = t.clientHeight), [[0, 0], [e, n]];
}
function fv() {
  return this.__zoom || Kl;
}
function Uk() {
  return -St.deltaY * (St.deltaMode ? 120 : 1) / 500;
}
function $k() {
  return "ontouchstart" in this;
}
function zk(t, e, n) {
  var r = t.invertX(e[0][0]) - n[0][0], a = t.invertX(e[1][0]) - n[1][0], o = t.invertY(e[0][1]) - n[0][1], u = t.invertY(e[1][1]) - n[1][1];
  return t.translate(
    a > r ? (r + a) / 2 : Math.min(0, r) || Math.max(0, a),
    u > o ? (o + u) / 2 : Math.min(0, o) || Math.max(0, u)
  );
}
function Vk() {
  var t = Bk, e = Fk, n = zk, r = Uk, a = $k, o = [0, 1 / 0], u = [[-1 / 0, -1 / 0], [1 / 0, 1 / 0]], c = 250, l = Tx, d = [], g = wi("start", "zoom", "end"), y, f, m = 500, b = 150, E = 0;
  function S(T) {
    T.property("__zoom", fv).on("wheel.zoom", w).on("mousedown.zoom", C).on("dblclick.zoom", P).filter(a).on("touchstart.zoom", Y).on("touchmove.zoom", V).on("touchend.zoom touchcancel.zoom", k).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  S.transform = function(T, R) {
    var F = T.selection ? T.selection() : T;
    F.property("__zoom", fv), T !== F ? A(T, R) : F.interrupt().each(function() {
      x(this, arguments).start().zoom(null, typeof R == "function" ? R.apply(this, arguments) : R).end();
    });
  }, S.scaleBy = function(T, R) {
    S.scaleTo(T, function() {
      var F = this.__zoom.k, U = typeof R == "function" ? R.apply(this, arguments) : R;
      return F * U;
    });
  }, S.scaleTo = function(T, R) {
    S.transform(T, function() {
      var F = e.apply(this, arguments), U = this.__zoom, H = O(F), W = U.invert(H), B = typeof R == "function" ? R.apply(this, arguments) : R;
      return n(N(M(U, B), H, W), F, u);
    });
  }, S.translateBy = function(T, R, F) {
    S.transform(T, function() {
      return n(this.__zoom.translate(
        typeof R == "function" ? R.apply(this, arguments) : R,
        typeof F == "function" ? F.apply(this, arguments) : F
      ), e.apply(this, arguments), u);
    });
  }, S.translateTo = function(T, R, F) {
    S.transform(T, function() {
      var U = e.apply(this, arguments), H = this.__zoom, W = O(U);
      return n(Kl.translate(W[0], W[1]).scale(H.k).translate(
        typeof R == "function" ? -R.apply(this, arguments) : -R,
        typeof F == "function" ? -F.apply(this, arguments) : -F
      ), U, u);
    });
  };
  function M(T, R) {
    return R = Math.max(o[0], Math.min(o[1], R)), R === T.k ? T : new Gr(R, T.x, T.y);
  }
  function N(T, R, F) {
    var U = R[0] - F[0] * T.k, H = R[1] - F[1] * T.k;
    return U === T.x && H === T.y ? T : new Gr(T.k, U, H);
  }
  function O(T) {
    return [(+T[0][0] + +T[1][0]) / 2, (+T[0][1] + +T[1][1]) / 2];
  }
  function A(T, R, F) {
    T.on("start.zoom", function() {
      x(this, arguments).start();
    }).on("interrupt.zoom end.zoom", function() {
      x(this, arguments).end();
    }).tween("zoom", function() {
      var U = this, H = arguments, W = x(U, H), B = e.apply(U, H), j = F || O(B), X = Math.max(B[1][0] - B[0][0], B[1][1] - B[0][1]), tt = U.__zoom, et = typeof R == "function" ? R.apply(U, H) : R, ot = l(tt.invert(j).concat(X / tt.k), et.invert(j).concat(X / et.k));
      return function(Z) {
        if (Z === 1) Z = et;
        else {
          var lt = ot(Z), z = X / lt[2];
          Z = new Gr(z, j[0] - lt[0] * z, j[1] - lt[1] * z);
        }
        W.zoom(null, Z);
      };
    });
  }
  function x(T, R) {
    for (var F = 0, U = d.length, H; F < U; ++F)
      if ((H = d[F]).that === T)
        return H;
    return new v(T, R);
  }
  function v(T, R) {
    this.that = T, this.args = R, this.index = -1, this.active = 0, this.extent = e.apply(T, R);
  }
  v.prototype = {
    start: function() {
      return ++this.active === 1 && (this.index = d.push(this) - 1, this.emit("start")), this;
    },
    zoom: function(T, R) {
      return this.mouse && T !== "mouse" && (this.mouse[1] = R.invert(this.mouse[0])), this.touch0 && T !== "touch" && (this.touch0[1] = R.invert(this.touch0[0])), this.touch1 && T !== "touch" && (this.touch1[1] = R.invert(this.touch1[0])), this.that.__zoom = R, this.emit("zoom"), this;
    },
    end: function() {
      return --this.active === 0 && (d.splice(this.index, 1), this.index = -1, this.emit("end")), this;
    },
    emit: function(T) {
      ps(new kk(S, T, this.that.__zoom), g.apply, g, [T, this.that, this.args]);
    }
  };
  function w() {
    if (!t.apply(this, arguments)) return;
    var T = x(this, arguments), R = this.__zoom, F = Math.max(o[0], Math.min(o[1], R.k * Math.pow(2, r.apply(this, arguments)))), U = fi(this);
    if (T.wheel)
      (T.mouse[0][0] !== U[0] || T.mouse[0][1] !== U[1]) && (T.mouse[1] = R.invert(T.mouse[0] = U)), clearTimeout(T.wheel);
    else {
      if (R.k === F) return;
      T.mouse = [U, R.invert(U)], Wi(this), T.start();
    }
    Uo(), T.wheel = setTimeout(H, b), T.zoom("mouse", n(N(M(R, F), T.mouse[0], T.mouse[1]), T.extent, u));
    function H() {
      T.wheel = null, T.end();
    }
  }
  function C() {
    if (f || !t.apply(this, arguments)) return;
    var T = x(this, arguments), R = Cn(St.view).on("mousemove.zoom", W, !0).on("mouseup.zoom", B, !0), F = fi(this), U = St.clientX, H = St.clientY;
    Cl(St.view), od(), T.mouse = [F, this.__zoom.invert(F)], Wi(this), T.start();
    function W() {
      if (Uo(), !T.moved) {
        var j = St.clientX - U, X = St.clientY - H;
        T.moved = j * j + X * X > E;
      }
      T.zoom("mouse", n(N(T.that.__zoom, T.mouse[0] = fi(T.that), T.mouse[1]), T.extent, u));
    }
    function B() {
      R.on("mousemove.zoom mouseup.zoom", null), Rl(St.view, T.moved), Uo(), T.end();
    }
  }
  function P() {
    if (t.apply(this, arguments)) {
      var T = this.__zoom, R = fi(this), F = T.invert(R), U = T.k * (St.shiftKey ? 0.5 : 2), H = n(N(M(T, U), R, F), e.apply(this, arguments), u);
      Uo(), c > 0 ? Cn(this).transition().duration(c).call(A, H, R) : Cn(this).call(S.transform, H);
    }
  }
  function Y() {
    if (t.apply(this, arguments)) {
      var T = x(this, arguments), R = St.changedTouches, F, U = R.length, H, W, B;
      for (od(), H = 0; H < U; ++H)
        W = R[H], B = Cc(this, R, W.identifier), B = [B, this.__zoom.invert(B), W.identifier], T.touch0 ? T.touch1 || (T.touch1 = B) : (T.touch0 = B, F = !0);
      if (y && (y = clearTimeout(y), !T.touch1)) {
        T.end(), B = Cn(this).on("dblclick.zoom"), B && B.apply(this, arguments);
        return;
      }
      F && (y = setTimeout(function() {
        y = null;
      }, m), Wi(this), T.start());
    }
  }
  function V() {
    var T = x(this, arguments), R = St.changedTouches, F = R.length, U, H, W, B;
    for (Uo(), y && (y = clearTimeout(y)), U = 0; U < F; ++U)
      H = R[U], W = Cc(this, R, H.identifier), T.touch0 && T.touch0[2] === H.identifier ? T.touch0[0] = W : T.touch1 && T.touch1[2] === H.identifier && (T.touch1[0] = W);
    if (H = T.that.__zoom, T.touch1) {
      var j = T.touch0[0], X = T.touch0[1], tt = T.touch1[0], et = T.touch1[1], ot = (ot = tt[0] - j[0]) * ot + (ot = tt[1] - j[1]) * ot, Z = (Z = et[0] - X[0]) * Z + (Z = et[1] - X[1]) * Z;
      H = M(H, Math.sqrt(ot / Z)), W = [(j[0] + tt[0]) / 2, (j[1] + tt[1]) / 2], B = [(X[0] + et[0]) / 2, (X[1] + et[1]) / 2];
    } else if (T.touch0) W = T.touch0[0], B = T.touch0[1];
    else return;
    T.zoom("touch", n(N(H, W, B), T.extent, u));
  }
  function k() {
    var T = x(this, arguments), R = St.changedTouches, F = R.length, U, H;
    for (od(), f && clearTimeout(f), f = setTimeout(function() {
      f = null;
    }, m), U = 0; U < F; ++U)
      H = R[U], T.touch0 && T.touch0[2] === H.identifier ? delete T.touch0 : T.touch1 && T.touch1[2] === H.identifier && delete T.touch1;
    T.touch1 && !T.touch0 && (T.touch0 = T.touch1, delete T.touch1), T.touch0 ? T.touch0[1] = this.__zoom.invert(T.touch0[0]) : T.end();
  }
  return S.wheelDelta = function(T) {
    return arguments.length ? (r = typeof T == "function" ? T : lc(+T), S) : r;
  }, S.filter = function(T) {
    return arguments.length ? (t = typeof T == "function" ? T : lc(!!T), S) : t;
  }, S.touchable = function(T) {
    return arguments.length ? (a = typeof T == "function" ? T : lc(!!T), S) : a;
  }, S.extent = function(T) {
    return arguments.length ? (e = typeof T == "function" ? T : lc([[+T[0][0], +T[0][1]], [+T[1][0], +T[1][1]]]), S) : e;
  }, S.scaleExtent = function(T) {
    return arguments.length ? (o[0] = +T[0], o[1] = +T[1], S) : [o[0], o[1]];
  }, S.translateExtent = function(T) {
    return arguments.length ? (u[0][0] = +T[0][0], u[1][0] = +T[1][0], u[0][1] = +T[0][1], u[1][1] = +T[1][1], S) : [[u[0][0], u[0][1]], [u[1][0], u[1][1]]];
  }, S.constrain = function(T) {
    return arguments.length ? (n = T, S) : n;
  }, S.duration = function(T) {
    return arguments.length ? (c = +T, S) : c;
  }, S.interpolate = function(T) {
    return arguments.length ? (l = T, S) : l;
  }, S.on = function() {
    var T = g.on.apply(g, arguments);
    return T === g ? S : T;
  }, S.clickDistance = function(T) {
    return arguments.length ? (E = (T = +T) * T, S) : Math.sqrt(E);
  }, S;
}
const Yk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  active: kI,
  arc: R4,
  area: Tb,
  areaRadial: rv,
  ascending: ea,
  axisBottom: tL,
  axisLeft: eL,
  axisRight: JO,
  axisTop: ZO,
  bisect: Hi,
  bisectLeft: RO,
  bisectRight: Hi,
  bisector: dp,
  brush: qI,
  brushSelection: YI,
  brushX: WI,
  brushY: GI,
  chord: XI,
  clientPoint: Tl,
  cluster: p5,
  color: yi,
  create: SP,
  creator: Sl,
  cross: MO,
  csv: E6,
  csvFormat: f3,
  csvFormatRows: h3,
  csvParse: Vx,
  csvParseRows: l3,
  cubehelix: cr,
  curveBasis: q4,
  curveBasisClosed: H4,
  curveBasisOpen: X4,
  curveBundle: Q4,
  curveCardinal: K4,
  curveCardinalClosed: Z4,
  curveCardinalOpen: J4,
  curveCatmullRom: tk,
  curveCatmullRomClosed: ek,
  curveCatmullRomOpen: nk,
  curveLinear: ql,
  curveLinearClosed: rk,
  curveMonotoneX: ik,
  curveMonotoneY: ak,
  curveNatural: ok,
  curveStep: sk,
  curveStepAfter: ck,
  curveStepBefore: uk,
  customEvent: ps,
  descending: OO,
  deviation: Wv,
  dispatch: wi,
  drag: LP,
  dragDisable: Cl,
  dragEnable: Rl,
  dsvFormat: jp,
  easeBack: jy,
  easeBackIn: MI,
  easeBackInOut: jy,
  easeBackOut: OI,
  easeBounce: bs,
  easeBounceIn: RI,
  easeBounceInOut: DI,
  easeBounceOut: bs,
  easeCircle: Iy,
  easeCircleIn: vI,
  easeCircleInOut: Iy,
  easeCircleOut: xI,
  easeCubic: Td,
  easeCubicIn: lI,
  easeCubicInOut: Td,
  easeCubicOut: fI,
  easeElastic: ky,
  easeElasticIn: LI,
  easeElasticInOut: PI,
  easeElasticOut: ky,
  easeExp: Ny,
  easeExpIn: mI,
  easeExpInOut: Ny,
  easeExpOut: yI,
  easeLinear: sI,
  easePoly: Ly,
  easePolyIn: hI,
  easePolyInOut: Ly,
  easePolyOut: dI,
  easeQuad: Oy,
  easeQuadIn: uI,
  easeQuadInOut: Oy,
  easeQuadOut: cI,
  easeSin: Py,
  easeSinIn: pI,
  easeSinInOut: Py,
  easeSinOut: gI,
  entries: s3,
  get event() {
    return St;
  },
  extent: ks,
  forceCenter: m3,
  forceCollide: I3,
  forceLink: k3,
  forceManyBody: V3,
  forceRadial: Y3,
  forceSimulation: z3,
  forceX: W3,
  forceY: G3,
  get format() {
    return Yt;
  },
  formatDefaultLocale: Xx,
  formatLocale: Hx,
  get formatPrefix() {
    return $s;
  },
  formatSpecifier: Es,
  geoAlbers: N_,
  geoAlbersUsa: Hj,
  geoArea: ej,
  geoAzimuthalEqualArea: Xj,
  geoAzimuthalEqualAreaRaw: Hp,
  geoAzimuthalEquidistant: Qj,
  geoAzimuthalEquidistantRaw: Xp,
  geoBounds: aj,
  geoCentroid: fj,
  geoCircle: hj,
  geoClipAntimeridian: $d,
  geoClipCircle: v_,
  geoClipExtent: xj,
  geoClipRectangle: Bl,
  geoConicConformal: Zj,
  geoConicConformalRaw: k_,
  geoConicEqualArea: al,
  geoConicEqualAreaRaw: P_,
  geoConicEquidistant: t5,
  geoConicEquidistantRaw: B_,
  geoContains: Tj,
  geoDistance: ss,
  geoEquirectangular: Jj,
  geoEquirectangularRaw: Cs,
  geoGnomonic: e5,
  geoGnomonicRaw: Qp,
  geoGraticule: b_,
  geoGraticule10: Cj,
  geoIdentity: n5,
  geoInterpolate: Rj,
  geoLength: x_,
  geoMercator: Kj,
  geoMercatorRaw: Ws,
  geoNaturalEarth1: r5,
  geoNaturalEarth1Raw: Kp,
  geoOrthographic: i5,
  geoOrthographicRaw: Zp,
  geoPath: Fj,
  geoProjection: Kr,
  geoProjectionMutator: Gp,
  geoRotation: h_,
  geoStereographic: a5,
  geoStereographicRaw: Jp,
  geoStream: or,
  geoTransform: Uj,
  geoTransverseMercator: o5,
  geoTransverseMercatorRaw: t0,
  hcl: Oc,
  hierarchy: e0,
  histogram: IO,
  hsl: Rc,
  html: v6,
  interpolate: Us,
  interpolateArray: vx,
  interpolateBasis: px,
  interpolateBasisClosed: gx,
  interpolateCool: p4,
  interpolateCubehelix: sN,
  interpolateCubehelixDefault: h4,
  interpolateCubehelixLong: Ol,
  interpolateDate: xx,
  interpolateHcl: aN,
  interpolateHclLong: oN,
  interpolateHsl: nN,
  interpolateHslLong: rN,
  interpolateInferno: v4,
  interpolateLab: iN,
  interpolateMagma: y4,
  interpolateNumber: jn,
  interpolateObject: _x,
  interpolatePlasma: x4,
  interpolateRainbow: g4,
  interpolateRgb: vs,
  interpolateRgbBasis: qP,
  interpolateRgbBasisClosed: HP,
  interpolateRound: bx,
  interpolateString: Cp,
  interpolateTransformCss: Sx,
  interpolateTransformSvg: Ax,
  interpolateViridis: m4,
  interpolateWarm: d4,
  interpolateZoom: Tx,
  interrupt: Wi,
  interval: hN,
  isoFormat: e4,
  isoParse: r4,
  json: x6,
  keys: $x,
  lab: Mc,
  line: x0,
  lineRadial: nv,
  linkHorizontal: k4,
  linkRadial: F4,
  linkVertical: B4,
  local: ix,
  map: Cr,
  matcher: yp,
  max: bl,
  mean: BO,
  median: FO,
  merge: gp,
  min: wl,
  mouse: fi,
  namespace: Bs,
  namespaces: yd,
  nest: Ip,
  now: oo,
  pack: F5,
  packEnclose: U_,
  packSiblings: j5,
  pairs: DO,
  partition: U5,
  path: Si,
  permute: UO,
  pie: O4,
  pointRadial: es,
  polygonArea: e6,
  polygonCentroid: n6,
  polygonContains: o6,
  polygonHull: a6,
  polygonLength: s6,
  precisionFixed: Qx,
  precisionPrefix: Kx,
  precisionRound: Zx,
  quadtree: kl,
  quantile: ds,
  quantize: uN,
  queue: X_,
  radialArea: rv,
  radialLine: nv,
  randomBates: p6,
  randomExponential: g6,
  randomIrwinHall: K_,
  randomLogNormal: d6,
  randomNormal: Q_,
  randomUniform: h6,
  range: tr,
  request: r0,
  rgb: ms,
  ribbon: r3,
  scaleBand: a0,
  scaleIdentity: nb,
  scaleImplicit: ep,
  scaleLinear: ul,
  scaleLog: ib,
  scaleOrdinal: qs,
  scalePoint: A6,
  scalePow: u0,
  scaleQuantile: ab,
  scaleQuantize: ob,
  scaleSequential: Sb,
  scaleSqrt: N6,
  scaleThreshold: sb,
  scaleTime: Wl,
  scaleUtc: s4,
  scan: $O,
  schemeCategory10: u4,
  schemeCategory20: f4,
  schemeCategory20b: c4,
  schemeCategory20c: l4,
  select: Cn,
  selectAll: TP,
  selection: na,
  selector: Al,
  selectorAll: mp,
  set: Ux,
  shuffle: zO,
  stack: fk,
  stackOffsetDiverging: dk,
  stackOffsetExpand: hk,
  stackOffsetNone: to,
  stackOffsetSilhouette: pk,
  stackOffsetWiggle: gk,
  stackOrderAscending: qb,
  stackOrderDescending: mk,
  stackOrderInsideOut: yk,
  stackOrderNone: eo,
  stackOrderReverse: vk,
  stratify: Y5,
  style: Xi,
  sum: VO,
  symbol: G4,
  symbolCircle: w0,
  symbolCross: Db,
  symbolDiamond: Ob,
  symbolSquare: Nb,
  symbolStar: Pb,
  symbolTriangle: Ib,
  symbolWye: jb,
  symbols: W4,
  text: _6,
  thresholdFreedmanDiaconis: jO,
  thresholdScott: kO,
  thresholdSturges: qv,
  tickIncrement: as,
  tickStep: hs,
  ticks: pp,
  timeDay: Xs,
  timeDays: k6,
  get timeFormat() {
    return je;
  },
  timeFormatDefaultLocale: wb,
  timeFormatLocale: vb,
  timeFriday: hb,
  timeFridays: z6,
  timeHour: l0,
  timeHours: j6,
  timeInterval: Ve,
  timeMillisecond: ta,
  timeMilliseconds: $1,
  timeMinute: c0,
  timeMinutes: I6,
  timeMonday: Ms,
  timeMondays: B6,
  timeMonth: f0,
  timeMonths: Y6,
  get timeParse() {
    return bb;
  },
  timeSaturday: db,
  timeSaturdays: V6,
  timeSecond: Rs,
  timeSeconds: z1,
  timeSunday: Ds,
  timeSundays: V1,
  timeThursday: us,
  timeThursdays: $6,
  timeTuesday: lb,
  timeTuesdays: F6,
  timeWednesday: fb,
  timeWednesdays: U6,
  timeWeek: Ds,
  timeWeeks: V1,
  timeYear: Hr,
  timeYears: W6,
  timeout: Ed,
  timer: Pl,
  timerFlush: Lx,
  touch: Cc,
  touches: CP,
  transition: Ix,
  transpose: Hv,
  tree: Q5,
  treemap: K5,
  treemapBinary: Z5,
  treemapDice: Gs,
  treemapResquarify: t6,
  treemapSlice: Ul,
  treemapSliceDice: J5,
  treemapSquarify: q_,
  tsv: S6,
  tsvFormat: p3,
  tsvFormatRows: g3,
  tsvParse: Yx,
  tsvParseRows: d3,
  utcDay: Qs,
  utcDays: H6,
  get utcFormat() {
    return Yl;
  },
  utcFriday: mb,
  utcFridays: J6,
  utcHour: d0,
  utcHours: q6,
  utcMillisecond: ta,
  utcMilliseconds: $1,
  utcMinute: h0,
  utcMinutes: G6,
  utcMonday: Ls,
  utcMondays: X6,
  utcMonth: p0,
  utcMonths: e8,
  get utcParse() {
    return g0;
  },
  utcSaturday: yb,
  utcSaturdays: t8,
  utcSecond: Rs,
  utcSeconds: z1,
  utcSunday: Os,
  utcSundays: Y1,
  utcThursday: cs,
  utcThursdays: Z6,
  utcTuesday: pb,
  utcTuesdays: Q6,
  utcWednesday: gb,
  utcWednesdays: K6,
  utcWeek: Os,
  utcWeeks: Y1,
  utcYear: Xr,
  utcYears: n8,
  values: o3,
  variance: Yv,
  version: TO,
  voronoi: jk,
  window: vp,
  xml: b6,
  zip: WO,
  zoom: Vk,
  zoomIdentity: Kl,
  zoomTransform: Jb
}, Symbol.toStringTag, { value: "Module" }));
function Wk(t, e) {
  t.sort((n, r) => n[e] < r[e] ? -1 : n[e] > r[e] ? 1 : 0);
}
const _r = (t) => {
  if (t && t.length > 0) {
    let e = [...t];
    Wk(e, "category");
    let n = {};
    const r = Qr(e);
    return r.empty || (n = r.category.map(function(a, o) {
      return {
        Category: a,
        min: r.minValue[o],
        max: r.maxValue[o],
        median: r.medianValue[o],
        LIF: r.p10Value[o],
        q1: r.p25Value[o],
        q3: r.p75Value[o],
        UIF: r.p90Value[o]
      };
    })), {
      yMax: bl(t, (a) => a.p90Value) || r.p90Value,
      data: n
    };
  } else
    return null;
}, Sr = (t) => {
  var e;
  return t instanceof Array ? (e = [], t.forEach((n) => {
    var r = {};
    r.id = +n.conceptId || n.conceptName, r.label = n.conceptName || "NULL (empty)", r.value = +n.countValue, e.push(r);
  })) : t.countValue instanceof Array ? e = t.countValue.map(function(n, r) {
    var a = {};
    return a.id = (n.conceptId || n.conceptName)[r], a.label = n.conceptName[r], a.value = n.countValue[r], a;
  }) : e = [
    {
      id: t.conceptId,
      label: t.conceptName,
      value: t.countValue
    }
  ], e = e.sort(function(n, r) {
    return r.label < n.label ? 1 : -1;
  }), e;
}, Da = (t) => {
  if (t && t.length > 0) {
    let e = Sr(t);
    return e.sort(function(n, r) {
      const a = n.label.toLowerCase(), o = r.label.toLowerCase();
      return a < o ? -1 : a > o ? 1 : 0;
    }), e;
  }
  return null;
};
var t2 = { exports: {} };
const Gk = /* @__PURE__ */ xD(Yk);
var rs = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
rs.exports;
var hv;
function qk() {
  return hv || (hv = 1, function(t, e) {
    (function() {
      var n, r = "4.17.21", a = 200, o = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", u = "Expected a function", c = "Invalid `variable` option passed into `_.template`", l = "__lodash_hash_undefined__", d = 500, g = "__lodash_placeholder__", y = 1, f = 2, m = 4, b = 1, E = 2, S = 1, M = 2, N = 4, O = 8, A = 16, x = 32, v = 64, w = 128, C = 256, P = 512, Y = 30, V = "...", k = 800, T = 16, R = 1, F = 2, U = 3, H = 1 / 0, W = 9007199254740991, B = 17976931348623157e292, j = NaN, X = 4294967295, tt = X - 1, et = X >>> 1, ot = [
        ["ary", w],
        ["bind", S],
        ["bindKey", M],
        ["curry", O],
        ["curryRight", A],
        ["flip", P],
        ["partial", x],
        ["partialRight", v],
        ["rearg", C]
      ], Z = "[object Arguments]", lt = "[object Array]", z = "[object AsyncFunction]", nt = "[object Boolean]", it = "[object Date]", Q = "[object DOMException]", ht = "[object Error]", pt = "[object Function]", st = "[object GeneratorFunction]", xt = "[object Map]", gt = "[object Number]", dt = "[object Null]", Tt = "[object Object]", Ht = "[object Promise]", te = "[object Proxy]", _t = "[object RegExp]", yt = "[object Set]", bt = "[object String]", Ct = "[object Symbol]", mt = "[object Undefined]", se = "[object WeakMap]", Gt = "[object WeakSet]", Re = "[object ArrayBuffer]", ke = "[object DataView]", ye = "[object Float32Array]", oe = "[object Float64Array]", Se = "[object Int8Array]", Dr = "[object Int16Array]", Zr = "[object Int32Array]", $t = "[object Uint8Array]", Ft = "[object Uint8ClampedArray]", re = "[object Uint16Array]", pe = "[object Uint32Array]", un = /\b__p \+= '';/g, _n = /\b(__p \+=) '' \+/g, oa = /(__e\(.*?\)|\b__t\)) \+\n'';/g, De = /&(?:amp|lt|gt|quot|#39);/g, bn = /[&<>"']/g, Mr = RegExp(De.source), Je = RegExp(bn.source), sa = /<%-([\s\S]+?)%>/g, Ri = /<%([\s\S]+?)%>/g, Ks = /<%=([\s\S]+?)%>/g, ef = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ua = /^\w*$/, nf = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Zs = /[\\^$.*+?()[\]{}|]/g, a2 = RegExp(Zs.source), rf = /^\s+/, o2 = /\s/, s2 = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, u2 = /\{\n\/\* \[wrapped with (.+)\] \*/, c2 = /,? & /, l2 = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, f2 = /[()=,{}\[\]\/\s]/, h2 = /\\(\\)?/g, d2 = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, R0 = /\w*$/, p2 = /^[-+]0x[0-9a-f]+$/i, g2 = /^0b[01]+$/i, m2 = /^\[object .+?Constructor\]$/, y2 = /^0o[0-7]+$/i, v2 = /^(?:0|[1-9]\d*)$/, x2 = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Js = /($^)/, _2 = /['\n\r\u2028\u2029\\]/g, tu = "\\ud800-\\udfff", b2 = "\\u0300-\\u036f", w2 = "\\ufe20-\\ufe2f", E2 = "\\u20d0-\\u20ff", D0 = b2 + w2 + E2, M0 = "\\u2700-\\u27bf", O0 = "a-z\\xdf-\\xf6\\xf8-\\xff", S2 = "\\xac\\xb1\\xd7\\xf7", A2 = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", T2 = "\\u2000-\\u206f", C2 = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", L0 = "A-Z\\xc0-\\xd6\\xd8-\\xde", P0 = "\\ufe0e\\ufe0f", N0 = S2 + A2 + T2 + C2, af = "['’]", R2 = "[" + tu + "]", I0 = "[" + N0 + "]", eu = "[" + D0 + "]", j0 = "\\d+", D2 = "[" + M0 + "]", k0 = "[" + O0 + "]", B0 = "[^" + tu + N0 + j0 + M0 + O0 + L0 + "]", of = "\\ud83c[\\udffb-\\udfff]", M2 = "(?:" + eu + "|" + of + ")", F0 = "[^" + tu + "]", sf = "(?:\\ud83c[\\udde6-\\uddff]){2}", uf = "[\\ud800-\\udbff][\\udc00-\\udfff]", ca = "[" + L0 + "]", U0 = "\\u200d", $0 = "(?:" + k0 + "|" + B0 + ")", O2 = "(?:" + ca + "|" + B0 + ")", z0 = "(?:" + af + "(?:d|ll|m|re|s|t|ve))?", V0 = "(?:" + af + "(?:D|LL|M|RE|S|T|VE))?", Y0 = M2 + "?", W0 = "[" + P0 + "]?", L2 = "(?:" + U0 + "(?:" + [F0, sf, uf].join("|") + ")" + W0 + Y0 + ")*", P2 = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", N2 = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", G0 = W0 + Y0 + L2, I2 = "(?:" + [D2, sf, uf].join("|") + ")" + G0, j2 = "(?:" + [F0 + eu + "?", eu, sf, uf, R2].join("|") + ")", k2 = RegExp(af, "g"), B2 = RegExp(eu, "g"), cf = RegExp(of + "(?=" + of + ")|" + j2 + G0, "g"), F2 = RegExp([
        ca + "?" + k0 + "+" + z0 + "(?=" + [I0, ca, "$"].join("|") + ")",
        O2 + "+" + V0 + "(?=" + [I0, ca + $0, "$"].join("|") + ")",
        ca + "?" + $0 + "+" + z0,
        ca + "+" + V0,
        N2,
        P2,
        j0,
        I2
      ].join("|"), "g"), U2 = RegExp("[" + U0 + tu + D0 + P0 + "]"), $2 = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, z2 = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], V2 = -1, ve = {};
      ve[ye] = ve[oe] = ve[Se] = ve[Dr] = ve[Zr] = ve[$t] = ve[Ft] = ve[re] = ve[pe] = !0, ve[Z] = ve[lt] = ve[Re] = ve[nt] = ve[ke] = ve[it] = ve[ht] = ve[pt] = ve[xt] = ve[gt] = ve[Tt] = ve[_t] = ve[yt] = ve[bt] = ve[se] = !1;
      var me = {};
      me[Z] = me[lt] = me[Re] = me[ke] = me[nt] = me[it] = me[ye] = me[oe] = me[Se] = me[Dr] = me[Zr] = me[xt] = me[gt] = me[Tt] = me[_t] = me[yt] = me[bt] = me[Ct] = me[$t] = me[Ft] = me[re] = me[pe] = !0, me[ht] = me[pt] = me[se] = !1;
      var Y2 = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, W2 = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, G2 = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, q2 = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, H2 = parseFloat, X2 = parseInt, q0 = typeof Ao == "object" && Ao && Ao.Object === Object && Ao, Q2 = typeof self == "object" && self && self.Object === Object && self, Ge = q0 || Q2 || Function("return this")(), lf = e && !e.nodeType && e, Di = lf && !0 && t && !t.nodeType && t, H0 = Di && Di.exports === lf, ff = H0 && q0.process, $n = function() {
        try {
          var K = Di && Di.require && Di.require("util").types;
          return K || ff && ff.binding && ff.binding("util");
        } catch {
        }
      }(), X0 = $n && $n.isArrayBuffer, Q0 = $n && $n.isDate, K0 = $n && $n.isMap, Z0 = $n && $n.isRegExp, J0 = $n && $n.isSet, tg = $n && $n.isTypedArray;
      function Dn(K, at, rt) {
        switch (rt.length) {
          case 0:
            return K.call(at);
          case 1:
            return K.call(at, rt[0]);
          case 2:
            return K.call(at, rt[0], rt[1]);
          case 3:
            return K.call(at, rt[0], rt[1], rt[2]);
        }
        return K.apply(at, rt);
      }
      function K2(K, at, rt, wt) {
        for (var zt = -1, ue = K == null ? 0 : K.length; ++zt < ue; ) {
          var Be = K[zt];
          at(wt, Be, rt(Be), K);
        }
        return wt;
      }
      function zn(K, at) {
        for (var rt = -1, wt = K == null ? 0 : K.length; ++rt < wt && at(K[rt], rt, K) !== !1; )
          ;
        return K;
      }
      function Z2(K, at) {
        for (var rt = K == null ? 0 : K.length; rt-- && at(K[rt], rt, K) !== !1; )
          ;
        return K;
      }
      function eg(K, at) {
        for (var rt = -1, wt = K == null ? 0 : K.length; ++rt < wt; )
          if (!at(K[rt], rt, K))
            return !1;
        return !0;
      }
      function Jr(K, at) {
        for (var rt = -1, wt = K == null ? 0 : K.length, zt = 0, ue = []; ++rt < wt; ) {
          var Be = K[rt];
          at(Be, rt, K) && (ue[zt++] = Be);
        }
        return ue;
      }
      function nu(K, at) {
        var rt = K == null ? 0 : K.length;
        return !!rt && la(K, at, 0) > -1;
      }
      function hf(K, at, rt) {
        for (var wt = -1, zt = K == null ? 0 : K.length; ++wt < zt; )
          if (rt(at, K[wt]))
            return !0;
        return !1;
      }
      function be(K, at) {
        for (var rt = -1, wt = K == null ? 0 : K.length, zt = Array(wt); ++rt < wt; )
          zt[rt] = at(K[rt], rt, K);
        return zt;
      }
      function ti(K, at) {
        for (var rt = -1, wt = at.length, zt = K.length; ++rt < wt; )
          K[zt + rt] = at[rt];
        return K;
      }
      function df(K, at, rt, wt) {
        var zt = -1, ue = K == null ? 0 : K.length;
        for (wt && ue && (rt = K[++zt]); ++zt < ue; )
          rt = at(rt, K[zt], zt, K);
        return rt;
      }
      function J2(K, at, rt, wt) {
        var zt = K == null ? 0 : K.length;
        for (wt && zt && (rt = K[--zt]); zt--; )
          rt = at(rt, K[zt], zt, K);
        return rt;
      }
      function pf(K, at) {
        for (var rt = -1, wt = K == null ? 0 : K.length; ++rt < wt; )
          if (at(K[rt], rt, K))
            return !0;
        return !1;
      }
      var tw = gf("length");
      function ew(K) {
        return K.split("");
      }
      function nw(K) {
        return K.match(l2) || [];
      }
      function ng(K, at, rt) {
        var wt;
        return rt(K, function(zt, ue, Be) {
          if (at(zt, ue, Be))
            return wt = ue, !1;
        }), wt;
      }
      function ru(K, at, rt, wt) {
        for (var zt = K.length, ue = rt + (wt ? 1 : -1); wt ? ue-- : ++ue < zt; )
          if (at(K[ue], ue, K))
            return ue;
        return -1;
      }
      function la(K, at, rt) {
        return at === at ? pw(K, at, rt) : ru(K, rg, rt);
      }
      function rw(K, at, rt, wt) {
        for (var zt = rt - 1, ue = K.length; ++zt < ue; )
          if (wt(K[zt], at))
            return zt;
        return -1;
      }
      function rg(K) {
        return K !== K;
      }
      function ig(K, at) {
        var rt = K == null ? 0 : K.length;
        return rt ? yf(K, at) / rt : j;
      }
      function gf(K) {
        return function(at) {
          return at == null ? n : at[K];
        };
      }
      function mf(K) {
        return function(at) {
          return K == null ? n : K[at];
        };
      }
      function ag(K, at, rt, wt, zt) {
        return zt(K, function(ue, Be, ge) {
          rt = wt ? (wt = !1, ue) : at(rt, ue, Be, ge);
        }), rt;
      }
      function iw(K, at) {
        var rt = K.length;
        for (K.sort(at); rt--; )
          K[rt] = K[rt].value;
        return K;
      }
      function yf(K, at) {
        for (var rt, wt = -1, zt = K.length; ++wt < zt; ) {
          var ue = at(K[wt]);
          ue !== n && (rt = rt === n ? ue : rt + ue);
        }
        return rt;
      }
      function vf(K, at) {
        for (var rt = -1, wt = Array(K); ++rt < K; )
          wt[rt] = at(rt);
        return wt;
      }
      function aw(K, at) {
        return be(at, function(rt) {
          return [rt, K[rt]];
        });
      }
      function og(K) {
        return K && K.slice(0, lg(K) + 1).replace(rf, "");
      }
      function Mn(K) {
        return function(at) {
          return K(at);
        };
      }
      function xf(K, at) {
        return be(at, function(rt) {
          return K[rt];
        });
      }
      function co(K, at) {
        return K.has(at);
      }
      function sg(K, at) {
        for (var rt = -1, wt = K.length; ++rt < wt && la(at, K[rt], 0) > -1; )
          ;
        return rt;
      }
      function ug(K, at) {
        for (var rt = K.length; rt-- && la(at, K[rt], 0) > -1; )
          ;
        return rt;
      }
      function ow(K, at) {
        for (var rt = K.length, wt = 0; rt--; )
          K[rt] === at && ++wt;
        return wt;
      }
      var sw = mf(Y2), uw = mf(W2);
      function cw(K) {
        return "\\" + q2[K];
      }
      function lw(K, at) {
        return K == null ? n : K[at];
      }
      function fa(K) {
        return U2.test(K);
      }
      function fw(K) {
        return $2.test(K);
      }
      function hw(K) {
        for (var at, rt = []; !(at = K.next()).done; )
          rt.push(at.value);
        return rt;
      }
      function _f(K) {
        var at = -1, rt = Array(K.size);
        return K.forEach(function(wt, zt) {
          rt[++at] = [zt, wt];
        }), rt;
      }
      function cg(K, at) {
        return function(rt) {
          return K(at(rt));
        };
      }
      function ei(K, at) {
        for (var rt = -1, wt = K.length, zt = 0, ue = []; ++rt < wt; ) {
          var Be = K[rt];
          (Be === at || Be === g) && (K[rt] = g, ue[zt++] = rt);
        }
        return ue;
      }
      function iu(K) {
        var at = -1, rt = Array(K.size);
        return K.forEach(function(wt) {
          rt[++at] = wt;
        }), rt;
      }
      function dw(K) {
        var at = -1, rt = Array(K.size);
        return K.forEach(function(wt) {
          rt[++at] = [wt, wt];
        }), rt;
      }
      function pw(K, at, rt) {
        for (var wt = rt - 1, zt = K.length; ++wt < zt; )
          if (K[wt] === at)
            return wt;
        return -1;
      }
      function gw(K, at, rt) {
        for (var wt = rt + 1; wt--; )
          if (K[wt] === at)
            return wt;
        return wt;
      }
      function ha(K) {
        return fa(K) ? yw(K) : tw(K);
      }
      function er(K) {
        return fa(K) ? vw(K) : ew(K);
      }
      function lg(K) {
        for (var at = K.length; at-- && o2.test(K.charAt(at)); )
          ;
        return at;
      }
      var mw = mf(G2);
      function yw(K) {
        for (var at = cf.lastIndex = 0; cf.test(K); )
          ++at;
        return at;
      }
      function vw(K) {
        return K.match(cf) || [];
      }
      function xw(K) {
        return K.match(F2) || [];
      }
      var _w = function K(at) {
        at = at == null ? Ge : da.defaults(Ge.Object(), at, da.pick(Ge, z2));
        var rt = at.Array, wt = at.Date, zt = at.Error, ue = at.Function, Be = at.Math, ge = at.Object, bf = at.RegExp, bw = at.String, Vn = at.TypeError, au = rt.prototype, ww = ue.prototype, pa = ge.prototype, ou = at["__core-js_shared__"], su = ww.toString, fe = pa.hasOwnProperty, Ew = 0, fg = function() {
          var i = /[^.]+$/.exec(ou && ou.keys && ou.keys.IE_PROTO || "");
          return i ? "Symbol(src)_1." + i : "";
        }(), uu = pa.toString, Sw = su.call(ge), Aw = Ge._, Tw = bf(
          "^" + su.call(fe).replace(Zs, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), cu = H0 ? at.Buffer : n, ni = at.Symbol, lu = at.Uint8Array, hg = cu ? cu.allocUnsafe : n, fu = cg(ge.getPrototypeOf, ge), dg = ge.create, pg = pa.propertyIsEnumerable, hu = au.splice, gg = ni ? ni.isConcatSpreadable : n, lo = ni ? ni.iterator : n, Mi = ni ? ni.toStringTag : n, du = function() {
          try {
            var i = Ii(ge, "defineProperty");
            return i({}, "", {}), i;
          } catch {
          }
        }(), Cw = at.clearTimeout !== Ge.clearTimeout && at.clearTimeout, Rw = wt && wt.now !== Ge.Date.now && wt.now, Dw = at.setTimeout !== Ge.setTimeout && at.setTimeout, pu = Be.ceil, gu = Be.floor, wf = ge.getOwnPropertySymbols, Mw = cu ? cu.isBuffer : n, mg = at.isFinite, Ow = au.join, Lw = cg(ge.keys, ge), Fe = Be.max, tn = Be.min, Pw = wt.now, Nw = at.parseInt, yg = Be.random, Iw = au.reverse, Ef = Ii(at, "DataView"), fo = Ii(at, "Map"), Sf = Ii(at, "Promise"), ga = Ii(at, "Set"), ho = Ii(at, "WeakMap"), po = Ii(ge, "create"), mu = ho && new ho(), ma = {}, jw = ji(Ef), kw = ji(fo), Bw = ji(Sf), Fw = ji(ga), Uw = ji(ho), yu = ni ? ni.prototype : n, go = yu ? yu.valueOf : n, vg = yu ? yu.toString : n;
        function L(i) {
          if (Ae(i) && !Wt(i) && !(i instanceof ee)) {
            if (i instanceof Yn)
              return i;
            if (fe.call(i, "__wrapped__"))
              return xm(i);
          }
          return new Yn(i);
        }
        var ya = /* @__PURE__ */ function() {
          function i() {
          }
          return function(s) {
            if (!we(s))
              return {};
            if (dg)
              return dg(s);
            i.prototype = s;
            var h = new i();
            return i.prototype = n, h;
          };
        }();
        function vu() {
        }
        function Yn(i, s) {
          this.__wrapped__ = i, this.__actions__ = [], this.__chain__ = !!s, this.__index__ = 0, this.__values__ = n;
        }
        L.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: sa,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: Ri,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: Ks,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: L
          }
        }, L.prototype = vu.prototype, L.prototype.constructor = L, Yn.prototype = ya(vu.prototype), Yn.prototype.constructor = Yn;
        function ee(i) {
          this.__wrapped__ = i, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = X, this.__views__ = [];
        }
        function $w() {
          var i = new ee(this.__wrapped__);
          return i.__actions__ = wn(this.__actions__), i.__dir__ = this.__dir__, i.__filtered__ = this.__filtered__, i.__iteratees__ = wn(this.__iteratees__), i.__takeCount__ = this.__takeCount__, i.__views__ = wn(this.__views__), i;
        }
        function zw() {
          if (this.__filtered__) {
            var i = new ee(this);
            i.__dir__ = -1, i.__filtered__ = !0;
          } else
            i = this.clone(), i.__dir__ *= -1;
          return i;
        }
        function Vw() {
          var i = this.__wrapped__.value(), s = this.__dir__, h = Wt(i), _ = s < 0, D = h ? i.length : 0, I = eS(0, D, this.__views__), $ = I.start, q = I.end, J = q - $, ut = _ ? q : $ - 1, ct = this.__iteratees__, ft = ct.length, vt = 0, Rt = tn(J, this.__takeCount__);
          if (!h || !_ && D == J && Rt == J)
            return zg(i, this.__actions__);
          var jt = [];
          t:
            for (; J-- && vt < Rt; ) {
              ut += s;
              for (var Xt = -1, kt = i[ut]; ++Xt < ft; ) {
                var Jt = ct[Xt], ie = Jt.iteratee, Pn = Jt.type, fn = ie(kt);
                if (Pn == F)
                  kt = fn;
                else if (!fn) {
                  if (Pn == R)
                    continue t;
                  break t;
                }
              }
              jt[vt++] = kt;
            }
          return jt;
        }
        ee.prototype = ya(vu.prototype), ee.prototype.constructor = ee;
        function Oi(i) {
          var s = -1, h = i == null ? 0 : i.length;
          for (this.clear(); ++s < h; ) {
            var _ = i[s];
            this.set(_[0], _[1]);
          }
        }
        function Yw() {
          this.__data__ = po ? po(null) : {}, this.size = 0;
        }
        function Ww(i) {
          var s = this.has(i) && delete this.__data__[i];
          return this.size -= s ? 1 : 0, s;
        }
        function Gw(i) {
          var s = this.__data__;
          if (po) {
            var h = s[i];
            return h === l ? n : h;
          }
          return fe.call(s, i) ? s[i] : n;
        }
        function qw(i) {
          var s = this.__data__;
          return po ? s[i] !== n : fe.call(s, i);
        }
        function Hw(i, s) {
          var h = this.__data__;
          return this.size += this.has(i) ? 0 : 1, h[i] = po && s === n ? l : s, this;
        }
        Oi.prototype.clear = Yw, Oi.prototype.delete = Ww, Oi.prototype.get = Gw, Oi.prototype.has = qw, Oi.prototype.set = Hw;
        function Or(i) {
          var s = -1, h = i == null ? 0 : i.length;
          for (this.clear(); ++s < h; ) {
            var _ = i[s];
            this.set(_[0], _[1]);
          }
        }
        function Xw() {
          this.__data__ = [], this.size = 0;
        }
        function Qw(i) {
          var s = this.__data__, h = xu(s, i);
          if (h < 0)
            return !1;
          var _ = s.length - 1;
          return h == _ ? s.pop() : hu.call(s, h, 1), --this.size, !0;
        }
        function Kw(i) {
          var s = this.__data__, h = xu(s, i);
          return h < 0 ? n : s[h][1];
        }
        function Zw(i) {
          return xu(this.__data__, i) > -1;
        }
        function Jw(i, s) {
          var h = this.__data__, _ = xu(h, i);
          return _ < 0 ? (++this.size, h.push([i, s])) : h[_][1] = s, this;
        }
        Or.prototype.clear = Xw, Or.prototype.delete = Qw, Or.prototype.get = Kw, Or.prototype.has = Zw, Or.prototype.set = Jw;
        function Lr(i) {
          var s = -1, h = i == null ? 0 : i.length;
          for (this.clear(); ++s < h; ) {
            var _ = i[s];
            this.set(_[0], _[1]);
          }
        }
        function tE() {
          this.size = 0, this.__data__ = {
            hash: new Oi(),
            map: new (fo || Or)(),
            string: new Oi()
          };
        }
        function eE(i) {
          var s = Ou(this, i).delete(i);
          return this.size -= s ? 1 : 0, s;
        }
        function nE(i) {
          return Ou(this, i).get(i);
        }
        function rE(i) {
          return Ou(this, i).has(i);
        }
        function iE(i, s) {
          var h = Ou(this, i), _ = h.size;
          return h.set(i, s), this.size += h.size == _ ? 0 : 1, this;
        }
        Lr.prototype.clear = tE, Lr.prototype.delete = eE, Lr.prototype.get = nE, Lr.prototype.has = rE, Lr.prototype.set = iE;
        function Li(i) {
          var s = -1, h = i == null ? 0 : i.length;
          for (this.__data__ = new Lr(); ++s < h; )
            this.add(i[s]);
        }
        function aE(i) {
          return this.__data__.set(i, l), this;
        }
        function oE(i) {
          return this.__data__.has(i);
        }
        Li.prototype.add = Li.prototype.push = aE, Li.prototype.has = oE;
        function nr(i) {
          var s = this.__data__ = new Or(i);
          this.size = s.size;
        }
        function sE() {
          this.__data__ = new Or(), this.size = 0;
        }
        function uE(i) {
          var s = this.__data__, h = s.delete(i);
          return this.size = s.size, h;
        }
        function cE(i) {
          return this.__data__.get(i);
        }
        function lE(i) {
          return this.__data__.has(i);
        }
        function fE(i, s) {
          var h = this.__data__;
          if (h instanceof Or) {
            var _ = h.__data__;
            if (!fo || _.length < a - 1)
              return _.push([i, s]), this.size = ++h.size, this;
            h = this.__data__ = new Lr(_);
          }
          return h.set(i, s), this.size = h.size, this;
        }
        nr.prototype.clear = sE, nr.prototype.delete = uE, nr.prototype.get = cE, nr.prototype.has = lE, nr.prototype.set = fE;
        function xg(i, s) {
          var h = Wt(i), _ = !h && ki(i), D = !h && !_ && si(i), I = !h && !_ && !D && ba(i), $ = h || _ || D || I, q = $ ? vf(i.length, bw) : [], J = q.length;
          for (var ut in i)
            (s || fe.call(i, ut)) && !($ && // Safari 9 has enumerable `arguments.length` in strict mode.
            (ut == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            D && (ut == "offset" || ut == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            I && (ut == "buffer" || ut == "byteLength" || ut == "byteOffset") || // Skip index properties.
            jr(ut, J))) && q.push(ut);
          return q;
        }
        function _g(i) {
          var s = i.length;
          return s ? i[If(0, s - 1)] : n;
        }
        function hE(i, s) {
          return Lu(wn(i), Pi(s, 0, i.length));
        }
        function dE(i) {
          return Lu(wn(i));
        }
        function Af(i, s, h) {
          (h !== n && !rr(i[s], h) || h === n && !(s in i)) && Pr(i, s, h);
        }
        function mo(i, s, h) {
          var _ = i[s];
          (!(fe.call(i, s) && rr(_, h)) || h === n && !(s in i)) && Pr(i, s, h);
        }
        function xu(i, s) {
          for (var h = i.length; h--; )
            if (rr(i[h][0], s))
              return h;
          return -1;
        }
        function pE(i, s, h, _) {
          return ri(i, function(D, I, $) {
            s(_, D, h(D), $);
          }), _;
        }
        function bg(i, s) {
          return i && dr(s, Ye(s), i);
        }
        function gE(i, s) {
          return i && dr(s, Sn(s), i);
        }
        function Pr(i, s, h) {
          s == "__proto__" && du ? du(i, s, {
            configurable: !0,
            enumerable: !0,
            value: h,
            writable: !0
          }) : i[s] = h;
        }
        function Tf(i, s) {
          for (var h = -1, _ = s.length, D = rt(_), I = i == null; ++h < _; )
            D[h] = I ? n : oh(i, s[h]);
          return D;
        }
        function Pi(i, s, h) {
          return i === i && (h !== n && (i = i <= h ? i : h), s !== n && (i = i >= s ? i : s)), i;
        }
        function Wn(i, s, h, _, D, I) {
          var $, q = s & y, J = s & f, ut = s & m;
          if (h && ($ = D ? h(i, _, D, I) : h(i)), $ !== n)
            return $;
          if (!we(i))
            return i;
          var ct = Wt(i);
          if (ct) {
            if ($ = rS(i), !q)
              return wn(i, $);
          } else {
            var ft = en(i), vt = ft == pt || ft == st;
            if (si(i))
              return Wg(i, q);
            if (ft == Tt || ft == Z || vt && !D) {
              if ($ = J || vt ? {} : lm(i), !q)
                return J ? GE(i, gE($, i)) : WE(i, bg($, i));
            } else {
              if (!me[ft])
                return D ? i : {};
              $ = iS(i, ft, q);
            }
          }
          I || (I = new nr());
          var Rt = I.get(i);
          if (Rt)
            return Rt;
          I.set(i, $), Fm(i) ? i.forEach(function(kt) {
            $.add(Wn(kt, s, h, kt, i, I));
          }) : km(i) && i.forEach(function(kt, Jt) {
            $.set(Jt, Wn(kt, s, h, Jt, i, I));
          });
          var jt = ut ? J ? Gf : Wf : J ? Sn : Ye, Xt = ct ? n : jt(i);
          return zn(Xt || i, function(kt, Jt) {
            Xt && (Jt = kt, kt = i[Jt]), mo($, Jt, Wn(kt, s, h, Jt, i, I));
          }), $;
        }
        function mE(i) {
          var s = Ye(i);
          return function(h) {
            return wg(h, i, s);
          };
        }
        function wg(i, s, h) {
          var _ = h.length;
          if (i == null)
            return !_;
          for (i = ge(i); _--; ) {
            var D = h[_], I = s[D], $ = i[D];
            if ($ === n && !(D in i) || !I($))
              return !1;
          }
          return !0;
        }
        function Eg(i, s, h) {
          if (typeof i != "function")
            throw new Vn(u);
          return Eo(function() {
            i.apply(n, h);
          }, s);
        }
        function yo(i, s, h, _) {
          var D = -1, I = nu, $ = !0, q = i.length, J = [], ut = s.length;
          if (!q)
            return J;
          h && (s = be(s, Mn(h))), _ ? (I = hf, $ = !1) : s.length >= a && (I = co, $ = !1, s = new Li(s));
          t:
            for (; ++D < q; ) {
              var ct = i[D], ft = h == null ? ct : h(ct);
              if (ct = _ || ct !== 0 ? ct : 0, $ && ft === ft) {
                for (var vt = ut; vt--; )
                  if (s[vt] === ft)
                    continue t;
                J.push(ct);
              } else I(s, ft, _) || J.push(ct);
            }
          return J;
        }
        var ri = Qg(hr), Sg = Qg(Rf, !0);
        function yE(i, s) {
          var h = !0;
          return ri(i, function(_, D, I) {
            return h = !!s(_, D, I), h;
          }), h;
        }
        function _u(i, s, h) {
          for (var _ = -1, D = i.length; ++_ < D; ) {
            var I = i[_], $ = s(I);
            if ($ != null && (q === n ? $ === $ && !Ln($) : h($, q)))
              var q = $, J = I;
          }
          return J;
        }
        function vE(i, s, h, _) {
          var D = i.length;
          for (h = qt(h), h < 0 && (h = -h > D ? 0 : D + h), _ = _ === n || _ > D ? D : qt(_), _ < 0 && (_ += D), _ = h > _ ? 0 : $m(_); h < _; )
            i[h++] = s;
          return i;
        }
        function Ag(i, s) {
          var h = [];
          return ri(i, function(_, D, I) {
            s(_, D, I) && h.push(_);
          }), h;
        }
        function qe(i, s, h, _, D) {
          var I = -1, $ = i.length;
          for (h || (h = oS), D || (D = []); ++I < $; ) {
            var q = i[I];
            s > 0 && h(q) ? s > 1 ? qe(q, s - 1, h, _, D) : ti(D, q) : _ || (D[D.length] = q);
          }
          return D;
        }
        var Cf = Kg(), Tg = Kg(!0);
        function hr(i, s) {
          return i && Cf(i, s, Ye);
        }
        function Rf(i, s) {
          return i && Tg(i, s, Ye);
        }
        function bu(i, s) {
          return Jr(s, function(h) {
            return kr(i[h]);
          });
        }
        function Ni(i, s) {
          s = ai(s, i);
          for (var h = 0, _ = s.length; i != null && h < _; )
            i = i[pr(s[h++])];
          return h && h == _ ? i : n;
        }
        function Cg(i, s, h) {
          var _ = s(i);
          return Wt(i) ? _ : ti(_, h(i));
        }
        function cn(i) {
          return i == null ? i === n ? mt : dt : Mi && Mi in ge(i) ? tS(i) : dS(i);
        }
        function Df(i, s) {
          return i > s;
        }
        function xE(i, s) {
          return i != null && fe.call(i, s);
        }
        function _E(i, s) {
          return i != null && s in ge(i);
        }
        function bE(i, s, h) {
          return i >= tn(s, h) && i < Fe(s, h);
        }
        function Mf(i, s, h) {
          for (var _ = h ? hf : nu, D = i[0].length, I = i.length, $ = I, q = rt(I), J = 1 / 0, ut = []; $--; ) {
            var ct = i[$];
            $ && s && (ct = be(ct, Mn(s))), J = tn(ct.length, J), q[$] = !h && (s || D >= 120 && ct.length >= 120) ? new Li($ && ct) : n;
          }
          ct = i[0];
          var ft = -1, vt = q[0];
          t:
            for (; ++ft < D && ut.length < J; ) {
              var Rt = ct[ft], jt = s ? s(Rt) : Rt;
              if (Rt = h || Rt !== 0 ? Rt : 0, !(vt ? co(vt, jt) : _(ut, jt, h))) {
                for ($ = I; --$; ) {
                  var Xt = q[$];
                  if (!(Xt ? co(Xt, jt) : _(i[$], jt, h)))
                    continue t;
                }
                vt && vt.push(jt), ut.push(Rt);
              }
            }
          return ut;
        }
        function wE(i, s, h, _) {
          return hr(i, function(D, I, $) {
            s(_, h(D), I, $);
          }), _;
        }
        function vo(i, s, h) {
          s = ai(s, i), i = pm(i, s);
          var _ = i == null ? i : i[pr(qn(s))];
          return _ == null ? n : Dn(_, i, h);
        }
        function Rg(i) {
          return Ae(i) && cn(i) == Z;
        }
        function EE(i) {
          return Ae(i) && cn(i) == Re;
        }
        function SE(i) {
          return Ae(i) && cn(i) == it;
        }
        function xo(i, s, h, _, D) {
          return i === s ? !0 : i == null || s == null || !Ae(i) && !Ae(s) ? i !== i && s !== s : AE(i, s, h, _, xo, D);
        }
        function AE(i, s, h, _, D, I) {
          var $ = Wt(i), q = Wt(s), J = $ ? lt : en(i), ut = q ? lt : en(s);
          J = J == Z ? Tt : J, ut = ut == Z ? Tt : ut;
          var ct = J == Tt, ft = ut == Tt, vt = J == ut;
          if (vt && si(i)) {
            if (!si(s))
              return !1;
            $ = !0, ct = !1;
          }
          if (vt && !ct)
            return I || (I = new nr()), $ || ba(i) ? sm(i, s, h, _, D, I) : ZE(i, s, J, h, _, D, I);
          if (!(h & b)) {
            var Rt = ct && fe.call(i, "__wrapped__"), jt = ft && fe.call(s, "__wrapped__");
            if (Rt || jt) {
              var Xt = Rt ? i.value() : i, kt = jt ? s.value() : s;
              return I || (I = new nr()), D(Xt, kt, h, _, I);
            }
          }
          return vt ? (I || (I = new nr()), JE(i, s, h, _, D, I)) : !1;
        }
        function TE(i) {
          return Ae(i) && en(i) == xt;
        }
        function Of(i, s, h, _) {
          var D = h.length, I = D, $ = !_;
          if (i == null)
            return !I;
          for (i = ge(i); D--; ) {
            var q = h[D];
            if ($ && q[2] ? q[1] !== i[q[0]] : !(q[0] in i))
              return !1;
          }
          for (; ++D < I; ) {
            q = h[D];
            var J = q[0], ut = i[J], ct = q[1];
            if ($ && q[2]) {
              if (ut === n && !(J in i))
                return !1;
            } else {
              var ft = new nr();
              if (_)
                var vt = _(ut, ct, J, i, s, ft);
              if (!(vt === n ? xo(ct, ut, b | E, _, ft) : vt))
                return !1;
            }
          }
          return !0;
        }
        function Dg(i) {
          if (!we(i) || uS(i))
            return !1;
          var s = kr(i) ? Tw : m2;
          return s.test(ji(i));
        }
        function CE(i) {
          return Ae(i) && cn(i) == _t;
        }
        function RE(i) {
          return Ae(i) && en(i) == yt;
        }
        function DE(i) {
          return Ae(i) && Bu(i.length) && !!ve[cn(i)];
        }
        function Mg(i) {
          return typeof i == "function" ? i : i == null ? An : typeof i == "object" ? Wt(i) ? Pg(i[0], i[1]) : Lg(i) : Zm(i);
        }
        function Lf(i) {
          if (!wo(i))
            return Lw(i);
          var s = [];
          for (var h in ge(i))
            fe.call(i, h) && h != "constructor" && s.push(h);
          return s;
        }
        function ME(i) {
          if (!we(i))
            return hS(i);
          var s = wo(i), h = [];
          for (var _ in i)
            _ == "constructor" && (s || !fe.call(i, _)) || h.push(_);
          return h;
        }
        function Pf(i, s) {
          return i < s;
        }
        function Og(i, s) {
          var h = -1, _ = En(i) ? rt(i.length) : [];
          return ri(i, function(D, I, $) {
            _[++h] = s(D, I, $);
          }), _;
        }
        function Lg(i) {
          var s = Hf(i);
          return s.length == 1 && s[0][2] ? hm(s[0][0], s[0][1]) : function(h) {
            return h === i || Of(h, i, s);
          };
        }
        function Pg(i, s) {
          return Qf(i) && fm(s) ? hm(pr(i), s) : function(h) {
            var _ = oh(h, i);
            return _ === n && _ === s ? sh(h, i) : xo(s, _, b | E);
          };
        }
        function wu(i, s, h, _, D) {
          i !== s && Cf(s, function(I, $) {
            if (D || (D = new nr()), we(I))
              OE(i, s, $, h, wu, _, D);
            else {
              var q = _ ? _(Zf(i, $), I, $ + "", i, s, D) : n;
              q === n && (q = I), Af(i, $, q);
            }
          }, Sn);
        }
        function OE(i, s, h, _, D, I, $) {
          var q = Zf(i, h), J = Zf(s, h), ut = $.get(J);
          if (ut) {
            Af(i, h, ut);
            return;
          }
          var ct = I ? I(q, J, h + "", i, s, $) : n, ft = ct === n;
          if (ft) {
            var vt = Wt(J), Rt = !vt && si(J), jt = !vt && !Rt && ba(J);
            ct = J, vt || Rt || jt ? Wt(q) ? ct = q : Me(q) ? ct = wn(q) : Rt ? (ft = !1, ct = Wg(J, !0)) : jt ? (ft = !1, ct = Gg(J, !0)) : ct = [] : So(J) || ki(J) ? (ct = q, ki(q) ? ct = zm(q) : (!we(q) || kr(q)) && (ct = lm(J))) : ft = !1;
          }
          ft && ($.set(J, ct), D(ct, J, _, I, $), $.delete(J)), Af(i, h, ct);
        }
        function Ng(i, s) {
          var h = i.length;
          if (h)
            return s += s < 0 ? h : 0, jr(s, h) ? i[s] : n;
        }
        function Ig(i, s, h) {
          s.length ? s = be(s, function(I) {
            return Wt(I) ? function($) {
              return Ni($, I.length === 1 ? I[0] : I);
            } : I;
          }) : s = [An];
          var _ = -1;
          s = be(s, Mn(Nt()));
          var D = Og(i, function(I, $, q) {
            var J = be(s, function(ut) {
              return ut(I);
            });
            return { criteria: J, index: ++_, value: I };
          });
          return iw(D, function(I, $) {
            return YE(I, $, h);
          });
        }
        function LE(i, s) {
          return jg(i, s, function(h, _) {
            return sh(i, _);
          });
        }
        function jg(i, s, h) {
          for (var _ = -1, D = s.length, I = {}; ++_ < D; ) {
            var $ = s[_], q = Ni(i, $);
            h(q, $) && _o(I, ai($, i), q);
          }
          return I;
        }
        function PE(i) {
          return function(s) {
            return Ni(s, i);
          };
        }
        function Nf(i, s, h, _) {
          var D = _ ? rw : la, I = -1, $ = s.length, q = i;
          for (i === s && (s = wn(s)), h && (q = be(i, Mn(h))); ++I < $; )
            for (var J = 0, ut = s[I], ct = h ? h(ut) : ut; (J = D(q, ct, J, _)) > -1; )
              q !== i && hu.call(q, J, 1), hu.call(i, J, 1);
          return i;
        }
        function kg(i, s) {
          for (var h = i ? s.length : 0, _ = h - 1; h--; ) {
            var D = s[h];
            if (h == _ || D !== I) {
              var I = D;
              jr(D) ? hu.call(i, D, 1) : Bf(i, D);
            }
          }
          return i;
        }
        function If(i, s) {
          return i + gu(yg() * (s - i + 1));
        }
        function NE(i, s, h, _) {
          for (var D = -1, I = Fe(pu((s - i) / (h || 1)), 0), $ = rt(I); I--; )
            $[_ ? I : ++D] = i, i += h;
          return $;
        }
        function jf(i, s) {
          var h = "";
          if (!i || s < 1 || s > W)
            return h;
          do
            s % 2 && (h += i), s = gu(s / 2), s && (i += i);
          while (s);
          return h;
        }
        function Kt(i, s) {
          return Jf(dm(i, s, An), i + "");
        }
        function IE(i) {
          return _g(wa(i));
        }
        function jE(i, s) {
          var h = wa(i);
          return Lu(h, Pi(s, 0, h.length));
        }
        function _o(i, s, h, _) {
          if (!we(i))
            return i;
          s = ai(s, i);
          for (var D = -1, I = s.length, $ = I - 1, q = i; q != null && ++D < I; ) {
            var J = pr(s[D]), ut = h;
            if (J === "__proto__" || J === "constructor" || J === "prototype")
              return i;
            if (D != $) {
              var ct = q[J];
              ut = _ ? _(ct, J, q) : n, ut === n && (ut = we(ct) ? ct : jr(s[D + 1]) ? [] : {});
            }
            mo(q, J, ut), q = q[J];
          }
          return i;
        }
        var Bg = mu ? function(i, s) {
          return mu.set(i, s), i;
        } : An, kE = du ? function(i, s) {
          return du(i, "toString", {
            configurable: !0,
            enumerable: !1,
            value: ch(s),
            writable: !0
          });
        } : An;
        function BE(i) {
          return Lu(wa(i));
        }
        function Gn(i, s, h) {
          var _ = -1, D = i.length;
          s < 0 && (s = -s > D ? 0 : D + s), h = h > D ? D : h, h < 0 && (h += D), D = s > h ? 0 : h - s >>> 0, s >>>= 0;
          for (var I = rt(D); ++_ < D; )
            I[_] = i[_ + s];
          return I;
        }
        function FE(i, s) {
          var h;
          return ri(i, function(_, D, I) {
            return h = s(_, D, I), !h;
          }), !!h;
        }
        function Eu(i, s, h) {
          var _ = 0, D = i == null ? _ : i.length;
          if (typeof s == "number" && s === s && D <= et) {
            for (; _ < D; ) {
              var I = _ + D >>> 1, $ = i[I];
              $ !== null && !Ln($) && (h ? $ <= s : $ < s) ? _ = I + 1 : D = I;
            }
            return D;
          }
          return kf(i, s, An, h);
        }
        function kf(i, s, h, _) {
          var D = 0, I = i == null ? 0 : i.length;
          if (I === 0)
            return 0;
          s = h(s);
          for (var $ = s !== s, q = s === null, J = Ln(s), ut = s === n; D < I; ) {
            var ct = gu((D + I) / 2), ft = h(i[ct]), vt = ft !== n, Rt = ft === null, jt = ft === ft, Xt = Ln(ft);
            if ($)
              var kt = _ || jt;
            else ut ? kt = jt && (_ || vt) : q ? kt = jt && vt && (_ || !Rt) : J ? kt = jt && vt && !Rt && (_ || !Xt) : Rt || Xt ? kt = !1 : kt = _ ? ft <= s : ft < s;
            kt ? D = ct + 1 : I = ct;
          }
          return tn(I, tt);
        }
        function Fg(i, s) {
          for (var h = -1, _ = i.length, D = 0, I = []; ++h < _; ) {
            var $ = i[h], q = s ? s($) : $;
            if (!h || !rr(q, J)) {
              var J = q;
              I[D++] = $ === 0 ? 0 : $;
            }
          }
          return I;
        }
        function Ug(i) {
          return typeof i == "number" ? i : Ln(i) ? j : +i;
        }
        function On(i) {
          if (typeof i == "string")
            return i;
          if (Wt(i))
            return be(i, On) + "";
          if (Ln(i))
            return vg ? vg.call(i) : "";
          var s = i + "";
          return s == "0" && 1 / i == -H ? "-0" : s;
        }
        function ii(i, s, h) {
          var _ = -1, D = nu, I = i.length, $ = !0, q = [], J = q;
          if (h)
            $ = !1, D = hf;
          else if (I >= a) {
            var ut = s ? null : QE(i);
            if (ut)
              return iu(ut);
            $ = !1, D = co, J = new Li();
          } else
            J = s ? [] : q;
          t:
            for (; ++_ < I; ) {
              var ct = i[_], ft = s ? s(ct) : ct;
              if (ct = h || ct !== 0 ? ct : 0, $ && ft === ft) {
                for (var vt = J.length; vt--; )
                  if (J[vt] === ft)
                    continue t;
                s && J.push(ft), q.push(ct);
              } else D(J, ft, h) || (J !== q && J.push(ft), q.push(ct));
            }
          return q;
        }
        function Bf(i, s) {
          return s = ai(s, i), i = pm(i, s), i == null || delete i[pr(qn(s))];
        }
        function $g(i, s, h, _) {
          return _o(i, s, h(Ni(i, s)), _);
        }
        function Su(i, s, h, _) {
          for (var D = i.length, I = _ ? D : -1; (_ ? I-- : ++I < D) && s(i[I], I, i); )
            ;
          return h ? Gn(i, _ ? 0 : I, _ ? I + 1 : D) : Gn(i, _ ? I + 1 : 0, _ ? D : I);
        }
        function zg(i, s) {
          var h = i;
          return h instanceof ee && (h = h.value()), df(s, function(_, D) {
            return D.func.apply(D.thisArg, ti([_], D.args));
          }, h);
        }
        function Ff(i, s, h) {
          var _ = i.length;
          if (_ < 2)
            return _ ? ii(i[0]) : [];
          for (var D = -1, I = rt(_); ++D < _; )
            for (var $ = i[D], q = -1; ++q < _; )
              q != D && (I[D] = yo(I[D] || $, i[q], s, h));
          return ii(qe(I, 1), s, h);
        }
        function Vg(i, s, h) {
          for (var _ = -1, D = i.length, I = s.length, $ = {}; ++_ < D; ) {
            var q = _ < I ? s[_] : n;
            h($, i[_], q);
          }
          return $;
        }
        function Uf(i) {
          return Me(i) ? i : [];
        }
        function $f(i) {
          return typeof i == "function" ? i : An;
        }
        function ai(i, s) {
          return Wt(i) ? i : Qf(i, s) ? [i] : vm(le(i));
        }
        var UE = Kt;
        function oi(i, s, h) {
          var _ = i.length;
          return h = h === n ? _ : h, !s && h >= _ ? i : Gn(i, s, h);
        }
        var Yg = Cw || function(i) {
          return Ge.clearTimeout(i);
        };
        function Wg(i, s) {
          if (s)
            return i.slice();
          var h = i.length, _ = hg ? hg(h) : new i.constructor(h);
          return i.copy(_), _;
        }
        function zf(i) {
          var s = new i.constructor(i.byteLength);
          return new lu(s).set(new lu(i)), s;
        }
        function $E(i, s) {
          var h = s ? zf(i.buffer) : i.buffer;
          return new i.constructor(h, i.byteOffset, i.byteLength);
        }
        function zE(i) {
          var s = new i.constructor(i.source, R0.exec(i));
          return s.lastIndex = i.lastIndex, s;
        }
        function VE(i) {
          return go ? ge(go.call(i)) : {};
        }
        function Gg(i, s) {
          var h = s ? zf(i.buffer) : i.buffer;
          return new i.constructor(h, i.byteOffset, i.length);
        }
        function qg(i, s) {
          if (i !== s) {
            var h = i !== n, _ = i === null, D = i === i, I = Ln(i), $ = s !== n, q = s === null, J = s === s, ut = Ln(s);
            if (!q && !ut && !I && i > s || I && $ && J && !q && !ut || _ && $ && J || !h && J || !D)
              return 1;
            if (!_ && !I && !ut && i < s || ut && h && D && !_ && !I || q && h && D || !$ && D || !J)
              return -1;
          }
          return 0;
        }
        function YE(i, s, h) {
          for (var _ = -1, D = i.criteria, I = s.criteria, $ = D.length, q = h.length; ++_ < $; ) {
            var J = qg(D[_], I[_]);
            if (J) {
              if (_ >= q)
                return J;
              var ut = h[_];
              return J * (ut == "desc" ? -1 : 1);
            }
          }
          return i.index - s.index;
        }
        function Hg(i, s, h, _) {
          for (var D = -1, I = i.length, $ = h.length, q = -1, J = s.length, ut = Fe(I - $, 0), ct = rt(J + ut), ft = !_; ++q < J; )
            ct[q] = s[q];
          for (; ++D < $; )
            (ft || D < I) && (ct[h[D]] = i[D]);
          for (; ut--; )
            ct[q++] = i[D++];
          return ct;
        }
        function Xg(i, s, h, _) {
          for (var D = -1, I = i.length, $ = -1, q = h.length, J = -1, ut = s.length, ct = Fe(I - q, 0), ft = rt(ct + ut), vt = !_; ++D < ct; )
            ft[D] = i[D];
          for (var Rt = D; ++J < ut; )
            ft[Rt + J] = s[J];
          for (; ++$ < q; )
            (vt || D < I) && (ft[Rt + h[$]] = i[D++]);
          return ft;
        }
        function wn(i, s) {
          var h = -1, _ = i.length;
          for (s || (s = rt(_)); ++h < _; )
            s[h] = i[h];
          return s;
        }
        function dr(i, s, h, _) {
          var D = !h;
          h || (h = {});
          for (var I = -1, $ = s.length; ++I < $; ) {
            var q = s[I], J = _ ? _(h[q], i[q], q, h, i) : n;
            J === n && (J = i[q]), D ? Pr(h, q, J) : mo(h, q, J);
          }
          return h;
        }
        function WE(i, s) {
          return dr(i, Xf(i), s);
        }
        function GE(i, s) {
          return dr(i, um(i), s);
        }
        function Au(i, s) {
          return function(h, _) {
            var D = Wt(h) ? K2 : pE, I = s ? s() : {};
            return D(h, i, Nt(_, 2), I);
          };
        }
        function va(i) {
          return Kt(function(s, h) {
            var _ = -1, D = h.length, I = D > 1 ? h[D - 1] : n, $ = D > 2 ? h[2] : n;
            for (I = i.length > 3 && typeof I == "function" ? (D--, I) : n, $ && ln(h[0], h[1], $) && (I = D < 3 ? n : I, D = 1), s = ge(s); ++_ < D; ) {
              var q = h[_];
              q && i(s, q, _, I);
            }
            return s;
          });
        }
        function Qg(i, s) {
          return function(h, _) {
            if (h == null)
              return h;
            if (!En(h))
              return i(h, _);
            for (var D = h.length, I = s ? D : -1, $ = ge(h); (s ? I-- : ++I < D) && _($[I], I, $) !== !1; )
              ;
            return h;
          };
        }
        function Kg(i) {
          return function(s, h, _) {
            for (var D = -1, I = ge(s), $ = _(s), q = $.length; q--; ) {
              var J = $[i ? q : ++D];
              if (h(I[J], J, I) === !1)
                break;
            }
            return s;
          };
        }
        function qE(i, s, h) {
          var _ = s & S, D = bo(i);
          function I() {
            var $ = this && this !== Ge && this instanceof I ? D : i;
            return $.apply(_ ? h : this, arguments);
          }
          return I;
        }
        function Zg(i) {
          return function(s) {
            s = le(s);
            var h = fa(s) ? er(s) : n, _ = h ? h[0] : s.charAt(0), D = h ? oi(h, 1).join("") : s.slice(1);
            return _[i]() + D;
          };
        }
        function xa(i) {
          return function(s) {
            return df(Qm(Xm(s).replace(k2, "")), i, "");
          };
        }
        function bo(i) {
          return function() {
            var s = arguments;
            switch (s.length) {
              case 0:
                return new i();
              case 1:
                return new i(s[0]);
              case 2:
                return new i(s[0], s[1]);
              case 3:
                return new i(s[0], s[1], s[2]);
              case 4:
                return new i(s[0], s[1], s[2], s[3]);
              case 5:
                return new i(s[0], s[1], s[2], s[3], s[4]);
              case 6:
                return new i(s[0], s[1], s[2], s[3], s[4], s[5]);
              case 7:
                return new i(s[0], s[1], s[2], s[3], s[4], s[5], s[6]);
            }
            var h = ya(i.prototype), _ = i.apply(h, s);
            return we(_) ? _ : h;
          };
        }
        function HE(i, s, h) {
          var _ = bo(i);
          function D() {
            for (var I = arguments.length, $ = rt(I), q = I, J = _a(D); q--; )
              $[q] = arguments[q];
            var ut = I < 3 && $[0] !== J && $[I - 1] !== J ? [] : ei($, J);
            if (I -= ut.length, I < h)
              return rm(
                i,
                s,
                Tu,
                D.placeholder,
                n,
                $,
                ut,
                n,
                n,
                h - I
              );
            var ct = this && this !== Ge && this instanceof D ? _ : i;
            return Dn(ct, this, $);
          }
          return D;
        }
        function Jg(i) {
          return function(s, h, _) {
            var D = ge(s);
            if (!En(s)) {
              var I = Nt(h, 3);
              s = Ye(s), h = function(q) {
                return I(D[q], q, D);
              };
            }
            var $ = i(s, h, _);
            return $ > -1 ? D[I ? s[$] : $] : n;
          };
        }
        function tm(i) {
          return Ir(function(s) {
            var h = s.length, _ = h, D = Yn.prototype.thru;
            for (i && s.reverse(); _--; ) {
              var I = s[_];
              if (typeof I != "function")
                throw new Vn(u);
              if (D && !$ && Mu(I) == "wrapper")
                var $ = new Yn([], !0);
            }
            for (_ = $ ? _ : h; ++_ < h; ) {
              I = s[_];
              var q = Mu(I), J = q == "wrapper" ? qf(I) : n;
              J && Kf(J[0]) && J[1] == (w | O | x | C) && !J[4].length && J[9] == 1 ? $ = $[Mu(J[0])].apply($, J[3]) : $ = I.length == 1 && Kf(I) ? $[q]() : $.thru(I);
            }
            return function() {
              var ut = arguments, ct = ut[0];
              if ($ && ut.length == 1 && Wt(ct))
                return $.plant(ct).value();
              for (var ft = 0, vt = h ? s[ft].apply(this, ut) : ct; ++ft < h; )
                vt = s[ft].call(this, vt);
              return vt;
            };
          });
        }
        function Tu(i, s, h, _, D, I, $, q, J, ut) {
          var ct = s & w, ft = s & S, vt = s & M, Rt = s & (O | A), jt = s & P, Xt = vt ? n : bo(i);
          function kt() {
            for (var Jt = arguments.length, ie = rt(Jt), Pn = Jt; Pn--; )
              ie[Pn] = arguments[Pn];
            if (Rt)
              var fn = _a(kt), Nn = ow(ie, fn);
            if (_ && (ie = Hg(ie, _, D, Rt)), I && (ie = Xg(ie, I, $, Rt)), Jt -= Nn, Rt && Jt < ut) {
              var Oe = ei(ie, fn);
              return rm(
                i,
                s,
                Tu,
                kt.placeholder,
                h,
                ie,
                Oe,
                q,
                J,
                ut - Jt
              );
            }
            var ir = ft ? h : this, Fr = vt ? ir[i] : i;
            return Jt = ie.length, q ? ie = pS(ie, q) : jt && Jt > 1 && ie.reverse(), ct && J < Jt && (ie.length = J), this && this !== Ge && this instanceof kt && (Fr = Xt || bo(Fr)), Fr.apply(ir, ie);
          }
          return kt;
        }
        function em(i, s) {
          return function(h, _) {
            return wE(h, i, s(_), {});
          };
        }
        function Cu(i, s) {
          return function(h, _) {
            var D;
            if (h === n && _ === n)
              return s;
            if (h !== n && (D = h), _ !== n) {
              if (D === n)
                return _;
              typeof h == "string" || typeof _ == "string" ? (h = On(h), _ = On(_)) : (h = Ug(h), _ = Ug(_)), D = i(h, _);
            }
            return D;
          };
        }
        function Vf(i) {
          return Ir(function(s) {
            return s = be(s, Mn(Nt())), Kt(function(h) {
              var _ = this;
              return i(s, function(D) {
                return Dn(D, _, h);
              });
            });
          });
        }
        function Ru(i, s) {
          s = s === n ? " " : On(s);
          var h = s.length;
          if (h < 2)
            return h ? jf(s, i) : s;
          var _ = jf(s, pu(i / ha(s)));
          return fa(s) ? oi(er(_), 0, i).join("") : _.slice(0, i);
        }
        function XE(i, s, h, _) {
          var D = s & S, I = bo(i);
          function $() {
            for (var q = -1, J = arguments.length, ut = -1, ct = _.length, ft = rt(ct + J), vt = this && this !== Ge && this instanceof $ ? I : i; ++ut < ct; )
              ft[ut] = _[ut];
            for (; J--; )
              ft[ut++] = arguments[++q];
            return Dn(vt, D ? h : this, ft);
          }
          return $;
        }
        function nm(i) {
          return function(s, h, _) {
            return _ && typeof _ != "number" && ln(s, h, _) && (h = _ = n), s = Br(s), h === n ? (h = s, s = 0) : h = Br(h), _ = _ === n ? s < h ? 1 : -1 : Br(_), NE(s, h, _, i);
          };
        }
        function Du(i) {
          return function(s, h) {
            return typeof s == "string" && typeof h == "string" || (s = Hn(s), h = Hn(h)), i(s, h);
          };
        }
        function rm(i, s, h, _, D, I, $, q, J, ut) {
          var ct = s & O, ft = ct ? $ : n, vt = ct ? n : $, Rt = ct ? I : n, jt = ct ? n : I;
          s |= ct ? x : v, s &= ~(ct ? v : x), s & N || (s &= -4);
          var Xt = [
            i,
            s,
            D,
            Rt,
            ft,
            jt,
            vt,
            q,
            J,
            ut
          ], kt = h.apply(n, Xt);
          return Kf(i) && gm(kt, Xt), kt.placeholder = _, mm(kt, i, s);
        }
        function Yf(i) {
          var s = Be[i];
          return function(h, _) {
            if (h = Hn(h), _ = _ == null ? 0 : tn(qt(_), 292), _ && mg(h)) {
              var D = (le(h) + "e").split("e"), I = s(D[0] + "e" + (+D[1] + _));
              return D = (le(I) + "e").split("e"), +(D[0] + "e" + (+D[1] - _));
            }
            return s(h);
          };
        }
        var QE = ga && 1 / iu(new ga([, -0]))[1] == H ? function(i) {
          return new ga(i);
        } : hh;
        function im(i) {
          return function(s) {
            var h = en(s);
            return h == xt ? _f(s) : h == yt ? dw(s) : aw(s, i(s));
          };
        }
        function Nr(i, s, h, _, D, I, $, q) {
          var J = s & M;
          if (!J && typeof i != "function")
            throw new Vn(u);
          var ut = _ ? _.length : 0;
          if (ut || (s &= -97, _ = D = n), $ = $ === n ? $ : Fe(qt($), 0), q = q === n ? q : qt(q), ut -= D ? D.length : 0, s & v) {
            var ct = _, ft = D;
            _ = D = n;
          }
          var vt = J ? n : qf(i), Rt = [
            i,
            s,
            h,
            _,
            D,
            ct,
            ft,
            I,
            $,
            q
          ];
          if (vt && fS(Rt, vt), i = Rt[0], s = Rt[1], h = Rt[2], _ = Rt[3], D = Rt[4], q = Rt[9] = Rt[9] === n ? J ? 0 : i.length : Fe(Rt[9] - ut, 0), !q && s & (O | A) && (s &= -25), !s || s == S)
            var jt = qE(i, s, h);
          else s == O || s == A ? jt = HE(i, s, q) : (s == x || s == (S | x)) && !D.length ? jt = XE(i, s, h, _) : jt = Tu.apply(n, Rt);
          var Xt = vt ? Bg : gm;
          return mm(Xt(jt, Rt), i, s);
        }
        function am(i, s, h, _) {
          return i === n || rr(i, pa[h]) && !fe.call(_, h) ? s : i;
        }
        function om(i, s, h, _, D, I) {
          return we(i) && we(s) && (I.set(s, i), wu(i, s, n, om, I), I.delete(s)), i;
        }
        function KE(i) {
          return So(i) ? n : i;
        }
        function sm(i, s, h, _, D, I) {
          var $ = h & b, q = i.length, J = s.length;
          if (q != J && !($ && J > q))
            return !1;
          var ut = I.get(i), ct = I.get(s);
          if (ut && ct)
            return ut == s && ct == i;
          var ft = -1, vt = !0, Rt = h & E ? new Li() : n;
          for (I.set(i, s), I.set(s, i); ++ft < q; ) {
            var jt = i[ft], Xt = s[ft];
            if (_)
              var kt = $ ? _(Xt, jt, ft, s, i, I) : _(jt, Xt, ft, i, s, I);
            if (kt !== n) {
              if (kt)
                continue;
              vt = !1;
              break;
            }
            if (Rt) {
              if (!pf(s, function(Jt, ie) {
                if (!co(Rt, ie) && (jt === Jt || D(jt, Jt, h, _, I)))
                  return Rt.push(ie);
              })) {
                vt = !1;
                break;
              }
            } else if (!(jt === Xt || D(jt, Xt, h, _, I))) {
              vt = !1;
              break;
            }
          }
          return I.delete(i), I.delete(s), vt;
        }
        function ZE(i, s, h, _, D, I, $) {
          switch (h) {
            case ke:
              if (i.byteLength != s.byteLength || i.byteOffset != s.byteOffset)
                return !1;
              i = i.buffer, s = s.buffer;
            case Re:
              return !(i.byteLength != s.byteLength || !I(new lu(i), new lu(s)));
            case nt:
            case it:
            case gt:
              return rr(+i, +s);
            case ht:
              return i.name == s.name && i.message == s.message;
            case _t:
            case bt:
              return i == s + "";
            case xt:
              var q = _f;
            case yt:
              var J = _ & b;
              if (q || (q = iu), i.size != s.size && !J)
                return !1;
              var ut = $.get(i);
              if (ut)
                return ut == s;
              _ |= E, $.set(i, s);
              var ct = sm(q(i), q(s), _, D, I, $);
              return $.delete(i), ct;
            case Ct:
              if (go)
                return go.call(i) == go.call(s);
          }
          return !1;
        }
        function JE(i, s, h, _, D, I) {
          var $ = h & b, q = Wf(i), J = q.length, ut = Wf(s), ct = ut.length;
          if (J != ct && !$)
            return !1;
          for (var ft = J; ft--; ) {
            var vt = q[ft];
            if (!($ ? vt in s : fe.call(s, vt)))
              return !1;
          }
          var Rt = I.get(i), jt = I.get(s);
          if (Rt && jt)
            return Rt == s && jt == i;
          var Xt = !0;
          I.set(i, s), I.set(s, i);
          for (var kt = $; ++ft < J; ) {
            vt = q[ft];
            var Jt = i[vt], ie = s[vt];
            if (_)
              var Pn = $ ? _(ie, Jt, vt, s, i, I) : _(Jt, ie, vt, i, s, I);
            if (!(Pn === n ? Jt === ie || D(Jt, ie, h, _, I) : Pn)) {
              Xt = !1;
              break;
            }
            kt || (kt = vt == "constructor");
          }
          if (Xt && !kt) {
            var fn = i.constructor, Nn = s.constructor;
            fn != Nn && "constructor" in i && "constructor" in s && !(typeof fn == "function" && fn instanceof fn && typeof Nn == "function" && Nn instanceof Nn) && (Xt = !1);
          }
          return I.delete(i), I.delete(s), Xt;
        }
        function Ir(i) {
          return Jf(dm(i, n, wm), i + "");
        }
        function Wf(i) {
          return Cg(i, Ye, Xf);
        }
        function Gf(i) {
          return Cg(i, Sn, um);
        }
        var qf = mu ? function(i) {
          return mu.get(i);
        } : hh;
        function Mu(i) {
          for (var s = i.name + "", h = ma[s], _ = fe.call(ma, s) ? h.length : 0; _--; ) {
            var D = h[_], I = D.func;
            if (I == null || I == i)
              return D.name;
          }
          return s;
        }
        function _a(i) {
          var s = fe.call(L, "placeholder") ? L : i;
          return s.placeholder;
        }
        function Nt() {
          var i = L.iteratee || lh;
          return i = i === lh ? Mg : i, arguments.length ? i(arguments[0], arguments[1]) : i;
        }
        function Ou(i, s) {
          var h = i.__data__;
          return sS(s) ? h[typeof s == "string" ? "string" : "hash"] : h.map;
        }
        function Hf(i) {
          for (var s = Ye(i), h = s.length; h--; ) {
            var _ = s[h], D = i[_];
            s[h] = [_, D, fm(D)];
          }
          return s;
        }
        function Ii(i, s) {
          var h = lw(i, s);
          return Dg(h) ? h : n;
        }
        function tS(i) {
          var s = fe.call(i, Mi), h = i[Mi];
          try {
            i[Mi] = n;
            var _ = !0;
          } catch {
          }
          var D = uu.call(i);
          return _ && (s ? i[Mi] = h : delete i[Mi]), D;
        }
        var Xf = wf ? function(i) {
          return i == null ? [] : (i = ge(i), Jr(wf(i), function(s) {
            return pg.call(i, s);
          }));
        } : dh, um = wf ? function(i) {
          for (var s = []; i; )
            ti(s, Xf(i)), i = fu(i);
          return s;
        } : dh, en = cn;
        (Ef && en(new Ef(new ArrayBuffer(1))) != ke || fo && en(new fo()) != xt || Sf && en(Sf.resolve()) != Ht || ga && en(new ga()) != yt || ho && en(new ho()) != se) && (en = function(i) {
          var s = cn(i), h = s == Tt ? i.constructor : n, _ = h ? ji(h) : "";
          if (_)
            switch (_) {
              case jw:
                return ke;
              case kw:
                return xt;
              case Bw:
                return Ht;
              case Fw:
                return yt;
              case Uw:
                return se;
            }
          return s;
        });
        function eS(i, s, h) {
          for (var _ = -1, D = h.length; ++_ < D; ) {
            var I = h[_], $ = I.size;
            switch (I.type) {
              case "drop":
                i += $;
                break;
              case "dropRight":
                s -= $;
                break;
              case "take":
                s = tn(s, i + $);
                break;
              case "takeRight":
                i = Fe(i, s - $);
                break;
            }
          }
          return { start: i, end: s };
        }
        function nS(i) {
          var s = i.match(u2);
          return s ? s[1].split(c2) : [];
        }
        function cm(i, s, h) {
          s = ai(s, i);
          for (var _ = -1, D = s.length, I = !1; ++_ < D; ) {
            var $ = pr(s[_]);
            if (!(I = i != null && h(i, $)))
              break;
            i = i[$];
          }
          return I || ++_ != D ? I : (D = i == null ? 0 : i.length, !!D && Bu(D) && jr($, D) && (Wt(i) || ki(i)));
        }
        function rS(i) {
          var s = i.length, h = new i.constructor(s);
          return s && typeof i[0] == "string" && fe.call(i, "index") && (h.index = i.index, h.input = i.input), h;
        }
        function lm(i) {
          return typeof i.constructor == "function" && !wo(i) ? ya(fu(i)) : {};
        }
        function iS(i, s, h) {
          var _ = i.constructor;
          switch (s) {
            case Re:
              return zf(i);
            case nt:
            case it:
              return new _(+i);
            case ke:
              return $E(i, h);
            case ye:
            case oe:
            case Se:
            case Dr:
            case Zr:
            case $t:
            case Ft:
            case re:
            case pe:
              return Gg(i, h);
            case xt:
              return new _();
            case gt:
            case bt:
              return new _(i);
            case _t:
              return zE(i);
            case yt:
              return new _();
            case Ct:
              return VE(i);
          }
        }
        function aS(i, s) {
          var h = s.length;
          if (!h)
            return i;
          var _ = h - 1;
          return s[_] = (h > 1 ? "& " : "") + s[_], s = s.join(h > 2 ? ", " : " "), i.replace(s2, `{
/* [wrapped with ` + s + `] */
`);
        }
        function oS(i) {
          return Wt(i) || ki(i) || !!(gg && i && i[gg]);
        }
        function jr(i, s) {
          var h = typeof i;
          return s = s ?? W, !!s && (h == "number" || h != "symbol" && v2.test(i)) && i > -1 && i % 1 == 0 && i < s;
        }
        function ln(i, s, h) {
          if (!we(h))
            return !1;
          var _ = typeof s;
          return (_ == "number" ? En(h) && jr(s, h.length) : _ == "string" && s in h) ? rr(h[s], i) : !1;
        }
        function Qf(i, s) {
          if (Wt(i))
            return !1;
          var h = typeof i;
          return h == "number" || h == "symbol" || h == "boolean" || i == null || Ln(i) ? !0 : ua.test(i) || !ef.test(i) || s != null && i in ge(s);
        }
        function sS(i) {
          var s = typeof i;
          return s == "string" || s == "number" || s == "symbol" || s == "boolean" ? i !== "__proto__" : i === null;
        }
        function Kf(i) {
          var s = Mu(i), h = L[s];
          if (typeof h != "function" || !(s in ee.prototype))
            return !1;
          if (i === h)
            return !0;
          var _ = qf(h);
          return !!_ && i === _[0];
        }
        function uS(i) {
          return !!fg && fg in i;
        }
        var cS = ou ? kr : ph;
        function wo(i) {
          var s = i && i.constructor, h = typeof s == "function" && s.prototype || pa;
          return i === h;
        }
        function fm(i) {
          return i === i && !we(i);
        }
        function hm(i, s) {
          return function(h) {
            return h == null ? !1 : h[i] === s && (s !== n || i in ge(h));
          };
        }
        function lS(i) {
          var s = ju(i, function(_) {
            return h.size === d && h.clear(), _;
          }), h = s.cache;
          return s;
        }
        function fS(i, s) {
          var h = i[1], _ = s[1], D = h | _, I = D < (S | M | w), $ = _ == w && h == O || _ == w && h == C && i[7].length <= s[8] || _ == (w | C) && s[7].length <= s[8] && h == O;
          if (!(I || $))
            return i;
          _ & S && (i[2] = s[2], D |= h & S ? 0 : N);
          var q = s[3];
          if (q) {
            var J = i[3];
            i[3] = J ? Hg(J, q, s[4]) : q, i[4] = J ? ei(i[3], g) : s[4];
          }
          return q = s[5], q && (J = i[5], i[5] = J ? Xg(J, q, s[6]) : q, i[6] = J ? ei(i[5], g) : s[6]), q = s[7], q && (i[7] = q), _ & w && (i[8] = i[8] == null ? s[8] : tn(i[8], s[8])), i[9] == null && (i[9] = s[9]), i[0] = s[0], i[1] = D, i;
        }
        function hS(i) {
          var s = [];
          if (i != null)
            for (var h in ge(i))
              s.push(h);
          return s;
        }
        function dS(i) {
          return uu.call(i);
        }
        function dm(i, s, h) {
          return s = Fe(s === n ? i.length - 1 : s, 0), function() {
            for (var _ = arguments, D = -1, I = Fe(_.length - s, 0), $ = rt(I); ++D < I; )
              $[D] = _[s + D];
            D = -1;
            for (var q = rt(s + 1); ++D < s; )
              q[D] = _[D];
            return q[s] = h($), Dn(i, this, q);
          };
        }
        function pm(i, s) {
          return s.length < 2 ? i : Ni(i, Gn(s, 0, -1));
        }
        function pS(i, s) {
          for (var h = i.length, _ = tn(s.length, h), D = wn(i); _--; ) {
            var I = s[_];
            i[_] = jr(I, h) ? D[I] : n;
          }
          return i;
        }
        function Zf(i, s) {
          if (!(s === "constructor" && typeof i[s] == "function") && s != "__proto__")
            return i[s];
        }
        var gm = ym(Bg), Eo = Dw || function(i, s) {
          return Ge.setTimeout(i, s);
        }, Jf = ym(kE);
        function mm(i, s, h) {
          var _ = s + "";
          return Jf(i, aS(_, gS(nS(_), h)));
        }
        function ym(i) {
          var s = 0, h = 0;
          return function() {
            var _ = Pw(), D = T - (_ - h);
            if (h = _, D > 0) {
              if (++s >= k)
                return arguments[0];
            } else
              s = 0;
            return i.apply(n, arguments);
          };
        }
        function Lu(i, s) {
          var h = -1, _ = i.length, D = _ - 1;
          for (s = s === n ? _ : s; ++h < s; ) {
            var I = If(h, D), $ = i[I];
            i[I] = i[h], i[h] = $;
          }
          return i.length = s, i;
        }
        var vm = lS(function(i) {
          var s = [];
          return i.charCodeAt(0) === 46 && s.push(""), i.replace(nf, function(h, _, D, I) {
            s.push(D ? I.replace(h2, "$1") : _ || h);
          }), s;
        });
        function pr(i) {
          if (typeof i == "string" || Ln(i))
            return i;
          var s = i + "";
          return s == "0" && 1 / i == -H ? "-0" : s;
        }
        function ji(i) {
          if (i != null) {
            try {
              return su.call(i);
            } catch {
            }
            try {
              return i + "";
            } catch {
            }
          }
          return "";
        }
        function gS(i, s) {
          return zn(ot, function(h) {
            var _ = "_." + h[0];
            s & h[1] && !nu(i, _) && i.push(_);
          }), i.sort();
        }
        function xm(i) {
          if (i instanceof ee)
            return i.clone();
          var s = new Yn(i.__wrapped__, i.__chain__);
          return s.__actions__ = wn(i.__actions__), s.__index__ = i.__index__, s.__values__ = i.__values__, s;
        }
        function mS(i, s, h) {
          (h ? ln(i, s, h) : s === n) ? s = 1 : s = Fe(qt(s), 0);
          var _ = i == null ? 0 : i.length;
          if (!_ || s < 1)
            return [];
          for (var D = 0, I = 0, $ = rt(pu(_ / s)); D < _; )
            $[I++] = Gn(i, D, D += s);
          return $;
        }
        function yS(i) {
          for (var s = -1, h = i == null ? 0 : i.length, _ = 0, D = []; ++s < h; ) {
            var I = i[s];
            I && (D[_++] = I);
          }
          return D;
        }
        function vS() {
          var i = arguments.length;
          if (!i)
            return [];
          for (var s = rt(i - 1), h = arguments[0], _ = i; _--; )
            s[_ - 1] = arguments[_];
          return ti(Wt(h) ? wn(h) : [h], qe(s, 1));
        }
        var xS = Kt(function(i, s) {
          return Me(i) ? yo(i, qe(s, 1, Me, !0)) : [];
        }), _S = Kt(function(i, s) {
          var h = qn(s);
          return Me(h) && (h = n), Me(i) ? yo(i, qe(s, 1, Me, !0), Nt(h, 2)) : [];
        }), bS = Kt(function(i, s) {
          var h = qn(s);
          return Me(h) && (h = n), Me(i) ? yo(i, qe(s, 1, Me, !0), n, h) : [];
        });
        function wS(i, s, h) {
          var _ = i == null ? 0 : i.length;
          return _ ? (s = h || s === n ? 1 : qt(s), Gn(i, s < 0 ? 0 : s, _)) : [];
        }
        function ES(i, s, h) {
          var _ = i == null ? 0 : i.length;
          return _ ? (s = h || s === n ? 1 : qt(s), s = _ - s, Gn(i, 0, s < 0 ? 0 : s)) : [];
        }
        function SS(i, s) {
          return i && i.length ? Su(i, Nt(s, 3), !0, !0) : [];
        }
        function AS(i, s) {
          return i && i.length ? Su(i, Nt(s, 3), !0) : [];
        }
        function TS(i, s, h, _) {
          var D = i == null ? 0 : i.length;
          return D ? (h && typeof h != "number" && ln(i, s, h) && (h = 0, _ = D), vE(i, s, h, _)) : [];
        }
        function _m(i, s, h) {
          var _ = i == null ? 0 : i.length;
          if (!_)
            return -1;
          var D = h == null ? 0 : qt(h);
          return D < 0 && (D = Fe(_ + D, 0)), ru(i, Nt(s, 3), D);
        }
        function bm(i, s, h) {
          var _ = i == null ? 0 : i.length;
          if (!_)
            return -1;
          var D = _ - 1;
          return h !== n && (D = qt(h), D = h < 0 ? Fe(_ + D, 0) : tn(D, _ - 1)), ru(i, Nt(s, 3), D, !0);
        }
        function wm(i) {
          var s = i == null ? 0 : i.length;
          return s ? qe(i, 1) : [];
        }
        function CS(i) {
          var s = i == null ? 0 : i.length;
          return s ? qe(i, H) : [];
        }
        function RS(i, s) {
          var h = i == null ? 0 : i.length;
          return h ? (s = s === n ? 1 : qt(s), qe(i, s)) : [];
        }
        function DS(i) {
          for (var s = -1, h = i == null ? 0 : i.length, _ = {}; ++s < h; ) {
            var D = i[s];
            _[D[0]] = D[1];
          }
          return _;
        }
        function Em(i) {
          return i && i.length ? i[0] : n;
        }
        function MS(i, s, h) {
          var _ = i == null ? 0 : i.length;
          if (!_)
            return -1;
          var D = h == null ? 0 : qt(h);
          return D < 0 && (D = Fe(_ + D, 0)), la(i, s, D);
        }
        function OS(i) {
          var s = i == null ? 0 : i.length;
          return s ? Gn(i, 0, -1) : [];
        }
        var LS = Kt(function(i) {
          var s = be(i, Uf);
          return s.length && s[0] === i[0] ? Mf(s) : [];
        }), PS = Kt(function(i) {
          var s = qn(i), h = be(i, Uf);
          return s === qn(h) ? s = n : h.pop(), h.length && h[0] === i[0] ? Mf(h, Nt(s, 2)) : [];
        }), NS = Kt(function(i) {
          var s = qn(i), h = be(i, Uf);
          return s = typeof s == "function" ? s : n, s && h.pop(), h.length && h[0] === i[0] ? Mf(h, n, s) : [];
        });
        function IS(i, s) {
          return i == null ? "" : Ow.call(i, s);
        }
        function qn(i) {
          var s = i == null ? 0 : i.length;
          return s ? i[s - 1] : n;
        }
        function jS(i, s, h) {
          var _ = i == null ? 0 : i.length;
          if (!_)
            return -1;
          var D = _;
          return h !== n && (D = qt(h), D = D < 0 ? Fe(_ + D, 0) : tn(D, _ - 1)), s === s ? gw(i, s, D) : ru(i, rg, D, !0);
        }
        function kS(i, s) {
          return i && i.length ? Ng(i, qt(s)) : n;
        }
        var BS = Kt(Sm);
        function Sm(i, s) {
          return i && i.length && s && s.length ? Nf(i, s) : i;
        }
        function FS(i, s, h) {
          return i && i.length && s && s.length ? Nf(i, s, Nt(h, 2)) : i;
        }
        function US(i, s, h) {
          return i && i.length && s && s.length ? Nf(i, s, n, h) : i;
        }
        var $S = Ir(function(i, s) {
          var h = i == null ? 0 : i.length, _ = Tf(i, s);
          return kg(i, be(s, function(D) {
            return jr(D, h) ? +D : D;
          }).sort(qg)), _;
        });
        function zS(i, s) {
          var h = [];
          if (!(i && i.length))
            return h;
          var _ = -1, D = [], I = i.length;
          for (s = Nt(s, 3); ++_ < I; ) {
            var $ = i[_];
            s($, _, i) && (h.push($), D.push(_));
          }
          return kg(i, D), h;
        }
        function th(i) {
          return i == null ? i : Iw.call(i);
        }
        function VS(i, s, h) {
          var _ = i == null ? 0 : i.length;
          return _ ? (h && typeof h != "number" && ln(i, s, h) ? (s = 0, h = _) : (s = s == null ? 0 : qt(s), h = h === n ? _ : qt(h)), Gn(i, s, h)) : [];
        }
        function YS(i, s) {
          return Eu(i, s);
        }
        function WS(i, s, h) {
          return kf(i, s, Nt(h, 2));
        }
        function GS(i, s) {
          var h = i == null ? 0 : i.length;
          if (h) {
            var _ = Eu(i, s);
            if (_ < h && rr(i[_], s))
              return _;
          }
          return -1;
        }
        function qS(i, s) {
          return Eu(i, s, !0);
        }
        function HS(i, s, h) {
          return kf(i, s, Nt(h, 2), !0);
        }
        function XS(i, s) {
          var h = i == null ? 0 : i.length;
          if (h) {
            var _ = Eu(i, s, !0) - 1;
            if (rr(i[_], s))
              return _;
          }
          return -1;
        }
        function QS(i) {
          return i && i.length ? Fg(i) : [];
        }
        function KS(i, s) {
          return i && i.length ? Fg(i, Nt(s, 2)) : [];
        }
        function ZS(i) {
          var s = i == null ? 0 : i.length;
          return s ? Gn(i, 1, s) : [];
        }
        function JS(i, s, h) {
          return i && i.length ? (s = h || s === n ? 1 : qt(s), Gn(i, 0, s < 0 ? 0 : s)) : [];
        }
        function tA(i, s, h) {
          var _ = i == null ? 0 : i.length;
          return _ ? (s = h || s === n ? 1 : qt(s), s = _ - s, Gn(i, s < 0 ? 0 : s, _)) : [];
        }
        function eA(i, s) {
          return i && i.length ? Su(i, Nt(s, 3), !1, !0) : [];
        }
        function nA(i, s) {
          return i && i.length ? Su(i, Nt(s, 3)) : [];
        }
        var rA = Kt(function(i) {
          return ii(qe(i, 1, Me, !0));
        }), iA = Kt(function(i) {
          var s = qn(i);
          return Me(s) && (s = n), ii(qe(i, 1, Me, !0), Nt(s, 2));
        }), aA = Kt(function(i) {
          var s = qn(i);
          return s = typeof s == "function" ? s : n, ii(qe(i, 1, Me, !0), n, s);
        });
        function oA(i) {
          return i && i.length ? ii(i) : [];
        }
        function sA(i, s) {
          return i && i.length ? ii(i, Nt(s, 2)) : [];
        }
        function uA(i, s) {
          return s = typeof s == "function" ? s : n, i && i.length ? ii(i, n, s) : [];
        }
        function eh(i) {
          if (!(i && i.length))
            return [];
          var s = 0;
          return i = Jr(i, function(h) {
            if (Me(h))
              return s = Fe(h.length, s), !0;
          }), vf(s, function(h) {
            return be(i, gf(h));
          });
        }
        function Am(i, s) {
          if (!(i && i.length))
            return [];
          var h = eh(i);
          return s == null ? h : be(h, function(_) {
            return Dn(s, n, _);
          });
        }
        var cA = Kt(function(i, s) {
          return Me(i) ? yo(i, s) : [];
        }), lA = Kt(function(i) {
          return Ff(Jr(i, Me));
        }), fA = Kt(function(i) {
          var s = qn(i);
          return Me(s) && (s = n), Ff(Jr(i, Me), Nt(s, 2));
        }), hA = Kt(function(i) {
          var s = qn(i);
          return s = typeof s == "function" ? s : n, Ff(Jr(i, Me), n, s);
        }), dA = Kt(eh);
        function pA(i, s) {
          return Vg(i || [], s || [], mo);
        }
        function gA(i, s) {
          return Vg(i || [], s || [], _o);
        }
        var mA = Kt(function(i) {
          var s = i.length, h = s > 1 ? i[s - 1] : n;
          return h = typeof h == "function" ? (i.pop(), h) : n, Am(i, h);
        });
        function Tm(i) {
          var s = L(i);
          return s.__chain__ = !0, s;
        }
        function yA(i, s) {
          return s(i), i;
        }
        function Pu(i, s) {
          return s(i);
        }
        var vA = Ir(function(i) {
          var s = i.length, h = s ? i[0] : 0, _ = this.__wrapped__, D = function(I) {
            return Tf(I, i);
          };
          return s > 1 || this.__actions__.length || !(_ instanceof ee) || !jr(h) ? this.thru(D) : (_ = _.slice(h, +h + (s ? 1 : 0)), _.__actions__.push({
            func: Pu,
            args: [D],
            thisArg: n
          }), new Yn(_, this.__chain__).thru(function(I) {
            return s && !I.length && I.push(n), I;
          }));
        });
        function xA() {
          return Tm(this);
        }
        function _A() {
          return new Yn(this.value(), this.__chain__);
        }
        function bA() {
          this.__values__ === n && (this.__values__ = Um(this.value()));
          var i = this.__index__ >= this.__values__.length, s = i ? n : this.__values__[this.__index__++];
          return { done: i, value: s };
        }
        function wA() {
          return this;
        }
        function EA(i) {
          for (var s, h = this; h instanceof vu; ) {
            var _ = xm(h);
            _.__index__ = 0, _.__values__ = n, s ? D.__wrapped__ = _ : s = _;
            var D = _;
            h = h.__wrapped__;
          }
          return D.__wrapped__ = i, s;
        }
        function SA() {
          var i = this.__wrapped__;
          if (i instanceof ee) {
            var s = i;
            return this.__actions__.length && (s = new ee(this)), s = s.reverse(), s.__actions__.push({
              func: Pu,
              args: [th],
              thisArg: n
            }), new Yn(s, this.__chain__);
          }
          return this.thru(th);
        }
        function AA() {
          return zg(this.__wrapped__, this.__actions__);
        }
        var TA = Au(function(i, s, h) {
          fe.call(i, h) ? ++i[h] : Pr(i, h, 1);
        });
        function CA(i, s, h) {
          var _ = Wt(i) ? eg : yE;
          return h && ln(i, s, h) && (s = n), _(i, Nt(s, 3));
        }
        function RA(i, s) {
          var h = Wt(i) ? Jr : Ag;
          return h(i, Nt(s, 3));
        }
        var DA = Jg(_m), MA = Jg(bm);
        function OA(i, s) {
          return qe(Nu(i, s), 1);
        }
        function LA(i, s) {
          return qe(Nu(i, s), H);
        }
        function PA(i, s, h) {
          return h = h === n ? 1 : qt(h), qe(Nu(i, s), h);
        }
        function Cm(i, s) {
          var h = Wt(i) ? zn : ri;
          return h(i, Nt(s, 3));
        }
        function Rm(i, s) {
          var h = Wt(i) ? Z2 : Sg;
          return h(i, Nt(s, 3));
        }
        var NA = Au(function(i, s, h) {
          fe.call(i, h) ? i[h].push(s) : Pr(i, h, [s]);
        });
        function IA(i, s, h, _) {
          i = En(i) ? i : wa(i), h = h && !_ ? qt(h) : 0;
          var D = i.length;
          return h < 0 && (h = Fe(D + h, 0)), Fu(i) ? h <= D && i.indexOf(s, h) > -1 : !!D && la(i, s, h) > -1;
        }
        var jA = Kt(function(i, s, h) {
          var _ = -1, D = typeof s == "function", I = En(i) ? rt(i.length) : [];
          return ri(i, function($) {
            I[++_] = D ? Dn(s, $, h) : vo($, s, h);
          }), I;
        }), kA = Au(function(i, s, h) {
          Pr(i, h, s);
        });
        function Nu(i, s) {
          var h = Wt(i) ? be : Og;
          return h(i, Nt(s, 3));
        }
        function BA(i, s, h, _) {
          return i == null ? [] : (Wt(s) || (s = s == null ? [] : [s]), h = _ ? n : h, Wt(h) || (h = h == null ? [] : [h]), Ig(i, s, h));
        }
        var FA = Au(function(i, s, h) {
          i[h ? 0 : 1].push(s);
        }, function() {
          return [[], []];
        });
        function UA(i, s, h) {
          var _ = Wt(i) ? df : ag, D = arguments.length < 3;
          return _(i, Nt(s, 4), h, D, ri);
        }
        function $A(i, s, h) {
          var _ = Wt(i) ? J2 : ag, D = arguments.length < 3;
          return _(i, Nt(s, 4), h, D, Sg);
        }
        function zA(i, s) {
          var h = Wt(i) ? Jr : Ag;
          return h(i, ku(Nt(s, 3)));
        }
        function VA(i) {
          var s = Wt(i) ? _g : IE;
          return s(i);
        }
        function YA(i, s, h) {
          (h ? ln(i, s, h) : s === n) ? s = 1 : s = qt(s);
          var _ = Wt(i) ? hE : jE;
          return _(i, s);
        }
        function WA(i) {
          var s = Wt(i) ? dE : BE;
          return s(i);
        }
        function GA(i) {
          if (i == null)
            return 0;
          if (En(i))
            return Fu(i) ? ha(i) : i.length;
          var s = en(i);
          return s == xt || s == yt ? i.size : Lf(i).length;
        }
        function qA(i, s, h) {
          var _ = Wt(i) ? pf : FE;
          return h && ln(i, s, h) && (s = n), _(i, Nt(s, 3));
        }
        var HA = Kt(function(i, s) {
          if (i == null)
            return [];
          var h = s.length;
          return h > 1 && ln(i, s[0], s[1]) ? s = [] : h > 2 && ln(s[0], s[1], s[2]) && (s = [s[0]]), Ig(i, qe(s, 1), []);
        }), Iu = Rw || function() {
          return Ge.Date.now();
        };
        function XA(i, s) {
          if (typeof s != "function")
            throw new Vn(u);
          return i = qt(i), function() {
            if (--i < 1)
              return s.apply(this, arguments);
          };
        }
        function Dm(i, s, h) {
          return s = h ? n : s, s = i && s == null ? i.length : s, Nr(i, w, n, n, n, n, s);
        }
        function Mm(i, s) {
          var h;
          if (typeof s != "function")
            throw new Vn(u);
          return i = qt(i), function() {
            return --i > 0 && (h = s.apply(this, arguments)), i <= 1 && (s = n), h;
          };
        }
        var nh = Kt(function(i, s, h) {
          var _ = S;
          if (h.length) {
            var D = ei(h, _a(nh));
            _ |= x;
          }
          return Nr(i, _, s, h, D);
        }), Om = Kt(function(i, s, h) {
          var _ = S | M;
          if (h.length) {
            var D = ei(h, _a(Om));
            _ |= x;
          }
          return Nr(s, _, i, h, D);
        });
        function Lm(i, s, h) {
          s = h ? n : s;
          var _ = Nr(i, O, n, n, n, n, n, s);
          return _.placeholder = Lm.placeholder, _;
        }
        function Pm(i, s, h) {
          s = h ? n : s;
          var _ = Nr(i, A, n, n, n, n, n, s);
          return _.placeholder = Pm.placeholder, _;
        }
        function Nm(i, s, h) {
          var _, D, I, $, q, J, ut = 0, ct = !1, ft = !1, vt = !0;
          if (typeof i != "function")
            throw new Vn(u);
          s = Hn(s) || 0, we(h) && (ct = !!h.leading, ft = "maxWait" in h, I = ft ? Fe(Hn(h.maxWait) || 0, s) : I, vt = "trailing" in h ? !!h.trailing : vt);
          function Rt(Oe) {
            var ir = _, Fr = D;
            return _ = D = n, ut = Oe, $ = i.apply(Fr, ir), $;
          }
          function jt(Oe) {
            return ut = Oe, q = Eo(Jt, s), ct ? Rt(Oe) : $;
          }
          function Xt(Oe) {
            var ir = Oe - J, Fr = Oe - ut, Jm = s - ir;
            return ft ? tn(Jm, I - Fr) : Jm;
          }
          function kt(Oe) {
            var ir = Oe - J, Fr = Oe - ut;
            return J === n || ir >= s || ir < 0 || ft && Fr >= I;
          }
          function Jt() {
            var Oe = Iu();
            if (kt(Oe))
              return ie(Oe);
            q = Eo(Jt, Xt(Oe));
          }
          function ie(Oe) {
            return q = n, vt && _ ? Rt(Oe) : (_ = D = n, $);
          }
          function Pn() {
            q !== n && Yg(q), ut = 0, _ = J = D = q = n;
          }
          function fn() {
            return q === n ? $ : ie(Iu());
          }
          function Nn() {
            var Oe = Iu(), ir = kt(Oe);
            if (_ = arguments, D = this, J = Oe, ir) {
              if (q === n)
                return jt(J);
              if (ft)
                return Yg(q), q = Eo(Jt, s), Rt(J);
            }
            return q === n && (q = Eo(Jt, s)), $;
          }
          return Nn.cancel = Pn, Nn.flush = fn, Nn;
        }
        var QA = Kt(function(i, s) {
          return Eg(i, 1, s);
        }), KA = Kt(function(i, s, h) {
          return Eg(i, Hn(s) || 0, h);
        });
        function ZA(i) {
          return Nr(i, P);
        }
        function ju(i, s) {
          if (typeof i != "function" || s != null && typeof s != "function")
            throw new Vn(u);
          var h = function() {
            var _ = arguments, D = s ? s.apply(this, _) : _[0], I = h.cache;
            if (I.has(D))
              return I.get(D);
            var $ = i.apply(this, _);
            return h.cache = I.set(D, $) || I, $;
          };
          return h.cache = new (ju.Cache || Lr)(), h;
        }
        ju.Cache = Lr;
        function ku(i) {
          if (typeof i != "function")
            throw new Vn(u);
          return function() {
            var s = arguments;
            switch (s.length) {
              case 0:
                return !i.call(this);
              case 1:
                return !i.call(this, s[0]);
              case 2:
                return !i.call(this, s[0], s[1]);
              case 3:
                return !i.call(this, s[0], s[1], s[2]);
            }
            return !i.apply(this, s);
          };
        }
        function JA(i) {
          return Mm(2, i);
        }
        var tT = UE(function(i, s) {
          s = s.length == 1 && Wt(s[0]) ? be(s[0], Mn(Nt())) : be(qe(s, 1), Mn(Nt()));
          var h = s.length;
          return Kt(function(_) {
            for (var D = -1, I = tn(_.length, h); ++D < I; )
              _[D] = s[D].call(this, _[D]);
            return Dn(i, this, _);
          });
        }), rh = Kt(function(i, s) {
          var h = ei(s, _a(rh));
          return Nr(i, x, n, s, h);
        }), Im = Kt(function(i, s) {
          var h = ei(s, _a(Im));
          return Nr(i, v, n, s, h);
        }), eT = Ir(function(i, s) {
          return Nr(i, C, n, n, n, s);
        });
        function nT(i, s) {
          if (typeof i != "function")
            throw new Vn(u);
          return s = s === n ? s : qt(s), Kt(i, s);
        }
        function rT(i, s) {
          if (typeof i != "function")
            throw new Vn(u);
          return s = s == null ? 0 : Fe(qt(s), 0), Kt(function(h) {
            var _ = h[s], D = oi(h, 0, s);
            return _ && ti(D, _), Dn(i, this, D);
          });
        }
        function iT(i, s, h) {
          var _ = !0, D = !0;
          if (typeof i != "function")
            throw new Vn(u);
          return we(h) && (_ = "leading" in h ? !!h.leading : _, D = "trailing" in h ? !!h.trailing : D), Nm(i, s, {
            leading: _,
            maxWait: s,
            trailing: D
          });
        }
        function aT(i) {
          return Dm(i, 1);
        }
        function oT(i, s) {
          return rh($f(s), i);
        }
        function sT() {
          if (!arguments.length)
            return [];
          var i = arguments[0];
          return Wt(i) ? i : [i];
        }
        function uT(i) {
          return Wn(i, m);
        }
        function cT(i, s) {
          return s = typeof s == "function" ? s : n, Wn(i, m, s);
        }
        function lT(i) {
          return Wn(i, y | m);
        }
        function fT(i, s) {
          return s = typeof s == "function" ? s : n, Wn(i, y | m, s);
        }
        function hT(i, s) {
          return s == null || wg(i, s, Ye(s));
        }
        function rr(i, s) {
          return i === s || i !== i && s !== s;
        }
        var dT = Du(Df), pT = Du(function(i, s) {
          return i >= s;
        }), ki = Rg(/* @__PURE__ */ function() {
          return arguments;
        }()) ? Rg : function(i) {
          return Ae(i) && fe.call(i, "callee") && !pg.call(i, "callee");
        }, Wt = rt.isArray, gT = X0 ? Mn(X0) : EE;
        function En(i) {
          return i != null && Bu(i.length) && !kr(i);
        }
        function Me(i) {
          return Ae(i) && En(i);
        }
        function mT(i) {
          return i === !0 || i === !1 || Ae(i) && cn(i) == nt;
        }
        var si = Mw || ph, yT = Q0 ? Mn(Q0) : SE;
        function vT(i) {
          return Ae(i) && i.nodeType === 1 && !So(i);
        }
        function xT(i) {
          if (i == null)
            return !0;
          if (En(i) && (Wt(i) || typeof i == "string" || typeof i.splice == "function" || si(i) || ba(i) || ki(i)))
            return !i.length;
          var s = en(i);
          if (s == xt || s == yt)
            return !i.size;
          if (wo(i))
            return !Lf(i).length;
          for (var h in i)
            if (fe.call(i, h))
              return !1;
          return !0;
        }
        function _T(i, s) {
          return xo(i, s);
        }
        function bT(i, s, h) {
          h = typeof h == "function" ? h : n;
          var _ = h ? h(i, s) : n;
          return _ === n ? xo(i, s, n, h) : !!_;
        }
        function ih(i) {
          if (!Ae(i))
            return !1;
          var s = cn(i);
          return s == ht || s == Q || typeof i.message == "string" && typeof i.name == "string" && !So(i);
        }
        function wT(i) {
          return typeof i == "number" && mg(i);
        }
        function kr(i) {
          if (!we(i))
            return !1;
          var s = cn(i);
          return s == pt || s == st || s == z || s == te;
        }
        function jm(i) {
          return typeof i == "number" && i == qt(i);
        }
        function Bu(i) {
          return typeof i == "number" && i > -1 && i % 1 == 0 && i <= W;
        }
        function we(i) {
          var s = typeof i;
          return i != null && (s == "object" || s == "function");
        }
        function Ae(i) {
          return i != null && typeof i == "object";
        }
        var km = K0 ? Mn(K0) : TE;
        function ET(i, s) {
          return i === s || Of(i, s, Hf(s));
        }
        function ST(i, s, h) {
          return h = typeof h == "function" ? h : n, Of(i, s, Hf(s), h);
        }
        function AT(i) {
          return Bm(i) && i != +i;
        }
        function TT(i) {
          if (cS(i))
            throw new zt(o);
          return Dg(i);
        }
        function CT(i) {
          return i === null;
        }
        function RT(i) {
          return i == null;
        }
        function Bm(i) {
          return typeof i == "number" || Ae(i) && cn(i) == gt;
        }
        function So(i) {
          if (!Ae(i) || cn(i) != Tt)
            return !1;
          var s = fu(i);
          if (s === null)
            return !0;
          var h = fe.call(s, "constructor") && s.constructor;
          return typeof h == "function" && h instanceof h && su.call(h) == Sw;
        }
        var ah = Z0 ? Mn(Z0) : CE;
        function DT(i) {
          return jm(i) && i >= -W && i <= W;
        }
        var Fm = J0 ? Mn(J0) : RE;
        function Fu(i) {
          return typeof i == "string" || !Wt(i) && Ae(i) && cn(i) == bt;
        }
        function Ln(i) {
          return typeof i == "symbol" || Ae(i) && cn(i) == Ct;
        }
        var ba = tg ? Mn(tg) : DE;
        function MT(i) {
          return i === n;
        }
        function OT(i) {
          return Ae(i) && en(i) == se;
        }
        function LT(i) {
          return Ae(i) && cn(i) == Gt;
        }
        var PT = Du(Pf), NT = Du(function(i, s) {
          return i <= s;
        });
        function Um(i) {
          if (!i)
            return [];
          if (En(i))
            return Fu(i) ? er(i) : wn(i);
          if (lo && i[lo])
            return hw(i[lo]());
          var s = en(i), h = s == xt ? _f : s == yt ? iu : wa;
          return h(i);
        }
        function Br(i) {
          if (!i)
            return i === 0 ? i : 0;
          if (i = Hn(i), i === H || i === -H) {
            var s = i < 0 ? -1 : 1;
            return s * B;
          }
          return i === i ? i : 0;
        }
        function qt(i) {
          var s = Br(i), h = s % 1;
          return s === s ? h ? s - h : s : 0;
        }
        function $m(i) {
          return i ? Pi(qt(i), 0, X) : 0;
        }
        function Hn(i) {
          if (typeof i == "number")
            return i;
          if (Ln(i))
            return j;
          if (we(i)) {
            var s = typeof i.valueOf == "function" ? i.valueOf() : i;
            i = we(s) ? s + "" : s;
          }
          if (typeof i != "string")
            return i === 0 ? i : +i;
          i = og(i);
          var h = g2.test(i);
          return h || y2.test(i) ? X2(i.slice(2), h ? 2 : 8) : p2.test(i) ? j : +i;
        }
        function zm(i) {
          return dr(i, Sn(i));
        }
        function IT(i) {
          return i ? Pi(qt(i), -W, W) : i === 0 ? i : 0;
        }
        function le(i) {
          return i == null ? "" : On(i);
        }
        var jT = va(function(i, s) {
          if (wo(s) || En(s)) {
            dr(s, Ye(s), i);
            return;
          }
          for (var h in s)
            fe.call(s, h) && mo(i, h, s[h]);
        }), Vm = va(function(i, s) {
          dr(s, Sn(s), i);
        }), Uu = va(function(i, s, h, _) {
          dr(s, Sn(s), i, _);
        }), kT = va(function(i, s, h, _) {
          dr(s, Ye(s), i, _);
        }), BT = Ir(Tf);
        function FT(i, s) {
          var h = ya(i);
          return s == null ? h : bg(h, s);
        }
        var UT = Kt(function(i, s) {
          i = ge(i);
          var h = -1, _ = s.length, D = _ > 2 ? s[2] : n;
          for (D && ln(s[0], s[1], D) && (_ = 1); ++h < _; )
            for (var I = s[h], $ = Sn(I), q = -1, J = $.length; ++q < J; ) {
              var ut = $[q], ct = i[ut];
              (ct === n || rr(ct, pa[ut]) && !fe.call(i, ut)) && (i[ut] = I[ut]);
            }
          return i;
        }), $T = Kt(function(i) {
          return i.push(n, om), Dn(Ym, n, i);
        });
        function zT(i, s) {
          return ng(i, Nt(s, 3), hr);
        }
        function VT(i, s) {
          return ng(i, Nt(s, 3), Rf);
        }
        function YT(i, s) {
          return i == null ? i : Cf(i, Nt(s, 3), Sn);
        }
        function WT(i, s) {
          return i == null ? i : Tg(i, Nt(s, 3), Sn);
        }
        function GT(i, s) {
          return i && hr(i, Nt(s, 3));
        }
        function qT(i, s) {
          return i && Rf(i, Nt(s, 3));
        }
        function HT(i) {
          return i == null ? [] : bu(i, Ye(i));
        }
        function XT(i) {
          return i == null ? [] : bu(i, Sn(i));
        }
        function oh(i, s, h) {
          var _ = i == null ? n : Ni(i, s);
          return _ === n ? h : _;
        }
        function QT(i, s) {
          return i != null && cm(i, s, xE);
        }
        function sh(i, s) {
          return i != null && cm(i, s, _E);
        }
        var KT = em(function(i, s, h) {
          s != null && typeof s.toString != "function" && (s = uu.call(s)), i[s] = h;
        }, ch(An)), ZT = em(function(i, s, h) {
          s != null && typeof s.toString != "function" && (s = uu.call(s)), fe.call(i, s) ? i[s].push(h) : i[s] = [h];
        }, Nt), JT = Kt(vo);
        function Ye(i) {
          return En(i) ? xg(i) : Lf(i);
        }
        function Sn(i) {
          return En(i) ? xg(i, !0) : ME(i);
        }
        function tC(i, s) {
          var h = {};
          return s = Nt(s, 3), hr(i, function(_, D, I) {
            Pr(h, s(_, D, I), _);
          }), h;
        }
        function eC(i, s) {
          var h = {};
          return s = Nt(s, 3), hr(i, function(_, D, I) {
            Pr(h, D, s(_, D, I));
          }), h;
        }
        var nC = va(function(i, s, h) {
          wu(i, s, h);
        }), Ym = va(function(i, s, h, _) {
          wu(i, s, h, _);
        }), rC = Ir(function(i, s) {
          var h = {};
          if (i == null)
            return h;
          var _ = !1;
          s = be(s, function(I) {
            return I = ai(I, i), _ || (_ = I.length > 1), I;
          }), dr(i, Gf(i), h), _ && (h = Wn(h, y | f | m, KE));
          for (var D = s.length; D--; )
            Bf(h, s[D]);
          return h;
        });
        function iC(i, s) {
          return Wm(i, ku(Nt(s)));
        }
        var aC = Ir(function(i, s) {
          return i == null ? {} : LE(i, s);
        });
        function Wm(i, s) {
          if (i == null)
            return {};
          var h = be(Gf(i), function(_) {
            return [_];
          });
          return s = Nt(s), jg(i, h, function(_, D) {
            return s(_, D[0]);
          });
        }
        function oC(i, s, h) {
          s = ai(s, i);
          var _ = -1, D = s.length;
          for (D || (D = 1, i = n); ++_ < D; ) {
            var I = i == null ? n : i[pr(s[_])];
            I === n && (_ = D, I = h), i = kr(I) ? I.call(i) : I;
          }
          return i;
        }
        function sC(i, s, h) {
          return i == null ? i : _o(i, s, h);
        }
        function uC(i, s, h, _) {
          return _ = typeof _ == "function" ? _ : n, i == null ? i : _o(i, s, h, _);
        }
        var Gm = im(Ye), qm = im(Sn);
        function cC(i, s, h) {
          var _ = Wt(i), D = _ || si(i) || ba(i);
          if (s = Nt(s, 4), h == null) {
            var I = i && i.constructor;
            D ? h = _ ? new I() : [] : we(i) ? h = kr(I) ? ya(fu(i)) : {} : h = {};
          }
          return (D ? zn : hr)(i, function($, q, J) {
            return s(h, $, q, J);
          }), h;
        }
        function lC(i, s) {
          return i == null ? !0 : Bf(i, s);
        }
        function fC(i, s, h) {
          return i == null ? i : $g(i, s, $f(h));
        }
        function hC(i, s, h, _) {
          return _ = typeof _ == "function" ? _ : n, i == null ? i : $g(i, s, $f(h), _);
        }
        function wa(i) {
          return i == null ? [] : xf(i, Ye(i));
        }
        function dC(i) {
          return i == null ? [] : xf(i, Sn(i));
        }
        function pC(i, s, h) {
          return h === n && (h = s, s = n), h !== n && (h = Hn(h), h = h === h ? h : 0), s !== n && (s = Hn(s), s = s === s ? s : 0), Pi(Hn(i), s, h);
        }
        function gC(i, s, h) {
          return s = Br(s), h === n ? (h = s, s = 0) : h = Br(h), i = Hn(i), bE(i, s, h);
        }
        function mC(i, s, h) {
          if (h && typeof h != "boolean" && ln(i, s, h) && (s = h = n), h === n && (typeof s == "boolean" ? (h = s, s = n) : typeof i == "boolean" && (h = i, i = n)), i === n && s === n ? (i = 0, s = 1) : (i = Br(i), s === n ? (s = i, i = 0) : s = Br(s)), i > s) {
            var _ = i;
            i = s, s = _;
          }
          if (h || i % 1 || s % 1) {
            var D = yg();
            return tn(i + D * (s - i + H2("1e-" + ((D + "").length - 1))), s);
          }
          return If(i, s);
        }
        var yC = xa(function(i, s, h) {
          return s = s.toLowerCase(), i + (h ? Hm(s) : s);
        });
        function Hm(i) {
          return uh(le(i).toLowerCase());
        }
        function Xm(i) {
          return i = le(i), i && i.replace(x2, sw).replace(B2, "");
        }
        function vC(i, s, h) {
          i = le(i), s = On(s);
          var _ = i.length;
          h = h === n ? _ : Pi(qt(h), 0, _);
          var D = h;
          return h -= s.length, h >= 0 && i.slice(h, D) == s;
        }
        function xC(i) {
          return i = le(i), i && Je.test(i) ? i.replace(bn, uw) : i;
        }
        function _C(i) {
          return i = le(i), i && a2.test(i) ? i.replace(Zs, "\\$&") : i;
        }
        var bC = xa(function(i, s, h) {
          return i + (h ? "-" : "") + s.toLowerCase();
        }), wC = xa(function(i, s, h) {
          return i + (h ? " " : "") + s.toLowerCase();
        }), EC = Zg("toLowerCase");
        function SC(i, s, h) {
          i = le(i), s = qt(s);
          var _ = s ? ha(i) : 0;
          if (!s || _ >= s)
            return i;
          var D = (s - _) / 2;
          return Ru(gu(D), h) + i + Ru(pu(D), h);
        }
        function AC(i, s, h) {
          i = le(i), s = qt(s);
          var _ = s ? ha(i) : 0;
          return s && _ < s ? i + Ru(s - _, h) : i;
        }
        function TC(i, s, h) {
          i = le(i), s = qt(s);
          var _ = s ? ha(i) : 0;
          return s && _ < s ? Ru(s - _, h) + i : i;
        }
        function CC(i, s, h) {
          return h || s == null ? s = 0 : s && (s = +s), Nw(le(i).replace(rf, ""), s || 0);
        }
        function RC(i, s, h) {
          return (h ? ln(i, s, h) : s === n) ? s = 1 : s = qt(s), jf(le(i), s);
        }
        function DC() {
          var i = arguments, s = le(i[0]);
          return i.length < 3 ? s : s.replace(i[1], i[2]);
        }
        var MC = xa(function(i, s, h) {
          return i + (h ? "_" : "") + s.toLowerCase();
        });
        function OC(i, s, h) {
          return h && typeof h != "number" && ln(i, s, h) && (s = h = n), h = h === n ? X : h >>> 0, h ? (i = le(i), i && (typeof s == "string" || s != null && !ah(s)) && (s = On(s), !s && fa(i)) ? oi(er(i), 0, h) : i.split(s, h)) : [];
        }
        var LC = xa(function(i, s, h) {
          return i + (h ? " " : "") + uh(s);
        });
        function PC(i, s, h) {
          return i = le(i), h = h == null ? 0 : Pi(qt(h), 0, i.length), s = On(s), i.slice(h, h + s.length) == s;
        }
        function NC(i, s, h) {
          var _ = L.templateSettings;
          h && ln(i, s, h) && (s = n), i = le(i), s = Uu({}, s, _, am);
          var D = Uu({}, s.imports, _.imports, am), I = Ye(D), $ = xf(D, I), q, J, ut = 0, ct = s.interpolate || Js, ft = "__p += '", vt = bf(
            (s.escape || Js).source + "|" + ct.source + "|" + (ct === Ks ? d2 : Js).source + "|" + (s.evaluate || Js).source + "|$",
            "g"
          ), Rt = "//# sourceURL=" + (fe.call(s, "sourceURL") ? (s.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++V2 + "]") + `
`;
          i.replace(vt, function(kt, Jt, ie, Pn, fn, Nn) {
            return ie || (ie = Pn), ft += i.slice(ut, Nn).replace(_2, cw), Jt && (q = !0, ft += `' +
__e(` + Jt + `) +
'`), fn && (J = !0, ft += `';
` + fn + `;
__p += '`), ie && (ft += `' +
((__t = (` + ie + `)) == null ? '' : __t) +
'`), ut = Nn + kt.length, kt;
          }), ft += `';
`;
          var jt = fe.call(s, "variable") && s.variable;
          if (!jt)
            ft = `with (obj) {
` + ft + `
}
`;
          else if (f2.test(jt))
            throw new zt(c);
          ft = (J ? ft.replace(un, "") : ft).replace(_n, "$1").replace(oa, "$1;"), ft = "function(" + (jt || "obj") + `) {
` + (jt ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (q ? ", __e = _.escape" : "") + (J ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + ft + `return __p
}`;
          var Xt = Km(function() {
            return ue(I, Rt + "return " + ft).apply(n, $);
          });
          if (Xt.source = ft, ih(Xt))
            throw Xt;
          return Xt;
        }
        function IC(i) {
          return le(i).toLowerCase();
        }
        function jC(i) {
          return le(i).toUpperCase();
        }
        function kC(i, s, h) {
          if (i = le(i), i && (h || s === n))
            return og(i);
          if (!i || !(s = On(s)))
            return i;
          var _ = er(i), D = er(s), I = sg(_, D), $ = ug(_, D) + 1;
          return oi(_, I, $).join("");
        }
        function BC(i, s, h) {
          if (i = le(i), i && (h || s === n))
            return i.slice(0, lg(i) + 1);
          if (!i || !(s = On(s)))
            return i;
          var _ = er(i), D = ug(_, er(s)) + 1;
          return oi(_, 0, D).join("");
        }
        function FC(i, s, h) {
          if (i = le(i), i && (h || s === n))
            return i.replace(rf, "");
          if (!i || !(s = On(s)))
            return i;
          var _ = er(i), D = sg(_, er(s));
          return oi(_, D).join("");
        }
        function UC(i, s) {
          var h = Y, _ = V;
          if (we(s)) {
            var D = "separator" in s ? s.separator : D;
            h = "length" in s ? qt(s.length) : h, _ = "omission" in s ? On(s.omission) : _;
          }
          i = le(i);
          var I = i.length;
          if (fa(i)) {
            var $ = er(i);
            I = $.length;
          }
          if (h >= I)
            return i;
          var q = h - ha(_);
          if (q < 1)
            return _;
          var J = $ ? oi($, 0, q).join("") : i.slice(0, q);
          if (D === n)
            return J + _;
          if ($ && (q += J.length - q), ah(D)) {
            if (i.slice(q).search(D)) {
              var ut, ct = J;
              for (D.global || (D = bf(D.source, le(R0.exec(D)) + "g")), D.lastIndex = 0; ut = D.exec(ct); )
                var ft = ut.index;
              J = J.slice(0, ft === n ? q : ft);
            }
          } else if (i.indexOf(On(D), q) != q) {
            var vt = J.lastIndexOf(D);
            vt > -1 && (J = J.slice(0, vt));
          }
          return J + _;
        }
        function $C(i) {
          return i = le(i), i && Mr.test(i) ? i.replace(De, mw) : i;
        }
        var zC = xa(function(i, s, h) {
          return i + (h ? " " : "") + s.toUpperCase();
        }), uh = Zg("toUpperCase");
        function Qm(i, s, h) {
          return i = le(i), s = h ? n : s, s === n ? fw(i) ? xw(i) : nw(i) : i.match(s) || [];
        }
        var Km = Kt(function(i, s) {
          try {
            return Dn(i, n, s);
          } catch (h) {
            return ih(h) ? h : new zt(h);
          }
        }), VC = Ir(function(i, s) {
          return zn(s, function(h) {
            h = pr(h), Pr(i, h, nh(i[h], i));
          }), i;
        });
        function YC(i) {
          var s = i == null ? 0 : i.length, h = Nt();
          return i = s ? be(i, function(_) {
            if (typeof _[1] != "function")
              throw new Vn(u);
            return [h(_[0]), _[1]];
          }) : [], Kt(function(_) {
            for (var D = -1; ++D < s; ) {
              var I = i[D];
              if (Dn(I[0], this, _))
                return Dn(I[1], this, _);
            }
          });
        }
        function WC(i) {
          return mE(Wn(i, y));
        }
        function ch(i) {
          return function() {
            return i;
          };
        }
        function GC(i, s) {
          return i == null || i !== i ? s : i;
        }
        var qC = tm(), HC = tm(!0);
        function An(i) {
          return i;
        }
        function lh(i) {
          return Mg(typeof i == "function" ? i : Wn(i, y));
        }
        function XC(i) {
          return Lg(Wn(i, y));
        }
        function QC(i, s) {
          return Pg(i, Wn(s, y));
        }
        var KC = Kt(function(i, s) {
          return function(h) {
            return vo(h, i, s);
          };
        }), ZC = Kt(function(i, s) {
          return function(h) {
            return vo(i, h, s);
          };
        });
        function fh(i, s, h) {
          var _ = Ye(s), D = bu(s, _);
          h == null && !(we(s) && (D.length || !_.length)) && (h = s, s = i, i = this, D = bu(s, Ye(s)));
          var I = !(we(h) && "chain" in h) || !!h.chain, $ = kr(i);
          return zn(D, function(q) {
            var J = s[q];
            i[q] = J, $ && (i.prototype[q] = function() {
              var ut = this.__chain__;
              if (I || ut) {
                var ct = i(this.__wrapped__), ft = ct.__actions__ = wn(this.__actions__);
                return ft.push({ func: J, args: arguments, thisArg: i }), ct.__chain__ = ut, ct;
              }
              return J.apply(i, ti([this.value()], arguments));
            });
          }), i;
        }
        function JC() {
          return Ge._ === this && (Ge._ = Aw), this;
        }
        function hh() {
        }
        function tR(i) {
          return i = qt(i), Kt(function(s) {
            return Ng(s, i);
          });
        }
        var eR = Vf(be), nR = Vf(eg), rR = Vf(pf);
        function Zm(i) {
          return Qf(i) ? gf(pr(i)) : PE(i);
        }
        function iR(i) {
          return function(s) {
            return i == null ? n : Ni(i, s);
          };
        }
        var aR = nm(), oR = nm(!0);
        function dh() {
          return [];
        }
        function ph() {
          return !1;
        }
        function sR() {
          return {};
        }
        function uR() {
          return "";
        }
        function cR() {
          return !0;
        }
        function lR(i, s) {
          if (i = qt(i), i < 1 || i > W)
            return [];
          var h = X, _ = tn(i, X);
          s = Nt(s), i -= X;
          for (var D = vf(_, s); ++h < i; )
            s(h);
          return D;
        }
        function fR(i) {
          return Wt(i) ? be(i, pr) : Ln(i) ? [i] : wn(vm(le(i)));
        }
        function hR(i) {
          var s = ++Ew;
          return le(i) + s;
        }
        var dR = Cu(function(i, s) {
          return i + s;
        }, 0), pR = Yf("ceil"), gR = Cu(function(i, s) {
          return i / s;
        }, 1), mR = Yf("floor");
        function yR(i) {
          return i && i.length ? _u(i, An, Df) : n;
        }
        function vR(i, s) {
          return i && i.length ? _u(i, Nt(s, 2), Df) : n;
        }
        function xR(i) {
          return ig(i, An);
        }
        function _R(i, s) {
          return ig(i, Nt(s, 2));
        }
        function bR(i) {
          return i && i.length ? _u(i, An, Pf) : n;
        }
        function wR(i, s) {
          return i && i.length ? _u(i, Nt(s, 2), Pf) : n;
        }
        var ER = Cu(function(i, s) {
          return i * s;
        }, 1), SR = Yf("round"), AR = Cu(function(i, s) {
          return i - s;
        }, 0);
        function TR(i) {
          return i && i.length ? yf(i, An) : 0;
        }
        function CR(i, s) {
          return i && i.length ? yf(i, Nt(s, 2)) : 0;
        }
        return L.after = XA, L.ary = Dm, L.assign = jT, L.assignIn = Vm, L.assignInWith = Uu, L.assignWith = kT, L.at = BT, L.before = Mm, L.bind = nh, L.bindAll = VC, L.bindKey = Om, L.castArray = sT, L.chain = Tm, L.chunk = mS, L.compact = yS, L.concat = vS, L.cond = YC, L.conforms = WC, L.constant = ch, L.countBy = TA, L.create = FT, L.curry = Lm, L.curryRight = Pm, L.debounce = Nm, L.defaults = UT, L.defaultsDeep = $T, L.defer = QA, L.delay = KA, L.difference = xS, L.differenceBy = _S, L.differenceWith = bS, L.drop = wS, L.dropRight = ES, L.dropRightWhile = SS, L.dropWhile = AS, L.fill = TS, L.filter = RA, L.flatMap = OA, L.flatMapDeep = LA, L.flatMapDepth = PA, L.flatten = wm, L.flattenDeep = CS, L.flattenDepth = RS, L.flip = ZA, L.flow = qC, L.flowRight = HC, L.fromPairs = DS, L.functions = HT, L.functionsIn = XT, L.groupBy = NA, L.initial = OS, L.intersection = LS, L.intersectionBy = PS, L.intersectionWith = NS, L.invert = KT, L.invertBy = ZT, L.invokeMap = jA, L.iteratee = lh, L.keyBy = kA, L.keys = Ye, L.keysIn = Sn, L.map = Nu, L.mapKeys = tC, L.mapValues = eC, L.matches = XC, L.matchesProperty = QC, L.memoize = ju, L.merge = nC, L.mergeWith = Ym, L.method = KC, L.methodOf = ZC, L.mixin = fh, L.negate = ku, L.nthArg = tR, L.omit = rC, L.omitBy = iC, L.once = JA, L.orderBy = BA, L.over = eR, L.overArgs = tT, L.overEvery = nR, L.overSome = rR, L.partial = rh, L.partialRight = Im, L.partition = FA, L.pick = aC, L.pickBy = Wm, L.property = Zm, L.propertyOf = iR, L.pull = BS, L.pullAll = Sm, L.pullAllBy = FS, L.pullAllWith = US, L.pullAt = $S, L.range = aR, L.rangeRight = oR, L.rearg = eT, L.reject = zA, L.remove = zS, L.rest = nT, L.reverse = th, L.sampleSize = YA, L.set = sC, L.setWith = uC, L.shuffle = WA, L.slice = VS, L.sortBy = HA, L.sortedUniq = QS, L.sortedUniqBy = KS, L.split = OC, L.spread = rT, L.tail = ZS, L.take = JS, L.takeRight = tA, L.takeRightWhile = eA, L.takeWhile = nA, L.tap = yA, L.throttle = iT, L.thru = Pu, L.toArray = Um, L.toPairs = Gm, L.toPairsIn = qm, L.toPath = fR, L.toPlainObject = zm, L.transform = cC, L.unary = aT, L.union = rA, L.unionBy = iA, L.unionWith = aA, L.uniq = oA, L.uniqBy = sA, L.uniqWith = uA, L.unset = lC, L.unzip = eh, L.unzipWith = Am, L.update = fC, L.updateWith = hC, L.values = wa, L.valuesIn = dC, L.without = cA, L.words = Qm, L.wrap = oT, L.xor = lA, L.xorBy = fA, L.xorWith = hA, L.zip = dA, L.zipObject = pA, L.zipObjectDeep = gA, L.zipWith = mA, L.entries = Gm, L.entriesIn = qm, L.extend = Vm, L.extendWith = Uu, fh(L, L), L.add = dR, L.attempt = Km, L.camelCase = yC, L.capitalize = Hm, L.ceil = pR, L.clamp = pC, L.clone = uT, L.cloneDeep = lT, L.cloneDeepWith = fT, L.cloneWith = cT, L.conformsTo = hT, L.deburr = Xm, L.defaultTo = GC, L.divide = gR, L.endsWith = vC, L.eq = rr, L.escape = xC, L.escapeRegExp = _C, L.every = CA, L.find = DA, L.findIndex = _m, L.findKey = zT, L.findLast = MA, L.findLastIndex = bm, L.findLastKey = VT, L.floor = mR, L.forEach = Cm, L.forEachRight = Rm, L.forIn = YT, L.forInRight = WT, L.forOwn = GT, L.forOwnRight = qT, L.get = oh, L.gt = dT, L.gte = pT, L.has = QT, L.hasIn = sh, L.head = Em, L.identity = An, L.includes = IA, L.indexOf = MS, L.inRange = gC, L.invoke = JT, L.isArguments = ki, L.isArray = Wt, L.isArrayBuffer = gT, L.isArrayLike = En, L.isArrayLikeObject = Me, L.isBoolean = mT, L.isBuffer = si, L.isDate = yT, L.isElement = vT, L.isEmpty = xT, L.isEqual = _T, L.isEqualWith = bT, L.isError = ih, L.isFinite = wT, L.isFunction = kr, L.isInteger = jm, L.isLength = Bu, L.isMap = km, L.isMatch = ET, L.isMatchWith = ST, L.isNaN = AT, L.isNative = TT, L.isNil = RT, L.isNull = CT, L.isNumber = Bm, L.isObject = we, L.isObjectLike = Ae, L.isPlainObject = So, L.isRegExp = ah, L.isSafeInteger = DT, L.isSet = Fm, L.isString = Fu, L.isSymbol = Ln, L.isTypedArray = ba, L.isUndefined = MT, L.isWeakMap = OT, L.isWeakSet = LT, L.join = IS, L.kebabCase = bC, L.last = qn, L.lastIndexOf = jS, L.lowerCase = wC, L.lowerFirst = EC, L.lt = PT, L.lte = NT, L.max = yR, L.maxBy = vR, L.mean = xR, L.meanBy = _R, L.min = bR, L.minBy = wR, L.stubArray = dh, L.stubFalse = ph, L.stubObject = sR, L.stubString = uR, L.stubTrue = cR, L.multiply = ER, L.nth = kS, L.noConflict = JC, L.noop = hh, L.now = Iu, L.pad = SC, L.padEnd = AC, L.padStart = TC, L.parseInt = CC, L.random = mC, L.reduce = UA, L.reduceRight = $A, L.repeat = RC, L.replace = DC, L.result = oC, L.round = SR, L.runInContext = K, L.sample = VA, L.size = GA, L.snakeCase = MC, L.some = qA, L.sortedIndex = YS, L.sortedIndexBy = WS, L.sortedIndexOf = GS, L.sortedLastIndex = qS, L.sortedLastIndexBy = HS, L.sortedLastIndexOf = XS, L.startCase = LC, L.startsWith = PC, L.subtract = AR, L.sum = TR, L.sumBy = CR, L.template = NC, L.times = lR, L.toFinite = Br, L.toInteger = qt, L.toLength = $m, L.toLower = IC, L.toNumber = Hn, L.toSafeInteger = IT, L.toString = le, L.toUpper = jC, L.trim = kC, L.trimEnd = BC, L.trimStart = FC, L.truncate = UC, L.unescape = $C, L.uniqueId = hR, L.upperCase = zC, L.upperFirst = uh, L.each = Cm, L.eachRight = Rm, L.first = Em, fh(L, function() {
          var i = {};
          return hr(L, function(s, h) {
            fe.call(L.prototype, h) || (i[h] = s);
          }), i;
        }(), { chain: !1 }), L.VERSION = r, zn(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(i) {
          L[i].placeholder = L;
        }), zn(["drop", "take"], function(i, s) {
          ee.prototype[i] = function(h) {
            h = h === n ? 1 : Fe(qt(h), 0);
            var _ = this.__filtered__ && !s ? new ee(this) : this.clone();
            return _.__filtered__ ? _.__takeCount__ = tn(h, _.__takeCount__) : _.__views__.push({
              size: tn(h, X),
              type: i + (_.__dir__ < 0 ? "Right" : "")
            }), _;
          }, ee.prototype[i + "Right"] = function(h) {
            return this.reverse()[i](h).reverse();
          };
        }), zn(["filter", "map", "takeWhile"], function(i, s) {
          var h = s + 1, _ = h == R || h == U;
          ee.prototype[i] = function(D) {
            var I = this.clone();
            return I.__iteratees__.push({
              iteratee: Nt(D, 3),
              type: h
            }), I.__filtered__ = I.__filtered__ || _, I;
          };
        }), zn(["head", "last"], function(i, s) {
          var h = "take" + (s ? "Right" : "");
          ee.prototype[i] = function() {
            return this[h](1).value()[0];
          };
        }), zn(["initial", "tail"], function(i, s) {
          var h = "drop" + (s ? "" : "Right");
          ee.prototype[i] = function() {
            return this.__filtered__ ? new ee(this) : this[h](1);
          };
        }), ee.prototype.compact = function() {
          return this.filter(An);
        }, ee.prototype.find = function(i) {
          return this.filter(i).head();
        }, ee.prototype.findLast = function(i) {
          return this.reverse().find(i);
        }, ee.prototype.invokeMap = Kt(function(i, s) {
          return typeof i == "function" ? new ee(this) : this.map(function(h) {
            return vo(h, i, s);
          });
        }), ee.prototype.reject = function(i) {
          return this.filter(ku(Nt(i)));
        }, ee.prototype.slice = function(i, s) {
          i = qt(i);
          var h = this;
          return h.__filtered__ && (i > 0 || s < 0) ? new ee(h) : (i < 0 ? h = h.takeRight(-i) : i && (h = h.drop(i)), s !== n && (s = qt(s), h = s < 0 ? h.dropRight(-s) : h.take(s - i)), h);
        }, ee.prototype.takeRightWhile = function(i) {
          return this.reverse().takeWhile(i).reverse();
        }, ee.prototype.toArray = function() {
          return this.take(X);
        }, hr(ee.prototype, function(i, s) {
          var h = /^(?:filter|find|map|reject)|While$/.test(s), _ = /^(?:head|last)$/.test(s), D = L[_ ? "take" + (s == "last" ? "Right" : "") : s], I = _ || /^find/.test(s);
          D && (L.prototype[s] = function() {
            var $ = this.__wrapped__, q = _ ? [1] : arguments, J = $ instanceof ee, ut = q[0], ct = J || Wt($), ft = function(Jt) {
              var ie = D.apply(L, ti([Jt], q));
              return _ && vt ? ie[0] : ie;
            };
            ct && h && typeof ut == "function" && ut.length != 1 && (J = ct = !1);
            var vt = this.__chain__, Rt = !!this.__actions__.length, jt = I && !vt, Xt = J && !Rt;
            if (!I && ct) {
              $ = Xt ? $ : new ee(this);
              var kt = i.apply($, q);
              return kt.__actions__.push({ func: Pu, args: [ft], thisArg: n }), new Yn(kt, vt);
            }
            return jt && Xt ? i.apply(this, q) : (kt = this.thru(ft), jt ? _ ? kt.value()[0] : kt.value() : kt);
          });
        }), zn(["pop", "push", "shift", "sort", "splice", "unshift"], function(i) {
          var s = au[i], h = /^(?:push|sort|unshift)$/.test(i) ? "tap" : "thru", _ = /^(?:pop|shift)$/.test(i);
          L.prototype[i] = function() {
            var D = arguments;
            if (_ && !this.__chain__) {
              var I = this.value();
              return s.apply(Wt(I) ? I : [], D);
            }
            return this[h](function($) {
              return s.apply(Wt($) ? $ : [], D);
            });
          };
        }), hr(ee.prototype, function(i, s) {
          var h = L[s];
          if (h) {
            var _ = h.name + "";
            fe.call(ma, _) || (ma[_] = []), ma[_].push({ name: s, func: h });
          }
        }), ma[Tu(n, M).name] = [{
          name: "wrapper",
          func: n
        }], ee.prototype.clone = $w, ee.prototype.reverse = zw, ee.prototype.value = Vw, L.prototype.at = vA, L.prototype.chain = xA, L.prototype.commit = _A, L.prototype.next = bA, L.prototype.plant = EA, L.prototype.reverse = SA, L.prototype.toJSON = L.prototype.valueOf = L.prototype.value = AA, L.prototype.first = L.prototype.head, lo && (L.prototype[lo] = wA), L;
      }, da = _w();
      Di ? ((Di.exports = da)._ = da, lf._ = da) : Ge._ = da;
    }).call(Ao);
  }(rs, rs.exports)), rs.exports;
}
(function(t, e) {
  (function(n, r) {
    t.exports = r(Gk, qk(), wr);
  })(self, function(n, r, a) {
    return (() => {
      var o = { 605: (l, d, g) => {
        var y, f;
        function m(x) {
          return m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(v) {
            return typeof v;
          } : function(v) {
            return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
          }, m(x);
        }
        function b(x, v) {
          if (!(x instanceof v)) throw new TypeError("Cannot call a class as a function");
        }
        function E(x, v) {
          for (var w = 0; w < v.length; w++) {
            var C = v[w];
            C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(x, C.key, C);
          }
        }
        function S(x, v, w) {
          return S = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(C, P, Y) {
            var V = function(T, R) {
              for (; !Object.prototype.hasOwnProperty.call(T, R) && (T = A(T)) !== null; ) ;
              return T;
            }(C, P);
            if (V) {
              var k = Object.getOwnPropertyDescriptor(V, P);
              return k.get ? k.get.call(Y) : k.value;
            }
          }, S(x, v, w || x);
        }
        function M(x, v) {
          return M = Object.setPrototypeOf || function(w, C) {
            return w.__proto__ = C, w;
          }, M(x, v);
        }
        function N(x) {
          var v = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var w, C = A(x);
            if (v) {
              var P = A(this).constructor;
              w = Reflect.construct(C, arguments, P);
            } else w = C.apply(this, arguments);
            return O(this, w);
          };
        }
        function O(x, v) {
          return !v || m(v) !== "object" && typeof v != "function" ? function(w) {
            if (w === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return w;
          }(x) : v;
        }
        function A(x) {
          return A = Object.setPrototypeOf ? Object.getPrototypeOf : function(v) {
            return v.__proto__ || Object.getPrototypeOf(v);
          }, A(x);
        }
        y = [g(680), g(842)], f = (function(x, v) {
          var w = function(C) {
            (function(T, R) {
              if (typeof R != "function" && R !== null) throw new TypeError("Super expression must either be null or a function");
              T.prototype = Object.create(R && R.prototype, { constructor: { value: T, writable: !0, configurable: !0 } }), R && M(T, R);
            })(k, C);
            var P, Y, V = N(k);
            function k() {
              return b(this, k), V.apply(this, arguments);
            }
            return P = k, (Y = [{ key: "render", value: function(T, R, F, U, H) {
              S(A(k.prototype), "render", this).call(this, T, R, F, U, H);
              var W = { margin: { top: 20, right: 30, bottom: 20, left: 40 }, yTicks: 4, xFormat: x.format(",.0f"), yFormat: x.format("s") }, B = F - (H = Object.assign({}, W, H)).margin.left - H.margin.right, j = U - H.margin.top - H.margin.bottom, X = x.scaleLinear().domain(x.extent(T, function(z) {
                return z.x;
              })).range([0, B]), tt = x.scaleLinear().domain([0, x.max(T, function(z) {
                return z.y;
              })]).range([j, 0]), et = x.axisBottom().scale(X).tickFormat(H.xFormat).ticks(10), ot = x.axisLeft().scale(tt).tickFormat(H.yFormat).ticks(H.yTicks), Z = x.area().x(function(z) {
                return X(z.x);
              }).y0(j).y1(function(z) {
                return tt(z.y);
              }), lt = this.createSvg(R, F, U).append("g").attr("transform", "translate(" + H.margin.left + "," + H.margin.top + ")");
              lt.append("path").data([T]).attr("class", "area").attr("d", Z), lt.append("g").attr("class", "x axis").attr("transform", "translate(0," + j + ")").call(et), lt.append("g").attr("class", "y axis").call(ot);
            } }]) && E(P.prototype, Y), k;
          }(v);
          return w;
        }).apply(d, y), f === void 0 || (l.exports = f);
      }, 648: (l, d, g) => {
        var y, f;
        function m(x) {
          return m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(v) {
            return typeof v;
          } : function(v) {
            return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
          }, m(x);
        }
        function b(x, v) {
          if (!(x instanceof v)) throw new TypeError("Cannot call a class as a function");
        }
        function E(x, v) {
          for (var w = 0; w < v.length; w++) {
            var C = v[w];
            C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(x, C.key, C);
          }
        }
        function S(x, v, w) {
          return S = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(C, P, Y) {
            var V = function(T, R) {
              for (; !Object.prototype.hasOwnProperty.call(T, R) && (T = A(T)) !== null; ) ;
              return T;
            }(C, P);
            if (V) {
              var k = Object.getOwnPropertyDescriptor(V, P);
              return k.get ? k.get.call(Y) : k.value;
            }
          }, S(x, v, w || x);
        }
        function M(x, v) {
          return M = Object.setPrototypeOf || function(w, C) {
            return w.__proto__ = C, w;
          }, M(x, v);
        }
        function N(x) {
          var v = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var w, C = A(x);
            if (v) {
              var P = A(this).constructor;
              w = Reflect.construct(C, arguments, P);
            } else w = C.apply(this, arguments);
            return O(this, w);
          };
        }
        function O(x, v) {
          return !v || m(v) !== "object" && typeof v != "function" ? function(w) {
            if (w === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return w;
          }(x) : v;
        }
        function A(x) {
          return A = Object.setPrototypeOf ? Object.getPrototypeOf : function(v) {
            return v.__proto__ || Object.getPrototypeOf(v);
          }, A(x);
        }
        y = [g(680), g(842)], f = (function(x, v) {
          var w = function(C) {
            (function(T, R) {
              if (typeof R != "function" && R !== null) throw new TypeError("Super expression must either be null or a function");
              T.prototype = Object.create(R && R.prototype, { constructor: { value: T, writable: !0, configurable: !0 } }), R && M(T, R);
            })(k, C);
            var P, Y, V = N(k);
            function k() {
              return b(this, k), V.apply(this, arguments);
            }
            return P = k, (Y = [{ key: "render", value: function(T, R, F, U, H) {
              S(A(k.prototype), "render", this).call(this, T, R, F, U, H);
              var W = this.getOptions({ maxPercent: 100 }, H), B = this.createSvg(R, F, U), j = B.append("g").attr("transform", "translate(".concat(F / 2, ", ").concat(U / 2, ")")), X = Math.min(F - 10, U - 10) / 2, tt = 0.3 * X, et = x.scaleLinear().domain([0, W.maxPercent]).range([tt, X]), ot = x.arc().innerRadius(tt).outerRadius(function(ht) {
                return et(ht.data.percent);
              }), Z = x.arc().innerRadius(tt).outerRadius(X), lt = [0, 2 * Math.PI], z = x.pie().sort(null).startAngle(lt[0]).endAngle(lt[1]).value(function(ht) {
                return ht.weight;
              });
              T.length > 1 && z.padAngle(0.01), j.selectAll(".solidArc").data(z(T)).enter().append("path").attr("fill", function(ht) {
                return W.colors(ht.data.id);
              }).attr("class", "solidArc").attr("d", ot), j.selectAll(".outlineArc").data(z(T)).enter().append("path").attr("fill", "none").attr("stroke", function(ht) {
                return W.colors(ht.data.id);
              }).attr("class", "outlineArc").attr("d", Z), W.asterLabel && B.append("svg:text").attr("class", "aster-label").attr("dy", ".35em").attr("text-anchor", "middle").text(asterLabel());
              for (var nt = j.append("g").attr("class", "axisWrapper"), it = Math.ceil(W.maxPercent / 25), Q = 1; Q < it; Q++) nt.append("circle").attr("class", "gridCircle").attr("r", et(25 * Q)).style("fill", "none").style("stroke", "#c5c5c5").style("stroke-width", 0.6), Q % 2 == 1 && (nt.append("rect").attr("x", -8).attr("y", -et(25 * Q) - 5).attr("width", 20).style("height", 10).attr("fill", "#fff"), nt.append("text").attr("class", "axisLabel").attr("x", -6).attr("y", -et(25 * Q)).attr("dy", ".4em").style("font-size", "8px").attr("fill", "#737373").text(function(ht, pt) {
                return "".concat(25 * Q, "%");
              }));
            } }]) && E(P.prototype, Y), k;
          }(v);
          return w;
        }).apply(d, y), f === void 0 || (l.exports = f);
      }, 131: (l, d, g) => {
        var y, f;
        function m(x) {
          return m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(v) {
            return typeof v;
          } : function(v) {
            return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
          }, m(x);
        }
        function b(x, v) {
          if (!(x instanceof v)) throw new TypeError("Cannot call a class as a function");
        }
        function E(x, v) {
          for (var w = 0; w < v.length; w++) {
            var C = v[w];
            C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(x, C.key, C);
          }
        }
        function S(x, v, w) {
          return S = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(C, P, Y) {
            var V = function(T, R) {
              for (; !Object.prototype.hasOwnProperty.call(T, R) && (T = A(T)) !== null; ) ;
              return T;
            }(C, P);
            if (V) {
              var k = Object.getOwnPropertyDescriptor(V, P);
              return k.get ? k.get.call(Y) : k.value;
            }
          }, S(x, v, w || x);
        }
        function M(x, v) {
          return M = Object.setPrototypeOf || function(w, C) {
            return w.__proto__ = C, w;
          }, M(x, v);
        }
        function N(x) {
          var v = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var w, C = A(x);
            if (v) {
              var P = A(this).constructor;
              w = Reflect.construct(C, arguments, P);
            } else w = C.apply(this, arguments);
            return O(this, w);
          };
        }
        function O(x, v) {
          return !v || m(v) !== "object" && typeof v != "function" ? function(w) {
            if (w === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return w;
          }(x) : v;
        }
        function A(x) {
          return A = Object.setPrototypeOf ? Object.getPrototypeOf : function(v) {
            return v.__proto__ || Object.getPrototypeOf(v);
          }, A(x);
        }
        y = [g(680), g(842)], f = (function(x, v) {
          var w = function(C) {
            (function(T, R) {
              if (typeof R != "function" && R !== null) throw new TypeError("Super expression must either be null or a function");
              T.prototype = Object.create(R && R.prototype, { constructor: { value: T, writable: !0, configurable: !0 } }), R && M(T, R);
            })(k, C);
            var P, Y, V = N(k);
            function k() {
              return b(this, k), V.apply(this, arguments);
            }
            return P = k, (Y = [{ key: "render", value: function(T, R, F, U, H) {
              var W = this;
              S(A(k.prototype), "render", this).call(this, T, R, F, U, H);
              var B = this.getOptions({ label: "label", value: "value", rotate: 0, textAnchor: "middle", showLabels: !1 }, H), j = this.createSvg(R, F, U);
              this.useTip(function(gt) {
                gt.attr("class", "d3-tip").offset([-10, 0]).html(function(dt) {
                  return dt.value;
                });
              });
              var X = B.label, tt = B.value, et = 0;
              T.forEach(function(gt) {
                et += gt[tt];
              });
              var ot = F - B.margins.left - B.margins.right, Z = U - B.margins.top - B.margins.bottom, lt = x.scaleBand().range([0, ot]).padding(0.1).round(1 / T.length), z = x.scaleLinear().range([Z, 0]), nt = x.axisBottom().scale(lt).tickSize(2, 0), it = x.axisLeft().scale(z).tickFormat(B.yFormat).ticks(5);
              lt.domain(T.map(function(gt) {
                return gt[X];
              })), z.domain([0, B.yMax || x.max(T, function(gt) {
                return gt[tt];
              })]);
              var Q = j.append("g").attr("class", "axis");
              Q.call(nt);
              var ht = Math.round(Q.node().getBBox().height), pt = Math.round(Q.node().getBBox().width);
              Z -= ht, ot -= Math.max(0, pt - ot), Q.remove();
              var st = j.append("g").attr("class", "axis");
              st.call(it);
              var xt = Math.round(st.node().getBBox().width);
              ot -= xt, st.remove(), lt.range([0, ot]), z.range([Z, 0]), (j = j.append("g").attr("transform", `translate(
	          `.concat(B.margins.left + xt, `,
	          `).concat(B.margins.top, `
	        )`))).append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(Z, ")")).call(nt).selectAll(".tick text").style("text-anchor", B.textAnchor).attr("transform", function(gt) {
                return "rotate(".concat(B.rotate, ")");
              }), B.wrap && j.selectAll(".tick text").call(this.wrap, lt.bandwidth()), j.append("g").attr("class", "y axis").attr("transform", "translate(0, 0)").call(it), j.selectAll(".bar").data(T).enter().append("rect").attr("class", "bar").attr("x", function(gt) {
                return lt(gt[X]);
              }).attr("width", lt.bandwidth()).attr("y", function(gt) {
                return z(gt[tt]);
              }).attr("height", function(gt) {
                return Z - z(gt[tt]);
              }).attr("title", function(gt) {
                var dt = "".concat(gt[X], ": ").concat(W.formatters.commaseparated(gt[tt], ","));
                return dt += " (".concat(et > 0 ? W.formatters.formatpercent(gt[tt] / et) : W.formatters.formatpercent(0), ")");
              }).style("fill", function(gt) {
                return B.colors(gt[X]);
              }).on("mouseover", function(gt) {
                return W.tip.show(gt, event.target);
              }).on("mouseout", function(gt) {
                return W.tip.hide(gt, event.target);
              }).exit().remove(), B.showLabels && j.selectAll(".barlabel").data(T).enter().append("text").attr("class", "barlabel").text(function(gt) {
                return W.formatters.formatpercent(gt[tt] / et);
              }).attr("x", function(gt) {
                return lt(gt[X]) + lt.bandwidth() / 2;
              }).attr("y", function(gt) {
                return z(gt[tt]) - 3;
              }).attr("text-anchor", "middle");
            } }, { key: "formatters", get: function() {
              return { commaseparated: x.format(","), formatpercent: x.format(".1%") };
            } }]) && E(P.prototype, Y), k;
          }(v);
          return w;
        }).apply(d, y), f === void 0 || (l.exports = f);
      }, 316: (l, d, g) => {
        var y, f;
        function m(x) {
          return m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(v) {
            return typeof v;
          } : function(v) {
            return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
          }, m(x);
        }
        function b(x, v) {
          if (!(x instanceof v)) throw new TypeError("Cannot call a class as a function");
        }
        function E(x, v) {
          for (var w = 0; w < v.length; w++) {
            var C = v[w];
            C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(x, C.key, C);
          }
        }
        function S(x, v, w) {
          return S = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(C, P, Y) {
            var V = function(T, R) {
              for (; !Object.prototype.hasOwnProperty.call(T, R) && (T = A(T)) !== null; ) ;
              return T;
            }(C, P);
            if (V) {
              var k = Object.getOwnPropertyDescriptor(V, P);
              return k.get ? k.get.call(Y) : k.value;
            }
          }, S(x, v, w || x);
        }
        function M(x, v) {
          return M = Object.setPrototypeOf || function(w, C) {
            return w.__proto__ = C, w;
          }, M(x, v);
        }
        function N(x) {
          var v = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var w, C = A(x);
            if (v) {
              var P = A(this).constructor;
              w = Reflect.construct(C, arguments, P);
            } else w = C.apply(this, arguments);
            return O(this, w);
          };
        }
        function O(x, v) {
          return !v || m(v) !== "object" && typeof v != "function" ? function(w) {
            if (w === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return w;
          }(x) : v;
        }
        function A(x) {
          return A = Object.setPrototypeOf ? Object.getPrototypeOf : function(v) {
            return v.__proto__ || Object.getPrototypeOf(v);
          }, A(x);
        }
        y = [g(680), g(842)], f = (function(x, v) {
          var w = function(C) {
            (function(T, R) {
              if (typeof R != "function" && R !== null) throw new TypeError("Super expression must either be null or a function");
              T.prototype = Object.create(R && R.prototype, { constructor: { value: T, writable: !0, configurable: !0 } }), R && M(T, R);
            })(k, C);
            var P, Y, V = N(k);
            function k() {
              return b(this, k), V.apply(this, arguments);
            }
            return P = k, (Y = [{ key: "defaultTip", value: function(T, R) {
              T.attr("class", "d3-tip").offset(function(F) {
                return F.tipOffset || [-10, 0];
              }).direction(function(F) {
                return F.tipDirection || "n";
              }).html(function(F) {
                return `<table class='boxplotValues'>
					<tr>
						<td>Max:</td>
						<td>`.concat(R.valueFormatter(F.max), `</td>
					</tr>
					<tr>
						<td>P90:</td>
						<td>`).concat(R.valueFormatter(F.UIF), `</td>
					</tr>
					<tr>
						<td>P75:</td>
						<td>`).concat(R.valueFormatter(F.q3), `</td>
					</tr>
					<tr>
						<td>Median:</td>
						<td>`).concat(R.valueFormatter(F.median), `</td>
					</tr>
					<tr>
						<td>P25:</td>
						<td>`).concat(R.valueFormatter(F.q1), `</td>
					</tr>
					<tr>
						<td>P10:</td>
						<td>`).concat(R.valueFormatter(F.LIF), `</td>
					</tr>
					<tr>
						<td>Min:</td>
						<td>`).concat(R.valueFormatter(F.min), `</td>
					</tr>
				</table>`);
              });
            } }, { key: "render", value: function(T, R, F, U, H) {
              S(A(k.prototype), "render", this).call(this, T, R, F, U, H);
              var W = { valueFormatter: this.formatters.formatSI(3) }, B = this.getOptions(W, H), j = this.createSvg(R, F, U);
              B.valueFormatter, this.useTip(this.defaultTip, B);
              var X = 0, tt = 0;
              if (B.xLabel) {
                var et = j.append("g").attr("transform", "translate(".concat(F / 2, ", ").concat(U - B.margins.bottom, ")"));
                et.append("text").attr("class", "axislabel").style("text-anchor", "middle").text(B.xLabel), X = et.node().getBBox().height;
              }
              if (B.yLabel) {
                var ot = j.append("g").attr("transform", `translate(
	            `.concat(B.margins.left, `,
	            `).concat((U - B.margins.bottom - B.margins.top) / 2 + B.margins.top, `
	          )`));
                ot.append("text").attr("class", "axislabel").attr("transform", "rotate(-90)").attr("y", 0).attr("x", 0).attr("dy", "1em").style("text-anchor", "middle").text(B.yLabel), tt = ot.node().getBBox().width;
              }
              var Z = F - B.margins.left - tt - B.margins.right, lt = U - B.margins.top - X - B.margins.bottom, z = x.scaleBand().range([0, Z]).round(1 / T.length).domain(T.map(function(yt) {
                return yt.Category;
              })), nt = x.scaleLinear().range([lt, 0]).domain([B.yMin || 0, B.yMax || x.max(T, function(yt) {
                return yt.max;
              })]), it = x.axisBottom().scale(z), Q = x.axisLeft().scale(nt).tickFormat(B.yFormat).ticks(5), ht = j.append("g").attr("class", "axis");
              ht.call(it);
              var pt = Math.round(ht.node().getBBox().height), st = Math.round(ht.node().getBBox().width);
              lt -= pt, Z -= Math.max(0, st - Z), ht.remove();
              var xt = j.append("g").attr("class", "axis");
              xt.call(Q);
              var gt = Math.round(xt.node().getBBox().width);
              Z -= gt, xt.remove(), z.range([0, Z]), nt.range([lt, 0]);
              var dt = z.bandwidth() / 2 - 5, Tt = z.bandwidth() / 2 - 2.5, Ht = j.append("g").attr("transform", `translate(
	          `.concat(B.margins.left + tt + gt, `,
	          `).concat(B.margins.top, `
	        )`)), te = Ht.selectAll(".boxplot").data(T).enter().append("g").attr("class", "boxplot").attr("transform", function(yt) {
                return "translate(".concat(z(yt.Category), ", 0)");
              }), _t = this;
              te.each(function(yt) {
                var bt = x.select(this);
                yt.LIF != yt.q1 && (bt.append("line").attr("class", "bar").attr("x1", Tt).attr("y1", nt(yt.LIF)).attr("x2", Tt + 5).attr("y2", nt(yt.LIF)), bt.append("line").attr("class", "whisker").attr("x1", z.bandwidth() / 2).attr("y1", nt(yt.LIF)).attr("x2", z.bandwidth() / 2).attr("y2", nt(yt.q1))), bt.append("rect").attr("class", "box").attr("x", dt).attr("y", nt(yt.q3)).attr("width", 10).attr("height", Math.max(1, nt(yt.q1) - nt(yt.q3))).on("mouseover", function(Ct) {
                  return _t.tip.show(Ct, event.target);
                }).on("mouseout", function(Ct) {
                  return _t.tip.hide(Ct, event.target);
                }), bt.append("line").attr("class", "median").attr("x1", dt).attr("y1", nt(yt.median)).attr("x2", dt + 10).attr("y2", nt(yt.median)), yt.UIF != yt.q3 && (bt.append("line").attr("class", "bar").attr("x1", Tt).attr("y1", nt(yt.UIF)).attr("x2", z.bandwidth() - Tt).attr("y2", nt(yt.UIF)), bt.append("line").attr("class", "whisker").attr("x1", z.bandwidth() / 2).attr("y1", nt(yt.UIF)).attr("x2", z.bandwidth() / 2).attr("y2", nt(yt.q3)));
              }), Ht.append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(lt, ")")).call(it), Ht.selectAll(".tick text").call(this.wrap, z.bandwidth() || z.range()), Ht.append("g").attr("class", "y axis").attr("transform", "translate(0, 0)").call(Q);
            } }]) && E(P.prototype, Y), k;
          }(v);
          return w;
        }).apply(d, y), f === void 0 || (l.exports = f);
      }, 842: (l, d, g) => {
        var y, f;
        function m(b, E) {
          for (var S = 0; S < E.length; S++) {
            var M = E[S];
            M.enumerable = M.enumerable || !1, M.configurable = !0, "value" in M && (M.writable = !0), Object.defineProperty(b, M.key, M);
          }
        }
        y = [g(680), g(92), g(383)], f = (function(b, E, S) {
          var M = function() {
            function N() {
              (function(v, w) {
                if (!(v instanceof w)) throw new TypeError("Cannot call a class as a function");
              })(this, N);
            }
            var O, A, x;
            return O = N, A = [{ key: "render", value: function(v, w, C, P, Y) {
              var V = this;
              typeof w == "string" && (w = document.querySelector(w)), this.cachedData = v, this.doResize || (this.doResize = E.debounce(function() {
                V.render(V.cachedData, w, w.clientWidth, w.clientHeight, Y);
              }, 250), window.addEventListener("resize", this.doResize));
            } }, { key: "getOptions", value: function(v, w) {
              return Object.assign({}, { margins: { top: 10, right: 10, bottom: 10, left: 10 }, xFormat: b.format(",.0f"), yFormat: b.format("s"), colors: b.scaleOrdinal(b.schemeCategory20.concat(b.schemeCategory20c)) }, Object.assign({}, v), Object.assign({}, w));
            } }, { key: "createSvg", value: function(v, w, C) {
              this.destroyTipIfExists();
              var P = b.select(v);
              P.select("svg").remove();
              var Y = P.append("svg").attr("preserveAspectRatio", "xMinYMin meet").attr("viewBox", `
	        0
	        0
	        `.concat(w, `
	        `).concat(C)).append("g").attr("class", "chart");
              return this.chart = Y, Y;
            } }, { key: "useTip", value: function() {
              var v = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
              }, w = arguments.length > 1 ? arguments[1] : void 0;
              return this.destroyTipIfExists(), this.tip = S().attr("class", "d3-tip"), v(this.tip, w), this.chart && this.chart.call(this.tip), this.tip;
            } }, { key: "destroyTipIfExists", value: function() {
              this.tip && this.tip.destroy();
            } }, { key: "truncate", value: function(v, w) {
              v.each(function() {
                for (var C = b.select(this), P = C.text(), Y = C.node().getComputedTextLength(), V = C.text(); Y > w && V.length > 0; ) V = V.slice(0, -1), C.text("".concat(V, "...")), Y = C.node().getComputedTextLength();
                C.append("title").text(P);
              });
            } }, { key: "wrap", value: function(v, w, C) {
              v.each(function() {
                for (var P, Y = b.select(this), V = Y.text(), k = Y.text().split(/\s+/).reverse(), T = [], R = 0, F = 0, U = Y.attr("y"), H = parseFloat(Y.attr("dy")), W = Y.text(null).append("tspan").attr("x", 0).attr("y", U).attr("dy", "".concat(H, "em")); P = k.pop(); ) if (T.push(P), W.text(T.join(" ")), W.node().getComputedTextLength() > w) {
                  if (T.length > 1) {
                    T.pop(), k.push(P);
                    var B = C && ++F === C ? "".concat(T.splice(0, T.length - 1).join(" "), "...") : T.join(" ");
                    W.text(B);
                  }
                  if (T = [], W = Y.append("tspan").attr("x", 0).attr("y", U).attr("dy", "".concat(1.1 * ++R + H, "em")), C && C === F) {
                    W.remove();
                    break;
                  }
                }
                Y.append("title").text(V);
              });
            } }, { key: "tooltipFactory", value: function(v) {
              return function(w) {
                var C = "";
                if (v !== void 0) for (var P = 0; P < v.length; P += 1) {
                  var Y = v[P].accessor(w);
                  v[P].format !== void 0 && (Y = v[P].format(Y)), C += "".concat(v[P].label, ": ").concat(Y, "</br>");
                }
                return C;
              };
            } }, { key: "lineDefaultTooltip", value: function(v, w, C, P, Y, V, k) {
              return function(T) {
                var R = "";
                return k(T) && (R = "Series: ".concat(k(T), "</br>")), R += "".concat(v, ": ").concat(w(C(T)), "</br>"), R += "".concat(P, ": ").concat(Y(V(T)));
              };
            } }, { key: "donutDefaultTooltip", value: function(v, w, C) {
              return function(P) {
                return "".concat(v(P), ": ").concat(w(P), " (").concat(C(P), ")");
              };
            } }, { key: "dispose", value: function() {
              this.destroyTipIfExists(), this.doResize && window.removeEventListener("resize", this.doResize);
            } }, { key: "formatters", get: function() {
              return { formatSI: function(v) {
                v = v || 0;
                var w = b.format(",.".concat(v, "s"));
                return function(C) {
                  return C < 1 ? C.toFixed(v).replace(new RegExp("(\\.0*|(?<=(\\.[0-9]*))0*)$"), "") : w(C).replace(new RegExp("(\\.0*|(?<=(\\.[0-9]*))0*)$"), "");
                };
              } };
            } }], x = [{ key: "normalizeDataframe", value: function(v) {
              var w = b.keys(v), C = Object.assign({}, v);
              return w.forEach(function(P) {
                v[P] instanceof Array || (C[P] = [v[P]]);
              }), C;
            } }, { key: "dataframeToArray", value: function(v) {
              var w = b.keys(v);
              return v[w[0]] instanceof Array ? v[w[0]].map(function(C, P) {
                var Y = {};
                return w.forEach(function(V) {
                  Y[V] = v[V][P];
                }), Y;
              }) : [v];
            } }, { key: "mapMonthYearDataToSeries", value: function(v, w) {
              var C = Object.assign({}, { dateField: "x", yValue: "y", yPercent: "p" }, w), P = { name: "All Time", values: [] };
              return v[C.dateField].map(function(Y, V) {
                P.values.push({ xValue: new Date(Math.floor(v[C.dateField][V] / 100), v[C.dateField][V] % 100 - 1, 1), yValue: v[C.yValue][V], yPercent: v[C.yPercent][V] });
              }), P.values.sort(function(Y, V) {
                return Y.xValue - V.xValue;
              }), [P];
            } }, { key: "prepareData", value: function(v, w) {
              if (w === this.chartTypes.BOXPLOT) {
                if (!v.CATEGORY.length) return null;
                var C = v.CATEGORY.map(function(P, Y) {
                  return { Category: v.CATEGORY[Y], min: v.MIN_VALUE[Y], max: v.MAX_VALUE[Y], median: v.MEDIAN_VALUE[Y], LIF: v.P10_VALUE[Y], q1: v.P25_VALUE[Y], q3: v.P75_VALUE[Y], UIF: v.P90_VALUE[Y] };
                }, v);
                return Object.values(C).reduce(function(P, Y) {
                  return P.concat(Y);
                }, []).length ? C : null;
              }
            } }, { key: "chartTypes", get: function() {
              return { AREA: "AREA", BOXPLOT: "BOXPLOT", DONUT: "DONUT", HISTOGRAM: "HISTOGRAM", LINE: "LINE", TRELLISLINE: "TRELLISLINE" };
            } }], A && m(O.prototype, A), x && m(O, x), N;
          }();
          return M;
        }).apply(d, y), f === void 0 || (l.exports = f);
      }, 535: (l, d, g) => {
        var y, f;
        function m(x) {
          return m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(v) {
            return typeof v;
          } : function(v) {
            return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
          }, m(x);
        }
        function b(x, v) {
          if (!(x instanceof v)) throw new TypeError("Cannot call a class as a function");
        }
        function E(x, v) {
          for (var w = 0; w < v.length; w++) {
            var C = v[w];
            C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(x, C.key, C);
          }
        }
        function S(x, v, w) {
          return S = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(C, P, Y) {
            var V = function(T, R) {
              for (; !Object.prototype.hasOwnProperty.call(T, R) && (T = A(T)) !== null; ) ;
              return T;
            }(C, P);
            if (V) {
              var k = Object.getOwnPropertyDescriptor(V, P);
              return k.get ? k.get.call(Y) : k.value;
            }
          }, S(x, v, w || x);
        }
        function M(x, v) {
          return M = Object.setPrototypeOf || function(w, C) {
            return w.__proto__ = C, w;
          }, M(x, v);
        }
        function N(x) {
          var v = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var w, C = A(x);
            if (v) {
              var P = A(this).constructor;
              w = Reflect.construct(C, arguments, P);
            } else w = C.apply(this, arguments);
            return O(this, w);
          };
        }
        function O(x, v) {
          return !v || m(v) !== "object" && typeof v != "function" ? function(w) {
            if (w === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return w;
          }(x) : v;
        }
        function A(x) {
          return A = Object.setPrototypeOf ? Object.getPrototypeOf : function(v) {
            return v.__proto__ || Object.getPrototypeOf(v);
          }, A(x);
        }
        y = [g(680), g(756), g(842)], f = (function(x, v, w) {
          var C = function(P) {
            (function(R, F) {
              if (typeof F != "function" && F !== null) throw new TypeError("Super expression must either be null or a function");
              R.prototype = Object.create(F && F.prototype, { constructor: { value: R, writable: !0, configurable: !0 } }), F && M(R, F);
            })(T, P);
            var Y, V, k = N(T);
            function T() {
              return b(this, T), k.apply(this, arguments);
            }
            return Y = T, (V = [{ key: "render", value: function(R, F, U, H, W) {
              var B = this;
              S(A(T.prototype), "render", this).call(this, R, F, U, H, W);
              var j = this.getOptions(W), X = this.createSvg(F, U, H), tt = 0;
              R.forEach(function(st) {
                tt += +st.value;
              });
              var et = this.donutDefaultTooltip(function(st) {
                return st.label;
              }, function(st) {
                return v(st.value).format("0,0");
              }, function(st) {
                return B.formatters.formatpercent(tt != 0 ? st.value / tt : 0);
              });
              if (this.useTip(function(st) {
                return st.attr("class", "d3-tip").direction("s").offset([3, 0]).html(et);
              }), R.length > 0) {
                var ot = X.append("g").attr("id", "chart"), Z = x.drag().on("drag", function() {
                  var st = x.select(this), xt = event.y - parseFloat(st.attr("initialY"));
                  if (isNaN(xt)) return !1;
                  st.attr("transform", `translate(
	        `.concat(parseFloat(st.attr("initialPositionX")), `,
	        `).concat(parseFloat(st.attr("initialPositionY")) + xt, `
	      )`));
                }).on("start", function() {
                  var st = x.select(this);
                  st.attr("initialX", event.x), st.attr("initialY", event.y);
                }).on("end", function() {
                  var st = x.select(this);
                  st.transition().duration(300).attr("transform", `translate(
	          `.concat(st.attr("initialPositionX"), `,
	          `).concat(st.attr("initialPositionY"), `
	        )`));
                }), lt = X.append("g").attr("class", "legend").call(Z);
                lt.selectAll("rect").data(R).enter().append("rect").attr("x", 0).attr("y", function(st, xt) {
                  return 15 * xt;
                }).attr("width", 10).attr("height", 10).style("fill", function(st) {
                  return j.colors(st.id);
                });
                var z = 0, nt = lt.selectAll("g.legend-item").data(R).enter().append("g").attr("class", "legend-item");
                nt.append("text").attr("x", 12).attr("y", function(st, xt) {
                  return 15 * xt + 9;
                }).text(function(st) {
                  return st.label;
                }), nt.append("title").attr("x", 12).attr("y", function(st, xt) {
                  return 15 * xt + 9;
                }).text(function(st) {
                  return st.label;
                }), nt.each(function() {
                  var st = this.getBBox().width;
                  st > z && z + st < 0.75 * U && (z = st);
                }), z += 12, lt.attr("transform", `translate(
	            `.concat(U - z - j.margins.right, `,
	            `).concat(j.margins.top, `
	          )`)).attr("initialPositionX", U - z - j.margins.right).attr("initialPositionY", j.margins.top), ot.attr("transform", "translate(".concat((U - z) / 2, ", ").concat(H / 2, ")"));
                var it = Math.min(H, U - z) / 2 - j.margins.top, Q = Math.min(H, U - z) / 6 - j.margins.top, ht = x.arc().innerRadius(Q).outerRadius(it), pt = x.pie().value(function(st) {
                  return st.value > 0 ? Math.max(st.value, 0.015 * tt) : 0;
                });
                ot.selectAll("g.slice").data(pt(R)).enter().append("g").attr("class", "slice").append("path").attr("fill", function(st) {
                  return j.colors(st.data.id);
                }).attr("stroke", "#fff").attr("stroke-width", 5).attr("title", function(st) {
                  return st.label;
                }).on("mouseover", function(st) {
                  return B.tip.show(st.data, event.target);
                }).on("mouseout", function(st) {
                  return B.tip.hide(st.data, event.target);
                }).attr("d", ht);
              } else X.append("text").attr("transform", "translate(".concat(U / 2, ", ").concat(H / 2, ")")).style("text-anchor", "middle").text("No Data");
            } }, { key: "formatters", get: function() {
              return { formatpercent: x.format(".1%") };
            } }]) && E(Y.prototype, V), T;
          }(w);
          return C;
        }).apply(d, y), f === void 0 || (l.exports = f);
      }, 502: (l, d, g) => {
        var y, f;
        function m(x) {
          return m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(v) {
            return typeof v;
          } : function(v) {
            return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
          }, m(x);
        }
        function b(x, v) {
          if (!(x instanceof v)) throw new TypeError("Cannot call a class as a function");
        }
        function E(x, v) {
          for (var w = 0; w < v.length; w++) {
            var C = v[w];
            C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(x, C.key, C);
          }
        }
        function S(x, v, w) {
          return S = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(C, P, Y) {
            var V = function(T, R) {
              for (; !Object.prototype.hasOwnProperty.call(T, R) && (T = A(T)) !== null; ) ;
              return T;
            }(C, P);
            if (V) {
              var k = Object.getOwnPropertyDescriptor(V, P);
              return k.get ? k.get.call(Y) : k.value;
            }
          }, S(x, v, w || x);
        }
        function M(x, v) {
          return M = Object.setPrototypeOf || function(w, C) {
            return w.__proto__ = C, w;
          }, M(x, v);
        }
        function N(x) {
          var v = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var w, C = A(x);
            if (v) {
              var P = A(this).constructor;
              w = Reflect.construct(C, arguments, P);
            } else w = C.apply(this, arguments);
            return O(this, w);
          };
        }
        function O(x, v) {
          return !v || m(v) !== "object" && typeof v != "function" ? function(w) {
            if (w === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return w;
          }(x) : v;
        }
        function A(x) {
          return A = Object.setPrototypeOf ? Object.getPrototypeOf : function(v) {
            return v.__proto__ || Object.getPrototypeOf(v);
          }, A(x);
        }
        y = [g(680), g(756), g(842)], f = (function(x, v, w) {
          var C = function(P) {
            (function(F, U) {
              if (typeof U != "function" && U !== null) throw new TypeError("Super expression must either be null or a function");
              F.prototype = Object.create(U && U.prototype, { constructor: { value: F, writable: !0, configurable: !0 } }), U && M(F, U);
            })(R, P);
            var Y, V, k, T = N(R);
            function R() {
              return b(this, R), T.apply(this, arguments);
            }
            return Y = R, k = [{ key: "mapHistogram", value: function(F) {
              for (var U = [], H = F.OFFSET || 0, W = F.INTERVAL_SIZE, B = this.normalizeDataframe(F.DATA), j = 0; j < F.INTERVALS; j += 1) {
                var X = {};
                X.x = H + 1 * B.INTERVAL_INDEX[j] * W, X.dx = W, X.y = B.COUNT_VALUE[j] || 0, U.push(X);
              }
              return U;
            } }], (V = [{ key: "drawBoxplot", value: function(F, U, H, W) {
              var B = F, j = this.xScale, X = W / 2;
              U.LIF !== U.q1 && (B.append("line").attr("class", "bar").attr("x1", j(U.LIF)).attr("y1", W / 2 - X / 2).attr("x2", j(U.LIF)).attr("y2", W / 2 + X / 2), B.append("line").attr("class", "whisker").attr("x1", j(U.LIF)).attr("y1", W / 2).attr("x2", j(U.q1)).attr("y2", W / 2)), B.append("rect").attr("class", "box").attr("x", j(U.q1)).attr("width", j(U.q3) - j(U.q1)).attr("height", W), B.append("line").attr("class", "median").attr("x1", j(U.median)).attr("y1", 0).attr("x2", j(U.median)).attr("y2", W), U.UIF !== U.q3 && (B.append("line").attr("class", "bar").attr("x1", j(U.UIF)).attr("y1", W / 2 - X / 2).attr("x2", j(U.UIF)).attr("y2", W / 2 + X / 2), B.append("line").attr("class", "whisker").attr("x1", j(U.q3)).attr("y1", W / 2).attr("x2", j(U.UIF)).attr("y2", W / 2));
            } }, { key: "render", value: function(F, U, H, W, B) {
              var j = this;
              S(A(R.prototype), "render", this).call(this, F, U, H, W, B);
              var X = { ticks: 10, yTicks: 4, yScale: x.scaleLinear(), boxplotHeight: 10, getTooltipBuilder: null }, tt = this.getOptions(X, B), et = this.createSvg(U, H, W);
              this.xScale = {};
              var ot = F || [], Z = typeof tt.getTooltipBuilder == "function" ? tt.getTooltipBuilder(tt) : function(Ct) {
                return v(Ct.y).format("0,0");
              };
              this.useTip(function(Ct) {
                Ct.attr("class", "d3-tip").offset([-10, 0]).html(Z);
              });
              var lt = 0, z = 0;
              if (tt.xLabel) {
                var nt = et.append("g").attr("transform", "translate(".concat(H / 2, ", ").concat(W - tt.margins.bottom, ")"));
                nt.append("text").attr("class", "axislabel").style("text-anchor", "middle").text(tt.xLabel), lt = nt.node().getBBox().height;
              }
              if (tt.yLabel) {
                var it = et.append("g").attr("transform", `translate(
	            `.concat(tt.margins.left, `,
	            `).concat((W - tt.margins.bottom - tt.margins.top) / 2 + tt.margins.top, `
	          )`));
                it.append("text").attr("class", "axislabel").attr("transform", "rotate(-90)").attr("y", 0).attr("x", 0).attr("dy", "1em").style("text-anchor", "middle").text(tt.yLabel), z = 1.5 * it.node().getBBox().width;
              }
              var Q = H - tt.margins.left - tt.margins.right - z, ht = W - tt.margins.top - tt.margins.bottom - lt, pt = this.xScale = x.scaleLinear().domain(tt.xDomain || [x.min(ot, function(Ct) {
                return Ct.x;
              }), x.max(ot, function(Ct) {
                return Ct.x + Ct.dx;
              })]).range([0, Q]), st = x.axisBottom().scale(pt).ticks(tt.ticks).tickFormat(tt.xFormat), xt = tt.yScale.domain([0, tt.yMax || x.max(ot, function(Ct) {
                return Ct.y;
              })]).range([ht, 0]), gt = x.axisLeft().scale(xt).ticks(tt.yTicks).tickFormat(tt.yFormat), dt = et.append("g").attr("class", "axis");
              dt.call(st);
              var Tt = Math.round(dt.node().getBBox().height), Ht = Math.round(dt.node().getBBox().width);
              ht -= Tt, Q -= Math.max(0, Ht - Q), dt.remove();
              var te = et.append("g").attr("class", "axis");
              te.call(gt);
              var _t = Math.round(te.node().getBBox().width);
              if (Q -= _t, te.remove(), tt.boxplot) {
                ht -= 12;
                var yt = et.append("g").attr("class", "boxplot").attr("transform", "translate(".concat(tt.margins.left + z + _t, `,
	          `).concat(tt.margins.top + ht + Tt, ")"));
                this.drawBoxplot(yt, tt.boxplot, Q, 8);
              }
              pt.range([0, Q]), xt.range([ht, 0]);
              var bt = et.append("g").attr("transform", `translate(
	        `.concat(tt.margins.left + z + _t, `,
	        `).concat(tt.margins.top, ")"));
              bt.selectAll(".bar").data(ot).enter().append("g").attr("class", "bar").attr("transform", function(Ct) {
                return "translate(".concat(pt(Ct.x), ", ").concat(xt(Ct.y), ")");
              }).on("mouseover", function(Ct) {
                return j.tip.show(Ct, event.target);
              }).on("mouseout", function(Ct) {
                return j.tip.hide(Ct, event.target);
              }).append("rect").attr("x", 1).attr("width", function(Ct) {
                return Math.max(pt(Ct.x + Ct.dx) - pt(Ct.x) - 1, 0.5);
              }).attr("height", function(Ct) {
                return ht - xt(Ct.y);
              }), bt.append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(ht, ")")).call(st), bt.append("g").attr("class", "y axis").attr("transform", "translate(0, 0)").call(gt);
            } }]) && E(Y.prototype, V), k && E(Y, k), R;
          }(w);
          return C;
        }).apply(d, y), f === void 0 || (l.exports = f);
      }, 487: (l, d, g) => {
        var y, f;
        function m(A) {
          return m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
            return typeof x;
          } : function(x) {
            return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
          }, m(A);
        }
        function b(A, x) {
          if (!(A instanceof x)) throw new TypeError("Cannot call a class as a function");
        }
        function E(A, x) {
          for (var v = 0; v < x.length; v++) {
            var w = x[v];
            w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(A, w.key, w);
          }
        }
        function S(A, x) {
          return S = Object.setPrototypeOf || function(v, w) {
            return v.__proto__ = w, v;
          }, S(A, x);
        }
        function M(A) {
          var x = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var v, w = O(A);
            if (x) {
              var C = O(this).constructor;
              v = Reflect.construct(w, arguments, C);
            } else v = w.apply(this, arguments);
            return N(this, v);
          };
        }
        function N(A, x) {
          return !x || m(x) !== "object" && typeof x != "function" ? function(v) {
            if (v === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return v;
          }(A) : x;
        }
        function O(A) {
          return O = Object.setPrototypeOf ? Object.getPrototypeOf : function(x) {
            return x.__proto__ || Object.getPrototypeOf(x);
          }, O(A);
        }
        y = [g(680), g(316)], f = (function(A, x) {
          var v = function(w) {
            (function(k, T) {
              if (typeof T != "function" && T !== null) throw new TypeError("Super expression must either be null or a function");
              k.prototype = Object.create(T && T.prototype, { constructor: { value: k, writable: !0, configurable: !0 } }), T && S(k, T);
            })(V, w);
            var C, P, Y = M(V);
            function V() {
              return b(this, V), Y.apply(this, arguments);
            }
            return C = V, (P = [{ key: "render", value: function(k, T, R, F, U) {
              var H = { showXAxis: !0, showMinMarkers: !0, showMaxMarkers: !0, boxHeight: 10, valueFormatter: this.formatters.formatSI(3), margins: { top: 0, right: 0, bottom: 0, left: 4 } }, W = this.getOptions(H, U), B = F < k.length * W.boxHeight ? k.length * W.boxHeight : F, j = this.createSvg(T, R, B), X = W.valueFormatter;
              this.useTip(this.defaultTip, W), k.forEach(function(yt) {
                return yt.Category = yt.Category || "Default";
              });
              var tt = R - W.margins.left - W.margins.right;
              B = B - W.margins.top - W.margins.bottom;
              var et = A.scaleLinear().range([0, tt]).domain([W.xMin || A.min(k, function(yt) {
                return yt.min;
              }), W.xMax || A.max(k, function(yt) {
                return yt.max;
              })]).nice(), ot = A.scaleBand().range([0, B]).round(1 / k.length).domain(k.map(function(yt) {
                return yt.Category;
              })), Z = A.axisBottom().scale(et).tickFormat(X), lt = A.axisLeft().scale(ot), z = A.scaleOrdinal().domain(k.map(function(yt) {
                return yt.Category;
              })).range(["#ff9315", "#0d61ff", "gold", "blue", "green", "red", "black", "orange", "brown", "grey", "slateblue", "grey1", "darkgreen"]), nt = 0, it = nt;
              if (W.showXAxis) {
                var Q = j.append("g").attr("class", "axis");
                Q.call(Z), nt = Math.round(Q.node().getBBox().height) + 2, it = Math.round(Q.node().getBBox().width) + 4, B -= nt, tt -= Math.max(0, it - tt), Q.remove();
              }
              var ht = 0;
              if (W.showYAxis) {
                var pt = j.append("g").attr("class", "axis");
                pt.call(lt), tt -= ht = Math.round(pt.node().getBBox().width), pt.remove();
              }
              var st = W.boxHeight, xt = ot.bandwidth() / 2 - st / 2, gt = st / 2, dt = gt / 10;
              W.showMinMarkers && (tt -= dt > ht ? 2 * dt - ht : dt), et.range([0, tt]), ot.range([B, 0]);
              var Tt = j.append("g").attr("transform", `translate(
	          `.concat(W.margins.left + Math.max(ht, dt), `,
	          `).concat(W.margins.top, `
	        )`)), Ht = Tt.selectAll(".boxplot").data(k).enter().append("g").attr("class", "boxplot").attr("transform", function(yt) {
                return "translate(0, ".concat(ot(yt.Category), ")");
              }), te = this, _t = A.scaleLinear().range([st / 2, 0]).domain([0, st]);
              Ht.each(function(yt) {
                var bt = yt, Ct = A.select(this).append("g").attr("transform", function() {
                  return "translate(0, ".concat(xt, ")");
                }).append("g").datum(yt);
                bt.LIF != bt.q1 && (Ct.append("line").attr("class", "bar").attr("x1", et(bt.LIF)).attr("y1", _t(1.5 * gt)).attr("x2", et(bt.LIF)).attr("y2", _t(0.5 * gt)).style("stroke", z(bt.Category)), Ct.append("line").attr("class", "whisker").attr("x1", et(bt.LIF)).attr("y1", _t(gt)).attr("x2", et(bt.q1)).attr("y2", _t(gt)).style("stroke", z(bt.Category))), Ct.append("rect").attr("class", "box").attr("x", et(bt.q1)).attr("y", Math.min(_t(0), _t(st))).attr("width", Math.max(1, et(bt.q3) - et(bt.q1))).attr("height", Math.abs(_t(0) - _t(st))).style("fill", z(bt.Category)).style("stroke", z(bt.Category)).style("fill-opacity", 0.4).on("mouseover", function(mt) {
                  return te.tip.show(mt, event.target);
                }).on("mouseout", function(mt) {
                  return te.tip.hide(mt, event.target);
                }), Ct.append("line").attr("class", "median").attr("x1", et(bt.median)).attr("y1", _t(0)).attr("x2", et(bt.median)).attr("y2", _t(st)).style("stroke", z(bt.Category)), bt.UIF != bt.q3 && (Ct.append("line").attr("class", "bar").attr("x1", et(bt.UIF)).attr("y1", _t(1.5 * gt)).attr("x2", et(bt.UIF)).attr("y2", _t(0.5 * gt)).style("stroke", z(bt.Category)), Ct.append("line").attr("class", "whisker").attr("x1", et(bt.q3)).attr("y1", _t(gt)).attr("x2", et(bt.UIF)).attr("y2", _t(gt)).style("stroke", z(bt.Category))), W.showMinMarkers && Ct.append("circle").attr("cx", et(bt.min)).attr("cy", _t(gt)).attr("r", dt).style("fill", z(bt.Category)).style("stroke", z(bt.Category)).style("fill-opacity", 0.4), W.showMaxMarkers && Ct.append("circle").attr("cx", et(bt.max)).attr("cy", _t(gt)).attr("r", dt).style("fill", z(bt.Category)).style("stroke", z(bt.Category)).style("fill-opacity", 0.4);
              }), W.showXAxis && Tt.append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(B, ")")).call(Z), W.showYAxis && Tt.append("g").attr("class", "y axis").attr("transform", "translate(0, 0)").call(lt).selectAll(".tick text").call(this.wrap, ot.bandwidth() || ot.range()).selectAll(".tick text tspan").attr("x", -9);
            } }]) && E(C.prototype, P), V;
          }(x);
          return v;
        }).apply(d, y), f === void 0 || (l.exports = f);
      }, 557: (l, d, g) => {
        var y, f;
        function m(x) {
          return m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(v) {
            return typeof v;
          } : function(v) {
            return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
          }, m(x);
        }
        function b(x, v) {
          if (!(x instanceof v)) throw new TypeError("Cannot call a class as a function");
        }
        function E(x, v) {
          for (var w = 0; w < v.length; w++) {
            var C = v[w];
            C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(x, C.key, C);
          }
        }
        function S(x, v, w) {
          return S = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(C, P, Y) {
            var V = function(T, R) {
              for (; !Object.prototype.hasOwnProperty.call(T, R) && (T = A(T)) !== null; ) ;
              return T;
            }(C, P);
            if (V) {
              var k = Object.getOwnPropertyDescriptor(V, P);
              return k.get ? k.get.call(Y) : k.value;
            }
          }, S(x, v, w || x);
        }
        function M(x, v) {
          return M = Object.setPrototypeOf || function(w, C) {
            return w.__proto__ = C, w;
          }, M(x, v);
        }
        function N(x) {
          var v = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var w, C = A(x);
            if (v) {
              var P = A(this).constructor;
              w = Reflect.construct(C, arguments, P);
            } else w = C.apply(this, arguments);
            return O(this, w);
          };
        }
        function O(x, v) {
          return !v || m(v) !== "object" && typeof v != "function" ? function(w) {
            if (w === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return w;
          }(x) : v;
        }
        function A(x) {
          return A = Object.setPrototypeOf ? Object.getPrototypeOf : function(v) {
            return v.__proto__ || Object.getPrototypeOf(v);
          }, A(x);
        }
        y = [g(680), g(842)], f = (function(x, v) {
          var w = function(C) {
            (function(R, F) {
              if (typeof F != "function" && F !== null) throw new TypeError("Super expression must either be null or a function");
              R.prototype = Object.create(F && F.prototype, { constructor: { value: R, writable: !0, configurable: !0 } }), F && M(R, F);
            })(T, C);
            var P, Y, V, k = N(T);
            function T() {
              return b(this, T), k.apply(this, arguments);
            }
            return P = T, V = [{ key: "convertData", value: function(R) {
              return R[0].hasOwnProperty("values") || (R = [{ name: "", values: R }]), R;
            } }, { key: "getMinValue", value: function(R, F) {
              return x.min(R, function(U) {
                return x.min(U.values, function(H) {
                  return H[F];
                });
              });
            } }, { key: "getMaxValue", value: function(R, F) {
              return x.max(R, function(U) {
                return x.max(U.values, function(H) {
                  return H[F];
                });
              });
            } }, { key: "getZeroBasedY", value: function(R) {
              var F = R.data, U = R.yValue, H = R.height, W = T.getMaxValue(F, U);
              return x.scaleLinear().domain([0, W]).range([H, 0]);
            } }, { key: "getRelativeY", value: function(R) {
              var F = R.data, U = R.yValue, H = U === void 0 ? "yValue" : U, W = R.height, B = R.yRangePadding, j = B === void 0 ? 0.1 : B, X = R.defaultYRangePadding, tt = X === void 0 ? 10 : X;
              F = T.convertData(F);
              var et = T.getMinValue(F, H), ot = T.getMaxValue(F, H), Z = (ot - et) * j || tt;
              return x.scaleLinear().domain([et - Z, ot + Z]).range([W, 0]);
            } }], (Y = [{ key: "render", value: function(R, F, U, H, W) {
              S(A(T.prototype), "render", this).call(this, R, F, U, H, W), typeof F == "string" && (F = document.querySelector(F));
              var B = { xFormat: this.formatters.formatSI(3), yFormat: this.formatters.formatSI(3), interpolate: this.interpolation.linear, seriesName: "SERIES_NAME", xValue: "xValue", yValue: "yValue", cssClass: "lineplot", ticks: 10, yTicks: 4, showSeriesLabel: !1, labelIndexDate: !1, colorBasedOnIndex: !1, getTooltipBuilder: null }, j = this.getOptions(B, W), X = this.createSvg(F, U, H), tt = typeof j.getTooltipBuilder == "function" ? j.getTooltipBuilder(j) : this.lineDefaultTooltip(j.xLabel || "x", j.xFormat, function(Gt) {
                return Gt[j.xValue];
              }, j.yLabel || "y", j.yFormat, function(Gt) {
                return Gt[j.yValue];
              }, function(Gt) {
                return Gt[j.seriesName];
              });
              if (R.length > 0) {
                R = T.convertData(R), this.useTip(function(Gt) {
                  Gt.attr("class", "d3-tip").offset([-10, 0]).html(tt);
                });
                var et = 0, ot = 0;
                if (j.xLabel) {
                  var Z = X.append("g").attr("transform", "translate(".concat(U / 2, ", ").concat(H - j.margins.bottom, ")"));
                  Z.append("text").attr("class", "axislabel").style("text-anchor", "middle").text(j.xLabel), et += Z.node().getBBox().height;
                }
                if (j.yLabel) {
                  var lt = X.append("g").attr("transform", `translate(
	              `.concat(j.margins.left, `,
	              `).concat((H - j.margins.bottom - j.margins.top) / 2 + j.margins.top, `
	            )`));
                  lt.append("text").attr("class", "axislabel").attr("transform", "rotate(-90)").attr("y", 0).attr("x", 0).attr("dy", "1em").style("text-anchor", "middle").text(j.yLabel), ot = 1.2 * lt.node().getBBox().width;
                }
                var z = 0;
                if (j.showLegend) {
                  var nt = X.append("g").attr("class", "legend"), it = 0;
                  R.forEach(function(Gt, Re) {
                    nt.append("rect").attr("x", 0).attr("y", 15 * Re).attr("width", 10).attr("height", 10).style("fill", j.colors(Gt.name));
                    var ke = nt.append("text").attr("x", 12).attr("y", 15 * Re + 9).text(Gt.name);
                    it = Math.max(ke.node().getBBox().width + 12, it);
                  }), nt.attr("transform", `translate(
	          `.concat(U - j.margins.right - it, `,
	          `).concat(j.margins.top, `
	        )`)), (z += it + 5) > U / 3 && nt.style("display", "none");
                }
                var Q = U - j.margins.left - j.margins.right - ot - (z > U / 5 ? 0 : z), ht = H - j.margins.top - j.margins.bottom - et, pt = j.xScale || x.scaleLinear().domain([x.min(R, function(Gt) {
                  return x.min(Gt.values, function(Re) {
                    return Re[j.xValue];
                  });
                }), x.max(R, function(Gt) {
                  return x.max(Gt.values, function(Re) {
                    return Re[j.xValue];
                  });
                })]), st = x.axisBottom().scale(pt).ticks(j.ticks);
                j.tickFormat ? st.tickFormat(j.tickFormat) : st.tickFormat(j.xFormat), typeof pt.rangePoints == "function" ? pt.rangePoints([0, Q]) : pt.range([0, Q]);
                var xt = j.yScale || T.getZeroBasedY({ data: R, height: ht, yValue: j.yValue }), gt = x.axisLeft().scale(xt).tickFormat(j.yFormat).ticks(j.yTicks), dt = X.append("g").attr("class", "axis");
                dt.call(st);
                var Tt = Math.round(dt.node().getBBox().height), Ht = Math.round(dt.node().getBBox().width);
                ht -= Tt, Q -= Math.max(0, Ht - Q), dt.remove();
                var te = j.yAxisWidth;
                if (j.yAxisWidth == null) {
                  var _t = X.append("g").attr("class", "axis");
                  _t.call(gt), te = Math.round(_t.node().getBBox().width), _t.remove();
                }
                Q -= te, typeof pt.rangePoints == "function" ? pt.rangePoints([0, Q]) : pt.range([0, Q]), xt.range([ht, 0]);
                var yt = x.line().x(function(Gt) {
                  return pt(Gt[j.xValue]);
                }).y(function(Gt) {
                  return xt(Gt[j.yValue]);
                }).curve(j.interpolate), bt = X.append("g").attr("class", j.cssClass).attr("transform", `translate(
	            `.concat(j.margins.left + ot + te, `,
	            `).concat(j.margins.top, `
	          )`)), Ct = bt.selectAll(".series").data(R).enter().append("g"), mt = Ct.append("path").attr("class", "line").attr("d", function(Gt) {
                  return yt(Gt.values.sort(function(Re, ke) {
                    return x.ascending(Re[j.xValue], ke[j.xValue]);
                  }));
                });
                j.colors && mt.style("stroke", function(Gt, Re) {
                  return j.colors(Gt.name);
                }), j.showSeriesLabel && Ct.append("text").datum(function(Gt) {
                  return { name: Gt.name, value: Gt.values[Gt.values.length - 1] };
                }).attr("transform", function(Gt) {
                  return "translate(".concat(pt(Gt.value[j.xValue]), ", ").concat(xt(Gt.value[j.yValue]), ")");
                }).attr("x", 3).attr("dy", 2).style("font-size", "8px").text(function(Gt) {
                  return Gt.name;
                });
                var se = { x: 0, y: 0 };
                bt.append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(ht, ")")).call(st), bt.append("g").attr("class", "y axis").call(gt), j.labelIndexDate && bt.append("rect").attr("transform", "translate(".concat(se.x - 0.5, ", ").concat(se.y, ")")).attr("width", 1).attr("height", ht), this.appendTracker({ vis: bt, data: R, width: Q, height: ht, x: pt, y: xt, options: j });
              } else X.append("text").attr("transform", "translate(".concat(U / 2, ", ").concat(H / 2, ")")).style("text-anchor", "middle").text("No Data");
            } }, { key: "appendTracker", value: function(R) {
              var F = this, U = R.vis, H = R.data, W = R.width, B = R.height, j = R.x, X = R.y, tt = R.options, et = U.append("g").attr("class", "current-focus").style("display", "none"), ot = et.append("line").attr("class", "x-hover-line").style("stroke-width", "2px").style("stroke-dasharray", "3,3").attr("y1", 0), Z = et.append("circle").attr("r", 2), lt = U.append("rect").style("opacity", 0), z = x.quadtree().x(function(it) {
                return j(it[tt.xValue]);
              }).y(function(it) {
                return X(it[tt.yValue]);
              }), nt = H.reduce(function(it, Q) {
                return it.concat(Q.values.map(function(ht) {
                  return ht.name = Q.name, ht;
                }));
              }, []);
              z.addAll(nt), lt.attr("class", "overlay").attr("width", W).attr("height", B).attr("pointer-events", "all").on("mouseover", function() {
                return et.style("display", null);
              }).on("mouseout", function() {
                et.style("display", "none"), F.tip.hide({}, et.node());
              }), lt.on("mousemove", function() {
                var it = x.event, Q = x.mouse(it.target), ht = z.find(Q[0], Q[1]);
                Z.style("fill", tt.colors(ht.name)), ot.style("stroke", tt.colors(ht.name)), ot.attr("y2", B - X(ht[tt.yValue])), et.attr("transform", "translate(" + j(ht[tt.xValue]) + "," + X(ht[tt.yValue]) + ")"), F.tip.show(ht, et.node());
              });
            } }, { key: "interpolation", get: function() {
              return { linear: x.curveLinear, curveStep: x.curveStep, curveStepBefore: x.curveStepBefore, curveStepAfter: x.curveStepAfter, curveBasis: x.curveBasis, curveCardinal: x.curveCardinal, curveMonotoneX: x.curveMonotoneX, curveCatmullRom: x.curveCatmullRom };
            } }]) && E(P.prototype, Y), V && E(P, V), T;
          }(v);
          return w;
        }).apply(d, y), f === void 0 || (l.exports = f);
      }, 76: (l, d, g) => {
        var y;
        l = g.nmd(l), y = (function(f) {
          var m = { version: "0.0.1" }, b = g(842), E = g(648), S = g(605), M = g(131), N = g(316), O = g(535), A = g(502), x = g(487), v = g(557), w = g(775), C = g(312), P = g(345), Y = g(255), V = g(587), k = g(132);
          return m.chart = b, m.aster = E, m.areachart = S, m.barchart = M, m.boxplot = N, m.donut = O, m.histogram = A, m.horizontalBoxplot = x, m.line = v, m.trellisline = w, m.treemap = C, m.scatterplot = P, m.splitBoxplot = Y, m.sunburst = V, m.util = k, m;
        }).call(d, g, d, l), y === void 0 || (l.exports = y);
      }, 345: (l, d, g) => {
        var y, f;
        function m(x) {
          return m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(v) {
            return typeof v;
          } : function(v) {
            return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
          }, m(x);
        }
        function b(x, v) {
          if (!(x instanceof v)) throw new TypeError("Cannot call a class as a function");
        }
        function E(x, v) {
          for (var w = 0; w < v.length; w++) {
            var C = v[w];
            C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(x, C.key, C);
          }
        }
        function S(x, v, w) {
          return S = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(C, P, Y) {
            var V = function(T, R) {
              for (; !Object.prototype.hasOwnProperty.call(T, R) && (T = A(T)) !== null; ) ;
              return T;
            }(C, P);
            if (V) {
              var k = Object.getOwnPropertyDescriptor(V, P);
              return k.get ? k.get.call(Y) : k.value;
            }
          }, S(x, v, w || x);
        }
        function M(x, v) {
          return M = Object.setPrototypeOf || function(w, C) {
            return w.__proto__ = C, w;
          }, M(x, v);
        }
        function N(x) {
          var v = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var w, C = A(x);
            if (v) {
              var P = A(this).constructor;
              w = Reflect.construct(C, arguments, P);
            } else w = C.apply(this, arguments);
            return O(this, w);
          };
        }
        function O(x, v) {
          return !v || m(v) !== "object" && typeof v != "function" ? function(w) {
            if (w === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return w;
          }(x) : v;
        }
        function A(x) {
          return A = Object.setPrototypeOf ? Object.getPrototypeOf : function(v) {
            return v.__proto__ || Object.getPrototypeOf(v);
          }, A(x);
        }
        y = [g(680), g(842)], f = (function(x, v) {
          var w = function(C) {
            (function(T, R) {
              if (typeof R != "function" && R !== null) throw new TypeError("Super expression must either be null or a function");
              T.prototype = Object.create(R && R.prototype, { constructor: { value: T, writable: !0, configurable: !0 } }), R && M(T, R);
            })(k, C);
            var P, Y, V = N(k);
            function k() {
              return b(this, k), V.apply(this, arguments);
            }
            return P = k, (Y = [{ key: "render", value: function(T, R, F, U, H) {
              S(A(k.prototype), "render", this).call(this, T, R, F, U, H);
              var W = { xFormat: this.formatters.formatSI(3), yFormat: this.formatters.formatSI(3), interpolate: x.curveLinear, seriesName: "SERIES_NAME", xValue: "xValue", yValue: "yValue", cssClass: "lineplot", ticks: 10, yTicks: 4, showSeriesLabel: !1, labelIndexDate: !1, colorBasedOnIndex: !1, truncateLabelAtLine: 2, showXAxis: !0, tooltip: function(mt) {
                return "<div>Series: ".concat(mt.seriesName, `</div>
					<div>X: `).concat(mt[B.xValue], `</div>
					<div>Y: `).concat(mt[B.yValue], `</div>
					`);
              }, circleRadius: 1, addDiagonal: !1, diagonalColor: "#ccc" }, B = this.getOptions(W, H);
              H.colors ? B.colors = x.scaleOrdinal(Object.values(H.colors)).domain(Object.keys(H.colors)) : B.colors = x.scaleOrdinal(x.schemeCategory20).domain(T.map(function(mt) {
                return mt.name;
              }));
              var j = this.createSvg(R, F, U);
              if (T.length > 0) {
                T[0].hasOwnProperty("values") || (T = [{ name: "", values: T }]), this.useTip(function(mt) {
                  mt.attr("class", "d3-tip").offset([-10, 0]).html(B.tooltip);
                });
                var X, tt, et = 0, ot = 0;
                B.xLabel && ((X = j.append("g")).append("text").attr("class", "axislabel").attr("dy", 0).attr("y", 0).style("text-anchor", "middle").text(B.xLabel), et += X.node().getBBox().height), B.yLabel && ((tt = j.append("g")).append("text").attr("class", "axislabel").attr("transform", "rotate(-90)").attr("y", 0).attr("x", 0).attr("dy", "1em").style("text-anchor", "middle").text(B.yLabel), ot = 1.5 * tt.node().getBBox().width);
                var Z = 0;
                if (B.showLegend) {
                  var lt = j.append("g").attr("class", "legend"), z = 0;
                  T.forEach(function(mt, se) {
                    lt.append("rect").attr("x", 0).attr("y", 15 * se).attr("width", 10).attr("height", 10).style("fill", B.colors(mt.name));
                    var Gt = lt.append("text").attr("x", 12).attr("y", 15 * se + 9).text(mt.name);
                    z = Math.max(Gt.node().getBBox().width + 12, z);
                  }), lt.attr("transform", "translate(" + (F - B.margins.right - z) + ",0)"), Z += z + 5;
                }
                var nt = F - B.margins.left - B.margins.right - ot - Z, it = U - B.margins.top - B.margins.bottom - et, Q = B.xScale || x.scaleLinear().domain([x.min(T, function(mt) {
                  return x.min(mt.values, function(se) {
                    return se[B.xValue];
                  });
                }), x.max(T, function(mt) {
                  return x.max(mt.values, function(se) {
                    return se[B.xValue];
                  });
                })]), ht = x.axisBottom().scale(Q).ticks(B.ticks);
                B.tickFormat ? ht.tickFormat(B.tickFormat) : ht.tickFormat(B.xFormat), typeof Q.rangePoints == "function" ? Q.rangePoints([0, nt]) : Q.range([0, nt]);
                var pt = B.yScale || x.scaleLinear().domain([0, x.max(T, function(mt) {
                  return x.max(mt.values, function(se) {
                    return se[B.yValue];
                  });
                })]).range([it, 0]), st = x.axisLeft().scale(pt).tickFormat(B.yFormat).ticks(B.yTicks), xt = j.append("g").attr("class", "axis");
                xt.call(ht);
                var gt = Math.round(xt.node().getBBox().height), dt = Math.round(xt.node().getBBox().width);
                it -= gt, nt -= Math.max(0, dt - nt), xt.remove();
                var Tt = j.append("g").attr("class", "axis");
                Tt.call(st);
                var Ht = Math.round(Tt.node().getBBox().width);
                if (nt -= Ht, Tt.remove(), B.xLabel && X) {
                  X.selectAll("text").call(this.wrap, nt, B.truncateLabelAtLine);
                  var te = X.node().getBBox().height;
                  it -= te, X.attr("transform", `translate(
								`.concat(ot + Ht + B.margins.left + nt / 2, `,
								`).concat(U - B.margins.bottom - te, `
							)`));
                }
                B.yLabel && tt && (tt.attr("transform", `translate(
							`.concat(B.margins.left, `,
							`).concat(B.margins.bottom + it / 2, `
						)`)).selectAll("text").call(this.wrap, it, B.truncateLabelAtLine), ot = tt.node().getBBox().width), typeof Q.rangePoints == "function" ? Q.rangePoints([0, nt]) : Q.range([0, nt]), pt.range([it, 0]);
                var _t = j.append("g").attr("class", B.cssClass).attr("transform", "translate(" + (B.margins.left + ot + Ht) + "," + B.margins.top + ")"), yt = _t.selectAll(".series").data(T).enter().append("g");
                yt.selectAll(".dot").data(function(mt) {
                  return mt.values.map(function(se) {
                    return Object.assign({}, se, { seriesName: mt.name });
                  });
                }).enter().append("circle").attr("class", "dot").attr("r", B.circleRadius).style("fill", function(mt, se) {
                  return B.colors(mt.seriesName);
                }).attr("transform", function(mt) {
                  return "translate(" + Q(mt[B.xValue]) + "," + pt(mt[B.yValue]) + ")";
                }), B.addDiagonal && yt.append("line").attr("x1", 0).attr("y1", it).attr("x2", nt).attr("y2", 0).attr("stroke-width", 1).attr("stroke", B.diagonalColor).attr("stroke-dasharray", "5,5"), B.showSeriesLabel && yt.append("text").datum(function(mt) {
                  return { name: mt.name, value: mt.values[mt.values.length - 1] };
                }).attr("transform", function(mt) {
                  return "translate(" + Q(mt.value[B.xValue]) + "," + pt(mt.value[B.yValue]) + ")";
                }).attr("x", 3).attr("dy", 2).style("font-size", "8px").text(function(mt) {
                  return mt.name;
                });
                var bt = { x: 0, y: 0 }, Ct = this;
                yt.selectAll(".focus").data(function(mt) {
                  return mt.values.map(function(se) {
                    return Object.assign({}, se, { seriesName: mt.name });
                  });
                }).enter().append("circle").attr("class", "focus").attr("r", B.circleRadius).attr("transform", function(mt) {
                  var se = Q(mt[B.xValue]), Gt = pt(mt[B.yValue]);
                  return mt[B.xValue] === 0 && bt.y === 0 && (bt.x = se, bt.y = Gt), "translate(" + se + "," + Gt + ")";
                }).on("mouseover", function(mt) {
                  x.select(this).style("opacity", "1").style("stroke", B.colors(mt.seriesName)).style("stroke-width", B.circleRadius / 2), Ct.tip.show(mt, event.target);
                }).on("mouseout", function(mt) {
                  x.select(this).style("opacity", "0"), Ct.tip.hide(mt, event.target);
                }), B.showXAxis && _t.append("g").attr("class", "x axis").attr("transform", "translate(0," + it + ")").call(ht), _t.append("g").attr("class", "y axis").call(st), B.labelIndexDate && _t.append("rect").attr("transform", function() {
                  return "translate(" + (bt.x - 0.5) + "," + bt.y + ")";
                }).attr("width", 1).attr("height", it);
              } else j.append("text").attr("transform", "translate(" + F / 2 + "," + U / 2 + ")").style("text-anchor", "middle").text("No Data");
            } }]) && E(P.prototype, Y), k;
          }(v);
          return w;
        }).apply(d, y), f === void 0 || (l.exports = f);
      }, 255: (l, d, g) => {
        var y, f;
        function m(A) {
          return m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
            return typeof x;
          } : function(x) {
            return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
          }, m(A);
        }
        function b(A, x) {
          if (!(A instanceof x)) throw new TypeError("Cannot call a class as a function");
        }
        function E(A, x) {
          for (var v = 0; v < x.length; v++) {
            var w = x[v];
            w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(A, w.key, w);
          }
        }
        function S(A, x) {
          return S = Object.setPrototypeOf || function(v, w) {
            return v.__proto__ = w, v;
          }, S(A, x);
        }
        function M(A) {
          var x = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var v, w = O(A);
            if (x) {
              var C = O(this).constructor;
              v = Reflect.construct(w, arguments, C);
            } else v = w.apply(this, arguments);
            return N(this, v);
          };
        }
        function N(A, x) {
          return !x || m(x) !== "object" && typeof x != "function" ? function(v) {
            if (v === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return v;
          }(A) : x;
        }
        function O(A) {
          return O = Object.setPrototypeOf ? Object.getPrototypeOf : function(x) {
            return x.__proto__ || Object.getPrototypeOf(x);
          }, O(A);
        }
        y = [g(680), g(316)], f = (function(A, x) {
          var v = function(w) {
            (function(k, T) {
              if (typeof T != "function" && T !== null) throw new TypeError("Super expression must either be null or a function");
              k.prototype = Object.create(T && T.prototype, { constructor: { value: k, writable: !0, configurable: !0 } }), T && S(k, T);
            })(V, w);
            var C, P, Y = M(V);
            function V() {
              return b(this, V), Y.apply(this, arguments);
            }
            return C = V, (P = [{ key: "render", value: function(k, T, R, F, U) {
              var H = { showXAxis: !0, showMinMarkers: !0, showMaxMarkers: !0, boxHeight: 10, valueFormatter: this.formatters.formatSI(3), margins: { top: 0, right: 0, bottom: 0, left: 0 } }, W = this.getOptions(H, U), B = this.createSvg(T, R, F), j = W.valueFormatter;
              this.useTip(this.defaultTip, W), k.forEach(function(mt) {
                return mt.Category = mt.Category || "Default";
              });
              var X = R - W.margins.left - W.margins.right, tt = F - W.margins.top - W.margins.bottom, et = A.scaleLinear().range([0, X]).domain([W.xMin || A.min(k, function(mt) {
                return Math.min(mt.target.min, mt.compare.min);
              }), W.xMax || A.max(k, function(mt) {
                return Math.max(mt.target.max, mt.compare.max);
              })]), ot = A.scaleBand().range([0, tt]).round(1 / k.length).domain(k.map(function(mt) {
                return mt.Category;
              })), Z = A.axisBottom().scale(et).tickFormat(j).ticks(5), lt = A.axisLeft().scale(ot), z = 0, nt = z;
              if (W.showXAxis) {
                var it = B.append("g").attr("class", "axis");
                it.call(Z), z = Math.round(it.node().getBBox().height) + 2, nt = Math.round(it.node().getBBox().width) + 4, tt -= z, X -= Math.max(0, nt - X), it.remove();
              }
              var Q = 0;
              if (W.showYAxis) {
                var ht = B.append("g").attr("class", "axis");
                ht.call(lt), X -= Q = Math.round(ht.node().getBBox().width), ht.remove();
              }
              var pt = W.boxHeight, st = ot.bandwidth() / 2 - pt / 2, xt = pt / 2, gt = xt / 10;
              W.showMinMarkers && (X -= gt > Q ? 2 * gt - Q : gt), et.range([0, X]), ot.range([tt, 0]);
              var dt = B.append("g").attr("transform", `translate(
	          `.concat(W.margins.left + Math.max(Q, gt), `,
	          `).concat(W.margins.top, `
	        )`));
              if (W.showLegend) {
                var Tt = B.append("g").attr("class", "legend"), Ht = Tt.append("g"), te = Tt.append("g");
                Ht.append("rect").attr("x", 0).attr("y", 0).attr("width", 10).attr("height", 10).attr("class", "target"), Ht.append("text").attr("x", 15).attr("y", 9).text("Target"), te.append("rect").attr("x", Ht.node().getBBox().width + 10).attr("y", 0).attr("width", 10).attr("height", 10).attr("class", "compare"), te.append("text").attr("x", Ht.node().getBBox().width + 25).attr("y", 9).text("Compare"), Tt.attr("transform", `translate(
					`.concat((R - Tt.node().getBBox().width) / 2, `,
					0
				)`));
              }
              var _t = dt.selectAll(".boxplot").data(k).enter().append("g").attr("class", "boxplot").attr("transform", function(mt) {
                return "translate(0, ".concat(ot(mt.Category), ")");
              }), yt = this, bt = A.scaleLinear().range([pt / 2, 0]).domain([0, pt]), Ct = A.scaleLinear().range([0, pt / 2]).domain([0, pt]);
              ot.bandwidth(), _t.each(function(mt) {
                var se = A.select(this).append("g").attr("transform", function() {
                  return "translate(0, ".concat(st, ")");
                }), Gt = se.append("g").datum(mt.target).attr("class", "target"), Re = se.append("g").datum(mt.compare).attr("class", "compare").attr("transform", function() {
                  return "translate(0, ".concat(pt / 2 + 2, ")");
                });
                [{ boxPlotData: mt.target, boxplot: Gt, boxScale: bt }, { boxPlotData: mt.compare, boxplot: Re, boxScale: Ct, tipDirection: "s", tipOffset: [10, 0] }].forEach(function(ke) {
                  var ye = ke.boxPlotData, oe = ke.boxplot, Se = ke.boxScale;
                  ye.LIF != ye.q1 && (oe.append("line").attr("class", "bar").attr("x1", et(ye.LIF)).attr("y1", Se(0)).attr("x2", et(ye.LIF)).attr("y2", Se(xt)), oe.append("line").attr("class", "whisker").attr("x1", et(ye.LIF)).attr("y1", Se(0)).attr("x2", et(ye.q1)).attr("y2", Se(0))), oe.append("rect").attr("class", "box").attr("x", et(ye.q1)).attr("y", Math.min(Se(0), Se(pt))).attr("width", Math.max(1, et(ye.q3) - et(ye.q1))).attr("height", Math.abs(Se(0) - Se(pt))).on("mouseover", function(Dr) {
                    return yt.tip.show(Object.assign({}, Dr, { tipDirection: ke.tipDirection, tipOffset: ke.tipOffset }), event.target);
                  }).on("mouseout", function(Dr) {
                    return yt.tip.hide(Dr, event.target);
                  }), oe.append("line").attr("class", "median").attr("x1", et(ye.median)).attr("y1", Se(0)).attr("x2", et(ye.median)).attr("y2", Se(pt)), ye.UIF != ye.q3 && (oe.append("line").attr("class", "bar").attr("x1", et(ye.UIF)).attr("y1", Se(0)).attr("x2", et(ye.UIF)).attr("y2", Se(xt)), oe.append("line").attr("class", "whisker").attr("x1", et(ye.q3)).attr("y1", Se(0)).attr("x2", et(ye.UIF)).attr("y2", Se(0))), W.showMinMarkers && oe.append("circle").attr("cx", et(ye.min)).attr("cy", Se(xt / 2)).attr("r", gt), W.showMaxMarkers && oe.append("circle").attr("cx", et(ye.max)).attr("cy", Se(xt / 2)).attr("r", gt);
                });
              }), W.showXAxis && dt.append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(tt, ")")).call(Z), W.showYAxis && dt.append("g").attr("class", "y axis").attr("transform", "translate(0, 0)").call(lt).selectAll(".tick text").call(this.wrap, ot.bandwidth() || ot.range());
            } }]) && E(C.prototype, P), V;
          }(x);
          return v;
        }).apply(d, y), f === void 0 || (l.exports = f);
      }, 587: (l, d, g) => {
        var y, f;
        function m(x) {
          return m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(v) {
            return typeof v;
          } : function(v) {
            return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
          }, m(x);
        }
        function b(x, v) {
          if (!(x instanceof v)) throw new TypeError("Cannot call a class as a function");
        }
        function E(x, v) {
          for (var w = 0; w < v.length; w++) {
            var C = v[w];
            C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(x, C.key, C);
          }
        }
        function S(x, v, w) {
          return S = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(C, P, Y) {
            var V = function(T, R) {
              for (; !Object.prototype.hasOwnProperty.call(T, R) && (T = A(T)) !== null; ) ;
              return T;
            }(C, P);
            if (V) {
              var k = Object.getOwnPropertyDescriptor(V, P);
              return k.get ? k.get.call(Y) : k.value;
            }
          }, S(x, v, w || x);
        }
        function M(x, v) {
          return M = Object.setPrototypeOf || function(w, C) {
            return w.__proto__ = C, w;
          }, M(x, v);
        }
        function N(x) {
          var v = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var w, C = A(x);
            if (v) {
              var P = A(this).constructor;
              w = Reflect.construct(C, arguments, P);
            } else w = C.apply(this, arguments);
            return O(this, w);
          };
        }
        function O(x, v) {
          return !v || m(v) !== "object" && typeof v != "function" ? function(w) {
            if (w === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return w;
          }(x) : v;
        }
        function A(x) {
          return A = Object.setPrototypeOf ? Object.getPrototypeOf : function(v) {
            return v.__proto__ || Object.getPrototypeOf(v);
          }, A(x);
        }
        y = [g(680), g(842)], f = (function(x, v) {
          var w = function(C) {
            (function(T, R) {
              if (typeof R != "function" && R !== null) throw new TypeError("Super expression must either be null or a function");
              T.prototype = Object.create(R && R.prototype, { constructor: { value: T, writable: !0, configurable: !0 } }), R && M(T, R);
            })(k, C);
            var P, Y, V = N(k);
            function k() {
              return b(this, k), V.apply(this, arguments);
            }
            return P = k, (Y = [{ key: "getTipDirection", value: function(T) {
              return "n";
            } }, { key: "getTipOffset", value: function(T, R) {
              var F = event.target.getBBox(), U = R.centroid(T), H = Math.abs(F.x - U[0]) - F.width / 2;
              return [Math.abs(F.y - U[1]) - 10, H];
            } }, { key: "render", value: function(T, R, F, U, H) {
              S(A(k.prototype), "render", this).call(this, T, R, F, U, H);
              var W = this.getOptions({ tooltip: function(z) {
                return "<div>No Tooltip Set</div>";
              }, minRadians: 5e-3 }, H), B = this.createSvg(R, F, U);
              B.attr("class", "sunburst"), this.useTip(function(z, nt) {
                z.attr("class", "d3-tip ".concat(nt.tipClass || "")).offset(function(it) {
                  return it.tipOffset || [-10, 0];
                }).direction(function(it) {
                  return it.tipDirection || "n";
                }).html(function(it) {
                  return nt.tooltip(it);
                });
              }, W);
              var j = B.append("svg:g").attr("transform", "translate(" + F / 2 + "," + U / 2 + ")"), X = Math.min(F, U) / 2, tt = x.partition().size([2 * Math.PI, X]), et = x.arc().startAngle(function(z) {
                return z.x0;
              }).endAngle(function(z) {
                return z.x1;
              }).innerRadius(function(z) {
                return z.y0;
              }).outerRadius(function(z) {
                return z.y1;
              });
              j.append("svg:circle").attr("r", X).style("opacity", 0);
              var ot = tt(x.hierarchy(T).sum(function(z) {
                return z.size;
              }).sort(function(z, nt) {
                return nt.value - z.value;
              })).descendants().filter(function(z) {
                return z.x1 - z.x0 > W.minRadians;
              }).reverse();
              if (W.split) {
                var Z = ot.reduce(function(z, nt) {
                  var it = W.split(nt);
                  return it.length > 1 && (nt.isSplit = !0, z = z.concat(it.map(function(Q) {
                    return Object.assign(Q, { isPartialNode: !0 });
                  }))), z;
                }, []);
                j.data([T]).selectAll("partialnode").data(Z).enter().append("svg:path").attr("d", et).attr("fill-rule", "evenodd").attr("class", "partial").style("fill", function(z) {
                  return W.colors(z.data.name);
                });
              }
              var lt = this;
              j.data([T]).selectAll("pathnode").data(ot).enter().append("svg:path").attr("display", function(z) {
                return z.depth ? null : "none";
              }).attr("d", et).attr("fill-rule", "evenodd").attr("class", function(z) {
                return W.nodeClass && W.nodeClass(z) || "node";
              }).style("fill", function(z) {
                return z.isSplit ? "#000" : W.colors(z.data.name);
              }).style("opacity", function(z) {
                return z.isSplit ? 0 : 1;
              }).on("mouseover", function(z) {
                return lt.tip.show(Object.assign({}, z, { tipDirection: lt.getTipDirection(z), tipOffset: lt.getTipOffset(z, et) }), event.target);
              }).on("mouseout", function(z) {
                return lt.tip.hide(z, event.target);
              }).on("click", function(z) {
                return W.onclick && W.onclick(z);
              });
            } }]) && E(P.prototype, Y), k;
          }(v);
          return w;
        }).apply(d, y), f === void 0 || (l.exports = f);
      }, 312: (l, d, g) => {
        var y, f;
        function m(A) {
          return m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
            return typeof x;
          } : function(x) {
            return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
          }, m(A);
        }
        function b(A, x) {
          if (!(A instanceof x)) throw new TypeError("Cannot call a class as a function");
        }
        function E(A, x) {
          for (var v = 0; v < x.length; v++) {
            var w = x[v];
            w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(A, w.key, w);
          }
        }
        function S(A, x) {
          return S = Object.setPrototypeOf || function(v, w) {
            return v.__proto__ = w, v;
          }, S(A, x);
        }
        function M(A) {
          var x = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var v, w = O(A);
            if (x) {
              var C = O(this).constructor;
              v = Reflect.construct(w, arguments, C);
            } else v = w.apply(this, arguments);
            return N(this, v);
          };
        }
        function N(A, x) {
          return !x || m(x) !== "object" && typeof x != "function" ? function(v) {
            if (v === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return v;
          }(A) : x;
        }
        function O(A) {
          return O = Object.setPrototypeOf ? Object.getPrototypeOf : function(x) {
            return x.__proto__ || Object.getPrototypeOf(x);
          }, O(A);
        }
        y = [g(680), g(842)], f = (function(A, x) {
          var v = function(w) {
            (function(T, R) {
              if (typeof R != "function" && R !== null) throw new TypeError("Super expression must either be null or a function");
              T.prototype = Object.create(R && R.prototype, { constructor: { value: T, writable: !0, configurable: !0 } }), R && S(T, R);
            })(k, w);
            var C, P, Y, V = M(k);
            function k() {
              return b(this, k), V.apply(this, arguments);
            }
            return C = k, P = [{ key: "render", value: function(T, R, F, U, H) {
              var W = this, B = this.getOptions(H), j = this.createSvg(R, F, U), X = A.scaleLinear().range([0, F]), tt = A.scaleLinear().range([0, U]);
              A.select(R).select(".treemap_zoomtarget").text("");
              var et = 0, ot = A.treemap().round(!1).size([F, U]), Z = A.hierarchy(T, function(dt) {
                return dt.children;
              }).sum(B.getsizevalue), lt = ot(Z);
              function z(dt) {
                var Tt = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], Ht = F / (dt.x1 - dt.x0) || F, te = U / (dt.y1 - dt.y0) || U;
                dt.x1 && dt.y1 ? (X.domain([dt.x0, dt.x0 + (dt.x1 - dt.x0)]), tt.domain([dt.y0, dt.y0 + (dt.y1 - dt.y0)])) : (X.domain([0, F]), tt.domain([0, U]));
                var _t = A.select(R).select(".treemap_zoomtarget");
                if (_t.size()) if (dt.data.name === "root") _t.text("");
                else {
                  var yt = _t.text();
                  _t.text("".concat(yt, " > ").concat(dt.data.name));
                }
                var bt = j.selectAll("g.cell, .grouper");
                Tt && (bt = bt.transition().duration(750)), bt.attr("transform", function(Ct) {
                  return "translate(".concat(X(Ct.x0), ", ").concat(tt(Ct.y0), ")");
                }).on("end", function() {
                  j.selectAll(".grouper").attr("display", "block");
                }), bt.select("rect").attr("width", function(Ct) {
                  return Math.max(0, Ht * (Ct.x1 - Ct.x0) - 1);
                }).attr("height", function(Ct) {
                  return Math.max(0, te * (Ct.y1 - Ct.y0) - 1);
                }), event && event.stopPropagation(), B.onZoom && B.onZoom(dt);
              }
              function nt(dt) {
                var Tt = F / (dt.x1 - dt.x0), Ht = U / (dt.y1 - dt.y0), te = lt.children.filter(function(_t) {
                  return _t.parent === dt;
                });
                j.selectAll(".grouper").remove(), j.selectAll(".grouper").data(te).enter().append("g").attr("class", "grouper").attr("transform", function(_t) {
                  return "translate(".concat(_t.x0 + 1, ", ").concat(_t.y0 + 1, ")");
                }).attr("display", "none").append("rect").attr("width", function(_t) {
                  return Math.max(0, Tt * (_t.x1 - _t.x0) - 1);
                }).attr("height", function(_t) {
                  return Math.max(0, Ht * (_t.y1 - _t.y0) - 1);
                }).attr("title", function(_t) {
                  return _t.name;
                }).attr("id", function(_t) {
                  return _t.id;
                });
              }
              var it, Q = lt.leaves().filter(function(dt) {
                return B.getsizevalue(dt.data);
              }), ht = A.extent(Q, function(dt) {
                return B.getcolorvalue(dt.data);
              }), pt = A.median(Q, function(dt) {
                return B.getcolorvalue(dt.data);
              });
              it = B.getcolorrange ? B.getcolorrange() : ["#E4FF7A", "#FC7F00"];
              var st = [ht[0], pt, ht[1]];
              B.getcolorscale && (st = B.getcolorscale());
              var xt = A.scaleLinear().domain(st).range(it), gt = j.selectAll("g").data(Q).enter().append("g").attr("class", "cell").attr("transform", function(dt) {
                return "translate(".concat(dt.x0, ", ").concat(dt.y0, ")");
              });
              gt.append("rect").attr("width", function(dt) {
                return Math.max(0, dt.x1 - dt.x0 - 1);
              }).attr("height", function(dt) {
                return Math.max(0, dt.y1 - dt.y0 - 1);
              }).attr("id", function(dt) {
                return dt.id;
              }).style("fill", function(dt) {
                return xt(B.getcolorvalue(dt.data));
              }).on("click", function(dt) {
                if (B.useTip && W.tip.hide(), event.altKey) z(Z), nt(Z);
                else if (event.ctrlKey) {
                  for (var Tt = dt; Tt.depth !== et + 1; ) Tt = Tt.parent;
                  et = Tt.depth, Tt.children && Tt.children.length > 1 ? (nt(Tt), z(Tt)) : (et = 0, nt(Z), z(Z));
                } else B.onclick(dt.data);
              }), B.useTip ? (this.useTip(function(dt) {
                dt.attr("class", "d3-tip").direction(function(Tt) {
                  var Ht = X.domain()[1] === 1 ? F : X.domain()[1];
                  return Tt.x1 >= Ht - Ht / 10 ? "w" : Tt.x0 <= Ht / 10 ? "e" : "n";
                }).offset([3, 0]).html(function(Tt) {
                  return "".concat(B.gettitle(Tt.data), "<br/><br/>").concat(B.getcontent(Tt.data));
                });
              }), gt.on("mouseover", function(dt) {
                return W.tip.show(dt, event.target);
              }).on("mouseout", function(dt) {
                return W.tip.hide(dt, event.target);
              })) : gt.attr("data-container", "body").attr("data-toggle", "popover").attr("data-trigger", "hover").attr("data-placement", "top").attr("data-html", !0).attr("data-title", function(dt) {
                return B.gettitle(dt.data);
              }).attr("data-content", function(dt) {
                return B.getcontent(dt.data);
              }), B.initialZoomedConcept ? (nt(B.initialZoomedConcept), z(B.initialZoomedConcept, !1)) : nt(Z), j.selectAll(".grouper").attr("display", "block");
            } }, { key: "formatters", get: function() {
              return { format_pct: A.format(".2%"), format_fixed: A.format(".2f"), format_comma: A.format(",") };
            } }], Y = [{ key: "buildHierarchyFromJSON", value: function(T, R, F) {
              var U = 0, H = { name: "root", children: [] };
              return T.PERCENT_PERSONS.forEach(function(W) {
                U += W;
              }), T.CONCEPT_PATH.forEach(function(W, B) {
                for (var j = W.split("||"), X = H, tt = function(ot) {
                  var Z = X.children, lt = j[ot], z = void 0;
                  if (ot + 1 < j.length) {
                    var nt = !1;
                    Z.forEach(function(it) {
                      it.name === lt && (z = it, nt = !0);
                    }), nt || (z = { name: lt, children: [] }, Z.push(z)), X = z;
                  } else z = F(lt, B, T), T.PERCENT_PERSONS[B] / U > R && Z.push(z);
                }, et = 0; et < j.length; et += 1) tt(et);
              }), H;
            } }], P && E(C.prototype, P), Y && E(C, Y), k;
          }(x);
          return v;
        }).apply(d, y), f === void 0 || (l.exports = f);
      }, 775: (l, d, g) => {
        var y, f;
        function m(x) {
          return m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(v) {
            return typeof v;
          } : function(v) {
            return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
          }, m(x);
        }
        function b(x, v) {
          if (!(x instanceof v)) throw new TypeError("Cannot call a class as a function");
        }
        function E(x, v) {
          for (var w = 0; w < v.length; w++) {
            var C = v[w];
            C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(x, C.key, C);
          }
        }
        function S(x, v, w) {
          return S = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(C, P, Y) {
            var V = function(T, R) {
              for (; !Object.prototype.hasOwnProperty.call(T, R) && (T = A(T)) !== null; ) ;
              return T;
            }(C, P);
            if (V) {
              var k = Object.getOwnPropertyDescriptor(V, P);
              return k.get ? k.get.call(Y) : k.value;
            }
          }, S(x, v, w || x);
        }
        function M(x, v) {
          return M = Object.setPrototypeOf || function(w, C) {
            return w.__proto__ = C, w;
          }, M(x, v);
        }
        function N(x) {
          var v = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var w, C = A(x);
            if (v) {
              var P = A(this).constructor;
              w = Reflect.construct(C, arguments, P);
            } else w = C.apply(this, arguments);
            return O(this, w);
          };
        }
        function O(x, v) {
          return !v || m(v) !== "object" && typeof v != "function" ? function(w) {
            if (w === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return w;
          }(x) : v;
        }
        function A(x) {
          return A = Object.setPrototypeOf ? Object.getPrototypeOf : function(v) {
            return v.__proto__ || Object.getPrototypeOf(v);
          }, A(x);
        }
        y = [g(680), g(842)], f = (function(x, v) {
          var w = function(C) {
            (function(T, R) {
              if (typeof R != "function" && R !== null) throw new TypeError("Super expression must either be null or a function");
              T.prototype = Object.create(R && R.prototype, { constructor: { value: T, writable: !0, configurable: !0 } }), R && M(T, R);
            })(k, C);
            var P, Y, V = N(k);
            function k() {
              return b(this, k), V.apply(this, arguments);
            }
            return P = k, (Y = [{ key: "render", value: function(T, R, F, U, H) {
              S(A(k.prototype), "render", this).call(this, T, R, F, U, H);
              var W = { trellisSet: x.keys(T), yTicks: 4, xFormat: x.format("d"), yFormat: x.format("d"), interpolate: x.curveLinear }, B = this.getOptions(W, H), j = this.createSvg(R, F, U);
              function X() {
                var $t = _t.invert(x.mouse(event.target)[0]);
                oe.selectAll(".g-label-value.g-start").call(tt, $t), oe.selectAll(".g-label-year.g-start").call(et, $t), oe.selectAll(".g-value").attr("transform", function(Ft) {
                  var re = Ft.values;
                  if (re) {
                    var pe = re[lt(re, $t, 0, re.length - 1)], un = pe.Y_PREVALENCE_1000PP === 0 || pe.Y_PREVALENCE_1000PP ? pe.Y_PREVALENCE_1000PP : pe.yPrevalence1000Pp;
                    return pe && pe.date ? "translate(" + _t(pe.date) + "," + yt(un) + ")" : "translate(0,0);";
                  }
                });
              }
              function tt($t, Ft) {
                var re = x.scaleLinear().domain(_t.range()), pe = {};
                $t.each(function(un, _n) {
                  var oa = x.select(this), De = un.values, bn = lt(De, Ft, 0, De.length - 1), Mr = Math.round(bn / (De.length - 1) * (De.length - 12)), Je = De[bn];
                  if (Je && Je.date) {
                    var sa = _t(Je.date), Ri = Je.Y_PREVALENCE_1000PP === 0 || Je.Y_PREVALENCE_1000PP ? Je.Y_PREVALENCE_1000PP : Je.yPrevalence1000Pp, Ks = re.range([0, te.bandwidth()])(sa), ef = yt(x.max(De.slice(Mr, Mr + 12), function(Zs) {
                      return Ri;
                    })), ua = Je.TRELLIS_NAME || Je.trellisName;
                    if (ua) {
                      !pe[ua] && (pe[ua] = []);
                      var nf = Je.date.getTime() === nt.getTime() ? "end" : (Je.date.getTime(), z.getTime(), "start");
                      pe[ua].push({ y: ef, x: Ks, textAnchor: nf, value: Ri, text: oa, color: B.colors(un.key) });
                    }
                  }
                }), Object.keys(pe).forEach(function(un) {
                  var _n = pe[un];
                  _n.sort(function(De, bn) {
                    return De.y - bn.y;
                  }), _n.forEach(function(De, bn) {
                    if (bn > 0) {
                      var Mr = _n[bn - 1].y;
                      _n[bn].y += Math.max(0, Mr + 15 - _n[bn].y);
                    }
                  });
                  var oa = _n.filter(function(De) {
                    return De.value <= 20;
                  });
                  _n.forEach(function(De) {
                    var bn = De.text, Mr = De.x, Je = De.y, sa = (De.color, De.textAnchor), Ri = De.value;
                    bn.text(B.yFormat(Ri)).style("display", "block").style("text-anchor", sa).attr("transform", `translate(
	              `.concat(sa === "start" ? Mr + 4 : Mr - 4, `,
	              `).concat(Ri <= 20 && oa.length !== 1 ? Je - 20 : Je, `
	            )`));
                  });
                });
              }
              function et($t, Ft) {
                var re = x.scaleLinear().domain(_t.range()), pe = T[0] && T[0].values[0] && T[0].values[0].values || [], un = pe[lt(pe, Ft, 0, pe.length - 1)];
                if (un && un.date) {
                  var _n = _t(un.date);
                  $t.each(function(oa) {
                    x.select(this).text(un.date.getFullYear()).attr("transform", `translate(
	              `.concat(re.range([0, te.bandwidth() - this.getComputedTextLength()])(_n), `,
	              `).concat(Ht + 6, `
	              )`)).style("display", null);
                  });
                }
              }
              var ot, Z, lt = x.bisector(function($t) {
                return $t.date;
              }).left, z = x.min(T, function($t) {
                return x.min($t.values, function(Ft) {
                  return x.min(Ft.values, function(re) {
                    return re.date;
                  });
                });
              }), nt = x.max(T, function($t) {
                return x.max($t.values, function(Ft) {
                  return x.max(Ft.values, function(re) {
                    return re.date;
                  });
                });
              }), it = x.min(T, function($t) {
                return x.min($t.values, function(Ft) {
                  return x.min(Ft.values, function(re) {
                    return re.Y_PREVALENCE_1000PP === 0 || re.Y_PREVALENCE_1000PP ? re.Y_PREVALENCE_1000PP : re.yPrevalence1000Pp;
                  });
                });
              }), Q = x.max(T, function($t) {
                return x.max($t.values, function(Ft) {
                  return x.max(Ft.values, function(re) {
                    return re.Y_PREVALENCE_1000PP === 0 || re.Y_PREVALENCE_1000PP ? re.Y_PREVALENCE_1000PP : re.yPrevalence1000Pp;
                  });
                });
              }), ht = 0;
              B.seriesLabel && ((ot = j.append("g")).append("text").attr("class", "axislabel").style("text-anchor", "middle").attr("dy", ".79em").text(B.seriesLabel), (ht = ot.node()) && (ht = ot.node().getBBox().height + 10));
              var pt, st, xt, gt = 0;
              B.trellisLabel && ((Z = j.append("g")).append("text").attr("class", "axislabel").style("text-anchor", "middle").attr("dy", ".79em").text(B.trellisLabel), gt = Z.node().getBBox().height + 10), (pt = j.append("g").attr("class", "g-label-trellis")).append("text").text(B.trellisSet.join("")), st = pt.node().getBBox().height + 10, pt.remove();
              var dt = 0;
              B.yLabel && ((xt = j.append("g")).append("text").attr("class", "axislabel").style("text-anchor", "middle").text(B.yLabel), dt = xt.node().getBBox().height + 4);
              var Tt = F - B.margins.left - dt - B.margins.right, Ht = U - B.margins.top - gt - st - ht - 2 * B.margins.bottom, te = x.scaleBand().domain(B.trellisSet).range([0, Tt]).paddingOuter(0.2).paddingInner(0.25), _t = x.scaleTime().domain([z, nt]).range([0, te.bandwidth()]), yt = x.scaleLinear().domain([it, Q]).range([Ht, 0]), bt = x.axisLeft().scale(yt).tickFormat(B.yFormat).ticks(B.yTicks), Ct = x.axisBottom().scale(_t), mt = j.append("g").attr("class", "axis");
              mt.call(Ct);
              var se = Math.round(mt.node().getBBox().height), Gt = Math.round(mt.node().getBBox().width);
              Ht -= se, Tt -= Math.max(0, Gt - Tt), mt.remove();
              var Re = j.append("g").attr("class", "axis");
              Re.call(bt);
              var ke = Math.round(Re.node().getBBox().width);
              Tt -= ke, Re.remove(), te.range([0, Tt]).paddingOuter(0.2).paddingInner(0.25), _t.range([0, te.bandwidth()]), yt.range([Ht, 0]), B.trellisLabel && Z.attr("transform", `translate(
	        `.concat(Tt / 2 + B.margins.left, `,
	        `).concat(B.margins.top, `
	      )`)), B.seriesLabel && ot.attr("transform", `translate(
	        `.concat(Tt / 2 + B.margins.left, `,
	        `).concat(gt + Ht + se + ht + 2 * B.margins.top, `
	      )`)), B.yLabel && (xt.attr("transform", `translate(
	        `.concat(B.margins.left, `,
	        `).concat(Ht / 2 + gt + st, `
	      )`)), xt.select("text").attr("transform", "rotate(-90)").attr("y", 0).attr("x", 0).attr("dy", "1em"));
              var ye = x.line().x(function($t) {
                return _t($t.date);
              }).y(function($t) {
                return yt($t.Y_PREVALENCE_1000PP === 0 || $t.Y_PREVALENCE_1000PP ? $t.Y_PREVALENCE_1000PP : $t.yPrevalence1000Pp);
              }).curve(B.interpolate), oe = x.select(j.node()).append("g").attr("transform", function($t) {
                return `translate(
	        `.concat(dt + ke + B.margins.left, `,
	        `).concat(gt, `
	      )`);
              }).selectAll(".g-trellis").data(te.domain()).enter().append("g").attr("class", "g-trellis").attr("transform", function($t) {
                return "translate(".concat(te($t), ", ").concat(st, ")");
              }), Se = x.axisBottom().scale(_t).tickFormat("").tickSize(-Ht), Dr = x.axisLeft().scale(yt).tickFormat("").tickSize(-te.bandwidth()).ticks(8);
              oe.append("g").attr("class", "x-guide").attr("transform", "translate(0, ".concat(Ht, ")")).call(Se), oe.append("g").attr("class", "y-guide").call(Dr);
              var Zr = oe.selectAll(".g-series").data(function($t) {
                var Ft = T.filter(function(re) {
                  return re.key === $t;
                });
                return Ft.length > 0 ? Ft[0].values : [];
              }).enter().append("g").attr("class", "g-series lineplot");
              Zr.append("path").attr("class", "line").attr("d", function($t) {
                return ye($t.values.sort(function(Ft, re) {
                  return x.ascending(Ft.date, re.date);
                }));
              }).style("stroke", function($t) {
                return B.colors($t.key);
              }), Zr.append("circle").attr("class", "g-value").attr("transform", function($t) {
                var Ft = $t.values;
                if (Ft && Ft[Ft.length - 1] && Ft[Ft.length - 1].date && Ft[Ft.length - 1] && (Ft[Ft.length - 1].Y_PREVALENCE_1000PP || Ft[Ft.length - 1].yPrevalence1000Pp)) {
                  var re = Ft[Ft.length - 1].Y_PREVALENCE_1000PP === 0 || Ft[Ft.length - 1].Y_PREVALENCE_1000PP ? Ft[Ft.length - 1].Y_PREVALENCE_1000PP : Ft[Ft.length - 1].yPrevalence1000Pp;
                  return "translate(".concat(_t(Ft[Ft.length - 1].date), ", ").concat(yt(re), ")");
                }
                return "translate(0, 0)";
              }).attr("r", 2.5).style("display", "none"), Zr.append("text").attr("class", "g-label-value g-start").call(tt, z), Zr.append("text").attr("class", "g-label-value g-end").call(tt, nt), oe.append("text").attr("class", "g-label-year g-start").attr("dy", ".71em").call(et, z), oe.append("text").attr("class", "g-label-year g-end").attr("dy", ".71em").call(et, nt), oe.append("g").attr("class", "x axis").append("line").attr("x2", te.bandwidth()).attr("y1", yt(it)).attr("y2", yt(it)), oe.append("g").attr("class", "g-label-trellis").attr("transform", function($t) {
                return "translate(".concat(te.bandwidth() / 2, ", 0)");
              }).append("text").attr("dy", "-1em").style("text-anchor", "middle").text(function($t) {
                return $t;
              }), oe.append("rect").attr("class", "g-overlay").attr("x", -4).attr("width", te.bandwidth() + 8).attr("height", Ht + 18).on("mouseover", function() {
                oe.selectAll(".g-end").style("display", "none"), oe.selectAll(".g-value").style("display", null), X.call(this);
              }).on("mousemove", X).on("mouseout", function() {
                oe.selectAll(".g-end").style("display", null), oe.selectAll(".g-label-value.g-start").call(tt, z), oe.selectAll(".g-label-year.g-start").call(et, z), oe.selectAll(".g-label-year.g-end").call(et, nt), oe.selectAll(".g-value").style("display", "none");
              }), x.select(oe.nodes()[0]).append("g").attr("class", "y axis").attr("transform", "translate(-4,0)").call(bt), j.append("g").attr("transform", "translate(".concat(B.margins.left, ", ").concat(B.margins.top, ")")).call(function($t) {
                var Ft = 0;
                B.colors.domain().forEach(function(re) {
                  var pe = $t.append("g").attr("class", "trellisLegend"), un = pe.append("text").text(re), _n = pe.node().getBBox();
                  un.attr("x", 12).attr("y", _n.height), pe.append("line").attr("x1", 0).attr("y1", 10).attr("x2", 10).attr("y2", 10).style("stroke", function() {
                    return B.colors(re);
                  }), pe.attr("transform", "translate(".concat(Ft, ", 0)")), Ft += pe.node().getBBox().width + 5;
                });
              });
            } }]) && E(P.prototype, Y), k;
          }(v);
          return w;
        }).apply(d, y), f === void 0 || (l.exports = f);
      }, 132: (l, d, g) => {
        var y, f;
        y = [g(680)], (f = (function(m) {
          var b = m.format(",.3r");
          return { wrap: function(E, S) {
            E.each(function() {
              for (var M, N = m.select(this), O = N.text().split(/\s+/).reverse(), A = [], x = 0, v = N.attr("y"), w = parseFloat(N.attr("dy")), C = N.text(null).append("tspan").attr("x", 0).attr("y", v).attr("dy", w + "em"); M = O.pop(); ) A.push(M), C.text(A.join(" ")), C.node().getComputedTextLength() > S && (A.length > 1 && (A.pop(), O.push(M), C.text(A.join(" "))), A = [], x += 1, C = N.append("tspan").attr("x", 0).attr("y", v).attr("dy", 1.1 * x + w + "em"));
            });
          }, formatInteger: function(E) {
            return b(E);
          }, formatSI: function(E) {
            return E = E || 0, function(S) {
              if (S < 1) return m.round(S, E);
              var M = m.formatPrefix(S);
              return m.round(M.scale(S), E) + M.symbol;
            };
          }, buildHierarchy: function(E, S, M) {
            for (var N = S || function(U) {
              return U[0];
            }, O = M || function(U) {
              return U[1];
            }, A = { name: "root", children: [] }, x = 0; x < E.length; x++) {
              var v = N(E[x]), w = +O(E[x]);
              if (!isNaN(w)) for (var C = v.split("-"), P = A, Y = 0; Y < C.length; Y++) {
                var V, k = P.children, T = C[Y];
                if (Y + 1 < C.length) {
                  for (var R = !1, F = 0; F < k.length; F++) if (k[F].name == T && k[F].children) {
                    V = k[F], R = !0;
                    break;
                  }
                  R || (V = { name: T, children: [] }, k.push(V)), P = V;
                } else V = { name: T, size: w }, k.push(V);
              }
            }
            return A;
          } };
        }).apply(d, y)) === void 0 || (l.exports = f);
      }, 383: function(l, d, g) {
        var y, f, m;
        f = [g(680)], y = function(b) {
          return function() {
            var E = w, S = C, M = P, N = j(), O = null, A = null, x = null;
            function v(Z) {
              O = X(Z), A = O.createSVGPoint(), document.body.appendChild(N);
            }
            function w() {
              return "n";
            }
            function C() {
              return [0, 0];
            }
            function P() {
              return " ";
            }
            v.show = function() {
              var Z = Array.prototype.slice.call(arguments);
              Z[Z.length - 1] instanceof SVGElement && (x = Z.pop());
              var lt, z = M.apply(this, Z), nt = S.apply(this, Z), it = E.apply(this, Z), Q = tt(), ht = V.length, pt = document.documentElement.scrollTop || document.body.scrollTop, st = document.documentElement.scrollLeft || document.body.scrollLeft;
              for (Q.html(z).style("opacity", 1).style("pointer-events", "all"); ht--; ) Q.classed(V[ht], !1);
              return lt = Y.get(it).apply(this), Q.classed(it, !0).style("top", lt.top + nt[0] + pt + "px").style("left", lt.left + nt[1] + st + "px"), v;
            }, v.hide = function() {
              return tt().style("opacity", 0).style("pointer-events", "none"), v;
            }, v.attr = function(Z, lt) {
              if (arguments.length < 2 && typeof Z == "string") return tt().attr(Z);
              var z = Array.prototype.slice.call(arguments);
              return b.selection.prototype.attr.apply(tt(), z), v;
            }, v.style = function(Z, lt) {
              if (arguments.length < 2 && typeof Z == "string") return tt().style(Z);
              var z = Array.prototype.slice.call(arguments);
              return b.selection.prototype.style.apply(tt(), z), v;
            }, v.direction = function(Z) {
              return arguments.length ? (E = Z == null ? Z : ot(Z), v) : E;
            }, v.offset = function(Z) {
              return arguments.length ? (S = Z == null ? Z : ot(Z), v) : S;
            }, v.html = function(Z) {
              return arguments.length ? (M = Z == null ? Z : ot(Z), v) : M;
            }, v.destroy = function() {
              return N && (tt().remove(), N = null), v;
            };
            var Y = b.map({ n: k, s: T, e: R, w: F, nw: U, ne: H, sw: W, se: B }), V = Y.keys();
            function k() {
              var Z = et();
              return { top: Z.n.y - N.offsetHeight, left: Z.n.x - N.offsetWidth / 2 };
            }
            function T() {
              var Z = et();
              return { top: Z.s.y, left: Z.s.x - N.offsetWidth / 2 };
            }
            function R() {
              var Z = et();
              return { top: Z.e.y - N.offsetHeight / 2, left: Z.e.x };
            }
            function F() {
              var Z = et();
              return { top: Z.w.y - N.offsetHeight / 2, left: Z.w.x - N.offsetWidth };
            }
            function U() {
              var Z = et();
              return { top: Z.nw.y - N.offsetHeight, left: Z.nw.x - N.offsetWidth };
            }
            function H() {
              var Z = et();
              return { top: Z.ne.y - N.offsetHeight, left: Z.ne.x };
            }
            function W() {
              var Z = et();
              return { top: Z.sw.y, left: Z.sw.x - N.offsetWidth };
            }
            function B() {
              var Z = et();
              return { top: Z.se.y, left: Z.e.x };
            }
            function j() {
              var Z = b.select(document.createElement("div"));
              return Z.style("position", "absolute").style("top", 0).style("opacity", 0).style("pointer-events", "none").style("box-sizing", "border-box"), Z.node();
            }
            function X(Z) {
              return (Z = Z.node()).tagName.toLowerCase() === "svg" ? Z : Z.ownerSVGElement;
            }
            function tt() {
              return N === null && (N = j(), document.body.appendChild(N)), b.select(N);
            }
            function et() {
              for (var Z = x || b.event.target; Z.getScreenCTM === void 0 && Z.parentNode === "undefined"; ) Z = Z.parentNode;
              var lt = {}, z = Z.getScreenCTM(), nt = Z.getBBox(), it = nt.width, Q = nt.height, ht = nt.x, pt = nt.y;
              return A.x = ht, A.y = pt, lt.nw = A.matrixTransform(z), A.x += it, lt.ne = A.matrixTransform(z), A.y += Q, lt.se = A.matrixTransform(z), A.x -= it, lt.sw = A.matrixTransform(z), A.y -= Q / 2, lt.w = A.matrixTransform(z), A.x += it, lt.e = A.matrixTransform(z), A.x -= it / 2, A.y -= Q / 2, lt.n = A.matrixTransform(z), A.y += Q, lt.s = A.matrixTransform(z), lt;
            }
            function ot(Z) {
              return typeof Z == "function" ? Z : function() {
                return Z;
              };
            }
            return v;
          };
        }, (m = typeof y == "function" ? y.apply(d, f) : y) === void 0 || (l.exports = m);
      }, 680: (l) => {
        l.exports = n;
      }, 756: (l) => {
        l.exports = a;
      }, 92: (l) => {
        l.exports = r;
      } }, u = {};
      function c(l) {
        if (u[l]) return u[l].exports;
        var d = u[l] = { id: l, loaded: !1, exports: {} };
        return o[l].call(d.exports, d, d.exports, c), d.loaded = !0, d.exports;
      }
      return c.nmd = (l) => (l.paths = [], l.children || (l.children = []), l), c(76);
    })();
  });
})(t2);
var Hk = t2.exports;
const Ci = /* @__PURE__ */ vD(Hk), Xk = (t, e) => {
  if (t) {
    const n = Qr(t);
    if (!n.empty) {
      const r = new Object(), a = new Object();
      let o = 0;
      for (let l in n.yNumPersons)
        o += n.yNumPersons[l];
      a.COUNT_VALUE = n.yNumPersons.slice(), a.INTERVAL_INDEX = n.xCount.slice(), a.PERCENT_VALUE = n.yNumPersons.map(function(l) {
        return l / o * 100;
      }), r.DATA = a, r.OFFSET = 0, r.INTERVALS = a.INTERVAL_INDEX.length, r.INTERVAL_SIZE = 1;
      const u = (Math.floor((Math.max.apply(null, n.yNumPersons) + 5) / 10) + 1) * 10;
      return {
        data: Ci.histogram.mapHistogram(r),
        yMax: u,
        xLabel: 'Count ("x" or more ' + e + "s)",
        ticks: Math.min(5, r.INTERVALS)
      };
    }
  }
}, Qk = (t, r) => {
  var n = {
    dateField: "x",
    yValue: "y",
    yPercent: "p"
  }, r = { ...n, ...r }, a = {};
  if (a.name = "All Time", a.values = [], t && !t.empty) {
    for (let o = 0; o < t[r.dateField].length; o++) {
      const c = (t[r.dateField][o] / 100).toString().split("."), l = c[0], d = c[1].split("");
      d.length === 1 && d.push("0");
      let g = "";
      d[0] > 0 && (g = d.join("") - 1), d[0] == 0 && (g = d[1] - 1), a.values.push({
        xValue: new Date(l, g, 1),
        yValue: t[r.yValue][o],
        yPercent: t[r.yPercent][o]
      });
    }
    a.values.sort(function(o, u) {
      return o.xValue - u.xValue;
    });
  }
  return [a];
}, Zl = (t, e) => {
  const n = Qr(t);
  if (!n.empty) {
    const r = Qk(n, e);
    return {
      data: r,
      xScale: Wl().domain(
        ks(r[0].values, (a) => a.xValue)
      )
    };
  }
}, e2 = (t, e) => {
  const n = Qr(t);
  e && (n.xCalendarYear = n.xCalendarYear, n.yPrevalence1000Pp = n.yPrevalence1000Pp);
  const r = "xCalendarYear";
  if (!n.empty) {
    const a = wl(n[r]), o = bl(n[r]), u = function(f, m, b, E) {
      return {
        trellisName: f,
        seriesName: m,
        xCalendarYear: b,
        yPrevalence1000Pp: E
      };
    }, c = Ip().key(function(f) {
      return f.trellisName;
    }).key(function(f) {
      return f.seriesName;
    }).sortValues(function(f, m) {
      return f[r] - m[r];
    }), l = n.trellisName.map(function(f, m) {
      const b = {}, E = n;
      return $x(E).forEach(function(S) {
        b[S] = E[S][m];
      }), b;
    }), d = c.entries(l), g = tr(a, o, 1);
    let y = {};
    return d.forEach(function(f) {
      f.values.forEach(function(m) {
        m.values = g.map(function(b) {
          return y = m.values.filter(function(E) {
            return E[r] === b;
          })[0] || u(f.key, m.key, b, 0), y.date = new Date(b, 0, 1), y;
        });
      });
    }), d;
  }
  return {};
}, Kk = (t, e) => {
  const n = e.prevalenceByGenderAgeYear && e.prevalenceByGenderAgeYear.length > 0 && e2(e.prevalenceByGenderAgeYear), r = e.prevalenceByMonth && e.prevalenceByMonth.length > 0 && Zl(e.prevalenceByMonth, {
    dateField: "xCalendarMonth",
    yValue: "yPrevalence1000Pp",
    yPercent: "yPrevalence1000Pp"
  }), a = e.ageAtFirstOccurrence && e.ageAtFirstOccurrence.length > 0 && _r(e.ageAtFirstOccurrence), o = e.byType && e.byType.length > 0 && Da(e.byType), u = e.lengthOfEra && e.lengthOfEra.length > 0 && _r(e.lengthOfEra), c = e.frequencyDistribution && e.frequencyDistribution.length > 0 && Xk(e.frequencyDistribution, t), l = e.byValueAsConcept && e.byValueAsConcept.length > 0 && Da(e.byValueAsConcept), d = e.byQualifier && e.byQualifier.length > 0 && Da(e.byQualifier), g = e.byOperator && e.byOperator.length > 0 && Da(e.byOperator), y = e.recordsByUnit && e.recordsByUnit.length > 0 && Da(e.recordsByUnit), f = e.measurementValueDistribution && e.measurementValueDistribution.length > 0 && _r(e.measurementValueDistribution), m = e.lowerLimitDistribution && e.lowerLimitDistribution.length > 0 && _r(e.lowerLimitDistribution), b = e.upperLimitDistribution && e.upperLimitDistribution.length > 0 && _r(e.upperLimitDistribution), E = e.valuesRelativeToNorm && e.valuesRelativeToNorm.length > 0 && Da(e.valuesRelativeToNorm);
  return {
    prevalenceByGenderAgeYearData: n,
    prevalenceByMonthData: r,
    ageAtFirstOccurrenceData: a,
    prevalenceByTypeData: o,
    frequencyDistributionData: c,
    byValueAsConceptData: l,
    byOperatorData: g,
    byQualifierData: d,
    lengthOfEraData: u,
    recordsByUnitData: y,
    measurementValueDistributionData: f,
    lowerLimitDistributionData: m,
    upperLimitDistributionData: b,
    valuesRelativeToNormData: E
  };
}, Zk = (t) => ({
  ahilles: (t.messages || []).map((n) => {
    const r = n.attributeValue, a = r.indexOf(":"), o = r.substring(0, a);
    let u = r.substring(a + 1);
    return u = u.replace(/\B(?=(\d{3})+(?!\d))/g, ","), {
      type: o,
      content: u
    };
  })
}), Jl = (t, e) => {
  if (!t.empty) {
    const n = {};
    n.INTERVAL_SIZE = 1, n.OFFSET = (e == null ? void 0 : e.minValue) || 0;
    let r = t.map((a) => ({
      INTERVAL_INDEX: a.intervalIndex,
      COUNT_VALUE: a.countValue
    }));
    return n.DATA = Qr(r), n.INTERVALS = n.DATA.INTERVAL_INDEX.length, Ci.histogram.mapHistogram(n);
  }
}, n2 = (t) => {
  const e = Qr(t);
  let n = {}, r = {};
  if (!e.empty)
    return n = Ci.chart.normalizeDataframe(e), n = n.xLengthOfObservation.map(function(a, o) {
      return {
        xValue: n.xLengthOfObservation[o],
        yValue: n.yPercentPersons[o]
      };
    }), n.length > 0 && (r.xLabel = "Days", n.length > 0 && n.slice(-1)[0].xValue - n[0].xValue > 1e3 && (n.forEach(function(a) {
      a.xValue = a.xValue / 365.25;
    }), r.xLabel = "Years")), {
      data: n,
      xLabel: r.xLabel
    };
}, Jk = (t) => {
  const e = t.gender && t.gender.length > 0 ? Sr(t.gender) : void 0, n = t.ageAtFirstObservation && t.ageAtFirstObservation.length > 0 ? Jl(t.ageAtFirstObservation) : void 0, r = t.cumulativeObservation && t.cumulativeObservation.length > 0 ? n2(t.cumulativeObservation) : void 0, a = t.observedByMonth && t.observedByMonth.length > 0 ? Zl(t.observedByMonth, {
    dateField: "monthYear",
    yValue: "countValue",
    yPercent: "percentValue"
  }) : void 0;
  return {
    summary: t == null ? void 0 : t.summary,
    genderConceptData: e,
    ageAtFirstObservationData: n,
    observationLineData: r,
    byMonthSeriesData: a
  };
}, ap = (t) => {
  const e = {
    data: null,
    xScale: null
  }, n = [];
  if (t) {
    t.totalRecords, t.forEach(function(a, o, u) {
      const c = a.xCalendarMonth;
      n[o] = {
        ...a,
        xCalendarMonth: new Date(Math.floor(c / 100), c % 100 - 1, 1)
      };
    });
    const r = Ip().key((a) => a.seriesName).entries(n).map((a) => ({
      name: a.key,
      values: a.values
    }));
    e.data = r, e.xScale = Wl().domain(ks(n, (a) => a.xCalendarMonth));
  }
  return e;
}, t7 = (t) => {
  const e = t.totalRecords && t.totalRecords.length > 0 && ap(t.totalRecords), n = t.recordsPerPerson && t.recordsPerPerson.length > 0 && ap(t.recordsPerPerson), r = t.conceptsPerPerson && t.conceptsPerPerson.length > 0 && _r(t.conceptsPerPerson);
  return {
    totalLineData: e,
    recordsperpersonLineData: n,
    conceptsPerPersonData: r
  };
}, e7 = (t) => {
  const e = t.prevalenceByGenderAgeYear && t.prevalenceByGenderAgeYear.length > 0 && e2(t.prevalenceByGenderAgeYear, !0), n = t.prevalenceByMonth && t.prevalenceByMonth.length > 0 && Zl(t.prevalenceByMonth, {
    dateField: "xCalendarMonth",
    yValue: "yPrevalence1000Pp",
    yPercent: "yPrevalence1000Pp"
  }), r = t.deathByType && t.deathByType.length > 0 && Sr(t.deathByType), a = t.ageAtDeath && t.ageAtDeath.length > 0 && _r(t.ageAtDeath);
  return {
    prevalenceByGenderAgeYearData: e,
    prevalenceByMonthData: n,
    deathByTypeData: r,
    ageAtDeathData: a
  };
}, n7 = (t) => {
  const e = {};
  if (t && t.length > 0) {
    let n = t.map((r) => ({
      INTERVAL_INDEX: r.intervalIndex,
      COUNT_VALUE: r.countValue
    }));
    e.OFFSET = 0, e.INTERVAL_SIZE = 1, e.DATA = Qr(n), e.INTERVALS = e.DATA.INTERVAL_INDEX.length;
  }
  return e;
}, dv = (t, [e]) => {
  const n = n7(t);
  if (e && (n.INTERVAL_SIZE = e.intervalSize, n.OFFSET = e.minValue || 0, n.MAX = e.maxValue, n.INTERVALS = n.DATA.INTERVAL_INDEX.length), !n.DATA.empty) {
    const r = Ci.histogram.mapHistogram(n);
    r.length > 0 && r[r.length - 1].x - r[0].x > 1e3 && r.forEach((o) => {
      o.x = o.x / 365.25, o.dx = o.dx / 365.25;
    });
    const a = n.DATA.INTERVAL_INDEX.length + 1;
    return {
      data: r,
      xLabel: "Years",
      ticks: a < 10 ? a : void 0
    };
  }
}, pv = (t, e) => {
  let n = wl(t, (a) => a.min);
  return bl(t, (a) => a.max) - n > 1e3 && t.forEach((a) => {
    a.min = a.min / 365.25, a.LIF = a.LIF / 365.25, a.q1 = a.q1 / 365.25, a.median = a.median / 365.25, a.q3 = a.q3 / 365.25, a.UIF = a.UIF / 365.25, a.max = a.max / 365.25;
  }), t;
}, r7 = (t) => {
  const e = t.ageAtFirst && t.ageAtFirst.length > 0 && Jl(t.ageAtFirst), n = t.ageByGender && t.ageByGender.length > 0 && _r(t.ageByGender), r = t.observationLength && t.observationLength.length > 0 && dv(
    t.observationLength,
    t.observationLengthStats
  ), a = t.durationByGender && t.durationByGender.length > 0 && _r(t.durationByGender), o = t.cumulativeObservation && t.cumulativeObservation.length > 0 && n2(t.cumulativeObservation), u = t.durationByAgeDecile && t.durationByAgeDecile.length > 0 && _r(t.durationByAgeDecile), c = t.personsWithContinuousObservationsByYear && t.personsWithContinuousObservationsByYear.length > 0 && dv(
    t.personsWithContinuousObservationsByYear,
    t.personsWithContinuousObservationsByYearStats
  ), l = t.observationPeriodsPerPerson && t.observationPeriodsPerPerson.length > 0 && Sr(t.observationPeriodsPerPerson), d = t.observedByMonth && t.observedByMonth.length > 0 && Zl(t.observedByMonth, {
    dateField: "monthYear",
    yValue: "countValue",
    yPercent: "percentValue"
  });
  return {
    ageAtFirstObservationData: e,
    ageByGenderData: n,
    observationLengthData: r,
    durationByGenderData: {
      ...a,
      data: pv(
        (a == null ? void 0 : a.data) || []
      )
    },
    cumulativeObservationData: o,
    durationByAgeDecileData: {
      ...u,
      data: pv(
        (u == null ? void 0 : u.data) || []
      )
    },
    personsWithContinuousObservationsByYearData: c,
    observationPeriodsPerPersonData: l,
    personsWithContinuousObservationByMonthData: d
  };
}, i7 = (t) => {
  const e = t.gender && t.gender.length > 0 ? Sr(t.gender) : void 0, n = t.ethnicity && t.ethnicity.length > 0 ? Sr(t.ethnicity) : void 0, r = t.race && t.race.length > 0 ? Sr(t.race) : void 0, a = t.yearOfBirth && t.yearOfBirth.length > 0 ? Jl(t.yearOfBirth, t.yearOfBirthStats[0]) : void 0;
  return {
    gender: e,
    ethnicity: n,
    race: r,
    yearOfBirth: a
  };
}, a7 = (t, e, n) => {
  let r = 0;
  const a = {
    name: "root",
    children: []
  };
  for (var o = 0; o < t.percentPersons.length; o++)
    r += t.percentPersons[o];
  for (var o = 0; o < t.conceptPath.length; o++) {
    const c = t.conceptPath[o].split("||");
    let l = a;
    for (let d = 0; d < c.length; d++) {
      const g = l.children, y = c[d];
      let f;
      if (d + 1 < c.length) {
        let m = !1;
        for (let b = 0; b < g.length; b++)
          if (g[b].name === y) {
            f = g[b], m = !0;
            break;
          }
        m || (f = {
          name: y,
          children: []
        }, g.push(f)), l = f;
      } else
        f = {
          name: y,
          num_persons: t.numPersons[o],
          concept_id: t.conceptId[o],
          path: t.conceptPath[o],
          percent_persons: t.percentPersons[o],
          agg_value: t[n.name][o]
        }, t.percentPersons[o] / r > e && g.push(f);
    }
  }
  return a;
}, gl = (t, e) => {
  const n = Ci.chart.normalizeDataframe(
    Qr(t.treeMap, !0)
  );
  let r = /* @__PURE__ */ new Set([]), a = [];
  return n.empty ? {
    treeVariant: {},
    tableVariant: [],
    description: void 0
  } : (n.conceptPath.forEach((o, u) => {
    if (!r.has(n.conceptId[u])) {
      r.add(n.conceptId[u]);
      const c = o.split("||");
      a.push({
        concept_id: n.conceptId[u],
        name: c[c.length - 1],
        domain: n.domain ? n.domain[u] : null,
        ingredient: c[3],
        num_persons: wr(n.numPersons[u]).format("0,0"),
        percent_persons: wr(n.percentPersons[u]).format(
          "0.00%"
        ),
        agg_value: wr(n[e.name][u]).format("0.00")
      });
    }
  }), {
    treeVariant: a7(
      n,
      50 / (300 * 300),
      e
    ),
    tableVariant: a,
    description: e.description
  });
}, o7 = (t) => {
  const e = t.costByDomain && t.costByDomain.length > 0 && Sr(t.costByDomain), n = t.costByCurrency && t.costByCurrency.length > 0 && Sr(t.costByCurrency), r = t.costByType && t.costByType.length > 0 && Sr(t.costByType), a = t.costAmountByYear && t.costAmountByYear.length > 0 && ap(t.costAmountByYear), o = {
    name: "recordsPerPerson",
    description: "Records per person"
  }, u = gl(
    { treeMap: t.prevalenceByCostEventId },
    o
  ), c = gl(
    { treeMap: t.prevalenceByDrgConceptId },
    o
  );
  return {
    costByDomain: e,
    costByCurrency: n,
    costByType: r,
    costAmountByYear: a,
    prevalenceByCostEventId: u,
    prevalenceByDrgConceptId: c
  };
}, s7 = (t, e, n) => {
  const r = t.percentPersons.reduce((o, u) => o + u, 0), a = {
    name: "root",
    children: []
  };
  return t.planConceptName.forEach((o, u) => {
    const c = {
      name: o,
      path: o,
      id: t.id[u],
      payer_concept_name: t.payerConceptName[u],
      payer_source_value: t.payerSourceValue[u],
      plan_concept_name: o,
      plan_source_value: t.planSourceValue[u],
      num_persons: t.personCount[u],
      percent_persons: t.percentPersons[u],
      agg_value: t.recordsPerPerson[u]
    };
    if (t.percentPersons[u] / r > e) {
      let l = a.children.find((d) => d.name === o);
      l || (l = { name: o, children: [] }, a.children.push(l)), l.children.push(c);
    }
  }), a;
}, u7 = (t, e) => {
  const n = Ci.chart.normalizeDataframe(
    Qr(t.treeMap, !0)
  );
  let r = /* @__PURE__ */ new Set([]), a = [];
  if (!n.empty) {
    for (var o = 0; o < n.planConceptName.length; o++)
      r.has(n.id[o]) || (r.add(n.id[o]), a.push({
        name: n.planConceptName[o],
        path: n.planConceptName[o],
        id: n.id[o],
        payer_concept_name: n.payerConceptName[o],
        payer_source_value: n.payerSourceValue[o],
        plan_concept_name: n.planConceptName[o],
        plan_source_value: n.planSourceValue[o],
        person_count: wr(n.personCount[o]).format("0,0"),
        percent_persons: wr(n.percentPersons[o]).format(
          "0.00%"
        ),
        agg_value: wr(n[e.name][o]).format("0.00")
      }));
    return {
      treeVariant: s7(
        n,
        50 / (300 * 300)
      ),
      tableVariant: a,
      description: e.description
    };
  }
  return {
    treeVariant: {},
    tableVariant: [],
    description: void 0
  };
}, c7 = (t) => {
  const e = t.personsWithPayerPlan && t.personsWithPayerPlan.length > 0 && Jl(
    t.personsWithPayerPlan.map((a) => ({
      intervalIndex: a.xCalendarMonth,
      countValue: a.yRecordCount
    }))
  ), n = {
    name: "recordsPerPerson",
    description: "Avg. records per person"
  }, r = u7(
    { treeMap: t.prevalenceByPayerPlanPeriodId },
    n
  );
  return {
    personsWithPayerPlanData: e,
    prevalenceByPayerPlanPeriodIdData: r
  };
}, Ma = (t) => gl(t || {}, KM), gv = (t) => gl(t || {}, ZM), r2 = (t, e) => {
  switch (t) {
    case Bt.DASHBOARD:
      return Jk(e);
    case Bt.PERSON:
      return i7(e);
    case Bt.DATADENSITY:
      return t7(e);
    case Bt.VISIT:
      return Ma(e);
    case Bt.CONDITION:
      return Ma(e);
    case Bt.CONDITION_ERA:
      return gv(e);
    case Bt.PROCEDURE:
      return Ma(e);
    case Bt.DRUG:
      return Ma(e);
    case Bt.DRUG_ERA:
      return gv(e);
    case Bt.MEASUREMENT:
      return Ma(e);
    case Bt.OBSERVATION:
      return Ma(e);
    case Bt.OBSERVATION_PERIOD:
      return r7(e);
    case Bt.DEATH:
      return e7(e);
    case Bt.AHILLES_SHEEL:
      return Zk(e);
    case Bt.COST:
      return o7(e);
    case Bt.PAYER_PLAN:
      return c7(e);
  }
};
var Pe = /* @__PURE__ */ ((t) => (t.INIT = "INIT", t.LOAD_REQUEST = "LOAD_REQUEST", t.LOAD_REQUEST_DONE = "LOAD_REQUEST_DONE", t.LOAD_REQUEST_FAILED = "LOAD_REQUEST_FAILED", t.CHANGE_CURRENT_REPORT = "CHANGE_CURRENT_REPORT", t.DRILLDOWN_REPORT_REQUEST = "DRILLDOWN_REPORT_REQUEST", t.DRILLDOWN_REPORT_REQUEST_DONE = "DRILLDOWN_REPORT_REQUEST_DONE", t.DRILLDOWN_REPORT_REQUEST_FAILED = "DRILLDOWN_REPORT_REQUEST_FAILED", t.GET_ALL_REPORTS = "GET_ALL_REPORTS", t.GET_ALL_REPORTS_DONE = "GET_ALL_REPORTS_DONE", t.GET_ALL_REPORTS_INIT = "GET_ALL_REPORTS_INIT", t))(Pe || {}), sr = /* @__PURE__ */ ((t) => (t.INITIAL = "INITIAL", t.LOADING_LIST = "LOADING_LIST", t.LOADED_LIST = "LOADED_LIST", t.LOADING_REPORT_FAILED = "LOADING_REPORT_FAILED", t))(sr || {});
const l7 = (t, e) => Rv(
  t,
  (n) => {
    var r, a;
    switch (e.type) {
      case Pe.LOAD_REQUEST:
        n.isLoading = !0, n.dataCurrentReport = null, n.error = null, n.drilldownError = null;
        break;
      case Pe.LOAD_REQUEST_DONE:
        n.isLoading = !1, n.currentReport === e.payload.reportName && (n.dataCurrentReport = e.payload.original, n.dataDrilldownReport = null, n.error = null, n.status = sr.LOADED_LIST);
        break;
      case Pe.LOAD_REQUEST_FAILED:
        n.isLoading = !1, n.error = "Report is not downloaded", n.status = sr.LOADING_REPORT_FAILED, n.dataCurrentReport = null;
        break;
      case Pe.GET_ALL_REPORTS_INIT:
        n.reportList = [], n.status = sr.LOADING_LIST;
        break;
      case Pe.GET_ALL_REPORTS:
        n.reportList = e.payload, n.currentReport = (a = (r = e.payload) == null ? void 0 : r[0]) == null ? void 0 : a.value, n.status = sr.LOADED_LIST;
        break;
      case Pe.CHANGE_CURRENT_REPORT:
        n.currentReport = e.payload, n.error = null, n.drilldownError = null, n.dataDrilldownReport = null, n.status = sr.LOADED_LIST;
        break;
      case Pe.DRILLDOWN_REPORT_REQUEST:
        n.isLoadingDrilldown = !0, n.drilldownError = null;
        break;
      case Pe.DRILLDOWN_REPORT_REQUEST_DONE:
        n.isLoadingDrilldown = !1, n.drilldownError = null, n.currentReport === e.payload.reportName && (n.dataDrilldownReport = e.payload.format);
        break;
      case Pe.DRILLDOWN_REPORT_REQUEST_FAILED:
        n.isLoadingDrilldown = !1, n.dataDrilldownReport = null, n.drilldownError = "Drilldown report is not downloaded";
        break;
    }
  }
), f7 = {
  originalData: {},
  currentReport: null,
  dataCurrentReport: null,
  dataDrilldownReport: null,
  isStartHook: !1,
  isLoading: !1,
  isLoadingReports: !1,
  isLoadingDrilldown: !1,
  reportList: [],
  error: null,
  drilldownError: null,
  status: sr.INITIAL
}, fc = (t) => {
  var e, n, r;
  return {
    status: (e = t == null ? void 0 : t.response) == null ? void 0 : e.status,
    statusText: (n = t == null ? void 0 : t.response) == null ? void 0 : n.statusText,
    message: t == null ? void 0 : t.message,
    data: (r = t == null ? void 0 : t.response) == null ? void 0 : r.data
  };
}, h7 = (t) => {
  var e;
  return {
    name: t.title || t.name || t.label,
    value: (e = t.name || t.label) == null ? void 0 : e.toLowerCase()
  };
}, i2 = (t) => t ? Array.isArray(t) ? t.length > 0 : typeof t != "object" ? !0 : Object.entries(t).some(([e, n]) => e === "description" ? !1 : i2(n)) : !1, d7 = (t) => {
  const [e, n] = yv(
    l7,
    f7
  ), r = Ie(async () => {
    if (n({
      type: Pe.LOAD_REQUEST
    }), !!e.currentReport)
      try {
        const c = await uy(t, e.currentReport);
        n({
          type: Pe.LOAD_REQUEST_DONE,
          payload: {
            original: c,
            reportName: e.currentReport
          }
        });
      } catch (c) {
        console.error("Failed to load dataset report", {
          datasourceId: t,
          reportName: e.currentReport,
          error: fc(c)
        }), n({
          type: Pe.LOAD_REQUEST_FAILED
        });
      }
  }, [t, e.currentReport]), a = Ie(
    (c) => {
      e.currentReport !== c && n({
        type: Pe.CHANGE_CURRENT_REPORT,
        payload: c
      });
    },
    [e.currentReport]
  ), o = Ie(async () => {
    n({
      type: Pe.GET_ALL_REPORTS_INIT
    });
    try {
      const c = await VD(t), l = (c == null ? void 0 : c.content) || [], d = (await Promise.all(
        l.map(async (g) => {
          const y = h7(g);
          if (!y.value) return null;
          try {
            const f = await uy(t, y.value), m = r2(
              y.value,
              f
            );
            if (i2(m))
              return y;
            console.info("Dataset report was hidden because it has no data", {
              datasourceId: t,
              reportName: y.value
            });
          } catch (f) {
            console.info("Dataset report was hidden because it cannot load", {
              datasourceId: t,
              reportName: y.value,
              error: fc(f)
            });
          }
          return null;
        })
      )).filter(Boolean);
      n({
        type: Pe.GET_ALL_REPORTS,
        payload: d
      });
    } catch (c) {
      console.error("Failed to load dataset reports list", {
        datasourceId: t,
        error: fc(c)
      }), n({
        type: Pe.GET_ALL_REPORTS,
        payload: []
      });
    }
  }, [t]), u = Ie(
    async (c) => {
      n({
        type: Pe.DRILLDOWN_REPORT_REQUEST
      });
      try {
        const l = await YD(
          t,
          e.currentReport,
          c
        );
        n({
          type: Pe.DRILLDOWN_REPORT_REQUEST_DONE,
          payload: {
            format: l,
            reportName: e.currentReport
          }
        });
      } catch (l) {
        console.error("Failed to load dataset report drilldown", {
          datasourceId: t,
          reportName: e.currentReport,
          reportPartId: c,
          error: fc(l)
        }), n({
          type: Pe.DRILLDOWN_REPORT_REQUEST_FAILED
        });
      }
    },
    [t, e.currentReport]
  );
  return Ce(() => {
    r();
  }, [r]), Ce(() => {
    o();
  }, [o]), {
    ...e,
    changeReport: a,
    drilldownReport: u,
    getAllReports: o
  };
}, Ut = Qt.div`
  padding: 16px;
  height: 300px;
`;
Qt.div``;
const p7 = (t) => {
  var n, r;
  const { data: e } = t;
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    (e == null ? void 0 : e.summary) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 6, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
      /* @__PURE__ */ p.jsx(Lt, { title: "CDM Summary" }),
      /* @__PURE__ */ p.jsx(FR, { children: e == null ? void 0 : e.summary.map((a, o) => /* @__PURE__ */ p.jsxs(G, { container: !0, children: [
        /* @__PURE__ */ p.jsx(G, { item: !0, xs: 6, children: /* @__PURE__ */ p.jsx("label", { children: a.attributeName }) }),
        /* @__PURE__ */ p.jsx(G, { item: !0, xs: 6, children: /* @__PURE__ */ p.jsx("span", { children: a.attributeValue }) })
      ] }, "grid-" + o)) })
    ] }) }),
    /* @__PURE__ */ p.jsx(G, { item: !0, xs: 6, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
      /* @__PURE__ */ p.jsx(Lt, { title: "Population by Gender" }),
      /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(Vt, { type: "donut", chartData: e == null ? void 0 : e.genderConceptData }) })
    ] }) }),
    /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
      /* @__PURE__ */ p.jsx(Lt, { title: "Age at First Observation" }),
      /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
        Vt,
        {
          type: "histogram",
          chartData: e == null ? void 0 : e.ageAtFirstObservationData,
          options: (a) => ({
            xFormat: Yt("d"),
            yFormat: Yt(",.1s"),
            xLabel: "Age",
            yLabel: "People"
          })
        }
      ) })
    ] }) }),
    /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
      /* @__PURE__ */ p.jsx(Lt, { title: "Cumulative Observation" }),
      /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
        Vt,
        {
          type: "line",
          chartData: (n = e == null ? void 0 : e.observationLineData) == null ? void 0 : n.data,
          options: (a) => {
            var o;
            return {
              yFormat: Yt("0.0%"),
              xFormat: function(u) {
                return u < 10 ? Yt(".2n")(u) : Yt("d")(u);
              },
              interpolate: new Ci.line().interpolation.curveStepBefore,
              xLabel: (o = e == null ? void 0 : e.observationLineData) == null ? void 0 : o.xLabel,
              yLabel: "Percent of Population"
            };
          }
        }
      ) })
    ] }) }),
    /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
      /* @__PURE__ */ p.jsx(Lt, { title: "Persons With Continuous Observation By Month" }),
      /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
        Vt,
        {
          type: "line",
          chartData: (r = e == null ? void 0 : e.byMonthSeriesData) == null ? void 0 : r.data,
          options: (a) => {
            var o;
            return {
              xScale: (o = e == null ? void 0 : e.byMonthSeriesData) == null ? void 0 : o.xScale,
              xFormat: je("%m/%Y"),
              xLabel: "Date",
              yLabel: "People",
              tickFormat: je("%m/%Y"),
              ticks: 10
            };
          }
        }
      ) })
    ] }) })
  ] });
}, g7 = (t) => {
  var r, a, o;
  const { data: e } = t, n = (u) => (c) => {
    const l = c[u.yValue], d = l < 1 ? Yt(".3f")(l) : $s(".3s", l)(l);
    return `
      ${c.seriesName}<br/>
      ${u.xLabel}: ${u.xFormat(c[u.xValue])}<br/>
      ${u.yLabel}: ${d}
    `;
  };
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
      /* @__PURE__ */ p.jsx(Lt, { title: "Total Rows" }),
      /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
        Vt,
        {
          type: "line",
          chartData: (r = e == null ? void 0 : e.totalLineData) == null ? void 0 : r.data,
          options: (u) => {
            var c;
            return {
              xScale: (c = e == null ? void 0 : e.totalLineData) == null ? void 0 : c.xScale,
              xFormat: je("%m/%Y"),
              tickFormat: je("%m/%Y"),
              xValue: "xCalendarMonth",
              yValue: "yRecordCount",
              xLabel: "Year",
              yLabel: "# of Records",
              showLegend: !0,
              getTooltipBuilder: n
            };
          }
        }
      ) })
    ] }) }),
    /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
      /* @__PURE__ */ p.jsx(Lt, { title: "Records Per Person" }),
      /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
        Vt,
        {
          type: "line",
          chartData: (a = e == null ? void 0 : e.recordsperpersonLineData) == null ? void 0 : a.data,
          options: (u) => {
            var c;
            return {
              xScale: (c = e == null ? void 0 : e.recordsperpersonLineData) == null ? void 0 : c.xScale,
              xFormat: je("%m/%Y"),
              tickFormat: je("%m/%Y"),
              xValue: "xCalendarMonth",
              yValue: "yRecordCount",
              xLabel: "Year",
              yLabel: "Records per Person",
              showLegend: !0,
              getTooltipBuilder: n
            };
          }
        }
      ) })
    ] }) }),
    /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
      /* @__PURE__ */ p.jsx(Lt, { title: "Concepts per Person" }),
      /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
        Vt,
        {
          type: "boxplot",
          chartData: (o = e == null ? void 0 : e.conceptsPerPersonData) == null ? void 0 : o.data,
          options: (u) => {
            var c;
            return {
              yMax: (c = e == null ? void 0 : e.conceptsPerPersonData) == null ? void 0 : c.yMax,
              yFormat: Yt(",.1s"),
              xLabel: "Concept Type",
              yLabel: "Concepts per Person",
              valueFormatter: Yt("d")
            };
          }
        }
      ) })
    ] }) })
  ] });
}, m7 = (t) => {
  const { data: e } = t;
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
      /* @__PURE__ */ p.jsx(Lt, { title: "Year of Birth" }),
      /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
        Vt,
        {
          type: "histogram",
          chartData: e == null ? void 0 : e.yearOfBirth,
          options: (n) => ({
            xFormat: Yt("d"),
            yFormat: Yt(",.1s"),
            xLabel: "Year",
            yLabel: "# of Persons",
            xValue: "x",
            yValue: "y",
            getTooltipBuilder: (r) => (a) => (Yt(""), `
                      ${r.xLabel}: ${r.xFormat(
              a[r.xValue]
            )}<br/>
                      ${r.yLabel}: ${Yt(",")(a[r.yValue])}
                    `)
          })
        }
      ) })
    ] }) }),
    /* @__PURE__ */ p.jsx(G, { item: !0, xs: 4, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
      /* @__PURE__ */ p.jsx(Lt, { title: "Gender" }),
      /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(Vt, { type: "donut", chartData: e == null ? void 0 : e.gender }) })
    ] }) }),
    /* @__PURE__ */ p.jsx(G, { item: !0, xs: 4, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
      /* @__PURE__ */ p.jsx(Lt, { title: "Ethnicity" }),
      /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(Vt, { type: "donut", chartData: e == null ? void 0 : e.ethnicity }) })
    ] }) }),
    /* @__PURE__ */ p.jsx(G, { item: !0, xs: 4, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
      /* @__PURE__ */ p.jsx(Lt, { title: "Race" }),
      /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(Vt, { type: "donut", chartData: e == null ? void 0 : e.race }) })
    ] }) })
  ] });
};
function sd(t) {
  return t < 10 ? Yt(".1f")(t) : Yt("d")(t);
}
const y7 = (t) => {
  var n, r, a, o, u;
  const { data: e } = t;
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    (e == null ? void 0 : e.ageAtFirstObservationData) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 8, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
      /* @__PURE__ */ p.jsx(Lt, { title: "Age at First Observation" }),
      /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
        Vt,
        {
          type: "histogram",
          chartData: e == null ? void 0 : e.ageAtFirstObservationData,
          options: (c) => ({
            xLabel: "Age",
            yLabel: "People",
            xFormat: Yt("d"),
            yFormat: Yt(",.1s")
          })
        }
      ) })
    ] }) }),
    (e == null ? void 0 : e.ageByGenderData) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 4, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
      /* @__PURE__ */ p.jsx(Lt, { title: "Age by Gender" }),
      /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
        Vt,
        {
          type: "boxplot",
          chartData: (n = e == null ? void 0 : e.ageByGenderData) == null ? void 0 : n.data,
          options: (c) => ({
            yLabel: "Age",
            xLabel: "Gender",
            yFormat: Yt(",.1s"),
            valueFormatter: Yt("d")
          })
        }
      ) })
    ] }) }),
    (e == null ? void 0 : e.observationLengthData) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 8, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
      /* @__PURE__ */ p.jsx(Lt, { title: "Observation Length" }),
      /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
        Vt,
        {
          type: "histogram",
          chartData: e == null ? void 0 : e.observationLengthData.data,
          options: (c) => ({
            xLabel: "Years",
            yLabel: "People",
            xFormat: (l) => sd(l),
            yFormat: Yt(",.1s")
          })
        }
      ) })
    ] }) }),
    (e == null ? void 0 : e.durationByGenderData) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 4, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
      /* @__PURE__ */ p.jsx(Lt, { title: "Duration By Gender" }),
      /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
        Vt,
        {
          type: "boxplot",
          chartData: (r = e == null ? void 0 : e.durationByGenderData) == null ? void 0 : r.data,
          options: (c) => ({
            yLabel: "Years",
            xLabel: "Gender",
            yFormat: Yt(",.1s"),
            valueFormatter: Yt("d")
          })
        }
      ) })
    ] }) }),
    (e == null ? void 0 : e.cumulativeObservationData) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 6, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
      /* @__PURE__ */ p.jsx(Lt, { title: "Cumulative Observation" }),
      /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
        Vt,
        {
          type: "line",
          chartData: (a = e == null ? void 0 : e.cumulativeObservationData) == null ? void 0 : a.data,
          options: (c) => {
            var l;
            return {
              yFormat: Yt("0.0%"),
              xFormat: (d) => sd(d),
              interpolate: new Ci.line().interpolation.curveStepBefore,
              xLabel: (l = e == null ? void 0 : e.cumulativeObservationData) == null ? void 0 : l.xLabel,
              yLabel: "Percent of Population"
            };
          }
        }
      ) })
    ] }) }),
    (e == null ? void 0 : e.durationByAgeDecileData) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 6, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
      /* @__PURE__ */ p.jsx(Lt, { title: "Duration By Age Decile" }),
      /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
        Vt,
        {
          type: "boxplot",
          chartData: (o = e == null ? void 0 : e.durationByAgeDecileData) == null ? void 0 : o.data,
          options: (c) => ({
            yLabel: "Years",
            xLabel: "Age Decile",
            yFormat: (l) => sd(l),
            valueFormatter: Yt("d")
          })
        }
      ) })
    ] }) }),
    (e == null ? void 0 : e.personsWithContinuousObservationsByYearData) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 8, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
      /* @__PURE__ */ p.jsx(Lt, { title: "Persons With Continuous Observation By Year" }),
      /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
        Vt,
        {
          type: "histogram",
          chartData: e == null ? void 0 : e.personsWithContinuousObservationsByYearData.data,
          options: (c) => ({
            xLabel: "Years",
            yLabel: "People",
            xFormat: Yt("d"),
            yFormat: Yt(",.1s"),
            ticks: e == null ? void 0 : e.personsWithContinuousObservationsByYearData.ticks
          })
        }
      ) })
    ] }) }),
    (e == null ? void 0 : e.observationPeriodsPerPersonData) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 4, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
      /* @__PURE__ */ p.jsx(Lt, { title: "Observation Periods per Person" }),
      /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
        Vt,
        {
          type: "donut",
          chartData: e == null ? void 0 : e.observationPeriodsPerPersonData,
          options: (c) => ({
            margin: {
              top: 5,
              left: 5,
              right: 200,
              bottom: 5
            }
          })
        }
      ) })
    ] }) }),
    (e == null ? void 0 : e.personsWithContinuousObservationByMonthData) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
      /* @__PURE__ */ p.jsx(Lt, { children: "Persons With Continuous Observation By Month" }),
      /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
        Vt,
        {
          type: "line",
          chartData: (u = e == null ? void 0 : e.personsWithContinuousObservationByMonthData) == null ? void 0 : u.data,
          options: (c) => {
            var l;
            return {
              xScale: (l = e == null ? void 0 : e.personsWithContinuousObservationByMonthData) == null ? void 0 : l.xScale,
              xFormat: je("%m/%Y"),
              tickFormat: je("%Y"),
              xLabel: "Date",
              yLabel: "People",
              yFormat: Yt(",.1s"),
              getTooltipBuilder: (d) => (g) => {
                const y = Yt(",.4s");
                return `
                            ${d.xLabel}: ${d.xFormat(g.xValue)}<br/>
                            ${d.yLabel}: ${y(g.yValue)}
                        `;
              }
            };
          }
        }
      ) })
    ] }) })
  ] });
}, v7 = (t) => {
  var n, r, a, o;
  const { data: e } = t;
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    ((n = Object.keys((e == null ? void 0 : e.prevalenceByGenderAgeYearData) || {})) == null ? void 0 : n.length) > 0 && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
      /* @__PURE__ */ p.jsx(Lt, { title: "Death Prevalence by Age, Gender, Year" }),
      /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
        Vt,
        {
          type: "trellisline",
          chartData: e == null ? void 0 : e.prevalenceByGenderAgeYearData,
          options: (u) => ({
            trellisSet: Uv,
            trellisLabel: "Age Decile",
            seriesLabel: "Year of Observation",
            yLabel: "Prevalence Per 1000 People",
            xFormat: je("%Y"),
            yFormat: Yt("0.2f"),
            tickPadding: 20,
            colors: qs().domain(["MALE", "FEMALE", "UNKNOWN"]).range(["#1F78B4", "#FB9A99", "#33A02C"])
          })
        }
      ) })
    ] }) }),
    (e == null ? void 0 : e.prevalenceByMonthData) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
      /* @__PURE__ */ p.jsx(Lt, { title: "Death Prevalence by Month" }),
      /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
        Vt,
        {
          type: "line",
          chartData: (r = e == null ? void 0 : e.prevalenceByMonthData) == null ? void 0 : r.data,
          options: (u) => {
            var c;
            return {
              xScale: (c = e == null ? void 0 : e.prevalenceByMonthData) == null ? void 0 : c.xScale,
              xFormat: je("%m/%Y"),
              tickFormat: je("%Y"),
              xLabel: "Date",
              yLabel: "Prevalence Per 1000 People",
              yFormat: Yt("0.2f"),
              getTooltipBuilder: (l) => (d) => {
                const g = Yt("0.5f");
                return `
								        ${l.xLabel}: ${l.xFormat(d.xValue)}<br/>
								        ${l.yLabel}: ${g(d.yValue)}
							`;
              }
            };
          }
        }
      ) })
    ] }) }),
    ((a = e == null ? void 0 : e.deathByTypeData) == null ? void 0 : a.length) > 0 && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 6, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
      /* @__PURE__ */ p.jsx(Lt, { title: "Death by Type" }),
      /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
        Vt,
        {
          type: "donut",
          chartData: e == null ? void 0 : e.deathByTypeData,
          options: (u) => ({
            margin: {
              top: 5,
              left: 5,
              right: 200,
              bottom: 5
            }
          })
        }
      ) })
    ] }) }),
    (e == null ? void 0 : e.ageAtDeathData) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 6, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
      /* @__PURE__ */ p.jsx(Lt, { title: "Age at Death" }),
      /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
        Vt,
        {
          type: "boxplot",
          chartData: (o = e == null ? void 0 : e.ageAtDeathData) == null ? void 0 : o.data,
          options: (u) => ({
            yLabel: "Age at first occurence",
            xLabel: "Gender",
            yFormat: Yt(",.1s"),
            valueFormatter: Yt("d")
          })
        }
      ) })
    ] }) })
  ] });
}, x7 = {
  setColumns: (t) => [
    {
      id: "type",
      Header: "Message Type",
      accessor: "type",
      isCropped: !0,
      width: 50,
      maxWidth: 50
    },
    {
      id: "content",
      Header: "Message",
      accessor: "content"
    }
  ]
}, _7 = lr((t) => {
  const { data: e, description: n } = t, r = Fn(() => x7.setColumns(n), [e == null ? void 0 : e.ahilles]);
  return /* @__PURE__ */ p.jsx(p.Fragment, { children: /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
    /* @__PURE__ */ p.jsx(Lt, { title: "Achilles Heel Results" }),
    /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
      cp,
      {
        enablePagination: !0,
        enableSorting: !0,
        data: (e == null ? void 0 : e.ahilles) || [],
        columns: r || []
      }
    ) })
  ] }) }) });
}), ml = lr((t) => {
  const { data: e, handlerDrilldown: n } = t;
  return /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
    Vt,
    {
      type: "treemap",
      chartData: e == null ? void 0 : e.treeVariant,
      options: (r) => ({
        useTip: !0,
        minimumArea: 50,
        onclick: n,
        getcolorrange: () => ["#c7eaff", "#6E92A8", "#1F425A"],
        getsizevalue: (a) => a.num_persons,
        getcolorvalue: (a) => a.agg_value,
        getcontent: (a) => {
          const o = a.path.split("||"), u = o.length - 1;
          return `<div class="pathleaf">${o[u]}</div>
                    <div class="pathleafstat">Prevalence: ${wr(
            a.percent_persons
          ).format("0.00%")}</div>
                    <div class="pathleafstat">Number of People: ${wr(
            a.num_persons
          ).format("0,0")}</div>
                    <div class="pathleafstat">Records per person: ${wr(
            a.agg_value
          ).format("0.00")}</div>
                    `;
        },
        gettitle: (a) => {
          let o = "";
          const u = a.path.split("||");
          for (let c = 0; c < u.length - 1; c++)
            o += ' <div class="pathstep">' + Array(c + 1).join("&nbsp;&nbsp") + u[c] + " </div>";
          return o;
        }
      })
    }
  ) });
}), b7 = {
  /*
     {
        id: 'id',
        Header: 'ID',
        accessor: 'id',
        isCropped: true,
        width: 50,
        maxWidth: 50,
      },
    */
  setColumns: (t) => [
    {
      id: "concept_id",
      header: "ID",
      accessorKey: "concept_id",
      isCropped: !0,
      width: 50,
      maxWidth: 50
    },
    {
      id: "name",
      header: "Name",
      accessorKey: "name",
      isCropped: !0,
      width: 220,
      maxWidth: 220
    },
    {
      id: "num_persons",
      accessorKey: "num_persons",
      header: "Person Count",
      // Cell: (props: any) => (
      //   <>{moment(props.value).format('MM/DD/yyyy h:mm A')}</>
      // ),
      width: 130,
      isCropped: !0
    },
    {
      id: "percent_persons",
      accessorKey: "percent_persons",
      header: "Prevalence",
      // Cell: (props: any) => (
      //   <>{moment(props.value).format('MM/DD/yyyy h:mm A')}</>
      // ),
      width: 130,
      isCropped: !0
    },
    {
      id: "agg_value",
      accessorKey: "agg_value",
      header: t,
      // Cell: (props: any) => (
      //   <>{moment(props.value).format('MM/DD/yyyy h:mm A')}</>
      // ),
      width: 130,
      maxWidth: 400,
      isCropped: !0
    }
  ]
}, yl = lr((t) => {
  const {
    data: e,
    handlerDrilldown: n,
    description: r,
    customColumns: a,
    filterValue: o,
    searchColumns: u
  } = t, c = Fn(() => b7.setColumns(r), [e]), l = Fn(() => o === null || o == "" ? e || [] : e == null ? void 0 : e.filter(
    (d) => (u ?? [
      "concept_id",
      "name",
      "num_persons",
      "agg_value",
      "percent_persons"
    ]).some((g) => {
      var y;
      return (y = d[g]) == null ? void 0 : y.toString().toLowerCase().includes(o);
    })
  ), [o, e, u]);
  return /* @__PURE__ */ p.jsx(
    Sv,
    {
      hideSettings: !0,
      data: l || [],
      columns: a || c || [],
      onRowClick: (d) => {
        n(d.original);
      }
    }
  );
}), vl = lr((t) => {
  const { onFind: e, onClear: n } = t, [r, a] = Ot(""), o = br.useCallback(
    (u) => {
      u.preventDefault(), e(r);
    },
    [r]
  );
  return /* @__PURE__ */ p.jsx("form", { onSubmit: o, className: "search-form", children: /* @__PURE__ */ p.jsx(
    ja,
    {
      fullWidth: !0,
      placeholder: "Search...",
      size: "medium",
      value: r,
      onChange: (u) => a(u.target.value),
      type: "text",
      name: "search-input",
      InputProps: {
        endAdornment: /* @__PURE__ */ p.jsx(ud, { size: "small", type: "submit", name: "submitSearch", children: /* @__PURE__ */ p.jsx(is, { text: "search", children: /* @__PURE__ */ p.jsx(Qe, { iconName: "search", sx: { fontSize: 12 } }) }) })
      }
    }
  ) });
}), w7 = lr((t) => {
  var b, E, S, M, N, O, A, x;
  const { data: e, isLoading: n, dataDrilldownReport: r, drilldownError: a, getDrilldown: o } = t, [u, c] = Ot(""), [l, d] = Ot(!1), [g, y] = Ot(), f = (v) => {
    if (!(v != null && v.concept_id)) {
      console.warn("Dataset report drilldown was skipped: missing concept_id", {
        node: v
      });
      return;
    }
    y(v.name), o(v.concept_id);
  }, m = (v) => {
    c(""), d(v);
  };
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(G, { container: !0, item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
      /* @__PURE__ */ p.jsx(Lt, { title: "Prevalence", children: /* @__PURE__ */ p.jsx(G, { item: !0, children: l ? /* @__PURE__ */ p.jsxs(G, { container: !0, spacing: 1, alignItems: "center", children: [
        /* @__PURE__ */ p.jsx(G, { item: !0, children: /* @__PURE__ */ p.jsx(
          vl,
          {
            onFind: (v) => c(
              v == null ? "" : v.toLowerCase()
            ),
            onClear: () => c("")
          }
        ) }),
        /* @__PURE__ */ p.jsx(G, { item: !0, children: /* @__PURE__ */ p.jsx(
          _e,
          {
            variant: "outlined",
            onClick: () => m(!1),
            children: "Switch to Treemap"
          }
        ) })
      ] }) : /* @__PURE__ */ p.jsx(G, { container: !0, alignItems: "center", children: /* @__PURE__ */ p.jsx(_e, { variant: "outlined", onClick: () => m(!0), children: "Switch to Table" }) }) }) }),
      /* @__PURE__ */ p.jsx(p.Fragment, { children: l ? /* @__PURE__ */ p.jsx(
        yl,
        {
          filterValue: u,
          data: e.tableVariant,
          description: e.description,
          handlerDrilldown: f
        }
      ) : /* @__PURE__ */ p.jsx(
        ml,
        {
          data: e,
          handlerDrilldown: f
        }
      ) })
    ] }) }) }),
    a && !n && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(Et, { children: /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, px: 3, py: 1, sx: { textAlign: "center" }, children: a }) }) }),
    !a && !n && r ? /* @__PURE__ */ p.jsxs(
      bv,
      {
        fallback: /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(Et, { children: /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, px: 3, py: 1, sx: { textAlign: "center" }, children: "Drilldown report contains invalid chart data" }) }) }),
        children: [
          /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx("label", { htmlFor: "", children: `${g} drilldown report` }) }),
          (r == null ? void 0 : r.prevalenceByGenderAgeYearData) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsxs(Et, { children: [
            /* @__PURE__ */ p.jsx(Lt, { title: "Prevalence" }),
            /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
              Vt,
              {
                type: "trellisline",
                chartData: r == null ? void 0 : r.prevalenceByGenderAgeYearData,
                options: (v) => ({
                  trellisSet: Uv,
                  trellisLabel: "Age Decile",
                  seriesLabel: "Year of Observation",
                  yLabel: "Prevalence Per 1000 People",
                  xFormat: je("%Y"),
                  yFormat: Yt("0.2f"),
                  tickPadding: 20,
                  colors: qs().domain(["MALE", "FEMALE", "UNKNOWN"]).range(["#1F78B4", "#FB9A99", "#33A02C"])
                })
              }
            ) })
          ] }) }),
          ((b = r == null ? void 0 : r.prevalenceByMonthData) == null ? void 0 : b.data) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsxs(Et, { children: [
            /* @__PURE__ */ p.jsx(Lt, { title: "Prevalence by Month" }),
            /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
              Vt,
              {
                type: "line",
                chartData: (E = r == null ? void 0 : r.prevalenceByMonthData) == null ? void 0 : E.data,
                options: (v) => {
                  var w;
                  return {
                    xScale: (w = r == null ? void 0 : r.prevalenceByMonthData) == null ? void 0 : w.xScale,
                    xFormat: je("%m/%Y"),
                    tickFormat: je("%Y"),
                    xLabel: "Date",
                    yLabel: "Prevalence per 1000 People"
                  };
                }
              }
            ) })
          ] }) }),
          !Object.values(r).some(Boolean) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(Et, { children: /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, px: 3, py: 1, sx: { textAlign: "center" }, children: "Drilldown report lacks chartable data" }) }) }),
          (r == null ? void 0 : r.ageAtFirstOccurrenceData) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 6, children: /* @__PURE__ */ p.jsxs(Et, { children: [
            /* @__PURE__ */ p.jsx(Lt, { title: "Age at First Occurrence" }),
            /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
              Vt,
              {
                type: "boxplot",
                chartData: (S = r == null ? void 0 : r.ageAtFirstOccurrenceData) == null ? void 0 : S.data,
                options: (v) => {
                  var w;
                  return {
                    yMax: (w = r == null ? void 0 : r.ageAtFirstOccurrenceData) == null ? void 0 : w.yMax,
                    xLabel: "Gender",
                    yLabel: "Age at First Occurrence",
                    yFormat: Yt(",.1s")
                  };
                }
              }
            ) })
          ] }) }),
          (r == null ? void 0 : r.prevalenceByTypeData) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 6, children: /* @__PURE__ */ p.jsxs(Et, { children: [
            /* @__PURE__ */ p.jsx(Lt, { title: "Type" }),
            /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
              Vt,
              {
                type: "donut",
                chartData: r == null ? void 0 : r.prevalenceByTypeData,
                options: (v) => ({
                  margin: {
                    top: 5,
                    left: 5,
                    right: 200,
                    bottom: 5
                  }
                })
              }
            ) })
          ] }) }),
          (r == null ? void 0 : r.lengthOfEraData) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 6, children: /* @__PURE__ */ p.jsxs(Et, { children: [
            /* @__PURE__ */ p.jsx(Lt, { title: "Length of Era Distribution" }),
            /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
              Vt,
              {
                type: "boxplot",
                chartData: (M = r == null ? void 0 : r.lengthOfEraData) == null ? void 0 : M.data,
                options: (v) => {
                  var w;
                  return {
                    yMax: (w = r == null ? void 0 : r.lengthOfEraData) == null ? void 0 : w.yMax,
                    yLabel: "Days",
                    yFormat: Yt("d")
                  };
                }
              }
            ) })
          ] }) }),
          (r == null ? void 0 : r.byValueAsConceptData) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 6, children: /* @__PURE__ */ p.jsxs(Et, { children: [
            /* @__PURE__ */ p.jsx(Lt, { title: "Value As Concept" }),
            /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
              Vt,
              {
                type: "donut",
                chartData: r == null ? void 0 : r.byValueAsConceptData,
                options: (v) => ({
                  margin: {
                    top: 5,
                    left: 5,
                    right: 200,
                    bottom: 5
                  }
                })
              }
            ) })
          ] }) }),
          (r == null ? void 0 : r.byQualifierData) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 6, children: /* @__PURE__ */ p.jsxs(Et, { children: [
            /* @__PURE__ */ p.jsx(Lt, { title: "Qualifier Concept" }),
            /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
              Vt,
              {
                type: "donut",
                chartData: r == null ? void 0 : r.byQualifierData,
                options: (v) => ({
                  margin: {
                    top: 5,
                    left: 5,
                    right: 200,
                    bottom: 5
                  }
                })
              }
            ) })
          ] }) }),
          (r == null ? void 0 : r.byOperatorData) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 6, children: /* @__PURE__ */ p.jsxs(Et, { children: [
            /* @__PURE__ */ p.jsx(Lt, { title: "Operator Concept" }),
            /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
              Vt,
              {
                type: "donut",
                chartData: r == null ? void 0 : r.byOperatorData,
                options: (v) => ({
                  margin: {
                    top: 5,
                    left: 5,
                    right: 200,
                    bottom: 5
                  }
                })
              }
            ) })
          ] }) }),
          (r == null ? void 0 : r.recordsByUnitData) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 6, children: /* @__PURE__ */ p.jsxs(Et, { children: [
            /* @__PURE__ */ p.jsx(Lt, { title: "Measurement Records by Unit" }),
            /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
              Vt,
              {
                type: "donut",
                chartData: r == null ? void 0 : r.recordsByUnitData,
                options: (v) => ({
                  margin: {
                    top: 5,
                    left: 5,
                    right: 200,
                    bottom: 5
                  }
                })
              }
            ) })
          ] }) }),
          (r == null ? void 0 : r.measurementValueDistributionData) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 6, children: /* @__PURE__ */ p.jsxs(Et, { children: [
            /* @__PURE__ */ p.jsx(Lt, { title: "Measurement Value Distribution" }),
            /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
              Vt,
              {
                type: "boxplot",
                chartData: (N = r == null ? void 0 : r.measurementValueDistributionData) == null ? void 0 : N.data,
                options: (v) => {
                  var w;
                  return {
                    yMax: (w = r == null ? void 0 : r.measurementValueDistributionData) == null ? void 0 : w.yMax,
                    xLabel: "Unit",
                    yLabel: "Measurement Value"
                  };
                }
              }
            ) })
          ] }) }),
          (r == null ? void 0 : r.lowerLimitDistributionData) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 4, children: /* @__PURE__ */ p.jsxs(Et, { children: [
            /* @__PURE__ */ p.jsx(Lt, { title: "Lower limit Distribution" }),
            /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
              Vt,
              {
                type: "boxplot",
                chartData: (O = r == null ? void 0 : r.lowerLimitDistributionData) == null ? void 0 : O.data,
                options: (v) => {
                  var w;
                  return {
                    yMax: (w = r == null ? void 0 : r.lowerLimitDistributionData) == null ? void 0 : w.yMax,
                    xLabel: "Unit",
                    yLabel: "Measurement Value"
                  };
                }
              }
            ) })
          ] }) }),
          (r == null ? void 0 : r.upperLimitDistributionData) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 4, children: /* @__PURE__ */ p.jsxs(Et, { children: [
            /* @__PURE__ */ p.jsx(Lt, { title: "Upper Limit Distribution" }),
            /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
              Vt,
              {
                type: "boxplot",
                chartData: (A = r == null ? void 0 : r.upperLimitDistributionData) == null ? void 0 : A.data,
                options: (v) => {
                  var w;
                  return {
                    yMax: (w = r == null ? void 0 : r.upperLimitDistributionData) == null ? void 0 : w.yMax,
                    xLabel: "Unit",
                    yLabel: "Measurement Value"
                  };
                }
              }
            ) })
          ] }) }),
          (r == null ? void 0 : r.valuesRelativeToNormData) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 6, children: /* @__PURE__ */ p.jsxs(Et, { children: [
            /* @__PURE__ */ p.jsx(Lt, { title: "Values Relative to Normal Range" }),
            /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
              Vt,
              {
                type: "donut",
                chartData: r == null ? void 0 : r.valuesRelativeToNormData,
                options: (v) => ({
                  margin: {
                    top: 5,
                    left: 5,
                    right: 200,
                    bottom: 5
                  }
                })
              }
            ) })
          ] }) }),
          (r == null ? void 0 : r.frequencyDistributionData) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsxs(Et, { children: [
            /* @__PURE__ */ p.jsx(Lt, { title: "Frequency Distribution" }),
            /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
              Vt,
              {
                type: "histogram",
                chartData: (x = r == null ? void 0 : r.frequencyDistributionData) == null ? void 0 : x.data,
                options: (v) => {
                  var w, C, P;
                  return {
                    xFormat: Yt("d"),
                    yFormat: Yt("d"),
                    xScale: ul().domain([1, 10]),
                    yScale: ul().domain([0, 100]),
                    yMax: (w = r == null ? void 0 : r.frequencyDistributionData) == null ? void 0 : w.yMax,
                    xLabel: (C = r == null ? void 0 : r.frequencyDistributionData) == null ? void 0 : C.xLabel,
                    yLabel: "% of total number of persons",
                    xValue: "x",
                    yValue: "y",
                    ticks: (P = r == null ? void 0 : r.frequencyDistributionData) == null ? void 0 : P.ticks,
                    getTooltipBuilder: (Y) => (V) => {
                      const k = Yt(".2f");
                      return `
                          Count: ${Y.xFormat(V[Y.xValue])}<br/>
                          ${Y.yLabel}: ${k(V[Y.yValue])}
                        `;
                    }
                  };
                }
              }
            ) })
          ] }) })
        ]
      },
      g
    ) : /* @__PURE__ */ p.jsx(p.Fragment, { children: n && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(Ke, {}) }) })
  ] });
}), E7 = {
  setColumns: (t) => [
    {
      id: "concept_id",
      header: "ID",
      accessorKey: "concept_id",
      size: 50,
      maxSize: 50
    },
    {
      id: "name",
      header: "Name",
      accessorKey: "name",
      size: 220,
      maxSize: 220
    },
    {
      id: "domain",
      header: "Domain",
      accessorKey: "domain",
      size: 180,
      maxSize: 180
    },
    {
      id: "num_persons",
      accessorKey: "num_persons",
      header: "Person Count",
      size: 130
    },
    {
      id: "percent_persons",
      accessorKey: "percent_persons",
      header: "Prevalence",
      size: 130
    },
    {
      id: "agg_value",
      accessorKey: "agg_value",
      header: t,
      size: 130,
      maxSize: 400
    }
  ]
}, S7 = (t) => {
  var y, f, m, b, E, S, M, N, O, A, x;
  const { data: e } = t, [n, r] = Ot(!1), [a, o] = Ot(!1), [u, c] = Ot(""), [l, d] = Ot(""), g = (v) => (w) => {
    const C = w[v.yValue], P = C < 1 ? Yt(".3f")(C) : $s(".3s", C)(C);
    return `
      ${w.seriesName}<br/>
      ${v.xLabel}: ${v.xFormat(w[v.xValue])}<br/>
      ${v.yLabel}: ${P}
    `;
  };
  if (e) {
    const v = (w, C, P) => {
      w(C), P("");
    };
    return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
      ((y = e == null ? void 0 : e.costByDomain) == null ? void 0 : y.length) && (e == null ? void 0 : e.costByDomain) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 4, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
        /* @__PURE__ */ p.jsx(Lt, { title: "Domain" }),
        /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(Vt, { type: "donut", chartData: e == null ? void 0 : e.costByDomain }) })
      ] }) }),
      ((f = e == null ? void 0 : e.costByType) == null ? void 0 : f.length) && (e == null ? void 0 : e.costByType) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 4, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
        /* @__PURE__ */ p.jsx(Lt, { title: "Type" }),
        /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(Vt, { type: "donut", chartData: e == null ? void 0 : e.costByType }) })
      ] }) }),
      ((m = e == null ? void 0 : e.costByCurrency) == null ? void 0 : m.length) && (e == null ? void 0 : e.costByCurrency) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 4, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
        /* @__PURE__ */ p.jsx(Lt, { title: "Currency" }),
        /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(Vt, { type: "donut", chartData: e == null ? void 0 : e.costByCurrency }) })
      ] }) }),
      ((E = (b = e == null ? void 0 : e.costAmountByYear) == null ? void 0 : b.data) == null ? void 0 : E.length) && ((S = e == null ? void 0 : e.costAmountByYear) == null ? void 0 : S.data) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
        /* @__PURE__ */ p.jsx(Lt, { title: "Amount By Year" }),
        /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
          Vt,
          {
            type: "line",
            chartData: (M = e == null ? void 0 : e.costAmountByYear) == null ? void 0 : M.data,
            options: (w) => {
              var C;
              return {
                xScale: (C = e == null ? void 0 : e.costAmountByYear) == null ? void 0 : C.xScale,
                xFormat: je("%m/%Y"),
                tickFormat: je("%m/%Y"),
                xValue: "xCalendarMonth",
                yValue: "yRecordCount",
                xLabel: "Year",
                yLabel: "Amount",
                showLegend: !0,
                getTooltipBuilder: g
              };
            }
          }
        ) })
      ] }) }),
      !!((O = (N = e == null ? void 0 : e.prevalenceByCostEventId) == null ? void 0 : N.tableVariant) != null && O.length) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsxs(Et, { children: [
        /* @__PURE__ */ p.jsx(Lt, { title: "Prevalence (Event)", children: /* @__PURE__ */ p.jsx(G, { item: !0, children: n ? /* @__PURE__ */ p.jsxs(G, { container: !0, spacing: 1, alignItems: "center", children: [
          /* @__PURE__ */ p.jsx(G, { item: !0, children: /* @__PURE__ */ p.jsx(
            vl,
            {
              onFind: (w) => c(
                w == null ? "" : w.toLowerCase()
              ),
              onClear: () => c("")
            }
          ) }),
          /* @__PURE__ */ p.jsx(G, { item: !0, children: /* @__PURE__ */ p.jsx(
            _e,
            {
              variant: "outlined",
              onClick: () => v(
                r,
                !1,
                c
              ),
              children: "Switch to Treemap"
            }
          ) })
        ] }) : /* @__PURE__ */ p.jsx(G, { container: !0, alignItems: "center", children: /* @__PURE__ */ p.jsx(
          _e,
          {
            variant: "outlined",
            onClick: () => v(
              r,
              !0,
              c
            ),
            children: "Switch to Table"
          }
        ) }) }) }),
        /* @__PURE__ */ p.jsx(p.Fragment, { children: n ? /* @__PURE__ */ p.jsx(
          yl,
          {
            filterValue: u,
            data: e == null ? void 0 : e.prevalenceByCostEventId.tableVariant,
            customColumns: E7.setColumns(
              e == null ? void 0 : e.prevalenceByCostEventId.description
            ),
            searchColumns: [
              "concept_id",
              "domain",
              "name",
              "ingredient",
              "num_persons",
              "agg_value",
              "percent_persons"
            ]
          }
        ) : /* @__PURE__ */ p.jsx(ml, { data: e == null ? void 0 : e.prevalenceByCostEventId }) })
      ] }) }),
      !!((x = (A = e == null ? void 0 : e.prevalenceByDrgConceptId) == null ? void 0 : A.tableVariant) != null && x.length) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsxs(Et, { children: [
        /* @__PURE__ */ p.jsx(Lt, { title: "Prevalence (Diagnosis Related Groups)", children: /* @__PURE__ */ p.jsx(G, { item: !0, children: a ? /* @__PURE__ */ p.jsxs(G, { container: !0, spacing: 1, alignItems: "center", children: [
          /* @__PURE__ */ p.jsx(G, { item: !0, children: /* @__PURE__ */ p.jsx(
            vl,
            {
              onFind: (w) => d(
                w == null ? "" : w.toLowerCase()
              ),
              onClear: () => d("")
            }
          ) }),
          /* @__PURE__ */ p.jsx(G, { item: !0, children: /* @__PURE__ */ p.jsx(
            _e,
            {
              variant: "outlined",
              onClick: () => v(
                o,
                !1,
                d
              ),
              children: "Switch to Treemap"
            }
          ) })
        ] }) : /* @__PURE__ */ p.jsx(G, { container: !0, alignItems: "center", children: /* @__PURE__ */ p.jsx(
          _e,
          {
            variant: "outlined",
            onClick: () => v(
              o,
              !0,
              d
            ),
            children: "Switch to Table"
          }
        ) }) }) }),
        /* @__PURE__ */ p.jsx(p.Fragment, { children: a ? /* @__PURE__ */ p.jsx(
          yl,
          {
            filterValue: l,
            data: e == null ? void 0 : e.prevalenceByDrgConceptId.tableVariant,
            description: e == null ? void 0 : e.prevalenceByDrgConceptId.description,
            searchColumns: [
              "concept_id",
              "domain",
              "name",
              "ingredient",
              "num_persons",
              "agg_value",
              "percent_persons"
            ]
          }
        ) : /* @__PURE__ */ p.jsx(
          ml,
          {
            data: e == null ? void 0 : e.prevalenceByDrgConceptId
          }
        ) })
      ] }) })
    ] });
  }
}, A7 = {
  setColumns: (t) => [
    {
      id: "payer_concept_name",
      header: "Payer",
      accessorKey: "payer_concept_name",
      size: 200,
      maxSize: 200
    },
    {
      id: "payer_source_value",
      header: "Payer (source)",
      accessorKey: "payer_source_value",
      size: 200,
      maxSize: 200
    },
    {
      id: "plan_concept_name",
      header: "Plan",
      accessorKey: "plan_concept_name",
      size: 2200,
      maxSize: 220
    },
    {
      id: "plan_source_value",
      accessorKey: "plan_source_value",
      header: "Plan (source)",
      size: 200
    },
    {
      id: "person_count",
      accessorKey: "person_count",
      header: "Person Count",
      size: 130
    },
    {
      id: "percent_persons",
      accessorKey: "percent_persons",
      header: "Prevalence",
      size: 130
    },
    // TODO check what goes here
    {
      id: "agg_value",
      accessorKey: "agg_value",
      header: t,
      size: 130,
      maxSize: 400
    }
  ]
}, T7 = (t) => {
  var c, l, d;
  const { data: e } = t, [n, r] = Ot(!1), [a, o] = Ot(""), u = (g, y, f) => {
    g(y), f("");
  };
  if (e) {
    const g = (c = e == null ? void 0 : e.personsWithPayerPlanData) == null ? void 0 : c.map((f) => ({
      x: new Date(Math.floor(f.x / 100), f.x % 100 - 1).getTime(),
      dx: 24192e5,
      // TODO the bar width is set to 28 days in millis, couldn't find a better way to handle this
      y: f.y
    })), y = {
      xScale: Wl(),
      xDomain: ks(g || [], (f) => f.x),
      xFormat: je("%m/%Y"),
      yFormat: Yt(",.1s"),
      xLabel: "Date",
      yLabel: "Person count"
    };
    return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
      (e == null ? void 0 : e.personsWithPayerPlanData) && /* @__PURE__ */ p.jsx(p.Fragment, { children: /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
        /* @__PURE__ */ p.jsx(Lt, { title: "Persons With Payer Plan" }),
        /* @__PURE__ */ p.jsx(Ut, { children: /* @__PURE__ */ p.jsx(
          Vt,
          {
            type: "histogram",
            chartData: g,
            options: (f) => y
          }
        ) })
      ] }) }) }),
      !!((d = (l = e == null ? void 0 : e.prevalenceByPayerPlanPeriodIdData) == null ? void 0 : l.tableVariant) != null && d.length) && /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsxs(Et, { children: [
        /* @__PURE__ */ p.jsx(Lt, { title: "Prevalence", children: /* @__PURE__ */ p.jsx(G, { item: !0, children: n ? /* @__PURE__ */ p.jsxs(G, { container: !0, spacing: 1, alignItems: "center", children: [
          /* @__PURE__ */ p.jsx(G, { item: !0, children: /* @__PURE__ */ p.jsx(
            vl,
            {
              onFind: (f) => o(
                f == null ? "" : f.toLowerCase()
              ),
              onClear: () => o("")
            }
          ) }),
          /* @__PURE__ */ p.jsx(G, { item: !0, children: /* @__PURE__ */ p.jsx(
            _e,
            {
              variant: "outlined",
              onClick: () => u(
                r,
                !1,
                o
              ),
              children: "Switch to Treemap"
            }
          ) })
        ] }) : /* @__PURE__ */ p.jsx(G, { container: !0, alignItems: "center", children: /* @__PURE__ */ p.jsx(
          _e,
          {
            variant: "outlined",
            onClick: () => u(
              r,
              !0,
              o
            ),
            children: "Switch to Table"
          }
        ) }) }) }),
        /* @__PURE__ */ p.jsx(p.Fragment, { children: n ? /* @__PURE__ */ p.jsx(
          yl,
          {
            filterValue: a,
            data: e == null ? void 0 : e.prevalenceByPayerPlanPeriodIdData.tableVariant,
            customColumns: A7.setColumns(
              e == null ? void 0 : e.prevalenceByPayerPlanPeriodIdData.description
            ),
            searchColumns: [
              "concept_id",
              "payer_concept_name",
              "payer_source_value",
              "plan_concept_name",
              "plan_source_value",
              "name",
              "num_persons",
              "agg_value",
              "percent_persons"
            ]
          }
        ) : /* @__PURE__ */ p.jsx(
          ml,
          {
            data: e == null ? void 0 : e.prevalenceByPayerPlanPeriodIdData
          }
        ) })
      ] }) })
    ] });
  }
}, C7 = (t) => {
  var x;
  const { data: e } = t, [n, r] = Ot(null), [a, o] = Ot(null), [u, c] = Ot(null), [l, d] = Ot(null), {
    isLoading: g,
    error: y,
    currentReport: f,
    dataCurrentReport: m,
    changeReport: b,
    isLoadingDrilldown: E,
    dataDrilldownReport: S,
    drilldownError: M,
    drilldownReport: N,
    reportList: O,
    status: A
  } = d7(e.id);
  return Ce(() => {
    if (m)
      try {
        const v = r2(
          f,
          m
        );
        v && (r(null), o(v), c(null), d(null));
      } catch (v) {
        console.error("Failed to format dataset report", {
          datasourceId: e.id,
          reportName: f,
          error: v
        }), o(null), c("Report contains invalid data");
      }
  }, [m]), Ce(() => {
    if (S)
      try {
        const v = Kk(
          f,
          S
        );
        v && (r(v), d(null));
      } catch (v) {
        console.error("Failed to format dataset report drilldown", {
          datasourceId: e.id,
          reportName: f,
          error: v
        }), r({}), d("Drilldown report contains invalid data");
      }
  }, [S]), [sr.INITIAL, sr.LOADING_LIST].includes(
    A
  ) ? /* @__PURE__ */ p.jsx(ro, { children: /* @__PURE__ */ p.jsx(Ke, { size: 32 }) }) : A === sr.LOADED_LIST && O.length === 0 ? /* @__PURE__ */ p.jsx(G, { container: !0, px: 6, py: 3, children: /* @__PURE__ */ p.jsx(_v, { children: /* @__PURE__ */ p.jsx(Et, { children: /* @__PURE__ */ p.jsx(
    G,
    {
      item: !0,
      xs: 12,
      px: 3,
      py: 1,
      sx: {
        textAlign: "center",
        color: "textColor.label"
      },
      children: "No reports"
    }
  ) }) }) }) : /* @__PURE__ */ p.jsxs(
    G,
    {
      container: !0,
      flexGrow: 1,
      bgcolor: "backgroundColor.dark",
      px: 6,
      py: 2,
      spacing: 2,
      alignContent: "flex-start",
      children: [
        /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(Ec, { elevated: !0, outlined: !0, children: /* @__PURE__ */ p.jsx(
          Ui,
          {
            value: (x = O.find((v) => v.value === f)) == null ? void 0 : x.value,
            options: O,
            onChange: (v) => {
              o(null), r(null), c(null), d(null), b(v);
            },
            fullWidth: !0
          }
        ) }) }),
        /* @__PURE__ */ p.jsx(
          bv,
          {
            fallback: /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(Ec, { children: /* @__PURE__ */ p.jsx(an, { textAlign: "center", variant: "subtitle2", children: "The report lacks the necessary data" }) }) }),
            children: /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(G, { container: !0, spacing: 2, children: a && !g || A === sr.LOADING_REPORT_FAILED ? /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(G, { container: !0, spacing: 2, children: /* @__PURE__ */ p.jsx(p.Fragment, { children: y || u ? /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(p.Fragment, { children: y || u }) }) : /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
              f === Bt.DASHBOARD && /* @__PURE__ */ p.jsx(p7, { data: a }),
              f === Bt.DATADENSITY && /* @__PURE__ */ p.jsx(g7, { data: a }),
              f === Bt.PERSON && /* @__PURE__ */ p.jsx(m7, { data: a }),
              f === Bt.COST && /* @__PURE__ */ p.jsx(S7, { data: a }),
              f === Bt.PAYER_PLAN && /* @__PURE__ */ p.jsx(T7, { data: a }),
              f === Bt.OBSERVATION_PERIOD && /* @__PURE__ */ p.jsx(y7, { data: a }),
              f === Bt.DEATH && /* @__PURE__ */ p.jsx(v7, { data: a }),
              f === Bt.AHILLES_SHEEL && /* @__PURE__ */ p.jsx(_7, { data: a }),
              (f === Bt.VISIT || f === Bt.CONDITION || f === Bt.CONDITION_ERA || f === Bt.PROCEDURE || f === Bt.DRUG || f === Bt.DRUG_ERA || f === Bt.MEASUREMENT || f === Bt.OBSERVATION) && /* @__PURE__ */ p.jsx(
                w7,
                {
                  data: a,
                  isLoading: E,
                  getDrilldown: N,
                  dataDrilldownReport: n,
                  drilldownError: M || l
                }
              )
            ] }) }) }) }) : /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, textAlign: "center", children: /* @__PURE__ */ p.jsx(Ke, {}) }) }) })
          },
          f
        )
      ]
    }
  );
}, R7 = {
  createCols: () => [
    {
      Header: "",
      accessor: (t) => {
        var e, n;
        return `${((e = t == null ? void 0 : t.firstName) == null ? void 0 : e[0]) || ""}${((n = t == null ? void 0 : t.lastName) == null ? void 0 : n[0]) || ""}`;
      },
      id: "logo",
      disableSortBy: !0,
      enableHiding: !1,
      width: "5%",
      minWidth: 50,
      Cell: (t) => /* @__PURE__ */ p.jsx(
        Av,
        {
          sx: (e) => ({
            fontSize: 12,
            width: 30,
            height: 30,
            // fontWeight: 'bold',
            backgroundColor: e.palette.secondary.main,
            color: e.palette.primary.main,
            my: -0.5
          }),
          children: t.value
        }
      )
    },
    {
      Header: "Name",
      accessor: "title",
      Cell: (t) => /* @__PURE__ */ p.jsx(UR, { value: t.value }),
      id: "title"
    },
    { Header: "Email", accessor: "email", id: "email" }
    // {
    //   Header: '',
    //   accessor: 'id',
    //   isCropped: true,
    //   disableSortBy: true,
    //   maxWidth: 100,
    //   Cell: (props: CellProps<any>) => {
    //     return <ActionCell onRemove={() => { confirmDelete(props.value) }} />;
    //   },
    // },
  ]
}, D7 = lr((t) => {
  var d, g;
  const { onClose: e, subModules: n, users: r, onChange: a, dataSourceId: o } = t, [u, c] = Ot(null), l = Ie(async () => {
    await (a == null ? void 0 : a(u)), e();
  }, [u, a, e]);
  return /* @__PURE__ */ p.jsx(G, { container: !0, p: 2, children: /* @__PURE__ */ p.jsx(Et, { children: /* @__PURE__ */ p.jsxs(G, { container: !0, spacing: 2, children: [
    /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(
      n.users,
      {
        type: "component",
        name: "users-owner-list",
        subModules: n,
        config: {
          parentId: o,
          users: r,
          methodList: hp,
          onChange: (y) => {
            c(y);
          }
        }
      }
    ) }),
    /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ p.jsxs(up, { children: [
      /* @__PURE__ */ p.jsx(
        _e,
        {
          variant: "outlined",
          onClick: e,
          startIcon: /* @__PURE__ */ p.jsx(Qe, { iconName: "deactivate", iconStatus: "info", ref: null }),
          name: "delete",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ p.jsx(
        _e,
        {
          onClick: l,
          variant: "contained",
          color: "success",
          startIcon: /* @__PURE__ */ p.jsx(Qe, { iconName: "submit", iconStatus: "info", ref: null }),
          name: "save",
          disabled: !((d = u == null ? void 0 : u.added) != null && d.length) && !((g = u == null ? void 0 : u.deleted) != null && g.length),
          children: "Save"
        }
      )
    ] }) })
  ] }) }) });
}), M7 = "00000000-0000-0000-0000-000000000000", O7 = (t) => {
  const { dataSourceId: e, subModules: n, canUpdate: r, onOwnersChange: a } = t, o = Ar(io), u = Ar(fD), { openModal: c, closeModal: l } = o, { showDialog: d, hideDialog: g } = u, {
    data: y,
    isLoading: f,
    getEntityList: m
  } = _l({
    primaryKey: "id",
    autoLoad: !0,
    methods: {
      read: {
        method: () => hp(e)
      }
    }
  }), b = Fn(
    () => Object.values(y.byId).filter(
      (A) => A.userId !== M7
    ),
    [y.byId]
  ), E = async () => {
    await m({}), await (a == null ? void 0 : a());
  }, S = async (A) => {
    const { added: x = [], deleted: v = [] } = A || {};
    await Promise.all([
      ...x.map((w) => {
        var P;
        const C = (w == null ? void 0 : w.userId) || (w == null ? void 0 : w.id) || ((P = w == null ? void 0 : w.object) == null ? void 0 : P.id);
        return C ? XD(e, { userId: C }) : Promise.resolve();
      }),
      ...v.map((w) => {
        var P;
        const C = (w == null ? void 0 : w.id) || (w == null ? void 0 : w.userId) || ((P = w == null ? void 0 : w.object) == null ? void 0 : P.id);
        return C ? cy(e, C) : Promise.resolve();
      })
    ]), await E();
  }, M = (A) => {
    d(zR, {
      onSubmit: async () => {
        await cy(e, A), await E();
      },
      onClose: g,
      text: "Are you sure you want to remove data owner?"
    });
  }, N = () => {
    c(
      () => /* @__PURE__ */ p.jsx(
        D7,
        {
          dataSourceId: e,
          onClose: l,
          subModules: n,
          users: Object.values(y.byId),
          onChange: S
        }
      ),
      "Update data owners",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: l
      }
    );
  }, O = Fn(() => R7.createCols(M), []);
  return /* @__PURE__ */ p.jsx(
    G,
    {
      container: !0,
      flexDirection: "column",
      flexGrow: 1,
      bgcolor: "backgroundColor.dark",
      px: 6,
      py: 2,
      children: /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsxs(Et, { elevated: !0, outlined: !0, children: [
        r && /* @__PURE__ */ p.jsx(
          G,
          {
            item: !0,
            xs: 12,
            px: 2,
            pt: 2,
            display: "flex",
            justifyContent: "flex-end",
            children: /* @__PURE__ */ p.jsx(
              $R,
              {
                id: "update-data-owners",
                name: "update-data-owners",
                className: "update-data-owners",
                iconName: "edit",
                onClick: N,
                size: "medium",
                children: "Update data owners"
              }
            )
          }
        ),
        /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, px: 2, children: /* @__PURE__ */ p.jsx(
          cp,
          {
            columns: O,
            data: b,
            isLoading: f,
            totalElements: b.length,
            enableSorting: !0,
            enablePagination: !0,
            onEdit: async () => {
            }
          }
        ) })
      ] }) })
    }
  );
}, L7 = (t, e, n) => [
  {
    value: "studies",
    title: /* @__PURE__ */ p.jsx(
      La,
      {
        count: String(e.count),
        status: e.status,
        title: "By Studies"
      }
    ),
    onTabClick: t
  },
  {
    value: "users",
    title: /* @__PURE__ */ p.jsx(
      La,
      {
        count: String(n.count),
        status: n.status,
        title: "By Users"
      }
    ),
    onTabClick: t
  }
], P7 = [
  {
    Header: "Name",
    accessor: "user",
    width: "40%",
    Cell: ({ value: t = {} }) => {
      var e, n;
      return /* @__PURE__ */ p.jsxs(He, { display: "flex", alignItems: "center", children: [
        /* @__PURE__ */ p.jsx(
          Av,
          {
            sx: (r) => {
              var a;
              return {
                width: 26,
                height: 26,
                fontSize: "0.8rem",
                backgroundColor: (a = r.palette) == null ? void 0 : a.secondary.main,
                fontWeight: "400",
                color: "primary.main",
                my: -0.2,
                mr: 1.5
              };
            },
            children: t.firstName || t.lastName ? (((e = t.firstName) == null ? void 0 : e[0]) || "") + (((n = t.lastName) == null ? void 0 : n[0]) || "") : /* @__PURE__ */ p.jsx(
              Qe,
              {
                iconName: "users",
                sx: { color: "primary.main", fontSize: "0.8rem" }
              }
            )
          }
        ),
        /* @__PURE__ */ p.jsxs(an, { fontWeight: 700, children: [
          t.firstName || "",
          " ",
          t.lastName || ""
        ] })
      ] });
    }
  },
  {
    Header: "Email",
    accessor: "user.email",
    width: "15%"
  },
  {
    Header: "Number of submissions per week",
    accessor: "chart",
    Cell: wv,
    disableSortBy: !0
  },
  {
    Header: "Total number of submissions",
    accessor: "amount"
  },
  {
    Header: "Avg. per week",
    accessor: "perWeek",
    Cell: ({ value: t }) => /* @__PURE__ */ p.jsx(p.Fragment, { children: Dv(t, 4, 4) })
  },
  {
    Header: "Last submission",
    accessor: "last",
    Cell: (t) => t.value ? /* @__PURE__ */ p.jsx(Ev, { ...t }) : /* @__PURE__ */ p.jsx(p.Fragment, {})
  }
], N7 = [
  {
    Header: "Name",
    accessor: "study.title",
    Cell: VR,
    isCropped: !0,
    width: "45%",
    minWidth: 200,
    maxWidth: 250
  },
  {
    Header: "Number of submissions per week",
    accessor: "chart",
    Cell: wv,
    disableSortBy: !0
  },
  {
    Header: "Total number of submissions",
    accessor: "amount"
  },
  {
    Header: "Avg. per week",
    accessor: "perWeek",
    Cell: ({ value: t }) => /* @__PURE__ */ p.jsx(p.Fragment, { children: Dv(t, 4, 4) })
  },
  {
    Header: "Last submission",
    accessor: "last",
    Cell: (t) => t.value ? /* @__PURE__ */ p.jsx(Ev, { ...t }) : /* @__PURE__ */ p.jsx(p.Fragment, {})
  }
], mv = ({ entity: t = "users", data: e, status: n }) => /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(
  cp,
  {
    data: (e == null ? void 0 : e.content) || [],
    enablePagination: !0,
    enableSorting: !0,
    isLoading: n === ne.IN_PROGRESS,
    columns: t === "users" ? P7 : N7,
    totalElements: e == null ? void 0 : e.content.length
  }
) }), I7 = () => {
  const { id: t } = op(), [e, n] = Ot("studies"), { state: r, status: a } = qi(
    aM,
    t
  ), { state: o, status: u } = qi(
    iM,
    t
  );
  return /* @__PURE__ */ p.jsx(Et, { elevated: !0, outlined: !0, children: /* @__PURE__ */ p.jsxs(G, { container: !0, children: [
    /* @__PURE__ */ p.jsxs(G, { item: !0, xs: 12, mb: 1, children: [
      /* @__PURE__ */ p.jsx(
        sp,
        {
          tabs: L7(
            n,
            {
              count: r == null ? void 0 : r.totalElements,
              status: a
            },
            {
              count: o == null ? void 0 : o.totalElements,
              status: u
            }
          ),
          active: e,
          secondary: !0
        }
      ),
      /* @__PURE__ */ p.jsx(fs, {})
    ] }),
    /* @__PURE__ */ p.jsxs(G, { item: !0, xs: 12, children: [
      e === "users" && /* @__PURE__ */ p.jsx(
        mv,
        {
          entity: "users",
          data: o,
          status: u
        }
      ),
      e === "studies" && /* @__PURE__ */ p.jsx(
        mv,
        {
          entity: "studies",
          data: r,
          status: a
        }
      )
    ] })
  ] }) });
}, j7 = (t) => {
  var o, u, c, l, d;
  const e = {
    count: (u = (o = t == null ? void 0 : t.chartDto) == null ? void 0 : o.statistics) == null ? void 0 : u.SUBMISSIONS,
    infoText: "Number of completed submissions / jobs",
    title: "Number of completed submissions"
  }, n = {
    data: (c = t == null ? void 0 : t.chartDto) == null ? void 0 : c.chart,
    title: "Number of submissions per week",
    infoText: "Weekly data set utilization trend"
  }, r = {
    title: "Number of studies",
    infoText: "Studies utilizing this data set",
    iconName: "study",
    count: t == null ? void 0 : t.studies
  }, a = {
    count: (d = (l = t == null ? void 0 : t.chartDto) == null ? void 0 : l.statistics) == null ? void 0 : d.USERS,
    title: "Number of users",
    infoText: "Users utilizing this data set",
    iconName: "users"
  };
  return {
    score: e,
    topLeft: r,
    bottomLeft: a,
    chart: n
  };
}, k7 = ({
  canSeeAll: t
}) => {
  const { id: e } = op(), { state: n, status: r } = qi(
    rM,
    e
  );
  return /* @__PURE__ */ p.jsx(
    G,
    {
      container: !0,
      flexGrow: 1,
      bgcolor: "backgroundColor.dark",
      px: 6,
      py: 2,
      spacing: 2,
      alignContent: "flex-start",
      children: /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
        /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(YR, { children: "Statistics are based on analysis execution submissions which are “published”." }) }),
        /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(WR, { status: r, data: j7(n) }) }),
        /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(I7, {}) })
      ] })
    }
  );
}, B7 = (t) => {
  const {
    entity: e,
    editLocator: n,
    getEntity: r,
    canUpdate: a,
    canManageReports: o,
    canManageDocuments: u,
    canManageAccessSettings: c,
    loadSummary: l,
    utilizationAvailable: d,
    reloadLogo: g
  } = t, [y, f] = Ot([]), m = Ar(io), b = Ar(tf), { openModal: E, closeModal: S } = m, { subModules: M } = b, { enqueueSnackbar: N } = bi(), { status: O, data: A } = hD(
    "&filter.metadata.subject=DATA_SOURCE",
    !1,
    !1
  ), {
    status: x,
    values: v,
    isLoading: w,
    saveMetadataValue: C,
    copyMetadataValues: P
  } = dD(e.id, {
    entityFilter: "datasource",
    getListValues: xh,
    updateMetadataValue: bh,
    removeMetadataValue: wh,
    createMetadataValue: _h,
    copyMetadataValue: Eh
  }), {
    status: Y,
    permissionReports: V,
    updatePermissions: k
  } = QM(e.id);
  Ce(() => {
    DD().then((W) => {
      f(
        W.content.map((B) => ({ name: B.name, value: B.code }))
      );
    });
  }, []), Ce(() => {
    l();
  }, [V, v]);
  const T = (W) => {
    E(
      () => /* @__PURE__ */ p.jsx(G, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ p.jsx(Et, { children: /* @__PURE__ */ p.jsx(
        M.documents,
        {
          type: "component",
          name: "upload-new-document",
          subModules: M,
          config: {
            onChange: () => {
              S();
            },
            onClose: S,
            createMethod: (B) => zD(W, B),
            freeUpload: !0,
            textAvailableExt: ".ZIP",
            acceptExt: [
              "application/zip",
              "application/octet-stream",
              "application/x-zip-compressed",
              "multipart/x-zip"
            ]
          }
        }
      ) }) }),
      "Upload files",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: S
      }
    );
  }, R = () => {
    E(
      () => /* @__PURE__ */ p.jsx(
        qR,
        {
          isContainer: !1,
          name: e.name,
          title: "Data Source",
          getBaseUrl: (W, B) => "/data-sources/",
          onCancel: S,
          metadataAttributes: A,
          metadataValues: yh(A, v),
          configMetadataValuesApi: {
            entityFilter: "datasource",
            getListValues: xh,
            updateMetadataValue: bh,
            removeMetadataValue: wh,
            createMetadataValue: _h,
            copyMetadataValue: Eh
          },
          onSave: async (W) => {
            await P(e.id, W), S(), N({
              message: "Meta attributes copied",
              variant: "success"
            });
          }
        }
      ),
      "Import metadata values",
      {
        width: "700px",
        closeOnClickOutside: !0,
        onClose: S
      }
    );
  }, F = () => {
    E(
      () => /* @__PURE__ */ p.jsx(
        GR,
        {
          name: e.name,
          title: "Data Source",
          getBaseUrl: (W, B) => "/data-sources/",
          onCancel: S,
          metadataAttributes: A,
          metadataValues: yh(A, v),
          configMetadataValuesApi: {
            entityFilter: "datasource",
            getListValues: xh,
            updateMetadataValue: bh,
            removeMetadataValue: wh,
            createMetadataValue: _h,
            copyMetadataValue: Eh
          },
          onSave: async (W) => {
            await P(e.id, W), S(), N({
              message: "Meta attributes copied",
              variant: "success"
            });
          }
        }
      ),
      "Export metadata values",
      {
        width: "700px",
        closeOnClickOutside: !0,
        onClose: S
      }
    );
  }, U = Ie(async (W, B) => {
    try {
      const j = await Iv(W, B);
      await r();
    } catch {
    }
  }, []), H = async (W) => {
    var B, j, X, tt, et, ot, Z;
    W && (await C(
      (B = W == null ? void 0 : W.currentState) == null ? void 0 : B.meta,
      (j = W == null ? void 0 : W.dataSource) == null ? void 0 : j.metaAttributes
    ), await U(e.id, {
      versionId: e == null ? void 0 : e.versionId,
      accessType: (X = W == null ? void 0 : W.currentState) == null ? void 0 : X.accessType,
      executionPolicy: (tt = W == null ? void 0 : W.currentState) == null ? void 0 : tt.executionPolicy,
      modelType: (et = W == null ? void 0 : W.currentState) == null ? void 0 : et.modelType,
      name: (ot = W == null ? void 0 : W.currentState) == null ? void 0 : ot.name,
      description: (Z = W == null ? void 0 : W.currentState) == null ? void 0 : Z.description
    }), await k(e.id, W.currentState.reports), N({
      message: "Data source updated",
      variant: "success"
    }));
  };
  return [
    iy.INITIAL,
    iy.LOADING_METADATA
  ].includes(x) && [
    fd.INITIAL,
    fd.LOADING
  ].includes(Y) && [ne.INITIAL, ne.IN_PROGRESS].includes(O) ? /* @__PURE__ */ p.jsx(ro, { children: /* @__PURE__ */ p.jsx(Ke, { size: 32 }) }) : /* @__PURE__ */ p.jsxs(xv, { children: [
    /* @__PURE__ */ p.jsx(
      ui,
      {
        index: !0,
        element: /* @__PURE__ */ p.jsx(
          AO,
          {
            dataSource: {
              ...e,
              metaAttributes: yh(A, v),
              achillesPermissions: lD(V),
              modelTypes: y
            },
            subModules: M,
            isLoading: w,
            canUpdate: a,
            canManageReports: o,
            canManageAccessSettings: c,
            onUpload: T,
            onImport: R,
            onExport: F,
            onChange: H,
            onFinishRunningReport: l,
            reloadLogo: g
          }
        )
      }
    ),
    /* @__PURE__ */ p.jsx(
      ui,
      {
        path: "reports/*",
        element: /* @__PURE__ */ p.jsx(C7, { data: e, isLoading: w })
      }
    ),
    /* @__PURE__ */ p.jsx(
      ui,
      {
        path: "data-owners/*",
        element: /* @__PURE__ */ p.jsx(
          O7,
          {
            dataSourceId: e.dataNode.id,
            subModules: M,
            canUpdate: a,
            isLoading: w,
            onOwnersChange: l
          }
        )
      }
    ),
    /* @__PURE__ */ p.jsx(
      ui,
      {
        path: "utilization-statistics/*",
        element: /* @__PURE__ */ p.jsx(k7, { canSeeAll: d })
      }
    ),
    /* @__PURE__ */ p.jsx(
      ui,
      {
        path: "documents/*",
        element: /* @__PURE__ */ p.jsx(
          M.documents,
          {
            type: "component",
            name: "documents-list",
            subModules: M,
            onChange: l,
            config: {
              parentId: e.id,
              canManageDocuments: u
            }
          }
        )
      }
    ),
    /* @__PURE__ */ p.jsx(
      ui,
      {
        path: "dqd-reports/*",
        element: /* @__PURE__ */ p.jsx(SO, { dataSource: e })
      }
    )
  ] });
}, F7 = "00000000-0000-0000-0000-000000000000", ls = (t) => String(t).replace(/[_\s-]/g, "").toLowerCase(), U7 = (t) => {
  if (typeof t == "boolean")
    return t;
  if (Array.isArray(t))
    return t.some((e) => {
      const n = ls(e);
      return n.includes("datasteward") || n.includes("steward") || n.includes("owner");
    });
  if (typeof t == "string") {
    const e = ls(t);
    return e.includes("datasteward") || e.includes("steward") || e.includes("owner");
  }
  return !!((t == null ? void 0 : t.dataSteward) ?? (t == null ? void 0 : t.steward) ?? (t == null ? void 0 : t.owner));
}, $7 = (t, e) => Array.isArray(e) && e.some((r) => ls(r) === "admin") ? !0 : typeof t == "boolean" ? t : Array.isArray(t) ? t.some((r) => ls(r).includes("admin")) : typeof t == "string" ? ls(t).includes("admin") : !!(t != null && t.admin), z7 = (t) => {
  var r, a, o, u, c, l, d;
  const e = (t == null ? void 0 : t.roles) || ((r = t == null ? void 0 : t.object) == null ? void 0 : r.roles);
  return {
    steward: U7(
      (t == null ? void 0 : t.dataSteward) ?? (t == null ? void 0 : t.steward) ?? (t == null ? void 0 : t.owner) ?? ((a = t == null ? void 0 : t.object) == null ? void 0 : a.dataSteward) ?? ((o = t == null ? void 0 : t.object) == null ? void 0 : o.steward) ?? ((u = t == null ? void 0 : t.object) == null ? void 0 : u.owner) ?? e
    ),
    admin: $7(
      (t == null ? void 0 : t.admin) ?? ((c = t == null ? void 0 : t.object) == null ? void 0 : c.admin) ?? e ?? (t == null ? void 0 : t.actions) ?? ((l = t == null ? void 0 : t.object) == null ? void 0 : l.actions),
      (t == null ? void 0 : t.moduleIds) ?? ((d = t == null ? void 0 : t.object) == null ? void 0 : d.moduleIds)
    )
  };
}, V7 = () => {
  var Z, lt;
  const { id: t } = op(), e = Ov(), n = Mv((z) => z.user.data), r = Ar(io), { openModal: a, closeModal: o } = r, [u, c] = Ot(""), [l, d] = Ot(), [g, y] = Ot(ne.INITIAL), [f, m] = Ot({
    steward: !1,
    admin: !1
  }), b = Ar(tf), { rootSettings: E, path: S, title: M, config: N, subModules: O } = b, { rootPath: A, rootTitle: x } = E, { parentId: v, parentTitle: w, typeContainer: C } = N, { createCrudEntity: P, entityBreadcrumbs: Y, entityNavigationPanel: V } = WM, k = Fn(() => P(C, v), [P, v, C]), { status: T, entity: R, getEntity: F, actions: U } = pD(
    {
      get: k.getMethod,
      update: k.upsertMethod,
      delete: k.deleteMethod
    },
    t,
    "Data Source"
  ), H = br.useCallback(async () => {
    var ht, pt;
    if (!(R != null && R.id) || !((ht = R == null ? void 0 : R.dataNode) != null && ht.id))
      return;
    y(ne.IN_PROGRESS);
    const [z, nt, it, Q] = await Promise.allSettled([
      QD(R.id),
      hp(R.dataNode.id),
      kv(R.id),
      Bv(R.id)
    ]);
    try {
      const st = z.status === "fulfilled" ? z.value : {}, xt = nt.status === "fulfilled" ? ((pt = nt.value) == null ? void 0 : pt.content) || nt.value || [] : [], gt = Q.status === "fulfilled" && Array.isArray(Q.value) ? Q.value : [], dt = it.status === "fulfilled" && !!it.value || gt.length > 0;
      d({
        ...st,
        ownersCount: xt.filter(
          (Tt) => Tt.userId !== F7
        ).length,
        hasDqd: dt
      }), y(ne.SUCCESS);
    } catch {
      y(ne.ERROR);
    }
  }, [(Z = R == null ? void 0 : R.dataNode) == null ? void 0 : Z.id, R == null ? void 0 : R.id]), W = Fn(() => V(l, g), [V, l, g]), B = br.useMemo(
    () => !!(!(R != null && R.actions) || U != null && U[gD.UPDATE]),
    [U]
  );
  Ce(() => {
    if (!(n != null && n.activeTenant) || !(n != null && n.id)) {
      m({ steward: !1, admin: !1 });
      return;
    }
    let z = !1;
    return MD(n.activeTenant).then((nt) => {
      if (z)
        return;
      const it = nt == null ? void 0 : nt.find(
        (Q) => {
          var ht, pt;
          return ((ht = Q == null ? void 0 : Q.object) == null ? void 0 : ht.id) === n.id || (Q == null ? void 0 : Q.id) === n.id || ((pt = Q == null ? void 0 : Q.object) == null ? void 0 : pt.email) === n.email || (Q == null ? void 0 : Q.email) === n.email;
        }
      );
      m(
        it ? z7(it) : { steward: !1, admin: !1 }
      );
    }).catch(() => {
      z || m({ steward: !1, admin: !1 });
    }), () => {
      z = !0;
    };
  }, [n == null ? void 0 : n.activeTenant, n == null ? void 0 : n.email, n == null ? void 0 : n.id]);
  const j = B || f.steward, X = B || f.admin, tt = X || f.steward || !!(R != null && R.currentUserDataOwner || (lt = R == null ? void 0 : R.dataNode) != null && lt.currentUserDataOwner), et = br.useCallback(() => {
    R != null && R.id && e(mD(R.id, !0));
  }, [e, R == null ? void 0 : R.id]);
  Ce(() => {
    R != null && R.name && (et(), e(
      yD(
        Y(t, R.name, {
          path: S,
          title: M,
          rootPath: A,
          rootTitle: x,
          parentTitle: w,
          parentId: v
        })
      )
    ));
  }, [
    e,
    R,
    Y,
    t,
    et,
    v,
    w,
    S,
    A,
    x,
    M
  ]), Ce(() => {
    H();
  }, [H]);
  const ot = () => {
    a(
      () => /* @__PURE__ */ p.jsx(
        qM,
        {
          dataSourceId: t,
          subModules: O,
          onCancel: o
        }
      ),
      "Request access",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: o
      }
    );
  };
  return T === ne.IN_PROGRESS || T === ne.INITIAL ? /* @__PURE__ */ p.jsx(GM, { children: /* @__PURE__ */ p.jsx(Ke, {}) }) : /* @__PURE__ */ p.jsxs(HR, { children: [
    /* @__PURE__ */ p.jsxs(XR, { children: [
      /* @__PURE__ */ p.jsx(
        QR,
        {
          entity: R,
          onInvite: X && ot,
          actions: U
        }
      ),
      /* @__PURE__ */ p.jsx(fs, {}),
      /* @__PURE__ */ p.jsx(sp, { tabs: W, withRouting: !0 })
    ] }),
    /* @__PURE__ */ p.jsx(
      B7,
      {
        entity: R,
        editLocator: u,
        getEntity: F,
        canUpdate: j,
        canManageReports: X,
        canManageDocuments: tt,
        canManageAccessSettings: X,
        loadSummary: H,
        utilizationAvailable: !0,
        reloadLogo: et
      }
    )
  ] });
}, tf = RR(null), Y7 = (t) => {
  const { path: e, title: n, name: r, storage: a, rootSettings: o, initStorage: u } = t, [c, l] = Ot(o), [d, g] = Ot(!0);
  return Ce(() => {
    o || l({
      rootPath: e,
      rootTitle: n
    }), g(!1), document.title = "Prometheus - Data Catalog";
  }, []), d ? /* @__PURE__ */ p.jsx(ro, { children: /* @__PURE__ */ p.jsx(Ke, { size: 32 }) }) : /* @__PURE__ */ p.jsx(tf.Provider, { value: { ...t, rootSettings: c }, children: /* @__PURE__ */ p.jsxs(xv, { children: [
    /* @__PURE__ */ p.jsx(ui, { path: ":id/*", element: /* @__PURE__ */ p.jsx(V7, {}) }),
    /* @__PURE__ */ p.jsx(ui, { index: !0, element: /* @__PURE__ */ p.jsx(YM, {}) })
  ] }) });
}, rB = (t) => {
  const { type: e, config: n } = t;
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    !e && /* @__PURE__ */ p.jsx(Y7, { ...t, config: { ...n } }),
    e === "component" && /* @__PURE__ */ p.jsx(zM, { ...t })
  ] });
};
export {
  Ba as AccessReports,
  rB as DataCatalog,
  zr as ExecutionPolicy,
  Bt as ReportTypes
};
//# sourceMappingURL=data-catalog.js.map
